{
  "accueil.aFaire": "À faire maintenant",
  "accueil.approbationsEnAttente": "approbations et décisions humaines en attente",
  "accueil.aucunDeploiementEchoue": "déploiement en échec",
  "accueil.aucuneExecution": "Aucune exécution",
  "accueil.aucunProjet": "Aucun projet sélectionné",
  "accueil.aucunProjetHint": "Choisissez un projet dans la barre de contexte pour voir ce qui vous attend.",
  "accueil.budgetNonDisponible": "budget IA : non disponible dans cette version (le quota courant est affiché dans le panneau)",
  "accueil.chargement": "Lecture des données réelles…",
  "accueil.deploiementsEchoues": "déploiement(s) en échec : {{envs}}",
  "accueil.deployeVersion": "— {{version}} déployée",
  "accueil.deposerIdee": "Déposer une idée",
  "accueil.doneNestPasDeploye": "Terminé n’est pas déployé : ci-dessous, ce qui tourne réellement.",
  "accueil.erreurDetail": "Une source de ce bloc n’a pas répondu ; les autres chiffres sont incomplets.",
  "accueil.etapeDone": "terminés (travail)",
  "accueil.etapeInProgress": "en cours",
  "accueil.etapeInReview": "en revue",
  "accueil.etapeTodo": "à faire",
  "accueil.ideesAQualifier": "idées à qualifier",
  "accueil.jobsEnEchec": "jobs en échec à reprendre",
  "accueil.progression": "Progression vers la production",
  "accueil.questionContributor": "Que puis-je faire ensuite ?",
  "accueil.questionOwner": "Qu’est-ce qui bloque ?",
  "accueil.questionViewer": "Où en sommes-nous ?",
  "accueil.rienDeploye": "Aucun déploiement réussi observé",
  "accueil.risques": "Risques et gates",
  "accueil.sod": "de vos demandes attendent un AUTRE approbateur (séparation des devoirs)",
  "accueil.testsDerniere": "— dernière campagne de tests",
  "accueil.testsEchec": "Échec",
  "accueil.testsOk": "Réussi",
  "activity.acted": "a agi sur l'item",
  "activity.attached": "a joint",
  "activity.commented": "a commenté",
  "activity.created": "a créé l'item",
  "activity.empty": "Aucune activité.",
  "activity.hide": "Masquer l'activité",
  "activity.loading": "Chargement…",
  "activity.statusChanged": "a fait passer le statut",
  "activity.statutDone": "Terminé",
  "activity.statutInProgress": "En cours",
  "activity.statutInReview": "En revue",
  "activity.statutTodo": "À faire",
  "activity.system": "Système",
  "activity.toggle": "Activité",
  "admin.accessDeniedDescription": "Votre rôle ne donne pas accès à la gouvernance (quotas, modèles, membres).",
  "admin.accessDeniedTitle": "Accès réservé au propriétaire de l'espace.",
  "admin.addMemberButton": "Ajouter",
  "admin.addMemberHeading": "Ajouter un membre",
  "admin.allowedModelsHeading": "Modèles autorisés",
  "admin.organisationAiModelsEmpty": "Aucun modèle global n’est disponible pour cette organisation. Demandez à l’administrateur global d’activer un fournisseur et de publier un modèle.",
  "admin.aiConnectorActivationBlocked": "Activez d’abord le connecteur associé.",
  "admin.colActions": "Actions",
  "admin.colCondition": "Condition",
  "admin.colConsumed": "Consommé",
  "admin.colEffect": "Effet",
  "admin.colEngine": "Moteur",
  "admin.colJobs": "Jobs traités",
  "admin.colLastSeen": "Dernier signe",
  "admin.colLimit": "Limite",
  "admin.colPermission": "Permission",
  "admin.colResource": "Ressource",
  "admin.colRole": "Rôle",
  "admin.colSince": "Depuis",
  "admin.colState": "État",
  "admin.colUser": "Utilisateur",
  "admin.colWorker": "Worker",
  "admin.effacerRecherche": "Effacer la recherche",
  "admin.effetAllow": "Autorisation",
  "admin.effetDeny": "Refus",
  "admin.ilYA": "il y a {{n}} s",
  "admin.loading": "Chargement…",
  "admin.memberAddedToast": "Membre ajouté",
  "admin.memberRemovedToast": "Membre retiré",
  "admin.memberRoleAria": "Rôle du membre",
  "admin.membersHeading": "Membres",
  "admin.memberUserPlaceholder": "user_id ou identifiant",
  "admin.membresAucunResultat": "Aucun membre ne correspond à cette recherche",
  "admin.membresAucunResultatHint": "La recherche porte sur l'identifiant, le rôle et la date d'entrée.",
  "admin.modelAdd": "Autoriser ce modèle",
  "admin.modelChoose": "— choisir un modèle —",
  "admin.modelNoneLeftHint": "Tous les modèles du catalogue sont déjà autorisés, ou le catalogue est vide.",
  "admin.modelNoneLeftTitle": "Aucun modèle à ajouter",
  "admin.modelRemove": "Retirer",
  "admin.modelRemoveC1": "Les générations qui demandent ce modèle seront refusées.",
  "admin.modelRemovedToast": "Modèle retiré de la liste",
  "admin.modelRemoveRev": "Vous pourrez le réautoriser à tout moment ; rien n'est perdu.",
  "admin.modelRemoveTitre": "Retirer {{m}} des modèles autorisés ?",
  "admin.modelRemoveVerbe": "Retirer le modèle",
  "admin.modelToAdd": "Modèle à autoriser",
  "admin.motifAllow": "Une règle d'AUTORISATION s'applique — elle accorde un droit que le rôle n'a pas forcément.",
  "admin.motifDeny": "Une règle de REFUS s'applique — elle l'emporte sur le rôle. Corrigez-la ci-dessus.",
  "admin.motifNone": "Aucune règle, et le rôle n'accorde pas cette permission. Cela se corrige dans « Rôles & permissions ».",
  "admin.motifRbac": "Aucune règle applicable : c'est le rôle qui accorde.",
  "admin.noMemberHint": "Les rôles sont portés par le realm ; cette table peut être vide.",
  "admin.noMemberTitle": "Aucun membre listé",
  "admin.noModelRestriction": "Aucun modèle autorisé : les générations sont bloquées.",
  "admin.noModelRestrictionTitle": "Aucun modèle autorisé : les générations sont bloquées.",
  "admin.noQuotaHint": "Cet espace consomme sans plafond. Posez une limite ci-dessous pour en fixer un.",
  "admin.noQuotaTitle": "Aucun quota défini",
  "admin.pageDescription": "Gouvernance de l'espace : quotas de ressources, modèles autorisés, membres.",
  "admin.permAucunResultat": "Aucune permission ne correspond à cette recherche",
  "admin.permAucunResultatHint": "La recherche porte sur le code technique et sur ce que la permission autorise.",
  "admin.polAdd": "Ajouter la règle",
  "admin.polAucunResultat": "Aucune règle ne correspond à cette recherche",
  "admin.polAucunResultatHint": "La recherche porte aussi sur la condition et sur le motif de la règle.",
  "admin.polChoisir": "— choisir —",
  "admin.polCle": "Attribut (clé)",
  "admin.polDelete": "Supprimer",
  "admin.polDeleteRev": "La règle pourra être recréée, mais son historique est perdu.",
  "admin.polDeleteTitre": "Supprimer cette règle ?",
  "admin.polDeleteVerbe": "Supprimer la règle",
  "admin.polDescription": "Motif de la règle",
  "admin.polDescriptionAide": "Affiché à l'administrateur qui verra cette règle refuser une action.",
  "admin.polEffect": "Effet",
  "admin.polEffectAide": "Un refus l'emporte TOUJOURS sur une autorisation, quelle que soit celle du rôle.",
  "admin.policiesHeading": "Politiques d'accès",
  "admin.polPermission": "Permission concernée",
  "admin.polRole": "Rôle visé",
  "admin.polRoleAide": "Laisser vide applique la règle à tous les rôles.",
  "admin.polSupprimeeToast": "Règle supprimée",
  "admin.polTousRoles": "Tous les rôles",
  "admin.polValeur": "Valeur attendue",
  "admin.polVideTitle": "Aucune règle d'attribut",
  "admin.pseudoCount": "{{n}} pseudonyme(s) attribué(s) pour cette organisation.",
  "admin.pseudoHeading": "Pseudonymisation",
  "admin.purgeAttest": "J'ai vérifié qu'aucun audit en cours ne porte sur cette période",
  "admin.purgeTitre": "Supprimer définitivement {{n}} événement(s) du journal ?",
  "admin.purgeToast": "Journaux purgés",
  "admin.purgeVerbe": "Purger les journaux",
  "admin.quoiMembres": "membres",
  "admin.quoiPermissions": "permissions",
  "admin.quoiPolitiques": "règles",
  "admin.quoiWorkers": "workers",
  "admin.quotaAuMoinsUn": "Une limite vaut au moins 1. Pour ne pas limiter, retirez la ligne du tableau.",
  "admin.quotaDelete": "Retirer",
  "admin.quotaDeleteC1": "La ressource redevient SANS plafond pour cet espace.",
  "admin.quotaDeleteC2": "Le compteur de consommation part avec la limite.",
  "admin.quotaDeleteRev": "Vous pourrez reposer une limite, mais le compteur repartira de zéro.",
  "admin.quotaDeleteTitre": "Retirer la limite sur {{r}} ?",
  "admin.quotaDeleteVerbe": "Retirer la limite",
  "admin.quotaExceeded": "Dépassé",
  "admin.quotaFormHeading": "Poser ou modifier une limite",
  "admin.quotaLimit": "Limite",
  "admin.quotaLimitAide": "Nombre entier. Pour retirer toute limite, supprimez la ligne plutôt que de saisir 0.",
  "admin.quotaNoCatalogTitle": "Catalogue des ressources indisponible",
  "admin.quotaNonApplique": "Enregistrée, mais pas encore appliquée : rien ne refuse ce dépassement.",
  "admin.quotaReset": "Remettre à zéro",
  "admin.quotaResetC2": "La limite, elle, est conservée telle quelle.",
  "admin.quotaResetRev": "La valeur précédente n'est pas conservée : le compteur ne peut pas être restauré.",
  "admin.quotaResetTitre": "Remettre à zéro la consommation de {{r}} ?",
  "admin.quotaResetVerbe": "Remettre à zéro",
  "admin.quotaResource": "Ressource",
  "admin.quotaSave": "Enregistrer la limite",
  "admin.quotasHeading": "Quotas",
  "admin.quotaSupprimeToast": "Limite retirée",
  "admin.quotaWithinLimits": "Dans les limites",
  "admin.rbacCaseAria": "{{permission}} pour le rôle {{role}}",
  "admin.rbacDernierAdminC2": "Accordez d'abord cette permission à un autre rôle.",
  "admin.rbacDernierAdminTitre": "Impossible : {{r}} est le dernier rôle administrateur",
  "admin.rbacDernierAdminVerbe": "J'ai compris",
  "admin.rbacLoading": "Chargement de la matrice…",
  "admin.rbacScopeTitle": "Ces droits valent pour TOUTE l'organisation.",
  "admin.removeAttest": "J'ai vérifié qu'aucune approbation en cours ne dépend de cette personne",
  "admin.removeC1": "L'accès est révoqué immédiatement, y compris aux artefacts déjà consultés.",
  "admin.removeC2": "Les approbations que cette personne devait rendre restent en attente.",
  "admin.removeMember": "Retirer",
  "admin.removeMemberConfirm": "Retirer ce membre de l'espace ?",
  "admin.removeRev": "Vous pourrez la réinviter, mais son historique de membre repart à zéro.",
  "admin.removeTitle": "Retirer {{u}} de cet espace ?",
  "admin.removeVerb": "Retirer le membre",
  "admin.ressource.jetonsParJour": "Jetons par jour",
  "admin.ressource.nombreDocuments": "Nombre de documents",
  "admin.ressource.requetesParMinute": "Requêtes par minute",
  "admin.ressource.tailleDocument": "Taille d'un document (Mo)",
  "admin.retentionEtat": "{{n}} événement(s) au journal de cet espace, le plus ancien du {{d}}.",
  "admin.retentionHeading": "Rétention des journaux",
  "admin.retentionJours": "Conserver les journaux (jours)",
  "admin.retentionPurger": "Purger maintenant",
  "admin.retentionResultat": "{{n}} événement(s) seraient supprimés avec une rétention de {{j}} jours.",
  "admin.retentionSimuler": "Simuler la purge",
  "admin.roleContributor": "contributeur",
  "admin.roleOwner": "propriétaire",
  "admin.roleViewer": "lecteur",
  "admin.rolesHeading": "Rôles & permissions",
  "admin.section.conformite": "Conformité",
  "admin.section.integrations": "Intégrations",
  "admin.section.membres": "Membres",
  "admin.section.modeles": "Modèles autorisés",
  "admin.section.politiques": "Politiques d'accès",
  "admin.section.quotas": "Quotas",
  "admin.section.roles": "Rôles & permissions",
  "admin.section.workers": "Exécutants",
  "admin.sectionsLabel": "Sections de l'administration",
  "admin.simAutorise": "Autorisé",
  "admin.simCle": "Attribut (clé)",
  "admin.simCleAide": "Facultatif. Laisser vide simule une décision sans attribut.",
  "admin.simHeading": "Simulateur de décision",
  "admin.simPermission": "Permission demandée",
  "admin.simRefuse": "Refusé",
  "admin.simRole": "Rôle simulé",
  "admin.simRun": "Simuler",
  "admin.simValeur": "Valeur",
  "admin.title": "Administration",
  "admin.workerMort": "Inactif",
  "admin.workerMoteurInconnu": "non déclaré (version antérieure)",
  "admin.workerPurge": "Retirer",
  "admin.workerPurgeC2Mort": "Son compteur de jobs traités est perdu.",
  "admin.workerPurgeTitre": "Retirer le battement de {{w}} ?",
  "admin.workerPurgeToast": "Battement retiré",
  "admin.workerPurgeVerbe": "Retirer le battement",
  "admin.workersAucunResultat": "Aucun worker ne correspond à cette recherche",
  "admin.workersAucunResultatHint": "La recherche porte sur l'identifiant, l'état, le moteur et sa provenance.",
  "admin.workersHeading": "Exécutants",
  "admin.workersScopeTitle": "Périmètre GLOBAL — pas seulement cette organisation.",
  "admin.workersVideTitle": "Aucun worker n'a jamais battu",
  "admin.workerVivant": "Actif",
  "app.logout": "Se déconnecter",
  "app.help": "Aide",
  "app.helpAria": "Ouvrir l’aide contextuelle",
  "app.helpTitle": "Aide contextuelle",
  "app.helpDescription": "Repères et prochaine action dans le contexte courant.",
  "app.helpFor": "Vous êtes dans « {{screen}} ».",
  "app.helpProject": "Projet actif :",
  "app.helpJourneyTitle": "Revenir au parcours",
  "app.helpJourneyDesc": "Retrouver les étapes idée → publication et la prochaine action.",
  "app.helpProcessTitle": "Voir le processus effectif",
  "app.helpProcessDesc": "Vérifier les prérequis, rôles et gates de ce projet.",
  "app.localSupportChannel": "Support local : contactez l’opérateur RunOps de votre organisation via son canal interne.",
  "app.commercialBoundary": "Frontière commerciale : cette installation on-premise ne propose ni abonnement, ni paiement, ni solde acheté ; les quotas expriment uniquement la gouvernance de capacité.",
  "app.localSupportSafety": "Pour le diagnostic, transmettez l’identifiant de corrélation et le contexte non sensible ; ne transmettez jamais de jeton, secret ou contenu de document.",
  "app.logoutShort": "Quitter",
  "app.readonly": " · lecture seule",
  "app.readonlyShort": "Lecture seule",
  "app.search": "Rechercher…",
  "app.searchAria": "Rechercher (Ctrl+K)",
  "app.versionInterfaceLine": "Interface {{version}} · {{date}}",
  "app.versionGatewayLine": "Passerelle {{version}} · {{date}}",
  "app.versionGatewayUnknown": "Passerelle : indisponible",
  "app.versionDateUnknown": "date inconnue",
  "approvals.and": "et",
  "approvals.approve": "Approuver",
  "approvals.approveConsequence": "publie cet artefact dans le dépôt (commit Git au prochain passage du worker).",
  "approvals.authorNoticeOther": "autre",
  "approvals.authorNoticeStrong": "Vous êtes le demandeur.",
  "approvals.authorNoticeText1": "La séparation des tâches (créateur ≠ approbateur) exige qu'un",
  "approvals.authorNoticeText2": "propriétaire ou contributeur décide. Faites relire par un collègue — ou, en démonstration, reconnectez-vous avec un autre compte (ex.",
  "approvals.authorNoticeText3": ") pour approuver.",
  "approvals.cancelEdit": "Annuler l’édition",
  "approvals.cardUnknown": "inconnue",
  "approvals.close": "Fermer",
  "approvals.closeWithoutDeciding": "Fermer sans décider",
  "approvals.colAction": "Action",
  "approvals.colArtifact": "Artefact",
  "approvals.colCard": "Carte",
  "approvals.collapse": "Réduire",
  "approvals.colModel": "Modèle",
  "approvals.colRequester": "Demandeur",
  "approvals.colStatus": "Statut",
  "approvals.commentLabel": "Commentaire (obligatoire pour un rejet)",
  "approvals.consult": "Consulter",
  "approvals.contentToPublish": "Contenu à publier",
  "approvals.decidedBy": "par",
  "approvals.decidedToast": "Décision enregistrée",
  "approvals.decisionSubtitle": "Vérifiez la provenance (carte, modèle, empreintes) et le contenu avant toute décision.",
  "approvals.decisionTitle": "Décision d'approbation",
  "approvals.detailLoading": "Chargement de la demande…",
  "approvals.draftSpec": "Rédiger la spécification",
  "approvals.draftSpecDesc": "en produit le document, qui revient en approbation.",
  "approvals.editContentManually": "Éditer le contenu à la main",
  "approvals.editedContentLabel": "Contenu édité (revient en approbation)",
  "approvals.editedToast": "Artefact modifié",
  "approvals.emptyHint": "Déposez une idée ou téléversez un document ; la spécification générée attendra ici sa décision.",
  "approvals.emptyTitle": "Aucune demande d'approbation",
  "approvals.examine": "Examiner",
  "approvals.fingerprintUnavailable": "indisponible",
  "approvals.generateBacklog": "Générer le backlog",
  "approvals.generateBacklogDesc": "décompose cette spécification approuvée en Epics → Stories → Tasks. Le backlog généré passe à son tour par une approbation avant d'être actif sur le board.",
  "approvals.generateEpics": "Générer les epics",
  "approvals.generateEpicsDesc": "décompose directement ce cadrage en epics sur le board — auto-acceptables par leur générateur tant qu'ils restent intacts ; dès qu'un epic est modifié, une autre personne doit l'accepter — amorçant la cascade idée → epics → features → US → tâches.",
  "approvals.generateOptions": "Générer les options",
  "approvals.generateOptionsDesc": "compare plusieurs pistes de solution depuis ce cadrage approuvé. Les options générées reviennent en approbation, puis nourrissent la spécification — l'étape suivante du cycle.",
  "approvals.generatePersonas": "Générer les personas",
  "approvals.generatePersonasProcessesDesc": "dérivent, de ce même cadrage, les utilisateurs cibles (rôles, objectifs, frustrations) et les processus métier (acteurs, étapes, exceptions). Chacun revient en approbation.",
  "approvals.generateProcesses": "Générer les processus",
  "approvals.howProduced": "Comment cet artefact a été produit",
  "approvals.instructionRequired": "Indiquez ce qui doit changer : la consigne guide la régénération.",
  "approvals.loading": "Chargement…",
  "approvals.metaArtifact": "Artefact",
  "approvals.metaDecision": "Décision",
  "approvals.metaInputFingerprint": "Empreinte entrée",
  "approvals.metaModel": "Modèle",
  "approvals.metaOutputFingerprint": "Empreinte sortie",
  "approvals.metaPromptCard": "Carte de prompt",
  "approvals.metaRequester": "Demandeur",
  "approvals.metaVersion": "Version",
  "approvals.modelUnknown": "inconnu",
  "approvals.pageDescription": "Chaque artefact généré attend ici la décision d'un relecteur — jamais celle de son demandeur.",
  "approvals.pageTitle": "Centre d'approbations",
  "approvals.quoi": "demandes",
  "approvals.readonlyStrong": "Lecture seule.",
  "approvals.readonlyText": "Votre rôle ne permet pas de décider — seul un propriétaire ou un contributeur, différent du demandeur, peut approuver ou rejeter.",
  "approvals.reasonRequired": "Un rejet exige un motif : il sera lu par le demandeur.",
  "approvals.regenerate": "Régénérer",
  "approvals.regenHint": "Décrivez la révision attendue ; l'IA repart de l'entrée d'origine augmentée de votre consigne, en version suivante.",
  "approvals.regenLaunchedPrefix": "Régénération lancée en",
  "approvals.regenLaunchedSuffix": "— suivez le modèle au travail ci-dessous ; la nouvelle version reviendra en approbation.",
  "approvals.regenPlaceholder": "Ex. Numérote chaque exigence et ajoute des critères de performance.",
  "approvals.regenTitle": "Régénérer avec instructions",
  "approvals.regenToast": "Régénération lancée",
  "approvals.reject": "Rejeter",
  "approvals.rejectConsequence": "retire l'artefact du disque ; son contenu reste consultable ici avec votre justification.",
  "approvals.reviewAttestation": "J'ai relu le contenu ci-dessus dans son intégralité",
  "approvals.evidenceAttestation": "J'ai examiné les preuves ancrées de ce reçu exact et validé leur pertinence",
  "approvals.evidenceAttestationRequired": "Examinez les preuves ancrées et cochez leur attestation avant d’approuver.",
  "approvals.revisedOnInstruction": "révisée sur consigne :",
  "approvals.saveEdit": "Enregistrer l’édition",
  "approvals.specGateApprovalBlocked": "L’approbation sera disponible après un Spec Gate réussi sur cette version exacte. Le rejet reste possible.",
  "approvals.specGateChecks": "Contrôles réussis",
  "approvals.specGateError": "Évaluation interrompue",
  "approvals.specGateErrorHint": "L’évaluation n’a pas pu aboutir. Relancez-la après avoir vérifié la disponibilité du service IA.",
  "approvals.specGateEvaluate": "Évaluer la spécification",
  "approvals.specGateFailed": "Corrections requises",
  "approvals.specGateFailedChecks": "Contrôles à corriger",
  "approvals.specGateFailedHint": "Corrigez les contrôles et constats ci-dessous, puis relancez une évaluation sur la nouvelle version.",
  "approvals.specGateFindings": "Constats prioritaires",
  "approvals.specGateFreshUntil": "valide jusqu’au",
  "approvals.specGateNotRequested": "Évaluation requise",
  "approvals.specGateNotRequestedHint": "La spécification doit être évaluée sur 13 contrôles avant de pouvoir être approuvée.",
  "approvals.specGatePassed": "Prête pour approbation",
  "approvals.specGatePassedHint": "Les 13 contrôles sont réussis et le reçu correspond à cette version exacte.",
  "approvals.specGateGrounded": "Preuve ancrée",
  "approvals.specGateAuthoritySteps": "Étapes d’autorité",
  "approvals.specGateGroundedStep": "1. Preuve ancrée",
  "approvals.specGateGroundedYes": "Coordonnées résolues et empreintes contrôlées par le serveur ; leur pertinence reste à valider humainement.",
  "approvals.specGateGroundedNo": "Preuve machine non établie.",
  "approvals.specGateHumanStep": "2. Validation humaine",
  "approvals.specGateHumanYes": "Attestation humaine enregistrée sur ce reçu exact.",
  "approvals.specGateHumanNo": "Attestation explicite encore requise.",
  "approvals.specGateBundle": "bundle",
  "approvals.specGateEvidence": "Preuves ancrées",
  "approvals.specGateEvidenceUnavailable": "Les preuves ancrées ne peuvent pas être vérifiées. L’attestation est bloquée.",
  "approvals.specGateReadonly": "Un propriétaire ou contributeur peut lancer l’évaluation. Vous pouvez consulter son résultat.",
  "approvals.specGateReasons": "Pourquoi le gate bloque",
  "approvals.specGateReceipt": "Reçu exact",
  "approvals.specGateRetry": "Réévaluer la spécification",
  "approvals.specGateRunning": "Évaluation en cours",
  "approvals.specGateRunningHint": "Le modèle vérifie les 13 contrôles. Le résultat apparaîtra ici automatiquement.",
  "approvals.specGateScore": "Score global",
  "approvals.specGateStale": "Évaluation obsolète",
  "approvals.specGateStaleHint": "Le contenu ou sa version a changé depuis le dernier reçu. Une nouvelle évaluation est nécessaire.",
  "approvals.specGateStarting": "Lancement…",
  "approvals.specGateTitle": "Qualité de la spécification",
  "approvals.renewal.title": "Renouveler la preuve Spec Gate",
  "approvals.renewal.badgeCurrent": "Preuve courante",
  "approvals.renewal.badgeExpired": "Preuve expirée",
  "approvals.renewal.success": "Preuve renouvelée et attestée par {{par}}, valide jusqu’au {{date}}. La génération est de nouveau possible ; la décision d’origine est inchangée.",
  "approvals.renewal.alreadyCurrent": "La preuve épinglée est courante : si une génération a été refusée, la spécification n’est peut-être pas encore publiée.",
  "approvals.renewal.expiredHint": "La preuve attestée à la décision a expiré le {{date}} (validité 24 h). La spécification reste approuvée, mais aucune génération n’est possible tant qu’une preuve courante ne lui est pas rattachée.",
  "approvals.renewal.expiredHintNoDate": "La preuve attestée à la décision n’est plus courante. La spécification reste approuvée, mais aucune génération n’est possible tant qu’une preuve courante ne lui est pas rattachée.",
  "approvals.renewal.steps": "Étapes du renouvellement",
  "approvals.renewal.step1": "1. Réévaluer la preuve",
  "approvals.renewal.running": "Réévaluation en cours sur le snapshot exact approuvé…",
  "approvals.renewal.passed": "Nouvelle preuve PASS (13/13 contrôles ancrés), valide jusqu’au {{date}}.",
  "approvals.renewal.passedNoDate": "Nouvelle preuve PASS (13/13 contrôles ancrés).",
  "approvals.renewal.failed": "La réévaluation a relevé des corrections : cette preuve ne peut pas être rattachée. Corrigez la spécification dans une nouvelle version, ou relancez la réévaluation.",
  "approvals.renewal.error": "La réévaluation n’a pas abouti. Relancez-la ; le contenu reste inchangé.",
  "approvals.renewal.none": "Aucune réévaluation depuis l’expiration : lancez-la pour obtenir une preuve courante.",
  "approvals.renewal.starting": "Lancement…",
  "approvals.renewal.reevaluate": "Réévaluer la preuve",
  "approvals.renewal.step2": "2. Rattacher la preuve renouvelée",
  "approvals.renewal.waitingPass": "Disponible dès qu’une réévaluation PASS du même contenu est enregistrée.",
  "approvals.renewal.evidenceUnavailable": "Les preuves du reçu renouvelé ne peuvent pas être chargées : le rattachement attend leur examen.",
  "approvals.renewal.readonly": "Seul un propriétaire ou un contributeur du projet peut renouveler la preuve.",
  "approvals.renewal.selfRefused": "Vous avez demandé cette spécification : un autre propriétaire ou contributeur doit attester la preuve renouvelée.",
  "approvals.renewal.attestation": "J’ai examiné les preuves ancrées de ce reçu renouvelé et validé leur pertinence pour la spécification approuvée.",
  "approvals.renewal.comment": "Commentaire (facultatif)",
  "approvals.renewal.attaching": "Rattachement…",
  "approvals.renewal.attach": "Rattacher la preuve renouvelée",
  "approvals.renewal.goTo": "Renouveler la preuve de la spécification",
  "approvals.statusApproved": "Approuvé",
  "approvals.statusPending": "En attente",
  "approvals.statusRejected": "Rejeté",
  "approvals.supersededBadge": "remplacée par une version plus récente",
  "approvals.theProcesses": "les processus",
  "artifactFamily.analyses": "Analyse",
  "artifactFamily.backlog": "Backlog",
  "artifactFamily.cadrages": "Cadrage",
  "artifactFamily.changes": "Changement",
  "artifactFamily.options": "Options",
  "artifactFamily.personas": "Personas",
  "artifactFamily.processes": "Processus",
  "artifactFamily.reviews": "Revue",
  "artifactFamily.specs": "Spécification",
  "artifacts.colArtifact": "Artefact",
  "artifacts.colCard": "Carte",
  "artifacts.colCodeCommit": "Commit code",
  "artifacts.colOutputHash": "Empreinte sortie",
  "artifacts.colPublicationCommit": "Commit publication",
  "artifacts.description": "Tout ce qui a été approuvé puis commité dans cet espace — spec, empreinte, commit de publication ET commit du code généré. Le dépôt reflète l'état des specs approuvées.",
  "artifacts.emptyHint": "Approuvez une génération : l'artefact commité apparaîtra ici avec son hash et ses commits.",
  "artifacts.emptyTitle": "Aucun artefact publié",
  "artifacts.fieldArtifactSpec": "Artefact (spec)",
  "artifacts.fieldCodeCommit": "Commit du code généré",
  "artifacts.fieldDecidedBy": "Approuvé par",
  "artifacts.fieldInputHash": "Empreinte entrée",
  "artifacts.fieldModel": "Modèle",
  "artifacts.fieldOutputHash": "Empreinte sortie",
  "artifacts.fieldPromptCard": "Carte de prompt",
  "artifacts.fieldPublicationCommit": "Commit de publication",
  "artifacts.fieldRequestedBy": "Demandé par",
  "artifacts.loading": "Chargement des artefacts…",
  "artifacts.quoi": "artefacts",
  "artifacts.title": "Artefacts publiés",
  "artifacts.traceability": "Traçabilité",
  "artifacts.traceabilityDescription": "L'artefact (spec) et l'état du dépôt qui lui correspond : commit du code généré et commit de publication. Cliquez une valeur pour la copier.",
  "artifacts.traceabilityTitle": "Traçabilité de l'artefact",
  "att.deleteConsequence": "Le fichier est retiré de cet item et du stockage. Vous devrez le téléverser à nouveau pour le récupérer.",
  "att.deletedToast": "Pièce jointe supprimée",
  "att.deleteTitle": "Supprimer « {{f}} » ?",
  "att.deleteVerb": "Supprimer la pièce jointe",
  "att.downloadedToast": "Pièce jointe téléchargée",
  "att.uploadedToast": "Pièce jointe ajoutée",
  "attach.addFile": "Ajouter un fichier",
  "attach.downloadAria": "Télécharger",
  "attach.empty": "Aucune pièce jointe.",
  "attach.heading": "Pièces jointes",
  "attach.hide": "Masquer les pièces jointes",
  "attach.loading": "Chargement…",
  "attach.removeAria": "Supprimer",
  "attach.unitBytes": "o",
  "attach.unitKilobytes": "Ko",
  "attach.unitMegabytes": "Mo",
  "attach.uploading": "Envoi…",
  "attachViewer.download": "Télécharger",
  "attachViewer.fetchError": "Impossible de charger la pièce jointe.",
  "attachViewer.loading": "Chargement…",
  "attachViewer.unsupported": "Aperçu indisponible pour ce type de fichier.",
  "attention.all": "Tout ({{n}})",
  "attention.approvalSubtitle": "demandée par {{w}}",
  "attention.approvePlan": "Approuver le plan et le budget proposés",
  "attention.category.approvals": "Approbations",
  "attention.category.colony": "Colonie",
  "attention.category.organisation": "Organisation",
  "attention.category.quality": "Qualité",
  "attention.description": "Ce qui attend une décision dans ce projet, avec son âge.",
  "attention.detail.age": "En attente depuis",
  "attention.detail.kind": "Nature",
  "attention.detail.who": "Par",
  "attention.detail.why": "Raison",
  "attention.emptyHint": "Les approbations, plans de mission et escalades apparaîtront ici avec leur âge.",
  "attention.emptyTitle": "Rien n’attend votre décision",
  "attention.escalationSubtitle": "{{c}} · {{r}}",
  "attention.filters": "Filtrer par catégorie",
  "attention.kind.ai_tool_execution": "Outil IA",
  "attention.kind.approval": "Approbation",
  "attention.kind.mission_escalation": "Escalade",
  "attention.kind.mission_plan": "Plan de mission",
  "attention.kind.mission_task_stopped": "Colonie arrêtée",
  "attention.loading": "Chargement…",
  "attention.openCockpit": "Décider dans le cockpit HITL",
  "attention.openMission": "Ouvrir le poste de pilotage",
  "attention.planSubtitle": "{{k}} · lancée par {{w}}",
  "attention.reject": "Refuser avec motif",
  "attention.taskSubtitle": "{{c}} · {{r}}",
  "attention.title": "Boîte d’attention",
  "attention.toolSubtitle": "proposé par {{w}}",
  "audit.chainVerified": "Chaîne de hachage vérifiée — aucune altération détectée.",
  "audit.description": "Rejoue le trail de gouvernance de l'espace (décisions + journal d'événements) et recalcule la chaîne de hachage : toute altération d'un événement signé est détectée.",
  "audit.downloadBundle": "Télécharger le bundle",
  "audit.exportedToast": "Export d'audit généré",
  "audit.fingerprint": "Empreinte",
  "audit.generatedAt": "Généré le",
  "audit.generateExport": "Générer l'export",
  "audit.generating": "Génération…",
  "audit.governanceDecisions": "décision(s) de gouvernance.",
  "audit.heading": "Export d'audit",
  "audit.pseudonymise": "Remplacer les identifiants de personnes par des pseudonymes stables",
  "audit.signedEventsVerified": "événement(s) signé(s) vérifié(s)",
  "audit.tampered": "Altération détectée",
  "audit.unsignedEvents": "non signé(s) (antérieurs à l'immuabilité)",
  "backlog.accept": "Accepter",
  "backlog.acceptedToast": "Item accepté",
  "backlog.aiGeneratedEpic": "Epic généré par l'IA — à faire accepter par une personne AUTRE que son générateur.",
  "backlog.aiGeneratedItem": "Item généré par l'IA — à accepter (auto-acceptation possible tant qu'il n'a pas été modifié depuis sa génération).",
  "backlog.aiItemModified": "Item généré par l'IA puis modifié — à faire accepter par une autre personne que son générateur.",
  "backlog.analysisStarted": "Analyse lancée — le worker cartographie le périmètre ci-dessous.",
  "backlog.analyzeRepo": "Analyser le dépôt",
  "backlog.analyzeScopeRequired": "Indiquez au moins un fichier à analyser.",
  "backlog.approvedDiffAttached": " · diff approuvé joint",
  "backlog.bulkConfirmC1": "Le changement porte sur {{n}} item(s) à la fois, et {{f}} de chacun est écrasé.",
  "backlog.bulkConfirmC2": "Aucune annulation n'est possible : il faudrait refaire la sélection et revenir en arrière item par item.",
  "backlog.bulkConfirmTitle": "Modifier {{n}} item(s) ?",
  "backlog.bulkConfirmVerb": "Modifier",
  "backlog.bulkFieldPriority": "la priorité",
  "backlog.bulkFieldSprint": "le sprint",
  "backlog.bulkFieldStatus": "le statut",
  "backlog.bulkPriorityPlaceholder": "Priorité…",
  "backlog.bulkPriorityLabel": "Priorité (masse)",
  "backlog.bulkSprintPlaceholder": "Sprint…",
  "backlog.bulkSprintLabel": "Sprint (masse)",
  "backlog.bulkStatusPlaceholder": "Statut…",
  "backlog.bulkStatusLabel": "Statut (masse)",
  "backlog.bulkEdit": "Édition en masse",
  "backlog.bulkToast": "Items mis à jour",
  "backlog.cancel": "Annuler",
  "backlog.childrenGenerationStarted": "Génération lancée — les enfants apparaîtront au board après génération (à accepter).",
  "backlog.childrenGenerationPending": "Génération des éléments en cours…",
  "backlog.errorKeep": "La passerelle n’a pas répondu ({{m}}). Le tableau précédent reste affiché.",
  "backlog.generatingChildren": "Génération…",
  "backlog.generatingDiff": "Génération…",
  "backlog.analyzing": "Analyse…",
  "backlog.designingTests": "Conception…",
  "backlog.openSpecifications": "Ouvrir les spécifications",
  "backlog.reviewPending": "Revue…",
  "backlog.aiActionPending": "Action IA en cours — vous pouvez suivre sa progression ci-dessous.",
  "backlog.clear": "Effacer",
  "backlog.codeGenerationStarted": "Génération lancée — suivez le modèle au travail ci-dessous ; le diff sera à approuver.",
  "backlog.codeReview": "Revue de code",
  "backlog.collapse": "Replier",
  "backlog.columnDone": "Terminé",
  "backlog.columnInProgress": "En cours",
  "backlog.columnInReview": "En revue",
  "backlog.columnTodo": "À faire",
  "backlog.componentVersion": "Composant / version",
  "backlog.createStory": "Créer la story",
  "backlog.creating": "Création…",
  "backlog.description": "Le backlog agile de l'espace — généré depuis une spécification approuvée, puis piloté colonne par colonne.",
  "backlog.designTests": "Concevoir des tests",
  "backlog.designTestsSubmit": "Concevoir les tests",
  "backlog.edit": "Éditer",
  "backlog.effortPoints": "Effort (points)",
  "backlog.emptyHint": "Générez le backlog depuis une spécification approuvée, ou créez une story.",
  "backlog.emptyTitle": "Backlog vide",
  "backlog.epicsHeading": "Epics — décomposez-les en features avec l'IA",
  "backlog.exitSelection": "Quitter la sélection",
  "backlog.expand": "Déplier",
  "backlog.featuresGenerationStarted": "Génération lancée — les features apparaîtront sur le board après génération (à accepter).",
  "backlog.filesInvolved": "Fichiers concernés (séparés par des virgules)",
  "backlog.filesToAnalyze": "Fichiers à analyser (séparés par des virgules)",
  "backlog.filesToCover": "Fichiers à couvrir (séparés par des virgules)",
  "backlog.filterKindAll": "Tous",
  "backlog.filterPriorityAll": "Toutes",
  "backlog.generateCode": "Générer le code",
  "backlog.generateDiff": "Générer le diff",
  "backlog.generateFeatures": "Générer les features",
  "backlog.generateStories": "Générer les US",
  "backlog.generateTasks": "Générer les tâches",
  "backlog.kindBug": "Bug",
  "backlog.kindEpic": "Epic",
  "backlog.kindFeature": "Feature",
  "backlog.kindStory": "Story",
  "backlog.kindTask": "Tâche",
  "backlog.kindUsShort": "US",
  "backlog.labels": "Labels",
  "backlog.links": "Liens",
  "backlog.loading": "Chargement du backlog…",
  "backlog.more": "Plus d'actions",
  "backlog.mrAlreadyOpen": "(déjà ouverte)",
  "backlog.mrOnGitlab": "sur GitLab",
  "backlog.mrOpened": "ouverte",
  "backlog.newStory": "Nouvelle story",
  "backlog.noEpicGroup": "Sans epic",
  "backlog.none": "Aucun",
  "backlog.noSprint": "Aucun sprint",
  "backlog.openApprovals": "Ouvrir le centre d'approbations",
  "backlog.parentEpic": "Epic parent",
  "backlog.priority": "Priorité",
  "backlog.priorityCritical": "Critique",
  "backlog.priorityHigh": "Haute",
  "backlog.priorityLow": "Basse",
  "backlog.priorityMedium": "Moyenne",
  "backlog.proposeMr": "Proposer la MR",
  "backlog.readOnly": "Lecture seule — votre rôle ne permet pas de modifier le backlog.",
  "backlog.reviewStarted": "Revue lancée sur le dernier changement approuvé.",
  "backlog.save": "Enregistrer",
  "backlog.scopeRequired": "Indiquez au moins un fichier concerné.",
  "backlog.select": "Sélectionner",
  "backlog.selectedCount": "sélectionné(s)",
  "backlog.sending": "Envoi…",
  "backlog.sprintTitle": "Sprint",
  "backlog.startAnalysis": "Lancer l'analyse",
  "backlog.storyAsA": "En tant que",
  "backlog.storyAsAAide": "Le rôle qui a ce besoin.",
  "backlog.storyAsAPlaceholder": "un rôle (ex. utilisateur)",
  "backlog.storyCreatedToast": "Story créée",
  "backlog.storyIWant": "Je veux",
  "backlog.storyIWantAide": "Le besoin lui-même : il sert de titre à la story.",
  "backlog.storyIWantPlaceholder": "le besoin (sert de titre)",
  "backlog.storySoThat": "Afin de",
  "backlog.storySoThatPlaceholder": "un bénéfice",
  "backlog.storyStructureHint": "Une user story se rédige en trois parties. « Je veux » sert de titre.",
  "backlog.storyTitle": "Titre de la story",
  "backlog.tabBoard": "Tableau",
  "backlog.tabList": "Liste",
  "backlog.tabTree": "Hiérarchie",
  "backlog.templatePrefix": "Modèle",
  "backlog.templateTitle": "Modèle de configuration de ce projet",
  "backlog.testsDesignStarted": "Conception de tests lancée — le worker propose des tests sur le périmètre ci-dessous.",
  "backlog.openTestApproval": "Ouvrir le centre d’approbations",
  "backlog.testsScopeRequired": "Indiquez au moins un fichier à couvrir.",
  "backlog.title": "Backlog",
  "backlog.filtersActions": "Filtres et actions du backlog",
  "backlog.toAccept": "à accepter",
  "backlog.type": "Type",
  "backlog.viewsLabel": "Vues du backlog",
  "champ.entierPositif": "Un nombre entier positif est attendu",
  "champ.longueurMax": "{{n}} caractères au maximum ({{actuel}} saisis)",
  "champ.longueurMin": "Au moins {{n}} caractères — il en manque {{manque}}",
  "champ.obligatoireSr": "(obligatoire)",
  "champ.pasAvant": "Doit être postérieur ou égal à « {{ref}} »",
  "champ.requis": "Ce champ est obligatoire",
  "chat.assistantTyping": "L'assistant répond…",
  "chat.chooseModel": "Choisir un modèle…",
  "chat.description": "Dialoguez avec l'assistant dans le contexte de votre projet.",
  "chat.emptyState": "Posez une première question pour démarrer la conversation.",
  "chat.inputPlaceholder": "Écrivez votre question…",
  "chat.inputTokens": "Tokens entrée",
  "chat.loadingModels": "Chargement des modèles…",
  "chat.messageLabel": "Votre message",
  "chat.model": "Modèle",
  "chat.noModelsTitle": "Aucun modèle autorisé dans cet espace",
  "chat.noModelsHint": "Un propriétaire doit autoriser au moins un modèle avant de lancer une conversation.",
  "chat.configureModels": "Configurer les modèles",
  "chat.observabilityMissing": "Identifiant Langfuse absent de la réponse — observabilité IA dégradée.",
  "chat.observabilityTrace": "Corrélation Langfuse — identifiant IA",
  "admin.langfuseProbeLatency": "durée du probe",
  "admin.langfuseIndexStatus": "indexation",
  "chat.outputTokens": "Tokens sortie",
  "chat.readOnly": "Lecture seule — votre rôle ne permet pas d'envoyer de messages.",
  "chat.roleAssistant": "Assistant",
  "chat.roleSystem": "Système",
  "chat.roleYou": "Vous",
  "chat.sendButton": "Envoyer",
  "chat.title": "Chat",
  "classif.componentCreatedToast": "Composant créé",
  "classif.componentTooltip": "Composant",
  "classif.newComponent": "Nouveau composant",
  "classif.newVersion": "Nouvelle version",
  "classif.noComponent": "Aucun composant",
  "classif.noVersion": "Aucune version",
  "classif.versionCreatedToast": "Version créée",
  "classif.versionTooltip": "Version cible",
  "cmdk.createGroup": "Créer",
  "cmdk.emptyState": "Aucun résultat.",
  "cmdk.searchPlaceholder": "Aller à un écran, lancer une action…",
  "comments.addedToast": "Commentaire publié",
  "comments.empty": "Aucun commentaire.",
  "comments.hide": "Masquer les commentaires",
  "comments.loading": "Chargement…",
  "comments.mention": "Mentionner :",
  "comments.placeholder": "Écrire un commentaire… (@pseudo pour notifier un membre)",
  "comments.submit": "Commenter",
  "comments.toggle": "Commentaires",
  "compare.compare": "Comparer",
  "compare.comparison": "Comparaison",
  "compare.createdToast": "Comparaison lancée",
  "compare.description": "Rejouez un prompt sur plusieurs modèles et comparez leurs sorties et leur coût.",
  "compare.emptyHint": "Lancez-en une ci-dessus.",
  "compare.emptyTitle": "Aucune comparaison",
  "compare.loading": "Chargement…",
  "compare.loadingModels": "Chargement des modèles…",
  "compare.modelFailed": "Modèle en échec",
  "compare.modelsLegend": "Modèles à comparer (au moins deux distincts)",
  "compare.noModelsTitle": "Aucun modèle autorisé dans cet espace",
  "compare.noModelsHint": "Autorisez au moins deux modèles avant de lancer une comparaison.",
  "compare.configureModels": "Configurer les modèles",
  "compare.modelsRequired": "Choisissez au moins deux modèles distincts à comparer.",
  "compare.newComparison": "Nouvelle comparaison",
  "compare.promptLabel": "Prompt",
  "compare.promptPlaceholder": "Explique la séparation des tâches en une phrase.",
  "compare.promptRequired": "Écrivez le prompt à comparer.",
  "compare.readOnly": "Lecture seule — lancer une comparaison est réservé aux contributeurs.",
  "compare.recentComparisons": "Comparaisons récentes",
  "compare.reviewUnavailable": "La revue nécessite au moins deux sorties réussies, non vides et mesurées.",
  "compare.starting": "Lancement…",
  "compare.title": "Diff multi-LLM",
  "compare.workerReplaying": "Le worker rejoue le prompt sur chaque modèle…",
  "config.addAgent": "Ajouter un agent",
  "config.addApi": "Ajouter une API",
  "config.addMcp": "Ajouter un serveur MCP",
  "config.addMode": "Ajouter un mode",
  "config.addModel": "Ajouter un modèle",
  "config.addWorkflow": "Ajouter un workflow",
  "config.agentDescPlaceholder": "Description",
  "config.agentIdPlaceholder": "Identifiant",
  "config.agentLabelPlaceholder": "Nom affiché",
  "config.agentRolePlaceholder": "Capability role",
  "config.agents": "Agents",
  "config.agentsEmpty": "Aucun agent déclaré.",
  "config.allerTemplateEspace": "Ouvrir celui de ce projet",
  "config.annulerModifs": "Annuler",
  "config.apercu.aucunProjet": "Aucun projet n'utilise ce template — les changements faits ici changeront ce que personne ne voit.",
  "config.apercu.contenu": "Ce que contient ce template",
  "config.apercu.impact": "Impact sur le projet actif",
  "config.apercu.impactAucun": "Tous les items de ce projet ont un type et un statut déclarés par ce template.",
  "config.apercu.impactChargement": "Mesure en cours…",
  "config.apercu.impactHypothese": "(ce projet n'utilise PAS ce template : chiffres à titre d'hypothèse)",
  "config.apercu.impactIndisponible": "Les items du projet n'ont pas pu être lus : l'impact ne peut pas être mesuré.",
  "config.apercu.impactKind": "{{n}} items portent le type « {{k}} », absent de ce template : ils restent en base mais ne peuvent plus être classés.",
  "config.apercu.impactNote": "Calculé uniquement sur le projet actif, à partir de ses items chargés. Les autres projets rattachés ne sont pas mesurés ici.",
  "config.apercu.impactPortee": "Mesuré sur « {{p}} », {{n}} items.",
  "config.apercu.impactSansProjet": "Aucun projet actif : sélectionnez-en un pour mesurer l'impact.",
  "config.apercu.impactStatut": "{{n}} items sont dans le statut « {{s}} », absent de ce template : leur colonne disparaîtra du board.",
  "config.apercu.nAgents": "agents",
  "config.apercu.nApis": "APIs déclarées",
  "config.apercu.nChamps": "champs déclarés",
  "config.apercu.nEtapes": "étapes de cycle de vie",
  "config.apercu.nLiaisons": "types de liaison",
  "config.apercu.nMcp": "serveurs MCP",
  "config.apercu.nModeles": "modèles LLM",
  "config.apercu.nStatuts": "statuts",
  "config.apercu.nTypes": "types de work-item",
  "config.apercu.nWorkflows": "workflows dynamiques",
  "config.apercu.projetActif": "projet actif",
  "config.apercu.rattachement": "Projets rattachés",
  "config.apercu.rattacherOu": "Le rattachement se choisit à la création d'un projet, dans « Nouveau projet ».",
  "config.apercu.sansDescription": "Ce template n'a pas de description : rien n'indique à quoi il sert.",
  "config.apiAuthPlaceholder": "Authentification (ex. Bearer, none)",
  "config.apiBaseUrlPlaceholder": "URL de base (ex. https://…/api/v4)",
  "config.apiDescPlaceholder": "Description",
  "config.apiIdPlaceholder": "Identifiant (ex. gitlab)",
  "config.apiLabelPlaceholder": "Nom affiché",
  "config.apis": "APIs & intégrations",
  "config.apisEmpty": "Aucune API déclarée.",
  "config.avertissementAutre": "Vous éditez un template que le projet « {{p}} » n'utilise pas. Ses écrans ne changeront pas.",
  "config.builtinBadge": "Intégré",
  "config.cancel": "Annuler",
  "config.chipEspaceActif": "Utilisé par l'espace actif",
  "config.createdToast": "Template créé",
  "config.createTemplateButton": "Créer le template",
  "config.deleteAttest": "J'ai vérifié quels projets utilisent ce template",
  "config.deleteC1": "Les projets qui utilisent ce template retombent sur le modèle intégré.",
  "config.deleteC2": "Les types et statuts spécifiques à ce template disparaissent de leurs écrans ; les items qui les portent restent en base mais ne peuvent plus être classés.",
  "config.deleteConfirm": "Supprimer ce template ? Cette action est irréversible.",
  "config.deletedToast": "Template supprimé",
  "config.deleteTemplate": "Supprimer ce template",
  "config.deleteTitle": "Supprimer le template « {{n}} » ?",
  "config.deleteVerb": "Supprimer le template",
  "config.duplicateDefault": "Dupliquer le Default pour éditer",
  "config.duplicateDefaultDesc": "Modèle dérivé du Default, librement modifiable.",
  "config.duplicateDefaultName": "Copie du Default",
  "config.duplicatedToast": "Template dupliqué",
  "config.emptyLinks": "Ce template ne définit aucune liaison.",
  "config.emptyTypes": "Ce template ne définit aucun type de work-item.",
  "config.engineChosenBy": "choix par",
  "config.engineFromArgument": "argument en ligne de commande",
  "config.engineFromDefault": "valeur par défaut",
  "config.engineFromEnv": "variable d'environnement",
  "config.engineRunning": "Moteur servant les jobs",
  "config.engineStale": "— dernier battement, worker actuellement arrêté",
  "config.enregistrer": "Enregistrer",
  "config.errNoDefault": "Le template Default est indisponible : impossible de créer une copie.",
  "config.generates": "Génère",
  "config.lifecycle": "Cycle de vie produit",
  "config.lifecycle.add": "Ajouter une étape",
  "config.lifecycle.empty": "Aucune étape propre à ce template : le cycle intégré ci-dessus s'applique.",
  "config.lifecycle.errDupStage": "Les clés d'étape doivent être uniques.",
  "config.lifecycle.fallbackBadge": "cycle intégré",
  "config.lifecycle.hint": "Les étapes que traverse une idée jusqu'à la publication. Laissez la liste vide pour conserver le cycle de vie intégré ; une étape réutilisant une clé connue hérite de son icône et de sa route.",
  "config.lifecycle.icon": "Icône de l'étape",
  "config.lifecycle.iconDefault": "(par défaut de la clé)",
  "config.lifecycle.iconLbl": "Icône",
  "config.lifecycle.key": "Clé de l'étape (ex. idee)",
  "config.lifecycle.keyLbl": "Clé de l'étape",
  "config.lifecycle.label": "Libellé affiché",
  "config.lifecycle.labelLbl": "Libellé",
  "config.lifecycle.preview": "Aperçu du rail",
  "config.lifecycle.remove": "Supprimer cette étape",
  "config.lifecycle.seed": "Partir du cycle intégré",
  "config.lifecycle.to": "Route où agir (ex. /ideas)",
  "config.lifecycle.toLbl": "Route",
  "config.lineage": "Lignée de génération",
  "config.lineageHint": "Toujours générer les enfants à partir du parent, de proche en proche.",
  "config.links": "Types de liaisons",
  "config.llm": "LLM & routage",
  "config.llmModelsEmpty": "Aucun modèle déclaré.",
  "config.llmRoutingLabel": "Politique de routage",
  "config.llmRoutingPlaceholder": "Ex. chaque prompt déclare une capability role ; le routeur la résout localement.",
  "config.mcp": "Serveurs MCP & tools",
  "config.mcpDescPlaceholder": "Description",
  "config.mcpEmpty": "Aucun serveur MCP déclaré.",
  "config.mcpIdPlaceholder": "Identifiant",
  "config.mcpLabelPlaceholder": "Nom affiché",
  "config.mcpToolsPlaceholder": "Tools, séparés par des virgules",
  "config.modeActive": "Mode appliqué à cet espace",
  "config.modeDescPlaceholder": "Description",
  "config.modeIdPlaceholder": "Identifiant",
  "config.model.addField": "Ajouter un champ",
  "config.model.addLink": "Ajouter une liaison",
  "config.model.addStatus": "Ajouter un statut",
  "config.model.addType": "Ajouter un type",
  "config.model.errDupField": "Les clés de champ doivent être uniques dans un type.",
  "config.model.errDupLink": "Les clés de liaison doivent être uniques.",
  "config.model.errDupStatus": "Les clés de statut doivent être uniques.",
  "config.model.errDupType": "Les clés de type doivent être uniques.",
  "config.model.errNoStatus": "Au moins un statut est requis.",
  "config.model.errNoType": "Au moins un type de work-item est requis.",
  "config.model.fieldKey": "Clé du champ",
  "config.model.fieldLabel": "Libellé du champ",
  "config.model.fields": "Champs",
  "config.model.fieldsEmpty": "Aucun champ.",
  "config.model.fieldType": "Type du champ",
  "config.model.generates": "Génère (clés enfants, séparées par des virgules)",
  "config.model.generatesLbl": "Génère",
  "config.model.iconDefault": "(par défaut du kind)",
  "config.model.lineageDerived": "Recomposée à partir des « génère » ci-dessus — elle ne se saisit pas séparément.",
  "config.model.linkDesc": "Description",
  "config.model.linkKey": "Clé (ex. blocks)",
  "config.model.linkKeyLbl": "Clé",
  "config.model.linkLabel": "Libellé",
  "config.model.linksEmpty": "Aucune liaison définie.",
  "config.model.linksHint": "Les relations que l'on pourra déclarer entre deux items (bloque, duplique…).",
  "config.model.moveDown": "Descendre",
  "config.model.moveUp": "Monter",
  "config.model.removeField": "Supprimer ce champ",
  "config.model.removeLink": "Supprimer cette liaison",
  "config.model.removeStatus": "Supprimer ce statut",
  "config.model.removeType": "Supprimer ce type",
  "config.model.required": "Requis",
  "config.model.reset": "Annuler",
  "config.model.richBody": "Corps riche (Markdown + Mermaid)",
  "config.model.save": "Enregistrer le modèle",
  "config.model.savedToast": "Modèle enregistré",
  "config.model.statusKey": "Clé du statut (ex. todo)",
  "config.model.statusKeyLbl": "Clé du statut",
  "config.model.statusLabel": "Libellé du statut",
  "config.model.statusTone": "Ton",
  "config.model.title": "Modèle de work item",
  "config.model.toneDefault": "(par défaut du statut)",
  "config.model.transitions": "Transitions (clés cibles)",
  "config.model.typeDesc": "Description du type",
  "config.model.typeIcon": "Icône",
  "config.model.typeKey": "Clé du type (ex. epic)",
  "config.model.typeKeyLbl": "Clé du type",
  "config.model.typeLabel": "Libellé affiché",
  "config.model.typesEmpty": "Aucun type défini.",
  "config.model.typesHint": "Clé (identifiant stable), libellé, type d'enfant engendré et champs de chaque type.",
  "config.model.unknownKind": "(type inconnu)",
  "config.model.workflowEmpty": "Aucun statut défini.",
  "config.modeLabelPlaceholder": "Nom affiché",
  "config.modelIdPlaceholder": "Identifiant (ex. qwen3-coder:30b)",
  "config.modelLabelPlaceholder": "Nom affiché",
  "config.modelPoolPlaceholder": "Pool (gpu, cpu…)",
  "config.modelRolePlaceholder": "Capability role (ex. code_agent_primary)",
  "config.modeNone": "(aucun — approbation par un second humain)",
  "config.modes": "Modes d’exécution",
  "config.modesEmpty": "Aucun mode déclaré.",
  "config.newTemplate": "Nouveau template",
  "config.newTemplateHint": "Crée un template d'organisation en clonant la configuration du Default.",
  "config.onglet.apercu": "Aperçu",
  "config.onglet.cycle": "Cycle de vie",
  "config.onglet.liaisons": "Liaisons",
  "config.onglet.plateforme": "Plateforme",
  "config.onglet.statuts": "Statuts & transitions",
  "config.onglet.types": "Types & champs",
  "config.nModifications": "{{n}} modifications non enregistrées",
  "config.ongletsLabel": "Sections de la configuration",
  "config.orgBadge": "Organisation",
  "config.platform": "Plateforme",
  "config.platform.blocsHint": "Six réglages indépendants. Chaque bloc s'ouvre séparément ; le nombre affiché correspond à ce qu'il contient déjà.",
  "config.platformReset": "Annuler",
  "config.platformSave": "Enregistrer",
  "config.platformSavedToast": "Plateforme enregistrée",
  "config.removeRow": "Supprimer cette ligne",
  "config.savedToast": "Configuration enregistrée",
  "config.source": "Source",
  "config.template": "Template",
  "config.templateDefaultOption": "Par défaut (intégré)",
  "config.templateDescAide": "À quoi sert cette façon de travailler ?",
  "config.templateDescLabel": "Description",
  "config.templateDescPlaceholder": "À quoi sert cette façon de travailler ?",
  "config.templateNameAide": "Ce nom apparaîtra dans le sélecteur ci-dessus et au rattachement d'un projet.",
  "config.templateNameLabel": "Nom",
  "config.templateNamePlaceholder": "Ex. Delivery assurance",
  "config.title": "Configuration",
  "config.types": "Types de work-item & champs",
  "config.typesHint": "Chaque type, ses champs, et le type d'enfant qu'il engendre.",
  "config.uneModification": "1 modification non enregistrée",
  "config.workflow": "Statuts & transitions",
  "config.workflowDescPlaceholder": "Description",
  "config.workflowHint": "Les statuts de workflow et les passages autorisés sont contrôlés par le serveur.",
  "config.workflowIdPlaceholder": "Identifiant (ex. spec-to-code)",
  "config.workflowLabelPlaceholder": "Nom affiché",
  "config.workflows": "Workflows dynamiques",
  "config.workflowsEmpty": "Aucun workflow dynamique déclaré.",
  "config.workflowStepsPlaceholder": "Étapes ordonnées, séparées par des virgules",
  "config.workflowTriggerLabel": "Déclencheur",
  "config.workflowTriggerPlaceholder": "Déclencheur (ex. approbation d’une spec)",
  "confirm.cancel": "Annuler",
  "contexte.accesRetire": "Votre accès au projet « {{id}} » a été retiré, ou il a été supprimé. Vous êtes maintenant dans « {{actuel}} ».",
  "contexte.aucunProgramme": "Aucun programme : un projet peut exister sans programme.",
  "contexte.aucunProjet": "Aucun projet accessible dans cette organisation",
  "contexte.aucunProjetChoisi": "Aucun projet choisi",
  "contexte.aucunResultat": "Aucun résultat pour cette recherche",
  "contexte.chargement": "Chargement du contexte…",
  "contexte.choisirProgramme": "Choisir un programme",
  "contexte.choisirProjet": "Choisir un projet",
  "contexte.continuerIci": "Continuer ici",
  "contexte.deepLinkPerimeProgramme": "Le programme « {{id}} » est introuvable ou inaccessible.",
  "contexte.deepLinkPerimeProjet": "Le projet « {{id}} » est introuvable ou inaccessible.",
  "contexte.fermerSansChanger": "Fermer sans changer de contexte",
  "contexte.feuilleTitre": "Changer de programme ou de projet",
  "contexte.nonVerifie": "Contexte non vérifié : réseau indisponible, changement de contexte bloqué",
  "contexte.organisation": "Organisation",
  "contexte.organisationInconnue": "organisation inconnue",
  "contexte.pastilleAria": "Projet : {{nom}} — changer",
  "contexte.pastilleAucun": "Choisir un projet",
  "contexte.perspective": "Perspective",
  "contexte.perspectiveProgrammes": "Programmes",
  "contexte.perspectiveProjets": "Projets",
  "contexte.programmeParent": "Programme parent",
  "contexte.programmeVide": "Aucun projet rattaché à ce programme : {{n}} / {{total}}",
  "contexte.projetCourant": "Projet courant",
  "contexte.projetHorsProgramme": "Le projet « {{projet}} » n’est pas dans le programme « {{programme}} ». Choisissez un projet du programme, ou restez dans le contexte précédent.",
  "contexte.rechercherProgramme": "Rechercher un programme",
  "contexte.rechercherProjet": "Rechercher un projet",
  "contexte.reessayer": "Réessayer",
  "contexte.region": "Contexte de travail",
  "contexte.rester": "Rester dans « {{projet}} »",
  "contexte.revenirParent": "Revenir au contexte accessible",
  "contexte.sansProgramme": "Sans programme",
  "contexte.selectionBloquee": "Sélection bloquée : contexte non vérifié",
  "contexte.voirTousProjets": "Voir tous les projets",
  "create.idea": "Nouvelle idée",
  "create.menu": "Créer",
  "create.menuTiroir": "Créer…",
  "create.menuTiroirDetail": "projet, idée, story",
  "create.program": "Nouveau programme",
  "create.project": "Nouveau projet",
  "create.story": "Nouvelle story",
  "ctx.clear": "tous",
  "ctx.filterTitle": "{{n}} projets sur {{total}} rattachés à ce programme",
  "dashboard.activeWorkspace": "Espace actif",
  "dashboard.aggregating": "Agrégation…",
  "dashboard.approved": "Approuvé",
  "dashboard.available": "Disponible",
  "dashboard.availableAgents": "Agents disponibles",
  "dashboard.by": "par",
  "dashboard.colApprovals": "Approbations",
  "dashboard.colDocuments": "Documents",
  "dashboard.colInProgress": "En cours",
  "dashboard.colJobsPending": "Jobs en attente",
  "dashboard.colWorkspace": "Espace",
  "dashboard.createFirstWorkspace": "Créer mon premier espace",
  "dashboard.depositFirstIdea": "Déposer ma première idée",
  "dashboard.description": "Vue d'ensemble de vos espaces, du parcours de livraison et du runtime.",
  "dashboard.emptyWorkspaceIntro": "Votre espace est vide. Suivez le cycle, de l'idée à la publication :",
  "dashboard.getStarted": "Commencer",
  "dashboard.kpiApprovals": "approbations en attente",
  "dashboard.kpiDocuments": "documents ingérés",
  "dashboard.kpiJobs": "jobs en cours ou en attente",
  "dashboard.kpiWorkspaces": "projets",
  "dashboard.loadingWorkspaces": "Chargement des espaces…",
  "dashboard.noAgents": "Aucun agent configuré",
  "dashboard.noDecisions": "Aucune décision rendue",
  "dashboard.noDecisionsHint": "Les approbations et rejets d'artefacts apparaîtront ici.",
  "dashboard.noDescription": "Sans description",
  "dashboard.noModels": "Aucun modèle servi",
  "dashboard.noModelsHint": "Le runtime d'inférence est-il démarré ?",
  "dashboard.noWorkspaces": "Aucun projet",
  "dashboard.noWorkspacesHint": "Un espace regroupe les idées, spécifications, backlog et artefacts d'un projet. Créez le premier : vous en serez propriétaire.",
  "dashboard.onboardingApproveDesc": "Validez l'artefact (créateur ≠ approbateur).",
  "dashboard.onboardingApproveTitle": "Approuver la spec",
  "dashboard.onboardingBacklogDesc": "Epics et stories à partir de la spec approuvée.",
  "dashboard.onboardingBacklogTitle": "Générer le backlog",
  "dashboard.onboardingCodeDesc": "Le worker écrit, teste et ouvre une MR.",
  "dashboard.onboardingCodeTitle": "Générer le code",
  "dashboard.onboardingDeployDesc": "Pipelines et publication tracée.",
  "dashboard.onboardingDeployTitle": "Publier / déployer",
  "dashboard.onboardingIdeaDesc": "Décrivez un besoin ; il est cadré automatiquement.",
  "dashboard.onboardingIdeaTitle": "Déposer une idée",
  "dashboard.noWorkspaceToAggregate": "Aucun espace à agréger",
  "dashboard.portfolio": "Portefeuille",
  "dashboard.quoi": "espaces",
  "dashboard.recentDecisions": "Décisions récentes",
  "dashboard.rejected": "Rejeté",
  "dashboard.servedModels": "Modèles servis",
  "dashboard.title": "Tableau de bord",
  "dashboard.workspaces": "Projets",
  "density.toggleComfortable": "Densité : confortable (cliquer pour compacte)",
  "density.toggleCompact": "Densité : compacte (cliquer pour confortable)",
  "dependencies.badgeBlocking": "Bloquante",
  "dependencies.badgeSatisfied": "Satisfaite",
  "dependencies.chooseSpace": "Choisir un espace…",
  "dependencies.colAction": "Action",
  "dependencies.colExpectedArtifact": "Artefact attendu",
  "dependencies.colState": "État",
  "dependencies.colWaitsForSpace": "Attend l'espace",
  "dependencies.declareButton": "Déclarer la dépendance",
  "dependencies.declaredHeading": "Dépendances déclarées",
  "dependencies.declareHeading": "Déclarer une dépendance",
  "dependencies.description": "Déclarez qu'un espace attend un artefact d'un autre : la publication de l'espace dépendant reste bloquée tant que l'amont n'a pas livré.",
  "dependencies.emptyHint": "Cet espace ne dépend d'aucun autre pour publier.",
  "dependencies.emptyTitle": "Aucune dépendance déclarée",
  "dependencies.expectedArtifactLabel": "Artefact attendu (fragment de chemin)",
  "dependencies.expectedSpaceLabel": "Espace attendu",
  "dependencies.hintRequired": "Indiquez l'artefact attendu, par exemple « cadrage.md ».",
  "dependencies.loading": "Chargement des dépendances…",
  "dependencies.quoi": "dépendances",
  "dependencies.readOnlyNotice": "Lecture seule — déclaration réservée aux contributeurs.",
  "dependencies.remove": "Retirer",
  "dependencies.spaceRequired": "Choisissez l'espace dont dépend celui-ci.",
  "dependencies.title": "Dépendances inter-projets",
  "deps.addedToast": "Dépendance ajoutée",
  "deps.removedToast": "Dépendance retirée",
  "display.density": "Densité",
  "display.menu": "Préférences d’affichage",
  "display.technical": "Identifiants techniques",
  "display.theme": "Thème",
  "doc.decisions": "décisions",
  "doc.desc": "Régénérée des données courantes à chaque ouverture — jamais périmée.",
  "doc.download": "Télécharger (.md)",
  "doc.generatedOn": "généré le",
  "doc.loading": "Génération de la documentation…",
  "doc.noWs": "Aucun espace sélectionné",
  "doc.pickWs": "Choisissez un projet pour générer sa documentation.",
  "doc.regen": "Régénérer",
  "doc.refreshing": "Régénération…",
  "doc.refreshingStatus": "Régénération de la documentation à partir des données actuelles…",
  "doc.regionLabel": "Documentation du projet",
  "doc.reqs": "exigences",
  "doc.sprints": "sprints",
  "doc.title": "Documentation vivante",
  "editor.contentLabel": "Contenu (Markdown, frontmatter compris)",
  "editor.contentRequired": "La nouvelle version ne peut pas être vide.",
  "editor.description": "Éditez une spécification approuvée : la nouvelle version part en approbation (décidée par un autre que vous) avant d'être publiée.",
  "editor.emptyHint": "Générez puis approuvez une spécification pour pouvoir l'éditer.",
  "editor.emptyTitle": "Aucune spécification approuvée",
  "editor.loading": "Chargement…",
  "editor.loadingContent": "Chargement du contenu…",
  "editor.provenanceNote": "Un identifiant d'artefact unique est attribué à l'édition ; la provenance (empreinte de sortie) est recalculée.",
  "editor.readOnly": "Lecture seule — l'édition est réservée aux contributeurs.",
  "editor.savedToast": "Spécification enregistrée — elle attend une approbation",
  "editor.sourceLabel": "Spécification à éditer",
  "editor.sourcePlaceholder": "Choisir une spécification…",
  "editor.submit": "Soumettre la nouvelle version à approbation",
  "editor.submitting": "Envoi…",
  "editor.title": "Éditeur de spécification",
  "empty.openApprovals": "Ouvrir le centre d'approbations",
  "empty.openBacklog": "Ouvrir le backlog",
  "empty.openSprints": "Ouvrir les sprints",
  "empty.openTree": "Ouvrir l'arbre",
  "empty.submitIdea": "Déposer une idée",
  "export.doneToast": "Export de l'espace téléchargé",
  "feedback.commentLabel": "Commentaire",
  "feedback.commentPlaceholder": "Ce qui était utile, ce qui manquait…",
  "feedback.description": "Notez ce que l'outil produit : la note et le commentaire nourrissent l'amélioration continue des cartes et des modèles.",
  "feedback.emptyHint": "Soyez le premier à noter cet espace.",
  "feedback.emptyTitle": "Aucun retour",
  "feedback.formTitle": "Laisser un retour",
  "feedback.listTitle": "Retours récents",
  "feedback.loading": "Chargement…",
  "feedback.noteLabel": "Note (1 à 5)",
  "feedback.rating1": "très insuffisant",
  "feedback.rating2": "insuffisant",
  "feedback.rating3": "correct",
  "feedback.rating4": "bon",
  "feedback.rating5": "excellent",
  "feedback.readOnly": "Lecture seule — laisser un retour est réservé aux contributeurs.",
  "feedback.sentToast": "Retour envoyé",
  "feedback.submit": "Envoyer le retour",
  "feedback.submitPending": "Envoi…",
  "filters.createdToast": "Filtre enregistré",
  "filters.deletedToast": "Filtre supprimé",
  "filters.deleteTitle": "Supprimer ce filtre sauvegardé ?",
  "filters.deleteVerb": "Supprimer le filtre",
  "form.legende": "champ obligatoire",
  "form.required": "obligatoire",
  "form.resume": "{{n}} champ à corriger : {{liste}}",
  "form.resume_one": "{{n}} champ à corriger : {{liste}}",
  "form.resume_other": "{{n}} champs à corriger : {{liste}}",
  "form.tousObligatoires": "Tous les champs sont obligatoires.",
  "gen.analyzeToast": "Analyse lancée",
  "gen.backlogToast": "Génération du backlog lancée",
  "gen.childrenToast": "Génération lancée",
  "gen.codeToast": "Génération du code lancée",
  "gen.epicsToast": "Génération des epics lancée",
  "gen.mrToast": "Merge request proposée",
  "gen.optionsToast": "Options en cours de proposition",
  "gen.personasToast": "Génération des personas lancée",
  "gen.processesToast": "Cartographie lancée",
  "gen.programEpicsToast": "Génération lancée",
  "gen.reviewToast": "Revue lancée",
  "gen.specToast": "Rédaction de la spécification lancée",
  "gen.testsToast": "Conception des tests lancée",
  "generation.carteAucune": "Aucune carte de génération pour ce profil.",
  "generation.carteNom": "Carte {{carte}} (registre des cartes non publié).",
  "generation.carteProfil": "Carte",
  "generation.mesureAutreVersion": "Mesurée sur {{mesuree}}, carte en service {{courante}} : générabilité à re-mesurer.",
  "generation.recuCarte": "reçu {{etat}}",
  "generation.voirCarte": "Voir au registre des cartes",
  "gitlab.baseRequired": "L'adresse de l'instance est obligatoire.",
  "gitlab.connect": "Connecter",
  "gitlab.connectedTo": "Connecté à",
  "gitlab.defaultBranch": "branche par défaut",
  "gitlab.description": "Relie l'espace à un projet GitLab pour suivre l'état CI/CD. Le jeton est stocké côté serveur, jamais renvoyé ; un projet public est lisible sans jeton.",
  "gitlab.heading": "Connecteur GitLab",
  "gitlab.instanceUrl": "URL de l'instance",
  "gitlab.loading": "Chargement…",
  "gitlab.noMr": "Aucune MR ouverte.",
  "gitlab.noPipeline": "Aucun pipeline.",
  "gitlab.openMrs": "Merge requests ouvertes",
  "gitlab.projectLabel": "Projet (chemin ou id)",
  "gitlab.projectPlaceholder": "groupe/projet",
  "gitlab.projectRequired": "L'identifiant ou le chemin du projet est obligatoire.",
  "gitlab.recentPipelines": "Pipelines récents",
  "gitlab.savedToast": "Connecteur enregistré",
  "gitlab.test": "Tester",
  "gitlab.tokenLabel": "Jeton d'accès",
  "gitlab.tokenOptional": "(optionnel pour un projet public)",
  "gitlab.tokenSaved": "(enregistré — laisser vide pour conserver)",
  "gitlab.update": "Mettre à jour",
  "graph.desc": "Hiérarchie (parent→enfant) et liens (bloque / lié à / duplique). Survolez un nœud pour isoler ses connexions.",
  "graph.empty": "Aucun item",
  "graph.emptyHint": "Décomposez une spec en items pour voir apparaître le graphe.",
  "graph.explicitLinks": "liens explicites",
  "graph.hierLinks": "liens de hiérarchie",
  "graph.items": "items",
  "graph.legendBlocks": "Bloque",
  "graph.legendDuplicates": "Duplique",
  "graph.legendHierarchy": "Hiérarchie",
  "graph.legendRelates": "Lié à",
  "graph.loading": "Construction du graphe…",
  "graph.resetView": "Réinitialiser la vue",
  "graph.sansRelation": "Aucune relation — les items existent mais ne sont ni reliés ni hiérarchisés.",
  "graph.title": "Graphe des work items (DAG)",
  "graph.zoomIn": "Zoom avant",
  "graph.zoomOut": "Zoom arrière",
  "grp.Concevoir": "Concevoir",
  "grp.Explorer": "Explorer",
  "grp.Gouvernance": "Gouvernance",
  "grp.Générer": "Générer",
  "grp.Livraison": "Livraison",
  "grp.Livrer": "Livrer",
  "grp.Piloter": "Piloter",
  "grp.Qualité": "Qualité",
  "guide.description": "Le cycle de bout en bout, de l'idée à la publication. Chaque étape est cliquable : lancez-vous, revenez ici quand vous voulez.",
  "guide.blockedNext": "Le processus est bloqué à « {{step}} » : consultez les prérequis avant de continuer.",
  "guide.defaultTemplate": "Template intégré",
  "guide.emptyNext": "Déposez une idée pour produire le premier artefact du projet.",
  "guide.nextTitle": "Prochaine action",
  "guide.noWorkspace": "Aucun projet sélectionné",
  "guide.openNext": "Ouvrir l’étape",
  "guide.openProcess": "Voir le processus effectif",
  "guide.pickWorkspace": "Sélectionnez un projet pour afficher son processus effectif.",
  "guide.processLoading": "Lecture des prérequis…",
  "guide.processUnavailable": "Le plan d’exécution n’est pas disponible pour le moment.",
  "guide.railIntro": "Vous êtes ici, au début du cycle :",
  "guide.railEffective": "Cycle déclaré pour ce projet :",
  "guide.readyNext": "Les capacités sont prêtes. Commencez par « {{step}} ».",
  "guide.resolveBlocker": "Voir les prérequis",
  "guide.sodBody": "La séparation des tâches exige qu'un autre owner ou reviewer, différent du créateur, approuve la décision.",
  "guide.sodTitle": "Bon à savoir : créateur ≠ approbateur",
  "guide.source": "Source : template effectif du projet",
  "guide.startCta": "Commencer : déposer une idée",
  "guide.stepDefault": "Suivez cette étape du cycle de bout en bout.",
  "guide.step.backlog": "Epics → stories → tâches, augmentés par l’IA.",
  "guide.step.cadrage": "Le cadrage (problème, valeur, risques) part en approbation.",
  "guide.step.code": "Le worker écrit, teste et ouvre une MR à approuver.",
  "guide.step.idee": "Décrivez un besoin en langage clair ; il est cadré automatiquement.",
  "guide.step.options": "Explorez des options avant de figer la spécification.",
  "guide.step.publication": "Pipelines et publication tracée.",
  "guide.step.spec": "La spécification approuvée devient la source du backlog.",
  "guide.stepsHeading": "Les étapes",
  "guide.title": "Prise en main",
  "harnaisPlateforme.approuver": "Approuver",
  "harnaisPlateforme.bandeauRecus": "{{valides}} carte(s) active(s) sur {{actives}} porte(nt) un reçu valide : en usage production, le worker refuse toute carte sans reçu valide, avant d’appeler le modèle.",
  "harnaisPlateforme.caste.architecte": "architecte",
  "harnaisPlateforme.caste.designer": "designer",
  "harnaisPlateforme.caste.eclaireuse": "éclaireuse",
  "harnaisPlateforme.caste.garde": "garde",
  "harnaisPlateforme.caste.ouvriere": "ouvrière",
  "harnaisPlateforme.caste.reine": "reine",
  "harnaisPlateforme.caste.reparatrice": "réparatrice",
  "harnaisPlateforme.caste.verificatrice": "vérificatrice",
  "harnaisPlateforme.chargement": "Lecture du registre des cartes…",
  "harnaisPlateforme.col.action": "action",
  "harnaisPlateforme.col.carte": "carte",
  "harnaisPlateforme.col.caste": "caste",
  "harnaisPlateforme.col.fenetre": "fenêtre",
  "harnaisPlateforme.col.modele": "rôle → modèle",
  "harnaisPlateforme.col.recu": "reçu",
  "harnaisPlateforme.col.statut": "statut",
  "harnaisPlateforme.copiee": "Copiée",
  "harnaisPlateforme.copier": "Copier la commande",
  "harnaisPlateforme.demande.approuvee": "approuvée — à exécuter sur l’hôte",
  "harnaisPlateforme.demande.attente": "en attente d’approbation",
  "harnaisPlateforme.demande.decidee": "décidée par {{qui}}",
  "harnaisPlateforme.demande.executee": "exécutée — reçu valide",
  "harnaisPlateforme.demande.par": "demandée par {{qui}} le {{quand}}",
  "harnaisPlateforme.demande.rapport": "Rapport",
  "harnaisPlateforme.demande.refusee": "refusée",
  "harnaisPlateforme.demande.retiree": "retirée",
  "harnaisPlateforme.demandeCreee": "Demande créée : elle attend l’approbation d’un autre administrateur.",
  "harnaisPlateforme.demanderQualification": "Demander la qualification (GPU)",
  "harnaisPlateforme.demandesAide": "Le demandeur ne décide pas. Approuvée, une demande donne la commande promote_prompt.py à lancer sur l’hôte ; elle est « exécutée » quand la carte porte un reçu valide qui cite son rapport.",
  "harnaisPlateforme.demandesTitre": "Demandes de promotion",
  "harnaisPlateforme.demandesVide": "Aucune demande de promotion",
  "harnaisPlateforme.demandesVideIndice": "Une demande naît du bouton « Promouvoir » d’une carte qualifiée.",
  "harnaisPlateforme.erreur": "Le registre des cartes n’a pas pu être lu.",
  "harnaisPlateforme.exige": "Exigé : score et couverture 100 %, identité du modèle vérifiée, résidence GPU 100 %.",
  "harnaisPlateforme.fermer": "Fermer",
  "harnaisPlateforme.filtre.actives": "Actives ({{n}})",
  "harnaisPlateforme.filtre.brouillons": "Brouillons ({{n}})",
  "harnaisPlateforme.filtre.candidates": "Candidates ({{n}})",
  "harnaisPlateforme.filtre.promouvables": "Actives et promouvables ({{n}})",
  "harnaisPlateforme.filtre.toutes": "Toutes ({{n}})",
  "harnaisPlateforme.filtres": "Filtrer les cartes par statut",
  "harnaisPlateforme.filtreVide": "Aucune carte pour ce statut",
  "harnaisPlateforme.filtreVideIndice": "Les cartes et leur statut viennent du registre des prompts du dépôt.",
  "harnaisPlateforme.instantane": "Instantané publié par {{worker}} il y a {{age}} ({{quand}}), révision {{rev}}.",
  "harnaisPlateforme.instantaneAncien": "Cet instantané a plus de 15 minutes : le worker ne le republie plus. Les cartes, reçus et résidents peuvent avoir changé depuis.",
  "harnaisPlateforme.legende.absent": "jamais qualifiée",
  "harnaisPlateforme.legende.perime": "carte, modèle ou base changés",
  "harnaisPlateforme.legende.valide": "même version, même sujet, même base de confiance",
  "harnaisPlateforme.legendeTable": "Cartes du registre, statut, caste, modèle et reçu",
  "harnaisPlateforme.motifManquant": "Un refus porte son motif : 10 caractères au moins.",
  "harnaisPlateforme.motifRefus": "Motif du refus (10 caractères au moins)",
  "harnaisPlateforme.note": "Note pour l’approbateur (facultative)",
  "harnaisPlateforme.poste.aucunResident": "Aucun modèle résident en VRAM au moment de l’instantané.",
  "harnaisPlateforme.poste.budget": "{{carte}} · budget {{budget}} Mio sur {{total}} Mio",
  "harnaisPlateforme.poste.degrade": "dégradé",
  "harnaisPlateforme.poste.fenetre": "fenêtre résidente ≤ {{n}}",
  "harnaisPlateforme.poste.permutation": "{{a}} et {{b}} ne tiennent pas ensemble en VRAM ({{somme}} > {{budget}} Mio) : une relecture par l’autre famille impose une permutation.",
  "harnaisPlateforme.poste.residents": "Résidents : {{liste}}",
  "harnaisPlateforme.poste.sondeIndisponible": "La sonde de résidence n’a pas répondu au worker : les modèles réellement chargés ne sont pas connus.",
  "harnaisPlateforme.poste.titre": "Modèles du poste",
  "harnaisPlateforme.promouvoir": "Promouvoir",
  "harnaisPlateforme.promouvoirTitre": "Promouvoir {{nom}} {{version}}",
  "harnaisPlateforme.qualificationAide": "À lancer sur l’hôte GPU : les missions passent d’abord. Le rapport canonique publié apparaît ici au prochain instantané du worker.",
  "harnaisPlateforme.rapportRefuse": "refusé",
  "harnaisPlateforme.rapportsPublies": "Rapports publiés pour cette version",
  "harnaisPlateforme.rapportSurModele": "Rapport de qualification sur le modèle de son rôle ({{modele}}, digest épinglé {{digest}}).",
  "harnaisPlateforme.recu.absent": "absent",
  "harnaisPlateforme.recu.perime": "périmé",
  "harnaisPlateforme.recu.valide": "valide",
  "harnaisPlateforme.refus.absent": "Aucun instantané du registre n’a été publié par le worker.",
  "harnaisPlateforme.refus.autre": "Action refusée par la passerelle.",
  "harnaisPlateforme.refus.close": "La demande est close.",
  "harnaisPlateforme.refus.dejaActive": "Carte déjà active : une nouvelle version se qualifie à son tour.",
  "harnaisPlateforme.refus.demandeOuverte": "Une demande est déjà ouverte pour cette version.",
  "harnaisPlateforme.refus.injection": "Une suite d’injection bloquante d’au moins 3 cas est exigée.",
  "harnaisPlateforme.refus.modele": "Aucun modèle approuvé (digest épinglé) pour le rôle de la carte.",
  "harnaisPlateforme.refus.nonEnAttente": "La demande n’est plus en attente de décision.",
  "harnaisPlateforme.refus.nonPromouvable": "Le registre ne déclare pas cette carte promouvable.",
  "harnaisPlateforme.refus.perime": "L’instantané du registre a plus d’une heure : le worker ne publie plus.",
  "harnaisPlateforme.refus.rapport": "Aucun rapport de qualification pour cette version.",
  "harnaisPlateforme.refus.rapportRefuse": "Ce rapport est publié mais le runtime le refuse.",
  "harnaisPlateforme.refus.sod": "Vous avez demandé cette promotion : un autre administrateur l’approuvera.",
  "harnaisPlateforme.refus.version": "La carte a changé de version depuis la demande.",
  "harnaisPlateforme.refusAcces": "Le registre des cartes est réservé à l’administration de la plateforme.",
  "harnaisPlateforme.refuser": "Refuser",
  "harnaisPlateforme.registreTitre": "Registre des cartes",
  "harnaisPlateforme.repli": "repli {{role}} → {{modele}}",
  "harnaisPlateforme.residence.depasse": "{{fenetre}} > {{limite}} : déborde de la carte GPU",
  "harnaisPlateforme.residence.nonMesuree": "{{fenetre}} : résidence non mesurée pour ce modèle",
  "harnaisPlateforme.residence.pleine": "{{fenetre}} ≤ {{limite}} : 100 % résident",
  "harnaisPlateforme.retirer": "Retirer la demande",
  "harnaisPlateforme.sodDemande": "Vous demandez cette promotion : un autre administrateur de la plateforme l’approuvera.",
  "harnaisPlateforme.statut.active": "active",
  "harnaisPlateforme.statut.candidate": "candidate",
  "harnaisPlateforme.statut.deprecated": "dépréciée",
  "harnaisPlateforme.statut.draft": "brouillon",
  "harnaisPlateforme.suiteInjection": "Suite d’injection bloquante : {{n}} cas",
  "harnaisPlateforme.versProfils": "Profils de génération qualifiés",
  "harnaisPlateforme.vide": "Aucun instantané du registre publié",
  "harnaisPlateforme.videIndice": "Le worker publie le registre des cartes et les modèles du poste à son démarrage, puis toutes les 5 minutes. Démarrez le worker sur l’hôte GPU.",
  "history.colAction": "Action",
  "history.colDocument": "Document",
  "history.colJob": "Job",
  "history.colStatus": "Statut",
  "history.colUpdated": "Mis à jour",
  "history.emptyHint": "Déposez une idée ou téléversez un document : le travail apparaîtra ici.",
  "history.emptyTitle": "Aucun job dans cet espace",
  "history.hide": "Masquer",
  "history.loading": "Chargement de l'historique…",
  "history.pageTitle": "Historique",
  "history.quoi": "jobs",
  "ideas.approvalsCenter": "centre d'approbations",
  "ideas.charsRemaining": "caractères encore nécessaires",
  "ideas.formTitle": "Votre idée",
  "ideas.ideaLabel": "Idée en langage naturel",
  "ideas.ideaPlaceholder": "Exemple : nos gestionnaires ressaisissent les mêmes informations entre deux outils ; je veux…",
  "ideas.ideaSubmittedBadge": "Idée déposée",
  "ideas.minCharsHint": "Décrivez l'idée en au moins 30 caractères — en dessous, il n'y a rien à cadrer",
  "ideas.noWorkspaceSelected": "Aucun projet sélectionné",
  "ideas.pageDescription": "Décrivez ce que vous voulez obtenir, avec vos mots. Le système en tire un document de cadrage — problème, utilisateurs, valeur, contraintes, risques et questions ouvertes — qu'un relecteur devra approuver. Les zones floues deviennent des questions, jamais des suppositions.",
  "ideas.pageTitle": "Déposer une idée",
  "ideas.readOnlyNotice": "Lecture seule — votre rôle ne permet pas de déposer une idée.",
  "ideas.resultCadrage": "cadrage",
  "ideas.resultLeadIn": "Elle devient un ",
  "ideas.resultMiddle": " (généré par le modèle ci-dessous), puis suit le cycle. Le cadrage attendra sa décision au ",
  "ideas.submitButton": "Déposer et cadrer",
  "ideas.submittedToast": "Idée déposée",
  "ideas.submitting": "Dépôt…",
  "impact.affectedByChange": "item(s) potentiellement affecté(s) par un changement.",
  "impact.groupBlocked": "Bloqués",
  "impact.groupDescendants": "Descendants",
  "impact.groupRelated": "Liés",
  "impact.kindBug": "Bug",
  "impact.kindCadrage": "Cadrage",
  "impact.kindEpic": "Epic",
  "impact.kindFeature": "Feature",
  "impact.kindIdea": "Idée",
  "impact.kindStory": "US",
  "impact.kindTask": "Tâche",
  "impact.levelPrefix": "niv.",
  "impact.linkDuplicates": "duplique",
  "impact.linkRelated": "lié",
  "impact.loading": "Analyse…",
  "impact.noDownstream": "Aucun item en aval — ce changement est isolé.",
  "impact.toggleHide": "Masquer l'impact",
  "impact.toggleShow": "Analyse d'impact",
  "ingestion.answerHeading": "Réponse",
  "ingestion.askButton": "Interroger",
  "ingestion.chooseModel": "Choisir un modèle…",
  "ingestion.columnChecksum": "Empreinte",
  "ingestion.columnFile": "Fichier",
  "ingestion.columnStatus": "État",
  "ingestion.columnUploadedAt": "Déposé le",
  "ingestion.description": "Téléversez des documents et interrogez la base avec des citations vérifiables.",
  "ingestion.documentIngested": "Document ingéré",
  "ingestion.documentLabel": "Document",
  "ingestion.dropzoneHint": "Glissez un fichier ici, ou choisissez-le ci-dessus.",
  "ingestion.errorNoFile": "Sélectionnez un fichier avant de téléverser",
  "ingestion.errorNoModel": "Sélectionnez un modèle",
  "ingestion.errorNoQuestion": "Saisissez une question",
  "ingestion.errorNoWorkspace": "Aucun projet sélectionné",
  "ingestion.loadingModels": "Chargement des modèles…",
  "ingestion.modelLabel": "Modèle",
  "ingestion.noModelsTitle": "Aucun modèle autorisé dans cet espace",
  "ingestion.noModelsHint": "Autorisez un modèle avant d’interroger la base documentaire.",
  "ingestion.configureModels": "Configurer les modèles",
  "ingestion.noCitationHint": "La réponse n'est pas adossée à un document indexé.",
  "ingestion.noCitationTitle": "Aucune source citée",
  "ingestion.noSourceHint": "Téléversez un premier document pour l'indexer.",
  "ingestion.noSourceTitle": "Aucune source",
  "ingestion.questionLabel": "Question",
  "ingestion.questionPlaceholder": "Quelles sont les exigences de sécurité ?",
  "ingestion.queuedToast": "Document en cours d'indexation",
  "ingestion.quoi": "sources",
  "ingestion.ragHeading": "Interroger la base documentaire",
  "ingestion.readOnlyAsk": "Lecture seule — votre rôle ne permet pas d'interroger la base documentaire.",
  "ingestion.readOnlyUpload": "Lecture seule — votre rôle ne permet pas de téléverser un document.",
  "ingestion.searching": "Recherche…",
  "ingestion.selectedFile": "Sélectionné :",
  "ingestion.semanticSearch": "Recherche sémantique en cours…",
  "ingestion.sourcesHeading": "Sources ingérées",
  "ingestion.sourcesLabel": "Sources",
  "ingestion.title": "Ingestion et interrogation",
  "ingestion.uploadButton": "Téléverser",
  "ingestion.uploadHeading": "Téléverser un document",
  "ingestion.uploading": "Téléversement…",
  "item.acceptance": "Critères d'acceptation",
  "item.aiActions": "Actions IA",
  "item.aiActionsHint": "Générer, analyser, revoir et proposer — depuis l'objet de travail.",
  "item.assignee": "Assignation",
  "item.backToBacklog": "Backlog",
  "item.backToBoard": "Board",
  "item.createdBy": "Créé par",
  "item.customFields": "Champs",
  "item.dans": "Dans",
  "item.effort": "Effort",
  "item.invalid": "Item introuvable",
  "item.invalidHint": "Le lien ne pointe pas vers un item valide.",
  "item.job": "Job de génération",
  "item.loading": "Chargement de l'item…",
  "item.metadata": "Métadonnées",
  "item.noSprint": "Aucun sprint",
  "item.notFound": "Item introuvable",
  "item.notFoundHint": "Cet item n'existe pas ou vous n'y avez pas accès.",
  "item.open": "Ouvrir la page de l'item",
  "item.parent": "Parent",
  "item.provenance": "Provenance",
  "item.source": "Source",
  "item.sprint": "Sprint",
  "item.status": "Statut",
  "item.unassigned": "Non assigné",
  "itemLabels.emptyHint": "Aucun label — créez-en un.",
  "itemLabels.newLabelPlaceholder": "Nouveau label",
  "job.approvalGranted": "Approuvé par",
  "job.approvalRejected": "Rejeté par",
  "job.approvalRequested": "En attente d’approbation — un relecteur doit décider",
  "job.artifactDiscarded": "Artefact retiré (rejet)",
  "job.artifactWritten": "Spécification écrite",
  "job.badgeAwaitingApproval": "En attente d'approbation",
  "job.badgeFailed": "Échec",
  "job.badgeInProgress": "En cours",
  "job.badgePublished": "Publié",
  "job.badgeRejected": "Rejeté",
  "job.claimed": "Prise en charge par le worker",
  "job.committed": "Publié",
  "job.documentFallback": "document",
  "job.doneCommitted": "Terminé",
  "job.donePending": "Génération terminée — artefact soumis à approbation",
  "job.emptyDetail": "(le modèle exécuté en local) le prend en charge dès qu'il tourne, et la progression s'affiche ici en direct. Si rien n'apparaît, c'est que le worker n'est pas lancé.",
  "job.emptyIntro": "Job en file d'attente. Le",
  "job.enqueued": "Demande enregistrée",
  "job.executionDetail": "Détail de l'exécution",
  "job.failed": "Échec",
  "job.generationFinished": "Génération terminée en",
  "job.generationStarted": "Génération en cours",
  "job.generatedTestsExecuted": "Tests générés exécutés",
  "job.generatedTestsFailed": "tests en échec",
  "job.generatedTestsPassed": "tests passés",
  "job.costUnavailable": "coût non mesuré (tarif cloud absent)",
  "job.modelFallback": "modèle",
  "job.progress": "Progression",
  "job.rowCard": "Carte",
  "job.rowCost": "Coût",
  "job.rowDuration": "Durée",
  "job.rowInputTokens": "Tokens d’entrée",
  "job.rowModel": "Modèle",
  "job.rowOutputTokens": "Tokens de sortie",
  "job.rowRepairs": "Réparations",
  "job.rowThroughput": "Débit",
  "job.streamInterrupted": "Flux interrompu. Les événements reçus sont conservés.",
  "job.reconnect": "Reconnecter le flux",
  "job.unknownCause": "cause inconnue",
  "labels.createdToast": "Étiquette créée",
  "lang.label": "Langue",
  "lifecycle.Approbation": "Approbation",
  "lifecycle.Backlog": "Backlog",
  "lifecycle.Code": "Code",
  "lifecycle.Idée": "Idée",
  "lifecycle.Publication": "Publication",
  "lifecycle.Spécification": "Spécification",
  "lifecycleRail.backlog": "Backlog",
  "lifecycleRail.cadrage": "Cadrage",
  "lifecycleRail.code": "Code",
  "lifecycleRail.idee": "Idée",
  "lifecycleRail.options": "Options",
  "lifecycleRail.publication": "Publication",
  "lifecycleRail.spec": "Spécification",
  "links.add": "Lier",
  "links.blocksIncoming": "bloqué par",
  "links.blocksOutgoing": "bloque",
  "links.createdToast": "Lien créé",
  "links.deleteConsequence": "Le lien disparaît des deux items. Les items eux-mêmes ne sont pas modifiés.",
  "links.deletedToast": "Lien supprimé",
  "links.deleteTitle": "Supprimer le lien vers #{{id}} ?",
  "links.deleteVerb": "Supprimer le lien",
  "links.duplicatesIncoming": "dupliqué par",
  "links.duplicatesOutgoing": "duplique",
  "links.empty": "Aucun lien.",
  "links.relatesToIncoming": "lié à",
  "links.relatesToOutgoing": "lié à",
  "links.selectPlaceholder": "Choisir un item…",
  "login.contributor": "Contributeur",
  "login.demo": "Comptes de démonstration",
  "login.demoLocal": "Démonstration locale",
  "login.error": "Connexion impossible",
  "login.hint": "Un clic remplit le formulaire ; « Se connecter » valide.",
  "login.identifier": "Identifiant",
  "login.owner": "Propriétaire",
  "login.password": "Mot de passe",
  "login.rateLimited": "Trop de tentatives, réessayez dans {{seconds}} secondes.",
  "login.reader": "Lecteur",
  "login.submit": "Se connecter",
  "login.submitting": "Connexion…",
  "login.subtitle": "Accédez à vos projets.",
  "login.tagline": "L'usine logicielle augmentée, de l'idée à la publication.",
  "login.title": "Connexion",
  "markdown.editTab": "Édition",
  "markdown.mermaidChargement": "Diagramme non chargé : la connexion semble interrompue. Il sera de nouveau demandé au prochain affichage.",
  "markdown.mermaidError": "Diagramme illisible — vérifiez la syntaxe Mermaid.",
  "markdown.previewEmpty": "Rien à prévisualiser pour le moment.",
  "markdown.previewTab": "Aperçu",
  "missions.age.days": "{{n}} j",
  "missions.age.hours": "{{n}} h",
  "missions.age.minutes": "{{n}} min",
  "missions.age.seconds": "{{n}} s",
  "missions.ago": "il y a {{age}}",
  "missions.backToList": "Retour aux missions",
  "missions.board.empty": "Aucun objet déposé pour l’instant.",
  "missions.board.loading": "Lecture du tableau noir…",
  "missions.board.newer": "Plus récents",
  "missions.board.older": "Plus anciens",
  "missions.board.provenance": "provenance",
  "missions.board.range": "{{a}}–{{b}} sur {{n}}",
  "missions.board.title": "Registre du tableau noir",
  "missions.cancel": "Annuler",
  "missions.caste.architecte": "Architecte",
  "missions.caste.avanceur": "Avanceur",
  "missions.caste.designer": "Designer",
  "missions.caste.eclaireuse": "Éclaireuse",
  "missions.caste.garde": "Garde",
  "missions.caste.greffiere": "Greffière",
  "missions.caste.humain": "Humain",
  "missions.caste.livreuse": "Livreuse",
  "missions.caste.ouvriere": "Ouvrière",
  "missions.caste.reine": "Reine",
  "missions.caste.reparatrice": "Réparatrice",
  "missions.caste.verificatrice_conception": "Vérificatrice (conception)",
  "missions.caste.verificatrice_execution": "Vérificatrice (exécution)",
  "missions.cockpit.active": "en cours",
  "missions.cockpit.approver": "Plan approuvé par",
  "missions.cockpit.budget": "Budget de la mission",
  "missions.cockpit.castes": "Castes",
  "missions.cockpit.dependsOn": "dépend de {{d}}",
  "missions.cockpit.failed": "La mission a échoué : {{r}}",
  "missions.cockpit.graph": "Graphe des tâches",
  "missions.cockpit.job": "Job courant",
  "missions.cockpit.level": "Niveau {{n}}",
  "missions.cockpit.loading": "Lecture du poste de pilotage…",
  "missions.cockpit.planning": "La reine prépare le plan (job {{j}} : {{s}}).",
  "missions.cockpit.progress": "Progression : {{f}} tâche(s) faite(s) sur {{n}}",
  "missions.cockpit.progressLabel": "Tâches faites",
  "missions.cockpit.requester": "Demandée par",
  "missions.cockpit.rounds": "Tours de correction",
  "missions.cockpit.started": "démarrée il y a {{age}}",
  "missions.cockpit.steps": "Étapes enfilées",
  "missions.cockpit.stopReason": "Motif d’arrêt : {{r}}",
  "missions.cockpit.suspended": "Suspendue : {{r}}",
  "missions.cockpit.tasksCaption": "Tâches, caste, état, tour, contrôles et dernier signal",
  "missions.cockpit.title": "Poste de pilotage",
  "missions.col.caste": "Caste",
  "missions.col.checks": "Contrôles",
  "missions.col.dependsOn": "Dépend de",
  "missions.col.estimate": "Estimation GPU",
  "missions.col.round": "Tour",
  "missions.col.signal": "Motif / dernier signal",
  "missions.col.state": "État",
  "missions.col.task": "Tâche",
  "missions.createdAgo": "lancée il y a {{age}}",
  "missions.decision.acceptStop": "Prendre acte de l’arrêt",
  "missions.decision.acknowledge": "Prendre acte",
  "missions.decision.announce": "Décision enregistrée au tableau noir.",
  "missions.decision.errReorient": "Réorienter exige une consigne.",
  "missions.decision.instruction": "Consigne (pour réorienter)",
  "missions.decision.otherFamily": "Confier une fois à une autre famille",
  "missions.decision.reorient": "Réorienter",
  "missions.decision.takeOver": "Prendre la main",
  "missions.emptyHint": "Une mission se lance depuis une spécification approuvée, un sprint ou une liste d’anomalies, avec un budget en minutes de GPU.",
  "missions.emptyHintReader": "Un contributeur ou le propriétaire de l’espace lance les missions.",
  "missions.emptyTitle": "Aucune mission dans cet espace",
  "missions.escalations": "Escalades",
  "missions.evidence.back": "Retour au poste de pilotage",
  "missions.evidence.checks": "Contrôles du chemin réel · {{p}} / {{n}}",
  "missions.evidence.cost": "Coût",
  "missions.evidence.costDetail": "{{j}} jetons · {{s}} s de génération",
  "missions.evidence.costValue": "{{m}} min de GPU",
  "missions.evidence.decision": "Décision",
  "missions.evidence.diff": "Diff",
  "missions.evidence.hiddenTests": "Tests cachés",
  "missions.evidence.junit": "JUnit : {{r}}",
  "missions.evidence.loading": "Lecture du dossier de preuves…",
  "missions.evidence.noChecks": "Détail des contrôles non déposé.",
  "missions.evidence.noReview": "Aucun avis déposé.",
  "missions.evidence.noRounds": "Aucun tour exécuté.",
  "missions.evidence.notYet": "La greffière n’a pas encore déposé le dossier de cette tâche.",
  "missions.evidence.opinionTag": "avis — ne décide pas",
  "missions.evidence.path": "Dossier",
  "missions.evidence.redCheck": "Contrôle rouge : {{n}} — {{m}}",
  "missions.evidence.redChecks": "Contrôles rouges avant → après",
  "missions.evidence.ref": "Référence et empreinte",
  "missions.evidence.requirements": "Exigences couvertes",
  "missions.evidence.reviews": "Avis de la garde",
  "missions.evidence.roundTests": "{{p}} / {{n}} ({{s}} sautés)",
  "missions.evidence.rounds": "Tours de correction",
  "missions.evidence.roundsTitle": "Tours de correction",
  "missions.evidence.stopReason": "Motif d’arrêt : {{r}}",
  "missions.evidence.subtitle": "Dossier de preuves · mission « {{m}} » · tâche {{r}}",
  "missions.evidence.tests": "Tests exécutés",
  "missions.evidence.testsDetail": "{{p}} verts · {{f}} rouges · {{s}} sautés / {{n}} · code {{c}}",
  "missions.experimental": "expérimental",
  "missions.form.autoAuto": "automatique",
  "missions.form.autoDeploy": "Déployer, promouvoir, toucher à l’organisation",
  "missions.form.autoGenerate": "Générer, corriger, tester dans le bac à sable",
  "missions.form.autoHuman": "bloquant — humain",
  "missions.form.autoMerge": "Fusionner une fonctionnalité relue",
  "missions.form.autoNotified": "après approbation du dossier",
  "missions.form.autonomy": "Autonomie par type d’action",
  "missions.form.budget": "Budget et limites",
  "missions.form.choose": "— choisir —",
  "missions.form.defects": "Anomalies à corriger",
  "missions.form.description": "Porte de départ : sujet, mode et budget. La reine propose ensuite le plan, qu’un autre membre approuve avant toute écriture.",
  "missions.form.errDefects": "Cochez au moins une anomalie.",
  "missions.form.errEscalations": "Entre 0 et 20 escalades.",
  "missions.form.errGpu": "Entre 1 et 1 440 minutes de GPU.",
  "missions.form.errRounds": "Entre 1 et 3 tours : au-delà, la correction ne progresse plus (ART-0171 § 4.3).",
  "missions.form.errSpec": "Choisissez la spécification approuvée.",
  "missions.form.errSprint": "Choisissez le sprint à exécuter.",
  "missions.form.escalations": "Escalades avant arrêt",
  "missions.form.items": "{{n}} items",
  "missions.form.kind": "Nature de la mission",
  "missions.form.mode": "Mode d’exécution du harnais",
  "missions.form.modeA": "A — agent de code enveloppé",
  "missions.form.modeAHelp": "Agent ouvert sur le moteur local ; mêmes invariants, sinon refus au lancement.",
  "missions.form.modeB": "B — harnais natif (4 outils)",
  "missions.form.modeBHelp": "Lire, écrire, lancer les contrôles, terminer — dans le bac à sable.",
  "missions.form.modeC": "C — boucle dans l’orchestrateur",
  "missions.form.modeCHelp": "Le harnais exécute et renvoie un retour structuré ; aucun outil pour le modèle.",
  "missions.form.modesFromTemplate": "Modes permis par le gabarit du projet : {{m}} (ADR-0108).",
  "missions.form.noDefects": "Aucune anomalie ouverte dans cet espace.",
  "missions.form.readOnly": "Votre rôle dans cet espace ne permet pas de lancer une mission.",
  "missions.form.rounds": "Tours de correction par tâche",
  "missions.form.spec": "Spécification approuvée",
  "missions.form.sprint": "Sprint",
  "missions.form.stopsBudget": "Arrêts automatiques : {{n}} tour(s) · 2 tours improductifs · action répétée 3 fois · oscillation · budget épuisé.",
  "missions.form.subject": "Sujet",
  "missions.form.submit": "Lancer — la reine propose le plan",
  "missions.form.title": "Titre (facultatif)",
  "missions.gpuMinutes": "Minutes de GPU",
  "missions.gpuMinutesShort": "Min. GPU",
  "missions.kind.fix_defects": "Corriger des anomalies",
  "missions.kind.generate_app": "Générer une application",
  "missions.kind.sprint": "Exécuter un sprint",
  "missions.launch": "Lancer une mission",
  "missions.loading": "Chargement des missions…",
  "missions.minutesShort": "{{n}} min",
  "missions.modeShort": "Mode {{m}}",
  "missions.obj.checks": "contrôles {{p}} / {{t}}",
  "missions.obj.cost": "{{s}} s de GPU",
  "missions.obj.decision": "décision : {{r}}",
  "missions.obj.escalation": "escalade : {{r}}",
  "missions.obj.stop": "arrêt : {{r}}",
  "missions.obj.tests": "tests {{p}} verts, {{f}} rouges, code {{c}}",
  "missions.opinion": "avis",
  "missions.pageDescription": "Régime harnais : la colonie exécute un sprint, génère une application ou corrige des anomalies entre deux portes humaines — plan et budget au départ, dossier de preuves à l’arrivée.",
  "missions.pageTitle": "Missions",
  "missions.plan.announceApproved": "Plan approuvé : la colonie démarre.",
  "missions.plan.announceRejected": "Plan refusé : la mission est arrêtée.",
  "missions.plan.approve": "Approuver et lancer",
  "missions.plan.budget": "Budget approuvé",
  "missions.plan.budgetLine": "Budget : {{g}} min de GPU · {{r}} tours par tâche · {{e}} escalades",
  "missions.plan.caption": "Tâches du plan, dans l’ordre",
  "missions.plan.confirmReject": "Confirmer le refus",
  "missions.plan.errBudget": "Budget hors bornes : 1 à 1 440 minutes, 1 à 3 tours, 0 à 20 escalades.",
  "missions.plan.errReason": "Un refus de plan exige un motif.",
  "missions.plan.readOnly": "Un contributeur ou le propriétaire de l’espace approuve le plan.",
  "missions.plan.reason": "Motif du refus",
  "missions.plan.reject": "Refuser avec motif",
  "missions.plan.sod": "Vous avez lancé cette mission : un autre membre doit approuver son plan et son budget (séparation des tâches).",
  "missions.plan.title": "Plan proposé par la reine",
  "missions.plan.untilApproval": "jusqu’à votre approbation",
  "missions.reason.budget": "budget épuisé",
  "missions.reason.completed": "terminée",
  "missions.reason.converged": "convergée",
  "missions.reason.enqueue_refused": "étape refusée par une garde",
  "missions.reason.human_stop": "arrêt humain",
  "missions.reason.human_takeover": "prise en main par un humain",
  "missions.reason.max_rounds": "plafond de tours atteint",
  "missions.reason.mission_stopped": "mission arrêtée",
  "missions.reason.oscillation": "oscillation entre deux diffs",
  "missions.reason.plan_failed": "plan en échec",
  "missions.reason.plan_rejected": "plan refusé",
  "missions.reason.repetition": "action répétée",
  "missions.reason.step_failed": "étape en échec",
  "missions.reason.suspension_prolongee": "attente prolongée",
  "missions.reason.unproductive": "deux tours improductifs",
  "missions.roundN": "tour {{n}}",
  "missions.roundsShort": "Tours",
  "missions.status.draft": "Plan en préparation",
  "missions.status.failed": "En échec",
  "missions.status.plan_approved": "Plan approuvé",
  "missions.status.plan_proposed": "Plan à approuver",
  "missions.status.running": "En cours",
  "missions.status.stopped": "Arrêtée",
  "missions.status.succeeded": "Réussie",
  "missions.status.suspended": "Suspendue",
  "missions.stop.announce": "Mission arrêtée. Le job en cours finit son étape.",
  "missions.stop.button": "Arrêter la mission",
  "missions.stop.confirmTitle": "Arrêter la mission « {{t}} » ?",
  "missions.stop.effect1": "Aucune nouvelle étape ne démarre : le job en attente est annulé, les tâches non commencées aussi.",
  "missions.stop.effect2": "Un job déjà démarré par le worker finit son étape : il n’est pas tué.",
  "missions.stop.reason": "Motif (facultatif)",
  "missions.stop.reversibility": "Une nouvelle mission peut être lancée sur le même sujet.",
  "missions.stop.verb": "Arrêter",
  "missions.suspension.admission": "admission refusée par le moteur",
  "missions.suspension.capacity": "plafond d’instances d’application atteint",
  "missions.suspension.human": "attend une décision humaine",
  "missions.suspension.vram": "un modèle étranger occupe la mémoire GPU",
  "missions.taskStatus.cancelled": "Annulée",
  "missions.taskStatus.pending": "À faire",
  "missions.taskStatus.ready": "Prête",
  "missions.taskStatus.running": "En cours",
  "missions.taskStatus.stopped": "Arrêtée",
  "missions.taskStatus.succeeded": "Faite",
  "missions.tasksDone": "Tâches faites",
  "missions.type.checks": "contrôles",
  "missions.type.commit": "commit",
  "missions.type.cost": "coût",
  "missions.type.decision": "décision",
  "missions.type.escalation": "escalade",
  "missions.type.evidence": "dossier de preuves",
  "missions.type.plan": "plan",
  "missions.type.round": "tour",
  "missions.type.stop": "arrêt",
  "missions.type.task_started": "tâche démarrée",
  "missions.type.tests": "tests",
  "missions.type.verdict": "avis",
  "missions.waitingHuman": "Attend un humain",
  "missions.waitingHumanCount": "Attend un humain ({{n}})",
  "mutation.ok": "Modification enregistrée",
  "n28.pastilleAria": "Prochaine action pour votre rôle ({{role}}) : {{action}}, en attente depuis {{depuis}}",
  "nav./": "Accueil",
  "nav./admin": "Réglages du projet",
  "nav./approvals": "Décisions à prendre",
  "nav./artifacts": "Artefacts publiés",
  "nav./attention": "Boîte d’attention",
  "nav./invitations": "Invitations",
  "nav./backlog": "Board",
  "nav./chat": "Assistant du projet",
  "nav./compare": "Comparer des modèles",
  "nav./config": "Gabarits",
  "nav./dependencies": "Dépendances inter-projets",
  "nav./documentation": "Documentation",
  "nav./editor": "Éditeur de spécification",
  "nav./feedback": "Retours sur les générations",
  "nav./graph": "Graphe",
  "nav./guide": "Prise en main",
  "nav./history": "Journal des jobs",
  "nav./ideas": "Déposer une idée",
  "nav./ingestion": "Sources et connaissances",
  "nav./missions": "Missions",
  "nav./notifications": "Notifications",
  "nav./pipelines": "Pipelines",
  "nav./quotas": "Quotas et palier",
  "nav./programs": "Programmes",
  "nav./roadmap": "Roadmap",
  "nav./scorecard": "Indicateurs",
  "nav./sprints": "Sprints",
  "nav./timeline": "Activité",
  "nav./traceability": "Couverture et traçabilité",
  "nav./tree": "Arbre",
  "nav./workflow": "Agents personnalisés",
  "nav.aidePriseEnMain": "Aide et prise en main",
  "nav.backlog": "Backlog",
  "nav.entreesBarreHaute": "Entrées de la barre haute",
  "nav.fermerMenu": "Fermer le menu",
  "nav.menu": "Menu",
  "nav.nonLues": "{{n}} non lue(s)",
  "nav.notifications": "Notifications",
  "nav.ouvrirMenu": "Ouvrir le menu",
  "nav.parent.programme": "Niveau organisation",
  "nav.parent.projet": "Niveau programme",
  "nav.processus": "Cycle et processus",
  "nav.rechercherTiroir": "Rechercher un écran, une action…",
  "nav.roadmap": "Roadmap",
  "nav.sprints": "Sprints",
  "navdesc./": "Votre vue par profil : ce qui attend votre décision et où en est le travail",
  "navdesc./admin": "Membres, modèles et agents autorisés, quotas et intégrations du projet",
  "navdesc./approvals": "Relire, contrôler et décider les documents produits : qui doit agir, et pourquoi",
  "navdesc./artifacts": "Index des artefacts publiés, avec empreinte et provenance",
  "navdesc./attention": "Ce qui attend une décision, avec son âge : approbations, colonie, anomalies à vérifier, dérogations",
  "navdesc./invitations": "Rejoindre un espace : vos invitations en attente ; un lien d’invitation s’ouvre ici",
  "navdesc./backlog": "Le board de travail : epics, stories, tâches — génération de code par item",
  "navdesc./chat": "Dialoguer avec l’assistant dans le contexte du projet",
  "navdesc./compare": "Un prompt, plusieurs modèles : comparer leurs réponses",
  "navdesc./config": "Gabarits : modèle d’item, cycles de vie, agents, modèles et routage, modes",
  "navdesc./dependencies": "Déclarer les dépendances entre projets",
  "navdesc./documentation": "Documentation vivante du projet, lisible à l’écran",
  "navdesc./editor": "Éditer une spécification approuvée en nouvelle version, Spec Gate",
  "navdesc./feedback": "Noter les sorties de l’IA et lire les retours",
  "navdesc./graph": "DAG interactif des work items : hiérarchie et liaisons",
  "navdesc./guide": "Le cycle de bout en bout, cliquable — revenez-y quand vous voulez",
  "navdesc./history": "Tous les jobs passés et leur boîte de verre",
  "navdesc./ideas": "Nouvelle demande : décrire l’idée, puis lancer son cadrage",
  "navdesc./ingestion": "Téléverser des documents et interroger la base documentaire",
  "navdesc./missions": "Lancer une mission de la colonie, la piloter et lire son dossier de preuves",
  "navdesc./notifications": "Vos @mentions et alertes ; marquer comme lu",
  "navdesc./pipelines": "Définir et lancer des pipelines, relier un run à son déploiement",
  "navdesc./programs": "Les programmes dont vous êtes membre ; créer un programme",
  "navdesc./quotas": "Consommation et limites courantes de votre espace et des modèles IA",
  "navdesc./roadmap": "Frise des sprints (Gantt), avancement et « aujourd'hui »",
  "navdesc./scorecard": "Livraison, DORA, IA, gouvernance et objectifs de service calculés des données",
  "navdesc./sprints": "Itérations agiles : engagement, avancement, vélocité",
  "navdesc./timeline": "Fil chronologique unifié des événements du projet",
  "navdesc./traceability": "Exigence → code → test → anomalie, et les trous de couverture",
  "navdesc./tree": "Arbre unifié Epic→Feature→US→Tâche, augmenté par l'IA",
  "navdesc./workflow": "Exécuter un agent personnalisé et suivre sa trace",
  "newWs.creating": "Création…",
  "newWs.descriptionLabel": "Description",
  "newWs.descriptionPlaceholder": "À quoi sert ce projet ?",
  "newWs.nameAide": "Ce nom apparaîtra dans le sélecteur de projet.",
  "newWs.nameLabel": "Nom du projet",
  "newWs.namePlaceholder": "Ex. Modernisation du core assurance",
  "newWs.nameTooShort": "Le nom doit comporter au moins 3 caractères",
  "newWs.optional": "(optionnel)",
  "newWs.templateDefaultOption": "Par défaut (intégré)",
  "newWs.templateHint": "La façon de travailler (types d'items, workflow, liaisons) de ce projet.",
  "newWs.templateLabel": "Gabarit de configuration",
  "newWs.title": "Nouveau projet",
  "newWs.triggerButton": "Nouvel espace",
  "notFound.backLink": "Retour au tableau de bord",
  "notFound.heading": "Page introuvable",
  "notFound.message": "Cette adresse ne correspond à aucun écran. Utilisez la navigation ou la palette de commandes (Ctrl+K).",
  "navigation.mode.discovery": "Mode Découverte",
  "navigation.mode.full": "Mode Complet",
  "navigation.mode.hidden": "{{count}} outils de plus via ⌘K",
  "navigation.mode.simplify": "Réduire aux actions essentielles",
  "notif.all": "Toutes",
  "notif.allReadToast": "Toutes les notifications sont lues",
  "notif.desc": "Vos @mentions et alertes. Cliquez une entrée pour rejoindre l'item concerné.",
  "notif.empty": "Aucune notification",
  "notif.emptyHint": "Vous serez notifié lors d’une mention, d’une approbation ou d’un incident.",
  "notif.approvalGranted": "a approuvé votre artefact",
  "notif.approvalRejected": "a rejeté votre artefact",
  "notif.processApprovalRequested": "demande votre approbation pour une étape de processus",
  "notif.pipelineFailure": "a signalé un échec de pipeline",
  "notif.deployFailure": "a signalé un échec de déploiement",
  "notif.emptyUnread": "Aucune notification non lue",
  "notif.loading": "Chargement des notifications…",
  "notif.markAll": "Tout marquer lu",
  "notif.markRead": "Lu",
  "notif.mentioned": "vous a mentionné",
  "notif.on": "sur",
  "notif.system": "Système",
  "notif.title": "Notifications",
  "notif.unread": "Non lues",
  "odoo.aucune": "Aucune connexion Odoo",
  "odoo.aucuneIndice": "Renseignez l’instance, la base et un compte technique.",
  "odoo.base": "Base de données",
  "odoo.champRequis": "Ce champ est obligatoire.",
  "odoo.chargement": "Lecture de la connexion Odoo…",
  "odoo.configuree": "configurée",
  "odoo.connecte": "connecté",
  "odoo.connecteDetail": "uid {{uid}}{{version}}",
  "odoo.connecter": "Connecter Odoo",
  "odoo.creer": "Créer",
  "odoo.creerPartenaire": "Créer un partenaire",
  "odoo.description": "Les identifiants sont chiffrés en base et jamais réaffichés : à chaque enregistrement, le mot de passe est saisi à nouveau.",
  "odoo.enregistre": "Connexion Odoo enregistrée",
  "odoo.enregistrer": "Enregistrer",
  "odoo.identifiant": "Identifiant",
  "odoo.majLe": "mise à jour le {{quand}}",
  "odoo.motDePasse": "Mot de passe",
  "odoo.motDePassePh": "saisir à nouveau pour enregistrer",
  "odoo.partenaireCree": "Partenaire n° {{id}} créé et relu dans Odoo.",
  "odoo.partenaireRequis": "Donnez le nom du partenaire.",
  "odoo.partenaires": "Partenaires (res.partner)",
  "odoo.refus": "La connexion Odoo se règle par le propriétaire du projet : elle ne vous est pas ouverte.",
  "odoo.refusSansConnexion": "Enregistrez d’abord une connexion : tester et créer un partenaire l’exigent.",
  "odoo.testEnCours": "Authentification auprès d’Odoo…",
  "odoo.tester": "Tester la connexion",
  "odoo.titre": "Connexion Odoo (CRM) du projet",
  "odoo.url": "URL de l’instance",
  "odoo.urlAide": "http(s) seulement ; l’hôte doit figurer dans la liste des sorties autorisées.",
  "quarantaine.statut.DEAD_LETTER": "lettre morte",
  "quarantaine.statut.RETRY_WAIT": "à retenter",
  "quarantaine.statut.PENDING": "en attente",
  "quarantaine.statut.LEASED": "en livraison",
  "quarantaine.statut.DELIVERED": "livré",
  "quarantaine.cause.UNKNOWN_KEY": "clé inconnue",
  "quarantaine.cause.RETIRED_KEY": "clé retirée",
  "quarantaine.cause.MISSING_ALIAS": "alias manquant",
  "quarantaine.cause.INVALID_KEY": "clé invalide",
  "quarantaine.rejoue": "Événement rejoué — il repart en livraison",
  "quarantaine.titre": "Événements en quarantaine (outbox)",
  "quarantaine.description": "Notifications dont la clé de signature n’a pas pu être résolue : gardées, jamais perdues, rejouables après reclassification.",
  "quarantaine.refus": "La quarantaine se consulte et se rejoue par l’administration de la plateforme seulement.",
  "quarantaine.confirmTitre": "Rejouer {{ek}} ?",
  "quarantaine.confirmC1": "L’événement quitte la lettre morte et repart en livraison (génération de rejeu {{g}}).",
  "quarantaine.confirmC2": "Le rejeu et son motif sont consignés à l’audit de l’organisation {{org}}.",
  "quarantaine.confirmRisque": "Rejeu à risque : la portée du projet a changé depuis la mise en lettre morte (génération {{a}} → {{n}}) ; la livraison se fera sous la nouvelle portée.",
  "quarantaine.confirmRev": "Aucun retour automatique : si la livraison échoue encore, l’événement revient en lettre morte après six tentatives.",
  "quarantaine.rejouerQuandMeme": "Rejouer quand même",
  "quarantaine.rejouer": "Rejouer",
  "quarantaine.attestation": "J’ai vérifié que le destinataire tolère une livraison sous la nouvelle portée",
  "quarantaine.porteeTitre": "Périmètre : toute l’installation.",
  "quarantaine.porteeDesc": "Données techniques seulement (clés hachées, cause, compteurs) : aucun contenu de projet. Chaque rejeu se consigne dans l’organisation de l’événement.",
  "quarantaine.filtreStatut": "Statut",
  "quarantaine.tous": "Tous",
  "quarantaine.filtreCause": "Cause",
  "quarantaine.toutes": "Toutes",
  "quarantaine.chargement": "Lecture de la quarantaine…",
  "quarantaine.vide": "Aucun événement en quarantaine",
  "quarantaine.videIndice": "Toutes les notifications ont trouvé leur clé.",
  "quarantaine.colEvenement": "Événement · cause",
  "quarantaine.colProjet": "Organisation · projet",
  "quarantaine.colStatut": "Statut",
  "quarantaine.colTentatives": "Tentatives",
  "quarantaine.colErreur": "Dernière erreur",
  "quarantaine.colVu": "Vu le",
  "quarantaine.voir": "Voir le détail de {{ek}}",
  "quarantaine.page": "Page {{p}} sur {{n}} · {{total}} événement(s)",
  "quarantaine.precedente": "Page précédente",
  "quarantaine.suivante": "Page suivante",
  "quarantaine.detailTitre": "Détail et rejeu",
  "quarantaine.correlation": "Corrélation",
  "quarantaine.notification": "Notification",
  "quarantaine.notificationDetail": "n° {{n}} · version de classification {{v}}",
  "quarantaine.cause": "Cause",
  "quarantaine.versionCle": "version de clé {{v}}",
  "quarantaine.chaine": "Chaîne",
  "quarantaine.generation": "Génération",
  "quarantaine.generationDetail": "rejeu {{r}} · portée {{a}} → {{n}} · cycle de vie {{c}}",
  "quarantaine.journal": "Journal d’audit",
  "quarantaine.dejaConsigne": "déjà consigné (un rejeu n’y crée pas de doublon)",
  "quarantaine.nonConsigne": "pas encore consigné",
  "quarantaine.motif": "Motif de reclassification (obligatoire, consigné)",
  "quarantaine.fermer": "Fermer",
  "quarantaine.nonRejouable": "Seul un événement en lettre morte, sur une portée active, se rejoue.",
  "quarantaine.motifRequis": "Le motif de reclassification est obligatoire.",
  "quarantaine.enCours": "Rejeu en cours…",
  "quarantaine.resteEnQuarantaine": "L’événement reste en quarantaine.",
  "executants.onglets": "Exécutants",
  "executants.battements": "Battements",
  "executants.quarantaine": "Quarantaine",
  "mcpTest.registre": "Registre",
  "mcpTest.activation": "Activation",
  "mcpTest.liaison": "Liaison à l’agent",
  "mcpTest.empreinte": "Empreinte approuvée",
  "mcpTest.paquet": "Paquet sur disque",
  "mcpTest.bacASable": "Bac à sable",
  "mcpTest.outils": "Outils déclarés",
  "mcpTest.source": "Source",
  "mcpTest.tester": "Tester la liaison",
  "mcpTest.enCours": "Vérification de la liaison…",
  "mcpTest.ok": "Liaison vérifiée en {{ms}} ms : {{n}} contrôles conformes, rien n’a été lancé.",
  "mcpTest.ko": "Liaison non conforme : {{code}}",
  "mcpTest.conforme": "conforme",
  "mcpTest.nonConforme": "non conforme",
  "exportGouv.public.owner": "Propriétaires",
  "exportGouv.public.contributor": "Contributeurs",
  "exportGouv.public.viewer": "Lecteurs",
  "exportGouv.telecharge": "Export gouverné téléchargé",
  "exportGouv.titre": "Export gouverné",
  "exportGouv.description": "Un lien signé, borné dans le temps, destiné à un public nommé du projet. La demande et chaque téléchargement sont consignés à l’audit.",
  "exportGouv.demander": "Demander un export gouverné…",
  "exportGouv.refus": "Seul le propriétaire du projet demande un export gouverné et en lit l’historique.",
  "exportGouv.lienPret": "Lien prêt — il ne sera plus réaffiché.",
  "exportGouv.lien": "Lien d’export (session du projet requise)",
  "exportGouv.copier": "Copier le lien",
  "exportGouv.expire": "Expire le",
  "exportGouv.publicCol": "Public",
  "exportGouv.redaction": "Rédaction",
  "exportGouv.pseudonymes": "pseudonymes",
  "exportGouv.nominatif": "nominatif (propriétaires seuls)",
  "exportGouv.demande": "Demande",
  "exportGouv.telecharger": "Télécharger",
  "exportGouv.echu": "Le lien d’export a expiré ou n’est plus valide pour ce projet : aucune donnée n’est servie. Demandez un nouvel export.",
  "exportGouv.chargement": "Lecture des demandes d’export…",
  "exportGouv.aucun": "Aucune demande d’export gouverné pour ce projet.",
  "exportGouv.colDemande": "Demande",
  "exportGouv.colTelecharge": "Téléchargé",
  "exportGouv.echuCourt": "échu",
  "exportGouv.valide": "valide",
  "exportGouv.jamais": "jamais",
  "exportGouv.dialogueTitre": "Demander un export gouverné",
  "exportGouv.dialoguePortee": "Projet {{ws}} · éléments, décisions, commentaires, sprints, journal, métadonnées des pièces jointes.",
  "exportGouv.publicLegende": "Public du lien (au moins un)",
  "exportGouv.publicRequis": "Choisissez au moins un public.",
  "exportGouv.duree": "Durée de validité du lien (heures)",
  "exportGouv.dureeInvalide": "Entre 1 et 168 heures.",
  "exportGouv.dureeAide": "Entre 1 et 168 heures (7 jours).",
  "exportGouv.redactionImposee": "Rédaction imposée : le public dépasse les seuls propriétaires, les personnes seront remplacées par des pseudonymes stables. Ce n’est pas un choix du demandeur.",
  "exportGouv.redactionNon": "Public limité aux propriétaires : l’export reste nominatif.",
  "exportGouv.emission": "Émission du lien signé…",
  "exportGouv.annuler": "Annuler",
  "exportGouv.emettre": "Émettre le lien",
  "erreurs.code.QUARANTINE_REASON_REQUIRED": "Le motif de reclassification est obligatoire.",
  "erreurs.code.QUARANTINE_NOT_REPLAYABLE": "Cet événement n’est plus rejouable : il a quitté la lettre morte, ou sa portée ou ses générations ont changé depuis la lecture.",
  "erreurs.code.EXPORT_AUDIENCE_MISMATCH": "Ce lien d’export est destiné à un autre public que votre rôle dans le projet.",
  "erreurs.code.PLATFORM_ADMIN_REQUIRED": "Réservé à l’administration de la plateforme.",
  "pgmGouv.ajouter": "Ajouter au programme",
  "pgmGouv.ajoutTitre": "Ajouter une exigence au programme",
  "pgmGouv.categorie": "Catégorie",
  "pgmGouv.chargement": "Lecture du référentiel du programme…",
  "pgmGouv.code": "Identifiant",
  "pgmGouv.codeRequis": "Donnez un identifiant, de la forme DOD-PRG-001.",
  "pgmGouv.controle": "contrôle",
  "pgmGouv.controleNom": "Contrôle qui la vérifie",
  "pgmGouv.controleRequis": "Nommez le contrôle qui vérifie ce critère.",
  "pgmGouv.critere": "Critère",
  "pgmGouv.critereRequis": "Énoncez le critère.",
  "pgmGouv.de": "Référentiel de gouvernance de {{nom}}",
  "pgmGouv.dod": "critère de fin (DoD)",
  "pgmGouv.erreur": "Le référentiel du programme n’a pas pu être lu ; rien n’a changé.",
  "pgmGouv.etatProjet": "L’état se juge dans chaque projet (Concevoir › Exigences héritées) : au programme, un critère naît « à vérifier ».",
  "pgmGouv.nAjoutes": "{{n}} ajouté(s) par le programme",
  "pgmGouv.nAVerifier": "{{n}} à vérifier",
  "pgmGouv.nCriteres": "{{n}} critère(s)",
  "pgmGouv.nDerogation": "{{n}} en dérogation",
  "pgmGouv.nfr": "exigence non fonctionnelle",
  "pgmGouv.origineOrganisation": "héritée de l’organisation",
  "pgmGouv.origineProgramme": "ajoutée par le programme · héritée par les projets rattachés",
  "pgmGouv.refusLecture": "Vous n’êtes pas membre de ce programme : son référentiel ne vous est pas ouvert.",
  "pgmGouv.regle": "Le programme renforce le référentiel de l’organisation pour ses projets : un critère ajouté ici est hérité par ses projets rattachés (un projet qui porte déjà ce code garde le sien).",
  "pgmGouv.renforcer": "Renforcer, jamais assouplir. Aucun retrait au niveau du programme dans cette version.",
  "pgmGouv.reserve": "Seul le propriétaire ou le gestionnaire du programme ajoute une exigence ; vous gardez la lecture.",
  "pgmGouv.seuil": "seuil {{s}}",
  "pgmGouv.seuilFacultatif": "Seuil (facultatif)",
  "pgmGouv.succes": "{{code}} ajoutée — à vérifier. Les projets rattachés l’héritent.",
  "pgmGouv.titreListe": "{{nom}} — référentiel de gouvernance",
  "pgmGouv.type": "Type",
  "pgmGouv.vide": "Aucune exigence propre au programme",
  "pgmGouv.videIndice": "Les projets suivent le référentiel de l’organisation. Ajoutez un critère pour le renforcer.",
  "pipelines.addStage": "+ Ajouter une étape",
  "pipelines.createdToast": "Pipeline créé",
  "pipelines.createPipeline": "Créer le pipeline",
  "pipelines.creating": "Création…",
  "pipelines.emptyHint": "Définissez-en un ci-dessus.",
  "pipelines.emptyTitle": "Aucun pipeline",
  "pipelines.loading": "Chargement…",
  "pipelines.loadingRuns": "Chargement des runs…",
  "pipelines.nameLabel": "Nom",
  "pipelines.namePlaceholder": "CI — lint & tests",
  "pipelines.nameRequired": "Le nom du pipeline est obligatoire.",
  "pipelines.newPipeline": "Nouveau pipeline",
  "pipelines.pageDescription": "Définissez des pipelines (des étapes de commande) et lancez-les. L'exécution tourne dans un sandbox, côté hôte, et n'a lieu que si elle est activée sur le serveur.",
  "pipelines.pageTitle": "Pipelines & déploiement",
  "pipelines.pipelinesTitle": "Pipelines",
  "pipelines.readOnly": "Lecture seule — définir un pipeline est réservé aux contributeurs.",
  "pipelines.run": "Lancer",
  "pipelines.runsEmptyHint": "Lancez le pipeline pour créer un run.",
  "pipelines.runsEmptyTitle": "Aucune exécution",
  "pipelines.runsTitle": "Exécutions",
  "pipelines.runToast": "Pipeline lancé",
  "pipelines.stageCommandPlaceholder": "Commande",
  "pipelines.stageFailed": "Échec",
  "pipelines.stageNamePlaceholder": "Nom",
  "pipelines.stagesCount": "étape(s)",
  "pipelines.stageSkipped": "Sautée",
  "pipelines.stagesLegend": "Étapes (exécutées dans l'ordre, arrêt au premier échec)",
  "pipelines.viewRuns": "Voir les runs",
  "planSprints.borneFacteur": "Facteur au-delà duquel le sprint est refusé",
  "planSprints.borneItems": "Items par sprint, au plus",
  "planSprints.borneNonEstime": "Points supposés d’un item non estimé",
  "planSprints.bornePoints": "Points par sprint, au plus",
  "planSprints.bornesLegend": "Bornes de découpage (modifiables avant de lancer)",
  "planSprints.consequencesLabel": "Conséquences",
  "planSprints.enters": "entre dans ce sprint",
  "planSprints.faulty": "ne peut pas entrer ici",
  "planSprints.fromSprint": "vient du sprint {{id}}",
  "planSprints.howProduced": "Comment cette proposition est produite",
  "planSprints.jobFailed": "La planification a échoué.",
  "planSprints.launch": "Proposer un découpage",
  "planSprints.launchConsequence": "appelle un modèle sur le périmètre ci-dessus et coûte une génération.",
  "planSprints.noWriteConsequence": "Aucun item n’est déplacé et aucun sprint n’est créé : le résultat est une proposition, dont le runtime recalcule le verdict sur votre backlog. Écrire le plan reste un geste SÉPARÉ, que vous déclenchez sous le diff après l’avoir lu.",
  "planSprints.selectionSeule": "Retenir sélectionne : {{n}} sprint(s) retenu(s) sur {{total}}. Rien n’est écrit tant que vous n’avez pas appliqué ci-dessous.",
  "planSprints.apply": "Appliquer les sprints retenus",
  "planSprints.bilanApplication": "{{sprints}} sprint(s) créé(s), {{items}} item(s) rangé(s).",
  "planSprints.refusEcrireInvalide": "« {{nom}} » est invalide : rien n’a été écrit. Corrigez-le, ou retirez-le de la sélection.",
  "planSprints.refusEcrireVide": "« {{nom}} » ne porte aucun item : rien n’a été écrit.",
  "planSprints.refusEcrireIdentifiant": "L’item « {{id}} » de « {{nom}} » n’est pas un identifiant de backlog : rien n’a été écrit.",
  "planSprints.portee": "{{items}} items planifiés, dont {{avec}} portent au moins une dépendance ; {{liens}} liens « bloque » saisis et {{derives}} blocages dérivés de la filiation. Le contrôle d’autonomie ne porte que sur ces dépendances — un lien jamais saisi ne peut contredire aucun plan.",
  "planSprints.porteeVide": "{{items}} items planifiés, AUCUNE dépendance déclarée dans cet espace. Le contrôle d’autonomie n’a donc rien pu contredire : ce verdict ne dit pas « ces sprints sont livrables seuls », il dit « rien ne prouve le contraire ». Les liens « bloque » se saisissent à la main sur la fiche d’un item.",
  "planSprints.porteeFiliation": "{{items}} items planifiés, dont {{avec}} portent au moins une dépendance. Elles viennent toutes de la filiation — {{derives}} blocages dérivés de « un parent n’est livrable qu’avec ses enfants » — car aucun lien « bloque » n’a été saisi dans cet espace. Le contrôle a donc bien pu contredire ce plan sur la hiérarchie, mais rien ne le contredit sur ce qu’un récit doit à un autre.",
  "planSprints.refusBorne": "« {{borne}} » doit être un entier entre 1 et {{max}}.",
  "planSprints.refusLecture": "Votre rôle permet de consulter cet espace, pas d’y lancer une génération.",
  "planSprints.refusPerimetreVide": "Aucun item à planifier : ni item hors sprint, ni item non terminé dans un sprint planifié ou clos.",
  "planSprints.refusSprintInvalide": "« {{nom}} » porte {{n}} violation(s) bloquante(s) : corrigez-les d’abord.",
  "planSprints.refusTout": "« {{nom}} » est invalide : corrigez-le ou retenez les autres sprints un par un.",
  "planSprints.retain": "Retenir",
  "planSprints.retainAll": "Tout retenir",
  "planSprints.retained": "Retenu",
  "planSprints.scopeLinks": "Dépendances déclarées",
  "planSprints.scopeLoading": "Lecture du périmètre…",
  "planSprints.scopeReplan": "Items à replanifier",
  "planSprints.scopeUnestimated": "Sans estimation",
  "planSprints.scopeUnplanned": "Items hors sprint",
  "planSprints.sprintMetrics": "{{points}} pts · {{items}} items",
  "planSprints.sprintUnestimated": "{{n}} non estimé(s)",
  "planSprints.unplaced": "Laissés hors plan par le modèle :",
  "planSprints.v.cycleInterne": "{{item}} et {{ref}} se bloquent mutuellement — livrables ensemble, mais la donnée est douteuse.",
  "planSprints.v.depassementItems": "{{mesure}} items pour une borne de {{borne}} — dépassement toléré, à assumer.",
  "planSprints.v.depassementPoints": "{{mesure}} points pour une borne de {{borne}} — dépassement toléré, à assumer.",
  "planSprints.v.dependanceAbsente": "{{item}} est bloqué par {{ref}}, qui n’est ni planifié dans ce plan ni livré.",
  "planSprints.v.dependanceInconnue": "{{item}} est bloqué par {{ref}}, absent du backlog de cet espace.",
  "planSprints.v.dependancePlusTard": "{{item}} est bloqué par {{ref}}, planifié dans un sprint PLUS TARD : ce sprint ne peut pas être livré seul.",
  "planSprints.v.estimationManquante": "{{mesure}} item(s) sans estimation : leurs points sont supposés, pas mesurés.",
  "planSprints.v.horsGabaritItems": "{{mesure}} items pour un plafond de {{borne}} : ce n’est plus un sprint, c’est le backlog entier.",
  "planSprints.v.horsGabaritPoints": "{{mesure}} points pour un plafond de {{borne}} : ce n’est plus un sprint, c’est le backlog entier.",
  "planSprints.v.inconnu": "Constat « {{code}} » non reconnu par cette interface.",
  "planSprints.v.itemEnDouble": "{{item}} est placé dans deux sprints à la fois.",
  "planSprints.v.itemInconnu": "{{item}} n’existe pas dans le backlog de cet espace : le modèle l’a inventé.",
  "planSprints.v.itemLivre": "{{item}} est déjà livré : le déplacer réécrirait ce qu’un sprint clos a livré.",
  "planSprints.v.parentDisperse": "{{item}} est séparé de son parent {{ref}}, placé dans un autre sprint.",
  "planSprints.v.sourceHorsMandat": "{{item}} appartient au sprint {{ref}}, qui est en cours : on ne retire pas du travail sous les pieds d’une itération lancée.",
  "planSprints.v.sprintVide": "Ce sprint ne contient aucun item exploitable.",
  "planSprints.verdictInvalide": "Invalide",
  "planSprints.verdictReserve": "Sous réserve",
  "planSprints.verdictValide": "Aucune violation",
  "planifier.affichagesBacklog": "Affichages du backlog",
  "planifier.aucuneFeature": "Aucune feature à évaluer",
  "planifier.aucuneFeatureHint": "Découpez une fonctionnalité en features et stories : l’état « prête » se calculera seul.",
  "planifier.backlogDescription": "Les items du projet. L’affichage choisi est dans l’adresse : il se partage et se retrouve au retour arrière.",
  "planifier.capaciteChargement": "Lecture des missions…",
  "planifier.capaciteCompte": "Colonie — prêtes : non calculé · {{n}} mission(s) active(s)",
  "planifier.capaciteErreur": "Capacité de la colonie illisible : la liste des missions n’a pas répondu.",
  "planifier.capaciteNote": "Ce bandeau ne bloque rien : il dit ce que la colonie a en cours. Le compte des features prêtes attend le contrôle de préparation côté serveur.",
  "planifier.capaciteTitre": "Capacité de la colonie — lecture seule",
  "planifier.colEtat": "État",
  "planifier.colFeature": "Feature et motif",
  "planifier.colMission": "Mission",
  "planifier.colUS": "US",
  "planifier.dorAVenir": "Le contrôle « prête pour la colonie » (DoR de la feature et de ses US, reçu Spec Gate frais par US, tests conçus, taille ≤ 32 K de contexte et ≤ 400 lignes) n’est pas calculé par cette passerelle : aucune feature n’est marquée prête par défaut. Les manques visibles dans les données sont nommés.",
  "planifier.etatFaite": "faite",
  "planifier.etatNonEvaluee": "non évaluée",
  "planifier.evaluation": "Évaluation des critères de préparation…",
  "planifier.evaluationErreur": "Évaluation indisponible : {{m}}",
  "planifier.lancerSprint": "Lancer une mission sur ce sprint",
  "planifier.lancerSprintMotif": "Cette version n’exécute pas encore les missions de sprint (G4) : seule « Générer l’application » l’est. Implémentez les stories une à une depuis leur fiche.",
  "planifier.lancerTranche": "Lancer une mission sur cette tranche",
  "planifier.lancerTrancheMotif": "Cette version n’exécute pas encore les missions sur une tranche (G4) : seule « Générer l’application » l’est. Implémentez les stories depuis leur fiche.",
  "planifier.manqueCriteres": "#{{id}} sans critère d’acceptation",
  "planifier.manqueSansUS": "aucune US",
  "planifier.manqueSource": "aucune spécification source",
  "planifier.ouvrirHierarchie": "Ouvrir la hiérarchie",
  "planifier.porteeSprint": "Comptée sur le sprint actif ({{nom}}).",
  "planifier.porteeTableau": "Sans sprint actif : comptée sur tout le tableau.",
  "planifier.reglerDansSprints": "Régler dans Sprints",
  "planifier.roadmapDescription": "Les sprints datés du projet.",
  "planifier.sansProjet": "Aucun projet sélectionné",
  "planifier.sansProjetHint": "Le Backlog porte toujours sur un projet : choisissez-le dans le sélecteur de contexte.",
  "planifier.sansProjetSprints": "Les sprints portent toujours sur un projet : choisissez-le dans le sélecteur de contexte.",
  "planifier.sprintsLectureSeule": "Lecture seule — créer un sprint ou y ranger une US est réservé aux contributeurs.",
  "planifier.tranchesCaption": "Features et leur état « prête pour la colonie »",
  "planifier.voirMissions": "Voir les missions",
  "planifier.wipAVenir": "Limite de travail en cours par colonne : le réglage n’est pas encore porté par la passerelle. Les colonnes affichent leur compte ; la limite s’affichera ici en « n / limite », ambre atteinte, rouge dépassée.",
  "planifier.wipAtteinte": "{{col}} : limite atteinte ({{n}} / {{l}}).",
  "planifier.wipAtteinteAria": "{{n}} carte(s) sur une limite de {{l}} : limite atteinte",
  "planifier.wipCompteAria": "{{n}} carte(s)",
  "planifier.wipDepassee": "{{col}} : limite dépassée ({{n}} / {{l}}) — un avertissement ; déplacer une carte reste possible.",
  "planifier.wipDepasseeAria": "{{n}} carte(s) sur une limite de {{l}} : limite dépassée",
  "planifier.wipNonReglee": "limite non réglée",
  "planifier.wipReglageAVenir": "Régler la limite de chaque colonne (SRF-PRJ-031) : non porté par cette passerelle — aucune limite stockée. Les comptes ci-dessus suivent déjà la règle.",
  "planifier.wipRegle": "Atteinte : ambre ; dépassée : rouge, un avertissement — déplacer une carte reste possible. Le Backlog (affichage Tableau) affiche ces limites en lecture.",
  "planifier.wipTitre": "Limite de travail en cours, par colonne du tableau du projet",
  "programs.attachButton": "Rattacher",
  "programs.attachLabel": "Rattacher un projet",
  "programs.attachPlaceholder": "Choisir un projet…",
  "programs.colAction": "Action",
  "programs.colApprovals": "Approbations",
  "programs.colDocuments": "Documents",
  "programs.colJobs": "Jobs",
  "programs.colProject": "Projet",
  "programs.createButton": "Créer le programme",
  "programs.createdToast": "Programme créé",
  "programs.descLabel": "Description",
  "programs.descPlaceholder": "À quoi sert ce programme ?",
  "programs.description": "Regroupez des projets sous un programme et pilotez-les au portefeuille : création, rattachement de projets et agrégat des projets rattachés.",
  "programs.detach": "Détacher",
  "programs.emptyHint": "Créez un programme, puis rattachez-y des projets.",
  "programs.emptyTitle": "Aucun programme",
  "programs.initiativeDesc": "Description",
  "programs.initiativeDescPlaceholder": "Le contexte, les objectifs, les contraintes…",
  "programs.initiativeGenerate": "Générer les epics",
  "programs.initiativeHeading": "Initiative → epics (IA)",
  "programs.initiativeIntro": "Décrivez une initiative de programme ; l'IA la décompose en epics dans la liste du projet choisi (à accepter).",
  "programs.initiativeLaunched": "Génération lancée — les epics apparaîtront dans la liste du projet (à accepter).",
  "programs.initiativeOpenList": "Ouvrir la liste",
  "programs.initiativeTarget": "Projet cible",
  "programs.initiativeTargetPlaceholder": "Choisir un projet du programme…",
  "programs.initiativeTargetRequired": "Choisissez le projet qui recevra les epics générés.",
  "programs.initiativeTitle": "Titre de l'initiative",
  "programs.initiativeTitlePlaceholder": "Ex. Conformité réglementaire CIMA",
  "programs.initiativeTitleTooShort": "L'intitulé de l'initiative fait au moins trois caractères.",
  "programs.kpiApprovals": "Approbations en attente",
  "programs.kpiDocuments": "Documents",
  "programs.kpiJobs": "Jobs en cours",
  "programs.kpiProjects": "Projets",
  "programs.listHeading": "Vos programmes",
  "programs.loading": "Chargement des programmes…",
  "programs.loadingRoadmap": "Chargement de la roadmap…",
  "programs.loadingRollup": "Agrégation des projets…",
  "programs.nameLabel": "Nom",
  "programs.namePlaceholder": "Ex. Modernisation Core Assurance",
  "programs.nameTooShort": "Le nom du programme fait au moins trois caractères.",
  "programs.newHeading": "Nouveau programme",
  "programs.noProjectHint": "Rattachez un projet ci-dessous pour le voir apparaître ici.",
  "programs.noProjectTitle": "Aucun projet rattaché",
  "programs.pickHint": "Choisissez un programme à gauche pour voir ses projets et son agrégat.",
  "programs.pickTitle": "Sélectionnez un programme",
  "programs.projectsHeading": "Projets du programme",
  "programs.quoi": "projets",
  "programs.roadmapEmptyHint": "Datez des sprints dans les projets rattachés pour les voir alignés ici.",
  "programs.roadmapEmptyTitle": "Aucun sprint daté",
  "programs.roadmapHeading": "Roadmap du programme",
  "programs.templateDefaultOption": "Par défaut (intégré)",
  "programs.templateHint": "La façon de travailler (types d'items, workflow, liaisons) de ce programme.",
  "programs.templateLabel": "Gabarit de configuration",
  "programs.title": "Programmes",
  "progSwitch.all": "Tous les projets",
  "progSwitch.label": "Programme",
  "projet.about": "À propos",
  "projet.axes": "Axes de rattachement",
  "projet.byStatus": "Répartition par statut",
  "projet.description": "Les items du projet et leurs différentes vues. La vue choisie figure dans l'adresse : elle peut être partagée et revient au retour du navigateur.",
  "projet.emptyBacklog": "Le backlog est vide.",
  "projet.itemsDone": "item(s) terminé(s)",
  "projet.loading": "Chargement du projet…",
  "projet.noAxis": "Aucun axe déclaré pour ce projet.",
  "projet.noDescription": "Ce projet n’a pas encore de description.",
  "projet.noWorkspace": "Aucun projet sélectionné",
  "projet.noWorkspaceHint": "Choisissez un projet dans le panneau de gauche.",
  "projet.progress": "Avancement",
  "projet.title": "Projet",
  "projet.viewsLabel": "Vues du projet",
  "projet.vue.apercu": "Aperçu",
  "projet.vue.graphe": "Graphe",
  "projet.vue.hierarchie": "Hiérarchie",
  "projet.vue.liste": "Liste",
  "projet.vue.pret-colonie": "Prêt pour la colonie",
  "projet.vue.roadmap": "Roadmap",
  "projet.vue.sprints": "Sprints",
  "projet.vue.tableau": "Tableau",
  "rail.etape": "étape",
  "rail.etapes": "étapes",
  "review.announceSubmitted": "Revue indépendante déposée.",
  "review.approvalBlocked.commentaireRisqueRequis": "Le relecteur a signalé un risque : approuver malgré ce risque exige un commentaire de décision.",
  "review.approvalBlocked.decidee": "Cette demande est déjà décidée.",
  "review.approvalBlocked.demandeur": "Vous êtes le demandeur : la séparation des tâches interdit d’approuver son propre artefact.",
  "review.approvalBlocked.planRisqueAbsent": "Le relecteur a signalé un risque : un plan de mitigation (propriétaire, mesure, échéance) doit être enregistré avant l’approbation.",
  "review.approvalBlocked.relecteur": "Vous avez rendu la revue indépendante de cet artefact : un autre que vous doit l’approuver.",
  "review.approvalBlocked.role": "Votre rôle ne permet pas de décider dans cet espace.",
  "review.approvalBlocked.verdictBloquant": "Le relecteur indépendant a rendu un verdict défavorable : l’approbation est impossible, sans contournement. Révisez l’artefact, puis faites-le relire à nouveau.",
  "review.approvalBlocked.revueRequise": "Une revue indépendante d’une troisième personne est requise — ni le demandeur ni l’approbateur. Faites déposer la revue ci-dessus, puis approuvez.",
  "review.approver": "Approbateur",
  "review.approverRule": "un tiers : ni le demandeur, ni le relecteur.",
  "review.blocked.decidee": "La demande est déjà décidée : déposer une revue ne débloquerait plus rien.",
  "review.blocked.dejaRelu": "La revue indépendante est déjà déposée ; elle ne se redépose pas.",
  "review.blocked.demandeur": "Vous êtes le demandeur : la revue indépendante doit venir d’un autre (séparation des tâches).",
  "review.blocked.role": "Votre rôle ne permet pas de relire : seul un propriétaire ou un contributeur de l’espace le peut.",
  "review.by": "par",
  "review.hint": "Trois rôles distincts : celui qui demande, celui qui relit, celui qui approuve. Un artefact produit par l’IA n’est approuvable qu’après un verdict de revue déposé par un tiers.",
  "review.justificationHint": "Ce que vous avez vérifié, et ce qui fonde votre verdict. Le texte est conservé et son empreinte scellée par le serveur.",
  "review.justificationLabel": "Justification (obligatoire)",
  "review.justificationRequired": "Une revue exige une justification : un verdict sans motif n’est pas une revue.",
  "review.missingWarning": "Aucune revue n’est attachée. Si cet artefact vient d’une génération IA, le serveur refusera toute approbation tant que la revue n’est pas déposée.",
  "review.none": "Revue indépendante : non déposée",
  "review.openApprovalCenter": "Ouvrir dans le Centre d’approbations",
  "review.openForm": "Relire",
  "review.requester": "Demandeur",
  "review.reviewer": "Relecteur",
  "review.serverErrorHint": "Cette demande ne porte aucun verdict de revue indépendante. Si l’artefact vient d’une génération IA, c’est la cause la plus probable du refus : faites déposer la revue ci-dessus par un tiers, puis approuvez.",
  "review.submit": "Déposer la revue",
  "review.submittedToast": "Revue indépendante déposée",
  "review.title": "Revue indépendante",
  "review.unknownReviewer": "relecteur inconnu",
  "review.verdictApprove": "Revue favorable",
  "review.verdictApproveConsequence": "Un tiers — ni vous, ni le demandeur — pourra approuver.",
  "review.verdictLegend": "Votre verdict",
  "review.verdictReject": "Revue défavorable",
  "review.verdictRejectConsequence": "L’approbation devient impossible, sans contournement : l’artefact devra être révisé puis relu à nouveau.",
  "review.verdictRisk": "Réserve — risque signalé",
  "review.verdictRiskConsequence": "L’approbation reste possible, mais exigera un commentaire et un plan de mitigation enregistré.",
  "review.verdictUnknown": "verdict inconnu",
  "review.you": "vous",
  "roadmap.description": "Les sprints sur une frise temporelle — planification et avancement d'un coup d'œil.",
  "roadmap.emptyHint": "Donnez des dates de début et de fin à vos sprints pour les voir sur la roadmap.",
  "roadmap.emptyTitle": "Aucun sprint daté",
  "roadmap.legendActive": "Actif",
  "roadmap.legendClosed": "Clôturé",
  "roadmap.legendPlanned": "Planifié",
  "roadmap.loading": "Chargement de la roadmap…",
  "roadmap.statusActive": "actif",
  "roadmap.statusClosed": "clôturé",
  "roadmap.statusPlanned": "planifié",
  "roadmap.title": "Roadmap",
  "roadmap.today": "aujourd'hui",
  "role.admin": "Administrateur de plateforme",
  "role.contributor": "Contributeur",
  "role.owner": "Propriétaire",
  "role.unknown": "Rôle inconnu",
  "role.viewer": "Lecteur",
  "role.auditor": "Auditrice/Auditeur",
  "role.orgAdmin": "Administratrice/Administrateur d’organisation",
  "runops.deployedToast": "Déploiement enregistré",
  "runops.deploymentPending": "Promotion en cours",
  "runops.deploymentPendingDetail": "Déploiement de {{release}} vers {{environment}}…",
  "runops.envCreate": "Déclarer",
  "runops.envCreatedToast": "Environnement déclaré",
  "runops.environments": "Environnements",
  "runops.envName": "Nom du palier",
  "runops.envNameAide": "Par exemple : dev, recette, production.",
  "runops.envRank": "Rang de promotion",
  "runops.envUrl": "Adresse du palier",
  "runops.envUrlAide": "Facultatif. Affichée à côté de la version en cours.",
  "runops.history": "Historique des déploiements",
  "runops.neverDeployed": "jamais déployée",
  "runops.newEnvironment": "Déclarer un palier",
  "runops.newEnvironmentTitle": "Déclarer un environnement",
  "runops.newRelease": "Créer une release",
  "runops.newReleaseTitle": "Créer une release",
  "runops.noDeployment": "Aucun déploiement enregistré.",
  "runops.noEnvironment": "Aucun environnement déclaré",
  "runops.noEnvironmentHelp": "Déclarez vos paliers (dev, recette, production) pour suivre ce qui tourne.",
  "runops.noRelease": "Aucune release",
  "runops.noReleaseHelp": "Une release associe une version à un commit précis — sans quoi elle ne serait pas traçable.",
  "runops.nothingDeployed": "Aucune version déployée",
  "runops.noWorkspaceHelp": "Choisissez d'abord un projet.",
  "runops.passedStages": "paliers franchis",
  "runops.rank": "rang",
  "runops.relCommit": "Commit d'origine",
  "runops.relCreate": "Créer",
  "runops.relCreatedToast": "Release créée",
  "runops.releases": "Releases",
  "runops.relNotes": "Notes de version",
  "runops.relVersion": "Version",
  "runops.relVersionAide": "Unique dans cet espace. Par exemple : 1.4.0.",
  "savedFilters.delete": "Supprimer",
  "savedFilters.nameLabel": "Nom du filtre à enregistrer",
  "savedFilters.namePlaceholder": "Nommer ce filtre",
  "savedFilters.save": "Enregistrer",
  "savedFilters.selectPlaceholder": "Filtres sauvegardés…",
  "scorecard.approvalRate": "Taux d'approbation",
  "scorecard.cycle": "Cycle time moy.",
  "scorecard.decided": "Décidées",
  "scorecard.delivery": "Livraison",
  "scorecard.desc": "Indicateurs de livraison, génération et gouvernance, calculés des données courantes.",
  "scorecard.done": "Terminés",
  "scorecard.failed": "Échoués",
  "scorecard.generatedAt": "Généré le",
  "scorecard.generation": "Génération IA",
  "scorecard.governance": "Gouvernance",
  "scorecard.items": "Items",
  "scorecard.jobs": "Jobs",
  "scorecard.latency": "Latence déc. moy.",
  "scorecard.loading": "Calcul des indicateurs…",
  "scorecard.met": "atteint",
  "scorecard.na": "n/a",
  "scorecard.noWs": "Aucun espace sélectionné",
  "scorecard.pending": "En attente",
  "scorecard.pickWs": "Choisissez un projet.",
  "scorecard.progress": "Avancement",
  "scorecard.slo": "Objectifs de service (SLI / SLO)",
  "scorecard.succeeded": "Réussis",
  "scorecard.successRate": "Taux de réussite",
  "scorecard.target": "cible",
  "scorecard.title": "Tableau de score KPI / SLI-SLO",
  "scorecard.unmet": "non atteint",
  "scorecard.value": "valeur",
  "shell.skipToContent": "Aller au contenu principal",
  "slo.actif": "actif",
  "slo.actifLibelle": "Objectif actif (mesuré lors d’un retour arrière compensatoire)",
  "slo.auMoins": "au moins (≥)",
  "slo.auPlus": "au plus (≤)",
  "slo.budgetIllisible": "Budget illisible : la passerelle n’a pas répondu.",
  "slo.catalogueReserve": "Le catalogue des objectifs (cible, sens, fenêtre) se lit par le propriétaire du projet ; le budget reste visible ci-dessous.",
  "slo.chargement": "Lecture des objectifs et du budget d’erreur…",
  "slo.cible": "Cible",
  "slo.cibleInvalide": "Donnez une cible numérique (ex. 0,95).",
  "slo.cle": "Identifiant de l’objectif",
  "slo.cleAide": "Aujourd’hui, seul generation_success_rate est mesuré par le runtime ; un autre objectif s’enregistre sans être mesuré.",
  "slo.cleInvalide": "Identifiant : minuscules, chiffres et _ (ex. generation_success_rate).",
  "slo.colActions": "actions",
  "slo.colCible": "cible",
  "slo.colConsomme": "consommé / total",
  "slo.colEtat": "état",
  "slo.colFenetre": "fenêtre",
  "slo.colIncidents": "incidents",
  "slo.colObjectif": "objectif",
  "slo.colRestant": "restant",
  "slo.dans": "dans le budget",
  "slo.derniereMesure": "Dernière mesure : {{quand}}",
  "slo.description": "La cible de chaque objectif du projet, sa fenêtre, et le budget d’erreur que consomment les incidents confirmés.",
  "slo.enregistre": "Objectif {{cle}} enregistré — version {{v}}.",
  "slo.enregistrer": "Enregistrer l’objectif",
  "slo.epuise": "épuisé",
  "slo.fenetreBudget": "budget mesuré sur {{f}}",
  "slo.fenetreInvalide": "La fenêtre est un nombre de minutes strictement positif.",
  "slo.fenetreMinutes": "Fenêtre (minutes)",
  "slo.formTitre": "Déclarer ou modifier un objectif",
  "slo.inactif": "inactif",
  "slo.jauge": "{{pct}} % du budget consommé",
  "slo.legende": "Objectifs de service du projet et leur budget d’erreur",
  "slo.modifier": "Modifier",
  "slo.nonMesure": "jamais mesuré",
  "slo.presque": "presque épuisé",
  "slo.regle": "Chaque incident SLO confirmé (retour arrière compensatoire, Environnements et déploiements) consomme sa part du budget de son objectif. Un budget épuisé avertit à la promotion en production ; il ne la bloque pas.",
  "slo.sansProjet": "Les objectifs de service appartiennent à un projet.",
  "slo.sens": "Sens",
  "slo.titre": "Objectifs de service",
  "slo.vide": "Aucun objectif de service",
  "slo.videIndice": "Budget intact : aucun objectif déclaré et aucun incident SLO sur ce projet.",
  "slo.voirIncidents": "Voir les déploiements et retours arrière",
  "sprints.avgVelocity": "Vélocité moyenne (sprints clôturés) :",
  "sprints.bandDone": "Terminé",
  "sprints.bandProgress": "En cours",
  "sprints.bandReview": "En revue",
  "sprints.bandTodo": "À faire",
  "sprints.burndown": "Burndown",
  "sprints.burndownAxisLabel": "Points restants dans le temps",
  "sprints.cancel": "Annuler",
  "sprints.cfdAxisLabel": "Items par statut, cumulés dans le temps",
  "sprints.createdToast": "Sprint créé",
  "sprints.createSprint": "Créer le sprint",
  "sprints.creating": "Création…",
  "sprints.cumulativeFlow": "Flux cumulé (items par statut dans le temps)",
  "sprints.description": "Planifiez des itérations, rangez-y des items, et suivez la vélocité — points engagés vs terminés.",
  "sprints.formEnd": "Fin",
  "sprints.formGoal": "Objectif",
  "sprints.formGoalAide": "Ce que ce sprint doit avoir prouvé à la fin.",
  "sprints.formName": "Nom du sprint",
  "sprints.formStart": "Début",
  "sprints.hideBurndown": "Masquer le burndown",
  "sprints.hideCumulativeFlow": "Masquer le flux cumulé",
  "sprints.hidePlanner": "Masquer la planification assistée",
  "sprints.items": "items",
  "sprints.legendIdeal": "Idéal",
  "sprints.legendRemaining": "Restant",
  "sprints.loading": "Chargement…",
  "sprints.loadingSprints": "Chargement des sprints…",
  "sprints.newSprint": "Nouveau sprint",
  "sprints.noHistoryHint": "Créez des items et changez leur statut : le flux se construit du journal des transitions.",
  "sprints.noHistoryTitle": "Pas encore d'historique",
  "sprints.noSprintHint": "Créez un sprint, puis rangez-y des stories depuis le board.",
  "sprints.noSprintTitle": "Aucun sprint",
  "sprints.planner": "Proposer un découpage en sprints (IA, vérifié par le runtime)",
  "sprints.pts": "pts",
  "sprints.ptsDone": "pts terminés",
  "sprints.statusActive": "Actif",
  "sprints.statusClosed": "Clôturé",
  "sprints.statusPlanned": "Planifié",
  "sprints.title": "Sprints",
  "state.empty": "Rien ici pour l'instant",
  "state.loading": "Chargement…",
  "state.retry": "Réessayer",
  "status.blocked": "Bloqué",
  "status.error": "En échec",
  "status.info": "Information",
  "status.pending": "En attente",
  "status.running": "En cours",
  "status.success": "Validé",
  "status.warning": "À revoir",
  "tableau.annoncePage": "Page {{page}} sur {{pages}}, {{n}} lignes affichées",
  "tableau.annonceTri": "Trié par {{colonne}}, ordre {{sens}}, {{n}} lignes",
  "tableau.annonceTriUne": "Trié par {{colonne}}, ordre {{sens}}, {{n}} ligne",
  "tableau.compteur": "{{n}} éléments",
  "tableau.compteurAucun": "Aucun élément",
  "tableau.compteurFiltre": "{{affiches}} sur {{total}} éléments",
  "tableau.compteurUn": "{{n}} élément",
  "tableau.ordreCroissant": "croissant",
  "tableau.ordreDecroissant": "décroissant",
  "tableau.pagePrecedente": "Page précédente",
  "tableau.pageSuivante": "Page suivante",
  "tableau.pageSur": "Page {{page}} sur {{pages}}",
  "tableau.paginationLabel": "Pagination du tableau",
  "tableau.rechercher": "Rechercher…",
  "tableau.rechercherDans": "Rechercher parmi les {{quoi}}…",
  "tableau.trierCroissant": "trier par ordre croissant",
  "tableau.trierDecroissant": "trier par ordre décroissant",
  "tableau.trierDefaut": "revenir à l’ordre par défaut",
  "taxonomy.attachedWork": "Travail rattaché (descendance comprise)",
  "taxonomy.axes": "Axes déclarés",
  "taxonomy.create": "Déclarer l’axe",
  "taxonomy.createdToast": "Axe créé",
  "taxonomy.description": "Le graphe de votre organisation — portefeuille, domaine, capacité, application. Un item se rattache à plusieurs axes : c'est ce qui permet l'analyse d'impact, la dé-duplication, et la composition d'une offre à partir des composants d'un domaine.",
  "taxonomy.items": "item(s)",
  "taxonomy.kind": "Nature",
  "taxonomy.name": "Nom",
  "taxonomy.namePlaceholder": "Ex. Sinistres",
  "taxonomy.nameRequired": "Le nom de l’axe est obligatoire.",
  "taxonomy.noAxis": "Aucun axe déclaré",
  "taxonomy.noAxisHint": "Déclarez vos portefeuilles, domaines et capacités pour y rattacher le travail.",
  "taxonomy.noParent": "— racine —",
  "taxonomy.nothingAttached": "Rien n’est rattaché à cet axe ni à sa descendance.",
  "taxonomy.parent": "Rattaché à",
  "taxonomy.pickAxis": "Choisissez un axe pour voir ce qui en dépend.",
  "taxonomy.title": "Axes de rattachement",
  "taxonomy.via": "via",
  "technical.toggle": "Détails techniques",
  "theme.dark": "Sombre",
  "theme.light": "Clair",
  "theme.system": "Système",
  "timeline.description": "L'activité de l'espace, tous jobs confondus, du plus récent au plus ancien.",
  "timeline.emptyHint": "Les événements des jobs de cet espace apparaîtront ici.",
  "timeline.emptyTitle": "Aucune activité",
  "timeline.eventApprovalRequested": "Approbation demandée",
  "timeline.eventArtifactDiscarded": "Artefact retiré (rejet)",
  "timeline.eventArtifactWritten": "Artefact écrit",
  "timeline.eventBacklogItemsInserted": "Backlog inséré en base",
  "timeline.eventChangeApplied": "Changement appliqué (worktree)",
  "timeline.eventChangeApplySkipped": "Application non activée",
  "timeline.eventCommitted": "Publié (commit)",
  "timeline.eventGenerationFinished": "Génération terminée",
  "timeline.eventGenerationStarted": "Génération démarrée",
  "timeline.eventJobClaimed": "Prise en charge par le worker",
  "timeline.eventJobDone": "Job terminé",
  "timeline.eventJobEnqueued": "Demande enregistrée",
  "timeline.eventJobFailed": "Échec",
  "timeline.eventPublicationBlocked": "Publication bloquée (dépendance)",
  "timeline.jobPrefix": "job",
  "timeline.loading": "Chargement de la timeline…",
  "timeline.title": "Chronologie",
  "trace.code": "Code",
  "trace.coverage": "Couverture",
  "trace.gapsOnly": "Afficher uniquement les trous",
  "trace.loading": "Analyse de la traçabilité…",
  "trace.quoi": "exigences",
  "trace.requirement": "Exigence",
  "trace.requirements": "Exigences",
  "trace.status": "Statut",
  "trace.tests": "Tests",
  "trace.type": "Type",
  "trace.withCode": "Avec code",
  "trace.withTests": "Avec tests",
  "traceLink.copied": "Copié",
  "traceLink.copyAction": "Copier",
  "traceLink.copyFailed": "Copie impossible",
  "tree.accept": "Accepter",
  "tree.acceptByOther": "modifié — à faire accepter par une autre personne",
  "tree.actions": "Actions",
  "tree.approvalsCenter": "Centre d'approbations",
  "tree.cancel": "Annuler",
  "tree.description": "La hiérarchie unifiée Epic → Feature → US → Tâche, augmentée par l'IA : générez les enfants de n'importe quel item, acceptez en séparation des tâches.",
  "tree.edit": "Éditer",
  "tree.editTitleLabel": "Titre",
  "tree.emptyHint": "Générez des epics depuis un cadrage approuvé, ou créez une story au board.",
  "tree.emptyTitle": "Aucun work item",
  "tree.generateChildren": "Générer les {{enfants}}",
  "tree.generateReadOnly": "Lecteur : générer est réservé aux contributeurs.",
  "tree.kindBug": "Bug",
  "tree.kindCadrage": "Cadrage",
  "tree.kindEpic": "Epic",
  "tree.kindFeature": "Feature",
  "tree.kindIdea": "Idée",
  "tree.kindStory": "US",
  "tree.kindTask": "Tâche",
  "tree.genStarted": "Génération lancée — les enfants apparaîtront ici après génération (à accepter).",
  "tree.loading": "Chargement de l'arbre…",
  "tree.prioCritical": "Critique",
  "tree.prioHigh": "Haute",
  "tree.prioLow": "Basse",
  "tree.prioMedium": "Moyenne",
  "tree.save": "Enregistrer",
  "tree.sodTooltip": "Séparation des tâches : cet item a été modifié depuis sa génération ; une autre personne que le générateur doit l'accepter",
  "tree.title": "Arbre des work items",
  "tree.toAccept": "à accepter",
  "user.menu": "Compte et préférences",
  "wi.kindBug": "Bug",
  "wi.kindCadrage": "Cadrage",
  "wi.kindEpic": "Epic",
  "wi.kindFeature": "Feature",
  "wi.kindIdea": "Idée",
  "wi.kindStory": "US",
  "wi.kindTask": "Tâche",
  "wi.prioCritical": "Critique",
  "wi.prioHigh": "Haute",
  "wi.prioLow": "Basse",
  "wi.prioMedium": "Moyenne",
  "wi.priority": "Priorité",
  "wi.status": "Statut",
  "wi.statusDone": "Terminé",
  "wi.statusInProgress": "En cours",
  "wi.statusInReview": "En revue",
  "wi.statusTodo": "À faire",
  "worker.active": "Worker actif",
  "worker.engine": "Moteur",
  "worker.inactive": "Service de génération en pause — réessayez dans un instant",
  "worker.processedNoun": "traités",
  "workflow.agentWorking": "L'agent travaille…",
  "workflow.annuler": "Annuler",
  "workflow.chargement": "Lecture des workflows du modèle…",
  "workflow.choose": "— choisir —",
  "workflow.consoleDescription": "Exécutez un agent sur l'espace actif et suivez sa trace et sa sortie.",
  "workflow.consoleTitle": "Console d'orchestration",
  "workflow.contraintes": "Contraintes (facultatif)",
  "workflow.declares": "Workflows déclarés par le modèle du projet",
  "workflow.declencheurPush": "déclencheur : push GitLab",
  "workflow.done": "Terminé",
  "workflow.duration": "Durée",
  "workflow.enterInstructionError": "Saisissez une instruction",
  "workflow.erreurLecture": "Les workflows du modèle n’ont pas pu être lus.",
  "workflow.etapes": "{{n}} étape(s) : {{chaine}}",
  "workflow.execute": "Exécuter",
  "workflow.executing": "Exécution en cours…",
  "workflow.executionLabel": "Exécution",
  "workflow.explication": "Un workflow enchaîne les étapes déclarées par le modèle du projet ; chacune produit un artefact à approuver, comme une action IA lancée seule. Il s’arrête à la première étape en échec.",
  "workflow.fichiers": "Fichiers sur lesquels le workflow peut travailler (obligatoire)",
  "workflow.fichiersAide": "Le workflow ne touche qu’à ce périmètre, étape après étape (séparés par des virgules).",
  "workflow.fichiersRequis": "Indiquez au moins un fichier : le workflow ne travaille que sur ce périmètre.",
  "workflow.instructionLabel": "Instruction",
  "workflow.instructionPlaceholder": "Rédige une user story pour l'ingestion de documents.",
  "workflow.lance": "Workflow « {{nom}} » lancé : chaque étape produit un artefact à approuver ; il s’arrête à la première étape en échec.",
  "workflow.lancer": "Lancer « {{nom}} »",
  "workflow.lancerSans": "Lancer",
  "workflow.loadingAgents": "Chargement des agents…",
  "workflow.motifPush": "Un workflow déclenché par un push GitLab ne se lance pas depuis une fiche.",
  "workflow.noExecutionHint": "Lancez un agent pour voir sa trace et sa sortie.",
  "workflow.noExecutionTitle": "Aucune exécution",
  "workflow.noWorkspaceError": "Aucun projet sélectionné",
  "workflow.output": "Sortie",
  "workflow.ouvrir": "Lancer un workflow…",
  "workflow.readOnly": "Lecture seule — votre rôle ne permet pas d'exécuter un agent.",
  "workflow.refusArret": "Arrêt de l’IA : les nouvelles requêtes IA sont interrompues ; le lancement attendra la levée.",
  "workflow.refusAucun": "Le modèle du projet ne déclare aucun workflow. Un administrateur les déclare dans Gabarits › Plateforme.",
  "workflow.refusAucunManuel": "Les workflows du modèle se déclenchent sur un push GitLab : aucun ne se lance depuis une fiche.",
  "workflow.refusLecteur": "Lecteur : les actions IA sont visibles mais réservées aux contributeurs du projet.",
  "workflow.resultTitle": "Résultat d'exécution",
  "workflow.noModelsTitle": "Aucun modèle autorisé dans cet espace",
  "workflow.noModelsHint": "Un propriétaire doit autoriser un modèle avant de lancer un agent.",
  "workflow.configureModels": "Configurer les modèles",
  "workflow.noModelsError": "Aucun modèle autorisé dans cet espace. Configurez les modèles avant de lancer un agent.",
  "workflow.runAgent": "Exécuter un agent",
  "workflow.selectAgentError": "Sélectionnez un agent",
  "workflow.startedToast": "Agent démarré",
  "workflow.titre": "Lancer un workflow sur {{ref}}",
  "workflow.tokensUsed": "Tokens consommés",
  "wsExport.buttonLabel": "Exporter l'espace (ZIP)",
  "wsExport.description": "Exporte les données de l'espace (items, décisions, commentaires, sprints, journal, pièces jointes) en une archive ZIP souveraine — assemblée localement.",
  "wsExport.pending": "Export…",
  "wsExport.title": "Portabilité de l'espace",
  "wsSwitch.empty": "Aucun espace",
  "wsSwitch.label": "Espace de travail",
  "wsSwitch.loading": "Chargement des espaces…",
  "wsSwitch.noneInProgram": "Aucun projet dans ce programme",
  "wsSwitch.showAll": "Voir tous les projets",
  "wsSwitch.unavailable": "Espaces indisponibles",
  "chat.observabilityPending": "Corrélation Langfuse en attente…",
  "chat.observabilityDegraded": "Appel IA terminé sans preuve de corrélation Langfuse — observabilité dégradée.",
  "tests.title": "Tests",
  "tests.description": "Concevez les cas de test, lancez des exécutions et conservez leurs résultats dans le temps.",
  "tests.noWorkspace": "Sélectionnez un projet",
  "tests.noWorkspaceHint": "Les cas et exécutions sont toujours rattachés à un projet.",
  "tests.readOnly": "Lecture seule — la création et la publication sont réservées aux contributeurs.",
  "tests.casesTitle": "Cas de test",
  "tests.newCase": "Nouveau cas de test",
  "tests.key": "Clé",
  "tests.name": "Nom",
  "tests.type": "Type",
  "tests.expected": "Résultat attendu",
  "tests.creating": "Création…",
  "tests.createCase": "Ajouter le cas",
  "tests.loadingCases": "Chargement des cas…",
  "tests.emptyCases": "Aucun cas de test",
  "tests.emptyCasesHint": "Ajoutez un cas ou générez-en depuis une exigence.",
  "tests.emptyCasesAction": "Le formulaire ci-dessus crée le premier cas.",
  "tests.select": "Sélectionner",
  "tests.runsTitle": "Exécutions",
  "tests.newRun": "Nouvelle exécution",
  "tests.runName": "Nom de l’exécution",
  "tests.runPlaceholder": "Régression sprint 12",
  "tests.startRun": "Démarrer",
  "tests.loadingRuns": "Chargement des exécutions…",
  "tests.emptyRuns": "Aucune exécution",
  "tests.emptyRunsHint": "Démarrez une exécution pour publier les résultats des cas sélectionnés.",
  "tests.emptyRunsAction": "Le formulaire ci-dessus démarre le premier run.",
  "tests.publishResult": "Publier un résultat",
  "tests.publishTitle": "Résultat du cas sélectionné",
  "tests.resultStatus": "Verdict",
  "tests.publishing": "Publication…",
  "tests.publish": "Publier le résultat",
  "tests.caseCreated": "Cas de test ajouté",
  "tests.runCreated": "Exécution démarrée",
  "tests.resultPublished": "Résultat publié",
  "backlog.testsImport": "Importer dans Tests",
  "backlog.testsImporting": "Import…",
  "backlog.testsImported": "Cas de test brouillons créés",
  "tests.planCreated": "Plan de test créé",
  "tests.caseAttached": "Cas rattaché au plan",
  "tests.campaignCreated": "Campagne ouverte",
  "tests.executionCreated": "Exécution et preuve enregistrées",
  "tests.campaignsTitle": "Plans et campagnes",
  "tests.newPlan": "Nouveau plan de test",
  "tests.planName": "Nom du plan",
  "tests.planPlaceholder": "Régression release 0.1",
  "tests.createPlan": "Créer le plan",
  "tests.loadingPlans": "Chargement des plans…",
  "tests.emptyPlans": "Aucun plan de test",
  "tests.emptyPlansHint": "Un plan regroupe les cas à exécuter ensemble.",
  "tests.emptyPlansAction": "Le formulaire ci-dessus crée le premier plan.",
  "tests.attachCase": "Rattacher le cas sélectionné",
  "tests.environment": "Environnement",
  "tests.chooseEnvironment": "Choisir…",
  "tests.createCampaign": "Ouvrir la campagne",
  "tests.openCampaigns": "Campagnes",
  "tests.evidenceForm": "Enregistrer une exécution avec preuve",
  "tests.evidenceOutput": "Sortie ou preuve",
  "tests.evidencePlaceholder": "Résumé de la sortie observée",
  "tests.executing": "Enregistrement…",
  "tests.recordExecution": "Enregistrer avec preuve",
  "tests.automatedStarted": "Exécution Docker démarrée",
  "tests.campaignExecutionStarted": "Exécutions Docker de la campagne démarrées",
  "tests.campaignStarting": "Mise en file…",
  "tests.executeCampaign": "Exécuter toute la campagne",
  "tests.campaignPolling": "Exécutions Docker en cours — actualisation automatique",
  "tests.executionDetails": "Détail des exécutions",
  "tests.noCampaignExecutions": "Aucune exécution pour le moment.",
  "tests.evidenceCount": "preuve(s)",
  "tests.statusRunning": "En cours",
  "tests.statusPassed": "Réussi",
  "tests.statusFailed": "Échoué",
  "tests.statusSkipped": "Ignoré",
  "tests.statusBlocked": "Bloqué",
  "tests.junitForm": "Importer un rapport JUnit",
  "tests.junitTitle": "Importer un rapport JUnit",
  "tests.junitHint": "Les noms des testcase doivent correspondre aux clés des cas de test. L’import clôture ce run.",
  "tests.junitXml": "Rapport XML",
  "tests.junitImporting": "Import…",
  "tests.junitImport": "Importer et clôturer",
  "tests.junitImported": "Rapport JUnit importé et exécution clôturée",
  "tests.junitRequired": "Collez un rapport JUnit XML avant de l’importer.",
  "tests.loadingResults": "Chargement des résultats…",
  "tests.resultsList": "Résultats du run",
  "tests.resultsTitle": "Résultats du run",
  "tests.noResults": "Aucun résultat reçu pour ce run.",
  "tests.executorAgent": "Automatisé",
  "tests.executorHuman": "Manuel",
  "tests.campaignStatusOpen": "Ouverte",
  "tests.campaignStatusClosed": "Fermée",
  "tests.campaignStatusCancelled": "Annulée",
  "tests.cancelReason": "Motif d’annulation",
  "tests.cancelReasonPlaceholder": "Motif obligatoire",
  "tests.cancelling": "Annulation…",
  "tests.cancelCampaign": "Annuler",
  "tests.campaignCancelled": "Campagne annulée",
  "deliveryOverview.title": "État de livraison",
  "deliveryOverview.description": "GitLab reste la source des branches et builds ; RunOps reste la source des environnements observés.",
  "deliveryOverview.source": "Source GitLab",
  "deliveryOverview.noWorkspace": "Sélectionnez un projet.",
  "deliveryOverview.loading": "Lecture…",
  "deliveryOverview.connectionError": "La connexion GitLab ne peut pas être vérifiée.",
  "deliveryOverview.notConfigured": "Non configuré",
  "deliveryOverview.branches": "branches",
  "deliveryOverview.branchesUnknown": "branches non vérifiées",
  "deliveryOverview.build": "Dernier build observé",
  "deliveryOverview.environments": "Environnements",
  "deliveryOverview.version": "Version",
  "deliveryOverview.signature": "Signature",
  "deliveryOverview.observationMissing": "Aucune version observée",
  "deliveryOverview.observedAt": "Observé",
  "deliveryOverview.openEnvironment": "Ouvrir",
  "deliveryOverview.unavailable": "Source indisponible",
  "deliveryOverview.none": "Aucune donnée observée",
  "deliveryOverview.release": "Release",
  "deliveryOverview.noRelease": "Aucune release observée",
  "deliveryOverview.lastDeployment": "Dernier déploiement",
  "deliveryOverview.noDeployment": "Aucun déploiement observé",
  "itemDeliveryProof.title": "Preuve de livraison",
  "itemDeliveryProof.description": "Relation observée entre cet item, GitLab et le dernier état CI connu.",
  "itemDeliveryProof.openCockpit": "Ouvrir le cockpit",
  "itemDeliveryProof.loading": "Lecture de la provenance…",
  "itemDeliveryProof.unavailable": "La provenance de cet item ne peut pas être vérifiée.",
  "itemDeliveryProof.notObserved": "Aucune preuve de commit observée",
  "itemDeliveryProof.notObservedHint": "Une MR ou un déploiement ne sera pas déduit du statut de l’item. Proposez une MR depuis les actions autorisées pour créer une preuve.",
  "itemDeliveryProof.observed": "Commit observé",
  "itemDeliveryProof.gitlabUnavailable": "GitLab est indisponible ; MR et pipeline non vérifiés.",
  "itemDeliveryProof.gitlabNotConfigured": "La connexion GitLab n’est pas configurée ; MR et pipeline non vérifiés.",
  "itemDeliveryProof.mergeRequest": "Merge request",
  "itemDeliveryProof.pipeline": "Pipeline",
  "itemDeliveryProof.checking": "Vérification…",
  "itemDeliveryProof.unavailableShort": "Indisponible",
  "itemDeliveryProof.notObservedShort": "Non observé pour cette branche",
  "itemDeliveryProof.jobs": "Jobs et logs",
  "itemDeliveryProof.noJobs": "Aucun job observé",
  "itemDeliveryProof.loadingLogs": "Lecture des logs…",
  "itemDeliveryProof.logsUnavailable": "Logs indisponibles",
  "itemDeliveryProof.runtime": "Release et environnement",
  "itemDeliveryProof.noRelease": "Aucune release observée pour ce commit",
  "itemDeliveryProof.release": "Release",
  "itemDeliveryProof.notDeployed": "Pas de déploiement observé pour cette release",
  "itemDeliveryProof.health": "Santé",
  "itemDeliveryProof.artifact": "Digest",
  "auditRoadmap.title": "Roadmap des recommandations d’audit",
  "auditRoadmap.description": "Un registre de décision qui relie chaque constat à une action, une discipline pilote, une gate, des dépendances et un critère de preuve.",
  "auditRoadmap.loading": "Chargement du registre d’audit…",
  "auditRoadmap.corpusLanguage": "Le corpus d’audit historique est versionné en français ; le chrome de navigation reste disponible en français et en anglais.",
  "auditRoadmap.disclaimerTitle": "Lecture honnête de l’audit",
  "auditRoadmap.disclaimer": "56 recommandations, 8 cycles et 28 indicateurs proviennent de la baseline d’audit versionnée. Un suivi n’est pas une preuve de livraison ; la cible 10/10 reste une trajectoire.",
  "auditRoadmap.summary": "Synthèse de la baseline d’audit",
  "auditRoadmap.baseline": "Baseline initiale",
  "auditRoadmap.baselineHint": "audit historique, pas état courant",
  "auditRoadmap.accessDeniedTitle": "Accès réservé à la gouvernance.",
  "auditRoadmap.accessDeniedDescription": "Votre rôle ne permet pas de consulter les constats internes et leur trajectoire de traitement.",
  "auditRoadmap.target": "Cible",
  "auditRoadmap.targetHint": "trajectoire, non atteinte",
  "auditRoadmap.p0": "P0 à protéger",
  "auditRoadmap.p0Hint": "gates prioritaires",
  "auditRoadmap.tracked": "Suivies",
  "auditRoadmap.trackedHint": "preuve à vérifier",
  "auditRoadmap.activeCycle": "Recommandations du cycle actif",
  "auditRoadmap.activeCycleHint": "cycle C01",
  "auditRoadmap.criticalPath": "Couverture par work item et par cycle",
  "auditRoadmap.criticalPathHint": "Chaque barre mesure seulement le raccordement à un work item. Sélectionnez un cycle pour filtrer.",
  "auditRoadmap.cycleActive": "Actif",
  "auditRoadmap.cycleConditional": "Conditionnel",
  "auditRoadmap.cycleOption": "Optionnel",
  "auditRoadmap.cyclePlanned": "Planifié",
  "auditRoadmap.cycleProgress": "Recommandations reliées à un work item",
  "auditRoadmap.noProofInferred": "aucune preuve déduite",
  "auditRoadmap.filters": "Filtres des recommandations",
  "auditRoadmap.search": "Rechercher dans les recommandations",
  "auditRoadmap.searchPlaceholder": "ID, constat, action ou work item…",
  "auditRoadmap.priority": "Priorité",
  "auditRoadmap.allPriorities": "Toutes",
  "auditRoadmap.cycle": "Cycle",
  "auditRoadmap.allCycles": "Tous",
  "auditRoadmap.tracking": "Suivi",
  "auditRoadmap.allTracking": "Tous",
  "auditRoadmap.withWorkItem": "Avec work item",
  "auditRoadmap.withoutWorkItem": "Sans work item",
  "auditRoadmap.reset": "Réinitialiser",
  "auditRoadmap.listTitle": "Registre actionnable des recommandations",
  "auditRoadmap.resultCount": "Résultats visibles :",
  "auditRoadmap.colRecommendation": "Recommandation",
  "auditRoadmap.colFinding": "Constat / action",
  "auditRoadmap.colGovernance": "Pilotage",
  "auditRoadmap.tableRegion": "Tableau des recommandations",
  "auditRoadmap.proofLabel": "Preuve",
  "auditRoadmap.detail": "Détail",
  "auditRoadmap.open": "Ouvrir",
  "auditRoadmap.openDetail": "Ouvrir le détail",
  "auditRoadmap.noResults": "Aucune recommandation ne correspond aux filtres.",
  "auditRoadmap.trackingReview": "Suivi · preuve à vérifier",
  "auditRoadmap.trackingFrame": "À cadrer",
  "auditRoadmap.trackingPlanned": "Planifiée",
  "auditRoadmap.detailDisclaimer": "Une recommandation d’audit est un objectif à réaliser. Cet écran ne la transforme pas en capacité livrée.",
  "auditRoadmap.finding": "Constat d’audit",
  "auditRoadmap.action": "Action recommandée",
  "auditRoadmap.owner": "Discipline pilote",
  "auditRoadmap.gate": "Gate",
  "auditRoadmap.milestone": "Jalon",
  "auditRoadmap.effort": "Effort indicatif",
  "auditRoadmap.value": "Valeur",
  "auditRoadmap.risk": "Risque si non traité",
  "auditRoadmap.dependencies": "Dépendances",
  "auditRoadmap.noDependencies": "Aucune dépendance explicite dans le manifeste.",
  "auditRoadmap.acceptance": "Critère d’acceptation",
  "auditRoadmap.workItems": "Travail concret",
  "auditRoadmap.linkedCountLabel": "Références liées :",
  "auditRoadmap.workItemCount": "Work items liés :",
  "auditRoadmap.filterByWorkItem": "Filtrer la roadmap par work item",
  "auditRoadmap.noWorkItem": "Aucun work item n’est encore raccordé à cette recommandation.",
  "auditRoadmap.sourceBoundary": "Source d’analyse : audit_codex. La baseline normative active reste docs/doit-specification/ ; les preuves d’implémentation vivent dans le registre d’exécution.",
  "auditRoadmap.footerSource": "Source d’analyse : roadmap_manifest.json et 09_recommandations_et_backlog.md. Référence normative active : docs/doit-specification/.",
  "nav./audit-roadmap": "Recommandations d’audit",
  "navdesc./audit-roadmap": "Recommandations d’audit, cycles, work items et niveau de preuve",
  "runops.actionsCompensation": "Cette ligne est une compensation : aucune nouvelle action implicite.",
  "runops.actionsFor": "Actions pour",
  "runops.actionsNotSucceeded": "Les actions sont disponibles uniquement après un déploiement réussi.",
  "runops.actionsReadOnly": "Consultation en lecture seule : aucune action de déploiement disponible.",
  "runops.actionsRollbackActive": "Le cycle de rollback doit atteindre un état terminal avant toute autre action.",
  "runops.actionsRollbackFailed": "Rollback en échec : seul un redeploy ou une nouvelle publication contrôlée est disponible.",
  "runops.actionsRolledBack": "Cette cible a été restaurée et ne propose plus d’action directe.",
  "runops.backupTitle": "Continuité et sauvegardes",
  "runops.compensatedBy": "Compensé par",
  "runops.composePipeline": "Publier + CI",
  "runops.composePipelineTriggered": "Pipeline Compose déclenché",
  "runops.confirmSloRollback": "Déclencher le rollback avec preuve SLO",
  "runops.deployedBy": "Déployé par",
  "runops.description": "Ce qui tourne, où, et depuis quel code. Une release franchit les paliers dans l’ordre.",
  "runops.executionDetails": "Détails d’exécution",
  "runops.finishedAt": "Terminé",
  "runops.operationRedeploy": "Redeploy",
  "runops.operationRollback": "Rollback compensatoire",
  "runops.pipelineChoose": "Aucun pipeline sélectionné",
  "runops.pipelineId": "Pipeline GitLab (optionnel)",
  "runops.pipelineIdHelp": "Seuls les pipelines réussis de ce commit sont proposés.",
  "runops.pipelineIdInvalid": "Le pipeline GitLab sélectionné n’est pas éligible pour ce commit.",
  "runops.pipelineLoading": "Chargement des pipelines GitLab…",
  "runops.pipelineNoneForCommit": "Aucun pipeline réussi pour ce commit.",
  "runops.pollingInterrupted": "Suivi automatique interrompu",
  "runops.pollingInterruptedDetail": "Le dernier état persistant est conservé. Actualisez manuellement pour obtenir l’état le plus récent.",
  "runops.provenance": "Provenance",
  "runops.redeploy": "Redéployer",
  "runops.redeployAuditConsequence": "Un nouveau déploiement sera enregistré avec une clé d’idempotence.",
  "runops.redeployConfirm": "Lancer le redeploy",
  "runops.redeployConsequence": "La version {{version}} sera relancée sur {{environment}}.",
  "runops.redeployQueued": "Redeploy lancé",
  "runops.redeployReversibility": "Un rollback restera disponible si la nouvelle exécution échoue.",
  "runops.redeployTitle": "Redéployer cette version ?",
  "runops.refreshStatus": "Actualiser le statut",
  "runops.rollback": "Rollback",
  "runops.rollbackAlreadyTerminal": "Ce rollback est déjà terminé. Actualisez l’historique pour consulter son état persistant.",
  "runops.rollbackAuditConsequence": "L’opération, ses commits et ses preuves d’artefact seront enregistrés dans l’audit RunOps.",
  "runops.rollbackCompensationConsequence": "Une compensation distincte sera créée ; le déploiement courant restera dans l’historique.",
  "runops.rollbackConfirm": "Lancer le rollback",
  "runops.rollbackConsequence": "Le palier {{environment}} sera replacé sur la version précédente connue.",
  "runops.rollbackCycle": "Cycle rollback",
  "runops.rollbackFinishedAt": "Cycle terminé",
  "runops.rollbackOf": "Rollback de",
  "runops.rollbackPlanConsequence": "Le palier {{environment}} passera de {{currentVersion}} (commit {{currentCommit}}) à {{previousVersion}} (commit {{previousCommit}}).",
  "runops.rollbackPlanMissing": "Le serveur n’a pas fourni de plan de rollback confirmable. Actualisez puis réessayez.",
  "runops.rollbackPreviewFailed": "Impossible de prévisualiser le rollback. Actualisez puis réessayez.",
  "runops.rollbackPreviewLoading": "Prévisualisation…",
  "runops.rollbackPreviewLoadingDetail": "Chargement du plan de rollback",
  "runops.rollbackQueued": "Rollback lancé",
  "runops.rollbackReversibility": "Une nouvelle promotion sera nécessaire pour revenir à {{version}}.",
  "runops.rollbackTitle": "Revenir à une version précédente ?",
  "runops.sloFieldsRequired": "Renseignez le SLO, le motif, la valeur observée et le seuil avant de continuer.",
  "runops.sloKey": "SLO",
  "runops.sloObserved": "Valeur observée",
  "runops.sloReason": "Motif",
  "runops.sloRollback": "Rollback SLO",
  "runops.sloRollbackQueued": "Rollback SLO lancé",
  "runops.sloThreshold": "Seuil",
  "runops.startedAt": "Démarré",
  "runops.statusRolledBack": "Restauré",
  "runops.provenanceWorker": "Preuve : exécution du worker",
  "runops.provenanceManual": "Déclaré manuellement",
  "runops.deliverySucceeded": "Pipeline GitLab réussi, exécution du worker en attente",
  "runops.deliveryFailed": "Pipeline GitLab en échec",
  "runops.deliveryInProgress": "Pipeline GitLab en cours",
  "runops.deliveryUnknown": "État du pipeline GitLab inconnu",
  "runops.correlation": "Corrélation",
  "common.close": "Fermer",
  "nav./projet": "Vue projet",
  "navdesc./projet": "Santé, cycle, équipe, missions et prochaine action du projet",
  "nav./taxonomy": "Axes de portefeuille",
  "navdesc./taxonomy": "Portefeuille, domaine, capacité — le travail qui s’y rattache et la santé répartie par axe",
  "nav./tests": "Tests",
  "navdesc./tests": "Cas, plans, non-régression, campagnes et résultats",
  "nav./delivery": "Cockpit de livraison",
  "navdesc./delivery": "Déploiements et pipelines en cours",
  "nav./runops": "Environnements et déploiements",
  "navdesc./runops": "Environnements, déploiements, retour arrière, budget d’erreur et continuité",
  "nav./runops?vue=slo": "Objectifs de service",
  "navdesc./runops?vue=slo": "Cible, fenêtre et budget d’erreur de chaque objectif de service du projet",
  "projet.vue.processus": "Cycle et processus",
  "admin.section.plateformes": "Plateformes IA",
  "admin.section.sante": "Santé plateforme",
  "config.onglet.processus": "Processus",
  "nav./hitl-cockpit": "Délais de décision",
  "navdesc./hitl-cockpit": "Toutes les décisions humaines en attente, triées par ancienneté, et leur temps de décision",
  "hitl.announceApproved": "Décision approuvée.",
  "hitl.announceRejected": "Décision rejetée.",
  "hitl.approve": "Approuver",
  "hitl.execution.titre": "Exécution d’outil IA en attente de décision",
  "hitl.execution.chargement": "Lecture de la décision en attente…",
  "hitl.execution.decidee": "Décision enregistrée : cette exécution n’attend plus de décision.",
  "hitl.execution.absente": "Cette exécution d’outil IA n’attend pas de décision dans ce projet (déjà décidée, ou introuvable).",
  "hitl.execution.outil": "Outil proposé",
  "hitl.execution.auteur": "Vous avez proposé cette exécution : une autre personne du projet la décide (séparation des tâches).",
  "hitl.execution.lectureSeule": "Votre rôle dans ce projet permet de lire cette demande, pas de la décider.",
  "hitl.cancel": "Annuler",
  "hitl.colAction": "Action",
  "hitl.colKind": "Type",
  "hitl.colWaiting": "En attente depuis",
  "hitl.colWhat": "Quoi",
  "hitl.colWho": "Qui",
  "hitl.colWhy": "Pourquoi",
  "hitl.confirmReject": "Confirmer le rejet",
  "hitl.durationHoursMinutes": "{{h}} h {{m}} min",
  "hitl.durationMinutes": "{{n}} min",
  "hitl.durationSeconds": "{{n}} s",
  "hitl.emptyHint": "La file du jour est vide : rien n’attend votre décision pour cet espace.",
  "hitl.emptyTitle": "Aucune décision en attente",
  "hitl.kindAiToolExecution": "Exécution d’outil IA",
  "hitl.kindApproval": "Approbation",
  "hitl.loading": "Chargement de la file…",
  "hitl.metricsEmpty": "Aucune décision posée sur cette fenêtre — rien à mesurer.",
  "hitl.metricsLoading": "Calcul en cours…",
  "hitl.metricsP50": "p50",
  "hitl.metricsP95": "p95",
  "hitl.metricsSampleCount": "Décisions mesurées",
  "hitl.metricsTitle": "Temps de décision",
  "hitl.metricsWindow": "Fenêtre",
  "hitl.metricsWindowDays": "{{n}} j",
  "hitl.pageDescription": "Toutes les décisions humaines en attente — approbations et exécutions d’outils IA — triées par ancienneté.",
  "hitl.pageTitle": "Cockpit HITL quotidien",
  "hitl.reject": "Rejeter",
  "hitl.rejectReasonLabel": "Motif du rejet",
  "hitl.rejectReasonRequired": "Un rejet exige un motif.",
  "hitl.tableCaption": "Décisions en attente, triées de la plus ancienne à la plus récente",
  "hitl.platformAdminOnly": "Décision réservée à l’administrateur plateforme",
  "etat.loading": "Chargement…",
  "etat.pending": "En attente",
  "etat.processing": "En cours",
  "etat.workerLost": "Worker perdu",
  "etat.failed": "Échec",
  "etat.timeout": "Délai dépassé",
  "etat.done": "Terminé",
  "etat.workerLostHint": "Le worker qui exécutait ce job a cessé de répondre. Vous pouvez le relancer.",
  "etat.workerLostHintLectureSeule": "Le worker qui exécutait ce job a cessé de répondre. Un responsable de l'espace peut le relancer.",
  "etat.relancer": "Relancer",
  "etat.relanceEnCours": "Relance…",
  "etat.relanceRefusee": "Votre rôle ne permet pas de relancer ce job.",
  "quota.unlimited": "Illimité",
  "quota.atLimit": "Quota atteint",
  "quota.atWarning": "Quota bientôt atteint",
  "quota.noWorkspace": "Sélectionnez un espace.",
  "quota.loading": "Chargement des quotas…",
  "quota.none": "Aucun quota configuré.",
  "quota.resourcesTitle": "Quotas d'espace",
  "quota.aiModelsTitle": "Quota d'appels IA (par organisation)",
  "quota.tabTitle": "Quotas",
  "quota.resource.requests_per_minute": "Requêtes par minute",
  "quota.resource.tokens_per_day": "Jetons par jour",
  "quota.resource.documents_count": "Documents de connaissance",
  "quota.resource.document_size_mb": "Taille des documents (Mio)",
  "quota.plan.title": "Palier de l'organisation",
  "quota.plan.loading": "Chargement du palier…",
  "quota.plan.noOrganisation": "Aucune organisation active.",
  "quota.plan.aiCallsPerDay": "Appels IA par jour",
  "quota.plan.free": "Free",
  "quota.plan.team": "Team",
  "quota.plan.enterprise": "Enterprise",
  "quota.plan.limiteCatalogue": "Limites du palier (non appliquées)",
  "quota.plan.limiteEffective": "Limites effectives",
  "quota.plan.limiteIllimitee": "illimitée (aucun quota appliqué)",
  "quota.piedAide": "Le quota du projet ouvert le plus proche de sa limite (documents, jetons, appels IA…) ; cliquez pour voir tous les quotas du projet.",
  "quota.piedContexte": "Quota du projet ouvert",
  "admin.section.organisations": "Organisations",
  "admin.organisationsTitle": "Organisations",
  "admin.organisationsDescription": "Provisionner une nouvelle organisation pour un compte déjà créé dans Keycloak, qui en devient propriétaire.",
  "org.admin.createButton": "Provisionner une organisation",
  "org.admin.createTitle": "Provisionner une organisation",
  "org.admin.createDescription": "Le compte désigné ci-dessous — déjà créé dans Keycloak — deviendra propriétaire ; un espace principal sera créé automatiquement.",
  "org.admin.ownerEmail": "Email du propriétaire (compte Keycloak existant)",
  "org.admin.submit": "Provisionner",
  "org.admin.createdToast": "Organisation provisionnée",
  "accueil.sansEspaceHint": "Demandez une invitation à un propriétaire d’espace : vous verrez alors ses projets ici.",
  "accueil.sansEspaceTitre": "Aucun espace ne vous est attribué",
  "admin.sansEspaceDescription": "Les sections liées à un espace (membres, quotas, modèles) exigent d'en être membre : demandez une invitation à un propriétaire, ou créez un espace depuis le sélecteur.",
  "admin.sansEspaceTitre": "Vous administrez la plateforme ; aucun espace ne vous est attribué.",
  "contexte.aucunEspaceAttribue": "Aucun espace ne vous est attribué — demandez une invitation.",
  "wsSwitch.noneAssigned": "Aucun espace ne vous est attribué — demandez une invitation.",
  "anomalies.form.titleRequired": "Donnez un titre à l’anomalie : ce qui ne va pas, en une phrase.",
  "anomalies.form.fromExecution": "Déclarer une anomalie depuis l’exécution",
  "anomalies.form.human": "Déclarer une anomalie",
  "anomalies.form.prefilledFrom": "Pré-rempli depuis l’exécution #{{execution}} du cas {{key}} · {{name}}",
  "anomalies.field.title": "Titre",
  "anomalies.form.possibleDuplicates": "Anomalies proches déjà déclarées",
  "anomalies.similarity": "similarité {{score}}",
  "anomalies.field.severity": "Sévérité (impact)",
  "anomalies.field.priority": "Priorité (urgence)",
  "anomalies.field.steps": "Étapes pour reproduire",
  "anomalies.field.expected": "Attendu",
  "anomalies.field.actual": "Obtenu",
  "anomalies.field.version": "Version concernée",
  "anomalies.field.environment": "Environnement",
  "anomalies.field.requirement": "Exigence violée",
  "anomalies.field.evidence": "Preuve (exécution, capture, journal)",
  "anomalies.form.creating": "Création…",
  "anomalies.form.create": "Créer l’anomalie",
  "anomalies.form.cancel": "Annuler",
  "anomalies.rerun.none": "Aucune campagne ouverte pour rejouer ce cas.",
  "anomalies.rerun.started": "Reproduction lancée — la vérification s’ouvrira dès qu’elle sera verte",
  "anomalies.loadingDetail": "Chargement de l’anomalie…",
  "anomalies.form.resolutionRequired": "Indiquez la référence du correctif (commit, demande de fusion, « Fixes {{ref}} »).",
  "anomalies.form.verificationRequired": "Choisissez l’exécution verte qui vérifie la correction.",
  "anomalies.form.closureRequired": "Indiquez la preuve de livraison (version, release, note).",
  "anomalies.form.duplicateRequired": "Choisissez l’anomalie d’origine.",
  "anomalies.form.reasonRequired": "Écrivez le motif de cette décision.",
  "anomalies.field.description": "Description",
  "anomalies.lifecycle": "Cycle de vie",
  "anomalies.stepDone": "franchie",
  "anomalies.badge.state": "état : {{v}}",
  "anomalies.badge.severity": "sévérité : {{v}}",
  "anomalies.badge.priority": "priorité : {{v}}",
  "anomalies.badge.version": "version : {{v}}",
  "anomalies.badge.requirement": "exigence : {{v}}",
  "anomalies.badge.failureClass": "échec : {{v}}",
  "anomalies.field.reportedBy": "Déclarée par",
  "anomalies.field.resolution": "Correctif",
  "anomalies.field.verifiedBy": "Vérifiée par",
  "anomalies.field.duplicateOf": "Doublon de",
  "anomalies.duplicates.title": "Doublons possibles",
  "anomalies.duplicates.hint": "Proposés par similarité de texte ; seul un humain marque un doublon.",
  "anomalies.duplicates.sameCase": "même cas de test",
  "anomalies.duplicates.mark": "Marquer doublon de {{ref}}",
  "anomalies.verify.title": "Vérifier puis fermer",
  "anomalies.verify.none": "Aucune exécution verte du cas de reproduction depuis la résolution.",
  "anomalies.verify.some": "{{n}} exécution(s) verte(s) disponible(s) pour vérifier.",
  "anomalies.rerun.starting": "Mise en file…",
  "anomalies.rerun.action": "Exécuter la reproduction",
  "anomalies.rerun.closed": "La campagne d’origine n’est plus ouverte : rejouez le cas dans une nouvelle campagne (écran Tests).",
  "anomalies.rerun.recette": "Reproduction automatique impossible : ce cas vient d’une recette métier, qu’une personne rejoue. Rejouez-le dans la campagne de recette (écran Tests ou Recette), puis vérifiez.",
  "anomalies.rerun.polling": "Exécution en cours — actualisation automatique.",
  "anomalies.actions": "Actions",
  "anomalies.noAction": "Aucune transition depuis cet état.",
  "anomalies.field.failureClass": "Classement de l’échec",
  "anomalies.field.resolutionRef": "Référence du correctif",
  "anomalies.field.verificationExecution": "Exécution verte qui vérifie",
  "anomalies.field.closureEvidence": "Preuve de livraison",
  "anomalies.duplicates.target": "Doublon de ANO-{{id}}",
  "anomalies.field.reason": "Motif",
  "anomalies.form.confirm": "Confirmer : {{action}}",
  "anomalies.executions": "Exécutions reliées",
  "anomalies.noExecution": "Aucune exécution reliée.",
  "anomalies.link.origin": "origine",
  "anomalies.link.verification": "vérification",
  "anomalies.history": "Historique des transitions",
  "anomalies.noWorkspace": "Sélectionnez un projet",
  "anomalies.noWorkspaceHint": "Les anomalies sont toujours rattachées à un projet.",
  "anomalies.title": "Anomalies",
  "anomalies.description": "Déclarer, trier, corriger, vérifier puis fermer — chaque étape avec sa preuve.",
  "anomalies.declare": "Déclarer une anomalie",
  "tests.requiredContributor": "Contributeur",
  "anomalies.listTitle": "Anomalies du projet",
  "anomalies.filters": "Filtres",
  "anomalies.filter.state": "État",
  "anomalies.filter.all": "Tous",
  "anomalies.filter.severity": "Sévérité",
  "anomalies.filter.version": "Version",
  "anomalies.loading": "Chargement des anomalies…",
  "anomalies.empty": "Aucune anomalie",
  "anomalies.emptyFiltered": "Aucune anomalie ne correspond à ces filtres.",
  "anomalies.emptyHint": "Une exécution rouge de l’écran Tests se déclare en anomalie en deux gestes.",
  "anomalies.detailTitle": "Détail",
  "anomalies.pick": "Choisissez une anomalie dans la liste.",
  "tests.rerunStarted": "Cas relancé — son dernier verdict fera foi",
  "tests.superseded": "remplacée par une exécution plus récente",
  "tests.defectLink": "Anomalie ANO-{{id}}",
  "tests.defectLinked": "Bug lié",
  "tests.declareDefect": "Déclarer une anomalie",
  "tests.rerunCase": "Relancer le cas",
  "anomalies.refusal.role": "Réservé aux contributeurs et propriétaires de l’espace.",
  "anomalies.refusal.triage": "Classez d’abord l’échec (produit, test, environnement ou instable) : triez l’anomalie.",
  "anomalies.refusal.fixCommitUnknown": "La référence du correctif ne cite aucun commit ni aucune révision enregistrés par le pipeline : rien ne relie une exécution verte au correctif. Rouvrez l’anomalie puis résolvez-la en citant le SHA du commit livré (7 caractères au moins) ou l’identifiant de la révision qui le contient.",
  "anomalies.refusal.fixNotAttested": "Le commit du correctif est absent du registre du pipeline pour ce projet : livrez-le par une mission, une publication ou « Construire et signer la révision », puis vérifiez.",
  "anomalies.refusal.executionRevisionUnknown": "L’exécution verte ne dit pas sur quelle révision elle a tourné : rejouez le cas dans une campagne ouverte sur une révision (ou liée à une version qui en retient une).",
  "anomalies.refusal.executionRevisionNotAttested": "La révision exécutée n’est pas attestée par le pipeline (ni image enregistrée ni lignée) : une révision déclarée ne prouve rien.",
  "anomalies.refusal.unknown": "Étape refusée par le serveur (code {{code}}).",
  "anomalies.verify.greensRefused": "{{n}} exécution(s) verte(s) du cas de reproduction, mais aucune ne vérifie ce correctif :",
  "anomalies.field.resolutionRefHint": "Pour pouvoir vérifier, citez le SHA du commit livré (7 caractères au moins) ou l’identifiant de la révision qui le contient : la vérification relie l’exécution verte au correctif par le registre du pipeline.",
  "anomalies.field.testCase": "Cas de recette dont elle est née (facultatif)",
  "anomalies.field.testCaseHelp": "Le cas exécuté « pas conforme » : il définit ce que la vérification exigera, et son test validé servira tel quel à la correction.",
  "anomalies.field.testCaseNone": "Aucun cas",
  "erreurs.code.SPEC_GATE_REQUIRED": "Preuve de spécification requise : la spécification source n’a pas de preuve Spec Gate courante (le reçu attesté expire 24 h après son évaluation). Ouvrez la spécification dans le Centre d’approbations, cliquez « Réévaluer la preuve », puis, la preuve PASS obtenue, « Rattacher la preuve renouvelée » (par un propriétaire ou contributeur autre que l’auteur). Si la spécification n’est pas encore approuvée, faites-la d’abord approuver. Pour un élément de backlog sans spécification source, rattachez-le à une spécification publiée.",
  "erreurs.code.SPEC_GATE_RENEWAL_SELF_REFUSED": "Vous avez demandé cette spécification : un autre propriétaire ou contributeur doit attester sa preuve renouvelée.",
  "erreurs.code.SPEC_GATE_RENEWAL_APPROVAL_NOT_APPROVED": "Seule une spécification approuvée peut voir sa preuve renouvelée ; une demande en attente se décide avec sa preuve courante.",
  "erreurs.code.SPEC_GATE_RENEWAL_APPROVAL_SUPERSEDED": "Cette version de la spécification a été remplacée : sa preuve ne peut plus être renouvelée. Travaillez sur la version courante.",
  "erreurs.code.SPEC_GATE_RENEWAL_PUBLICATION_IN_PROGRESS": "La spécification est en cours de publication : réessayez le rattachement une fois la publication terminée.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_NOT_FOUND": "Reçu Spec Gate introuvable : relancez « Réévaluer la preuve » puis rattachez le reçu obtenu.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_OTHER_SPECIFICATION": "Ce reçu évalue une autre spécification ou une autre version : seul un reçu du contenu exact approuvé peut être rattaché.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_NOT_PASS": "Ce reçu n’est pas un PASS courant (13/13 contrôles ancrés, aucun bloquant, carte et politique courantes) : il ne peut pas être rattaché.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_EXPIRED": "Ce reçu a lui aussi expiré : relancez « Réévaluer la preuve » pour en obtenir un frais.",
  "erreurs.code.SPEC_GATE_RENEWAL_BUNDLE_MISMATCH": "Le bundle attesté n’est pas celui de ce reçu : rechargez la preuve affichée et attestez-la de nouveau.",
  "erreurs.code.SPEC_GATE_RENEWAL_ALREADY_CURRENT": "Ce reçu est déjà la preuve épinglée de la spécification : rien à rattacher.",
  "erreurs.code.SPEC_GATE_RENEWAL_CONFLICT": "La spécification a changé pendant le rattachement : rechargez l’écran et réessayez.",
  "anomalies.refusal.green": "Aucune exécution verte du cas de reproduction depuis la résolution : exécutez la reproduction.",
  "anomalies.refusal.sod": "Vous avez résolu cette anomalie : la vérification revient à une autre personne.",
  "anomalies.refusal.order": "Cette étape n’est pas atteignable depuis l’état actuel.",
  "tests.versionPublished": "Version du plan publiée",
  "tests.planArchived": "Plan archivé",
  "tests.campaignClosed": "Campagne clôturée",
  "tests.planVersion": "Version du plan",
  "tests.currentPlan": "Plan courant (non versionné)",
  "tests.publishingVersion": "Publication…",
  "tests.publishVersion": "Publier une version",
  "tests.archiving": "Archivage…",
  "tests.archivePlan": "Archiver",
  "tests.release": "Release certifiée",
  "tests.noRelease": "Aucune (campagne libre)",
  "tests.archivedPlanCampaignBlocked": "Plan archivé — aucune nouvelle campagne ne peut être ouverte. Les campagnes existantes restent consultables.",
  "tests.coverage": "Couverture de campagne",
  "tests.closing": "Clôture…",
  "tests.closeCampaign": "Clôturer",
  "tests.automatedStarting": "Démarrage…",
  "tests.executeDocker": "Exécuter dans Docker",
  "anomalies.state.new": "nouvelle",
  "anomalies.state.triaged": "triée",
  "anomalies.state.in_progress": "en cours",
  "anomalies.state.resolved": "résolue",
  "anomalies.state.verified": "vérifiée",
  "anomalies.state.closed": "fermée",
  "anomalies.state.duplicate": "doublon",
  "anomalies.state.rejected": "rejetée",
  "anomalies.state.not_reproducible": "non reproductible",
  "anomalies.state.reopened": "rouverte",
  "anomalies.severity.blocker": "bloquante",
  "anomalies.severity.major": "majeure",
  "anomalies.severity.minor": "mineure",
  "anomalies.severity.cosmetic": "cosmétique",
  "anomalies.priority.critical": "critique",
  "anomalies.priority.high": "haute",
  "anomalies.priority.medium": "moyenne",
  "anomalies.priority.low": "basse",
  "anomalies.failureClass.product": "produit",
  "anomalies.failureClass.test": "test",
  "anomalies.failureClass.environment": "environnement",
  "anomalies.failureClass.flaky": "instable",
  "anomalies.source.execution": "exécution de test",
  "anomalies.source.preview_annotation": "annotation d’aperçu",
  "anomalies.source.review": "verdict de revue",
  "anomalies.source.verifier": "vérificatrice",
  "anomalies.source.human": "déclaration humaine",
  "anomalies.action.new": "Déclarer",
  "anomalies.action.triaged": "Trier",
  "anomalies.action.in_progress": "Prendre en charge",
  "anomalies.action.resolved": "Marquer résolue",
  "anomalies.action.verified": "Marquer vérifiée",
  "anomalies.action.closed": "Fermer",
  "anomalies.action.duplicate": "Marquer doublon",
  "anomalies.action.rejected": "Rejeter",
  "anomalies.action.not_reproducible": "Non reproductible",
  "anomalies.action.reopened": "Rouvrir",
  "nav./anomalies": "Anomalies",
  "navdesc./anomalies": "Déclarer, trier, corriger, vérifier puis fermer chaque anomalie avec sa preuve",
  "adr.card.chosenOption": "Option retenue",
  "adr.card.comment": "Commentaire",
  "adr.card.decideRequired": "Choisissez l'option retenue et écrivez la décision.",
  "adr.card.g4": "porte G4 : au moins 3 options",
  "adr.card.oneWay": "décision à sens unique : triangle obligatoire",
  "adr.card.requestApproval": "Demander l'approbation",
  "adr.card.review": "Relire",
  "adr.card.reviewJustify": "Une revue se justifie.",
  "adr.card.reviewedBy": "Relue par {{who}} — {{verdict}}",
  "adr.card.save": "Enregistrer",
  "adr.card.submitDecision": "Décider",
  "adr.card.submitReview": "Enregistrer la revue",
  "adr.card.supersede": "Remplacer une ADR",
  "adr.card.twoPerson": "décidée en mode deux personnes",
  "adr.caste.badge": "AVIS",
  "adr.caste.note": "Un avis étiqueté : il n'entre pas dans le score ; un humain note et décide.",
  "adr.caste.title": "Proposition de la caste architectes",
  "adr.create.g4": "Porte G4 (au moins 3 options)",
  "adr.create.open": "Nouvelle ADR",
  "adr.create.required": "Le titre et le contexte sont obligatoires.",
  "adr.create.subject": "Sujet",
  "adr.create.submit": "Créer l'ADR",
  "adr.create.supersedes": "Remplace {{n}} — l'ancienne ADR restera lisible, marquée « remplacée par ».",
  "adr.create.titleLabel": "Titre",
  "adr.description": "Décisions d'architecture (ADR) du projet et de l'outil : options comparées sur des critères fixés avant la notation, décision tracée, remplacement jamais silencieux.",
  "adr.fields.compliance": "Conformité",
  "adr.fields.consequencesMinus": "Conséquences −",
  "adr.fields.consequencesPlus": "Conséquences +",
  "adr.fields.context": "Contexte",
  "adr.fields.deciders": "Décideurs",
  "adr.fields.decision": "Décision",
  "adr.list.empty": "Aucune ADR",
  "adr.list.emptyHint": "Une ADR naît d'un geste existant : porte G4, changement de pile, dérogation.",
  "adr.list.noWorkspaceHint": "Ouvrez un projet pour voir ses décisions.",
  "adr.list.project": "Projet",
  "adr.list.scope": "Portée des décisions",
  "adr.list.supersededBy": "remplacée par {{n}}",
  "adr.list.supersedes": "remplace {{n}}",
  "adr.list.title": "Décisions",
  "adr.list.tool": "L'outil (DoIt)",
  "adr.matrix.addCriterion": "Ajouter un critère",
  "adr.matrix.addOption": "Ajouter une option",
  "adr.matrix.changeWeight": "Modifier un poids",
  "adr.matrix.choose": "Choisir…",
  "adr.matrix.criterion": "critère",
  "adr.matrix.empty": "Ajoutez des options et des critères pour comparer.",
  "adr.matrix.excluded": "écartée (obligatoire)",
  "adr.matrix.fieldsRequired": "Tous les champs sont obligatoires (une note se justifie).",
  "adr.matrix.frozen": "poids fixés le {{date}}, avant la notation · notes 1 à 5",
  "adr.matrix.justification": "Justification",
  "adr.matrix.key": "Clé (minuscules)",
  "adr.matrix.kind": "Nature",
  "adr.matrix.label": "Libellé",
  "adr.matrix.mandatory": "obligatoire",
  "adr.matrix.no": "non",
  "adr.matrix.noStack": "— aucune —",
  "adr.matrix.notFrozen": "poids modifiables jusqu'à la première note — ils seront alors figés",
  "adr.matrix.option": "Option",
  "adr.matrix.passed": "Réussi ?",
  "adr.matrix.rule": "Une pile sans cas dorés qualifiés sur le modèle en service n'est pas proposable : elle reste visible, grisée, avec son motif.",
  "adr.matrix.save": "Enregistrer",
  "adr.matrix.score": "Noter une option",
  "adr.matrix.scoreLabel": "Note (1 à 5)",
  "adr.matrix.stack": "Pile du catalogue (ADR de pile)",
  "adr.matrix.title": "Matrice de comparaison",
  "adr.matrix.weight": "poids",
  "adr.matrix.weightPercent": "Poids (%)",
  "adr.matrix.weighted": "pondéré",
  "adr.matrix.weightedScore": "Score pondéré",
  "adr.matrix.weightsTotal": "total des poids : {{n}} % (100 % attendus)",
  "adr.matrix.yes": "oui",
  "adr.noSelection": "Choisissez une décision pour voir sa matrice et sa fiche.",
  "adr.stack.fromAdr": "décidée par",
  "adr.stack.measured": "{{passed}} / {{total}} cas dorés · {{model}}",
  "adr.stack.none": "Aucune pile décidée : le profil de pile naît d'une ADR de pile décidée.",
  "adr.stack.notProposable": "non proposable",
  "adr.stack.proposable": "proposable",
  "adr.stack.title": "Profil de pile du projet",
  "adr.stack.unmeasured": "générabilité non mesurée",
  "adr.status.decided": "décidée",
  "adr.status.deprecated": "dépréciée",
  "adr.status.proposed": "proposée",
  "adr.status.superseded": "remplacée",
  "adr.subject.database": "base de données",
  "adr.subject.engine": "moteur d'inférence",
  "adr.subject.other": "autre",
  "adr.subject.stack": "pile technique",
  "adr.title": "Décisions",
  "nav./decisions": "Décisions et profil de pile",
  "nav./organisation": "Référentiel d’exigences",
  "navdesc./decisions": "Décisions d’architecture (ADR), matrice et profil de pile du projet",
  "navdesc./organisation": "Définition de fini, exigences et contrôles de l’organisation",
  "org.cancel": "Annuler",
  "org.category.accessibilite": "accessibilité",
  "org.category.compatibilite": "compatibilité",
  "org.category.donneesPersonnelles": "données personnelles",
  "org.category.fiabilite": "fiabilité",
  "org.category.licences": "licences",
  "org.category.maintenabilite": "maintenabilité",
  "org.category.performance": "performance",
  "org.category.pile": "pile technique",
  "org.category.portabilite": "portabilité",
  "org.category.qualite": "qualité",
  "org.category.securite": "sécurité",
  "org.category.tracabilite": "traçabilité",
  "org.category.utilisabilite": "utilisabilité",
  "org.page.description": "Ce que l'organisation exige de chaque projet, ce qu'un projet hérite, et les dérogations — toujours datées, jamais prolongées en silence.",
  "org.heritage.add": "Ajouter le critère",
  "org.heritage.addLabel": "Renforcer : ajouter un critère",
  "org.heritage.addRequired": "Identifiant, critère et contrôle nommé sont obligatoires.",
  "org.heritage.addedByProject": "ajoutée par le projet",
  "org.heritage.code": "Identifiant (ex. DOD-PRJ-001)",
  "org.heritage.control": "contrôle",
  "org.heritage.countAVerifier": "{{n}} à vérifier",
  "org.heritage.countConforme": "{{n}} conformes",
  "org.heritage.countDerogation": "{{n}} en dérogation",
  "org.heritage.countNonConforme": "{{n}} non conformes",
  "org.heritage.empty": "Aucune exigence portée par ce projet",
  "org.heritage.emptyHint": "Les exigences en vigueur ou en observation de l'organisation sont héritées à la création du projet.",
  "org.heritage.enforce": "appliquer",
  "org.heritage.fromOrganisation": "héritée de l'organisation",
  "org.heritage.fromProgram": "héritée du programme {{id}}",
  "org.heritage.modeEnforce": "Mode : appliquer — une exigence héritée absente bloque l'approbation de la spécification.",
  "org.heritage.modeLabel": "Mode d'application",
  "org.heritage.modeObserve": "Mode : observer — les non-conformités sont rapportées, rien n'est bloqué.",
  "org.heritage.modeSave": "Appliquer le mode",
  "org.heritage.noneRemoved": "aucun retiré",
  "org.heritage.observe": "observer",
  "org.heritage.receivedOn": "reçue le {{date}}",
  "org.heritage.remove": "Retirer",
  "org.heritage.removedUnderWaiver": "{{n}} retiré(s) sous dérogation",
  "org.heritage.statement": "Critère",
  "org.heritage.summary": "{{total}} critères · renforcée par le projet (+{{added}}) · {{removed}}",
  "org.heritage.title": "Héritage du projet",
  "org.noWorkspace": "Aucun projet ouvert",
  "org.noWorkspaceHint": "Ouvrez un projet pour voir ce qu'il hérite et ses dérogations.",
  "org.presence.content": "Texte de la spécification",
  "org.presence.contentRequired": "Collez le texte à vérifier.",
  "org.presence.digest": "Empreinte",
  "org.presence.hint": "Chaque exigence du projet doit être citée par son identifiant, ou couverte par une dérogation en vigueur. Contrôle déterministe : jamais le Spec Gate.",
  "org.presence.missing": "Manquantes :",
  "org.presence.observed": "manquantes rapportées (mode observer)",
  "org.presence.pass": "toutes les exigences sont présentes ou couvertes",
  "org.presence.refused": "refusée — exigence héritée absente",
  "org.presence.run": "Vérifier",
  "org.presence.title": "Contrôle de présence des exigences héritées",
  "org.ref.add": "Ajouter une exigence",
  "org.ref.category": "Catégorie",
  "org.ref.changeStatus": "Changer le statut de {{code}}",
  "org.ref.code": "Identifiant (ex. NFR-PERF-001)",
  "org.ref.colControl": "contrôle qui la vérifie",
  "org.ref.colId": "identifiant",
  "org.ref.colMeasure": "mesure",
  "org.ref.colStatement": "exigence",
  "org.ref.colStatus": "statut",
  "org.ref.control": "Contrôle qui la vérifie",
  "org.ref.controlRequired": "Une exigence sans contrôle nommé ne passe ni en observation ni en vigueur.",
  "org.ref.created": "Exigence ajoutée au référentiel",
  "org.ref.empty": "Aucune exigence de référence",
  "org.ref.emptyHint": "L'administration de l'organisation définit la DoD et les exigences non fonctionnelles de référence.",
  "org.ref.formLabel": "Nouvelle exigence de référence",
  "org.ref.initialStatus": "Statut initial",
  "org.ref.method": "Méthode de mesure",
  "org.ref.moveTo": "Passer à…",
  "org.ref.noControl": "aucun contrôle nommé",
  "org.ref.note": "Une exigence sans contrôle nommé ne passe pas « en vigueur ». Une nouvelle règle commence en « observer ».",
  "org.ref.owner": "Propriétaire",
  "org.ref.readOnly": "Lecture seule — le référentiel est administré par l'organisation.",
  "org.ref.requiredFields": "Identifiant, exigence et propriétaire sont obligatoires.",
  "org.ref.statement": "Exigence",
  "org.ref.submit": "Ajouter",
  "org.ref.threshold": "Seuil",
  "org.ref.title": "Référentiel de l'organisation",
  "org.request.controls": "Contrôles compensatoires (testables)",
  "org.request.controlsRequired": "Au moins un contrôle compensatoire testable est exigé.",
  "org.request.expiry": "Expire le (obligatoire)",
  "org.request.expiryRequired": "La date d'expiration est obligatoire : une dérogation sans échéance est refusée.",
  "org.request.justification": "Justification",
  "org.request.justificationRequired": "La justification est obligatoire.",
  "org.request.owner": "Propriétaire",
  "org.request.ownerRequired": "Le propriétaire est obligatoire.",
  "org.request.readOnly": "Lecture seule — demander une dérogation est réservé aux contributeurs du projet.",
  "org.request.requirement": "Exigence visée",
  "org.request.requirementRequired": "Choisissez l'exigence visée.",
  "org.request.riskFixed": "risque {{risk}} — fixé par la catégorie",
  "org.request.riskLevel": "Risque (relevable, jamais abaissable)",
  "org.request.ruleHigh": "Risque élevé : approbation par le triangle. Au-delà de 90 jours, revue obligatoire. Jamais de prolongation silencieuse.",
  "org.request.ruleLow": "Risque faible : approbation par le propriétaire du projet. Jamais de prolongation silencieuse.",
  "org.request.ruleMedium": "Risque moyen : approbation par un architecte désigné. Jamais de prolongation silencieuse.",
  "org.request.securityNote": "Revue de sécurité (au-delà de 90 jours)",
  "org.request.securityReviewRequired": "Au-delà de 90 jours, une dérogation de sécurité exige une revue de sécurité consignée.",
  "org.request.sent": "Dérogation demandée — en attente d'approbation",
  "org.request.submit": "Demander l'approbation",
  "org.request.title": "Demande de dérogation",
  "org.risk.high": "élevé",
  "org.risk.low": "faible",
  "org.risk.medium": "moyen",
  "org.risk.unclassified": "non classé",
  "org.state.aVerifier": "à vérifier",
  "org.state.conforme": "conforme",
  "org.state.enDerogation": "en dérogation",
  "org.state.nonConforme": "non conforme",
  "org.state.perimee": "périmée",
  "org.status.inForce": "en vigueur",
  "org.status.observe": "observer",
  "org.status.proposed": "proposée",
  "org.status.retired": "retirée",
  "org.page.title": "Exigences et dérogations",
  "org.twoPerson.alwaysThree": "Gardent toujours trois personnes :",
  "org.twoPerson.disabled": "désactivé",
  "org.twoPerson.disabledRule": "Le demandeur n'approuve jamais son propre objet : trois personnes distinctes (demandeur, relecteur, approbateur).",
  "org.twoPerson.enabled": "activé",
  "org.twoPerson.enabledRule": "Pour un objet à risque faible seulement, l'approbateur peut être le demandeur ; le relecteur reste distinct et l'approbation porte la mention « mode deux personnes » à l'audit.",
  "org.twoPerson.excludedOneWay": "décisions à sens unique (pile, moteur, base)",
  "org.twoPerson.excludedProduction": "promotion en production",
  "org.twoPerson.excludedSecurity": "sécurité",
  "org.twoPerson.excludedWaiver": "dérogations",
  "org.twoPerson.setting": "Réglage du gabarit",
  "org.twoPerson.title": "Mode deux personnes",
  "org.waiver.dueIn": "dans {{n}} j",
  "org.waiver.expiredNonCompliant": "échue — non conforme",
  "org.waiver.lifted": "levée",
  "org.waiver.refused": "refusée",
  "org.waiver.requested": "demandée",
  "org.waiver.routeArchitect": "architecte",
  "org.waiver.routeOwner": "propriétaire du projet",
  "org.waiver.routeTriangle": "triangle (trois personnes)",
  "org.waivers.age": "demandée il y a {{n}} j",
  "org.waivers.colDue": "échéance",
  "org.waivers.colGranted": "accordée",
  "org.waivers.colRequirement": "exigence",
  "org.waivers.colRisk": "risque",
  "org.waivers.colState": "état",
  "org.waivers.comment": "Commentaire (obligatoire pour une revue ou un refus)",
  "org.waivers.confirm": "Enregistrer",
  "org.waivers.decide": "Décider",
  "org.waivers.decision": "Décision",
  "org.waivers.empty": "Aucune dérogation active",
  "org.waivers.emptyHint": "Une dérogation se demande depuis le formulaire « Demande de dérogation ».",
  "org.waivers.grant": "accorder",
  "org.waivers.lift": "Lever",
  "org.waivers.refuse": "refuser",
  "org.waivers.review": "Relire",
  "org.waivers.reviewApprove": "favorable",
  "org.waivers.reviewReject": "défavorable",
  "org.waivers.reviewVerdict": "Verdict de revue",
  "org.waivers.title": "Dérogations actives",
  "org.settings.title": "Réglages de l'organisation",
  "org.settings.edit": "Modifier",
  "org.settings.enforce": "appliquer",
  "org.settings.observe": "observer",
  "org.settings.newProjectMode": "Nouveaux projets :",
  "org.settings.modeHint": "s'applique aux projets créés ensuite ; les projets existants restent en observer jusqu'à l'échéance fixée par l'administration",
  "org.settings.architects": "Architectes désignés :",
  "org.settings.noArchitect": "aucun architecte désigné",
  "org.settings.architectsHint": "les dérogations à risque moyen sont décidées par un architecte désigné",
  "org.settings.readOnly": "Lecture seule — ces réglages sont modifiés par l'administration de l'organisation.",
  "org.settings.modeLabel": "Mode des nouveaux projets",
  "org.settings.architectsLabel": "Architectes désignés (identifiants, séparés par des virgules ou un par ligne)",
  "org.settings.save": "Enregistrer les réglages",
  "admin.aiConnectionAdd": "Enregistrer la connexion",
  "admin.aiConnectionDisable": "Désactiver",
  "admin.aiConnectionEnable": "Activer",
  "admin.aiConnectionName": "Nom",
  "admin.aiConnectionsHeading": "Connexions fournisseurs IA",
  "admin.aiConnectionsHint": "Les clés restent dans le secret-store : seul un secret_ref est enregistré.",
  "admin.aiConnectorConnected": "connecteur actif",
  "admin.aiConnectorDisabled": "connecteur désactivé",
  "admin.aiConnectorLocal": "runtime local",
  "admin.aiConnectorMissing": "connecteur introuvable",
  "admin.aiEndpoint": "Endpoint",
  "admin.aiProvider": "Fournisseur",
  "admin.aiSecretRef": "Référence secret (optionnelle)",
  "admin.disabled": "désactivé",
  "admin.enabled": "activé",
  "admin.globalAiActivate": "Activer pour cette organisation",
  "admin.globalAiChooseOrg": "Choisir une organisation",
  "admin.globalAiConnectionRequired": "Connexion obligatoire",
  "admin.globalAiCreate": "Ajouter la plateforme",
  "admin.globalAiDeactivate": "Désactiver pour cette organisation",
  "admin.globalAiDefaultConnection": "Runtime local par défaut",
  "admin.globalAiDisable": "Désactiver la connexion",
  "admin.globalAiDisabledBinding": "Le connecteur lié est désactivé : réactivez-le ou choisissez-en un autre.",
  "admin.globalAiDiscoverModels": "Découvrir les modèles",
  "admin.globalAiDiscoveryResult": "Découverte : {{count}} modèle(s) ajouté(s) ou mis à jour.",
  "admin.globalAiEnable": "Activer la connexion",
  "admin.globalAiHeading": "Plateformes IA globales",
  "admin.globalAiHint": "Déclarez les fournisseurs une fois, puis activez-les organisation par organisation. Les secrets restent référencés, jamais affichés.",
  "admin.globalAiKillSwitchDisable": "Interrompre les requêtes IA",
  "admin.globalAiKillSwitchEnable": "Réactiver les requêtes IA",
  "admin.globalAiKillSwitchHint": "Bloque immédiatement les nouvelles générations pour toutes les organisations.",
  "admin.globalAiKillSwitchReason": "Motif",
  "admin.globalAiKillSwitchReasonPlaceholder": "Motif (obligatoire, conservé dans l’historique)",
  "admin.globalAiKillSwitchReasonRequired": "Indiquez un motif (3 caractères au moins) : il reste dans l’historique.",
  "admin.globalAiKillSwitchConfirmation": "Confirmation : tapez « plateforme »",
  "admin.globalAiKillSwitchConfirmationPlaceholder": "Tapez « plateforme » pour confirmer",
  "admin.globalAiKillSwitchConfirmationRequired": "Tapez « plateforme » pour confirmer la bascule de toute la plateforme.",
  "admin.globalAiKillSwitchTitle": "Interruption globale des requêtes IA",
  "admin.globalAiLocalRuntime": "runtime local par défaut",
  "admin.globalAiMissingBinding": "Aucun connecteur actif ne correspond à ce modèle.",
  "admin.globalAiModelCapabilities": "Capacités du modèle",
  "admin.globalAiModelConnection": "Connexion du modèle",
  "admin.globalAiModelName": "Nom affiché",
  "admin.globalAiModelsHeading": "Raccordement des modèles",
  "admin.globalAiModelsHint": "Choisissez la connexion réellement utilisée par chaque modèle du catalogue.",
  "admin.globalAiModelType": "Type de modèle",
  "admin.globalAiNoCompatibleConnection": "Aucun connecteur activé pour ce fournisseur",
  "admin.globalAiOrganisation": "Organisation cible",
  "admin.globalAiOrganisationRequired": "Choisissez une organisation avant de modifier son activation.",
  "admin.globalAiProbe": "Sonder",
  "admin.globalAiRegisterModel": "Enregistrer le modèle",
  "admin.globalAiRegisterModelHeading": "Enregistrer un modèle",
  "admin.globalAiRegisterModelHint": "Pour les fournisseurs cloud protégés ou les modèles absents du catalogue automatique. Une connexion compatible peut être sélectionnée.",
  "admin.globalAiResolvedConnection": "connecteur résolu",
  "admin.langfuseProbe": "Tester l’ingestion",
  "admin.langfuseProbeHint": "Vérifie une vraie ingestion sans afficher de clé ni de contenu métier.",
  "admin.langfuseProbeTitle": "Observabilité Langfuse",
  "admin.notificationAdd": "Ajouter le canal",
  "admin.notificationChannelsHeading": "Canaux de notification",
  "admin.notificationChannelsHint": "Configurez les destinations utilisées pour les échecs de génération. Les secrets restent dans le gestionnaire externe.",
  "admin.notificationEndpoint": "Endpoint ou adresse",
  "admin.notificationName": "Nom du canal",
  "admin.notificationProvider": "Type de canal",
  "admin.notificationSecretRef": "Référence secret (optionnelle)",
  "admin.operationsHealthDescription": "État opérationnel par organisation, rafraîchi automatiquement.",
  "admin.operationsHealthScrollRegion": "Tableau de santé défilable",
  "admin.operationsHealthTable": "État de santé des organisations",
  "admin.operationsHealthTitle": "Santé plateforme",
  "admin.organisationAiActivate": "Activer",
  "admin.organisationAiDeactivate": "Désactiver",
  "admin.organisationAiModelsHeading": "Modèles IA activés pour l’organisation",
  "admin.organisationAiModelsHint": "Activez uniquement les modèles utilisables par les espaces. Le fournisseur et le connecteur sont ceux du catalogue global.",
  "admin.teamCreate": "Créer l’équipe",
  "admin.teamCreatedToast": "Équipe créée",
  "admin.teamDescriptionPlaceholder": "Description (facultative)",
  "admin.teamMemberAddedToast": "Membre ajouté à l’équipe",
  "admin.teamMemberChoose": "Choisir un membre",
  "admin.teamMemberSelect": "Membre à ajouter à l’équipe",
  "admin.teamMemberAdd": "Ajouter le membre choisi à l’équipe",
  "admin.teamNameError": "Saisissez au moins 2 caractères.",
  "admin.teamNamePlaceholder": "Nom de l’équipe",
  "admin.teamsHeading": "Équipes de travail",
  "admin.teamsHint": "Regroupez les membres du projet par équipe sans modifier leurs rôles d’accès.",
  "approvals.appPort": "Port d'écoute",
  "approvals.appPortInvalide": "Port invalide : un entier entre 1 et 65535.",
  "approvals.appSlug": "Nom technique",
  "approvals.appSlugInvalide": "Nom technique invalide : minuscules, chiffres et tirets, de 3 à 41 caractères, ne commençant pas par un tiret.",
  "approvals.attestationRequired": "Relisez le contenu avant de rejeter.",
  "approvals.compareExtraction": "Comparer cette extraction",
  "approvals.generateApp": "Générer l'application",
  "approvals.generateAppDesc": "produit l'arborescence complète d'une application autonome couvrant cette spécification approuvée. Le compte rendu revient en approbation comme tout autre artefact ; rien n'est déployé.",
  "approvals.historicalEvidenceAttested": "Une attestation humaine historique est enregistrée pour cette preuve exacte.",
  "approvals.historicalEvidenceNotAttested": "Cette preuve historique est non attestée par un humain.",
  "approvals.latestEvaluationEvidence": "Preuve de la dernière évaluation",
  "approvals.noPriorVersion": "Aucune version antérieure comparable : consultez la source disponible ci-dessus ; aucun diff n’est fabriqué.",
  "approvals.openSource": "Voir la source",
  "approvals.originalPrompt": "Prompt / source d’origine",
  "approvals.reasonHint": "Ajoutez un motif pour activer le rejet.",
  "approvals.recordedDecisionEvidence": "Preuve de la décision enregistrée",
  "approvals.sourceContextApprovalBlocked": "L’approbation reste indisponible tant que le contexte source requis n’est pas chargé.",
  "approvals.sourceContextHint": "Le prompt d’origine et la comparaison sont affichés avant toute décision.",
  "approvals.sourceContextTitle": "Contexte source de la décision",
  "approvals.sourceContextUnavailable": "Le contexte source requis ne peut pas être chargé ; l’approbation est bloquée.",
  "approvals.specGateEvidenceConsultationUnavailable": "La preuve historique ne peut pas être chargée pour le moment.",
  "approvals.specGateEvidenceEmpty": "Aucune référence détaillée dans cette preuve.",
  "approvals.specGateEvidenceLoading": "Chargement des références de preuve…",
  "approvals.specGateEvidenceReferences": "Références de preuve",
  "approvals.specGateTerminalError": "La dernière évaluation n’a pas abouti. Ce dossier est clos.",
  "approvals.specGateTerminalFailed": "La dernière évaluation a relevé des corrections. Ce dossier est clos.",
  "approvals.specGateTerminalFailedLabel": "Corrections relevées",
  "approvals.specGateTerminalNotRequested": "Aucune évaluation n’a été enregistrée avant la décision. Ce dossier est clos.",
  "approvals.specGateTerminalNotRequestedLabel": "Aucune évaluation enregistrée",
  "approvals.specGateTerminalStale": "La dernière évaluation enregistrée est obsolète. Ce dossier est clos.",
  "approvals.unifiedDiff": "Diff unifié : version courante → proposition",
  "backlog.bulkFieldTeam": "l’équipe",
  "backlog.bulkTeamLabel": "Équipe (masse)",
  "backlog.bulkTeamPlaceholder": "Équipe…",
  "backlog.filterTeamAll": "Toutes",
  "backlog.noTeam": "Aucune équipe",
  "backlog.reviewStoryHint": "La revue vérifiera le dernier changement approuvé associé à cet objet.",
  "backlog.sprint": "Sprint",
  "backlog.sprintSelect": "Affecter au sprint",
  "backlog.sprintUpdated": "Sprint mis à jour",
  "backlog.team": "Équipe",
  "backlog.teamSelect": "Affecter à une équipe",
  "classement.etiquettes": "Étiquettes",
  "classement.aucuneEtiquette": "Aucune étiquette",
  "classement.etiquette": "Étiquette",
  "classement.composants": "Composants",
  "classement.aucunComposant": "Aucun composant",
  "classement.composant": "Composant",
  "classement.versions": "Versions de classement",
  "classement.aucuneVersion": "Aucune version de classement",
  "classement.version": "Version de classement",
  "classement.cree": "Classement créé",
  "classement.sansProjet": "Aucun projet ouvert",
  "classement.sansProjetAide": "Le classement appartient à un projet : ouvrez-le dans la barre de contexte.",
  "classement.titre": "Classement du projet",
  "classement.description": "Étiquettes, composants et versions de classement : ce qui range les items en travers de la hiérarchie.",
  "classement.versBacklog": "Retour au backlog",
  "classement.chargement": "Chargement…",
  "classement.videAide": "Créez-en un ci-dessous, ou depuis la fiche d’un item.",
  "classement.formulaireDessous": "Le formulaire ci-dessous le crée.",
  "classement.nItems": "{{n}} item(s)",
  "classement.creer": "Créer : {{nature}}",
  "classement.nom": "Nom",
  "classement.ajouter": "Ajouter",
  "classement.modifie": "Version de classement modifiée",
  "classement.supprime": "Classement supprimé ; les items sont conservés",
  "classement.versListe": "Tout le classement du projet",
  "classement.introuvable": "Classement introuvable",
  "classement.introuvableAide": "Il n’existe pas (ou plus) dans le projet ouvert.",
  "classement.supprimerTitre": "Supprimer « {{nom}} » ?",
  "classement.supprimerConsequence": "{{n}} item(s) perdent ce classement ; aucun item n’est supprimé.",
  "classement.supprimerReversible": "Vous pourrez recréer le classement, mais il faudra le reposer sur les items.",
  "classement.supprimer": "Supprimer",
  "classement.ficheDescription": "Les items qui portent ce classement, et ce qu’on peut en faire.",
  "classement.date": "Date prévue",
  "classement.livree": "Livrée",
  "classement.oui": "oui",
  "classement.non": "non",
  "classement.itemsPortant": "Items qui le portent ({{n}})",
  "classement.chargementItems": "Chargement des items…",
  "classement.aucunItem": "Aucun item ne le porte",
  "classement.aucunItemAide": "On le pose depuis la fiche d’un item.",
  "classement.modifierVersion": "Modifier la version de classement",
  "classement.enregistrer": "Enregistrer",
  "classement.marquerNonLivree": "Marquer non livrée",
  "classement.marquerLivree": "Marquer livrée",
  "classement.lectureSeule": "Lecture seule : réservé aux propriétaires et contributeurs du projet.",
  "classement.nomManquant": "Donnez un nom.",
  "chat.latency": "Latence",
  "chat.messageRequired": "Écrivez un message avant d’envoyer.",
  "chat.modelRequired": "Choisissez un modèle avant d’envoyer.",
  "chat.provider": "Fournisseur",
  "classif.versionSelect": "Affecter à la version",
  "classif.versionUpdatedToast": "Version mise à jour",
  "compare.approve": "Approuver",
  "compare.executionFailed": "La comparaison s’est arrêtée avant de produire des sorties exploitables.",
  "compare.executionFailedDetail": "Vous pouvez la relancer après vérification de la capacité IA.",
  "compare.insufficientModelsTitle": "Deux modèles autorisés sont nécessaires",
  "compare.linkedDocument": "Document lié",
  "compare.modelsUnavailable": "Le catalogue de modèles est indisponible.",
  "compare.reject": "Rejeter",
  "compare.retry": "Relancer la comparaison",
  "compare.retrying": "Relance…",
  "compare.reviewComment": "Commentaire (obligatoire pour un rejet)",
  "compare.reviewCommentRequired": "Un rejet doit être justifié.",
  "compare.reviewedBy": "Décision enregistrée par",
  "compare.reviewSaved": "Décision de revue enregistrée",
  "compare.reviewStatus": "Statut",
  "compare.reviewTitle": "Revue humaine",
  "compare.sectionEmpty": "La section sélectionnée est vide.",
  "compare.sectionLabel": "Section à comparer",
  "config.agentRoleChoose": "Choisir un rôle",
  "config.agentUnavailable": "indisponible",
  "config.apiAuthUnavailable": "héritée/non supportée",
  "config.apiUnavailable": "héritée/non supportée",
  "config.bindWorkspaceTemplate": "Utiliser pour cet espace",
  "config.editTemplate": "Modifier ce template",
  "config.exitEdit": "Quitter le mode modification",
  "config.lifecycle.keyFormat": "Commencez par une minuscule, puis utilisez uniquement a-z, 0-9, _ ou - (2 à 64 caractères).",
  "config.lifecycle.routeDefault": "(route héritée de la clé)",
  "config.lifecycle.routeLegacy": "héritée",
  "config.llmRoutingChoose": "Choisir une politique",
  "config.llmRoutingLegacy": "héritée/non supportée",
  "config.mcpAgent": "Agent MCP",
  "config.mcpApprove": "Approuver",
  "config.mcpBindAgent": "Associer",
  "config.mcpChooseAgent": "Choisir un agent",
  "config.mcpDisable": "Désactiver",
  "config.mcpEnable": "Activer",
  "config.mcpImportHint": "Importez un ZIP MCP. Le manifeste est contrôlé avant toute activation.",
  "config.mcpImporting": "Validation…",
  "config.mcpImportReadOnly": "Import disponible dans un template organisationnel modifiable.",
  "config.mcpImportSource": "Importer",
  "config.mcpSourceGitlab": "Dépôt GitLab",
  "config.mcpSourceInvalid": "L’URL MCP doit être une URL HTTP(S) valide.",
  "config.mcpSourceRequired": "Saisissez une URL de source MCP.",
  "config.mcpSourceRevision": "Branche ou tag GitLab",
  "config.mcpSourceType": "Source MCP",
  "config.mcpSourceUpload": "ZIP local",
  "config.mcpSourceUrl": "URL ZIP",
  "config.mcpSourceUrlLabel": "URL de source MCP",
  "config.mcpToolUnavailable": "hérité",
  "config.mcpUnavailable": "indisponible",
  "config.mcpUseInTemplate": "Utiliser dans ce template",
  "config.mcpZip": "Archive MCP ZIP",
  "config.modeChoose": "Choisir une politique",
  "config.model.gates": "Gates à l’entrée",
  "config.modelChoose": "Choisir un modèle configuré",
  "config.modelEmbeddingMismatch": "Ce rôle attend un modèle d’embedding, mais ce modèle ne l’annonce pas.",
  "config.modelPoolChoose": "Choisir un pool",
  "config.modelRoleChoose": "Choisir un rôle",
  "config.modelUnavailable": "indisponible",
  "config.modelVisionMismatch": "Ce rôle attend la vision, mais ce modèle ne l’annonce pas.",
  "config.modeUnavailable": "hérité/non déclaré",
  "config.modeUnavailableDescription": "Politique non supportée par cette version.",
  "config.noActiveModelsHint": "Aucun modèle exécutable n’est disponible. Activez un connecteur et accordez au moins un modèle dans l’administration IA.",
  "config.noWorkspaceTemplate": "Sélectionnez un espace et un template.",
  "config.processAdd": "Ajouter une étape",
  "config.processAgentWorkflow": "Workflow agent",
  "config.processApproval": "Validation",
  "config.processApprovalReason": "Motif d’approbation",
  "config.processApprovalReasonHint": "Motif (requis)",
  "config.processApprovalRequired": "Saisissez un motif d’au moins 3 caractères pour approuver.",
  "config.processApprove": "Approuver et continuer",
  "config.processApproveConfirmed": "Approbation confirmée — statut : {{status}}.",
  "config.processBlocked": "Prérequis à compléter",
  "config.processEmpty": "Aucune étape déclarée. Le cycle intégré reste disponible.",
  "config.processEnvironment": "Environnement Docker",
  "config.processGates": "Gates",
  "config.processGitlabRef": "Référence GitLab",
  "config.processHint": "Ordonnez les actions, gates et validations humaines de votre organisation.",
  "config.processInputs": "Entrées",
  "config.processKey": "Clé",
  "config.processKeyFormat": "Commencez par une minuscule, puis utilisez uniquement a-z, 0-9 ou _ (2 à 64 caractères).",
  "config.processKind": "Type d’étape",
  "config.processLabel": "Libellé",
  "config.processNoBlockers": "Toutes les capacités déclarées sont disponibles.",
  "config.processOutputs": "Sorties",
  "config.processPipelineId": "Pipeline du projet",
  "config.processReadOnlyApproval": "Cette étape attend une approbation d’un propriétaire ou reviewer.",
  "config.processReadOnlyResume": "Lecture seule : un propriétaire ou contributeur peut reprendre le processus.",
  "config.processReadOnlyRun": "Lecture seule : un propriétaire ou contributeur doit lancer le processus.",
  "config.processReadOnlyStep": "Lecture seule : un propriétaire ou contributeur peut exécuter cette étape.",
  "config.processReady": "Processus prêt",
  "config.processRelease": "Release à déployer",
  "config.processRemove": "Supprimer l’étape",
  "config.processResume": "Reprendre l'exécution",
  "config.processResumeConfirmed": "Reprise confirmée — statut : {{status}}.",
  "config.processRoles": "Rôles",
  "config.processRun": "Exécuter cette étape",
  "config.processRunAll": "Lancer le processus",
  "config.processSave": "Enregistrer le processus",
  "config.processSaved": "Processus enregistré",
  "config.processStartConfirmed": "Démarrage confirmé — statut : {{status}}.",
  "config.processTitle": "Processus idée → production",
  "config.publicationBlocked": "Publication à préparer",
  "config.published": "Publié · v{{v}}",
  "config.publishedToast": "Version publiée",
  "config.publishTemplate": "Publier v{{v}}",
  "config.retryBackoffMaxSeconds": "Backoff plafond (s)",
  "config.retryBackoffSeconds": "Backoff initial (s)",
  "config.retryMaxAttempts": "Tentatives maximales",
  "config.retryPolicy": "Politique de reprise des outils",
  "config.retryPolicyHint": "Les erreurs de transport et timeouts suivent cette reprise bornée ; les erreurs métier restent terminales.",
  "config.technologiesProjectHint": "Les technologies d’implémentation se configurent dans RunOps pour chaque projet/environnement, pas dans le template.",
  "config.templateBoundToast": "Template rattaché à l’espace",
  "config.templateMigrate": "Prévisualiser et migrer",
  "config.templateMigrationAttest": "J’ai vérifié l’aperçu des changements",
  "config.templateMigrationAvailable": "Migration disponible",
  "config.templateMigrationC1": "La nouvelle configuration deviendra la version épinglée de ce projet.",
  "config.templateMigrationC2": "Le changement sera enregistré dans l’audit et ne sera pas automatique.",
  "config.templateMigrationSummary": "Version projet v{{from}} → v{{to}} · {{n}} rubrique(s) modifiée(s)",
  "config.templateMigrationTitle": "Migrer le projet vers v{{v}} ?",
  "config.templateMigrationToast": "Projet migré vers la nouvelle version",
  "config.templateMigrationVerb": "Migrer le projet",
  "config.templateVersionPinned": "Version projet v{{v}}",
  "config.workflowIdFormat": "Commencez par une minuscule, puis utilisez uniquement a-z, 0-9, _ ou - (2 à 64 caractères).",
  "config.workflowStepUnavailable": "héritée",
  "config.workflowTriggerChoose": "Choisir un déclencheur",
  "config.workflowTriggerUnavailable": "hérité/non supporté",
  "confirm.graceRemaining": "Confirmation disponible dans {{seconds}} s",
  "dashboard.archivedWorkspace": "Archivé · lecture seule",
  "dashboard.createOrganisation": "Créer mon organisation",
  "dashboard.noOrganisation": "Votre organisation n’est pas encore créée",
  "dashboard.recentDecisionsRegion": "Liste des décisions récentes",
  "dashboard.servedModelsList": "Liste des modèles servis",
  "delivery.description": "Suivez le code GitLab et promouvez la même release vers vos environnements Docker depuis un seul parcours.",
  "delivery.title": "Cockpit de livraison",
  "gen.appToast": "Génération de l'application lancée",
  "gitlab.pipelineTriggered": "Pipeline GitLab déclenché",
  "gitlab.refLabel": "Branche ou ref",
  "gitlab.refRequired": "Saisissez une branche ou une ref GitLab.",
  "gitlab.refresh": "Actualiser les données GitLab",
  "gitlab.trigger": "Déclencher",
  "graph.children": "Enfants",
  "graph.dataTable": "Tableau de données du graphe",
  "graph.dataTableCaption": "Données, hiérarchie et relations du graphe des work items",
  "graph.keyboardHelp": "Utilisez Tab pour parcourir les items du graphe, puis Entrée ou Espace pour ouvrir l’item. Le tableau de données ci-dessous fournit l’équivalent textuel complet.",
  "graph.noRelation": "Aucune relation",
  "graph.parent": "Parent",
  "graph.tableId": "ID",
  "graph.tableItem": "Item",
  "graph.tableKind": "Type",
  "graph.tableRelations": "Relations",
  "graph.tableStatus": "Statut",
  "history.semanticEmpty": "Aucun événement proche trouvé.",
  "history.semanticLoading": "Recherche sémantique…",
  "history.semanticQueryRequired": "Saisissez un terme avant la recherche sémantique.",
  "history.semanticResults": "Résultats sémantiques",
  "history.semanticSearch": "Recherche sémantique",
  "ideas.draftRestored": "Brouillon restauré — reprise de votre saisie précédente.",
  "ideas.openHistory": "Ouvrir l’historique",
  "ideas.queuedWithoutTimeline": "Votre idée est bien enregistrée et la génération est en file d’attente. La timeline apparaîtra dès que le worker aura publié le job. Vous pouvez rester sur cette page ou consulter l’historique.",
  "ingestion.columnActions": "Actions",
  "ingestion.compareAcrossModels": "Comparer cette question sur plusieurs modèles",
  "ingestion.delete": "Supprimer",
  "ingestion.documentScopeAll": "Toute la base documentaire",
  "ingestion.documentScopeLabel": "Document (optionnel)",
  "ingestion.loadingSources": "Chargement des sources ingérées…",
  "ingestion.missingChecksum": "L’empreinte SHA-256 persistée n’est pas disponible : le document n’est pas encore validé.",
  "ingestion.uploadProgress": "Progression du téléversement",
  "ingestion.uploadProgressComplete": "Téléversement terminé — validation de l’empreinte en cours.",
  "ingestion.uploadStage": "Étape : téléversement du document",
  "ingestion.verificationStage": "Étape : vérification de l’empreinte persistée",
  "ingestion.verifySourceError": "Impossible de vérifier l’empreinte persistée. Réessayez de charger les sources.",
  "item.cancelEdit": "Annuler",
  "item.criteriaHint": "Un critère par ligne",
  "item.description": "Description",
  "item.edit": "Modifier",
  "item.editHint": "Les changements sont enregistrés sur cette fiche.",
  "item.editTitle": "Modifier l'item",
  "item.executableAfterDecomposition": "Cette story décrit le besoin. Générez puis acceptez ses tâches avant de produire du code.",
  "item.invalidEffort": "L'effort doit être un entier positif.",
  "item.noTeam": "Aucune équipe",
  "item.save": "Enregistrer",
  "item.saving": "Enregistrement…",
  "item.team": "Équipe",
  "item.title": "Titre",
  "item.titleRequired": "Le titre est obligatoire.",
  "job.agentCompleted": "Exécution de l’agent terminée",
  "login.demoHint": "Les comptes de démonstration sont configurés dans votre environnement local.",
  "login.otherMethod": "Autre méthode de connexion",
  "login.username": "Identifiant",
  "notif.approvalRequested": "vous demande une approbation",
  "notif.digest": "résumé des notifications non lues",
  "notif.digestActeur": "Résumé",
  "notif.reglages": "Réglages",
  "notif.reglagesDesc": "Tout, mentions seulement ou muet, par défaut puis par projet ; résumé trois fois par jour.",
  "notif.reglagesTitre": "Réglages de notification",
  "notif.retourFil": "Retour aux notifications",
  "org.createButton": "Créer mon organisation",
  "org.createDescription": "Votre compte deviendra propriétaire et un espace principal sera créé automatiquement.",
  "org.createdToast": "Organisation créée",
  "org.createTitle": "Créer votre organisation",
  "org.creating": "Création…",
  "org.description": "Description (facultatif)",
  "org.name": "Nom de l’organisation",
  "org.submit": "Créer l’organisation",
  "processView.description": "Les étapes et prérequis réellement applicables à ce projet, avant toute exécution.",
  "processView.title": "Processus effectif",
  "programs.initiativeFrame": "Cadrer puis spécifier",
  "programs.initiativeFramingLaunched": "Cadrage lancé. Il sera soumis à revue humaine avant la spécification et le code.",
  "programs.initiativeNextStep": "Étapes suivantes : approuver le cadrage, rédiger la spécification, passer le Spec Gate, puis générer le code.",
  "programs.initiativeObjective": "Objectif (facultatif)",
  "programs.initiativeObjectiveFailed": "L’initiative est lancée, mais son objectif n’a pas été enregistré : définissez-le depuis la trace.",
  "programs.initiativeObjectiveHint": "Posé sur l’initiative dès son lancement ; il se modifie ensuite depuis la trace.",
  "programs.initiativeObjectivePlaceholder": "Ex. +10 % de clients récurrents",
  "programs.initiativeObjectiveSet": "Objectif enregistré sur l’initiative.",
  "programs.initiativeOpenApprovals": "Ouvrir les approbations",
  "runops.autoStop": "Arrêt automatique (minutes)",
  "runops.autoStopAide": "Obligatoire pour une preview, entre 5 minutes et 30 jours.",
  "runops.composeFile": "Fichier Compose",
  "runops.composeFileAide": "Chemin relatif dans le dépôt ; aucune commande shell libre.",
  "runops.editEnvironment": "Modifier",
  "runops.editEnvironmentHelp": "Les déploiements déjà exécutés restent inchangés.",
  "runops.editEnvironmentTitle": "Modifier l’environnement",
  "runops.envUpdatedToast": "Environnement mis à jour",
  "runops.healthcheck": "URL de healthcheck",
  "runops.healthcheckAide": "Facultatif. HTTP(S), utilisé pour vérifier la disponibilité.",
  "runops.lifetimeType": "Cycle de vie",
  "runops.lifetimeTypeAide": "Persistant reste actif ; éphémère s’arrête automatiquement.",
  "runops.postgresSecretRef": "Référence secret PostgreSQL",
  "runops.postgresSecretRefAide": "Référence opaque résolue par le runner, par exemple project/db-password. Ne saisissez jamais la valeur ici.",
  "runops.relSourceRef": "Branche ou tag",
  "runops.relSourceRefHelp": "Ex. main, preprod ou feature/ma-fonctionnalite.",
  "runops.requireGitlabPipeline": "Exiger un pipeline GitLab réussi avant promotion",
  "runops.saveEnvironment": "Enregistrer",
  "runops.sourceDir": "Répertoire du dépôt",
  "runops.sourceDirAide": "Facultatif. Chemin relatif autorisé sur le runner Docker.",
  "runops.sourceRefPattern": "Branches/tags autorisés",
  "runops.sourceRefPatternAide": "Facultatif. Ex. main, preprod ou feature/*.",
  "runops.technologies": "Technologies sélectionnées",
  "runops.technologiesAide": "Ex. fastapi,postgres,redis. Le Compose est généré si le dépôt ne fournit pas le fichier.",
  "scorecard.changeFailure": "Taux d’échec changement",
  "scorecard.deployFrequency": "Déploiements / 30 j",
  "scorecard.deploymentsTotal": "Déploiements total",
  "scorecard.dora": "DORA",
  "scorecard.mttr": "MTTR moyen",
  "sprints.addStory": "Ajouter une US",
  "sprints.barreAria": "{{fait}} points terminés sur {{engage}} engagés",
  "sprints.capaciteResume": "Capacité déclarée : {{n}} jours-personnes",
  "sprints.chooseStory": "Choisir une US à ajouter…",
  "sprints.groupeActif": "Actif",
  "sprints.groupeClos": "Clos",
  "sprints.groupePlanifies": "Planifiés",
  "sprints.noAvailableStory": "Aucune US disponible",
  "sprints.ouvrir": "Ouvrir le sprint",
  "sprints.ouvrirAria": "Ouvrir le sprint « {{nom}} » : contenu, capacité, burndown, revue",
  "sprints.storyAdded": "US ajoutée au sprint",
  "tests.createDefect": "Créer un bug",
  "tests.defectCreated": "Bug créé depuis l’échec de test",
  "tests.generatedDefectDescription": "Échec constaté dans la campagne de tests.",
  "tests.generatedDefectTitle": "Défaut détecté par un test",
  "trace.openItem": "Ouvrir l'item",
  "trace.openProof": "Explorer la preuve",
  "trace.proof": "Preuve",
  "trace.proofTitle": "Explorateur de preuve",
  "tree.noSprint": "Sans sprint",
  "tree.sprintSelect": "Affecter au sprint",
  "tree.sprintUpdated": "Sprint mis à jour",
  "wi.priorityCritical": "Critique",
  "wi.priorityHigh": "Haute",
  "wi.priorityLow": "Basse",
  "wi.priorityMedium": "Moyenne",
  "workflow.agentAccessError": "Impossible de charger les autorisations des agents.",
  "workflow.agentAccessHint": "Une ligne désactivée est refusée à toute nouvelle exécution. Sans ligne, le catalogue reste autorisé.",
  "workflow.agentAccessTitle": "Agents autorisés dans cet espace",
  "workflow.agentAccessToggle": "autorisé",
  "workflow.agentStatusEmpty": "Aucun état d’agent observé",
  "workflow.agentStatusEmptyHint": "Lancez un agent pour suivre son état ici.",
  "workflow.agentStatusHint": "Suivi temps réel des agents Idle, Running ou Error.",
  "workflow.agentStatusLoading": "Chargement des états…",
  "workflow.agentStatusTitle": "État des agents",
  "workflow.loadingAgentAccess": "Chargement des autorisations…",
  "workflow.model": "Modèle",
  "workflow.resumeAgent": "Reprendre",
  "workflow.resumeBudget": "Reprises",
  "workflow.resumeBudgetExhausted": "Limite de relances atteinte (QUOTA_EXCEEDED)",
  "approvals.regenAriaLabel": "Régénérer avec instructions",
  "approvals.consequencesAriaLabel": "Conséquences",
  "approvals.generateOptionsAriaLabel": "Génération d'options",
  "approvals.generateBacklogAriaLabel": "Décomposition en backlog",
  "approvals.generateAppAriaLabel": "Génération de l'application",
  "pipelines.authorCannotRunHint": "Vous êtes l'auteur de ce pipeline : la séparation des tâches exige qu'un autre membre le lance.",
  "versions.noWorkspace": "Sélectionnez un projet",
  "versions.noWorkspaceHint": "Une version appartient toujours à un projet.",
  "versions.title": "Versions",
  "versions.description": "Préparer une version, savoir si elle est prête et pourquoi, l’approuver par environnement, la déployer, la livrer et la documenter.",
  "versions.create": "Préparer une version",
  "versions.listTitle": "Versions du projet",
  "versions.loading": "Chargement des versions…",
  "versions.empty": "Aucune version",
  "versions.emptyHint": "Préparez une version : ses révisions, ses items livrés et les campagnes qui la certifient.",
  "versions.ready": "prête",
  "versions.notReady": "pas prête",
  "versions.detailTitle": "Fiche de la version",
  "versions.pick": "Choisissez une version dans la liste.",
  "versions.createForm": "Nouvelle version",
  "versions.field.version": "Version",
  "versions.field.title": "Nom du produit",
  "versions.field.titlePlaceholder": "Caisse boutique",
  "versions.field.commit": "Commit",
  "versions.field.sourceRef": "Branche ou tag",
  "versions.createSubmit": "Créer en brouillon",
  "versions.cancel": "Annuler",
  "versions.summary": "Préparation de la version",
  "versions.summaryReady": "{{nom}} : prête",
  "versions.summaryNotReady": "{{nom}} : pas prête",
  "versions.summaryMore": "(+{{n}} autre(s))",
  "versions.summarySeeWhy": "Voir ce qui bloque",
  "versions.summaryTests": "Tests de la version",
  "versions.summaryDefects": "Anomalies bloquantes ouvertes",
  "versions.summaryMinor": "{{n}} mineure(s)",
  "versions.summaryApprovals": "Approbations par environnement",
  "versions.loadingDetail": "Chargement de la version…",
  "versions.withdrawTitle": "Retirer la version {{version}} ?",
  "versions.withdrawConsequence": "La version ne pourra plus être déployée ; les approbations en attente sont retirées.",
  "versions.withdrawAudit": "Le retrait, son auteur et son motif sont enregistrés à l’audit.",
  "versions.withdrawReversibility": "Un retour arrière vers cette version reste possible en cas d’incident.",
  "versions.withdrawVerb": "Retirer la version",
  "versions.withdrawReason": "Motif du retrait",
  "versions.transition.adopt": "Préparer cette release comme version",
  "versions.transition.candidate": "Figer le contenu (candidate)",
  "versions.transition.draft": "Rouvrir en brouillon",
  "versions.transition.released": "Déclarer livrée",
  "versions.transition.withdrawn": "Retirer la version",
  "versions.headerSection": "Statut de la version",
  "versions.twoPersonMode": "Mode deux personnes actif (jamais pour la production)",
  "versions.withdrawnBecause": "Retirée : {{motif}}",
  "versions.openApp": "Ouvrir l’application livrée ({{env}})",
  "versions.transitions": "Transitions",
  "versions.readinessSection": "Prête ?",
  "versions.readinessTitle": "Prête ?",
  "versions.readinessTarget": "Pour l’environnement {{env}}{{prod}}",
  "versions.production": "production",
  "versions.removeContent": "Retirer du contenu : {{objet}}",
  "versions.contentSection": "Contenu",
  "versions.contentTitle": "Contenu de {{version}}",
  "versions.contentFrozen": "Contenu figé : rouvrez en brouillon pour le modifier.",
  "versions.revisions": "Révisions de l’application",
  "versions.none": "aucune",
  "versions.items": "Items livrés",
  "versions.defects": "Anomalies corrigées",
  "versions.campaigns": "Campagnes qui la certifient",
  "versions.contentKind": "Ajouter",
  "versions.kind.revision": "une révision",
  "versions.kind.item": "un item livré",
  "versions.kind.defect": "une anomalie corrigée",
  "versions.kind.campaign": "une campagne certifiante",
  "versions.contentChoice": "Objet",
  "versions.choose": "Choisir…",
  "versions.add": "Ajouter",
  "versions.envSection": "Environnements",
  "versions.envTitle": "Approbations, déploiement et retour arrière",
  "versions.noEnv": "Aucun environnement : créez-en un dans RunOps.",
  "versions.rejectTitle": "Rejeter la version {{version}} pour {{env}} ?",
  "versions.withdrawApprovalTitle": "Retirer l’approbation de {{env}} ?",
  "versions.rejectConsequence": "La demande est close ; une nouvelle demande reste possible.",
  "versions.withdrawApprovalConsequence": "La version ne pourra plus être déployée sur cet environnement sans nouvelle approbation.",
  "versions.rejectVerb": "Rejeter",
  "versions.withdrawApprovalVerb": "Retirer l’approbation",
  "versions.reason": "Motif",
  "versions.deployTitle": "Déployer {{version}} sur {{env}} ?",
  "versions.deployConsequence": "Un déploiement RunOps est créé (job deploy_docker) et suivi dans l’historique.",
  "versions.deployAudit": "La demande, son auteur et l’approbation qui l’autorise sont enregistrés à l’audit.",
  "versions.deployReversibility": "Un retour arrière vers la version précédente reste disponible.",
  "versions.deployVerb": "Déployer",
  "versions.rollbackUnavailable": "Aucun plan de retour arrière confirmable pour ce déploiement.",
  "versions.requestedBy": "demandée par {{who}}",
  "versions.reviewedBy": "relue par {{who}}",
  "versions.decidedBy": "décidée par {{who}}",
  "versions.twoPersonUsed": "mode deux personnes",
  "versions.lastDeployment": "déploiement {{status}} par {{who}}",
  "versions.deploy": "Déployer sur {{env}}",
  "versions.rollback": "Revenir à la version précédente",
  "versions.action.request": "Demander l’approbation",
  "versions.action.review": "Relire (mode deux personnes)",
  "versions.action.approve": "Accorder",
  "versions.action.reject": "Rejeter",
  "versions.action.withdraw": "Retirer l’approbation",
  "versions.twoPersonNotice": "Vous approuvez votre propre demande en mode deux personnes (hors production, relue par un tiers) : c’est tracé à l’audit.",
  "versions.notesSection": "Notes de version",
  "versions.notesTitle": "Notes de version",
  "versions.notesState": "v{{n}} ({{origine}}, {{auteur}}) · publiée : {{publiee}}",
  "versions.notesGenerated": "rédigées depuis les objets",
  "versions.notesEdited": "retouchées",
  "versions.notesUnpublished": "non",
  "versions.notesNone": "Aucune note : générez-les depuis les objets.",
  "versions.notesBody": "Texte (Markdown), relisible et modifiable avant publication",
  "versions.notesGenerate": "Générer depuis les objets",
  "versions.notesSave": "Enregistrer la retouche (nouvelle version)",
  "versions.notesPublish": "Publier la v{{n}}",
  "versions.notesHistory": "Historique ({{n}} versions conservées)",
  "versions.docsSection": "Documentation de livraison",
  "versions.docsTitle": "Documentation de livraison",
  "versions.docsHint": "Générée depuis les objets, sans modèle de langage : mêmes objets, même texte.",
  "versions.docsGenerate": "Générer la documentation",
  "versions.docsDownload": "Télécharger {{doc}} ({{format}})",
  "versions.doc.user_guide": "Guide utilisateur",
  "versions.doc.operations_guide": "Guide d’exploitation",
  "versions.doc.release_notes": "Notes de version",
  "versions.status.unmanaged": "hors cycle (RunOps)",
  "versions.approval.none": "non demandée",
  "nav./versions": "Versions",
  "navdesc./versions": "Préparer une version, savoir si elle est prête, l’approuver par environnement et la livrer",
  "versions.status.draft": "brouillon",
  "versions.status.candidate": "candidate",
  "versions.status.approved": "approuvée",
  "versions.status.released": "livrée",
  "versions.status.withdrawn": "retirée",
  "versions.readiness.ok": "vert",
  "versions.readiness.blocking": "bloquant",
  "versions.readiness.warning": "avertissement",
  "versions.readiness.info": "information",
  "versions.approval.requested": "demandée",
  "versions.approval.approved": "accordée",
  "versions.approval.rejected": "rejetée",
  "versions.approval.withdrawn": "retirée",
  "versions.architecture": "Architecture, SBOM et vulnérabilités de la version",
  "versions.key.status": "Statut",
  "versions.key.revisions": "Contrôles de la révision",
  "versions.key.spec_gate": "Spec Gate",
  "versions.key.items": "Items livrés",
  "versions.key.campaigns": "Tests de la version",
  "versions.key.defects": "Anomalies",
  "versions.key.requirements": "Exigences",
  "versions.key.waivers": "Dérogations en vigueur",
  "versions.key.notes": "Notes de version",
  "versions.key.approvals": "Approbation",
  "versions.code.RELEASE_NOT_MANAGED": "Version hors cycle : préparez-la d’abord",
  "versions.code.RELEASE_DRAFT": "Préparation en cours : passez la version en candidate pour figer son contenu",
  "versions.code.RELEASE_WITHDRAWN": "Version retirée",
  "versions.code.RELEASE_STATUS_OK": "Contenu figé",
  "versions.code.REVISION_MISSING": "Aucune révision de l’application générée n’est rattachée",
  "versions.code.REVISION_NOT_AVAILABLE": "Une révision n’est pas terminée ou est introuvable",
  "versions.code.REVISION_CHECKS_FAILED": "Des contrôles de la révision sont rouges",
  "versions.code.REVISION_CHECKS_MISSING": "Une révision n’a pas de relevé de contrôles",
  "versions.code.REVISION_CHECKS_GREEN": "Contrôles de la révision verts",
  "versions.code.SPEC_GATE_SOURCE_MISSING": "Aucune spécification source rattachée au contenu",
  "versions.code.SPEC_GATE_NOT_PASSED": "Une spécification source n’a pas de Spec Gate publié, réussi et frais",
  "versions.code.SPEC_GATE_PASSED": "Spec Gate passé",
  "versions.code.ITEMS_NONE": "Aucun item de backlog dans le contenu",
  "versions.code.ITEMS_NOT_DELIVERED": "Des items ne sont pas acceptés ou pas livrés",
  "versions.code.ITEMS_DELIVERED": "Items acceptés et livrés",
  "versions.code.CAMPAIGN_MISSING": "Aucune campagne de test ne certifie la version",
  "versions.code.CAMPAIGN_OPEN": "Une campagne est encore ouverte",
  "versions.code.CAMPAIGN_NOT_GREEN": "Une campagne close n’est pas verte (rouge, bloqué, sauté ou non couvert)",
  "versions.code.CAMPAIGN_GREEN": "Tests de la version verts",
  "versions.code.DEFECTS_BLOCKING_OPEN": "Des anomalies bloquantes ou majeures sont ouvertes",
  "versions.code.DEFECTS_FIX_UNVERIFIED": "Des anomalies déclarées corrigées ne sont pas vérifiées",
  "versions.code.DEFECTS_NONE_BLOCKING": "Aucune anomalie bloquante ouverte",
  "versions.code.REQUIREMENTS_CONFORMING": "Aucune exigence non conforme",
  "versions.code.REQUIREMENTS_NON_CONFORMING": "Des exigences sont non conformes (dérogation échue)",
  "versions.code.REQUIREMENTS_NON_CONFORMING_OBSERVED": "Des exigences sont non conformes — projet en mode « observer »",
  "versions.code.WAIVERS_NONE": "Aucune dérogation en vigueur",
  "versions.code.WAIVERS_IN_FORCE": "Des dérogations sont en vigueur",
  "versions.code.NOTES_NOT_PUBLISHED": "Notes de version non publiées (générer, relire, publier)",
  "versions.code.NOTES_PUBLISHED": "Notes de version relues et publiées",
  "versions.code.APPROVAL_TARGET_MISSING": "Aucun environnement cible dans cet espace",
  "versions.code.APPROVAL_GRANTED": "Approbation accordée pour l’environnement cible",
  "versions.code.APPROVAL_PENDING": "Approbation demandée, en attente de décision",
  "versions.code.APPROVAL_MISSING": "Approbation manquante pour l’environnement cible",
  "versions.code.ACCESS_DENIED": "Lecture seule : rôle owner ou contributor requis",
  "versions.code.RELEASE_STATUS_INVALID": "Le statut de la version ne le permet pas",
  "versions.code.SELF_APPROVAL_REFUSED": "Vous avez demandé cette approbation : un autre approbateur est requis",
  "versions.code.TWO_PERSON_MODE_EXCLUDED_PRODUCTION": "La production garde trois personnes, même en mode deux personnes",
  "versions.code.TWO_PERSON_MODE_REVIEWER_REQUIRED": "Le mode deux personnes exige d’abord la relecture d’un tiers",
  "versions.code.TWO_PERSON_MODE_RISK_NOT_LOW": "Le mode deux personnes ne s’applique qu’aux risques faibles",
  "versions.code.REVIEWER_CANNOT_APPROVE_OWN_REVIEW": "Vous avez relu cette demande : un autre décideur est requis",
  "versions.code.RELEASE_APPROVAL_STATE_INVALID": "Cette approbation n’est plus en attente",
  "versions.code.RELEASE_APPROVAL_ALREADY_REVIEWED": "Cette demande est déjà relue",
  "versions.code.RELEASE_APPROVAL_REVIEWER_IS_REQUESTER": "Vous avez demandé cette approbation : un autre relecteur est requis",
  "versions.code.RELEASE_APPROVAL_NOTE_REQUIRED": "Un rejet exige un motif",
  "versions.code.RELEASE_NOT_READY": "La version n’est pas prête : voir « Prête ? »",
  "versions.code.RELEASE_NOT_APPROVED_FOR_ENVIRONMENT": "La version n’est pas approuvée pour cet environnement",
  "versions.code.DEPLOYER_CANNOT_BE_RELEASE_APPROVER": "SoD-02 : l’approbateur ou le créateur de la version ne la déploie pas ; un tiers déploie",
  "versions.code.RELEASE_TRANSITION_FORBIDDEN": "Transition refusée depuis ce statut",
  "versions.code.RELEASE_CONTENT_EMPTY": "Ajoutez au moins une révision, un item ou une anomalie",
  "versions.code.RELEASE_NOT_DEPLOYED": "Aucun déploiement réussi sur un environnement approuvé",
  "versions.code.RELEASE_WITHDRAWAL_REASON_REQUIRED": "Le retrait exige un motif",
  "versions.code.DEPLOYED_LINK_NO_URL": "Livrée sur un environnement sans URL renseignée",
  "versions.toastCreated": "Version créée en brouillon",
  "versions.toastStatus": "Statut de la version mis à jour",
  "versions.toastApproval": "Approbation enregistrée",
  "versions.toastDeploy": "Déploiement lancé par RunOps",
  "versions.toastRollback": "Retour arrière lancé",
  "versions.toastNotes": "Notes de version publiées",
  "versions.code.REVISION_REJECTED": "Une révision a été rejetée à l’approbation",
  "versions.code.SCM_PIPELINE_REQUIRED": "Cet environnement exige la preuve d’un pipeline GitLab réussi",
  "apercu.annotate.becomes": "deviendra une anomalie",
  "apercu.annotate.cancel": "Annuler",
  "apercu.annotate.create": "Créer l’anomalie",
  "apercu.annotate.created": "Annotation enregistrée :",
  "apercu.annotate.defectLink": "Anomalie ANO-{{id}}",
  "apercu.annotate.defectRef": "Anomalie {{ref}}",
  "apercu.annotate.dismiss": "Fermer",
  "apercu.annotate.element": "Élément",
  "apercu.annotate.elementFree": "Sélecteur (saisie libre)",
  "apercu.annotate.elementNone": "Aucun, ou saisie libre",
  "apercu.annotate.heading": "Annotation {{n}}",
  "apercu.annotate.listTitle": "Annotations de cet aperçu",
  "apercu.annotate.noPin": "Cliquez dans le cadre pour épingler l’endroit (facultatif).",
  "apercu.annotate.otherRoute": "Autre route (saisie libre)",
  "apercu.annotate.overlay": "Épingler une annotation à cet endroit du cadre",
  "apercu.annotate.pinned": "Épingle {{n}} posée à {{x}} % × {{y}} % du cadre",
  "apercu.annotate.route": "Route",
  "apercu.annotate.screen": "Écran",
  "apercu.annotate.severity": "Sévérité",
  "apercu.annotate.size": "Écran · taille",
  "apercu.annotate.text": "Ce qui ne va pas",
  "apercu.app": "Application",
  "apercu.capacity": "{{count}} aperçu(s) vivant(s) sur {{cap}} dans ce projet · ports du proxy {{pool}}",
  "apercu.capture.alt": "Capture de {{screen}}, révision {{short}}, {{width}} px",
  "apercu.capture.loading": "Chargement de la capture…",
  "apercu.capture.missing": "Capture indisponible",
  "apercu.compare.absent": "absent",
  "apercu.compare.added": "{{n}} écrans nouveaux",
  "apercu.compare.added_one": "{{n}} écran nouveau",
  "apercu.compare.added_other": "{{n}} écrans nouveaux",
  "apercu.compare.captures": "Captures",
  "apercu.compare.changed": "{{n}} écrans changés",
  "apercu.compare.changedWidths": "captures changées : {{widths}} px",
  "apercu.compare.changed_one": "{{n}} écran changé",
  "apercu.compare.changed_other": "{{n}} écrans changés",
  "apercu.compare.gap": "Écart",
  "apercu.compare.heading": "Révision {{base}} ↔ révision {{head}}",
  "apercu.compare.hideCaptures": "Masquer",
  "apercu.compare.identical": "{{n}} écrans identiques",
  "apercu.compare.identical_one": "{{n}} écran identique",
  "apercu.compare.identical_other": "{{n}} écrans identiques",
  "apercu.compare.loading": "Comparaison des relevés…",
  "apercu.compare.noSurvey": "relevé pas encore produit",
  "apercu.compare.none": "Cette application n’a qu’une révision : rien à comparer.",
  "apercu.compare.notRunning": "Aperçu non démarré : les captures appariées ci-dessous en tiennent lieu.",
  "apercu.compare.pick": "Choisir une autre révision…",
  "apercu.compare.present": "présent",
  "apercu.compare.removed": "{{n}} écrans disparus",
  "apercu.compare.removed_one": "{{n}} écran disparu",
  "apercu.compare.removed_other": "{{n}} écrans disparus",
  "apercu.compare.rule": "Une capture différente dit « a changé », jamais « c’est correct » : la référence visuelle ne se met à jour qu’avec une approbation.",
  "apercu.compare.screen": "Écran",
  "apercu.compare.showCaptures": "Captures",
  "apercu.compare.side": "Révision {{short}}",
  "apercu.compare.tableCaption": "Écrans appariés des deux révisions",
  "apercu.compare.title": "Comparer deux révisions",
  "apercu.compare.with": "Comparer avec la révision",
  "apercu.controls.failed": "contrôles {{passed}}/{{total}} — en échec : {{names}}",
  "apercu.controls.passed": "contrôles {{passed}}/{{total}}",
  "apercu.controls.unknown": "contrôles non mesurés",
  "apercu.count.interactive": "{{n}} balises interactives",
  "apercu.count.interactive_one": "{{n}} balise interactive",
  "apercu.count.interactive_other": "{{n}} balises interactives",
  "apercu.count.routes": "{{n}} routes",
  "apercu.count.routes_one": "{{n}} route",
  "apercu.count.routes_other": "{{n}} routes",
  "apercu.count.screens": "{{n}} écrans",
  "apercu.count.screens_one": "{{n}} écran",
  "apercu.count.screens_other": "{{n}} écrans",
  "apercu.description": "Lancer une révision générée, la voir à la taille d’un téléphone, d’une tablette ou d’un poste, la comparer et l’annoter.",
  "apercu.diff.absent": "absent des deux",
  "apercu.diff.added": "nouveau",
  "apercu.diff.changed": "a changé",
  "apercu.diff.identical": "identique",
  "apercu.diff.removed": "disparu",
  "apercu.empty": "Aucune application générée",
  "apercu.emptyHint": "Une révision naît d’une génération d’application depuis une spécification approuvée (écran Approbations).",
  "apercu.error.allLogs": "Journaux de tous les services",
  "apercu.error.composeUp": "Sortie de docker compose up",
  "apercu.error.emptyLog": "(journal vide)",
  "apercu.error.failedService": "Service en échec : {{service}}",
  "apercu.error.lastLines": "Dernières lignes de son journal :",
  "apercu.error.otherServices": "Autres services",
  "apercu.frame.emulated": "Largeur émulée : {{width}} px",
  "apercu.frame.loading": "Ouverture de l’aperçu…",
  "apercu.frame.refusedInvalid": "Aperçu non affiché : l’adresse d’accès reçue de la passerelle est invalide.",
  "apercu.frame.refusedSameHost": "Aperçu non affiché : son hôte est celui de l’outil. Configurez un nom d’hôte d’aperçu distinct (DOIT_PREVIEW_HOST).",
  "apercu.frame.reload": "Recharger",
  "apercu.frame.scaled": "affiché à {{pct}} %",
  "apercu.frame.titleRevision": "Aperçu de la révision {{short}}",
  "apercu.identity.builtAt": "construite le {{date}}",
  "apercu.identity.container": "conteneur : {{status}}",
  "apercu.identity.expires": "expire le {{date}}",
  "apercu.identity.isolated": "isolé · aucun port publié hors 127.0.0.1",
  "apercu.identity.job": "job {{job}}",
  "apercu.identity.label": "Identité de la révision",
  "apercu.identity.model": "modèle {{model}}",
  "apercu.identity.revision": "révision {{short}}",
  "apercu.loading": "Chargement des révisions…",
  "apercu.mode.annotate": "Annoter",
  "apercu.mode.compare": "Comparer deux révisions",
  "apercu.noWorkspace": "Sélectionnez un projet",
  "apercu.noWorkspaceHint": "Les aperçus appartiennent à un projet.",
  "apercu.notRunning": "Aucun aperçu vivant pour cette révision.",
  "apercu.openTab": "Ouvrir dans un onglet",
  "apercu.openTabFallback": "L’onglet ne s’est pas ouvert ? Utilisez ce lien (valable jusqu’à l’expiration du jeton).",
  "apercu.openTabHint": "Une application qui garde sa session par cookie se teste en plein onglet",
  "apercu.revision": "Révision",
  "apercu.revisionRefused": "contrôles non passés",
  "apercu.selection": "Révision affichée",
  "apercu.start.refused": "Aperçu refusé : {{reason}}",
  "apercu.start.refusedDefault": "Cette révision n’a pas passé ses contrôles.",
  "apercu.startAction": "Démarrer l’aperçu",
  "apercu.starting": "Démarrage en cours : construction de l’image, puis démarrage du conteneur isolé…",
  "apercu.status.failed": "en échec",
  "apercu.status.requested": "demandé",
  "apercu.status.running": "prêt",
  "apercu.status.starting": "démarrage",
  "apercu.status.stopped": "arrêté",
  "apercu.stop": "Arrêter",
  "apercu.stopRequested": "Arrêt demandé : le conteneur s’arrête.",
  "apercu.title": "Aperçu de l’application",
  "apercu.viewport.desktop": "Poste",
  "apercu.viewport.label": "Taille d’écran émulée",
  "apercu.viewport.phone": "Téléphone",
  "apercu.viewport.tablet": "Tablette",
  "apercu.writeActions": "Démarrer, arrêter ou annoter un aperçu",
  "nav./apercu": "Aperçus",
  "nav./architecture": "Architecture",
  "navdesc./apercu": "Voir, comparer et annoter une révision de l’application",
  "navdesc./architecture": "Composants, API, dépendances (SBOM) et vulnérabilités de l’application livrée, par version",
  "apercu.annotate.loadingSurvey": "Chargement du relevé de la révision…",
  "nav./tableau-de-bord": "Vue d’ensemble",
  "navdesc./tableau-de-bord": "Santé répartie, qualité, livraison et attention des projets de l’organisation",
  "nav./projet?vue=processus": "Cycle et processus",
  "navdesc./projet?vue=processus": "Exécutions de processus du projet : portes, approbations et reprises",
  "grp.Accueil": "Accueil",
  "grp.Boîte d’attention": "Boîte d’attention",
  "grp.Demandes": "Demandes",
  "grp.Produit": "Produit",
  "grp.Missions": "Missions",
  "grp.Application": "Application",
  "grp.Organisation": "Organisation",
  "nav.attentionCount": "{{n}} décision(s) en attente",
  "nav.sectionUnread": "{{n}} notification(s) non lue(s)",
  "nav.sectionToggle": "Écrans de la section {{section}}",
  "demande.niveau.prefixe": "Approbation · niveau",
  "demande.ligne.action": "Action",
  "demande.ligne.cible": "Cible",
  "demande.ligne.contenu": "Contenu",
  "demande.ligne.raison": "Raison",
  "demande.ligne.impact": "Impact",
  "demande.ligne.retour": "Retour",
  "demande.sod.deuxPersonnes": "Mode deux personnes : vous avez demandé cet objet à risque faible, relu par {{r}} — vous pouvez le décider ; la décision portera la mention « mode deux personnes ».",
  "demande.sod.libre": "Séparation des tâches : vous n’avez ni demandé ni relu cet objet — vous pouvez l’approuver.",
  "demande.deuxPersonnesActif": "Mode deux personnes actif dans ce projet (risque faible seulement).",
  "demande.approuverPorte": "Approuver (porte)",
  "demande.preuves": "Preuves",
  "demande.gate.ok": "réussi",
  "demande.gate.ko": "échoué",
  "demande.gate.absent": "non évalué",
  "demande.gate.controles": "{{n}} contrôle(s) réussi(s)",
  "demande.gate.echecs": "en échec : {{c}}",
  "demande.revueIndependante": "Revue indépendante",
  "demande.revueAbsente": "pas encore relue",
  "demande.avisJuge": "Avis du juge",
  "demande.avis": "AVIS",
  "demande.score": "score {{s}}",
  "demande.provenance": "Provenance",
  "demande.detail": "Détail du contenu",
  "lectureSpec.aucuneExigence": "Aucune exigence numérotée n’a été trouvée : le texte intégral est dans le registre technique.",
  "lectureSpec.detailTechnique": "Détail technique",
  "lectureSpec.registreMetier": "Registre métier : l’en-tête technique ({{carte}}, modèle, chemins) est masqué ; « Détails techniques » l’affiche.",
  "demande.objet.spec": "la spécification{{nom}}{{v}}",
  "demande.objet.cadrage": "le cadrage{{nom}}{{v}}",
  "demande.objet.autre": "l’artefact « {{nom}} »{{v}}",
  "demande.contenu.diff": " · +{{a}} −{{r}} lignes depuis v{{p}}",
  "demande.contenu.exigences": "{{n}} exigence(s) · {{l}} lignes",
  "demande.contenu.lignes": "{{l}} lignes",
  "demande.gate.reussi": "{{g}} : réussi{{s}}",
  "demande.gate.echoue": "{{g}} : échoué",
  "demande.revue": "relue par {{r}} ({{v}})",
  "demande.demandeePar": "Demandée par {{u}}",
  "demande.impact.specMetier": "Elle devient la base de la construction de l’application et du backlog",
  "demande.impact.spec": "Base du job scaffold_app et de la génération du backlog",
  "demande.impact.cadrage": "La spécification pourra être générée à partir de ce cadrage",
  "demande.impact.autre": "L’artefact est publié dans le projet",
  "demande.retour.spec": "Une nouvelle version de la spécification la remplace ; ce qui a été construit reste tracé",
  "demande.retour.autre": "Une nouvelle version peut le remplacer ; la décision reste au journal",
  "demande.titre": "Approuver {{objet}}",
  "demande.action.spec": "Figer {{objet}}",
  "demande.action.autre": "Approuver {{objet}}",
  "profil.vueLabel": "Vue",
  "profil.suggeree": "Vue suggérée d’après votre rôle : choisissez la vôtre.",
  "profil.roleAcces": "Rôle d’accès : {{role}}",
  "accueil.synthese": "Synthèse du projet",
  "accueil.vueDe": "Accueil · vue {{vue}}{{projet}}",
  "accueil.vueSuggeree": "Vue suggérée d’après votre rôle d’accès ({{role}}) : choisissez la vôtre dans « Vue », en bas de la navigation. Changer de vue ne change aucun droit.",
  "accueil.profilsExerces": "Les profils que j’exerce",
  "accueil.profilsExercesAide": "La vue combinée montre le premier bloc de chacun ; sans choix, les cinq.",
  "demande.resumeAria": "Résumé de la demande",
  "demande.allerDecision": "Aller à la décision",
  "demande.preuvesEtDetail": "Preuves et détail",
  "attention.defectSubtitle": "résolue par {{w}} · sévérité {{s}} · la reproduction doit repasser au vert",
  "attention.waiverSubtitle": "demandée par {{w}} · à relire puis décider",
  "attention.waiverExpiredSubtitle": "échue : l’exigence repasse non conforme · responsable {{w}}",
  "attention.detail.defectWhy": "Correctif livré : rejouer la reproduction ; qui l’a résolue ne peut pas la vérifier.",
  "attention.openDefect": "Vérifier l’anomalie",
  "attention.openWaivers": "Ouvrir les dérogations",
  "attention.kind.defect_to_verify": "Anomalie à vérifier",
  "attention.kind.waiver_to_decide": "Dérogation à rendre",
  "attention.kind.waiver_expired": "Dérogation échue",
  "accueil.dev.aRevoir": "À revoir",
  "accueil.dev.aRevoirAide": "Artefacts générés en attente de revue, et dernières révisions avec leurs contrôles.",
  "accueil.dev.rienARevoir": "Rien à revoir pour l’instant.",
  "accueil.dev.gateReussi": "réussi",
  "accueil.dev.gateEchoue": "échoué",
  "accueil.dev.gateAbsent": "non évalué",
  "accueil.dev.revoir": "Revoir",
  "accueil.dev.controles": "contrôles {{p}}/{{n}}",
  "accueil.dev.montrable": "montrable",
  "accueil.dev.aCorriger": "à corriger",
  "accueil.dev.ouvrir": "Ouvrir",
  "accueil.dev.arretees": "Tâches où la colonie s’est arrêtée",
  "accueil.dev.aucuneArretee": "Aucune tâche arrêtée : la colonie n’attend personne.",
  "accueil.dev.motif": "Motif :",
  "accueil.dev.prendreLaMain": "Prendre la main",
  "accueil.dev.echecs": "Traitements en échec",
  "accueil.dev.aucunEchec": "Aucun traitement en échec.",
  "accueil.metier.livreeLe": "livrée le {{d}}",
  "accueil.metier.aVoir": "version {{r}} à voir · construite le {{d}}",
  "accueil.metier.constructionRefusee": "la dernière construction n’est pas montrable : {{m}}",
  "accueil.metier.enConstruction": "construction en cours depuis le {{d}}",
  "accueil.metier.aApprouver": "à approuver · demandée le {{d}}",
  "accueil.metier.approuvee": "approuvée le {{d}}",
  "accueil.metier.ideeDeposee": "idée déposée le {{d}}",
  "accueil.metier.etapesAria": "Étape : {{e}}",
  "accueil.metier.aDecider": "Ce qui attend ma décision",
  "accueil.metier.rienADecider": "Rien n’attend votre décision pour l’instant.",
  "accueil.metier.mesDemandesAide": "Chaque demande à son étape, du dépôt de l’idée à la livraison.",
  "accueil.metier.aucuneDemande": "Aucune demande pour l’instant",
  "accueil.metier.aucuneDemandeAide": "Déposez une idée : elle apparaîtra ici à chaque étape, jusqu’à l’application livrée.",
  "accueil.metier.derniereVersion": "La dernière version de l’application",
  "accueil.metier.versionConstruite": "{{v}} {{r}} · {{c}} contrôles sur {{n}} réussis",
  "accueil.metier.voir": "Voir",
  "accueil.metier.aucuneVersion": "Aucune version montrable pour l’instant : elle apparaîtra dès que sa construction aura réussi ses contrôles.",
  "accueil.po.sprint": "Sprint en cours",
  "accueil.po.ouvrirSprints": "Ouvrir les sprints",
  "accueil.po.aucunSprint": "Aucun sprint actif ni planifié : planifiez-en un depuis le projet.",
  "accueil.po.vraimentFini": "Vraiment fini ?",
  "accueil.po.vraimentFiniAide": "Une exigence n’est finie que si des tests la couvrent et qu’aucune anomalie ne reste ouverte.",
  "accueil.po.aucuneExigence": "Aucune exigence tracée dans ce projet.",
  "accueil.po.nonCouverte": "non couverte",
  "accueil.po.anomaliesOuvertes": "{{n}} anomalie(s) encore ouverte(s) dans le projet : une exigence qu’elles touchent n’est pas finie",
  "accueil.po.decisions": "Décisions à rendre",
  "accueil.po.aucuneDecision": "Aucune décision d’architecture ni dérogation en attente.",
  "accueil.po.decider": "Décider",
  "accueil.po.derogation": "Dérogation · {{c}} — risque {{r}}",
  "accueil.po.examiner": "Examiner",
  "accueil.release.prete": "prête",
  "accueil.release.pasPrete": "pas prête : {{n}} raison(s) bloquante(s)",
  "accueil.release.approbationsDetail": "{{a}} environnement(s) approuvé(s) sur {{n}}",
  "accueil.release.deployeSur": "déployée sur {{e}}",
  "accueil.release.deployable": "déployable",
  "accueil.release.nonDeployable": "aucun environnement ne l’accepte encore (raisons dans la fiche)",
  "accueil.release.livraisonDetail": "lien {{l}} · {{n}} document(s) · notes {{p}}",
  "accueil.release.lienPublie": "publié",
  "accueil.release.lienAbsent": "absent",
  "accueil.release.notesPubliees": "publiées",
  "accueil.release.notesNonPubliees": "non publiées",
  "accueil.release.preparation": "Préparation de la version",
  "accueil.release.ouvrirVersion": "Ouvrir la version",
  "accueil.release.aucuneVersion": "Aucune version préparée : commencez par en préparer une.",
  "accueil.release.parcours": "Parcours de livraison",
  "accueil.release.parcoursAide": "Chaque étape ouvre sa section de la fiche de la version.",
  "accueil.release.parcoursVide": "Le parcours apparaît dès qu’une version est préparée.",
  "accueil.release.fait": "fait",
  "accueil.release.bloque": "bloqué",
  "accueil.release.aFaire": "à faire",
  "accueil.release.ouvrir": "Ouvrir",
  "accueil.release.livre": "Ce qui a été livré, à qui, avec quelles preuves",
  "accueil.release.rienLivre": "Aucune version livrée pour l’instant.",
  "accueil.release.preuves": "Preuves",
  "accueil.testeur.campagne": "Campagne « {{n}} »",
  "accueil.testeur.campagneEnCours": "Campagne en cours",
  "accueil.testeur.campagneAide": "{{n}} cas · {{e}} · verdict de la dernière exécution par cas",
  "accueil.testeur.executer": "Exécuter la campagne",
  "accueil.testeur.verts": "verts",
  "accueil.testeur.rouges": "rouges ou bloqués",
  "accueil.testeur.nonExecutes": "non exécutés",
  "accueil.testeur.aucuneCampagne": "Aucune campagne ouverte : ouvrez-en une depuis l’écran Tests.",
  "accueil.testeur.executionsRouges": "Exécutions rouges",
  "accueil.testeur.aucuneRouge": "Aucune exécution rouge dans la campagne en cours.",
  "accueil.testeur.voirAnomalie": "Voir l’anomalie ANO-{{n}}",
  "accueil.testeur.declarer": "Déclarer une anomalie",
  "accueil.testeur.aVerifier": "Résolues, à vérifier",
  "accueil.testeur.rienAVerifier": "Aucune anomalie résolue n’attend de vérification.",
  "accueil.testeur.verifier": "Vérifier",
  "accueil.testeur.sansTest": "Exigences sans test",
  "accueil.testeur.toutesTestees": "Toutes les exigences tracées ont au moins un test.",
  "accueil.testeur.traceabilite": "Voir la traçabilité",
  "accueil.colonie.titreMetier": "Ce que l’équipe automatique fait en ce moment",
  "accueil.colonie.titre": "Missions de la colonie en cours",
  "accueil.colonie.aucuneMetier": "Aucun travail automatique en cours.",
  "accueil.colonie.aucune": "Aucune mission de la colonie en cours.",
  "accueil.colonie.progression": "{{f}} tâche(s) faite(s) sur {{n}}",
  "accueil.colonie.budget": "Minutes de GPU : {{c}} / {{b}} · escalades : {{e}} / {{me}}",
  "accueil.colonie.decisions": "{{n}} décision(s) vous attend(ent)",
  "accueil.colonie.rienDemande": "Rien ne vous est demandé pour l’instant.",
  "attention.kind.mission_task_stopped.metier": "Équipe automatique arrêtée",
  "attention.kind.defect_to_verify.metier": "Problème corrigé à vérifier",
  "attention.kind.waiver_to_decide.metier": "Exception demandée à décider",
  "attention.kind.waiver_expired.metier": "Exception expirée",
  "profil.metier": "Métier",
  "profil.po": "Product owner",
  "profil.dev": "Développeur",
  "profil.testeur": "Testeur",
  "profil.release": "Release manager",
  "profil.combinee": "Vue combinée",
  "profil.role.owner": "propriétaire",
  "profil.role.contributor": "contributeur",
  "profil.role.viewer": "lecteur",
  "accueil.titre.metier": "Les demandes du projet et ce qui attend ma décision",
  "accueil.titre.po": "Le sprint en cours, les missions de la colonie et ce qui est vraiment fini",
  "accueil.titre.dev": "Ce que la colonie a produit à revoir, et les tâches où elle s’est arrêtée",
  "accueil.titre.testeur": "La campagne en cours, les anomalies à vérifier et les exigences sans test",
  "accueil.titre.release": "La version est-elle prête ? Ce qui a été livré, à qui, avec quelles preuves",
  "accueil.titre.combinee": "Les blocs de chacun de vos profils, sur une seule page",
  "accueil.metier.etape.idee": "idée",
  "accueil.metier.etape.cadree": "cadrée",
  "accueil.metier.etape.specifiee": "spécifiée",
  "accueil.metier.etape.construction": "en construction",
  "accueil.metier.etape.a_voir": "à voir",
  "accueil.metier.etape.livree": "livrée",
  "accueil.po.etat.todo": "à faire",
  "accueil.po.etat.in_progress": "en cours",
  "accueil.po.etat.in_review": "en revue",
  "accueil.po.etat.done": "faites",
  "accueil.release.etape.version": "Prête ?",
  "accueil.release.etape.approbations": "Approbations par environnement",
  "accueil.release.etape.deploiement": "Déploiement",
  "accueil.release.etape.livraison": "Lien et documentation",
  "demande.niveau.reversible": "réversible seul",
  "demande.niveau.reversible_aide": "réversible avec aide",
  "demande.niveau.irreversible": "irréversible — porte",
  "deuxPersonnes.refus.SELF_APPROVAL_REFUSED": "Vous avez demandé cet objet et le mode deux personnes n’est pas actif dans ce projet : un autre membre doit l’approuver.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_PRODUCTION": "Promotion en production : trois personnes distinctes restent exigées, même en mode deux personnes.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_SECURITY": "Objet de sécurité : trois personnes distinctes restent exigées, même en mode deux personnes.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_WAIVER": "Dérogation : trois personnes distinctes restent exigées, même en mode deux personnes.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_ONE_WAY_DECISION": "Décision à sens unique : trois personnes distinctes restent exigées, même en mode deux personnes.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_RISK_NOT_LOW": "Le mode deux personnes ne vaut que pour un risque faible : cet objet est classé plus haut.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_REVIEWER_REQUIRED": "Le mode deux personnes exige d’abord la revue d’un autre membre : faites relire cet objet.",
  "registre.scaffold_app.technique": "job scaffold_app",
  "registre.scaffold_app.metier": "construction de l’application",
  "registre.revision.technique": "révision",
  "registre.revision.metier": "version de l’application",
  "registre.prompt_card.technique": "carte de prompt",
  "registre.prompt_card.metier": "modèle de travail",
  "registre.spec_gate.technique": "Spec Gate",
  "registre.spec_gate.metier": "contrôle de la spécification",
  "registre.anomalie.technique": "anomalie",
  "registre.anomalie.metier": "problème signalé",
  "registre.mission.technique": "mission",
  "registre.mission.metier": "travail automatique",
  "registre.caste.technique": "caste",
  "registre.caste.metier": "équipe automatique",
  "registre.colonie.technique": "colonie",
  "registre.colonie.metier": "équipe automatique",
  "registre.promotion.technique": "promotion",
  "registre.promotion.metier": "mise à disposition",
  "registre.job.technique": "job",
  "registre.job.metier": "traitement",
  "registre.plan_mission.technique": "plan de mission",
  "registre.plan_mission.metier": "plan du travail automatique",
  "registre.derogation.technique": "dérogation",
  "registre.derogation.metier": "exception accordée",
  "registre.exigence.technique": "exigence",
  "registre.exigence.metier": "règle à respecter",
  "registre.deploiement.technique": "déploiement",
  "registre.deploiement.metier": "mise en service",
  "lectureSpec.affichage": "Affichage",
  "lectureSpec.registre.metier": "Registre métier",
  "lectureSpec.registre.technique": "Registre technique",
  "demande.risqueAuCentre": "Décidez-en dans le Centre d’approbations, qui porte ces champs.",
  "risque.releve": "Catégorie de risque relevée",
  "risque.faible": "faible",
  "risque.moyen": "moyen",
  "risque.eleve": "élevé",
  "risque.actuel": "Catégorie de risque : {{c}}",
  "risque.maximum": "Déjà au plus haut : rien à relever.",
  "risque.releverForm": "Relever la catégorie de risque",
  "risque.releverA": "Relever à",
  "risque.choisir": "Choisir…",
  "risque.relever": "Relever",
  "risque.aide": "Se relève, jamais ne s’abaisse ; au-dessus de « faible », trois personnes distinctes redeviennent exigées.",
  "profil.revenirSuggestion": "Revenir à la vue suggérée",
  "profil.erreurConcurrente": "Votre vue a été changée ailleurs entre-temps : la valeur enregistrée est affichée, choisissez à nouveau.",
  "accueil.metier.rienADeciderLecteur": "Votre rôle d’accès ne rend pas de décision dans ce projet : vous suivez les demandes ci-dessous.",
  "accueil.metier.demandesProjet": "Les demandes du projet",
  "profil.role.admin": "administrateur de la plateforme",
  "profil.roleOrganisation": "Rôle dans l’organisation : {{role}}",
  "design.charter.colorPicker": "Choisir la couleur dans le nuancier",
  "design.charter.createdBy": "par {{author}} le {{date}}",
  "design.charter.customLabel": "Couleur (#rrggbb)",
  "design.charter.density": "Densité",
  "design.charter.designMd": "DESIGN.md : mise en page, composants, voix des libellés",
  "design.charter.hexInvalid": "Saisissez une couleur au format #rrggbb (par exemple #0a5f63).",
  "design.charter.hexRequired": "Saisissez la couleur principale au format #rrggbb (par exemple #0a5f63).",
  "design.charter.hideJson": "Masquer le JSON des jetons",
  "design.charter.history": "Historique des versions",
  "design.charter.historyEmpty": "Aucune version enregistrée pour ce projet.",
  "design.charter.json": "JSON",
  "design.charter.jsonLabel": "JSON des jetons",
  "design.charter.jsonOf": "Jetons W3C DTCG de la version v{{version}} · empreinte {{sha}}",
  "design.charter.loading": "Chargement de la charte…",
  "design.charter.loadingJson": "Chargement des jetons…",
  "design.charter.logo": "Logo (texte)",
  "design.charter.logoCount": "{{count}} / {{max}} caractères",
  "design.charter.logoStyle": "Présentation du logo",
  "design.charter.noneValidated": "Aucune version validée : la génération applique la charte par défaut.",
  "design.charter.originOrganisation": "héritée de l’organisation",
  "design.charter.originProject": "propre au projet",
  "design.charter.primary": "Couleur principale",
  "design.charter.save": "Enregistrer la version",
  "design.charter.saved": "Version v{{version}} enregistrée en brouillon : une autre personne de l’espace doit la valider.",
  "design.charter.showJson": "Voir le JSON des jetons",
  "design.charter.showJsonOf": "Voir le JSON des jetons de la version v{{version}}",
  "design.charter.title": "Charte, sans jargon",
  "design.charter.typography": "Typographie",
  "design.charter.validate": "Valider cette version",
  "design.charter.validatedBy": "validée par {{who}} le {{date}}",
  "design.charter.validatedInfo": "Version validée : v{{version}} ({{semver}}). Seule une version validée part en génération.",
  "design.charter.voice": "Voix des libellés",
  "design.conformance.axe": "axe AA",
  "design.conformance.axeCount": "{{count}} violation(s)",
  "design.conformance.axeUnavailable": "axe n’a pas tourné sur cette révision",
  "design.conformance.axeVersion": "axe-core {{version}}",
  "design.conformance.charterDefault": "Charte appliquée : charte par défaut (aucune version validée à la génération).",
  "design.conformance.charterUnknown": "Charte appliquée : inconnue.",
  "design.conformance.charterValidated": "Charte appliquée : version validée v{{version}} ({{semver}}).",
  "design.conformance.colorOn": "{{value}} sur « {{screen}} » ({{count}} élément(s))",
  "design.conformance.colors": "Couleurs hors jetons",
  "design.conformance.colorsMeasured": "Couleurs mesurées sur les valeurs calculées par le navigateur :",
  "design.conformance.colorsNoDetail": "{{count}} couleur(s) hors jetons, sans détail par élément dans le relevé.",
  "design.conformance.colorsNone": "Aucune couleur hors jetons sur les valeurs calculées par le navigateur.",
  "design.conformance.colorsPartial": "Examen partiel des couleurs sur {{screens}} : la page dépasse le plafond d’éléments examinés, le reste n’est pas mesuré.",
  "design.conformance.digestMismatch": "empreinte différente",
  "design.conformance.exampleScreen": "« {{screen}} » ({{property}})",
  "design.conformance.examples": "Exemples de violations",
  "design.conformance.floor": "L’automate est un plancher, pas une preuve de conformité : le reste relève d’une revue humaine.",
  "design.conformance.flowScreens": "Écrans du parcours",
  "design.conformance.loading": "Chargement de la conformité…",
  "design.conformance.loadingRevisions": "Chargement des révisions…",
  "design.conformance.missing": "Écrans du parcours absents de l’application ({{count}}) :",
  "design.conformance.noFlow": "aucun parcours validé à comparer",
  "design.conformance.noRevision": "Aucune révision générée",
  "design.conformance.noRevisionHint": "La conformité se mesure sur une application en marche : générez l’application depuis une spécification approuvée, puis lancez son aperçu.",
  "design.conformance.noSurvey": "relevé absent",
  "design.conformance.notMeasured": "non mesuré",
  "design.conformance.outside": "Écrans hors parcours",
  "design.conformance.outsideList": "Écrans hors parcours : {{routes}}",
  "design.conformance.perScreen": "Détail par écran ({{count}})",
  "design.conformance.revision": "Révision",
  "design.conformance.screenAxe": "axe : {{count}} violation(s)",
  "design.conformance.screenAxeNot": "axe non mesuré ({{reason}})",
  "design.conformance.screenColors": "{{count}} couleur(s) hors jetons",
  "design.conformance.screenColorsNot": "couleurs non mesurées ({{reason}})",
  "design.conformance.screenColorsPartial": "(examen partiel : {{checked}} éléments)",
  "design.conformance.title": "Conformité d’interface — révision {{short}} (application en marche)",
  "design.conformance.titleNone": "Conformité d’interface (application en marche)",
  "design.conformance.tokensMismatch": "Feuille tokens.css servie (HTTP {{status}}), mais ce n’est PAS la feuille de cette révision : {{reason}}.",
  "design.conformance.tokensNotServed": "Feuille tokens.css NON servie (HTTP {{status}}) : {{reason}}. Les couleurs d’une page qui n’a pas chargé ses jetons ne sont pas mesurées.",
  "design.conformance.tokensOk": "Feuille tokens.css servie (HTTP {{status}}) : c’est bien la feuille de cette révision.",
  "design.conformance.tokensUnknown": "Feuille tokens.css : non vérifiée pour cette révision.",
  "design.conformance.unavailable": "Pas encore de relevé de conformité pour cette révision : il est produit quand son aperçu a tourné.",
  "design.contrast.failedPair": "{{label}} : {{ratio}} (minimum {{minimum}})",
  "design.contrast.insufficient": "contraste insuffisant",
  "design.contrast.notComputed": "contraste non calculé : couleur à compléter",
  "design.contrast.ok": "contraste {{ratio}} — conforme AA",
  "design.contrast.scope": "{{count}} paires vérifiées à chaque choix : textes, liens, boutons, focus, bordures des champs, messages (WCAG 2.2 AA).",
  "design.density.aeree": "Aérée",
  "design.density.compacte": "Compacte",
  "design.density.standard": "Standard",
  "design.description": "Le parcours d’écrans, les maquettes et la charte de l’application générée, puis sa conformité une fois en marche. Seules les versions validées partent en génération.",
  "design.flow.byCaste": "la caste designer",
  "design.flow.caption": "Chaque écran porte les exigences qu’il sert. Un écran sans exigence est signalé.",
  "design.flow.chooseSpec": "Choisissez une spécification approuvée.",
  "design.flow.empty": "Aucun parcours pour ce projet",
  "design.flow.emptyHint": "Proposez-en un depuis une spécification approuvée : la caste designer en dérive les écrans et les exigences qu’ils servent.",
  "design.flow.jobFailed": "en échec",
  "design.flow.jobRunning": "en cours",
  "design.flow.jobs": "Propositions de la caste designer",
  "design.flow.loading": "Chargement des parcours…",
  "design.flow.loadingDetail": "Chargement du parcours…",
  "design.flow.loadingSpecs": "Chargement des spécifications approuvées…",
  "design.flow.meta": "v{{version}} · {{screens}} écrans · {{transitions}} transitions · par {{author}} le {{date}}",
  "design.flow.model": "modèle {{model}}",
  "design.flow.noRequirement": "sans exigence",
  "design.flow.noSpec": "Aucune spécification approuvée : approuvez-en une dans l’écran Approbations, puis revenez proposer le parcours.",
  "design.flow.propose": "Proposer le parcours",
  "design.flow.proposeAction": "Proposer le parcours",
  "design.flow.proposed": "Proposition lancée (job {{job}}) : le parcours apparaîtra ici quand la caste designer aura terminé.",
  "design.flow.screensWithout": "Écrans qui ne servent aucune exigence : {{names}}",
  "design.flow.spec": "Spécification approuvée",
  "design.flow.title": "Parcours d’écrans",
  "design.flow.traced": "chaque exigence a son écran, chaque écran son exigence",
  "design.flow.unserved": "Exigences servies par aucun écran ({{count}}) :",
  "design.flow.validate": "Valider le parcours",
  "design.flow.version": "Version affichée",
  "design.flow.versionOption": "v{{version}} · {{status}} · {{count}} écrans",
  "design.logo.style.aucun": "Aucun",
  "design.logo.style.initiales": "Initiales",
  "design.logo.style.nom": "Nom",
  "design.noWorkspace": "Sélectionnez un projet",
  "design.noWorkspaceHint": "La charte, le parcours et les maquettes appartiennent à un projet.",
  "design.pair.control-border-on-background": "bordure des champs sur le fond des cartes",
  "design.pair.control-border-on-canvas": "bordure des champs sur le fond de page",
  "design.pair.danger-on-background": "message d'erreur sur le fond des cartes",
  "design.pair.focus-on-canvas": "anneau de focus sur le fond de page",
  "design.pair.link-on-background": "liens sur le fond des cartes",
  "design.pair.link-on-canvas": "liens sur le fond de page",
  "design.pair.muted-on-background": "texte secondaire sur le fond des cartes",
  "design.pair.muted-on-canvas": "texte secondaire sur le fond de page",
  "design.pair.on-primary": "texte des boutons sur la couleur principale",
  "design.pair.on-primary-strong": "texte des boutons survolés",
  "design.pair.success-on-background": "message de réussite sur le fond des cartes",
  "design.pair.text-on-background": "texte sur le fond des cartes",
  "design.pair.text-on-canvas": "texte sur le fond de page",
  "design.pair.warning-on-background": "message d'avertissement sur le fond des cartes",
  "design.palette.custom": "Autre couleur",
  "design.palette.label": "Palette {{name}}",
  "design.palette.name.bleu-nuit": "bleu nuit",
  "design.palette.name.brique": "brique",
  "design.palette.name.olive": "olive",
  "design.palette.name.personnalisee": "autre couleur",
  "design.palette.name.sarcelle": "sarcelle",
  "design.status.draft": "brouillon",
  "design.status.supersededF": "remplacée",
  "design.status.supersededM": "remplacé",
  "design.status.validatedF": "validée",
  "design.status.validatedM": "validé",
  "design.title": "Design de l’interface",
  "design.typography.chaleureuse": "Chaleureuse",
  "design.typography.sobre": "Sobre",
  "design.typography.technique": "Technique",
  "design.validate.selfRefused": "Vous en êtes l’auteur : l’auteur d’une version ne la valide jamais lui-même. Une autre personne de l’espace (contributeur ou propriétaire) doit la valider.",
  "design.voice.tutoiement": "Tutoiement",
  "design.voice.vouvoiement": "Vouvoiement",
  "design.wireframe.annotations": "Annotations de la maquette « {{name}} »",
  "design.wireframe.byCaste": "caste designer",
  "design.wireframe.byHuman": "saisie humaine",
  "design.wireframe.caption": "Volontairement sobres : le poli oriente les retours vers le superficiel.",
  "design.wireframe.drafts": "{{count}} brouillon(s)",
  "design.wireframe.empty": "Aucune maquette pour ce parcours",
  "design.wireframe.emptyHint": "La caste designer produit une maquette par écran avec le parcours.",
  "design.wireframe.frameTitle": "Maquette « {{name}} »",
  "design.wireframe.invalidUrl": "Maquette non affichée : l’adresse de rendu reçue de la passerelle est invalide.",
  "design.wireframe.isolation": "Chaque maquette est affichée sans aucun script ni accès à l’outil : c’est une sortie de modèle.",
  "design.wireframe.loading": "Ouverture de la maquette…",
  "design.wireframe.loadingList": "Chargement des maquettes…",
  "design.wireframe.noFlow": "Aucune maquette",
  "design.wireframe.noFlowHint": "Les maquettes accompagnent un parcours d’écrans : proposez d’abord le parcours.",
  "design.wireframe.title": "Maquettes basse fidélité",
  "design.writeActions": "Modifier le design",
  "nav./design": "Design",
  "navdesc./design": "Parcours d’écrans, maquettes et charte, puis la conformité d’une révision",
  "design.wireframe.meta": "v{{version}} · {{author}}",
  "design.you": "vous",
  "design.wireframe.validateShort": "Valider",
  "design.wireframe.validateNamed": "Valider la maquette « {{name}} »",
  "missions.col.criteria": "Critères couverts",
  "missions.plan.noCriteria": "aucun (ossature)",
  "missions.decision.approveDossier": "Approuver le dossier et fusionner",
  "missions.decision.rejectDossier": "Refuser le dossier",
  "missions.decision.errRejectDossier": "Refuser le dossier exige un motif.",
  "missions.decision.dossierSod": "Vous avez lancé cette mission : un autre membre doit approuver son dossier de preuves (séparation des tâches).",
  "missions.decision.dossierRef": "Dossier : {{ref}} · empreinte {{sha}}",
  "missions.decision.dossierReason": "Motif (pour refuser le dossier)",
  "missions.decision.dossierTitle": "Dossier de mission à approuver",
  "missions.reason.tests_refused": "suite de tests refusée deux fois",
  "missions.reason.task_not_converged": "tâche arrêtée sans convergence",
  "missions.reason.dossier_approval": "dossier de mission à approuver",
  "missions.reason.control_inconsistent": "contrôle incohérent (anomalie sur le contrôle)",
  "missions.form.modeUnavailable": "non disponible dans cette version",
  "missions.decision.dossierView": "Dossier de preuves et diff consolidé, à relire avant de décider",
  "missions.decision.dossierNoView": "Le dossier n’est pas servi : il ne peut pas être approuvé à l’aveugle.",
  "missions.suspension.executor": "exécuteur d’application indisponible (démon Docker, commande Docker ou révision qui ne démarre pas)",
  "missions.reason.executor_unavailable": "exécuteur d’application indisponible à répétition",
  "nav./technologies": "Choix et baseline",
  "navdesc./technologies": "Baseline technologique du projet, héritage par catégorie et profil de génération",
  "nav./technologies/changements": "Demandes de changement",
  "navdesc./technologies/changements": "Changer une valeur technologique : demande de changement ou propagation",
  "nav./exigences": "Exigences héritées",
  "navdesc./exigences": "Héritage du référentiel, renforcement, contrôle de présence et dérogations du projet",
  "nav./projet?vue=tableau": "Backlog",
  "navdesc./projet?vue=tableau": "Items du projet : tableau, liste, hiérarchie, graphe et prêt pour la colonie",
  "nav./projet?vue=sprints": "Sprints",
  "navdesc./projet?vue=sprints": "Sprints, planificateur et burndown",
  "nav./projet?vue=roadmap": "Roadmap",
  "navdesc./projet?vue=roadmap": "Epics et features datés, versions en jalons, sprints",
  "nav./supervision": "Supervision des agents",
  "navdesc./supervision": "Ce qui tourne dans le projet : missions, castes au travail, agents ; coût estimé et consommé étiquetés séparément",
  "nav./recette": "Recette métier",
  "navdesc./recette": "Validation d’une version par le métier : accepter ou refuser, remarques en anomalies",
  "nav./qualite": "Tableau de bord qualité",
  "navdesc./qualite": "Échappement, réouverture, délai de correction",
  "nav./publication": "Publication du code",
  "navdesc./publication": "Dépôt GitLab par révision, précondition, environnements reliés",
  "nav./exploitation": "Application en service",
  "navdesc./exploitation": "Version en production, sonde et documentation",
  "nav./programme": "Vue programme",
  "navdesc./programme": "Objectif, jalon, santé répartie, étape des projets, train et dépendances bloquantes",
  "nav./programme/membres": "Membres du programme",
  "navdesc./programme/membres": "Lister, ajouter, retirer les membres et leurs rôles",
  "nav./programme/projets": "Projets du programme",
  "navdesc./programme/projets": "Rattacher, détacher ; étape, pile et santé des projets",
  "nav./programme/roadmap": "Roadmap et train",
  "navdesc./programme/roadmap": "Sprints, jalons et versions du programme",
  "nav./programme/backlog": "Backlog et initiatives",
  "navdesc./programme/backlog": "Cadrage ou génération d’epics et trace des initiatives lancées",
  "nav./programme/dependances": "Dépendances inter-projets",
  "navdesc./programme/dependances": "Carte des dépendances entre les projets du programme",
  "nav./programme/gouvernance": "Gouvernance et standards",
  "navdesc./programme/gouvernance": "Référentiel du programme, qui renforce celui de l’organisation",
  "nav./programme/technologies": "Choix technologiques du programme",
  "navdesc./programme/technologies": "Héritage du catalogue, standard du programme et baseline",
  "nav./programme/technologies?vue=changements": "Demandes de changement du programme",
  "navdesc./programme/technologies?vue=changements": "Portefeuille des demandes de changement des projets du programme",
  "nav./programme/versions": "Versions du programme",
  "navdesc./programme/versions": "Le train des versions, en lecture agrégée",
  "nav./programme/capacite": "Coût et capacité",
  "navdesc./programme/capacite": "Minutes GPU consommées et estimées, missions en cours par projet",
  "nav./programme/reglages": "Réglages du programme",
  "navdesc./programme/reglages": "Nom, propriétaire, statut, gabarit par défaut",
  "nav./org/projets": "Projets",
  "navdesc./org/projets": "Projets de l’organisation : programme, santé, pile ; créer, rattacher, archiver",
  "nav./org/technologies": "Catalogue technologique",
  "navdesc./org/technologies": "Les choix technologiques dynamiques de l’organisation : catalogue, catégories, radar",
  "nav./org/derogations": "Dérogations",
  "navdesc./org/derogations": "Toutes les dérogations de l’organisation : par projet, risque, échéance et état",
  "nav./org/gouvernance": "Gouvernance et approbations",
  "navdesc./org/gouvernance": "Modes d’approbation et arrêt d’urgence de l’IA à la portée de l’organisation",
  "nav./org/harnais": "Harnais et agents",
  "navdesc./org/harnais": "Castes, agents personnalisés et leur promotion, finalités IA, serveurs MCP, connexions et modèles, supervision",
  "nav./org/acces": "Accès : rôles et politiques",
  "navdesc./org/acces": "Matrice des rôles, politiques d’accès et simulateur",
  "nav./org/conformite": "Conformité et audit",
  "navdesc./org/conformite": "Rétention, purge, export d’audit et historique des arrêts d’urgence",
  "nav./plateforme/sante": "Santé de la plateforme",
  "navdesc./plateforme/sante": "Santé par organisation, versions et profil du poste (GPU, moteur, modèles)",
  "nav./plateforme/file-gpu": "File GPU de la plateforme",
  "navdesc./plateforme/file-gpu": "Qui utilise le GPU maintenant, dans quel ordre, et ce qui est suspendu",
  "nav./plateforme/organisations": "Organisations",
  "navdesc./plateforme/organisations": "Provisionner, palier, suspendre",
  "nav./plateforme/ia": "Fournisseurs et modèles d’IA",
  "navdesc./plateforme/ia": "Connexions, modèles, raccordements, observabilité, canaux",
  "nav./plateforme/arret-ia": "Arrêt d’urgence de l’IA",
  "navdesc./plateforme/arret-ia": "Portée plateforme, arrêts actifs par organisation et historique commun",
  "nav./plateforme/executants": "Exécutants et file",
  "navdesc./plateforme/executants": "Exécutants, signes de vie et quarantaine",
  "nav./plateforme/harnais": "Cartes, castes et modèles du poste",
  "navdesc./plateforme/harnais": "Registre des cartes par caste, promotion, reçus, budget VRAM",
  "nav./plateforme/generation": "Profils de génération qualifiés",
  "navdesc./plateforme/generation": "Profils qualifiés, cas dorés et âge du dernier reçu valide",
  "nav./plateforme/continuite": "Continuité de la plateforme DoIt",
  "navdesc./plateforme/continuite": "Sauvegarde de l’état de DoIt lui-même, rétention, essai de restauration",
  "nav./plateforme/journal": "Journal du super-administrateur",
  "navdesc./plateforme/journal": "Toute action de la plateforme sur une organisation",
  "nav./plateforme/acces-exceptionnels": "Accès exceptionnels actifs",
  "navdesc./plateforme/acces-exceptionnels": "Sessions d’accès exceptionnel en cours et révocation",
  "nav./plateforme/decisions": "Décisions de l’outil",
  "navdesc./plateforme/decisions": "Décisions d’architecture de DoIt",
  "grp.Planifier": "Planifier",
  "grp.Construire": "Construire",
  "grp.Vérifier": "Vérifier",
  "grp.Livrer et exploiter": "Livrer et exploiter",
  "grp.Référentiel et technologies": "Référentiel et technologies",
  "grp.Harnais": "Harnais",
  "acces.description": "Matrice des rôles, politiques d’accès et simulateur. Réservé à l’administration.",
  "acces.onglets": "Sections de l’accès",
  "acces.roles": "Rôles et permissions",
  "acces.politiques": "Politiques d’accès",
  "admin.globalAiKillSwitchActif": "Actif à la portée plateforme : les nouvelles requêtes IA sont interrompues.",
  "admin.globalAiKillSwitchInactif": "Inactif à la portée plateforme.",
  "admin.globalAiKillSwitchLien": "Ouvrir l’arrêt d’urgence de l’IA",
  "app.attention": "Boîte d’attention",
  "app.attentionAria": "Boîte d’attention : {{n}} décision(s) en attente",
  "app.notificationsAria": "Notifications : {{n}} non lue(s)",
  "arret.active": "arrêt activé",
  "arret.activer": "Arrêter l’IA",
  "arret.bandeauRegion": "Arrêt d’urgence de l’IA",
  "arret.chargement": "Lecture de l’arrêt d’urgence…",
  "arret.confirmationOrganisation": "Confirmation : tapez le nom de l’organisation ({{org}})",
  "arret.confirmationPlateforme": "Confirmation : tapez « plateforme »",
  "arret.confirmationRequiseOrganisation": "Tapez le nom de l’organisation pour confirmer.",
  "arret.confirmationRequisePlateforme": "Tapez « plateforme » pour confirmer la bascule de toute la plateforme.",
  "arret.constateDetail": "— refus constaté à {{instant}} ; la cause est lisible par l’administration de votre organisation.",
  "arret.constateTitre": "Requêtes IA interrompues",
  "arret.etatActif": "Arrêt ACTIF depuis {{depuis}} — motif : « {{motif}} ».",
  "arret.etatInactif": "Aucun arrêt à cette portée : les requêtes IA sont permises par elle.",
  "arret.historique": "Historique commun",
  "arret.historiqueVide": "Aucune bascule enregistrée.",
  "arret.interrompu": "Interrompu",
  "arret.leve": "arrêt levé",
  "arret.lever": "Lever l’arrêt de l’IA",
  "arret.lienOrganisation": "Organisation › Gouvernance et approbations",
  "arret.lienPlateforme": "Plateforme › Arrêt d’urgence de l’IA",
  "arret.motif": "Motif (obligatoire, gardé dans l’historique)",
  "arret.motifRequis": "Indiquez un motif de 3 à 500 caractères : il reste dans l’historique.",
  "arret.orgsArretees": "Encore arrêtées par leur propre décision : {{n}} ({{liste}}). Lever la plateforme ne les rétablit pas.",
  "arret.pourquoi": "Pourquoi ? Cause et effets",
  "arret.regle": "L’IA est arrêtée si la plateforme OU votre organisation l’a arrêtée : lever l’une ne rétablit rien tant que l’autre reste active.",
  "arret.restePlateforme": "L’IA reste arrêtée par la plateforme depuis {{depuis}} : lever l’arrêt de l’organisation ne la rétablit pas.",
  "arret.restePossible": "Reste possible",
  "arret.restreintOrganisation": "Réservé à l’administration de l’organisation : l’état vous est signalé par le bandeau.",
  "arret.restreintPlateforme": "Réservé à l’administration de la plateforme.",
  "arret.titreOrganisation": "Arrêt d’urgence de l’IA — portée organisation",
  "arret.titrePlateforme": "Arrêt d’urgence de l’IA — portée plateforme",
  "arret.restentPossibles": "Restent possibles : arrêter un aperçu, revenir en arrière, déployer, exécuter les campagnes de tests et les pipelines.",
  "avenir.05x": "Cette entrée est {{marque}} : elle est visible pour que vous sachiez où elle vivra.",
  "avenir.beta": "Cet écran fait partie de la v0.5.0 ; il est livré par la vague {{vague}} de la nouvelle interface.",
  "avenir.enAttendant": "En attendant :",
  "avenir.inconnu": "Écran introuvable",
  "cmdk.general": "Général",
  "conformite.description": "Rétention, purge, export d’audit et historique des arrêts d’urgence.",
  "conformite.sansEspace": "Ouvrez un projet dans le sélecteur de contexte : l’export d’audit est encore lu par espace.",
  "contexte.plateforme": "Plateforme",
  "contexte.vueEnsemble": "Vue d’ensemble",
  "contexte.vueProgramme": "Vue du programme",
  "contexte.vueProjet": "Vue projet",
  "demenagement.avis": "Cet écran a déménagé : l’adresse {{ancienne}} mène désormais ici. Mettez vos signets à jour.",
  "demenagement.fermer": "Fermer l’avis de déménagement",
  "fil.region": "Fil d’Ariane",
  "gouvernance.description": "Modes d’approbation et arrêt d’urgence de l’IA à la portée de l’organisation.",
  "gouvernance.modes": "Modes d’approbation, deux ou trois personnes et architectes désignés : réglés aujourd’hui dans les",
  "nav.affichageProjet": "Affichage de la navigation du projet",
  "nav.itemUnread": "{{n}} notification(s) non lue(s)",
  "nav.modeComplet": "Complet",
  "nav.modeDecouverte": "Découverte",
  "nav.reserveAdministration": "réservé à l’administration",
  "nav.marque05x": "conçu, livré après la v0.5.0",
  "nav.niveau.projet": "Navigation du projet",
  "nav.niveau.programme": "Navigation du programme",
  "nav.niveau.organisation": "Navigation de l’organisation",
  "nav.niveau.plateforme": "Navigation de la plateforme",
  "nav.titreNiveau.projet": "Projet",
  "nav.titreNiveau.programme": "Programme",
  "nav.titreNiveau.organisation": "Organisation",
  "nav.titreNiveau.plateforme": "Plateforme",
  "plateforme.reserve": "Le niveau Plateforme est réservé au super-administrateur.",
  "reglages.pageDescription": "Modèles autorisés, quotas et intégrations du projet. La section choisie est dans l'adresse.",
  "reglages.title": "Réglages du projet",
  "vueProjet.chargement": "Lecture en cours…",
  "vueProjet.blocIndisponible": "{{titre}} indisponible : la lecture n’a pas répondu ; les autres blocs restent affichés.",
  "vueProjet.reessayer": "Réessayer ce bloc",
  "vueProjet.sansProjet": "Choisissez un projet dans le sélecteur de contexte ; la Vue projet porte toujours sur un projet.",
  "vueProjet.indicateurs05x": "Indicateurs (flux des changements technologiques, délai idée → livré, efficacité par caste et modèle) : conçus, livrés après la v0.5.0 — aucune de ces mesures n’existe encore côté passerelle.",
  "vueProjet.commence": "Ce projet commence.",
  "vueProjet.troisEtapes": "Trois étapes pour démarrer ; elles disparaissent dès la première demande.",
  "vueProjet.etape1": "Déposer une première demande",
  "vueProjet.etape2": "Décider la pile (ADR)",
  "vueProjet.etape3": "Inviter l’équipe",
  "vueProjet.sante": "Santé du projet",
  "vueProjet.santeCouleur": "Santé : {{c}}",
  "vueProjet.signaux": "Les 7 signaux",
  "vueProjet.detailSignaux": "Voir le détail des 7 signaux",
  "vueProjet.formule": "formule {{v}} · pire signal, jamais une moyenne",
  "vueProjet.detailCaption": "Santé — détail des 7 signaux",
  "vueProjet.prochaineAction": "Prochaine action pour vous",
  "vueProjet.equipe": "Équipe",
  "vueProjet.colonie": "la colonie · castes du harnais",
  "vueProjet.membres": "Membres et équipes",
  "vueProjet.pile": "Pile et profil",
  "vueProjet.decideePar": "décidée par",
  "vueProjet.profil": "profil",
  "vueProjet.baseline": "baseline technologique résumée ici après la v0.5.0",
  "vueProjet.pileAucune": "Aucune pile décidée : une ADR rend possible le signal « Générabilité ».",
  "vueProjet.jauge": "Jauge du cycle — demandes par étape",
  "vueProjet.jaugeTableau": "Voir la jauge en tableau",
  "vueProjet.jaugeCaption": "Jauge du cycle en tableau",
  "vueProjet.jaugeRegle": "chaque demande compte à l’étape la plus avancée atteinte par un de ses items (ARB-r2-09) · {{n}} demande(s) au projet",
  "vueProjet.missions": "Missions en cours",
  "vueProjet.aucuneMission": "Aucune mission en cours.",
  "vueProjet.version": "Version en préparation",
  "vueProjet.prete": "Prête ?",
  "vueProjet.ouvrirVersion": "Ouvrir la version",
  "vueProjet.aucuneVersion": "Aucune version en préparation.",
  "vueProjet.decisions": "Dernières décisions",
  "vueProjet.aucuneDecision": "Aucune décision enregistrée.",
  "vueProjet.attention": "Attention du projet",
  "vueProjet.boite": "Boîte d’attention (portée : ce projet)",
  "vueProjet.couleurVert": "vert",
  "vueProjet.couleurAmbre": "ambre",
  "vueProjet.couleurRouge": "rouge",
  "vueProjet.couleurSansObjet": "sans objet",
  "vueProjet.signalQualite": "Qualité",
  "vueProjet.signalLivraison": "Livraison",
  "vueProjet.signalDecisions": "Décisions",
  "vueProjet.signalConformite": "Conformité",
  "vueProjet.signalColonie": "Colonie",
  "vueProjet.signalExploitation": "Exploitation",
  "vueProjet.signalGenerabilite": "Générabilité",
  "vueProjet.santeSansObjet": "Sans objet : aucun signal n’a de donnée.",
  "vueProjet.santeVert": "Vert : tous les signaux disponibles sont verts.",
  "vueProjet.santeDeterminant": "{{signal}} : {{raison}}",
  "vueProjet.santeSeparateur": " ; ",
  "vueProjet.santeSignaux": "{{titre}} : {{nb}} signaux — {{detail}}.",
  "vueProjet.santeUnSignal": "{{titre}} : 1 signal — {{detail}}.",
  "vueProjet.etapeCadrage": "Cadrage",
  "vueProjet.etapeChoixTechno": "Choix technologiques",
  "vueProjet.etapeDesign": "Design",
  "vueProjet.etapeSpecification": "Spécification",
  "vueProjet.etapePlanification": "Planification",
  "vueProjet.etapeDeveloppement": "Développement par les agents",
  "vueProjet.etapeTests": "Tests et qualité",
  "vueProjet.etapeLivraison": "Livraison",
  "vueProjet.etapeExploitation": "Exploitation",
  "vueProjet.etatEnCours": "en cours",
  "vueProjet.etatRouverte": "rouverte",
  "vueProjet.etatFaite": "faite",
  "vueProjet.etatNonActivee": "non activée",
  "vueProjet.etatAVenir": "à venir",
  "vueProjet.jaugeAucune": "Aucune demande : toutes les étapes sont à venir.",
  "vueProjet.jaugeElement": "{{etape}} ({{nb}})",
  "vueProjet.jaugeElementPremier": "{{etape}} ({{nb}} demandes)",
  "vueProjet.jaugeElementPremierUn": "{{etape}} ({{nb}} demande)",
  "vueProjet.jaugeElementRouverte": "{{element}} rouverte",
  "vueProjet.jaugeEnCoursNonActivees": "En cours : {{liste}} ; non activée : {{inactives}}.",
  "vueProjet.jaugeEnCours": "En cours : {{liste}}.",
  "vueProjet.colSignal": "signal",
  "vueProjet.colEtat": "état",
  "vueProjet.colDetermine": "ce qui le détermine",
  "vueProjet.colSource": "source",
  "vueProjet.colEtape": "étape",
  "vueProjet.colDemandes": "demandes",
  "n28.titre": "Prochaine action",
  "n28.depuis": "depuis",
  "n28.enAttente": "en attente depuis",
  "n28.agir": "Y aller",
  "n28.egalite": "en cas d’égalité, la plus ancienne gagne",
  "n28.rien": "Rien ne vous attend ici.",
  "n28.autreRole": "Le {{role}} peut agir : {{action}}.",
  "nav./demandes": "Demandes",
  "navdesc./demandes": "Déposer une demande — son premier état est l’idée — et lancer son cadrage",
  "nav./specifications": "Spécifications",
  "nav./specifications/modifications": "Demandes de modification",
  "nav./projet/classement": "Classement du projet",
  "navdesc./specifications": "Spécifications approuvées, reçu Spec Gate, édition en nouvelle version et suite du parcours",
  "navdesc./specifications/modifications": "Demandes de modification des spécifications approuvées : justification, impact estimé, décision",
  "navdesc./projet/classement": "Étiquettes, composants et versions de classement : renommer, dater, supprimer",
  "arret.refusAction": "Les nouvelles requêtes IA sont temporairement interrompues.",
  "arret.refusPorteePlateforme": "Arrêt de l’IA sur la plateforme : la génération attendra la levée.",
  "arret.refusPorteeOrganisation": "Arrêt de l’IA dans votre organisation : la génération attendra la levée.",
  "arret.detailTechnique": "Détail technique",
  "concevoir.etapesSuivantes": "Étapes suivantes (générer le backlog)",
  "concevoir.genererApplication": "Ouvrir « Générer l’application »",
  "concevoir.suiteRefusPerime": "Reçu Spec Gate périmé (évaluation obsolète) : réévaluez la spécification avant d’en tirer la suite.",
  "concevoir.suiteRefusSansRecu": "Aucun reçu Spec Gate frais : réévaluez la spécification avant d’en tirer la suite.",
  "concevoir.suiteArretIA": "L’arrêt de l’IA refuse toute génération avant le clic ; l’écran s’ouvre, la génération attendra la levée.",
  "demandes.sansProjet": "Aucun projet sélectionné",
  "demandes.sansProjetHint": "Choisissez un projet dans la barre de contexte.",
  "demandes.title": "Demandes",
  "demandes.description": "Chaque demande a son état, de l’idée à la version livrée : idée, cadrée, spécifiée, en construction, à voir, livrée (§ 4.2). Le nom ouvre le fil de la demande.",
  "demandes.deposer": "Déposer une idée",
  "demandes.chargement": "Chargement des demandes…",
  "demandes.erreurGardee": "La liste n’a pas pu être lue ; la précédente reste affichée.",
  "demandes.vide": "Aucune demande dans ce projet",
  "demandes.videHint": "Une demande naît d’une idée déposée ; elle passe ensuite par ses états.",
  "demandes.filtreEtat": "Filtrer par état",
  "demandes.toutes": "Toutes",
  "demandes.etatAVenir": "À venir : la filiation demande → spécification → version n’existe pas encore dans les API.",
  "demandes.filtreDemandeur": "Demandeur",
  "demandes.tousDemandeurs": "Tous les demandeurs",
  "demandes.colDemande": "demande",
  "demandes.colEtat": "état de la demande",
  "demandes.colDemandeur": "demandeur",
  "demandes.colAge": "âge",
  "demandes.colItems": "items issus",
  "demandes.colActivite": "dernière activité",
  "demandes.colAttend": "attend",
  "demandes.itemsAVenir": "À venir : aucun lien demande → items dans les API.",
  "demandes.pied": "{{n}} demandes · triées par dernière activité",
  "demandes.filiationAVenir": "À venir : la filiation idée → cadrage → spécification → application n’existe pas encore dans les API. Une demande est lue ici sur son cadrage ; les états « spécifiée » à « livrée » et les items issus s’afficheront quand le serveur portera ce lien.",
  "demandes.filOuEnEst": "Où en est ma demande",
  "demandes.filDeposee": "déposée par {{qui}} le {{quand}} · cadrage v{{v}}",
  "demandes.cadrageRefuse": "cadrage refusé",
  "demandes.filEtats": "États de la demande",
  "demandes.filEtatsNote": "Cliquer sur un état ouvre l’entrée qui le porte ; le filtre sur cette demande est à venir.",
  "demandes.filItems": "Items issus de cette demande",
  "demandes.filItemsAVenir": "À venir : le lien demande → items n’existe pas encore dans les API (ASM-IA-10).",
  "demandes.ouvrirBacklog": "Ouvrir le Backlog",
  "demandes.filInitiative": "Initiative d’origine",
  "demandes.filInitiativeAVenir": "À venir : l’initiative d’origine n’est pas conservée avec la demande.",
  "demandes.filSuite": "Étapes suivantes",
  "demandes.filSuiteCadree": "Cadrage approuvé : options, personas, processus, epics ou spécification se lancent depuis ses étapes suivantes.",
  "demandes.filOuvrirSuite": "Étapes suivantes de la demande",
  "demandes.filSuiteArret": "L’arrêt de l’IA refuse toute génération avant le clic ; l’écran s’ouvre, la génération attendra la levée.",
  "demandes.filSuiteRefuse": "Le cadrage a été refusé : déposez l’idée à nouveau, reformulée.",
  "demandes.filSuiteIdee": "Le cadrage attend sa décision au centre d’approbations.",
  "demandes.filVoirCadrage": "Voir le cadrage à décider",
  "demandes.filTitre": "Demande",
  "demandes.filDescription": "Le fil de la demande : où elle en est, ce qui en est issu, et sa suite.",
  "demandes.retour": "Toutes les demandes",
  "demandes.chargementFil": "Chargement de la demande…",
  "demandes.introuvable": "Demande introuvable",
  "demandes.introuvableHint": "Elle n’appartient pas à ce projet, ou son cadrage a été remplacé.",
  "specs.perimeMotif": "Évaluation obsolète : le reçu Spec Gate ne vaut plus pour « Prêt pour la colonie ».",
  "specs.sansRecuMotif": "Aucun reçu Spec Gate frais pour cette version.",
  "specs.reevaluer": "Réévaluer (Spec Gate)",
  "specs.ouvrirVersion": "Ouvrir la version v{{v}}",
  "specs.reevaluerArret": "Le Spec Gate interroge un modèle : refusé pendant l’arrêt de l’IA ; réévaluez à la levée.",
  "specs.title": "Spécifications",
  "specs.description": "Les spécifications approuvées du projet, leur reçu Spec Gate et la suite du parcours : générer le backlog ou l’application.",
  "specs.editer": "Éditer une spécification",
  "specs.sansProjet": "Aucun projet ouvert",
  "specs.sansProjetHint": "Les spécifications appartiennent à un projet : ouvrez-le dans la barre de contexte.",
  "specs.chargement": "Chargement des spécifications…",
  "specs.erreurGardee": "La passerelle n’a pas répondu ; la liste précédente reste affichée.",
  "specs.vide": "Aucune spécification",
  "specs.videHint": "Une spécification naît d’une demande cadrée ; déposez d’abord une idée.",
  "specs.region1": "Spécifications du projet",
  "specs.filtre": "Filtrer les spécifications",
  "specs.toutes": "Toutes",
  "specs.perimes": "Reçu périmé",
  "specs.colSpec": "spécification",
  "specs.colVersion": "version",
  "specs.colDemande": "demande d’origine",
  "specs.colGate": "Spec Gate",
  "specs.colApprouvee": "approuvée par",
  "specs.colCouverture": "couverture",
  "specs.demandeAVenir": "À venir : lien spécification → demande absent des API.",
  "specs.couverture": "Couverture et traçabilité",
  "specs.couvertureAVenir": "À venir : « N critères / M cas liés » par spécification et la demande d’origine supposent une traçabilité filtrée par spécification, absente des API ; la couverture s’ouvre non filtrée.",
  "specs.suiteIntro": "Sur une spécification approuvée dont le reçu Spec Gate est frais, deux actions ouvrent la suite du parcours :",
  "editor.noProject": "Aucun projet ouvert",
  "editor.noProjectHint": "Les spécifications appartiennent à un projet : ouvrez-le dans la barre de contexte.",
  "editor.approved": "approuvée",
  "editor.suiteTitre": "La suite de cette spécification approuvée :",
  "editor.dmsDemander": "Demander une modification de la spécification",
  "editor.dmsAVenir": "À venir : la demande de modification de la spécification (DMS-n) — justification, impact estimé sur exigences, tests et backlog, relecture de l’architecte — n’a pas encore d’API. Elle ne se confond pas avec la demande de changement (CHG-n), réservée au changement technologique. La comparaison de deux versions suit le même chemin.",
  "dms.statut.open": "ouverte",
  "dms.statut.accepted": "acceptée",
  "dms.statut.refused": "refusée",
  "dms.statut.withdrawn": "retirée",
  "dms.comparerTitre": "Comparer deux versions",
  "dms.chargementVersions": "Chargement des versions de la spécification…",
  "dms.uneSeuleVersion": "Une seule version de cette spécification",
  "dms.uneSeuleVersionAide": "Rien à comparer : une nouvelle version naît de l’édition puis de son approbation.",
  "dms.versionA": "Version de départ",
  "dms.choisirVersion": "Choisir une version…",
  "dms.versionB": "Version comparée",
  "dms.memeVersion": "Choisissez deux versions différentes.",
  "dms.chargementDiff": "Comparaison en cours…",
  "dms.diffCompte": "{{ajouts}} ligne(s) ajoutée(s), {{retraits}} retirée(s)",
  "dms.envoyee": "Demande de modification enregistrée : elle attend une décision",
  "dms.demandeTitre": "Demander une modification de la spécification",
  "dms.demandeAide": "Une demande DMS-n dit ce qui doit changer et pourquoi ; un autre que vous la décide (propriétaire du projet ou architecte désigné). Elle ne se confond pas avec la demande de changement technologique (CHG-n).",
  "dms.chargement": "Chargement des demandes de modification…",
  "dms.lectureSeule": "Lecture seule : demander une modification est réservé aux propriétaires et contributeurs du projet.",
  "dms.dejaOuverte": "{{ref}} est déjà ouverte sur cette spécification : décidez-la ou retirez-la avant d’en ouvrir une autre.",
  "dms.formulaire": "Demande de modification",
  "dms.justification": "Justification (obligatoire) : ce qui doit changer et pourquoi",
  "dms.justificationCourte": "Justifiez en {{n}} caractères au moins.",
  "dms.niveau": "Impact estimé",
  "dms.niveauMineur": "Mineur : précision, sans effet sur le périmètre",
  "dms.niveauMajeur": "Majeur : exigences, tests ou backlog à reprendre",
  "dms.note": "Note d’impact (facultative)",
  "dms.impactCalcule": "À l’envoi, la passerelle calcule l’impact sur ce qu’elle sait : exigences de la version, items issus de la spécification, cas de test reliés.",
  "dms.toutes": "Toutes les demandes de modification du projet",
  "dms.listeTitre": "Demandes de modification des spécifications",
  "dms.listeDescription": "Chaque DMS-n : la spécification visée, la justification, l’impact estimé et la décision.",
  "dms.versSpecs": "Retour aux spécifications",
  "dms.filtre": "Statut",
  "dms.tous": "Tous",
  "dms.aucuneFiltre": "Aucune demande avec ce statut",
  "dms.aucune": "Aucune demande de modification",
  "dms.aucuneAide": "Une demande se fait depuis l’éditeur, sur une spécification approuvée.",
  "dms.majeur": "impact majeur",
  "dms.mineur": "impact mineur",
  "dms.decisionEnregistree": "Décision enregistrée",
  "dms.retiree": "Demande retirée",
  "dms.versListe": "Toutes les demandes de modification",
  "dms.introuvable": "Demande introuvable",
  "dms.chargementFiche": "Chargement de la demande…",
  "dms.introuvableAide": "Elle n’existe pas dans le projet ouvert.",
  "dms.retirerTitre": "Retirer {{ref}} ?",
  "dms.retirerConsequence": "La demande est close sans décision ; elle reste lisible dans l’historique.",
  "dms.retirerReversible": "Vous pourrez en ouvrir une nouvelle sur la même spécification.",
  "dms.retirer": "Retirer la demande",
  "dms.ficheTitre": "{{ref}} — demande de modification",
  "dms.statut": "Statut",
  "dms.source": "Version visée",
  "dms.demandeur": "Demandée par",
  "dms.justificationCourt": "Justification",
  "dms.retireePar": "Retirée par",
  "dms.decideePar": "Décidée par",
  "dms.impactTitre": "Impact calculé à la demande",
  "dms.exigences": "exigence(s) dans la version",
  "dms.items": "item(s) issus de la spécification",
  "dms.cas": "cas de test reliés",
  "dms.enAttente": "version(s) déjà en attente",
  "dms.itemsTouches": "Items touchés",
  "dms.versTracabilite": "Voir la traçabilité exigence → test",
  "dms.realisationTitre": "Réalisation",
  "dms.realiseePar": "Réalisée par la version",
  "dms.aRealiser": "Acceptée, pas encore réalisée :",
  "dms.realiser": "éditer la spécification",
  "dms.decisionTitre": "Décider",
  "dms.decisionNote": "Note (obligatoire pour refuser)",
  "dms.refusSansNote": "Dites pourquoi vous refusez (5 caractères au moins).",
  "dms.accepter": "Accepter la demande",
  "dms.refuser": "Refuser la demande",
  "dms.pasDecideur": "La décision revient au propriétaire du projet ou à un architecte désigné, jamais au demandeur.",
  "ideas.arretIA": "Les nouvelles requêtes IA sont temporairement interrompues : votre texte reste en brouillon sur ce poste.",
  "ideas.voirDemandes": "Voir la demande dans Demandes",
  "adr.noProject": "Aucun projet ouvert",
  "adr.noProjectHint": "Ouvrez un projet pour voir ses décisions ; la portée Outil reste lisible.",
  "adr.baseline05x": "En 0.5.x : cette entrée devient « Choix et baseline » — baseline technologique versionnée, héritage par catégorie (organisation → programme → projet), demande de changement (CHG-n) ou propagation. L’ADR et la matrice restent le chemin d’une catégorie définie pour ce projet.",
  "adr.voirBaseline": "Voir Choix et baseline (0.5.x)",
  "design.revisionEntiere": "La conformité vaut toujours pour la révision entière : elle ne se filtre pas par demande — un écart d’un écran touche toute l’application.",
  "design.voirApercus": "Voir et annoter dans Aperçus",
  "fileGpu.attente": "attente",
  "fileGpu.aVenir": "VRAM par tâche, modèle servi et créneau de qualification proposé : la passerelle ne les expose pas encore.",
  "fileGpu.carte": "carte",
  "fileGpu.chargement": "Lecture de la file GPU…",
  "fileGpu.compteurs": "{{q}} en file · {{r}} servie(s) · mise à jour toutes les 10 s · {{a}}",
  "fileGpu.erreur": "La file GPU n’a pas pu être lue.",
  "fileGpu.etat": "état",
  "fileGpu.legende": "Tâches servies et en attente, par rang",
  "fileGpu.organisation": "organisation",
  "fileGpu.plateforme": "plateforme",
  "fileGpu.rang": "rang",
  "fileGpu.refus": "La file GPU de la plateforme est réservée au super-administrateur.",
  "fileGpu.tache": "tâche",
  "fileGpu.titre": "File d’admission — toutes organisations",
  "fileGpu.tronquee": "Liste tronquée : les compteurs ci-dessus portent sur toute la file.",
  "fileGpu.vide": "La file GPU est vide",
  "fileGpu.videIndice": "Aucune tâche servie ni en attente, toutes organisations confondues.",
  "gouvernance.derogations": "Qui approuve une dérogation dépend de son risque : le résumé, les échéances et les décomptes sont tenus sur l’écran Dérogations.",
  "gouvernance.voirDerogations": "Ouvrir les dérogations",
  "journal.action": "action",
  "journal.arret": "arrêt d’urgence ({{portee}})",
  "journal.arrets": "Arrêts d’urgence de l’IA — toutes portées",
  "journal.aVenir": "Suspensions, paliers, connexions IA et suppressions : la passerelle n’expose pas encore le journal des actions de la plateforme sur une organisation. Seuls les arrêts d’urgence de l’IA sont journalisés ci-dessous.",
  "journal.chargement": "Lecture du journal…",
  "journal.detail": "détail",
  "journal.erreur": "Le journal n’a pas pu être lu.",
  "journal.evenement": "événement",
  "journal.legende": "Journal des arrêts d’urgence, du plus récent au plus ancien",
  "journal.levee": "levée de l’arrêt ({{portee}})",
  "journal.organisation": "organisation",
  "journal.par": "par",
  "journal.quand": "quand",
  "journal.refus": "Le journal de la plateforme est réservé au super-administrateur.",
  "journal.toutes": "toutes",
  "journal.vide": "Aucune action journalisée",
  "journal.videIndice": "Aucun arrêt d’urgence n’a encore été décidé.",
  "niveaux.aVenir": "à venir",
  "niveaux.nonAccessibles1": "1 projet ne vous est pas ouvert — ni nom, ni santé, ni jalon : un compte seulement.",
  "niveaux.nonAccessiblesN": "{{n}} projets ne vous sont pas ouverts — ni nom, ni santé, ni jalon : un compte seulement.",
  "orgProjets.actif": "actif",
  "orgProjets.archive": "archivé",
  "orgProjets.autreProgramme": "un programme dont vous n’êtes pas membre",
  "orgProjets.aVenir": "Étapes en cours, pile et santé par projet : la passerelle ne les agrège pas encore au niveau de l’organisation.",
  "orgProjets.chargement": "Lecture des projets…",
  "orgProjets.description": "Projets de l’organisation dont vous êtes membre ; les autres sont comptés, jamais nommés.",
  "orgProjets.erreur": "Les projets n’ont pas pu être lus.",
  "orgProjets.filtre": "Programme",
  "orgProjets.horsProgramme": "hors programme",
  "orgProjets.horsProgrammeOption": "Hors programme",
  "orgProjets.legende": "Projets dont vous êtes membre",
  "orgProjets.monRole": "mon rôle",
  "orgProjets.ouvrir": "Ouvrir",
  "orgProjets.programme": "programme",
  "orgProjets.projet": "projet",
  "orgProjets.refus": "Votre rôle ne permet pas de lister les projets de l’organisation.",
  "orgProjets.statut": "statut",
  "orgProjets.tous": "Tous les programmes",
  "orgProjets.vide": "Aucun projet à afficher",
  "orgProjets.videFiltre": "Aucun de vos projets ne correspond à ce programme.",
  "orgProjets.videIndice": "Vous n’êtes membre d’aucun projet de cette organisation.",
  "orgQualite.aucune": "aucune",
  "orgQualite.aVenir": "Campagnes ouvertes, dernière non-régression, « prête ? » et déploiements en échec : pas encore agrégés au niveau de l’organisation ; chaque projet les montre dans Vérifier et Livrer.",
  "orgQualite.bloquantes": "bloquantes ouvertes",
  "orgQualite.chargement": "Lecture des projets…",
  "orgQualite.compteur": "Anomalies bloquantes ouvertes : {{n}} — {{p}} projet(s) touché(s)",
  "orgQualite.deployee": "déployée sur",
  "orgQualite.description": "Qualité et livraison des projets dont vous êtes membre.",
  "orgQualite.erreur": "Les projets n’ont pas pu être lus.",
  "orgQualite.legende": "Qualité et livraison par projet",
  "orgQualite.nonLu": "non lu",
  "orgQualite.partiel": "Vue partielle : {{noms}} non lu(s).",
  "orgQualite.projet": "projet",
  "orgQualite.refus": "Votre rôle ne permet pas de lister les projets de l’organisation.",
  "orgQualite.titre": "Qualité et livraison",
  "orgQualite.version": "dernière version",
  "orgQualite.vide": "Aucun projet actif à suivre",
  "orgQualite.videIndice": "Vous n’êtes membre d’aucun projet actif de cette organisation.",
  "pgmMembres.actions": "actions",
  "pgmMembres.ajouter": "Ajouter",
  "pgmMembres.chargement": "Lecture des membres…",
  "pgmMembres.de": "Membres de {{nom}}",
  "pgmMembres.depuis": "depuis",
  "pgmMembres.dernier": "Dernier propriétaire : nommez d’abord un autre propriétaire.",
  "pgmMembres.detail": "Détail technique",
  "pgmMembres.erreur": "Les membres n’ont pas pu être lus.",
  "pgmMembres.identifiant": "Identifiant de l’utilisateur",
  "pgmMembres.legende": "Membres du programme et leur rôle",
  "pgmMembres.membre": "membre",
  "pgmMembres.refus": "Vous n’êtes pas membre de ce programme : sa liste de membres ne vous est pas ouverte.",
  "pgmMembres.regle": "Propriétaire et contributeur voient tous les projets rattachés (agrégats) ; un lecteur, les seuls projets dont il est membre. Ouvrir un projet exige d’en être membre.",
  "pgmMembres.requis": "Indiquez l’identifiant de l’utilisateur à ajouter.",
  "pgmMembres.reserve": "Réservé à un propriétaire du programme.",
  "pgmMembres.retirer": "Retirer",
  "pgmMembres.role": "rôle dans le programme",
  "pgmMembres.roleDe": "Rôle de {{nom}}",
  "pgmMembres.roleNouveau": "Rôle",
  "pgmMembres.vide": "Aucun membre",
  "pgmMembres.videIndice": "Le programme n’a encore aucun membre déclaré.",
  "pgmProjets.agregat": "agrégat seulement",
  "pgmProjets.aucunCandidat": "Aucun autre projet dont vous êtes membre à rattacher.",
  "pgmProjets.chargement": "Lecture des projets du programme…",
  "pgmProjets.de": "Projets rattachés à {{nom}} (0 ou 1 programme par projet)",
  "pgmProjets.dejaAutre": "Déjà rattaché à un autre programme : détachez-le d’abord.",
  "pgmProjets.dejaNomme": "Déjà rattaché au programme « {{nom}} » : détachez-le d’abord de ce programme.",
  "pgmProjets.detacher": "Détacher",
  "pgmProjets.erreur": "Les projets du programme n’ont pas pu être lus.",
  "pgmProjets.legende": "Projets rattachés au programme",
  "pgmProjets.monRole": "mon rôle",
  "pgmProjets.projet": "projet",
  "pgmProjets.raisonProprietaire": "Seul le propriétaire de ce projet, ou l’administrateur de la plateforme, peut le rattacher ou le détacher.",
  "pgmProjets.rattacher": "Rattacher",
  "pgmProjets.rattacherTitre": "Rattacher un projet",
  "pgmProjets.refus": "Vous n’êtes pas membre de ce programme : ses projets ne vous sont pas ouverts.",
  "pgmProjets.version": "version en préparation",
  "pgmProjets.vide": "Aucun projet rattaché",
  "pgmProjets.videIndice": "Rattachez ci-dessous un projet dont vous êtes propriétaire.",
  "pgmRoadmap.aVenir": "Frise graphique et jalon cible du programme : pas encore construits ; la même information est donnée en tableau.",
  "pgmRoadmap.chargement": "Lecture de la roadmap…",
  "pgmRoadmap.dates": "dates",
  "pgmRoadmap.dependances": "Dépendances inter-projets du train",
  "pgmRoadmap.description": "Sprints, jalons et versions des projets rattachés",
  "pgmRoadmap.erreur": "La roadmap du programme n’a pas pu être lue.",
  "pgmRoadmap.etat": "état",
  "pgmRoadmap.jalons": "Versions en préparation :",
  "pgmRoadmap.legende": "Sprints des projets rattachés",
  "pgmRoadmap.points": "points engagés / terminés",
  "pgmRoadmap.projet": "projet",
  "pgmRoadmap.sprint": "sprint",
  "pgmRoadmap.vide": "Aucun sprint daté",
  "pgmRoadmap.videIndice": "Les sprints des projets rattachés apparaîtront ici dès qu’ils sont planifiés.",
  "pgmVersions.aVenir": "Date cible, raison de « prête ? » et dépendances par version : pas encore agrégées au niveau du programme.",
  "pgmVersions.chargement": "Chargement du train…",
  "pgmVersions.description": "Train des versions — lecture agrégée",
  "pgmVersions.legende": "Versions des projets rattachés",
  "pgmVersions.lireProjet": "lire dans le projet",
  "pgmVersions.livree": "dernière livrée",
  "pgmVersions.preparation": "en préparation",
  "pgmVersions.pret": "prête ?",
  "pgmVersions.projet": "projet",
  "pgmVersions.regle": "« Prête ? » est celui de chaque projet (Versions) : ici, on lit ; on décide dans le projet.",
  "pgmVersions.sansObjet": "sans objet",
  "pgmVersions.vide": "Aucune version préparée",
  "pgmVersions.videIndice": "Les versions des projets rattachés apparaîtront ici.",
  "pgmVue.aller": "Aller plus loin",
  "pgmVue.chargement": "Lecture du train…",
  "pgmVue.erreur": "Le train du programme n’a pas pu être lu.",
  "pgmVue.livree": "dernière livrée : {{v}}",
  "pgmVue.objectif": "Objectif et jalon cible du programme.",
  "pgmVue.preparation": "en préparation : {{v}}",
  "pgmVue.projets": "Projets rattachés",
  "pgmVue.sante": "Santé répartie et étapes en cours par projet : la passerelle ne les agrège pas encore au niveau du programme.",
  "pgmVue.statut": "Statut : {{s}}",
  "programme.aucun": "Aucun programme choisi",
  "programme.aucunIndice": "Choisissez un programme dans le sélecteur de contexte ou dans la liste des programmes.",
  "missions.pageDescriptionHarnais": "Régime harnais : la colonie travaille entre deux portes humaines — plan et budget au départ, dossier de preuves à l’arrivée.",
  "construire.sansProjet": "Aucun projet sélectionné",
  "construire.sansProjetAide": "Choisissez un projet dans le sélecteur pour voir ses missions.",
  "missions.filtres": "Filtrer les missions",
  "missions.refus": "Accès restreint : les missions se lisent par les membres du projet. Demandez l’accès au propriétaire.",
  "missions.emptyTitleProjet": "Aucune mission dans ce projet",
  "missions.filtreVide": "Aucune mission dans ce filtre.",
  "missions.filtreToutes": "Voir toutes les missions",
  "missions.tableau": "Missions du projet",
  "missions.tableauLegende": "Missions du projet · rafraîchi toutes les 10 s",
  "missions.col.mission": "Mission",
  "missions.col.statusReason": "Statut et motif",
  "missions.col.gpuEscalations": "GPU consommé · escalades",
  "missions.modesTitre": "Modes du harnais (ADR-0108)",
  "missions.modeDefaut": "défaut du gabarit",
  "missions.modePermis": "permis par le gabarit",
  "missions.modeNonPermis": "non permis par ce gabarit",
  "missions.modesNote": "Les trois modes sont livrés en bêta ; A et B restent expérimentaux tant que le banc h n’est pas passé. Un mode non permis est affiché désactivé avec son motif — jamais dégradé en C sans le dire.",
  "missions.attenteTitre": "Attend un humain ({{n}})",
  "missions.attenteVide": "Aucune décision en attente.",
  "missions.attentePlan": "plan à approuver",
  "missions.attenteEscalades": "{{n}} décision(s) ouverte(s)",
  "missions.relirePlan": "Relire le plan",
  "missions.ouvrirPoste": "Ouvrir le poste de pilotage",
  "missions.attenteBoite": "Les mêmes entrées, avec leur âge, dans la boîte d’attention.",
  "missions.status.attenteArretIA": "En attente (arrêt IA)",
  "missions.attenteArretIA": "Les requêtes IA sont interrompues : l’étape en cours finit, la suite attend la levée de l’arrêt sans consommer le budget.",
  "missions.status.fileGpu": "Plan approuvé · en file GPU",
  "missions.fileGpu": "La mission démarrera à la levée de l’arrêt de l’IA.",
  "missions.planAAutre": "À approuver par un autre membre que le demandeur, sur l’empreinte du plan relu.",
  "missions.escaladesCourt": "escalades {{n}}/{{max}}",
  "missions.form.readOnlyProjet": "Votre rôle dans ce projet ne permet pas de lancer une mission.",
  "missions.form.modeNotAllowed": "Non permis par le gabarit du projet (ADR-0108 : le mode est choisi par le gabarit) ; jamais dégradé en C sans le dire.",
  "missions.form.stopsRules": "Arrêts : {{n}} tour(s) · 2 tours improductifs · même arbre · oscillation · budget · suite de tests refusée deux fois.",
  "missions.form.appBusy": "L’application de ce projet a déjà une mission d’itération en cours : « {{m}} ». Une seule à la fois, sinon la fusion porterait un arbre jamais testé.",
  "missions.form.aiStopped": "Les nouvelles requêtes IA sont temporairement interrompues : le plan ne serait pas proposé.",
  "missions.plan.changed": "Le plan a changé depuis votre lecture : relisez-le avant de l’approuver.",
  "missions.plan.selfRefused": "Vous avez lancé cette mission : un autre membre doit approuver son plan et son budget (séparation des tâches).",
  "missions.col.casteCarteModele": "Caste · carte · modèle",
  "missions.sansCarte": "sans carte",
  "missions.sansModele": "sans modèle",
  "missions.plan.total": "Total estimé : {{e}} min de GPU sur {{b}} · {{r}} tours · {{x}} escalades · empreinte du plan relu {{h}}",
  "missions.plan.instanciation": "Instanciation par tâche : castes, cartes, modèles, contexte",
  "missions.plan.noEdit": "« Modifier le plan » n’existe pas : replanifier = refuser avec motif, puis relancer.",
  "missions.plan.readOnlyProjet": "Un contributeur ou le propriétaire du projet approuve le plan.",
  "missions.plan.sodReject": "« Refuser avec motif » reste possible.",
  "missions.plan.aiStopped": "Pendant l’arrêt de l’IA, approuver reste possible : aucun modèle n’est appelé, la mission attend en file GPU jusqu’à la reprise.",
  "missions.inst.loading": "Lecture de l’instanciation…",
  "missions.inst.title": "Instanciation par tâche",
  "missions.inst.back": "Retour au plan",
  "missions.inst.avis": "proposé par la reine jusqu’à votre approbation",
  "missions.inst.lie": "plan approuvé : l’instanciation lie la mission",
  "missions.inst.empty": "La reine n’a pas encore proposé de plan",
  "missions.inst.emptyHint": "L’instanciation apparaît avec le plan.",
  "missions.inst.caption": "Instanciation des agents, par tâche",
  "missions.inst.total": "Total estimé : {{e}} min de GPU sur {{b}} · empreinte du plan relu {{h}}",
  "missions.inst.ecart": "Pas encore exposés par la passerelle : la fenêtre de contexte, la source du routage et une ligne par caste (vérificatrice, garde) pour chaque tâche. Ils ne sont pas devinés ici.",
  "missions.inst.changeModel": "Changer le modèle d’une caste",
  "missions.inst.static": "Le routage est statique en v0.5.0 (carte → rôle → modèle) ; le modifier n’est pas spécifié (DIA-16).",
  "missions.inst.reader": "Lecteur : l’instanciation se lit ; approuver le plan est réservé aux contributeurs et au propriétaire.",
  "construire.orch.supervisionCourt": "Supervision des agents",
  "missions.pause.button": "Mettre en pause",
  "missions.pause.later": "Mettre en pause et « Reprendre la mission » : pause volontaire livrée après la v0.5.0 (DIA-15) — aujourd’hui « Arrêter » seulement.",
  "missions.cockpit.fileGpuTitre": "En file GPU : la mission attend la levée de l’arrêt de l’IA",
  "missions.cockpit.fileGpu": "Aucune tâche ne démarre tant que l’arrêt n’est pas levé : aucune minute de GPU n’est consommée, aucun tour n’est compté.",
  "missions.cockpit.baseMoved": "Rien n’est fusionné : main a avancé depuis le départ de la mission. La fusion ne serait pas une avance de l’arbre approuvé et testé ; une nouvelle mission repartira de la tête de main.",
  "missions.cockpit.instanciation": "Instanciation par tâche : carte, modèle, estimation",
  "construire.agentsPerso": "Agents personnalisés",
  "missions.transcript.later": "Transcript par caste et par tour : 0.5.x (B-408) ; aujourd’hui, le registre du tableau noir.",
  "missions.cockpit.estimeNote": "Estimé au plan et consommé sont deux mesures distinctes, jamais additionnées.",
  "missions.cockpit.estimated": "Estimé au plan",
  "missions.decision.otherFamilyUsed": "Déjà confiée à general_agent pour cette tâche.",
  "missions.decision.reopenedTwice": "Tâche déjà rouverte deux fois : « Réorienter », « Faire reconcevoir les tests cachés » et « Confier à general_agent » sont refusés. Restent « Prendre la main » et « Prendre acte de l’arrêt ».",
  "missions.decision.generalAgent": "Confier à general_agent",
  "missions.decision.aiStopped": "Réorienter et confier à general_agent appellent un modèle : refusés pendant l’arrêt de l’IA. Prendre la main et prendre acte restent possibles.",
  "missions.decision.dossierChanged": "Le dossier a changé depuis votre lecture : relisez-le avant de décider.",
  "missions.betaExperimental": "bêta · expérimental",
  "supervision.title": "Supervision des agents",
  "supervision.description": "Tout ce qui tourne dans le projet : missions, castes au travail, agents personnalisés. Lecture seule — les contrôles (arrêter, prendre la main, réorienter) restent au poste de pilotage de chaque mission.",
  "supervision.sansProjetAide": "Choisissez un projet pour voir ce qui y tourne.",
  "supervision.loading": "Lecture des missions, castes et jobs…",
  "supervision.refus": "Accès restreint : la supervision se lit par les membres du projet. Demandez l’accès au propriétaire.",
  "supervision.refresh": "rafraîchi toutes les 10 s",
  "supervision.iaTitre": "IA interrompue",
  "supervision.ia": "Les missions finissent leur étape en cours et attendent la levée de l’arrêt ; la supervision reste lisible.",
  "supervision.executeurTitre": "Aucun exécutant ne répond",
  "supervision.executeur": "Les étapes restent en file tant qu’un exécutant ne les prend pas ; les missions ne sont pas perdues.",
  "supervision.suspendue": "Suspendue",
  "supervision.repriseAuto": "Reprise automatique dès qu’une place se libère.",
  "supervision.vide": "Rien ne tourne dans ce projet",
  "supervision.videAide": "Aucune mission active, aucun agent ni job en cours.",
  "supervision.missionsActives": "Missions actives ({{n}})",
  "supervision.toutesMissions": "Toutes les missions",
  "supervision.missionsActivesLabel": "Missions actives du projet",
  "supervision.castesAuTravail": "Castes au travail",
  "supervision.aucuneCaste": "aucune",
  "supervision.estime": "estimé au plan : {{n}}",
  "supervision.consomme": "consommé : {{c}} / {{b}} min",
  "supervision.estimeConsomme": "Minutes de GPU : « estimé au plan » (la reine, par tâche) et « consommé » (la mission) sont deux mesures distinctes, étiquetées séparément et jamais additionnées.",
  "supervision.castesDe": "Castes au travail — {{m}}",
  "construire.orch.pilotageCourt": "Poste de pilotage",
  "supervision.modele": "Modèle",
  "supervision.dernierSignal": "Dernier signal",
  "supervision.age": "Âge",
  "supervision.agentsPerso": "Agents personnalisés ({{n}} en cours)",
  "supervision.agentsErreur": "État des agents personnalisés illisible pour l’instant.",
  "supervision.ouvrirAgents": "Ouvrir les agents personnalisés",
  "supervision.cout05x": "Coût et traces : le coût se lit aujourd’hui mission par mission (budget du poste de pilotage) ; la ventilation par caste, tâche et tour et le lien vers les traces viennent en 0.5.x (B-408, KPI-07).",
  "construire.carteBrouillon": "brouillon · sans reçu de qualification",
  "construire.carteBrouillonNote": "Admis en bêta (QST-F-03) : la qualification au banc précède la version stable, pas la bêta ; le dossier de mission le consigne. Le reçu du profil de génération ne couvre pas la carte.",
  "construire.orch.plan": "Plan de la reine (tâches, castes, critères)",
  "construire.orch.instanciation": "Instanciation par tâche (carte, modèle, contexte)",
  "construire.orch.pilotage": "Poste de pilotage : graphe des tâches, castes du harnais",
  "construire.orch.supervision": "Supervision des agents du projet",
  "construire.orch.registre": "Registre du tableau noir",
  "construire.orch.titre": "Orchestration des agents : où la voir",
  "construire.orch.aide": "Le harnais, la surveillance des agents, l’instanciation et l’orchestration ont chacun leur écran ; cette console n’exécute que les agents personnalisés, hors colonie.",
  "construire.orch.sansMission": "Aucune mission active : le plan, l’instanciation et le registre s’ouvrent depuis la liste des missions.",
  "workflow.titreAgentsPerso": "Agents personnalisés",
  "workflow.descriptionAgentsPerso": "Exécutez un agent personnalisé sur le projet, hors colonie, et suivez sa trace et sa sortie.",
  "workflow.relancerApresErreur": "Relancer après erreur",
  "livrer.pourEnv": "pour {{env}}",
  "livrer.douzeRaisons": "{{n}} raisons",
  "livrer.vertes": "vertes : {{liste}}",
  "livrer.approbationPasRaison": "L’approbation de mise en ligne n’est pas une raison : elle suit, une fois la version prête.",
  "livrer.repli": "Calcul de repli : la passerelle n’expose pas encore les 12 raisons ; les raisons qu’elle ne calcule pas sont « non calculées », jamais comptées vertes.",
  "livrer.nonCalculee": "non calculée par ce serveur",
  "livrer.objets": "Objets en cause",
  "livrer.retourTitre": "Retour arrière",
  "livrer.decisionEnregistree": "Décision de mise en ligne enregistrée",
  "livrer.recetteAFaireRefus": "La recette métier de {{version}} n’est pas encore accordée (exigée par le gabarit).",
  "livrer.refuserTitre": "Refuser la mise en ligne de {{nom}} ?",
  "livrer.refuserConsequence": "Le motif est transmis à la personne qui a demandé la mise en ligne.",
  "livrer.refuser": "Refuser",
  "livrer.refuserMotif": "Pourquoi refusez-vous ? (obligatoire)",
  "livrer.miseEnLigne": "Mise en ligne",
  "livrer.mettreEnLigneQ": "Mettre en ligne {{nom}} ?",
  "livrer.quoi": "Quoi",
  "livrer.quoiTexte": "Mettre en ligne {{nom}}.",
  "livrer.ou": "Où",
  "livrer.quand": "Quand",
  "livrer.quandTexte": "Après votre décision, au déploiement par le release manager.",
  "livrer.qui": "Qui",
  "livrer.quiTexte": "Demandée par {{par}} · vous décidez · une troisième personne la déploie.",
  "livrer.quiSansDemande": "Pas encore demandée : le release manager la demande depuis « Approbations, déploiement et retour arrière ».",
  "livrer.retourPossible": "Retour possible",
  "livrer.preuves": "Preuves",
  "livrer.voirRecette": "Voir la recette",
  "livrer.approuveePar": "Approuvée par {{par}} le {{quand}}.",
  "livrer.ouvrirApp": "Ouvrir l’application",
  "livrer.refuseeMotif": "Refusée : « {{motif}} »",
  "livrer.mettreEnLigne": "Mettre en ligne",
  "livrer.trace": "Ce que vous approuvez est tracé avec votre nom, l’heure et la version exacte.",
  "livrer.enServiceTitre": "Application en service",
  "livrer.sansProjet": "Choisissez d’abord un projet",
  "livrer.sansProjetAide": "L’application en service appartient à un projet.",
  "livrer.chargement": "Chargement de l’application en service…",
  "livrer.refus403": "Accès refusé",
  "livrer.refus403Aide": "Vous n’êtes pas membre de ce projet : demandez l’accès à son propriétaire.",
  "livrer.rienEnService": "Aucune version en service",
  "livrer.rienEnServiceAide": "Aucun palier n’a encore de déploiement réussi : préparez une version, puis déployez-la.",
  "livrer.allerVersions": "Ouvrir Versions",
  "livrer.sondeSaine": "sonde saine{{detail}}",
  "livrer.sondeEchec": "sonde en échec",
  "livrer.sondeNonConfiguree": "sonde non configurée",
  "livrer.sondeNonMesuree": "sonde non mesurée",
  "livrer.enServiceBadge": "en service",
  "livrer.candidatDe": "candidat rc{{n}} de {{base}}",
  "livrer.surPalier": "Sur {{env}} (rang {{rang}})",
  "livrer.depuis": "depuis le {{quand}}",
  "livrer.observee": "observée le {{quand}}",
  "livrer.acces": "Accès",
  "livrer.documentation": "Documentation",
  "livrer.ficheVersion": "Fiche de version",
  "livrer.retourProd": "Retour arrière de la production",
  "livrer.nonMesure": "non mesuré",
  "livrer.continuiteTitre": "Continuité de l’application",
  "livrer.continuitePortee": "Composants de l’application livrée, pas ceux de DoIt ; la sauvegarde de DoIt lui-même n’est pas outillée en bêta (DIA3-26).",
  "livrer.continuiteChargement": "Chargement de l’état de sauvegarde…",
  "livrer.continuiteErreur": "Impossible de lire l’état de sauvegarde : {{message}}",
  "livrer.base": "Base",
  "livrer.composantsAbsents": "non fournis par le serveur pour l’application livrée",
  "livrer.composantsPlateforme": "{{n}} composant(s) de DoIt écarté(s) : ils ne décrivent pas l’application.",
  "livrer.sauvegarde": "Sauvegarde",
  "livrer.derniereSauvegarde": "dernière le {{quand}}",
  "livrer.aucuneSauvegarde": "aucune sauvegarde réussie",
  "livrer.cible": "cible",
  "livrer.rtoNonMesure": "non mesuré : dernière restauration testée : jamais",
  "livrer.continuiteNonMesure": "Testez une restauration pour mesurer le RTO : tant qu’il ne l’est pas, la continuité n’est pas dite saine.",
  "livrer.continuiteNonSaine": "Un état non sain bloque la certification de continuité ; vérifiez le scheduler et le journal avant une mise en production.",
  "livrer.apercuEnProduction": "Cette version d’essai est en production : {{version}} sur {{env}}.",
  "livrer.apercuManuel": "Aperçu indisponible : livraison manuelle",
  "livrer.apercuManuelAide": "Ce projet est livré à la main : aucune version d’essai n’est construite par l’outil. Le bandeau « en production » s’appuie alors sur le commit déployé.",
  "livrer.docVivante": "Lire la documentation du projet à l’écran",
  "livrer.summaryNonEtablie": "{{nom}} : « prête ? » non établie (raisons non calculées)",
  "verifier.recetteSansProjet": "Une recette est toujours rattachée à un projet.",
  "verifier.permissionLecture": "Lecture de vos permissions…",
  "verifier.permissionIllisible": "Vos permissions n’ont pas pu être lues : le verdict reste désactivé.",
  "verifier.recetteSansPermission": "Vous n’avez pas la permission « exécuter une recette » dans ce projet : demandez-la au propriétaire du projet ou à l’administration de l’organisation (Membres du projet).",
  "verifier.recetteFermee": "Cette recette n’est plus ouverte : son verdict est figé.",
  "verifier.recetteTitre": "Recette métier",
  "verifier.recetteDescription": "Vous essayez la version et dites si chaque scénario est conforme. Une remarque accompagne un « pas conforme ».",
  "verifier.recetteChargement": "Chargement des recettes…",
  "verifier.recetteErreur": "Recettes illisibles : la passerelle n’a pas répondu.",
  "verifier.recetteVide": "Aucune version à recetter",
  "verifier.recetteVideAide": "L’équipe ouvre une campagne de nature « Recette métier » depuis Tests › Plans et campagnes ; elle apparaît ici.",
  "verifier.recetteVideAction": "Plans et campagnes",
  "verifier.versionsARecetter": "Versions à recetter",
  "verifier.enCours": "en cours",
  "verifier.close": "close",
  "verifier.recetteDe": "Recette de {{v}}",
  "verifier.recetteEnvironnement": "Environnement : {{e}}",
  "verifier.recetteAvecPermission": "Vous avez la permission « exécuter une recette ».",
  "verifier.recetteScenariosChargement": "Chargement des scénarios…",
  "verifier.recetteScenariosErreur": "Scénarios illisibles : la passerelle n’a pas répondu.",
  "verifier.recetteSansScenario": "Aucun scénario",
  "verifier.recetteSansScenarioAide": "Le plan de cette recette ne contient encore aucun cas.",
  "verifier.recetteAvancement": "{{vus}} scénario(s) vu(s) sur {{total}}",
  "verifier.aVoir": "à voir",
  "verifier.conforme": "conforme",
  "verifier.pasConforme": "pas conforme",
  "verifier.conformeAction": "Conforme",
  "verifier.pasConformeAction": "Pas conforme",
  "verifier.votreRemarque": "Votre remarque",
  "verifier.remarqueRequise": "Dites ce qui ne va pas : la remarque est jointe au verdict pour l’équipe.",
  "verifier.annuler": "Annuler",
  "verifier.envoyerRemarque": "Envoyer la remarque",
  "verifier.remarqueDevenueAnomalie": "Remarque devenue l’anomalie ANO-{{a}}",
  "verifier.remarqueATrier": "Remarque jointe au verdict : l’équipe la déclare en anomalie depuis le résultat EXE-{{e}}",
  "verifier.verdictVersion": "Votre verdict sur la version",
  "verifier.verdictRefusee": "Au moins un scénario « pas conforme » : pas d’acceptation avec réserve. Vos remarques vont à l’équipe ; une nouvelle recette suivra le correctif.",
  "verifier.verdictAccordee": "Tous les scénarios sont conformes : la recette est accordée. La mise en ligne reste l’acte de la sponsor.",
  "verifier.verdictEnCours": "Tous les scénarios ne sont pas encore vus : la version ne peut pas encore être acceptée.",
  "verifier.voirVersions": "Voir la version dans Versions",
  "verifier.ecartRecette": "Le verdict global de la version (accepté / refusé) se déduit des scénarios ; la passerelle ne l’enregistre pas encore comme un acte distinct, et la liste des cas du plan n’est pas publiée : un cas hors plan est refusé par la passerelle (TEST_SCOPE_MISMATCH).",
  "verifier.ongletCas": "Cas, plans et campagnes",
  "verifier.ongletNonRegression": "Non-régression",
  "verifier.ongletsTests": "Sections des tests",
  "verifier.etapeCas": "Cas",
  "verifier.etapeScenario": "Scénario",
  "verifier.etapeCampagne": "Campagne",
  "verifier.etapeResultat": "Résultat",
  "verifier.etapeAnomalie": "Anomalie",
  "verifier.etapeVerification": "Vérification du correctif",
  "verifier.etapeNonRegression": "Non-régression",
  "verifier.parcoursTesteur": "Parcours du testeur",
  "verifier.concevoirTests": "Proposer des cas par l’IA",
  "verifier.concevoirTestsAide": "Depuis la couverture : choisissez une exigence sans test, puis « Concevoir des tests » sur sa fiche.",
  "verifier.concevoirTestsRefus": "Proposer des cas par l’IA est suspendu pendant l’arrêt de l’IA. Exécuter les campagnes reste possible.",
  "verifier.aVenir": "À venir (0.5.x)",
  "verifier.scenarioEnregistre": "Scénario enregistré",
  "verifier.casIntrouvable": "Cas introuvable",
  "verifier.casIntrouvableAide": "Ce cas n’existe pas dans ce projet.",
  "verifier.retourTests": "Retour aux tests",
  "verifier.scenarioVide": "Un scénario compte au moins une étape.",
  "verifier.etapeSansAttendu": "Chaque étape dit ce qui est attendu : l’étape {{n}} est incomplète.",
  "verifier.casFicheDescription": "Scénario, rattachement et historique du cas.",
  "verifier.genereIA": "généré par l’IA",
  "verifier.elementLie": "élément lié #{{id}}",
  "verifier.scenarioTitre": "Scénario — étapes et résultat attendu",
  "verifier.scenarioAucun": "Aucune étape écrite : le cas n’a pas encore de scénario.",
  "verifier.attendu": "attendu : {{v}}",
  "verifier.editeurScenario": "Éditeur de scénario",
  "verifier.etapeAction": "Étape {{n}} — action",
  "verifier.etapeAttendu": "Étape {{n}} — résultat attendu",
  "verifier.monter": "Monter l’étape {{n}}",
  "verifier.descendre": "Descendre l’étape {{n}}",
  "verifier.retirer": "Retirer l’étape {{n}}",
  "verifier.ajouterEtape": "Ajouter une étape",
  "verifier.enregistrerScenario": "Enregistrer le scénario",
  "verifier.resultatAttendu": "Résultat attendu : {{v}}",
  "verifier.modifierScenario": "Modifier le scénario",
  "verifier.executerDansCampagne": "Exécuter dans une campagne",
  "verifier.historiqueTitre": "Historique du cas — dernière exécution par campagne",
  "verifier.historiqueChargement": "Lecture des résultats du cas…",
  "verifier.historiqueErreur": "Historique illisible : la passerelle n’a pas répondu ; la fiche reste affichée.",
  "verifier.jamaisExecute": "Jamais exécuté : ajoutez ce cas à une campagne.",
  "verifier.lienResultat": "Résultat EXE-{{id}}",
  "verifier.nonRegressionTitre": "Non-régression",
  "verifier.nonRegressionDescription": "La campagne courante comparée à la dernière campagne clôturée : ce qui marchait marche-t-il encore ?",
  "verifier.nonRegressionChargementCampagnes": "Chargement des campagnes…",
  "verifier.nonRegressionErreur": "Comparaison impossible : une campagne n’a pas pu être lue.",
  "verifier.nonRegressionVide": "Aucune campagne à comparer",
  "verifier.nonRegressionVideAide": "Ouvrez une campagne sur un plan : son rapport se compare ensuite à la précédente.",
  "verifier.ouvrirCampagne": "Ouvrir une campagne",
  "verifier.campagnesComparees": "Campagnes comparées",
  "verifier.campagneCourante": "Campagne courante",
  "verifier.campagneReference": "Référence (dernière clôturée)",
  "verifier.aucuneReference": "Aucune",
  "verifier.rienAComparer": "Rien à comparer",
  "verifier.rienAComparerAide": "Aucune campagne clôturée avant celle-ci : sa campagne devient la référence une fois clôturée.",
  "verifier.comparaisonChargement": "Comparaison des campagnes #{{a}} et #{{b}}…",
  "verifier.syntheseNonRegression": "Synthèse",
  "verifier.regressionsNonAcceptees": "{{n}} régression(s) non acceptée(s) : « tests réussis » ne peut pas s’écrire. Corrigez-les, ou acceptez-les avec un motif et une échéance.",
  "verifier.casNonExecutes": "Aucune régression, mais {{n}} cas non exécuté(s) : la comparaison n’est pas complète.",
  "verifier.aucuneRegression": "Aucune régression par rapport à la campagne #{{r}}.",
  "verifier.avantApres": "campagne #{{r}} : {{a}} → campagne #{{c}} : {{b}}",
  "verifier.accepterMotif": "Accepter (motif, échéance)",
  "verifier.accepterRegression": "Accepter une régression",
  "verifier.motifObligatoire": "Motif (obligatoire)",
  "verifier.echeance": "Échéance de correction (obligatoire)",
  "verifier.motifManquant": "Écrivez le motif de l’acceptation.",
  "verifier.echeanceManquante": "Fixez l’échéance de correction.",
  "verifier.echeancePassee": "L’échéance ne peut pas être passée.",
  "verifier.verifierSaisie": "Vérifier la saisie",
  "verifier.acceptationNonEnregistree": "Saisie complète, mais la passerelle n’enregistre pas encore l’acceptation d’une régression (auteur, motif, échéance) : rien n’est accepté. La régression reste comptée.",
  "verifier.ecartNonRegression": "Suite de non-régression marquée, acceptation motivée d’une régression et exigence à chaque version candidate : pas encore portées par la passerelle. Le rapport ci-dessus est calculé sur les exécutions réelles des deux campagnes.",
  "verifier.resultatChargement": "Chargement du résultat…",
  "verifier.resultatErreur": "Résultat illisible : la passerelle n’a pas répondu.",
  "verifier.resultatIntrouvable": "Exécution introuvable",
  "verifier.resultatIntrouvableAide": "Cette exécution n’appartient pas à la campagne #{{c}}.",
  "verifier.dejaDeclaree": "EXE-{{e}} a déjà fait naître ANO-{{a}} : une exécution rouge ne fait naître qu’une anomalie.",
  "verifier.executionVerte": "EXE-{{e}} n’est pas rouge : rien à déclarer depuis elle. Déclaration libre possible depuis l’écran Anomalies.",
  "verifier.resultatTitre": "Résultat EXE-{{id}} — {{cas}}",
  "verifier.resultatDescription": "Campagne #{{c}} · verdict, durée, exécutant et suites.",
  "verifier.verdict": "Verdict",
  "verifier.duree": "Durée",
  "verifier.executant": "Exécutant",
  "verifier.executantAgent": "colonie · runner Docker",
  "verifier.executantHumain": "personne",
  "verifier.executee": "Exécutée",
  "verifier.preuves": "Preuves",
  "verifier.etapesDuCas": "Étapes du cas",
  "verifier.etapeEnEchecAVenir": "L’étape en échec et l’obtenu par étape ne sont pas encore publiés par le runner : le verdict porte sur le cas entier.",
  "verifier.suites": "Suites",
  "verifier.ficheDuCas": "Fiche du cas {{cle}}",
  "verifier.anomalieLiee": "Anomalie liée : ANO-{{a}}",
  "verifier.voirNonRegression": "Voir la non-régression",
  "verifier.natureCampagne": "Nature",
  "verifier.natureTechnique": "Régression ou campagne libre — exécutée par l’équipe",
  "verifier.natureRecette": "Recette métier — exécutée par le métier",
  "verifier.natureRecetteAide": "La recette métier est une campagne comme les autres : elle compte dans l’historique des cas et les agrégats qualité. Seul un détenteur de « exécuter une recette » rend son verdict ; aucun agent ne l’exécute.",
  "verifier.campagneLibreAide": "Une campagne libre n’atteste aucune version : elle ne compte pas pour « prête ? ».",
  "verifier.badgeRecette": "recette métier",
  "verifier.ouvrirRecette": "Ouvrir la recette métier",
  "verifier.rapportNonRegression": "Rapport de non-régression",
  "verifier.anomaliesOuvertes": "{{n}} ouverte(s), dont {{v}} résolue(s) à vérifier — une anomalie résolue compte comme ouverte tant que sa reproduction n’est pas repassée au vert.",
  "verifier.regleCorrectif": "Règle : seule une exécution verte du cas de reproduction sur une révision qui contient le commit du correctif vérifie l’anomalie — jamais la date. Tant qu’elle n’est pas vérifiée, elle compte comme ouverte.",
  "verifier.correctif": "Correctif : {{ref}}",
  "verifier.ficheCasRepro": "Fiche du cas de reproduction",
  "verifier.refusCorrectifAbsent": "Aucune exécution verte du cas de reproduction sur une révision qui contient le commit du correctif : la date ne suffit pas (ARB-r2-13). Rejouez le cas sur une révision déployée qui le contient.",
  "verifier.categorie.regression": "régression",
  "verifier.categorie.corrige": "corrigé",
  "verifier.categorie.toujours-en-echec": "toujours en échec",
  "verifier.categorie.nouveau": "nouveau cas",
  "verifier.categorie.non-execute": "non exécuté",
  "verifier.categorie.stable": "stable",
  "verifier.etatRecette.a-faire": "à faire",
  "verifier.etatRecette.en-cours": "en cours",
  "verifier.etatRecette.refusee": "refusée",
  "verifier.etatRecette.accordee": "accordée",
  "verifier.etatResolue": "résolue, à vérifier",
  "verifier.formAcceptationRegression": "Accepter une régression",
  "planifier.porteeSprintServeur": "Comptée par la passerelle sur le sprint actif.",
  "planifier.wipReglageErreur": "Non calculé par la passerelle (la lecture des limites a échoué) : réglage indisponible. Les comptes ci-dessus suivent déjà la règle.",
  "planifier.wipInvalide": "{{col}} : une limite entière de 1 à 999, ou vide pour aucune limite.",
  "planifier.wipEnregistrer": "Enregistrer les limites",
  "planifier.wipRefus": "Régler les limites est réservé au propriétaire du projet ou au détenteur de « backlog.wip_limits » (product owner).",
  "planifier.wipEnregistre": "Limites enregistrées.",
  "vueProjet.repliErreur": "la lecture de la passerelle a échoué",
  "vueProjet.repliAbsent": "la passerelle n’expose pas cet agrégat",
  "vueProjet.santeNonCalculee": "Non calculé par la passerelle ({{raison}}) : estimation locale sur les lectures du projet ; un signal sans donnée reste « sans objet », jamais vert.",
  "vueProjet.jaugeNonCalculee": "Non calculé par la passerelle ({{raison}}) : jauge estimée sur le backlog seul ; « rouverte » n’est pas calculable ici.",
  "demandes.filiationRepli": "Non calculé par la passerelle : les demandes DEM-n (filiation idée → cadrage → spécification → application) n’y sont pas lisibles. Une demande est lue ici sur son cadrage ; les états « spécifiée » à « livrée » et les items issus ne sont pas établis.",
  "pgmVue.santeTitre": "Santé, étape et pile par projet",
  "pgmVue.santeAucun": "Aucun projet visible dans ce programme.",
  "pgmVue.santeCaption": "Santé, étapes en cours et pile des projets visibles",
  "pgmVue.colProjet": "projet",
  "pgmVue.colSante": "santé",
  "pgmVue.colEtape": "étapes en cours",
  "pgmVue.colPile": "pile",
  "pgmVue.pileAucune": "aucune pile décidée",
  "pgmVue.partiel": "{{n}} projet(s) n’ont pas pu être évalués : la vue d’ensemble est partielle.",
  "pgmVue.santeErreur": "Santé et étapes par projet : non calculées — la vue d’ensemble du programme n’a pas pu être lue.",
  "planifier.dorServeur": "Définition de prêt calculée par la passerelle : {{n}} / {{total}} feature(s) et US prêtes. Taille ≤ 32 K de contexte et ≤ 400 lignes : pas encore évaluées.",
  "planifier.etatPrete": "prête",
  "planifier.etatNonPrete": "pas prête",
  "verifier.regressionsToutesAcceptees": "{{n}} régression(s), toutes acceptées avec motif et échéance : elles restent listées jusqu’à leur correction.",
  "verifier.regressionAcceptee": "acceptée par {{qui}} ({{qualite}}) jusqu’au {{date}} : {{motif}}",
  "verifier.motifCourt": "Le motif doit faire 10 caractères au moins.",
  "verifier.accepterRefus": "Refusé : accepter une régression est réservé au propriétaire du projet ou au détenteur de « regression.accept ».",
  "demandes.colEtape": "étape",
  "demandes.piedServeur": "{{n}} demandes · numérotées DEM-n par la passerelle, dans l’ordre de dépôt",
  "demandes.filDeposeeServeur": "déposée par {{qui}} le {{quand}}",
  "demandes.abandon": "abandonnée : {{m}}",
  "demandes.filEtapes": "Étapes du cycle de la demande",
  "demandes.filItemsAucun": "Aucun item n’est encore issu de cette demande.",
  "demandes.filSpecs": "{{n}} spécification(s) rattachée(s)",
  "demandes.ouvrirSpecs": "Spécifications",
  "demandes.filMissions": "Missions",
  "demandes.filVersions": "Versions",
  "demandes.filAttend": "Attend : {{a}}.",
  "demandes.filOuvrirEtape": "Ouvrir : {{e}}",
  "demandes.introuvableHintServeur": "Elle n’existe pas, ou vous n’êtes pas membre de son projet.",
  "nav.vueProjet": "Vue projet",
  "projet.onglets": "Vues du projet",
  "app.marqueAria": "DoIt — {{org}} : aller à l’accueil",
  "app.deployeLe": "déployé le",
  "n28.objet": "objet :",
  "projet.vue.activite": "Activité",
  "projet.vue.indicateurs": "Indicateurs",
  "admin.operationsHealthBlockedPublications": "Publications bloquées",
  "adr.card.ruleOptions": "Règle : une ADR compare au moins 2 options (actuellement : {{n}}).",
  "adr.card.ruleOptionsAdd": "Ajoutez une option dans la matrice avant de décider.",
  "adr.card.ruleOptionsG4": "Règle : la porte G4 exige au moins 3 options comparées (actuellement : {{n}}).",
  "adr.stack.askPlatformAdmin": "L’administrateur de la plateforme l’enregistre dans Plateforme › Profils de génération qualifiés.",
  "adr.stack.noneProposable": "Aucune pile n’est encore proposable : une ADR de pile ne peut pas être décidée tant qu’aucune qualification mesurée n’est enregistrée.",
  "adr.stack.toQualification": "Enregistrer une qualification (Plateforme › Profils de génération qualifiés)",
  "design.flow.prerequis": "Prérequis : des items de backlog ACCEPTÉS issus de cette spécification (générer le backlog depuis la spécification approuvée, puis accepter ses items). Sans eux, la proposition échoue.",
  "design.flow.prerequisManquant": "Prérequis manquant : aucun item de backlog accepté dans ce projet. Le parcours d’écrans sert des exigences ACCEPTÉES : générez le backlog depuis la spécification approuvée, acceptez ses items, puis revenez proposer le parcours.",
  "generation.carte": "Carte de génération",
  "generation.catalogue": "Piles du catalogue et générabilité mesurée",
  "generation.enregistrer": "Enregistrer une qualification mesurée",
  "generation.envoyer": "Enregistrer la qualification",
  "generation.invalid": "reçu invalide",
  "generation.modele": "Modèle mesuré",
  "generation.notQualified": "non qualifiée",
  "generation.ok": "Qualification enregistrée : le catalogue ci-dessus est relu.",
  "generation.passes": "Cas réussis",
  "generation.pile": "Pile",
  "generation.qualified": "qualifiée (tous les cas dorés passent)",
  "generation.recu": "Reçu de mesure (empreinte du rapport)",
  "generation.regle": "Une pile est proposable dans une ADR de pile si et seulement si sa dernière qualification mesurée est « qualifiée » : tous ses tirages passent tous les juges, sauf les tests livrés de l’application générée, qui doivent passer dans au moins 75 % des tirages après réparation (même règle que la carte).",
  "generation.source": "Reportez le résultat du banc de générabilité (scripts/doit/mesurer_generabilite.py) : le reçu est l’empreinte de son rapport. Chaque enregistrement est ajouté à l’historique, jamais modifié.",
  "generation.statut": "Statut mesuré",
  "generation.total": "Cas exécutés",
  "generation.version": "Version de la carte",
  "specs.publicationAttente": "non publiée — publication en attente",
  "specs.publicationBloquee": "non publiée — publication bloquée",
  "specs.publicationEchec": "non publiée — publication en échec",
  "specs.demandesModification": "Demandes de modification",
  "specs.videCadree": "Aucune spécification approuvée pour l’instant",
  "specs.videCadreeHint": "{{n}} cadrage(s) approuvé(s) attendent leur spécification : rédigez-la depuis la demande, ou décidez celle qui attend au centre d’approbations.",
  "specs.versDemandes": "Voir les demandes cadrées",
  "specs.versApprobations": "Centre d’approbations",
  "approvals.publicationBlockedAt": "Bloquée le {{date}}",
  "missions.plan.normCreated": "(tâche créée par la normalisation)",
  "missions.plan.normMove": "critère {{c}} déplacé de {{de}} vers {{vers}}",
  "missions.plan.normTask": "la tâche {{rang}} « {{titre}} »",
  "missions.plan.normTaskId": "la tâche {{id}}",
  "missions.plan.normTitle": "Le plan a été normalisé par le runtime avant votre relecture",
  "missions.plan.normWhy": "Un critère d’acceptation est testé dans la tâche qui construit son item : ceux que la reine avait rangés ailleurs ont été déplacés. Rien d’autre n’a été modifié.",
  "tests.campaignDeclareEnvironment": "Déclarer un environnement",
  "tests.campaignEnvironmentsUnreadable": "Environnements illisibles : la campagne ne peut pas choisir où s’exécuter. Rechargez la page ; si le refus persiste, voyez « Environnements et déploiements ».",
  "tests.campaignNoEnvironment": "Aucun environnement déclaré dans ce projet : une campagne, recette métier comprise, s’exécute toujours sur un environnement.",
  "tests.campaignNoEnvironmentHow": "Déclarez-en un dans « Environnements et déploiements » (bouton « Déclarer un palier ») : il faut un fichier Compose pour ce palier, et un exécutant d’application actif sur un worker hôte pour le démarrer.",
  "tests.noEnvironmentOption": "Aucun environnement déclaré",
  "versions.field.commitHelp": "Rempli par la révision choisie ; modifiable à la main.",
  "versions.field.publishedChoose": "Choisir une révision publiée…",
  "versions.field.publishedError": "Révisions publiées illisibles : saisissez le commit à la main.",
  "versions.field.publishedLoading": "Chargement des révisions publiées…",
  "versions.field.publishedNone": "Aucune révision publiée dans ce projet : une révision l’est quand son approbation est publiée (« Publié — commit … »). Saisissez le commit à la main.",
  "versions.field.publishedRevision": "Révision publiée",
  "admin.colRecette": "Exécuter une recette",
  "admin.recetteAttributionsIllisibles": "Les attributions de permissions du projet (exécuter une recette, accepter une régression, limites d’en-cours) n’ont pas pu être lues.",
  "admin.recetteCaseAria": "Exécuter une recette : {{u}}",
  "admin.recetteAide": "« Exécuter une recette » : rendre le verdict d’une recette métier. Aucun rôle ne la donne par défaut ; cochez-la pour un membre, lecteur compris (profil métier). Chaque attribution est tracée.",
  "admin.rbacLectureSeule": "Consultation seulement : la matrice d’une organisation se modifie par son administrateur. Pour la recette métier, le propriétaire du projet ou l’administration de l’organisation attribue « exécuter une recette » à un membre dans Réglages du projet › Membres.",
  "runops.refusVersionNonApprouvee": "Version « {{s}} » : seule une version approuvée se déploie. Passez-la en candidate puis faites approuver son déploiement (écran Versions).",
  "runops.refusVersionNonApprouveeEnv": "Version non approuvée pour cet environnement : demandez son approbation (écran Versions).",
  "verifier.ecartRecetteVerdict": "Le verdict global de la version (accepté / refusé) se déduit des scénarios ; la passerelle ne l’enregistre pas encore comme un acte distinct.",
  "missions.evidence.notBuiltShort": "Aucun : l’application n’a pas été construite",
  "missions.evidence.notStartedShort": "Aucun : l’application n’a pas démarré",
  "missions.evidence.notBuilt": "L’application n’a pas été construite au tour {{r}} : les tests cachés n’ont pas pu s’exécuter.",
  "missions.evidence.notStarted": "L’application n’a pas démarré au tour {{r}} : les tests cachés n’ont pas pu s’exécuter.",
  "missions.evidence.startNoDetail": "Motif non déposé par le runtime pour ce tour.",
  "missions.evidence.failedTests": "Tests rouges du dernier tour · {{n}}",
  "missions.evidence.attemptCurrent": "Tentative {{n}} (actuelle)",
  "missions.evidence.attempt": "Tentative {{n}}",
  "missions.evidence.reopenedOtherFamily": "Rouverte par un humain : confiée à une autre famille de modèle.",
  "missions.evidence.reopenedReorient": "Rouverte par un humain (réorientation), consigne :",
  "missions.evidence.roundNotBuilt": "non construite : aucun test",
  "missions.evidence.roundNotStarted": "application non démarrée : aucun test",
  "missions.evidence.admission": "admission refusée : {{m}}",
  "missions.evidence.designRefusedThenAccepted": "Conception des tests cachés, essai {{a}} : suite refusée par les juges ; reconçue et acceptée à l’essai {{b}}.",
  "missions.evidence.designRefused": "Conception des tests cachés, essai {{a}} : suite refusée par les juges.",
  "missions.evidence.judgesProblems": "Motifs des juges",
  "missions.decision.closed": "Mission terminée : plus aucune décision n’est attendue. {{n}} tâche(s) arrêtée(s) restent en l’état.",
  "missions.cockpit.escalationsLeft": "Escalades restantes : {{r}} sur {{n}}",
  "dod.aucunCandidat": "Aucun cas libre dans ce projet : créez-en un dans ",
  "dod.chargementCas": "Chargement des cas…",
  "dod.choisirCas": "Choisir un cas non relié",
  "dod.derniereExecution": "dernière exécution : {{v}}",
  "dod.jamaisExecute": "jamais exécuté",
  "dod.manquant": "manquant",
  "dod.nonRemplie": "non remplie",
  "dod.refusAvantClic": "Le passage à « {{fin}} » sera refusé tant qu’un critère manque.",
  "dod.relier": "Relier ce cas à la story",
  "dod.relierLibelle": "Cas de recette ou test qui prouve la story",
  "dod.rempli": "rempli",
  "dod.remplie": "remplie",
  "dod.tests": "Tests",
  "dod.titre": "Definition of Done",
  "livrer.signatureEchec": "Échec de la construction ou de la signature : {{erreur}}",
  "livrer.signatureEnCours": "Construction demandée (job {{job}}) : le worker construit l’image, produit le SBOM et signe la provenance.",
  "livrer.signatureFaite": "Image, SBOM et signature enregistrés au registre des révisions.",
  "livrer.signatureRefus": "Réservé aux membres qui agissent sur le projet (owner ou contributor).",
  "livrer.signerRevision": "Construire et signer la révision {{rev}}",
  "tests.clotureEchec": "Clôture refusée par la passerelle : {{motif}}",
  "tests.clotureRefusee": "Clôture impossible, critères de sortie non satisfaits : {{liste}}.",
  "verifier.envoyerConforme": "Déclarer conforme",
  "verifier.etapes": "Étapes",
  "verifier.preuveExemple": "Par exemple : {{attendu}} — obtenu tel quel",
  "verifier.preuveLien": "Lien vers une capture ou un document (facultatif)",
  "verifier.preuveLienInvalide": "Le lien doit commencer par http:// ou https://.",
  "verifier.preuveRequise": "Un « conforme » se prouve : décrivez ce que vous avez observé, ou joignez un lien vers une capture.",
  "verifier.preuveRequiseServeur": "La passerelle exige une preuve : décrivez ce que vous avez observé ou joignez un lien.",
  "verifier.resultatAttenduAbsent": "Résultat attendu non renseigné sur le cas : demandez-le à l’équipe avant de juger.",
  "verifier.votrePreuve": "Ce que vous avez observé",
  "anomalies.missionFix.title": "Corriger dans une mission",
  "anomalies.missionFix.help": "La colonie reproduit l’anomalie (test rouge), corrige l’application livrée, puis la marque « résolue » à la livraison de la correction ; la vérification reste la vôtre.",
  "anomalies.missionFix.base": "Base : application « {{app}} », dernière révision livrée {{rev}}.",
  "anomalies.missionFix.launch": "Corriger dans une mission",
  "anomalies.missionFix.missions": "Missions qui l’ont portée",
  "anomalies.missionFix.task": "tâche : {{s}}",
  "missions.form.errApplication": "Choisissez l’application à faire évoluer.",
  "missions.form.defectsToTriage": "{{n}} anomalie(s) « nouvelle(s) » à trier d’abord (écran Anomalies) : une mission ne corrige qu’une anomalie triée « produit ».",
  "missions.form.application": "Application à faire évoluer",
  "missions.form.baseChoice": "Révision de base",
  "missions.form.baseDefault": "Par défaut : la révision de la version où les anomalies ont été trouvées, sinon la plus récente",
  "missions.form.baseRevision": "Travaille sur l’application « {{app}} », à partir de sa dernière révision livrée {{rev}}.",
  "missions.form.noApplication": "Aucune application livrée dans ce projet : un sprint ou une correction fait évoluer une application déjà générée et livrée.",
  "approvals.humanEditTitle": "Édition manuelle — aucun prompt",
  "approvals.humanEditAuthor": "Rédigée à la main par {{author}}, à partir de",
  "approvals.humanEditHint": "La source de cette version est l’artefact repris : la comparaison ci-dessous montre ce que l’auteur a changé. L’auteur ne peut pas approuver sa propre édition.",
  "approvals.humanEditNoJob": "Aucune génération : contenu rédigé à la main par {{author}}. Aucun job n’est à exécuter ; la publication suivra l’approbation.",
  "approvals.regenFailed": "La régénération a échoué : aucune nouvelle version ne reviendra en approbation.",
  "approvals.regenFailedUnknown": "Cause non transmise par le worker.",
  "approvals.regenKeptDrift": "La consigne demandait de conserver ces éléments ; cette version les a changés :",
  "approvals.regenKeptRemoved": "retiré",
  "approvals.regenKeptChanged": "modifié",
  "approvals.regenLimit": "{{n}} / {{max}} caractères — au-delà, la consigne est refusée ; une consigne longue peut aussi dépasser la fenêtre de contexte du modèle.",
  "approvals.specGateAxisBelow": "sous 9",
  "approvals.specGateFindingLines": "document, lignes {{lines}}",
  "approvals.specGateReasonScore": "Score global {{score}} sous le seuil de 9 (voir les axes ci-dessus)",
  "approvals.specGateReasonVerdict": "Le relecteur modèle n’a pas rendu le verdict « pass »",
  "approvals.specGateReasonCritical": "Au moins un constat critique (listé ci-dessous)",
  "approvals.specGateReasonChecks": "Au moins un des 13 contrôles a échoué",
  "approvals.specGateReasonSourceBlockers": "La source porte des points bloquants",
  "approvals.specGateReasonBlockers": "Des points bloquants ne sont pas résolus dans le document",
  "approvals.specGateSeverityCritical": "Critique",
  "approvals.specGateSeverityHigh": "Élevé",
  "missions.form.specOption": "{{fichier}} — v{{version}} · approbation n° {{id}} · approuvée le {{date}}{{dossier}}",
  "missions.decision.redesignTests": "Faire reconcevoir les tests cachés",
  "missions.decision.effect.takeOver": "La tâche est annulée et sort de la colonie : vous la réalisez vous-même, hors de l’outil. {{n}} tâche(s) qui en dépendent seront annulées.",
  "missions.decision.effect.reorient": "La tâche est rouverte : l’ouvrière reprend avec votre consigne, contre les MÊMES tests cachés. Une réouverture de plus (deux au plus) ; un nouvel arrêt consomme une escalade.",
  "missions.decision.effect.redesignTests": "La tâche est rouverte : la vérificatrice reconçoit les tests cachés à partir des tests rouges (et de votre consigne éventuelle), puis l’ouvrière reprend. À choisir quand les tests se contredisent, dépendent de leur ordre ou pilotent mal l’écran.",
  "missions.decision.effect.otherFamily": "La tâche est rouverte et confiée, une seule fois, à un modèle d’une autre famille (general_agent), contre les mêmes tests cachés.",
  "missions.decision.effect.acceptStop": "La tâche reste arrêtée, sans nouvelle tentative. {{n}} tâche(s) qui en dépendent seront annulées.",
  "missions.decision.effect.acknowledge": "L’escalade est close ; la mission reprend là où elle en était.",
  "missions.decision.errReorientTask": "Réorienter « {{titre}} » exige une consigne : écrivez-la dans la zone de cette tâche, rien n’a été envoyé.",
  "missions.decision.effect.refusedCap": "Refusé : tâche déjà rouverte deux fois.",
  "missions.decision.effect.acceptAllStops": "Toutes les tâches arrêtées le restent, sans nouvelle tentative ; {{c}} tâche(s) bloquée(s) par ces arrêts sont annulées ; la mission est close sans fusion et l’application est libérée pour une nouvelle mission.",
  "missions.decision.suiteSuspectNoReco": "Les tests cachés semblent en cause ({{r}}) : {{tests}}. La reconception n’est plus possible (tâche déjà rouverte deux fois).",
  "missions.evidence.suiteSuspectRefused": "La reconception n’est plus possible : tâche déjà rouverte deux fois.",
  "missions.evidence.suiteAppSide": "Imputés à l’application (elle répondait une erreur) : {{tests}}.",
  "missions.decision.suiteSuspect": "Les tests cachés semblent en cause ({{r}}) : {{tests}}. Décision recommandée : « Faire reconcevoir les tests cachés ».",
  "missions.decision.confirmTitle": "Confirmer « {{d}} » ?",
  "missions.decision.confirmCancelled": "Ces tâches, qui en dépendent, seront ANNULÉES :",
  "missions.decision.confirmNoCancel": "Aucune tâche ne dépend de celle-ci.",
  "missions.decision.confirmMissionEnds": "Plus aucune autre tâche ne peut réussir : la mission s’arrêtera. Sa cause restera l’arrêt sans convergence de cette tâche.",
  "missions.decision.confirmYes": "Confirmer",
  "missions.decision.confirmNo": "Annuler",
  "missions.evidence.failedTestsRedFirst": "Tests rouges mesurés avant le premier tour (rouge d’abord) · {{n}}",
  "missions.evidence.isolationTitle": "Isolation des tests cachés",
  "missions.evidence.isolationRerun": "{{n}} test(s) rouge(s) rejoué(s) seul(s) sur une application neuve.",
  "missions.evidence.orderDependent": "Rouges avec les autres tests, verts seuls : ils dépendent de l’ordre. Défaut de la suite, pas de l’application — comptés verts.",
  "missions.evidence.isolationInterrupted": "Rejeux interrompus : {{m}}",
  "missions.evidence.suiteSuspect": "Les tests cachés semblent en cause : {{r}}.",
  "missions.evidence.suiteSuspectAction": "Décision recommandée au poste de pilotage : « Faire reconcevoir les tests cachés ».",
  "missions.evidence.hiddenSuite": "Tests cachés conçus par la vérificatrice · {{n}}",
  "missions.evidence.hiddenSuiteNone": "Aucune suite cachée admise pour cette tâche.",
  "missions.evidence.kindBrowser": "navigateur",
  "missions.evidence.kindHttp": "HTTP",
  "missions.evidence.interfaceUsed": "Interface utilisée : {{i}}",
  "missions.evidence.uncovered": "Critères déclarés non couverts : {{u}}",
  "missions.evidence.none": "aucun",
  "missions.evidence.suiteModel": "Conçue par {{m}} · empreinte {{s}}",
  "missions.evidence.hiddenSuiteRecette": "Tests cachés : test de recette du cas, validé par un humain · {{n}}",
  "missions.evidence.kindRecette": "recette",
  "missions.evidence.recetteOrigin": "Test de recette du cas {{k}} « {{nom}} », validé par {{v}} le {{d}} — utilisé tel quel : aucune conception par le modèle, aucun juge de conception ; seul le rouge d’abord est exigé.",
  "missions.evidence.recetteRefusal": "Refusé comme test caché : {{c}} — {{m}}",
  "missions.evidence.suiteSuspectRecette": "La suite est le test de recette validé du cas {{k}} : elle ne se reconçoit pas par le modèle. Relisez-le (et corrigez-le s’il le faut) depuis la fiche du cas, faites-le valider, puis rouvrez la tâche.",
  "missions.obj.testsDesign": "{{n}} test(s) caché(s) conçus · critères {{c}} · interface {{i}}",
  "missions.obj.stopCause": "arrêt : {{r}} — cause : {{c}}",
  "missions.obj.stopCauseItem": "tâche {{k}} ({{m}})",
  "missions.obj.testsRecette": "test de recette du cas {{k}}, validé par {{v}} le {{d}} · {{n}} test(s) caché(s) tel(s) quel(s)",
  "missions.reason.withCause": "{{m}} — cause : {{c}}",
  "missions.reason.causeItem": "tâche {{k}} arrêtée ({{r}})",
  "missions.form.specBacklog": "{{n}} item(s) de backlog accepté(s) issus de cette spécification : la reine planifie à partir d’eux.",
  "missions.form.backlogPending": "Le backlog de cette spécification attend son approbation ({{n}} item(s) en attente) : faites-le approuver, puis lancez la mission.",
  "missions.form.backlogMissing": "Aucun item de backlog accepté issu de cette spécification : générez le backlog depuis son approbation (« Générer le backlog »), faites-le approuver, puis lancez la mission.",
  "missions.form.openApprovals": "Ouvrir les approbations",
  "missions.form.generateBacklog": "Générer le backlog de cette spécification",
  "missions.decision.suspect.order_dependent": "des tests dépendent de leur ordre",
  "missions.decision.suspect.test_defect": "un test échoue par sa propre faute",
  "missions.decision.suspect.red_every_attempt": "même test rouge à chaque tentative",
  "missions.decision.suspect.reds_trade_places": "corriger un test en casse un autre",
  "livrer.resignerRevision": "Reconstruire et re-signer la révision {{rev}}",
  "livrer.resignerTitreOk": "Reconstruire et re-signer (si l'image a été purgée de l'hôte depuis ce constat)",
  "livrer.imageAbsente": "Image absente de l'hôte",
  "runops.ouvrirApplication": "Ouvrir l’application",
  "runops.conteneur": "conteneur",
  "runops.composeTargetBranche": "Branche Git de publication du Compose",
  "runops.composeTargetAide": "Branche Git où « Publier le Compose » écrit le fichier ; sans rapport avec le nom des paliers.",
  "livrer.enServiceDescriptionPalier": "La version en service sur le palier déployé le plus haut, sa sonde, sa documentation et sa continuité.",
  "verifier.candidatsRevision": "{{n}} exécution(s) verte(s) du cas de reproduction sur une révision qui contient le correctif :",
  "anomalies.preuveRevision": "révision {{rev}} · arbre {{arbre}}",
  "anomalies.preuveArbre": "arbre {{arbre}}",
  "verifier.correctifRevision": "Révision du correctif : {{rev}}",
  "verifier.versSuiteTnr": "Les cas exigés à chaque version candidate forment la",
  "verifier.suiteTnrLien": "suite de non-régression",
  "verifier.ecartNonRegressionAcceptation": "L’acceptation motivée d’une régression n’est pas portée par cette passerelle. Le rapport ci-dessus est calculé sur les exécutions réelles des deux campagnes.",
  "verifier.ongletSuiteTnr": "Suite de non-régression",
  "tnr.ouvrirVersions": "Ouvrir les versions",
  "tnr.designee": "Suite de non-régression enregistrée",
  "tnr.nCas": "{{n}} cas",
  "tnr.origineAnomalie": "Anomalie corrigée",
  "tnr.origineExigence": "Exigence livrée",
  "tnr.livreeDans": "livrée dans {{v}}",
  "tnr.origineManuelle": "Ajout manuel",
  "tnr.origineInconnue": "Origine non tracée (plan existant)",
  "tnr.casAjoute": "Cas ajouté à la suite de non-régression",
  "tnr.casRetire": "Cas retiré de la suite",
  "tnr.retirerTitre": "Retirer {{cas}} de la suite de non-régression ?",
  "tnr.retirerConsequence": "Le cas ne sera plus exigé à chaque version candidate. Son historique d’exécutions reste intact.",
  "tnr.retirerReversible": "Vous pourrez l’ajouter de nouveau, avec son origine.",
  "tnr.retirer": "Retirer de la suite",
  "tnr.retirerMotif": "Pourquoi ce cas quitte-t-il la suite ? (obligatoire)",
  "tnr.retirerDesignationTitre": "Le plan « {{plan}} » cesse d’être la suite de non-régression ?",
  "tnr.retirerDesignationConsequence": "Plus aucune version candidate n’exigera d’exécution de non-régression tant qu’un autre plan n’est pas désigné.",
  "tnr.retirerDesignationReversible": "Le plan et ses cas restent intacts ; vous pourrez le désigner de nouveau.",
  "tnr.retirerDesignation": "Retirer la désignation",
  "tnr.designerForm": "Désigner le plan de la suite",
  "tnr.planPorteur": "Plan qui porte la suite",
  "tnr.choisirPlan": "Choisir un plan…",
  "tnr.changerPlan": "Faire de ce plan la suite",
  "tnr.designer": "Désigner comme suite de non-régression",
  "tnr.titre": "Suite de non-régression",
  "tnr.description": "Les cas rejoués à chaque version candidate : ce qui a été livré ou corrigé ne doit plus casser.",
  "tnr.chargement": "Chargement de la suite de non-régression…",
  "tnr.erreur": "Suite de non-régression illisible : la passerelle n’a pas répondu.",
  "tnr.lectureSeule": "Lecture seule : la suite se modifie par un propriétaire ou un contributeur du projet.",
  "tnr.aucuneSuite": "Aucune suite de non-régression désignée",
  "tnr.aucuneSuiteAide": "Désignez le plan de test qui la porte : ses cas seront exigés à chaque version candidate.",
  "tnr.planTitre": "Plan porteur",
  "tnr.casTitre": "Cas de la suite",
  "tnr.suiteVide": "La suite ne contient encore aucun cas",
  "tnr.suiteVideAide": "Ajoutez les cas proposés ci-dessous, ou un cas choisi à la main.",
  "tnr.colCas": "Cas",
  "tnr.colOrigine": "Origine",
  "tnr.colAjout": "Ajouté",
  "tnr.colDerniere": "Dernière exécution sur la suite",
  "tnr.colActions": "Actions",
  "tnr.jamaisExecute": "jamais exécuté sur la suite",
  "tnr.ajoutManuel": "Ajouter un cas à la main",
  "tnr.choisirCas": "Choisir un cas…",
  "tnr.ajouter": "Ajouter à la suite",
  "tnr.propositionsTitre": "Cas proposés à l’ajout",
  "tnr.propositionsAide": "Le cas d’une anomalie vérifiée protège sa correction ; le cas d’une exigence livrée et vérifiée protège la livraison. Rien n’entre dans la suite sans votre geste.",
  "tnr.aucuneProposition": "Aucune proposition",
  "tnr.aucunePropositionAide": "Elles naissent de la vérification d’une anomalie et de la certification d’une version.",
  "tnr.ajoutSansSuite": "Désignez d’abord le plan de la suite.",
  "tnr.versionsTitre": "Exigée à chaque version candidate",
  "tnr.aucuneVersion": "Aucune version en préparation",
  "tnr.aucuneVersionAide": "Une version se prépare dans Livraison › Versions.",
  "tnr.horsCycle": "hors cycle",
  "tnr.executee": "suite lancée",
  "tnr.campagne": "Campagne #{{id}} ({{statut}})",
  "tnr.aExecuter": "à exécuter : « Prête ? » bloque",
  "tnr.dejaDansSuite": "Le cas qui a vérifié la correction est dans la",
  "tnr.anomalieSansSuite": "Le projet n’a pas encore de suite de non-régression pour protéger cette correction :",
  "tnr.designerLien": "la désigner",
  "tnr.proposerAnomalie": "Protéger cette correction : ajouter le cas qui l’a vérifiée à la suite de non-régression.",
  "tnr.proposeLecture": "Ce cas est proposé à la suite de non-régression ; un contributeur peut l’y ajouter.",
  "tnr.refAnomalie": "ANO-{{id}}",
  "adr.card.decideOpen": "Décider…",
  "adr.card.decidedBy": "Décidée par {{who}} le {{when}}",
  "adr.card.decisionComment": "Commentaire de décision : {{c}}",
  "adr.card.optionExcluded": "Cette option est écartée par un critère obligatoire : elle ne peut pas être retenue.",
  "adr.matrix.outOfCatalog": "hors catalogue",
  "adr.matrix.reason.mandatoryFailed": "Échoue le critère obligatoire « {{criterion}} »",
  "adr.matrix.reason.outOfCatalog": "Option hors du catalogue des piles",
  "adr.matrix.unmeasured": "non qualifiée",
  "adr.stack.batch": "lot {{lot}}",
  "adr.stack.bench": "banc {{rev}}",
  "adr.stack.draws": "{{cases}} cas × {{draws}} tirage(s)",
  "adr.stack.deliveredRate": "qualifiée — tests livrés {{passed}}/{{total}} ({{pct}} % ≥ {{seuil}} %)",
  "adr.stack.deliveredAbove": "tests livrés {{passed}}/{{total}} ({{pct}} % ≥ {{seuil}} %)",
  "adr.stack.deliveredBelow": "tests livrés {{passed}}/{{total}} ({{pct}} % < {{seuil}} %)",
  "adr.stack.drawsOnly": "{{draws}} tirage(s) par cas",
  "adr.stack.noneQualified": "Aucune pile n’a passé tous ses cas dorés : une ADR de pile ne peut pas encore être décidée. Corrigez la génération de la pile visée, puis re-mesurez-la au banc et enregistrez la nouvelle qualification.",
  "adr.stack.reason.invalid": "Dernier reçu de qualification invalide ({{mesure}})",
  "adr.stack.reason.measure": "{{passed}}/{{total}} cas dorés, {{model}}",
  "adr.stack.reason.notQualified": "Pile non qualifiée ({{mesure}})",
  "adr.stack.reason.unmeasured": "Aucun cas doré qualifié pour cette pile (générabilité non mesurée)",
  "approvals.attestationRequiredApprove": "Cochez « J’ai relu le contenu » avant d’approuver.",
  "approvals.attestationRequiredReject": "Cochez « J’ai relu le contenu » avant de rejeter : le rejet engage votre relecture.",
  "approvals.regenHint2": "Décrivez la révision attendue ; le job reçoit l'entrée d'origine, votre consigne et CETTE version comme version précédente (édition manuelle comprise). La nouvelle version remplacera celle-ci.",
  "approvals.statusSuperseded": "Remplacée",
  "approvals.supersededPending": "Cette version a été remplacée par une version plus récente (régénération ou édition) : décidez plutôt la dernière version, dans la liste.",
  "approvals.commentLabelRisk": "Commentaire (obligatoire pour approuver malgré la réserve, et pour un rejet)",
  "approvals.reasonHintRisk": "Ajoutez un motif : il est exigé pour approuver malgré la réserve, comme pour rejeter.",
  "approvals.regenEtat.pending": "État : en file d’attente — le worker ne l’a pas encore pris.",
  "approvals.regenEtat.processing": "État : génération en cours.",
  "approvals.regenEtat.workerLost": "État : le worker ne répond plus — la génération peut être relancée depuis l’historique.",
  "approvals.regenEtat.done": "État : terminée — la nouvelle version attend sa décision dans la liste.",
  "approvals.regenEtat.failed": "État : échec.",
  "approvals.regenEtat.unknown": "État : lecture en cours…",
  "generation.distincts": "Cas distincts (facultatif)",
  "generation.lot": "Lot (facultatif)",
  "generation.revisionBanc": "Révision source du banc (facultatif)",
  "generation.tirages": "Tirages par cas (facultatif)",
  "item.statusFinal": "Aucune transition n’est permise depuis « {{actuel}} ».",
  "item.statusNext": "Depuis « {{actuel}} », le workflow permet : {{suivants}}.",
  "item.gererClassement": "Gérer les étiquettes, composants et versions du projet",
  "axesItem.titre": "Axes de portefeuille",
  "axesItem.chargement": "Chargement des axes…",
  "axesItem.vide": "Rattaché à aucun axe : il n’apparaît dans aucune analyse d’impact ni recherche de doublons.",
  "axesItem.detacher": "Détacher de l’axe {{nom}}",
  "axesItem.rattacher": "Rattacher à un axe",
  "axesItem.choisir": "Choisir un axe…",
  "axesItem.ajouter": "Rattacher",
  "axesItem.gerer": "Gérer les axes et voir les doublons probables",
  "gestes.raisons": "Ce qui l’interdit",
  "gestes.supprime": "Item supprimé",
  "gestes.supprConsequence": "L’item #{{id}} « {{titre}} », ses commentaires, pièces jointes et liens sont supprimés.",
  "gestes.supprDescendants": "Ses {{n}} descendant(s) sont supprimés avec lui.",
  "gestes.supprCas": "{{n}} cas de test resteront sans item rattaché.",
  "gestes.supprTitre": "Supprimer l’item #{{id}} ?",
  "gestes.supprIrreversible": "Aucune restauration : la suppression est consignée au journal d’audit.",
  "gestes.supprimer": "Supprimer l’item",
  "gestes.supprAttestation": "Je supprime aussi les {{n}} descendant(s).",
  "gestes.supprSection": "Supprimer l’item",
  "gestes.verification": "Vérification…",
  "gestes.descendants": "{{n}} descendant(s) seront supprimés avec lui.",
  "gestes.lectureSeule": "Réservé aux propriétaires et contributeurs du projet.",
  "gestes.fusionne": "Doublon fusionné : l’item conservé a tout repris",
  "gestes.fusionTitre": "Fusionner #{{source}} dans #{{cible}} ?",
  "gestes.fusionDeplace": "#{{cible}} « {{titre}} » reprend {{enfants}} enfant(s), {{com}} commentaire(s), étiquettes, axes, liens et cas de test.",
  "gestes.fusionSupprime": "#{{source}} « {{titre}} » est supprimé ; son instantané (titre, description, critères, auteur, motif) est conservé.",
  "gestes.fusionIrreversible": "Pas de défusion automatique : l’instantané permet de recréer l’item à la main.",
  "gestes.fusionner": "Fusionner",
  "gestes.fusionSection": "Fusionner ce doublon dans un autre item",
  "gestes.fusionAucunCandidat": "Aucun autre item du même type dans ce projet : rien à fusionner.",
  "gestes.fusionCible": "Item conservé (même type)",
  "gestes.fusionChoisir": "Choisir l’item conservé…",
  "gestes.apercu": "Aperçu de la fusion…",
  "gestes.fusionVers": "Vers",
  "gestes.fusionCompte": "Déplacés : {{enfants}} enfant(s), {{com}} commentaire(s), {{pj}} pièce(s) jointe(s), {{lab}} étiquette(s), {{axes}} axe(s), {{liens}} lien(s), {{cas}} cas de test, {{ano}} anomalie(s).",
  "gestes.fusionMotif": "Pourquoi est-ce un doublon ? (obligatoire)",
  "gestes.fusionMotifCourt": "Écrivez le motif (5 caractères au moins).",
  "gestes.absorbes": "Doublons absorbés par cet item",
  "gestes.code.BACKLOG_ITEM_IN_ACTIVE_SPRINT": "L’item ou un descendant est engagé dans un sprint actif : retirez-le du sprint d’abord",
  "gestes.code.BACKLOG_ITEM_IN_RELEASE": "L’item ou un descendant fait partie du contenu d’une version : retirez-le de la version d’abord",
  "gestes.code.BACKLOG_ITEM_REFERENCED": "L’item ou un descendant est cité par un incident de service",
  "job.appTreeWritten": "Application écrite",
  "job.backlogInserted": "Items de backlog ajoutés",
  "job.badgePublicationBlocked": "Publication bloquée",
  "job.block.git": "dépôt divergent",
  "job.block.other": "motif non précisé",
  "job.block.plan": "plan de publication divergent",
  "job.block.projection": "version divergente conservée",
  "job.block.snapshot": "contenu approuvé invalide",
  "job.deploymentStarted": "Déploiement en cours",
  "job.deploymentSucceeded": "Déploiement réussi",
  "job.files": "fichier(s)",
  "job.keptChanged": "Des exigences à conserver ont changé (voir l’avertissement)",
  "job.otherStep": "Étape technique : {{code}}",
  "job.previewFailed": "Aperçu en échec",
  "job.previewRunning": "Aperçu en service",
  "job.previewStarting": "Aperçu en démarrage",
  "job.previewStopped": "Aperçu arrêté",
  "job.publicationBlocked": "Publication bloquée, nouvelle tentative prévue",
  "job.publicationTerminalBlocked": "Publication bloquée définitivement",
  "job.reviewSubmitted": "Revue indépendante déposée",
  "job.signed": "Révision signée",
  "job.signingStarted": "Construction et signature de la révision",
  "job.specGateDone": "Spec Gate évalué",
  "job.specGateStarted": "Évaluation Spec Gate en cours",
  "job.stackResolved": "Pile retenue",
  "job.revisionInstructionsOmitted": "(écartées par la borne : {{versions}})",
  "job.revisionInstructionsResolved": "Consignes précédentes jointes",
  "job.templateLeakRefused": "Sortie refusée : lignes de gabarit non résolues",
  "job.templateLeakRepair": "Lignes de gabarit détectées : réparation tentée",
  "job.terminalFailed": "Traitement terminé en échec",
  "job.terminalSucceeded": "Traitement terminé",
  "launchedJobs.cause": "Cause : {{cause}}",
  "launchedJobs.causeUnknown": "non transmise par le worker",
  "launchedJobs.done": "Terminé",
  "launchedJobs.failed": "Échec",
  "launchedJobs.failedAppHint": "Aucune application ne reviendra en approbation pour ce lancement ; vous pouvez relancer la génération.",
  "launchedJobs.failedHint": "Aucune nouvelle version ne reviendra en approbation pour ce lancement.",
  "launchedJobs.running": "En cours",
  "launchedJobs.title": "Travaux lancés depuis cette demande",
  "launchedJobs.type.backlog": "Génération du backlog",
  "launchedJobs.type.designFlow": "Parcours d’écrans",
  "launchedJobs.type.epics": "Génération des epics",
  "launchedJobs.type.framing": "Cadrage",
  "launchedJobs.type.options": "Proposition d’options",
  "launchedJobs.type.other": "Job {{type}}",
  "launchedJobs.type.personas": "Génération des personas",
  "launchedJobs.type.processes": "Cartographie des processus",
  "launchedJobs.type.scaffoldApp": "Génération de l'application",
  "launchedJobs.type.spec": "Rédaction de la spécification",
  "launchedJobs.type.specGate": "Évaluation Spec Gate",
  "launchedJobs.workerLost": "Worker perdu",
  "revision.rejected": "approbation rejetée",
  "revision.rejectedInReview": "rejetée en revue",
  "tests.cancelEchec": "Annulation refusée par la passerelle : {{motif}}",
  "tests.cancelReasonRequired": "Saisissez le motif d’annulation : il est obligatoire et reste au journal de la campagne.",
  "tests.ouvrirPlan": "Ouvrir la fiche du plan {{nom}}",
  "planFiche.campagne": "Campagne #{{id}}",
  "planFiche.masquerExecutions": "Masquer les exécutions",
  "planFiche.voirExecutions": "Voir les exécutions",
  "planFiche.chargementExecutions": "Chargement des exécutions…",
  "planFiche.aucuneExecution": "Aucune exécution dans cette campagne",
  "planFiche.aucuneExecutionAide": "Les exécutions naissent du lanceur pas à pas ou du runner.",
  "planFiche.executions": "Exécutions",
  "planFiche.retour": "Retour aux plans et campagnes",
  "planFiche.invalide": "Plan introuvable",
  "planFiche.invalideAide": "Le lien ne désigne pas un plan.",
  "planFiche.chargement": "Chargement du plan…",
  "planFiche.introuvable": "Plan introuvable",
  "planFiche.introuvableAide": "Ce plan n’existe pas dans le projet ouvert.",
  "planFiche.erreur": "Plan illisible : la passerelle n’a pas répondu.",
  "planFiche.titre": "Plan de test — {{nom}}",
  "planFiche.description": "Cas du plan, versions publiées et campagnes ouvertes sur ce plan.",
  "planFiche.estSuite": "Ce plan est la suite de non-régression du projet",
  "planFiche.designerSuite": "En faire la suite de non-régression",
  "planFiche.cas": "Cas du plan ({{n}})",
  "planFiche.aucunCas": "Aucun cas dans ce plan",
  "planFiche.aucunCasAide": "Rattachez des cas depuis la liste des cas (Tests › Cas, plans et campagnes).",
  "planFiche.versCas": "Ouvrir les cas",
  "planFiche.versions": "Versions publiées",
  "planFiche.chargementVersions": "Chargement des versions…",
  "planFiche.aucuneVersion": "Aucune version publiée",
  "planFiche.aucuneVersionAide": "Une version fige la liste des cas pour une campagne : « Publier une version » dans Tests.",
  "planFiche.campagnes": "Campagnes sur ce plan",
  "planFiche.chargementCampagnes": "Chargement des campagnes…",
  "planFiche.aucuneCampagne": "Aucune campagne sur ce plan",
  "planFiche.aucuneCampagneAide": "Ouvrez une campagne depuis Tests › Plans et campagnes.",
  "versions.removeConfirmConsequence": "L’élément ne fera plus partie de cette version ; il reste disponible pour être rattaché de nouveau.",
  "versions.removeConfirmTitle": "Retirer « {{objet}} » du contenu de {{version}} ?",
  "versions.removeConfirmVerb": "Retirer",
  "vueProjet.casDores": "{{passed}} / {{total}} cas dorés",
  "vueProjet.indicateursFlux05x": "Indicateurs : le flux des changements technologiques est conçu, livré après la v0.5.0 — cette mesure n’existe pas encore côté passerelle.",
  "vueProjet.pileNonQualifiee": "non qualifiée",
  "vueProjet.pileQualifiee": "qualifiée",
  "apercu.restart.action": "Redémarrer",
  "apercu.restart.failed": "Redémarrage en échec : {{cause}}",
  "apercu.restart.hint": "Recrée les conteneurs de l’aperçu en gardant son volume de données : pour éprouver « les données survivent au redémarrage ».",
  "apercu.restart.noCause": "cause non transmise",
  "apercu.restart.noVolume": "Aucun volume de données : les données de cet aperçu ont été perdues au redémarrage.",
  "apercu.restart.recreated": "Conteneurs recréés (prouvé) : {{avant}} → {{apres}}.",
  "apercu.restart.running": "Redémarrage en cours : les conteneurs de l’aperçu sont recréés…",
  "apercu.restart.unverified": "Recréation non vérifiable (conteneurs illisibles) : {{avant}} → {{apres}}.",
  "apercu.restart.volume": "Données conservées dans le volume {{volume}}.",
  "apercu.share.action": "Partager (24 h)",
  "apercu.share.active": "Liens actifs",
  "apercu.share.close": "Fermer le partage",
  "apercu.share.copy": "Copier",
  "apercu.share.create": "Créer le lien ({{count}} h)",
  "apercu.share.createRestricted": "Créer ou révoquer un lien de partage",
  "apercu.share.createdCopied": "Lien créé et copié · expire le {{date}} ({{count}} h)",
  "apercu.share.createdNotCopied": "Lien créé · expire le {{date}} ({{count}} h). Copie automatique impossible : sélectionnez le lien.",
  "apercu.share.duration": "Durée du lien",
  "apercu.share.empty": "Aucun lien actif pour cet aperçu.",
  "apercu.share.hours": "{{count}} h",
  "apercu.share.item": "Lien {{short}} · par {{author}} · expire le {{date}}",
  "apercu.share.link": "Lien à transmettre",
  "apercu.share.loading": "Chargement des liens de partage…",
  "apercu.share.revoke": "Révoquer",
  "apercu.share.rule": "Le lien désigne cet aperçu : il ne l’ouvre qu’à un membre connecté du projet, jusqu’à son échéance, et ne contient aucun jeton d’accès. Création, ouverture et révocation sont tracées à l’audit.",
  "apercu.share.title": "Partager l’aperçu",
  "apercu.shareOpen.back": "Aller aux aperçus de mon projet",
  "apercu.shareOpen.description": "Ouverture d’un aperçu partagé par lien : réservée aux membres connectés du projet.",
  "apercu.shareOpen.error": "Le lien de partage n’a pas pu être ouvert",
  "apercu.shareOpen.expired": "Ce lien de partage a expiré",
  "apercu.shareOpen.expiredHint": "Un lien de partage ne vaut que jusqu’à son échéance. Demandez un nouveau lien.",
  "apercu.shareOpen.forbidden": "Ce lien désigne l’aperçu d’un projet dont vous n’êtes pas membre",
  "apercu.shareOpen.forbiddenHint": "Un lien de partage n’ouvre l’aperçu qu’aux membres du projet. Demandez l’accès à son propriétaire.",
  "apercu.shareOpen.loading": "Ouverture du lien de partage…",
  "apercu.shareOpen.notFound": "Lien de partage introuvable",
  "apercu.shareOpen.notFoundHint": "Il n’existe pas, ou il appartient à une autre organisation. Vérifiez l’adresse reçue.",
  "apercu.shareOpen.notLive": "L’aperçu désigné n’est plus en marche.",
  "apercu.shareOpen.opened": "Aperçu ouvert depuis un lien de partage de {{author}}, valable jusqu’au {{date}}.",
  "apercu.shareOpen.revoked": "Ce lien de partage a été révoqué",
  "apercu.shareOpen.revokedHint": "Il ne mène plus à l’aperçu. Demandez un nouveau lien à la personne qui vous l’a envoyé.",
  "apercu.viewport.emulation": "Émulation : le cadre prend la largeur et la hauteur de l’appareil choisi ({{width}} × {{height}} px). Ce n’est pas un appareil réel : moteur du navigateur, tactile et densité de pixels restent ceux de ce poste.",
  "runops.redeploy.containers": "avant {{avant}} → après {{apres}}",
  "runops.redeploy.notRecreated": "Conteneurs NON recréés : {{services}}",
  "runops.redeploy.recreated": "Conteneurs recréés (prouvé)",
  "runops.redeploy.unverified": "Recréation non vérifiable (conteneurs illisibles)",
  "invitations.aucune": "Aucune invitation n’attend votre réponse. Un propriétaire d’espace peut vous en adresser une.",
  "invitations.description": "Rejoindre un espace auquel vous avez été invité.",
  "invitations.detail": "Rôle offert : {{role}}{{par}}{{echeance}}",
  "invitations.echeance": " · valable jusqu’au {{date}}",
  "invitations.ignorer": "Ignorer ce lien",
  "invitations.lienAide": "L’invitation est nominative : elle ne vaut que pour le compte dont l’adresse e-mail a été invitée. En la rejoignant, vous devenez membre de l’espace avec le rôle offert.",
  "invitations.lienTitre": "Vous avez ouvert un lien d’invitation",
  "invitations.par": " · invité par {{nom}}",
  "invitations.recues": "Invitations reçues",
  "invitations.refus.consommee": "Cette invitation a déjà été acceptée.",
  "invitations.refus.echue": "Cette invitation a expiré : demandez-en une nouvelle au propriétaire de l’espace.",
  "invitations.refus.emailNonAtteste": "Votre adresse e-mail n’est pas attestée : ouvrez le lien d’invitation qui vous a été transmis pour rejoindre l’espace.",
  "invitations.refus.inconnu": "L’acceptation a échoué.",
  "invitations.refus.indisponible": "Cette invitation n’existe pas ou n’est pas adressée au compte connecté (vérifiez l’adresse e-mail du compte).",
  "invitations.refus.revoquee": "Cette invitation a été révoquée par un propriétaire de l’espace ou par l’administration de l’organisation.",
  "invitations.rejoindre": "Rejoindre l’espace",
  "invitations.rejointe": "Espace rejoint",
  "invitations.titre": "Invitations",
  "runops.clotureEffet1": "Le déploiement est clos avec cette issue ; seule une issue « Réussi » ouvre le palier suivant.",
  "runops.clotureEffet2": "L’issue est tracée comme saisie manuelle, avec votre identité, dans le journal d’audit.",
  "runops.clotureGroupe": "Déclarer l’issue observée de {{version}}",
  "runops.clotureIrreversible": "Une issue déclarée ne se réécrit pas : un nouveau déploiement la remplacera.",
  "runops.clotureTitre": "Déclarer « {{issue}} » pour {{version}} sur {{env}} ?",
  "runops.clotureVerbe": "Déclarer l’issue",
  "runops.issue.failed": "Échoué",
  "runops.issue.rolledBack": "Annulé (retour arrière)",
  "runops.issue.succeeded": "Réussi",
  "runops.issueDeclaree": "Issue du déploiement déclarée",
  "runops.issueObservee": "Issue observée",
  "missions.plan.sodTwoPerson": "Le mode deux personnes de ce projet ne s’applique pas aux missions : leur plan et leur dossier engagent un budget GPU et l’exécution du code généré.",
  "missions.plan.twoPersonExcluded": "Vous avez lancé cette mission : même en mode deux personnes, un autre membre approuve son plan et son budget (budget GPU et exécution du code généré).",
  "planifier.lancerSprintNote": "Une mission de sprint itère sur l’application déjà livrée de ce projet, à partir de sa dernière révision livrée : le formulaire les montre, et refuse avant le lancement si aucune application n’est livrée.",
  "planifier.lancerTrancheNom": "Lancer une mission sur la tranche #{{id}} « {{titre}} »",
  "planifier.lancerTrancheNote": "Une mission sur une tranche est une mission de sprint sur une feature PRÊTE et ses stories : « Lancer une mission sur cette tranche » ouvre le lanceur prérempli. La reine propose ensuite le plan, qu’un autre membre approuve.",
  "planifier.trancheEvaluationEnCours": "Évaluation de la préparation en cours : le lancement attend de savoir si la tranche est prête.",
  "planifier.trancheEvaluationIndisponible": "Préparation non évaluée par la passerelle : impossible de dire qu’une tranche est prête, le lancement est désactivé.",
  "planifier.trancheNonPrete": "La tranche n’est pas prête : {{n}} manque(s).",
  "runops.production": "Type de palier",
  "runops.productionDeduite": "Non déclaré — hors production sauf si le nom dit « production »",
  "runops.productionDeduiteNon": "Non déclaré — déduit : hors production (à déclarer)",
  "runops.productionDeduiteOui": "Non déclaré — déduit : production (à déclarer)",
  "runops.productionNon": "Hors production — dev, recette, préproduction",
  "runops.productionOui": "Production — utilisé par les clients réels",
  "runops.refusVersionHorsCycle": "Version hors cycle : adoptez-la dans le cycle de version puis faites approuver son déploiement sur cet environnement (écran Versions).",
  "import.tropGros": "Fichier trop volumineux ({{taille}} Kio) : 1 Mio au plus. Découpez le référentiel en plusieurs fichiers.",
  "import.encodage": "Ce fichier n’est pas en UTF-8 : des caractères sont illisibles. Réenregistrez-le en « CSV UTF-8 » puis choisissez-le de nouveau.",
  "import.tropDeLignes": "{{n}} lignes : 5 000 au plus par import. Découpez le référentiel en plusieurs fichiers.",
  "import.titre": "Importer un référentiel",
  "import.de": "Axes de l’organisation depuis un CSV de tableur ou un export Jira : un constat d’abord, rien n’est écrit avant « Appliquer ».",
  "import.retour": "Retour aux axes",
  "import.etapes": "Étapes de l’import",
  "import.etape1": "Choisir le fichier",
  "import.etape2": "Constat — rien n’est écrit",
  "import.etape3": "Appliquer",
  "import.choisirTitre": "1. Choisir le fichier",
  "import.fichier": "Fichier CSV",
  "import.limites": "CSV en UTF-8 (un tableur l’appelle « CSV UTF-8 »), 1 Mio et 5 000 lignes au plus, un axe par ligne. Nature : 40 caractères au plus ; nom : 120.",
  "import.nLignes": "{{n}} ligne(s) après l’en-tête",
  "import.separateur": "Séparateur du fichier",
  "import.virgule": "Virgule « , » (export Jira)",
  "import.pointVirgule": "Point-virgule « ; » (tableur)",
  "import.tabulation": "Tabulation",
  "import.colonnesAttendues": "Colonnes attendues",
  "import.colonne": "colonne",
  "import.sens": "sens",
  "import.kindSens": "nature de l’axe (portefeuille, domaine, capacité… ou la vôtre)",
  "import.obligatoire": "obligatoire",
  "import.nameSens": "nom de l’axe",
  "import.parentSens": "nom de l’axe parent (dans le fichier ou déjà présent)",
  "import.facultative": "facultative",
  "import.descriptionSens": "texte libre",
  "import.guillemets": "Les guillemets protègent un libellé qui contient le séparateur ou un retour à la ligne (« Sinistres, auto et habitation »).",
  "import.jiraTitre": "Faire correspondre les colonnes (export Jira)",
  "import.jiraAide": "Ce fichier n’a pas de colonnes « kind » et « name » : choisissez celles qui en tiennent lieu. Seule la ligne d’en-tête est réécrite avant l’envoi.",
  "import.mapKind": "Nature (kind) ←",
  "import.mapName": "Nom (name) ←",
  "import.mapParent": "Parent ←",
  "import.mapDescription": "Description ←",
  "import.aucune": "— aucune —",
  "import.mapManque": "Nature et nom sont obligatoires.",
  "import.analyser": "Analyser sans rien écrire",
  "import.refusLecteur": "Lecteur : l’analyse et l’import sont réservés aux contributeurs du projet ; vous voyez les axes.",
  "import.analyseEnCours": "Analyse de {{nom}}… recherche des axes déjà présents dans l’organisation.",
  "import.refusFichier": "Fichier refusé",
  "import.refusTaille": "Fichier trop volumineux",
  "import.refusEncodage": "Encodage non pris en charge",
  "import.erreurAnalyse": "Analyse impossible ; rien n’a été écrit.",
  "import.constatTitre": "2. Constat avant application — rien n’a été écrit",
  "import.constatVide": "Choisissez un fichier puis « Analyser sans rien écrire » : le constat dit ce que l’import créerait, réutiliserait et refuserait, ligne par ligne.",
  "import.appliquer": "Appliquer : créer {{n}} axe(s)",
  "import.changer": "Changer de fichier",
  "import.rienACreer": "Rien à créer : tous les axes valides du fichier sont déjà présents.",
  "import.motifAppliquer": "Les axes sont partagés par toute l’organisation : seul un administrateur d’organisation applique l’import. Le constat reste ouvert à tout contributeur.",
  "import.succes": "Import appliqué : {{crees}} axe(s) créé(s), {{rattaches}} rattaché(s) à leur parent.",
  "import.rejouable": "Rejouable : les axes déjà présents sont réutilisés, jamais dupliqués. L’import est tracé au journal d’audit de l’organisation.",
  "import.voirAxes": "Voir les axes",
  "import.autre": "Importer un autre fichier",
  "import.aCreer": "À créer",
  "import.nouveaux": "nouveaux axes",
  "import.deja": "Déjà présents",
  "import.reutilises": "réutilisés tels quels, jamais dupliqués",
  "import.refusees": "Lignes refusées",
  "import.surN": "sur {{n}} lue(s)",
  "import.partages": "Ces axes sont partagés par toute l’organisation (tous les projets), pas seulement par « {{projet}} » : relisez avant d’appliquer.",
  "import.apercuTitre": "Aperçu des créations — les {{n}} premières sur {{total}}",
  "import.ligne": "ligne",
  "import.nature": "nature",
  "import.nom": "nom",
  "import.parent": "parent",
  "import.description": "description",
  "import.parentIntrouvable": "parent introuvable",
  "import.avertissementsTitre": "Avertissements",
  "import.ligneN": "Ligne {{n}}",
  "import.erreursTitre": "Erreurs de lignes",
  "import.motif": "motif",
  "import.refusesNonDetailles": "… et {{n}} autre(s) ligne(s) refusée(s), non détaillée(s).",
  "import.corriger": "Ces lignes sont ignorées. Corrigez le fichier et relancez l’analyse : l’import se rejoue sans doublon.",
  "harnais.ongletCastes": "Castes",
  "harnais.ongletAgents": "Agents personnalisés",
  "harnais.ongletMcp": "Serveurs MCP",
  "harnais.ongletModeles": "Connexions et modèles",
  "harnais.ongletSupervision": "Supervision",
  "harnais.titre": "Harnais et agents",
  "harnais.de": "Castes du harnais, agents personnalisés et leur promotion, serveurs MCP, modèles",
  "harnais.onglets": "Vues du harnais",
  "harnais.aVenir": "Cette vue n’a pas encore d’écran dédié. Les castes, serveurs MCP et modèles se règlent aujourd’hui dans",
  "harnais.gabarits": "Gabarits",
  "agentsPerso.plateforme": "catalogue de la plateforme",
  "agentsPerso.enRevue": "en revue",
  "agentsPerso.promu": "promu par l’organisation",
  "agentsPerso.refuse": "promotion refusée",
  "agentsPerso.brouillon": "brouillon de projet",
  "agentsPerso.brouillonAncien": "brouillon (antérieur à la revue)",
  "agentsPerso.r.catalogue": "Agent du catalogue de la plateforme : lisible de tous, non modifiable ici.",
  "agentsPerso.r.enRevue": "En revue : le contenu est figé jusqu’à la décision du relecteur.",
  "agentsPerso.r.promu": "Promu : tous les projets le voient, il est figé. L’administration d’organisation retire d’abord la promotion.",
  "agentsPerso.r.proprietaire": "Seul le propriétaire du projet d’origine modifie un brouillon.",
  "agentsPerso.r.admin": "La promotion revient à l’administration d’organisation.",
  "agentsPerso.r.sansModele": "Aucun modèle par défaut : aucun projet ne pourrait l’exécuter. Choisissez-en un d’abord.",
  "agentsPerso.r.modele": "Son modèle par défaut n’est pas accordé à l’organisation : choisissez un modèle accordé avant la revue.",
  "agentsPerso.r.etat": "Cet acte ne s’applique pas à l’état actuel de l’agent.",
  "agentsPerso.r.auteur": "Vous êtes l’auteur de cet agent : un autre relecteur tranche sa promotion.",
  "agentsPerso.r.relecteur": "Seul le relecteur désigné tranche cette promotion.",
  "agentsPerso.retire": "« {{nom}} » redevient brouillon de son projet.",
  "agentsPerso.chargement": "Lecture des agents personnalisés…",
  "agentsPerso.refusLecture": "Les agents personnalisés ne vous sont pas ouverts.",
  "agentsPerso.erreur": "Les agents personnalisés n’ont pas pu être lus ; rien n’a changé.",
  "agentsPerso.titre": "Agents personnalisés — provenance et statut",
  "agentsPerso.regle": "Un brouillon n’est visible que de son projet d’origine ; promu par l’organisation, il l’est de tous les projets. La promotion passe par la revue d’un relecteur distinct de l’auteur.",
  "agentsPerso.vide": "Aucun agent personnalisé",
  "agentsPerso.videIndice": "Le propriétaire d’un projet crée un agent ; il naît brouillon de ce projet.",
  "agentsPerso.creer": "Créer un agent dans « {{projet}} »",
  "agentsPerso.refusCreer": "Seul le propriétaire du projet actif crée un agent ; il naît brouillon de ce projet.",
  "agentsPerso.cycle": "Cycle d’un agent",
  "agentsPerso.c1": "Brouillon : créé par le propriétaire d’un projet, visible de ce projet seul.",
  "agentsPerso.c2": "En revue : envoyé par l’administration d’organisation, relecteur distinct de l’auteur, modèle accordé ; contenu figé.",
  "agentsPerso.c3": "Promu ou refusé : tranché par le seul relecteur ; un refus est motivé, l’auteur corrige et le brouillon repart.",
  "agentsPerso.c4": "Retrait : l’administration remet un agent promu à l’état de brouillon de son projet.",
  "agentsPerso.outils": "Un agent personnalisé n’a pas d’outils : leur attribution est refusée (TOOLS_NOT_SUPPORTED).",
  "agentsPerso.provPlateforme": "catalogue de la plateforme",
  "agentsPerso.provenance": "créé par le projet {{projet}} · {{auteur}}",
  "agentsPerso.provInconnue": "provenance inconnue (créé avant la revue des agents)",
  "agentsPerso.relecteurDe": "relecteur : {{r}}",
  "agentsPerso.cestVous": "c’est vous",
  "agentsPerso.refusePar": "Promotion refusée par {{r}} : « {{motif}} »",
  "agentsPerso.modifier": "Modifier",
  "agentsPerso.promouvoir": "Promouvoir…",
  "agentsPerso.trancher": "Relire et trancher…",
  "agentsPerso.annulerRevue": "Annuler la revue",
  "agentsPerso.retirer": "Retirer la promotion",
  "agentsPerso.modifie": "Agent enregistré — {{nom}}",
  "agentsPerso.cree": "Agent créé — {{nom}}, brouillon de ce projet",
  "agentsPerso.modifierTitre": "Modifier l’agent « {{nom}} »",
  "agentsPerso.creerTitre": "Créer un agent personnalisé",
  "agentsPerso.creerAide": "Il naît brouillon de son projet d’origine, visible de ce projet seul, jusqu’à sa promotion par l’organisation.",
  "agentsPerso.nom": "Nom",
  "agentsPerso.nomRequis": "Donnez un nom à l’agent.",
  "agentsPerso.persona": "Persona",
  "agentsPerso.personaRequis": "Nommez la persona (100 caractères au plus).",
  "agentsPerso.description": "Description",
  "agentsPerso.prompt": "Prompt système (obligatoire)",
  "agentsPerso.promptRequis": "Le prompt système est obligatoire.",
  "agentsPerso.modele": "Modèle par défaut",
  "agentsPerso.aucunModele": "— aucun —",
  "agentsPerso.modeleAide": "Un modèle accordé à l’organisation est exigé pour la revue et au lancement (MODEL_NOT_GRANTED sinon).",
  "agentsPerso.annuler": "Annuler",
  "agentsPerso.enregistrer": "Enregistrer",
  "agentsPerso.envoye": "« {{nom}} » envoyé en revue à {{r}}.",
  "agentsPerso.promouvoirTitre": "Promouvoir « {{nom}} » au catalogue de l’organisation",
  "agentsPerso.promouvoirAide": "Promu, l’agent devient lisible par tous les projets ; son projet d’origine perd la modification seule.",
  "agentsPerso.provenanceCle": "Provenance",
  "agentsPerso.modeleCle": "Modèle",
  "agentsPerso.accorde": "accordé à l’organisation",
  "agentsPerso.nonAccorde": "non accordé",
  "agentsPerso.outilsCle": "Outils",
  "agentsPerso.aucunOutil": "aucun (l’attribution d’outils reste refusée)",
  "agentsPerso.relecteur": "Relecteur (distinct de l’auteur)",
  "agentsPerso.lectureRelecteurs": "Lecture…",
  "agentsPerso.choisir": "— choisir —",
  "agentsPerso.relecteurRequis": "Désignez un relecteur.",
  "agentsPerso.note": "Note pour le relecteur (facultative)",
  "agentsPerso.envoyer": "Envoyer en revue",
  "agentsPerso.promuAnnonce": "« {{nom}} » promu au catalogue de l’organisation.",
  "agentsPerso.refuseAnnonce": "Promotion de « {{nom}} » refusée ; l’auteur lit votre motif.",
  "agentsPerso.trancherTitre": "Relire « {{nom}} »",
  "agentsPerso.trancherAide": "Vous êtes le relecteur désigné. Promu, l’agent devient lisible par tous les projets de l’organisation.",
  "agentsPerso.motif": "Motif (obligatoire pour refuser, 10 caractères au moins)",
  "agentsPerso.motifRequis": "Motivez le refus : l’auteur le lit pour corriger (10 caractères au moins).",
  "agentsPerso.refuserBouton": "Refuser",
  "agentsPerso.promouvoirBouton": "Promouvoir",
  "taxonomy.importer": "Importer un référentiel",
  "missions.replan.changed": "La proposition a changé depuis votre lecture : relisez-la avant de l’approuver.",
  "missions.replan.stale": "Les tâches restantes ont changé depuis la proposition : elle ne s’applique plus telle quelle.",
  "missions.replan.selfRefused": "Vous avez lancé cette mission : un autre membre doit approuver sa replanification (séparation des tâches).",
  "missions.replan.announceApproved": "Nouveau découpage approuvé : la colonie reprend sur les parties.",
  "missions.replan.announceRejected": "Replanification refusée : la tâche arrêtée attend votre décision.",
  "missions.replan.title": "Replanification proposée par la reine",
  "missions.replan.unreadable": "La proposition n’est pas servie lisiblement : elle ne peut pas être approuvée à l’aveugle.",
  "missions.replan.errReason": "Refuser la replanification exige un motif.",
  "missions.replan.index": "replanification {{i}} sur {{max}} au plus",
  "missions.replan.stopped": "La tâche {{rang}} « {{titre}} » s’est arrêtée sans converger ({{cause}}) : {{detail}}",
  "missions.replan.split": "Découpage proposé (chaque partie est jugée par SES critères seulement)",
  "missions.replan.part": "Tâche {{rang}} — {{titre}}",
  "missions.replan.partMeta": "carte {{carte}} · dépend de {{deps}}",
  "missions.replan.rewiredTitle": "Tâches restantes rebranchées",
  "missions.replan.rewired": "Tâche {{rang}} « {{titre}} » : dépendait de {{avant}}, dépendra de {{apres}}",
  "missions.replan.effect": "Approuver annule la tâche {{rang}} (remplacée) et insère les parties ; décider la tâche arrêtée autrement, dans « Attend un humain », décline cette proposition. Empreinte de la proposition relue : {{sha}}",
  "missions.replan.readOnly": "Un contributeur ou le propriétaire du projet décide de la replanification.",
  "missions.replan.approve": "Approuver le nouveau découpage",
  "missions.replan.sod": "Vous avez lancé cette mission : un autre membre doit approuver sa replanification, comme son plan (séparation des tâches). « Refuser avec motif » reste possible.",
  "missions.replan.reason": "Motif du refus",
  "missions.replan.confirmReject": "Confirmer le refus",
  "missions.replan.reject": "Refuser avec motif",
  "missions.diff.added": "ajoutée",
  "missions.diff.removed": "retirée",
  "missions.diff.dossier": "Dossier de preuves rendu",
  "missions.diff.truncated": "Extrait tronqué par la greffière : les fichiers marqués « hors extrait » ne sont pas montrés ici. Diff complet : {{ref}}, empreinte {{sha}}.",
  "missions.diff.tree": "Fichiers modifiés ({{n}})",
  "missions.diff.outOfExcerpt": "hors extrait",
  "missions.diff.new": "nouveau",
  "missions.diff.deleted": "supprimé",
  "missions.diff.previous": "Fichier précédent",
  "missions.diff.next": "Fichier suivant",
  "missions.diff.outOfExcerptDetail": "Ce fichier est au-delà de l’extrait servi : son diff est dans le fichier complet {{ref}} (empreinte {{sha}}).",
  "missions.diff.binary": "Fichier binaire : aucun diff textuel.",
  "missions.diff.region": "Diff de {{f}}",
  "missions.diff.caption": "Lignes : ancien numéro, nouveau numéro, contenu",
  "missions.diff.rawText": "Texte servi intégral (dossier rendu et extrait du diff, celui que l’empreinte couvre)",
  "missions.decision.replanPending": "La reine propose un nouveau découpage de cette tâche (section « Replanification proposée par la reine ») : l’approuver la remplace ; une décision ci-dessous décline la proposition.",
  "missions.decision.openStops": "{{n}} arrêt(s) de tâche attendent une décision : tant qu’il en reste un, la mission reste suspendue et son application ne peut accueillir aucune autre mission.",
  "missions.decision.acceptAllStops": "Prendre acte de tous les arrêts et clore la mission",
  "missions.decision.closeAllBlocked": "D’autres tâches de la mission peuvent encore réussir : tranchez ces arrêts un par un.",
  "missions.replan.cause.generation_timeout": "délais de génération répétés",
  "missions.replan.cause.task_tokens": "plafond de jetons de la tâche",
  "missions.reason.replan_proposed": "nouveau découpage proposé par la reine",
  "missions.reason.replanned": "remplacée par un nouveau découpage",
  "missions.reason.recette_test_invalid": "test de recette inutilisable comme test caché",
  "missions.reason.recette_test_not_reproduced": "test de recette vert sur la version de départ : anomalie non reproduite",
  "missions.diff.opened": "Fichier ouvert : {{f}}",
  "missions.form.launching": "Lancement en cours : la mission est créée, puis la reine prépare le plan…",
  "missions.form.slice": "Tranche : feature #{{id}} « {{titre}} » et ses stories à faire.",
  "missions.form.sliceBacklog": "Voir « Prêt pour la colonie »",
  "missions.form.sliceDefaultTitle": "Tranche — {{titre}}",
  "missions.form.sliceNotEvaluated": "Préparation de la tranche non lue ici : la passerelle la vérifie au lancement (SLICE_NOT_READY si elle n’est pas prête).",
  "missions.form.sliceNotReady": "La tranche n’est pas prête : {{n}} manque(s).",
  "missions.form.sliceOpen": "Ouvrir la fiche",
  "missions.form.sliceReady": "Prête pour la colonie selon la passerelle : la reine planifie à partir de ses stories.",
  "missions.form.sliceUnknown": "Tranche : feature #{{id}} et ses stories à faire.",
  "missions.pause.alreadySuspended": "Pause inutile : la mission est déjà suspendue par l’outil ; elle reprendra seule quand une place se libère. Arrêtez-la si vous ne voulez pas qu’elle reprenne.",
  "missions.pause.alreadySuspendedExecutor": "Pause inutile : la mission est déjà suspendue par l’outil ; elle reprendra seule quand un exécutant répond. Arrêtez-la si vous ne voulez pas qu’elle reprenne.",
  "missions.pause.alreadySuspendedHuman": "Pause inutile : la mission est déjà suspendue, en attente d’une décision dans la Boîte d’attention ; elle reprendra dès qu’elle est prise. Arrêtez-la si vous ne voulez pas qu’elle reprenne.",
  "missions.pause.announce": "Mission en pause : plus aucune minute de GPU n’est consommée.",
  "missions.pause.announceFinishing": "Mise en pause demandée : l’étape en cours finit, puis la mission s’arrête.",
  "missions.pause.bannerHelp": "Aucune minute de GPU n’est consommée ; les décisions en attente restent dans la Boîte d’attention.",
  "missions.pause.bannerTitle": "En pause",
  "missions.pause.confirmTitle": "Mettre la mission « {{t}} » en pause ?",
  "missions.pause.currentStep": "{{caste}} · tâche {{k}} « {{titre}} », tour {{r}}",
  "missions.pause.effectDecisions": "Les décisions en attente, s’il en vient, restent dans la Boîte d’attention.",
  "missions.pause.effectDecisionsN": "Les décisions en attente ({{n}}) restent dans la Boîte d’attention.",
  "missions.pause.effectGpu": "Plus aucune minute de GPU n’est consommée pendant la pause ; la place de la mission dans la file est rendue.",
  "missions.pause.effectStep": "L’étape en cours finit, puis la mission s’arrête : aucun travail n’est jeté.",
  "missions.pause.effectStepNamed": "L’étape en cours finit ({{e}}), puis la mission s’arrête : aucun travail n’est jeté.",
  "missions.pause.finishing": "Mise en pause demandée : l’étape en cours finit…",
  "missions.pause.finishingNamed": "Mise en pause demandée : l’étape en cours finit ({{e}})…",
  "missions.pause.finishingOthers": "Les autres castes n’acceptent plus de nouvelle étape.",
  "missions.pause.pending": "Mise en pause…",
  "missions.pause.reason": "Motif (facultatif)",
  "missions.pause.reasonHelp": "Visible sur le poste de pilotage, 500 caractères au plus.",
  "missions.pause.refusedEnded": "La mission est terminée : il n’y a plus rien à suspendre.",
  "missions.pause.reversibility": "« Reprendre la mission » repart au tour suivant, avec les mêmes castes et le même budget restant ({{n}} min).",
  "missions.pause.since": "depuis {{h}} · par {{nom}}",
  "missions.resume.announce": "Mission reprise : elle repart au tour suivant.",
  "missions.resume.button": "Reprendre la mission",
  "missions.resume.distinction": "Reprendre une mission, après une pause volontaire, n’est pas relancer un agent personnalisé après une erreur (plafonné) :",
  "missions.resume.pending": "Reprise…",
  "missions.suspension.paused": "en pause",
  "rejoindre.succes": "Vous avez rejoint « {{nom}} » en tant que propriétaire (action tracée).",
  "rejoindre.dejaMembre": "Vous êtes déjà membre de « {{nom}} » ({{role}}) : rien n’a changé.",
  "rejoindre.echec": "Impossible de rejoindre « {{nom}} » : {{detail}}",
  "contexte.nonMembreRejoindre": "non membre — rejoindre",
  "contexte.rejoindreEnCours": "Rattachement au projet…",
  "contexte.fermer": "Fermer",
  "dashboard.nonMembre": "Non membre",
  "dashboard.rejoindre": "Rejoindre",
  "menu.administrationPlateforme": "Administration de la plateforme",
  "menu.reglagesNotifications": "Réglages de notification",
  "contexte.rejoindreCeProjet": "Rejoindre « {{nom}} » en tant que propriétaire",
  "dashboard.archivesHorsPortefeuille": "{{n}} projet(s) archivé(s), en lecture seule :",
  "dashboard.voirProjetsOrganisation": "voir les projets de l’organisation",
  "dashboard.rejoindreEnCours": "Rattachement…",
  "dashboard.rejoindreAria": "Rejoindre le projet « {{nom}} » en tant que propriétaire",
  "pgmReglages.de": "Identité et gouvernance de {{nom}}",
  "pgmReglages.chargement": "Lecture des réglages…",
  "pgmReglages.refus": "Vous n’êtes pas membre de ce programme : ses réglages ne vous sont pas ouverts.",
  "pgmReglages.erreur": "Les réglages du programme n’ont pas pu être lus.",
  "pgmReglages.succes": "Réglages du programme enregistrés.",
  "pgmReglages.nomRequis": "Le nom est obligatoire.",
  "pgmReglages.nomLongueur": "Le nom compte de {{min}} à {{max}} caractères.",
  "pgmReglages.descriptionLongueur": "La description compte au plus {{max}} caractères.",
  "pgmReglages.lecture": "Réservé à un propriétaire du programme (ou à l’administrateur de la plateforme) : vous lisez ces réglages sans pouvoir les modifier.",
  "pgmReglages.gabaritDefaut": "Par défaut (intégré)",
  "pgmReglages.identite": "Identité et gouvernance",
  "pgmReglages.conflitTitre": "Modification concurrente",
  "pgmReglages.conflit": "Le programme a été modifié entre-temps : rechargez ses réglages avant d’enregistrer.",
  "pgmReglages.recharger": "Recharger",
  "pgmReglages.nom": "Nom",
  "pgmReglages.description": "Description",
  "pgmReglages.proprietaires": "Propriétaire(s)",
  "pgmReglages.proprietairesIndice": "Le propriétaire se nomme par les rôles, sur l’écran",
  "pgmReglages.statut": "Statut",
  "pgmReglages.gabarit": "Gabarit par défaut des nouveaux projets",
  "pgmReglages.gabaritsErreur": "Le catalogue des gabarits n’a pas pu être lu ; le gabarit enregistré est conservé.",
  "pgmReglages.enregistrement": "Enregistrement…",
  "pgmReglages.enregistrer": "Enregistrer",
  "pgmBacklog.de": "Initiatives de {{nom}} : cadrage ou epics, et leur trace",
  "pgmBacklog.refus": "Vous n’êtes pas membre de ce programme : ses initiatives ne vous sont pas ouvertes.",
  "pgmBacklog.chargementProjets": "Lecture des projets du programme…",
  "pgmBacklog.lancer": "Lancer une initiative",
  "pgmBacklog.sansDroit": "Lancer une initiative exige un rôle d’écriture (propriétaire ou contributeur) dans un projet du programme ; les initiatives restent lisibles ci-dessous.",
  "pgmBacklog.lancees": "Initiatives lancées",
  "pgmBacklog.chargement": "Lecture des initiatives…",
  "pgmBacklog.erreur": "Les initiatives n’ont pas pu être lues.",
  "pgmBacklog.nonAccessibles1": "1 initiative vise un projet qui ne vous est pas ouvert : un compte seulement.",
  "pgmBacklog.nonAccessiblesN": "{{n}} initiatives visent des projets qui ne vous sont pas ouverts : un compte seulement.",
  "pgmBacklog.vide": "Aucune initiative lancée",
  "pgmBacklog.videIndice": "Les initiatives s’enregistrent ici dès leur lancement, depuis le formulaire ci-dessus.",
  "pgmBacklog.legende": "Initiatives lancées dans le programme, la plus récente d’abord",
  "pgmBacklog.colInitiative": "initiative",
  "pgmBacklog.colAuteur": "auteur",
  "pgmBacklog.colProjet": "projet cible",
  "pgmBacklog.colJob": "job",
  "pgmBacklog.colResultat": "résultat",
  "pgmBacklog.colDate": "lancée le",
  "pgmBacklog.limite": "La trace se lit dans les jobs et documents du programme : une initiative dont le job a été purgé par la rétention n’y figure plus.",
  "pgmBacklog.epics": "{{n}} epic(s), dont {{m}} à accepter",
  "pgmBacklog.ouvrirBacklog": "Ouvrir dans le backlog",
  "pgmBacklog.aucunEpic": "aucun epic posé",
  "pgmBacklog.avancement": "{{n}} / {{m}} epics terminés",
  "pgmBacklog.cadrageEnRevue": "cadrage en revue",
  "pgmBacklog.cadrageApprouve": "cadrage approuvé",
  "pgmBacklog.cadrageRefuse": "cadrage refusé",
  "pgmBacklog.cadrageAttendu": "cadrage pas encore produit",
  "pgmBacklog.cheminEpics": "epics",
  "pgmBacklog.cheminCadrage": "cadrage",
  "pgmBacklog.colAvancement": "avancement (epics réels)",
  "pgmBacklog.colObjectif": "objectif",
  "pgmBacklog.colStatut": "statut",
  "pgmBacklog.echecObjet": "Génération échouée : l’initiative reste « proposée ».",
  "programs.initiativeTargetReadOnly": "{{nom}} (lecture seule : rôle d’écriture requis)",
  "pgmBacklog.erreurProjets": "Les projets du programme n’ont pas pu être lus : le lancement d’une initiative est indisponible.",
  "pgmBacklog.objectifAnnuler": "Annuler",
  "pgmBacklog.objectifAucun": "aucun objectif",
  "pgmBacklog.objectifDe": "Objectif de « {{titre}} »",
  "pgmBacklog.objectifDefinir": "Définir l’objectif",
  "pgmBacklog.objectifDefinirDe": "Définir l’objectif de « {{titre}} »",
  "pgmBacklog.objectifEnregistrer": "Enregistrer",
  "pgmBacklog.objectifLecture": "Lecture seule : l’objectif d’une initiative se fixe par son auteur ou un pilote du programme (propriétaire ou contributeur).",
  "pgmBacklog.objectifLongueur": "L’objectif compte de {{min}} à {{max}} caractères.",
  "pgmBacklog.objectifModifier": "Modifier l’objectif",
  "pgmBacklog.statutCadree": "cadrée",
  "pgmBacklog.statutEnCours": "en cours",
  "pgmBacklog.statutEnRevue": "en revue",
  "pgmBacklog.statutProposee": "proposée",
  "pgmBacklog.statutTerminee": "terminée",
  "catalogueTech.ongletCatalogueN": "Catalogue ({{n}})",
  "catalogueTech.ongletCatalogue": "Catalogue",
  "catalogueTech.ongletCategoriesN": "Catégories ({{n}})",
  "catalogueTech.ongletCategories": "Catégories",
  "catalogueTech.ongletRadar": "Radar",
  "catalogueTech.chargement": "Chargement du catalogue…",
  "catalogueTech.refusLecture": "Le catalogue technologique de l’organisation ne vous est pas ouvert.",
  "catalogueTech.erreur": "Catalogue illisible : la passerelle n’a pas répondu ; rien n’a changé.",
  "catalogueTech.titre": "Catalogue technologique",
  "catalogueTech.de": "Les choix technologiques de l’organisation, des langages aux utilitaires de plateforme ; leur générabilité par la colonie, mesurée.",
  "catalogueTech.lectureSeule": "Lecture seule : l’administration de l’organisation (administrateur de la plateforme) modifie le catalogue.",
  "catalogueTech.onglets": "Vues du catalogue",
  "catalogueTech.changementsAVenir": "Demandes de changement et propagation : à venir avec le lot suivant.",
  "catalogueTech.ongletChangements": "Changements",
  "catalogueTech.aVenir": "à venir",
  "catalogueTech.jeuApplique": "Jeu de départ appliqué : {{n}} catégorie(s) ajoutée(s). Ajoutez maintenant vos entrées.",
  "catalogueTech.utiliserJeu": "Utiliser le jeu de départ ({{n}} catégories)",
  "catalogueTech.filtrer": "Catégorie",
  "catalogueTech.toutes": "Toutes les catégories",
  "catalogueTech.nouvelleEntree": "Nouvelle entrée",
  "catalogueTech.vide": "Catalogue vide",
  "catalogueTech.videAide": "Commencez par le jeu de catégories de départ, puis ajoutez vos entrées. Les catégories du plancher (identité et accès, coffre de secrets) existent déjà.",
  "catalogueTech.videAction": "Ajoutez une entrée avec « Nouvelle entrée ».",
  "catalogueTech.videLecture": "L’administration de l’organisation n’a encore inscrit aucune entrée.",
  "catalogueTech.videFiltre": "Aucune entrée dans cette catégorie",
  "catalogueTech.videFiltreAide": "Choisissez « Toutes les catégories » ou ajoutez une entrée.",
  "catalogueTech.entreesCaption": "Entrées du catalogue technologique",
  "catalogueTech.categorie": "Catégorie",
  "catalogueTech.produitVersion": "Produit · version",
  "catalogueTech.licenceCol": "Licence (SPDX)",
  "catalogueTech.choisie": "Choisie par l’organisation",
  "catalogueTech.generable": "Générable par la colonie",
  "catalogueTech.actions": "Actions",
  "catalogueTech.anneauDe": "radar : {{anneau}}",
  "catalogueTech.fondeePar": "fondée par {{adr}}",
  "catalogueTech.modifier": "Modifier",
  "catalogueTech.changerStatut": "Changer le statut",
  "catalogueTech.deuxAttributs": "Deux attributs côte à côte : choisie par l’organisation (gouvernance) et générable par la colonie (fait mesuré : un profil de génération qualifié la couvre). Le socle ASVS et les licences autorisées restent au",
  "catalogueTech.referentiel": "Référentiel d’exigences",
  "catalogueTech.profils": "Profils de génération qualifiés",
  "catalogueTech.entreeModifiee": "Entrée enregistrée — {{produit}}",
  "catalogueTech.entreeCreee": "Entrée ajoutée — {{produit}}, {{statut}}",
  "catalogueTech.modifierTitre": "Entrée — {{produit}}",
  "catalogueTech.nouvelleTitre": "Nouvelle entrée du catalogue",
  "catalogueTech.modifierAide": "Le produit et la catégorie ne changent pas ; le statut se change à part, avec son effet sur les projets.",
  "catalogueTech.nouvelleAide": "Une entrée naît « à l’étude » ou « autorisée » ; l’imposer est un changement de statut, avec son effet sur les projets.",
  "catalogueTech.produit": "Produit",
  "catalogueTech.produitRequis": "Nommez le produit (ex. Valkey).",
  "catalogueTech.version": "Version ou plage",
  "catalogueTech.versionInvalide": "Une version (8.1) ou une plage (8.x, ≥ 8.0).",
  "catalogueTech.licence": "Licence (SPDX)",
  "catalogueTech.statutInitial": "Statut",
  "catalogueTech.anneauRadar": "Anneau du radar (facultatif)",
  "catalogueTech.sansAnneau": "— aucun —",
  "catalogueTech.adrLiee": "ADR d’organisation liée (facultatif)",
  "catalogueTech.sansAdr": "— aucune —",
  "catalogueTech.note": "Note",
  "catalogueTech.enregistrer": "Enregistrer",
  "catalogueTech.statutChange": "« {{produit}} » est désormais {{statut}}.",
  "catalogueTech.statutTitre": "Changer le statut — {{produit}}",
  "catalogueTech.statutActuel": "Statut actuel : {{statut}}. Choisie par l’organisation (gouvernance) ; générable par la colonie : {{gen}} (fait mesuré).",
  "catalogueTech.retireeFinale": "Une entrée retirée ne change plus de statut : ajoutez une nouvelle entrée.",
  "catalogueTech.nouveauStatut": "Nouveau statut",
  "catalogueTech.avertNonGenerable": "Aucun profil de génération qualifié ne la couvre : les projets qui l’héritent ne pourront pas lancer de génération par la colonie. C’est permis : la générabilité conditionne la génération, pas le choix (D3).",
  "catalogueTech.refusSensible": "« {{categorie}} » est une catégorie sensible : passer « {{produit}} » à « {{statut}} » assouplit sa protection. Cela exige la confirmation renforcée et deux personnes, par une demande de changement de l’organisation.",
  "catalogueTech.impactCalcul": "Calcul de l’effet sur les projets…",
  "catalogueTech.impactTouche": "Ce changement touche {{n}} projet(s) sur {{total}} de l’organisation.",
  "catalogueTech.impactAucun": "Aucun projet n’est touché ({{total}} projet(s) dans l’organisation).",
  "catalogueTech.impactBase": "Compté sur le profil de pile actuel des projets ({{utilisent}} l’utilisent), sans nommer les projets. Tant que les baselines technologiques n’existent pas, rien n’est propagé aux projets.",
  "catalogueTech.impactConfirmer": "J’ai lu l’effet sur les projets et je confirme.",
  "catalogueTech.statutValider": "Passer à « {{statut}} »",
  "catalogueTech.radarResumeAnneau": "{{anneau}} {{n}}",
  "catalogueTech.radar": "Radar",
  "catalogueTech.radarVide": "Aucune entrée sur le radar",
  "catalogueTech.radarVideAide": "Le radar se remplit quand une entrée porte un anneau (adopter, essayer, évaluer, suspendre) ; il se règle dans la vue Catalogue.",
  "catalogueTech.radarEnTexte": "En texte : {{resume}}.",
  "catalogueTech.radarCaption": "Entrées du catalogue par anneau du radar",
  "catalogueTech.anneauCol": "Anneau",
  "catalogueTech.entrees": "Entrées",
  "catalogueTech.aucune": "aucune",
  "catalogueTech.radarNote": "L’anneau oriente ; il ne rend pas une entrée générable.",
  "catalogueTech.adrsOrg": "ADR d’organisation",
  "catalogueTech.adrsChargement": "Lecture des ADR d’organisation…",
  "catalogueTech.adrsErreur": "Les ADR d’organisation n’ont pas pu être lues.",
  "catalogueTech.adrsVide": "Aucune ADR d’organisation",
  "catalogueTech.adrsVideAide": "Une ADR d’organisation fonde une décision qui vaut pour toutes les applications (ex. Keycloak pour l’identité).",
  "catalogueTech.adrsCaption": "ADR de portée organisation",
  "catalogueTech.titreAdr": "Titre",
  "catalogueTech.statutCol": "Statut",
  "catalogueTech.nouvelleAdr": "Nouvelle ADR d’organisation",
  "catalogueTech.cardinalite": "Cardinalité",
  "catalogueTech.choixUnique": "choix unique",
  "catalogueTech.choixMultiple": "choix multiple",
  "catalogueTech.obligatoire": "Obligatoire",
  "catalogueTech.sensible": "Sensible",
  "catalogueTech.categorieAjoutee": "Catégorie « {{libelle}} » ajoutée — {{obligatoire}}, {{cardinalite}}",
  "catalogueTech.obligatoireMin": "obligatoire",
  "catalogueTech.facultative": "facultative",
  "catalogueTech.categorieSupprimee": "Catégorie « {{libelle}} » supprimée.",
  "catalogueTech.categoriesCaption": "Catégories du catalogue de l’organisation",
  "catalogueTech.oui": "oui",
  "catalogueTech.non": "non",
  "catalogueTech.unique": "unique",
  "catalogueTech.multiple": "multiple",
  "catalogueTech.sensiblePlancher": "sensible · plancher",
  "catalogueTech.sensibleMin": "sensible",
  "catalogueTech.supprimer": "Supprimer",
  "catalogueTech.plancherNote": "{{categories}} : plancher de la plateforme — obligatoires et sensibles pour toute organisation, jamais supprimables.",
  "catalogueTech.nouvelleCategorie": "Nouvelle catégorie",
  "catalogueTech.libelle": "Libellé",
  "catalogueTech.ajouter": "Ajouter",
  "catalogueTech.libelleRequis": "Le libellé est obligatoire.",
  "catalogueTech.categorieModifiee": "Catégorie « {{libelle}} » enregistrée.",
  "catalogueTech.categorieTitre": "Catégorie — {{libelle}}",
  "catalogueTech.plancherAide": "Plancher de la plateforme : obligatoire et sensible pour toute organisation (A5).",
  "catalogueTech.categorieAide": "Une catégorie obligatoire doit avoir une valeur dans chaque projet avant la fin de son lancement.",
  "catalogueTech.statut.proposed": "à l’étude",
  "catalogueTech.statut.allowed": "autorisée",
  "catalogueTech.statut.inForce": "imposée",
  "catalogueTech.statut.retired": "retirée",
  "catalogueTech.anneau.adopt": "adopter",
  "catalogueTech.anneau.trial": "essayer",
  "catalogueTech.anneau.assess": "évaluer",
  "catalogueTech.anneau.hold": "suspendre",
  "catalogueTech.gen.generable": "générable",
  "catalogueTech.gen.nonQualifiee": "non mesurée",
  "catalogueTech.gen.nonCouverte": "non générable",
  "catalogueTech.gen.aucunProfil": "aucun profil de génération ne la couvre : la colonie ne sait pas encore l’intégrer",
  "catalogueTech.gen.profilQualifie": "profil {{profil}} ({{passes}}/{{total}} cas dorés, {{modele}})",
  "catalogueTech.gen.profilNonQualifie": "profil {{profil}} : {{motif}}",
  "catalogueTech.r.admin": "Réservé à l’administration de l’organisation (administrateur de la plateforme) : vous consultez le catalogue en lecture seule.",
  "catalogueTech.r.plancher": "Plancher de la plateforme : cette catégorie reste obligatoire et sensible pour toute organisation, et n’est jamais supprimée.",
  "catalogueTech.r.utilisee": "Catégorie utilisée par des entrées du catalogue (retirées comprises) : elle reste.",
  "catalogueTech.r.existe": "Cette catégorie existe déjà.",
  "catalogueTech.r.unique": "Catégorie à choix unique : elle a déjà une entrée imposée. Rendez-la autorisée ou retirez-la d’abord.",
  "catalogueTech.r.sensible": "Catégorie sensible : assouplir une entrée exige la confirmation renforcée et deux personnes. Passez par une demande de changement (à venir).",
  "catalogueTech.r.impact": "Ce changement touche des projets : confirmez-le après avoir lu son effet.",
  "catalogueTech.r.doublon": "Ce produit, dans cette version, est déjà au catalogue dans cette catégorie.",
  "catalogueTech.r.retiree": "Une entrée retirée ne se modifie plus.",
  "catalogueTech.r.transition": "Ce changement de statut n’est pas admis depuis l’état actuel.",
  "catalogueTech.jeuCompletApplique": "Jeu de départ appliqué : {{c}} catégorie(s) et {{e}} entrée(s) ajoutée(s), autorisées (choisissables au lancement, jamais imposées).",
  "catalogueTech.jeuResteCoffre": "Reste à inscrire votre coffre de secrets.",
  "catalogueTech.lectureSeuleOrg": "Lecture seule : l’administration de l’organisation (administratrice ou administrateur d’organisation) modifie le catalogue.",
  "catalogueTech.ouvrirCatalogue": "Ouvrir le catalogue technologique",
  "catalogueTech.plancherCoffre": "Coffre de secrets",
  "catalogueTech.plancherCoffreAide": "à définir par l’organisation : la plateforme n’en déploie aucun. Inscrivez le vôtre (par exemple HashiCorp Vault, OpenBao, ou les secrets chiffrés de votre orchestrateur) avec « Nouvelle entrée ». Tant qu’il manque, chaque projet le définit lui-même au lancement (« Définir » puis « Hors catalogue… »).",
  "catalogueTech.plancherIdentite": "Identité et accès",
  "catalogueTech.plancherTitre": "Plancher de la plateforme encore sans entrée",
  "catalogueTech.r.adminOrg": "Réservé à l’administration de l’organisation (administratrice ou administrateur d’organisation) : vous consultez le catalogue en lecture seule.",
  "catalogueTech.utiliserJeuComplet": "Utiliser le jeu de départ ({{c}} catégorie(s), {{e}} entrée(s))",
  "catalogueTech.videAideComplet": "Le jeu de départ pose en un geste les catégories et les technologies que la plateforme sait générer (langages, frameworks, bases de données, plateforme cible web, mobile ou bureau), chacune avec sa générabilité mesurée. Vous ajoutez ou retirez ensuite ce que vous voulez.",
  "qualite.duree.jours": "{{n}} j",
  "qualite.duree.heures": "{{n}} h",
  "qualite.duree.minutes": "{{n}} min",
  "qualite.motif.echappement": "Aucune anomalie déclarée sur la période avec son environnement renseigné.",
  "qualite.motif.reouverture": "Aucune anomalie résolue pour la première fois sur la période.",
  "qualite.motif.mttr": "Aucune anomalie fermée sur la période.",
  "qualite.motif.inconnu": "Mesure impossible (code {{code}}).",
  "qualite.detail.echappement": "{{n}} trouvée(s) en production sur {{d}} anomalie(s) avérée(s) déclarée(s) sur la période",
  "qualite.detail.reouverture": "{{n}} rouverte(s) sur {{d}} corrigée(s)",
  "qualite.def.echappement": "Anomalies trouvées en production ÷ anomalies avérées déclarées sur la période dont l’environnement est connu (doublons, rejetées et non reproductibles exclues).",
  "qualite.def.reouverture": "Anomalies rouvertes après un correctif (résolue, vérifiée ou fermée → rouverte) ÷ anomalies résolues pour la première fois sur la période.",
  "qualite.def.mttr": "Délai moyen de la déclaration à la fermeture, sur les anomalies fermées pendant la période.",
  "qualite.def.ouvertes": "Nouvelles, triées, en cours, résolues à vérifier et rouvertes — maintenant, toutes périodes.",
  "qualite.lecon.refus.fermee": "Une leçon naît d’une anomalie fermée (vérifiée par une exécution verte, puis livrée) : refusée sans anomalie fermée reliée (B-108).",
  "qualite.lecon.refus.existe": "Cette anomalie a déjà une leçon proposée ou validée.",
  "qualite.lecon.refus.auteur": "Vous avez proposé cette leçon : sa validation revient à une autre personne.",
  "qualite.lecon.refus.decidee": "Cette leçon a déjà été décidée.",
  "qualite.lecon.refus.echue": "Cette leçon est échue : proposez-en une nouvelle.",
  "qualite.lecon.refus.expiration": "L’expiration doit tomber entre demain et 366 jours.",
  "qualite.lecon.refus.champs": "Symptôme, cause et correctif sont tous exigés.",
  "qualite.lecon.refus.motif": "Écarter une leçon exige un motif écrit.",
  "qualite.lecon.refus.humain": "Une leçon se décide dans une session humaine : un jeton de service est refusé.",
  "qualite.lecon.statut.ecartee": "écartée",
  "qualite.lecon.statut.echue": "échue",
  "qualite.lecon.statut.avis": "AVIS — à valider par un humain",
  "qualite.lecon.statut.active": "validée, active",
  "qualite.lecon.statut.valideeEchue": "validée, échue",
  "qualite.lecon.statut.suspendue": "validée, suspendue : l’anomalie n’est plus fermée",
  "qualite.lecon.titre": "Leçon #{{id}}",
  "qualite.lecon.origineColonie": "proposée par la colonie",
  "qualite.lecon.symptome": "Symptôme",
  "qualite.lecon.cause": "Cause",
  "qualite.lecon.correctif": "Correctif",
  "qualite.lecon.expire": "Expire",
  "qualite.lecon.preuve": "Preuve",
  "qualite.lecon.preuveExecution": "{{ano}} fermée, vérifiée par l’exécution verte #{{exe}}",
  "qualite.lecon.preuveAnomalie": "{{ano}} fermée",
  "qualite.lecon.auteur": "Proposée par",
  "qualite.lecon.decidee": "Décidée par",
  "qualite.lecon.valider": "Valider la leçon",
  "qualite.lecon.ecarter": "Écarter",
  "qualite.lecon.motif": "Motif (obligatoire)",
  "qualite.lecon.ecarterConfirmer": "Confirmer : écarter",
  "qualite.lecon.expiration": "Expiration",
  "qualite.lecon.proposer": "Proposer la leçon",
  "qualite.lecon.panneau": "Leçon proposée",
  "qualite.lecon.aide": "Symptôme → cause → correctif, rattachés à cette anomalie fermée et à sa vérification, avec une date d’expiration. Proposée, c’est un avis : elle ne sert à la colonie qu’après la validation d’une autre personne.",
  "qualite.lecon.chargement": "Chargement des leçons…",
  "qualite.insuffisant": "Données insuffisantes",
  "qualite.exclues": "{{n}} anomalie(s) sans environnement exclue(s) : on ne sait pas où elles ont été trouvées.",
  "qualite.echappement": "Échappement",
  "qualite.reouverture": "Réouverture",
  "qualite.mttr": "MTTR",
  "qualite.mttrDetail": "sur {{n}} anomalie(s) fermée(s)",
  "qualite.ouvertes": "Ouvertes",
  "qualite.aVerifier": "dont {{n}} résolue(s) à vérifier",
  "qualite.parVersion": "Anomalies par sévérité et par version",
  "qualite.parVersionPortee": "Anomalies comptées",
  "qualite.parVersionOuvertes": "Ouvertes",
  "qualite.parVersionToutes": "Toutes",
  "qualite.parVersionVide": "Aucune anomalie avérée",
  "qualite.parVersionVideAide": "Doublons, rejetées et non reproductibles ne comptent pas.",
  "qualite.version": "Version",
  "qualite.total": "Total",
  "qualite.sansVersion": "sans version",
  "qualite.anciennes": "Les plus anciennes non fermées",
  "qualite.anciennesVide": "Aucune anomalie ouverte",
  "qualite.anciennesVideAide": "Une exécution rouge de l’écran Tests se déclare en anomalie en deux gestes.",
  "qualite.ouvrirAnomalies": "Ouvrir les anomalies",
  "qualite.mttrParSeverite": "MTTR par sévérité",
  "qualite.severite": "Sévérité",
  "qualite.fermees": "Fermées",
  "qualite.lecons": "Leçons",
  "qualite.leconsCompte": "{{p}} à valider, {{a}} active(s) — une leçon active est validée, non échue, et son anomalie reste fermée.",
  "qualite.leconsVide": "Aucune leçon à valider",
  "qualite.leconsVideAide": "Une leçon se propose depuis le détail d’une anomalie fermée.",
  "qualite.titre": "Tableau de bord qualité",
  "qualite.description": "Échappement, réouverture, délai de correction et anomalies par sévérité et par version — calculés par la passerelle sur les anomalies du projet.",
  "qualite.sansProjet": "Le tableau de bord qualité porte sur un projet.",
  "qualite.periode": "Période",
  "qualite.periodeJours": "{{n}} derniers jours",
  "qualite.versionVue": "Version (vue release)",
  "qualite.toutesVersions": "Toutes les versions",
  "qualite.chargement": "Calcul des indicateurs qualité…",
  "qualite.refus": "Ce projet n’est pas accessible avec votre compte : demandez l’accès à son propriétaire.",
  "qualite.vide": "Pas encore de mesure",
  "qualite.videVersion": "Aucune anomalie pour cette version.",
  "qualite.videAide": "MTTR et réouverture s’afficheront après la première anomalie fermée.",
  "cmdk.title": "Palette de commandes",
  "cmdk.description": "Rechercher un écran ou une action",
  "app.chargement": "Chargement…",
  "app.cetEcran": "cet écran",
  "app.chargementEcran": "Chargement de l’écran…",
  "app.refusAdministration": "Votre rôle ne permet pas d’administrer cet espace.",
  "app.refusOrganisation": "Réservé à l’administration de l’organisation.",
  "acces.restreint": "Accès restreint",
  "acces.retourTableauDeBord": "Retour au tableau de bord",
  "echecEcran.region": "Échec de {{ecran}}",
  "echecEcran.titre": "Impossible d’ouvrir {{ecran}}.",
  "echecEcran.indice": "La navigation reste disponible. Réessayez ou revenez au tableau de bord.",
  "echecEcran.reessayer": "Réessayer",
  "echecEcran.indiceRelance": "La connexion semble interrompue. Nouvelle tentative automatique…",
  "echecEcran.indiceHorsLigne": "Vous semblez hors ligne. L’écran se rechargera seul au retour du réseau.",
  "echecEcran.indiceEpuise": "La connexion semble interrompue. Vérifiez-la, puis réessayez.",
  "livrer.ouvrirRaison": "Ouvrir : {{titre}}",
  "livrer.preuveCampagnes": "{{titre}} : {{etat}}",
  "livrer.preuveRecetteAccordee": "recette accordée",
  "livrer.preuveRecetteAFaire": "recette à faire",
  "livrer.preuveRecetteNonCalculee": "recette non calculée",
  "livrer.preuveRevision": "révision {{sha}}",
  "scorecard.sloNom.generation_success_rate": "Taux de réussite des générations",
  "scorecard.sloNom.decision_latency": "Latence de décision (moy.)",
  "scorecard.sloNom.backlog_progress": "Avancement du backlog",
  "repartition.titre": "Répartition du backlog par statut",
  "repartition.aide": "Stories et anomalies, nombre et points par colonne du workflow du projet.",
  "repartition.chargement": "Calcul de la répartition…",
  "repartition.vide": "Aucune story ni anomalie dans le backlog",
  "repartition.videAide": "Le backlog se génère depuis une spécification approuvée ou se remplit à la main.",
  "repartition.versBacklog": "Ouvrir le backlog",
  "repartition.statut": "Statut",
  "repartition.nombre": "Nombre",
  "repartition.points": "Points",
  "versions.code.NON_REGRESSION_NO_BASELINE": "Aucune campagne précédente à comparer",
  "versions.code.NO_REGRESSION": "Aucune régression",
  "versions.code.REGRESSIONS_ACCEPTED": "Régression(s) acceptée(s)",
  "versions.code.REGRESSION_NOT_ACCEPTED": "Régression(s) non acceptée(s)",
  "versions.code.RECETTE_GRANTED": "Recette métier accordée",
  "versions.code.RECETTE_MISSING": "Recette métier à faire : aucune campagne de recette ne certifie la version",
  "versions.code.RECETTE_NOT_GRANTED": "Recette métier non accordée",
  "versions.code.SIGNED_ARTEFACTS_MISSING": "Révision(s) sans image signée ni SBOM enregistrés",
  "versions.code.SIGNED_ARTEFACTS_NO_REVISION": "Aucune révision retenue : rien à signer",
  "versions.code.SIGNED_ARTEFACTS_PRESENT": "Image, signature et SBOM enregistrés",
  "versions.code.SIGNED_IMAGE_MISSING_FROM_HOST": "Image signée absente de l’hôte : reconstruire et re-signer la révision",
  "vueProjet.versionItems": "{{n}} item(s)",
  "vueProjet.preteOui": "oui",
  "vueProjet.preteNon": "non",
  "vueProjet.raisonsBloquantes": "{{n}} raison(s) bloquante(s)",
  "vueProjet.dontPremiere": ", dont {{raison}}",
  "n28.role.metier": "métier",
  "n28.role.po": "product owner",
  "n28.role.dev": "développeur",
  "n28.role.testeur": "testeur",
  "n28.role.release": "release manager",
  "n28.role.proprietaire": "propriétaire",
  "n28.action.planMission": "Approuver le plan de la mission {{objet}}",
  "n28.action.decider": "Décider : {{objet}}",
  "n28.action.approuver": "Approuver {{nature}}",
  "n28.action.approuverProjet": "Approuver {{nature}} — {{projet}}",
  "n28.action.trancherTache": "Trancher la tâche arrêtée {{objet}}",
  "n28.action.tacheArretee": "Tâche de colonie arrêtée : {{objet}}",
  "n28.action.verifierAnomalie": "Vérifier l’anomalie résolue {{objet}}",
  "n28.action.rendreDerogation": "Rendre la dérogation échue {{objet}}",
  "n28.action.approbationAncienne": "Décider l’approbation en attente la plus ancienne",
  "n28.action.executerCampagne": "Exécuter les cas restants de la campagne #{{id}}",
  "n28.action.retablirDeploiement": "Rétablir le déploiement en échec {{version}} ({{env}})",
  "n28.action.approuverVersion": "Approuver la version prête {{version}}",
  "n28.action.approuverMiseEnLigne": "Approuver la mise en ligne de {{version}}",
  "n28.action.budgetErreur": "Budget d’erreur {{slo}} à {{pct}} %",
  "n28.action.voirApercu": "Voir l’aperçu de la révision {{revision}}",
  "n28.action.accepterItem": "Accepter l’item généré « {{titre}} »",
  "n28.action.specifierDemande": "Spécifier la demande cadrée « {{titre}} »",
  "n28.action.poursuivre": "Poursuivre « {{titre}} »",
  "n28.nature.specification": "la spécification",
  "n28.nature.decision": "la décision",
  "n28.nature.plan": "le plan",
  "n28.nature.design": "le design",
  "n28.nature.backlog": "le backlog",
  "n28.nature.campagne": "la campagne de tests",
  "n28.nature.version": "la version",
  "n28.nature.code": "le code généré",
  "n28.nature.artefact": "l’artefact",
  "n28.regleN": "règle {{n}} : {{regle}}",
  "n28.regleSautees": "{{base}} ; {{n}} action(s) sautée(s) : refusée(s) avant le clic",
  "n28.regle.metier.1": "recette métier ou mise en ligne à approuver",
  "n28.regle.metier.2": "spécification à relire en registre métier",
  "n28.regle.metier.3": "aperçu nouveau à voir",
  "n28.regle.metier.4": "demande « à voir »",
  "n28.regle.po.1": "plan de mission à approuver",
  "n28.regle.po.2": "approbation en attente",
  "n28.regle.po.2_5": "items de reprise d’une demande de changement approuvée",
  "n28.regle.po.3": "tâche de colonie arrêtée depuis plus de 24 h",
  "n28.regle.po.4": "items générés à accepter",
  "n28.regle.po.5": "demande cadrée non spécifiée",
  "n28.regle.po.6": "demande de changement technologique à examiner",
  "n28.regle.dev.1": "tâche arrêtée à trancher",
  "n28.regle.dev.2": "dossier de mission à relire",
  "n28.regle.dev.3": "item qui m’est assigné en cours",
  "n28.regle.testeur.1": "anomalie résolue à vérifier",
  "n28.regle.testeur.2": "campagne ouverte avec des exécutions à faire",
  "n28.regle.testeur.3": "exigence sans test",
  "n28.regle.release.1": "déploiement en échec",
  "n28.regle.release.2": "approbation de palier en attente",
  "n28.regle.release.3": "version prête non approuvée",
  "n28.regle.release.4": "budget d’erreur ≥ 80 %",
  "n28.regle.proprietaire.1": "dérogation échue",
  "n28.regle.proprietaire.2": "demande de changement technologique à approuver",
  "n28.regle.proprietaire.3": "migration de gabarit disponible",
  "grp.Projet": "Projet",
  "demandes.etat.idee": "Idée",
  "demandes.etat.cadree": "Cadrée",
  "demandes.etat.specifiee": "Spécifiée",
  "demandes.etat.en-construction": "En construction",
  "demandes.etat.a-voir": "À voir",
  "demandes.etat.livree": "Livrée",
  "demandes.etat.abandonnee": "Abandonnée",
  "demandes.attente.idee": "la décision sur le cadrage",
  "demandes.attente.cadree": "la rédaction de la spécification",
  "demandes.attente.specifiee": "la planification et la construction",
  "demandes.attente.enConstruction": "la fin de la construction par la colonie",
  "demandes.attente.aVoir": "la vérification et la livraison",
  "demandes.attente.livree": "rien : livrée",
  "demandes.attente.abandonneeMotif": "rien : abandonnée ({{motif}})",
  "demandes.attente.abandonnee": "rien : abandonnée",
  "demandes.age.minutes": "{{n}} min",
  "demandes.age.heures": "{{n}} h",
  "demandes.age.jours": "{{n}} j",
  "demandes.suite.etapeEchec": "en échec",
  "demandes.suite.attente.cadrageEnCours": "la génération du cadrage",
  "demandes.suite.attente.cadrageEchoue": "la relance du cadrage, qui a échoué",
  "demandes.suite.attente.redactionEnCours": "la fin de la rédaction de la spécification",
  "demandes.suite.attente.redactionEchouee": "une nouvelle rédaction de la spécification, la précédente a échoué",
  "demandes.suite.attente.specADecider": "la décision sur la spécification rédigée",
  "demandes.suite.relanceToast": "Cadrage relancé",
  "demandes.suite.cadrageEnCours": "Le cadrage est en cours de génération ; cette fiche se met à jour d’elle-même.",
  "demandes.suite.cadrageEchoue": "Le cadrage de cette demande a échoué : aucun cadrage n’attend de décision.",
  "demandes.suite.redactionEchouee": "La rédaction de la spécification a échoué : aucune spécification n’attend de décision.",
  "demandes.suite.workerPerdu": "Le worker ne répond plus pour ce job.",
  "demandes.suite.causeInconnue": "Cause non transmise par le worker.",
  "demandes.suite.redactionEnCours": "La spécification est en cours de rédaction ; elle reviendra en approbation.",
  "demandes.suite.voirSpec": "Ouvrir les décisions à prendre",
  "demandes.suite.relancerCadrage": "Relancer le cadrage",
  "demandes.suite.autres": "Autres suites du cadrage (options, personas, processus, epics)",
  "gitlab.indisponible": "GitLab est temporairement indisponible. Vérifiez la connexion SCM, puis réessayez.",
  "gitlab.connexionActive": "Connexion GitLab active",
  "gitlab.nonConfigure": "GitLab non configuré",
  "gitlab.configAilleurs": "La configuration et les jetons se gèrent dans Administration → Intégrations.",
  "gitlab.proprietaireDoitConnecter": "Un propriétaire doit connecter GitLab avant de suivre les pipelines ici.",
  "gitlab.ouvrirConfiguration": "Ouvrir la configuration GitLab",
  "gitlab.filtrerPipelines": "Filtrer les pipelines par statut",
  "gitlab.statut.tous": "Tous les statuts",
  "gitlab.statut.succes": "Succès",
  "gitlab.statut.echec": "Échec",
  "gitlab.statut.enCours": "En cours",
  "gitlab.statut.enAttente": "En attente",
  "gitlab.rechercherPipeline": "Rechercher une branche ou un SHA de pipeline",
  "gitlab.brancheOuSha": "Branche ou SHA…",
  "gitlab.jobsDuPipeline": "Jobs du pipeline #{{n}}",
  "gitlab.branches": "Branches",
  "gitlab.rechercherBranche": "Rechercher une branche ou un SHA",
  "gitlab.rechercherBrancheIndice": "Rechercher une branche ou un SHA…",
  "gitlab.brancheDefaut": "par défaut",
  "gitlab.brancheProtegee": "protégée",
  "gitlab.deconnecte": "Connexion GitLab supprimée",
  "gitlab.deconnecterTitre": "Supprimer la connexion GitLab de ce projet ?",
  "gitlab.deconnecterConsequence": "L’adresse, le projet et le jeton chiffré sont effacés ; pipelines, branches et demandes de fusion ne se lisent plus.",
  "gitlab.deconnecterLivraison": "Une version qui exige un pipeline GitLab ne pourra plus être promue tant que la connexion n’est pas refaite.",
  "gitlab.deconnecterReversible": "Vous pourrez reconnecter le projet avec un nouveau jeton.",
  "gitlab.deconnecter": "Supprimer la connexion",
  "deliveryOverview.sante.sain": "Sain",
  "deliveryOverview.sante.malade": "En échec",
  "deliveryOverview.sante.nonConfigure": "Non configuré",
  "deliveryOverview.sante.nonVerifie": "Non vérifié",
  "runops.portee.programme": "Programme",
  "runops.portee.projet": "Projet",
  "runops.duree.ephemere": "éphémère",
  "runops.duree.persistant": "persistant",
  "runops.arretAuto": "{{n}} min avant arrêt automatique",
  "admin.confirmerDepart": "Confirmer le départ",
  "admin.invitationCreee": "Invitation créée",
  "admin.invitationRevoquee": "Invitation révoquée",
  "admin.departConfirme": "Départ confirmé",
  "admin.invitations": "Invitations",
  "admin.inviterParEmail": "Inviter par e-mail",
  "admin.invitationEmail": "E-mail de l’invitation",
  "admin.invitationRole": "Rôle de l’invitation",
  "admin.inviter": "Inviter",
  "admin.lienInvitationPour": "Lien d’invitation pour {{email}} — transmettez-le à cette personne ; il ne sera plus affiché. Elle retrouvera aussi l’invitation dans sa boîte d’attention une fois connectée.",
  "admin.lienInvitation": "Lien d’invitation",
  "admin.copierLien": "Copier le lien",
  "admin.masquer": "Masquer",
  "admin.revoquer": "Révoquer",
  "admin.nMembres": "{{n}} membre(s)",
  "config.model.tone.pending": "En attente (gris)",
  "config.model.tone.running": "En cours (bleu)",
  "config.model.tone.info": "Information (neutre)",
  "config.model.tone.success": "Succès (vert)",
  "config.model.tone.warning": "À revoir (ambre)",
  "config.model.tone.blocked": "Bloqué (rouge)",
  "config.model.tone.error": "En échec (rouge)",
  "planifier.dor.NON_ACCEPTEE": "US non acceptée",
  "planifier.dor.CRITERES_ABSENTS": "critères d’acceptation absents",
  "planifier.dor.LIEN_REQ_ABSENT": "aucun lien vers une exigence",
  "planifier.dor.RECU_SPEC_GATE_ABSENT": "reçu Spec Gate absent",
  "planifier.dor.ESTIMATION_ABSENTE": "estimation absente",
  "planifier.dor.TESTS_NON_CONCUS": "tests non conçus",
  "planifier.dor.DEPENDANCE_OUVERTE": "dépendance bloquante ouverte",
  "planifier.dor.OBJECTIF_ABSENT": "objectif absent",
  "planifier.dor.PERIMETRE_NON_VALIDE": "périmètre non validé",
  "planifier.dor.RISQUES_NON_IDENTIFIES": "risques non identifiés",
  "planifier.dor.TRACABILITE_ABSENTE": "traçabilité absente",
  "planifier.dor.US_ABSENTES": "aucune US",
  "planifier.dor.US_NON_PRETES": "US non prêtes",
  "planifier.dor.TAILLE_CONTEXTE_32K": "taille ≤ 32 K de contexte",
  "planifier.dor.LIGNES_REVUE_400": "≤ 400 lignes de revue",
  "missions.filtre.toutes": "Toutes",
  "missions.filtre.a-approuver": "Plan à approuver",
  "missions.filtre.en-cours": "En cours",
  "missions.filtre.en-attente": "En attente",
  "missions.filtre.arretees": "Arrêtées",
  "missions.filtre.reussies": "Réussies",
  "missions.filtre.echouees": "Échouées",
  "livrer.continuite.sain": "Sain",
  "livrer.continuite.non-mesure": "non mesuré — restauration jamais testée",
  "livrer.continuite.perime": "Périmé",
  "livrer.continuite.echec": "Échec",
  "livrer.continuite.absent": "Absent",
  "livrer.continuite.hors-cible": "Hors cible",
  "livrer.verdict.prete": "prête",
  "livrer.verdict.pas-prete": "pas prête",
  "livrer.verdict.non-etablie": "non établie",
  "livrer.etat.ok": "vert",
  "livrer.etat.bloquant": "bloquant",
  "livrer.etat.avertissement": "avertissement",
  "livrer.etat.information": "information",
  "livrer.etat.non-calcule": "non calculée",
  "livrer.raison.status": "Statut",
  "livrer.raison.revisions": "Contrôles de la révision",
  "livrer.raison.spec_gate": "Spec Gate",
  "livrer.raison.items": "Items livrés",
  "livrer.raison.campaigns": "Tests de la version",
  "livrer.raison.acceptance": "Recette métier",
  "livrer.raison.defects": "Anomalies",
  "livrer.raison.requirements": "Exigences",
  "livrer.raison.waivers": "Dérogations en vigueur",
  "livrer.raison.non_regression": "Non-régression",
  "livrer.raison.notes": "Notes de version",
  "livrer.raison.signed_artifacts": "Artefacts signés",
  "livrer.miseEnLigneEtat.approuvee": "approuvée",
  "livrer.miseEnLigneEtat.refusee": "refusée",
  "livrer.miseEnLigneEtat.a-approuver": "à approuver",
  "livrer.miseEnLigneEtat.aucune": "non demandée",
  "livrer.recette.accordee": "Recette : accordée",
  "livrer.recette.a-faire": "Recette : à faire",
  "livrer.recette.inconnue": "Recette : non calculée par ce serveur",
  "audit.pseudonymiseHint": "Pour un auditeur externe : il vérifie que le créateur diffère de l'approbateur sans recevoir l'annuaire du personnel. La vérification d'intégrité reste valide.",
  "config.model.workflowHint": "Clé, libellé et transitions autorisées (clés de statut cibles, séparées par des virgules). L'ordre définit l'affichage.",
  "config.modeHint": "Le mode « manuel » refuse toute génération IA ; l’auto-acceptation allégée fait entrer les items générés déjà acceptés.",
  "config.modeSinglePolicyHint": "Un seul mode est appliqué à la publication. Les autres lignes sont uniquement les politiques disponibles du catalogue, pas des configurations concurrentes.",
  "runops.envRankAide": "Une release n'atteint un rang qu'après avoir réussi un rang INFÉRIEUR. Deux paliers de même rang sont parallèles, pas successifs.",
  "runops.newEnvironmentDesc": "Un palier est une étape de promotion : c'est lui qui répond à « quelle version tourne ici, et depuis quand ? ».",
  "runops.relCommitAide": "Le commit dont la release est issue. Sans lui elle ne serait pas traçable — c'est pourquoi la passerelle l'exige.",
  "runops.newReleaseDesc": "Une release associe une version à un commit précis. Elle est ensuite promue palier par palier, dans l'ordre des rangs.",
  "runops.voirTrace": "Trace de bout en bout",
  "envFiche.champ.source_scope": "Défini au niveau",
  "envFiche.champ.url": "Adresse",
  "envFiche.champ.target_type": "Cible",
  "envFiche.champ.compose_file": "Fichier Compose",
  "envFiche.champ.healthcheck_url": "Sonde de santé",
  "envFiche.champ.image_policy": "Politique d’image",
  "envFiche.champ.auto_stop_minutes": "Arrêt automatique (min)",
  "envFiche.champ.source_dir": "Répertoire source",
  "envFiche.champ.source_ref_pattern": "Branches et tags admis",
  "envFiche.champ.require_gitlab_pipeline": "Pipeline GitLab exigé",
  "envFiche.champ.technologies": "Technologies",
  "envFiche.champ.test_command": "Commande de tests",
  "envFiche.champ.lifetime_type": "Durée de vie",
  "envFiche.champ.contract_version": "Version du contrat",
  "envFiche.champ.source_verified": "Source vérifiée",
  "envFiche.chargement": "Chargement de l’environnement…",
  "envFiche.introuvable": "Environnement introuvable",
  "envFiche.introuvableAide": "Il n’est ni déclaré dans ce projet ni hérité de son programme.",
  "envFiche.titre": "Environnement {{nom}}",
  "envFiche.description": "Ce qui y tourne, le contrat de résolution effectif et les déploiements sur ce palier.",
  "envFiche.enService": "En service",
  "envFiche.vide": "palier vide",
  "envFiche.sante": "Santé",
  "envFiche.effectif": "Contrat de résolution effectif",
  "envFiche.chargementEffectif": "Résolution de l’environnement…",
  "envFiche.deploiements": "Déploiements sur ce palier",
  "envFiche.chargementDeploiements": "Chargement des déploiements…",
  "envFiche.aucunDeploiement": "Aucun déploiement",
  "envFiche.aucunDeploiementAide": "Un déploiement se lance depuis une version prête (Livraison › Versions).",
  "traceDeploiement.chargement": "Chargement de la trace du déploiement…",
  "traceDeploiement.introuvable": "Déploiement introuvable",
  "traceDeploiement.introuvableAide": "Il n’existe pas dans le projet ouvert.",
  "traceDeploiement.titre": "Trace du déploiement {{v}} sur {{env}}",
  "traceDeploiement.description": "De l’item au palier : version, commit, items publiés, pipeline, événements et provenance du statut.",
  "traceDeploiement.statut": "Statut",
  "traceDeploiement.provenance": "Provenance du statut",
  "traceDeploiement.parWorker": "preuve d’exécution du worker",
  "traceDeploiement.manuel": "saisie tracée",
  "traceDeploiement.environnement": "Environnement",
  "traceDeploiement.version": "Version",
  "traceDeploiement.commit": "Commit",
  "traceDeploiement.correlation": "Corrélation",
  "traceDeploiement.pipeline": "Pipeline",
  "traceDeploiement.sansPipeline": "aucun pipeline rattaché",
  "traceDeploiement.livraison": "livraison : {{s}}",
  "traceDeploiement.items": "Items publiés dans ce commit",
  "traceDeploiement.aucunItem": "Aucun item rattaché à ce commit",
  "traceDeploiement.aucunItemAide": "Un item se rattache à un commit quand sa branche est publiée (provenance SCM).",
  "traceDeploiement.itemSupprime": "item supprimé",
  "traceDeploiement.evenements": "Événements du fournisseur",
  "traceDeploiement.aucunEvenement": "Aucun événement ingéré",
  "traceDeploiement.aucunEvenementAide": "Les événements du pipeline arrivent par la synchronisation GitLab.",
  "runopsFiche.sansProjet": "Aucun projet ouvert",
  "runopsFiche.sansProjetAide": "L’exploitation se lit par projet : ouvrez-le dans la barre de contexte.",
  "config.desc": "La façon de travailler de votre organisation, rangée par sujet : le modèle de work-item, les statuts, les liaisons, la plateforme et le cycle de vie.",
  "login.intro": "Un cycle complet, gouverné et traçable — chaque artefact généré, revu et approuvé (créateur ≠ approbateur), avec la transparence des modèles.",
  "markdown.hint": "Markdown pris en charge (titres, listes, tableaux, liens, code) ; un bloc ```mermaid``` est rendu en diagramme dans l'aperçu.",
  "accueil.po.nonConforme": "non conforme",
  "accueil.po.nonExecutee": "jamais exécutée",
  "accueil.po.testsConformes": "tests conformes",
  "anomalies.badge.colony": "origine : échec de la colonie",
  "anomalies.badge.product": "origine : produit",
  "anomalies.origine.all": "Toutes",
  "anomalies.origine.badge": "colonie",
  "anomalies.origine.colony": "Échecs de la colonie",
  "anomalies.origine.colonyAide": "Une tâche de la colonie qui n’a pas convergé n’est pas une anomalie du produit : elle ne compte ni dans la santé ni dans le tableau de bord qualité. Corrigez-la en relançant ou en replanifiant la mission.",
  "anomalies.origine.compte": "{{o}} ouvertes / {{n}}",
  "anomalies.origine.label": "Origine des anomalies",
  "anomalies.origine.product": "Produit",
  "anomalies.case.aucun": "Aucun cas de recette rattaché : la vérification et la correction ne peuvent pas s’appuyer sur le cas exécuté.",
  "anomalies.case.choisir": "Cas dont l’anomalie est née",
  "anomalies.case.choisirVide": "Choisir un cas…",
  "anomalies.case.definitif": "Le cas définit ce que la vérification exigera : une fois rattaché, il ne change plus.",
  "anomalies.case.lie": "Anomalie rattachée à son cas de recette",
  "anomalies.case.rattacher": "Rattacher (définitif)",
  "anomalies.case.testAValider": "Le test exécutable du cas attend sa validation par un autre membre du projet. Sans test validé, la vérificatrice conçoit les tests cachés à partir du cas exécuté (étapes, attendu, observé).",
  "anomalies.case.testAbsent": "Le cas n’a pas de test exécutable. Sans test validé, la vérificatrice conçoit les tests cachés à partir du cas exécuté (étapes, attendu, observé).",
  "anomalies.case.testValide": "test validé par {{qui}} le {{quand}}",
  "anomalies.case.testValideAide": "Une mission de correction l’utilise TEL QUEL comme test caché : il doit échouer sur la version actuelle et passer une fois l’anomalie corrigée.",
  "anomalies.case.titre": "Cas de recette et test caché de la correction",
  "cas.classementEnregistre": "Priorité et risque enregistrés",
  "cas.classementTitre": "Priorité et risque",
  "cas.classer": "Modifier",
  "cas.enregistrer": "Enregistrer",
  "cas.priorite": "Priorité",
  "cas.priorite.critical": "critique",
  "cas.priorite.high": "haute",
  "cas.priorite.low": "basse",
  "cas.priorite.medium": "moyenne",
  "cas.prioriteLue": "Priorité : {{v}}",
  "cas.risque": "Risque",
  "cas.risque.high": "élevé",
  "cas.risque.low": "faible",
  "cas.risque.medium": "moyen",
  "cas.risque.none": "non évalué",
  "cas.risqueLu": "Risque : {{v}}",
  "cas.test.aValider": "À valider — écrit par {{qui}}",
  "cas.test.aide": "Écrit en pytest + httpx. La plateforme fournit les fixtures client_connecte (premier compte, connecté par le parcours de l’application), client_second_role (second rôle), executer_en_parallele(n, fonction) et la variable BASE_URL. Une fois validé par un autre membre du projet, ce test devient TEL QUEL le test caché de toute mission qui corrige une anomalie de ce cas : il doit échouer sur la version qui présente l’anomalie et passer une fois corrigée.",
  "cas.test.aucun": "Aucun test exécutable",
  "cas.test.auteurNeValidePas": "Vous en êtes l’auteur : un autre membre du projet le relit et le valide.",
  "cas.test.code": "Code pytest du cas",
  "cas.test.ecrire": "Écrire le test",
  "cas.test.editeur": "Éditeur du test exécutable",
  "cas.test.empreinte": "empreinte {{s}}",
  "cas.test.enregistre": "Test enregistré : un autre membre du projet doit le valider",
  "cas.test.enregistrer": "Enregistrer le test",
  "cas.test.lectureSeule": "Lecture seule : seul un contributeur du projet écrit ou valide un test.",
  "cas.test.modifier": "Modifier le test",
  "cas.test.modifierRetire": "Enregistrer une modification retire la validation : un autre membre devra relire et valider la nouvelle version.",
  "cas.test.refusAuteur": "Vous êtes l’auteur de ce test : un autre membre du projet le relit et le valide.",
  "cas.test.refusChange": "Le test a changé depuis votre lecture : relisez la version affichée, puis validez-la.",
  "cas.test.refusInvalide": "Le test doit contenir au moins une fonction pytest « def test_…() ».",
  "cas.test.titre": "Test exécutable (test de recette)",
  "cas.test.valide": "Test validé : il servira tel quel de test caché aux corrections",
  "cas.test.validePar": "Test validé par {{qui}} le {{quand}}",
  "cas.test.validerAction": "Valider ce test (je l’ai relu)",
  "pas.assigneA": "Assigné à",
  "pas.assigneLu": "assigné à {{u}}",
  "pas.assignesMoi": "Assignés à moi",
  "pas.attendu": "Attendu : {{v}}",
  "pas.aucunAssigne": "Aucun cas ne vous est assigné dans cette campagne",
  "pas.aucunCas": "Aucun cas dans cette campagne",
  "pas.aucunCasAide": "Les cas viennent du plan de la campagne.",
  "pas.bilan": "Verdict du cas : {{v}} en {{d}}",
  "pas.campagneFermee": "Cette campagne est {{s}} : ses exécutions se consultent, elles ne se jouent plus.",
  "pas.casDeLaCampagne": "Cas de la campagne",
  "pas.casHorsCampagne": "Ce cas n’est pas dans la campagne",
  "pas.casHorsCampagneAide": "Choisissez un cas de la liste.",
  "pas.chargement": "Lecture de la campagne…",
  "pas.chargementExecution": "Lecture de l’exécution…",
  "pas.choisirVerdict": "Choisissez un verdict pour cette étape.",
  "pas.declarer": "Déclarer l’anomalie (pré-remplie à l’étape {{n}})",
  "pas.demarrer": "Démarrer l’exécution",
  "pas.description": "Un verdict et une preuve par étape ; l’anomalie se déclare depuis l’étape rouge.",
  "pas.ecrireScenario": "Aucune étape : écrire le scénario",
  "pas.enregistrerEtape": "Enregistrer l’étape",
  "pas.etape": "Étape {{n}}",
  "pas.executer": "Exécuter pas à pas",
  "pas.jamaisExecute": "jamais exécuté",
  "pas.lienCampagne": "Exécuter pas à pas et assigner",
  "pas.nbEtapes": "{{n}} étape(s)",
  "pas.nonAssigne": "Non assigné",
  "pas.obtenu": "Obtenu",
  "pas.obtenuLu": "Obtenu : {{v}}",
  "pas.obtenuObligatoire": "Obtenu (obligatoire)",
  "pas.obtenuRequis": "Étape rouge : dites ce qui a été obtenu.",
  "pas.ouvrirPlans": "Ouvrir les plans",
  "pas.pasExecutant": "Seul l’exécutant ({{u}}) rend les verdicts de cette exécution.",
  "pas.preconditions": "Préconditions : {{v}}",
  "pas.preuve": "Preuve (capture, lien, sortie)",
  "pas.preuveLue": "Preuve : {{v}}",
  "pas.priorite": "priorité {{v}}",
  "pas.prioriteRisque": "Priorité {{p}} · risque {{r}}",
  "pas.retourCas": "← Tous les cas de la campagne",
  "pas.risque": "risque {{v}}",
  "pas.rougeAide": "Étape {{n}} rouge : terminez l’exécution, les étapes suivantes seront ignorées.",
  "pas.statut.cancelled": "annulée",
  "pas.statut.closed": "fermée",
  "pas.termine": "Exécution terminée : son verdict fait foi dans la campagne",
  "pas.terminer": "Terminer l’exécution",
  "pas.titre": "Exécuter la campagne #{{id}} pas à pas",
  "pas.verdict.blocked": "Bloquée",
  "pas.verdict.failed": "Non conforme",
  "pas.verdict.passed": "Conforme",
  "pas.verdict.running": "En cours",
  "pas.verdict.skipped": "Ignorée",
  "pas.verdictEtape": "Verdict de l’étape {{n}}",
  "pas.voirCas": "Voir les cas",
  "qualite.echecsColonie": "{{n}} échec(s) de la colonie, dont {{o}} ouvert(s), sont suivis à part.",
  "qualite.perimetreProduit": "Anomalies du produit seulement.",
  "trace.anomalies": "Anomalies",
  "trace.aucunCas": "Aucun cas de test relié.",
  "trace.aucunCritere": "La spécification ne cite aucun critère pour cette exigence.",
  "trace.aucuneAnomalie": "Aucune anomalie reliée.",
  "trace.aucunItem": "Aucun item du backlog ne cite cette exigence.",
  "trace.cases": "Cas",
  "trace.casEtExecutions": "Cas et dernière exécution",
  "trace.casGenere": "généré",
  "trace.conformes": "Conformes",
  "trace.criteres": "Critères d’acceptation",
  "trace.critereSansCas": "(aucun cas ne le cite)",
  "trace.desc": "Chaque exigence REQ de la spécification approuvée, ses items, les cas qui la prouvent, leur dernière exécution et les anomalies. Les trous sont nommés.",
  "admin.retentionJoursAide": "Les événements d'un même job partent ENSEMBLE, jugés sur le plus récent : découper un job à la date romprait sa chaîne de hachage et ferait croire à une altération.",
  "admin.pseudoHint": "La correspondance identifiant → pseudonyme n'est jamais exposée, pas même ici : la révéler à un administrateur annulerait ce que la pseudonymisation protège. Un pseudonyme reste stable dans tout un export, ce qui suffit à prouver que le créateur diffère de l'approbateur.",
  "admin.purgeC1": "Ces événements ne sont récupérables par aucun écran : aucun point de restauration n'existe côté serveur.",
  "admin.purgeC2": "Un export d'audit produit ensuite ne les contiendra plus — y compris si un auditeur les réclame.",
  "admin.purgeRev": "Irréversible. Générez et téléchargez un export d'audit avant, si ces journaux doivent être conservés hors du produit.",
  "admin.purgeObsolete": "Si le volume a changé depuis la simulation, le serveur refuse la purge : détruire un volume différent de celui qu'on vous a montré ne serait pas la même opération.",
  "admin.addMemberHint": "Utilisateurs existants uniquement (identifiant ou nom d'utilisateur). L'invitation par e-mail et le provisioning Keycloak sont hors périmètre.",
  "admin.noModelRestrictionWarn": "Choisissez un modèle dans le catalogue ci-dessous pour autoriser les générations dans cet espace. Le modèle doit aussi être activé pour l’organisation.",
  "admin.modelRemoveDernier": "C'est le DERNIER de la liste : le retirer bloque les générations jusqu'à l'autorisation explicite d'un autre modèle.",
  "admin.polCleAide": "Un attribut ABSENT au moment de la décision ne satisfait jamais la condition : la règle ne s'applique alors pas.",
  "admin.policiesDesc": "Des règles qui portent sur les attributs de la ressource, et non sur le seul rôle. C'est ce qui exprime la séparation des devoirs — « l'approbateur n'est pas le créateur » — sans multiplier les rôles.",
  "admin.polVideHint": "Seul le rôle décide aujourd'hui. Ajoutez une règle ci-dessous pour poser une condition qu'un rôle ne peut pas exprimer.",
  "admin.polDeleteDeny": "C'est un REFUS : le supprimer AUTORISE ce qu'il interdisait, pour tous les appelants concernés.",
  "admin.polDeleteAllow": "C'est une autorisation d'exception : la supprimer ramène la décision au seul rôle.",
  "admin.simDesc": "Interroge la décision RÉELLE du serveur, pas une reconstitution : ce que ce simulateur répond est ce que le produit fera.",
  "admin.quotaResetC1": "Le compteur repart de zéro : la consommation déjà faite cesse d'être décomptée.",
  "admin.quotaNoCatalogHint": "La passerelle n'a pas renvoyé la liste des ressources : sans elle, une saisie libre créerait un quota que rien ne lit.",
  "admin.quotaUpsertHint": "Une ressource déjà limitée voit sa valeur remplacée : il ne peut exister qu'une limite par ressource et par espace.",
  "admin.rbacScopeDesc": "La matrice n'est pas rattachée à un espace : accorder une permission à un rôle la lui donne dans tous les projets du locataire, pas seulement celui-ci. Les rôles eux-mêmes viennent du realm et ne se créent pas ici.",
  "admin.workersScopeDesc": "La table des battements ne porte aucun locataire : ces workers servent toute l'installation. Ce que vous voyez et purgez ici concerne tout le monde. Seules des données techniques sont exposées — identifiant, fraîcheur, moteur.",
  "admin.workersVideHint": "Le worker tourne sur l'hôte, où vit le GPU : aucun conteneur ne le démarre. Lancez-le avec « make worker ».",
  "admin.workerPurgeC1": "La ligne disparaît de la supervision de TOUTE l'installation, pas seulement de cette organisation.",
  "admin.workerPurgeC2Vivant": "Ce worker bat encore : il réinscrira sa ligne dans les secondes qui suivent. Le serveur refusera.",
  "admin.workerPurgeRev": "Un worker qui redémarre recrée sa ligne, mais son historique de jobs repart à zéro.",
  "config.viewingOnly": "Le Default est le modèle intégré, en lecture seule. Pour l'adapter, dupliquez-le : la copie (template d'organisation) devient entièrement modifiable.",
  "chat.admissionWait": "Moteur occupé — nouvelle tentative dans {{s}} s.",
  "dashboard.archiveWorkspace": "Archiver {{nom}}",
  "ingestion.uploadProgressValue": "Progression : {{progress}} %",
  "ingestion.confirmDelete": "Supprimer définitivement {{fichier}} et ses vecteurs ?",
  "admin.rbacDernierAdminC1": "Retirer « {{permission}} » au dernier rôle qui la porte fermerait l'administration à toute l'organisation, sans moyen de la rouvrir depuis le produit.",
  "equipe.membreRetire": "Membre retiré de l’équipe",
  "equipe.supprimee": "Équipe supprimée ; ses items sont conservés, sans équipe",
  "equipe.versEquipes": "Membres et équipes du projet",
  "equipe.sansProjet": "Aucun projet ouvert",
  "equipe.sansProjetAide": "Une équipe appartient à un projet : ouvrez-le dans la barre de contexte.",
  "equipe.chargement": "Chargement de l’équipe…",
  "equipe.introuvable": "Équipe introuvable",
  "equipe.introuvableAide": "Elle n’existe pas (ou plus) dans le projet ouvert.",
  "equipe.retirerTitre": "Retirer {{nom}} de l’équipe {{equipe}} ?",
  "equipe.retirerConsequence": "{{nom}} reste membre du projet avec le même rôle ; seule son appartenance à l’équipe disparaît.",
  "equipe.retirerReversible": "Vous pourrez l’ajouter de nouveau depuis Membres et équipes.",
  "equipe.retirer": "Retirer de l’équipe",
  "equipe.supprimerTitre": "Supprimer l’équipe {{equipe}} ?",
  "equipe.supprimerMembres": "Ses {{n}} membre(s) restent membres du projet.",
  "equipe.supprimerItems": "Ses {{n}} item(s) sont conservés et deviennent « sans équipe ».",
  "equipe.supprimerIrreversible": "L’équipe ne se restaure pas ; la suppression est consignée au journal d’audit.",
  "equipe.supprimer": "Supprimer l’équipe",
  "equipe.titre": "Équipe — {{nom}}",
  "equipe.sansDescription": "Membres, travail rangé dans l’équipe et charge du sprint actif.",
  "equipe.lectureSeule": "Lecture seule : gérer une équipe est réservé au propriétaire du projet ou à l’administration de l’organisation.",
  "equipe.charge": "Charge et capacité",
  "equipe.items": "item(s) rangés dans l’équipe",
  "equipe.points": "point(s) estimés",
  "equipe.membres": "membre(s)",
  "equipe.sansSprint": "Aucun sprint actif dans le projet.",
  "equipe.chargeSprint": "{{items}} item(s), {{points}} point(s) de l’équipe",
  "equipe.capaciteSprint": "capacité déclarée du sprint : {{j}} jour(s)-personne(s)",
  "equipe.capaciteNonDeclaree": "capacité du sprint non déclarée",
  "equipe.membresTitre": "Membres",
  "equipe.aucunMembre": "Aucun membre",
  "equipe.aucunMembreAide": "On ajoute un membre du projet depuis Membres et équipes.",
  "equipe.horsProjet": "plus membre du projet",
  "equipe.compteInactif": "compte désactivé",
  "equipe.assignes": "{{n}} item(s) assigné(s) dans l’équipe",
  "equipe.itemsTitre": "Travail rangé dans l’équipe",
  "equipe.aucunItem": "Aucun item",
  "equipe.aucunItemAide": "Un item se range dans une équipe depuis sa fiche (champ Équipe).",
  "equipe.role.owner": "propriétaire",
  "equipe.role.contributor": "contributeur",
  "equipe.role.viewer": "lecteur",
  "livrer.budgetEpuise": "La marge d'incidents de l'application est épuisée. Vous pouvez quand même mettre en ligne : c'est un avertissement, aucune justification n'est demandée.",
  "versions.summaryLivree": "Dernière livrée : {{version}} ({{envs}})",
  "versions.summaryAucuneLivree": "Dernière livrée : aucune",
  "versions.summaryDeployeeNonLivree": "Déployée : {{version}} ({{envs}}), pas encore déclarée livrée",
  "pgmVue.deployeeNonLivree": "déployée : {{v}} ({{env}}), pas encore déclarée livrée",
  "pgmVersions.regleLivree": "« Livrée » : déclarée livrée dans le projet, ce qui exige un déploiement réussi sur un environnement approuvé ; un déploiement non déclaré est dit « déployée ».",
  "trace.emptyItems": "Aucun item implémentable",
  "trace.emptyItemsHint": "Décomposez une spécification en features, US et tâches.",
  "trace.item": "Item",
  "trace.items": "Items",
  "trace.itemsConformes": "Tests conformes",
  "trace.itemsImplementables": "Items",
  "trace.itemsRelies": "Items reliés",
  "trace.nonConformes": "Non conformes",
  "trace.nonCouvertes": "Sans cas de test",
  "trace.nonExecutees": "Jamais exécutées",
  "trace.noWorkspaceHint": "La traçabilité se lit dans un projet.",
  "trace.openDefects": "Anomalies ouvertes",
  "trace.openProofShort": "Explorer",
  "trace.origineColonie": "colonie",
  "trace.origineProduit": "produit",
  "trace.orphelins": "Cas reliés à aucune exigence ({{n}})",
  "trace.ouvrirSpecs": "Ouvrir les spécifications",
  "trace.quoiItems": "items",
  "trace.source": "Spécification approuvée : version {{v}} (approbation #{{id}})",
  "trace.sourceAucune": "Aucune spécification approuvée",
  "trace.statut.failed": "non conforme",
  "trace.statut.notCovered": "non couverte",
  "trace.statut.notRun": "jamais exécutée",
  "trace.statut.passed": "conforme",
  "trace.testsDetail": "{{cas}} cas relié(s), {{jobs}} job(s) de conception",
  "trace.titre": "Couverture et traçabilité",
  "trace.trous": "Trous de couverture",
  "trace.verdict.failed": "non conforme",
  "trace.verdict.notRun": "jamais exécuté",
  "trace.verdict.passed": "conforme",
  "trace.via.child": "enfant d’un item qui la cite",
  "trace.via.cites": "cite l’exigence",
  "trace.via.parent": "porte la tâche qui la cite",
  "trace.videReq": "Aucune exigence REQ dans la spécification approuvée",
  "trace.videReqAide": "Les exigences viennent des titres « REQ-01 — … » de la spécification approuvée : faites approuver une spécification.",
  "trace.vueExigences": "Par exigence",
  "trace.vueItems": "Par item du backlog",
  "trace.vues": "Vues de la traçabilité",
  "versions.parCorrectif": "correctif livré par cette version",
  "versions.code.REGRESSION_SUITE_NOT_RUN": "La suite de non-régression n’a pas été exécutée sur cette version",
  "preteEnv.titre": "Prête pour quel environnement ?",
  "preteEnv.aucunEnv": "Aucun environnement déclaré",
  "preteEnv.cible": "Environnement cible",
  "preteEnv.choisir": "Choisir un environnement…",
  "preteEnv.chargement": "Évaluation pour cet environnement…",
  "preteEnv.prete": "prête",
  "preteEnv.pasPrete": "pas prête : {{n}} raison(s) bloquante(s)",
  "preteEnv.approbation": "approbation : {{s}}",
  "preteEnv.nonDemandee": "non demandée",
  "preteEnv.deployable": "Déployable sur cet environnement",
  "preteEnv.nonDeployable": "Pas encore déployable sur cet environnement :",
  "docLivraison.retour": "Retour à la version",
  "docLivraison.sansProjet": "Aucun projet ouvert",
  "docLivraison.sansProjetAide": "Une version appartient à un projet : ouvrez-le dans la barre de contexte.",
  "docLivraison.inconnu": "Document inconnu",
  "docLivraison.chargement": "Chargement des documents de livraison…",
  "docLivraison.versionIntrouvable": "Version introuvable",
  "docLivraison.versionIntrouvableAide": "Elle n’existe pas dans le projet ouvert.",
  "docLivraison.description": "Document de livraison généré depuis les objets de la version, sans modèle de langage.",
  "docLivraison.nonGenere": "Pas encore généré",
  "docLivraison.nonGenereAide": "Générez la documentation depuis la fiche de la version (Documentation de livraison).",
  "docLivraison.version": "Version du document",
  "docLivraison.generePar": "Généré par",
  "docLivraison.generateur": "Générateur",
  "docLivraison.empreinte": "Empreinte",
  "docLivraison.telecharger": "Télécharger ({{f}})",
  "docLivraison.lecture": "Lecture du document…",
  "agile.bulkFieldAssigne": "l’assigné",
  "agile.sprintDeLUs": "Sprint de l’US : {{nom}}",
  "agile.bulkAssigneLabel": "Assigné (masse)",
  "agile.bulkAssignePlaceholder": "Assigné…",
  "agile.aucunResultat": "Aucun item ne correspond aux filtres",
  "agile.aucunResultatHint": "Élargissez ou effacez les filtres : le backlog, lui, n’est pas vide.",
  "agile.effacer": "Effacer les filtres",
  "agile.rangPose": "« {{titre}} » posé en position {{pos}} sur {{n}}.",
  "agile.rangSaisi": "« {{titre}} » saisi, position {{pos}} sur {{n}}. Flèches pour déplacer, Espace pour poser, Échap pour annuler.",
  "agile.rangDeplace": "Position {{pos}} sur {{n}}.",
  "agile.rangAnnule": "Déplacement annulé.",
  "agile.rangAide": "Poignée : Espace pour saisir la ligne, flèches haut et bas pour la déplacer, Espace ou Entrée pour la poser, Échap pour annuler.",
  "agile.rangListe": "Lignes de {{groupe}}, dans l’ordre du backlog",
  "agile.rangPoignee": "Déplacer « {{titre}} »",
  "monTravail.echeanceDepassee": "échéance dépassée : {{d}}",
  "monTravail.echeance": "échéance : {{d}}",
  "monTravail.titre": "Mon travail",
  "monTravail.toutVoir": "Tout voir, tous projets",
  "monTravail.chargement": "Lecture de votre travail…",
  "monTravail.erreur": "Votre travail n’a pas pu être lu.",
  "monTravail.nItems": "{{n}} item(s) assigné(s)",
  "monTravail.nAnomalies": "{{n}} anomalie(s)",
  "monTravail.nDecisions": "{{n}} décision(s) à rendre",
  "monTravail.aucunItem": "Aucun item ne vous est assigné.",
  "monTravail.description": "Ce qui vous est assigné et ce qui attend votre décision, dans tous vos projets.",
  "monTravail.sansProjet": "Vous n’êtes membre d’aucun projet",
  "monTravail.sansProjetHint": "Demandez à un propriétaire de vous ajouter, ou ouvrez vos invitations.",
  "monTravail.invitations": "Mes invitations",
  "monTravail.vide": "Rien ne vous attend",
  "monTravail.videHint": "Aucun item, aucune anomalie ne vous est assigné, et aucune décision n’attend votre avis.",
  "monTravail.mesItems": "Mes items",
  "monTravail.mesAnomalies": "Mes anomalies",
  "monTravail.decisions": "Décisions à rendre",
  "monTravail.demandePar": "demandée par {{qui}}",
  "monTravail.campagnes": "Campagnes à exécuter",
  "monTravail.nonAccessibles": "{{n}} autre(s) projet(s) de l’organisation ne vous sont pas ouverts.",
  "agile.sprintHeriteTitre": "Sprint de son US parente : l’item n’a pas de sprint propre.",
  "agile.viaUs": "(via l’US #{{id}})",
  "agile.assigneLabel": "Assigné",
  "agile.assigneMisAJour": "Assignation mise à jour",
  "agile.changerAssigne": "Changer l’assigné",
  "agile.decomposerAvantCode": "Cet item se découpe en éléments plus petits ; le code se produit depuis une tâche.",
  "agile.assigneAgent": "Assigné à un agent : {{ref}}",
  "agile.agent": "Agent",
  "agile.assigneParti": "{{nom}} n’est plus membre actif du projet : réassignez l’item.",
  "agile.membreParti": "(membre parti)",
  "agile.assigneA": "Assigné à {{nom}}",
  "agile.moi": "(moi)",
  "agile.assignerMoi": "Moi",
  "agile.membresIllisibles": "Membres illisibles",
  "agile.annuaireRetirer": "Choisir quelqu’un d’autre",
  "agile.annuairePlaceholder": "Nom, identifiant ou e-mail…",
  "agile.annuaireChargement": "Recherche…",
  "agile.annuaireRefus": "Réservé à un propriétaire du projet ou à l’administration de l’organisation : vous ne pouvez pas ajouter de membres ici.",
  "agile.annuaireErreur": "L’annuaire n’a pas pu être lu.",
  "agile.annuaireListe": "Utilisateurs de l’organisation",
  "agile.annuaireAucun": "Aucun utilisateur de l’organisation ne correspond, ou il est déjà membre.",
  "agile.annuaireTous": "Tous les utilisateurs actifs de l’organisation sont déjà membres.",
  "agile.avancementLibelle": "{{faites}} / {{total}} terminées · {{pct}} %",
  "agile.avancement": "Avancement",
  "agile.statutCalculeTitre": "Statut calculé depuis les enfants",
  "agile.statutEnregistre": "(enregistré : {{statut}})",
  "agile.filtresTravail": "Filtres de travail",
  "agile.filtreTexte": "Texte ou #id",
  "agile.filtreTextePlaceholder": "ticket, #9…",
  "agile.tousSprints": "Tous",
  "agile.sansSprint": "Sans sprint",
  "agile.tous": "Tous",
  "agile.assigneAMoi": "Moi",
  "agile.unAgent": "Un agent",
  "agile.effacerFiltres": "Effacer les filtres ({{n}})",
  "agile.anomalieAssignee": "Assignation de l’anomalie mise à jour",
  "agile.assigneAnomalie": "Assignée à",
  "agile.parentClos": "Statut aligné sur ses enfants",
  "agile.hierarchie": "Hiérarchie",
  "agile.hierarchieChargement": "Lecture de la hiérarchie…",
  "agile.hierarchieErreur": "La hiérarchie n’a pas pu être lue.",
  "agile.parent": "Parent",
  "agile.sansParent": "Sans parent : cet item est à la racine du backlog.",
  "agile.filParents": "Parents de l’item",
  "agile.enfants": "Enfants",
  "agile.sansEnfant": "Aucun enfant pour l’instant : ajoutez-en un ci-dessous ou générez-les depuis « Actions IA ».",
  "agile.sansEnfantFeuille": "Aucun enfant : cet item est une feuille du backlog.",
  "agile.tousTermines": "Tous les enfants sont terminés, mais cet item est encore ouvert.",
  "agile.clore": "Passer au statut final",
  "agile.cloreLecteur": "Un contributeur peut l’aligner.",
  "agile.enfantCree": "Enfant ajouté",
  "agile.enfantTitreRequis": "Un titre de 3 caractères au moins.",
  "agile.nouvelEnfant": "Nouvel enfant",
  "agile.typeEnfant": "Type de l’enfant",
  "agile.ajouterEnfant": "Ajouter",
  "agile.epicSansEnfant": "aucun enfant",
  "agile.avancementEpics": "Avancement des epics",
  "agile.avancementChargement": "Calcul de l’avancement…",
  "agile.avancementErreur": "L’avancement n’a pas pu être lu.",
  "agile.aucunEpic": "Aucun epic",
  "agile.aucunEpicHint": "Les epics naissent du backlog généré depuis une spécification approuvée.",
  "agile.avancementEpicsProgramme": "Avancement des epics par projet",
  "agile.aucunProjetMembre": "Aucun projet dont vous êtes membre",
  "agile.aucunProjetMembreHint": "Le détail d’un projet n’est montré qu’à ses membres.",
  "agile.projetsNonAccessibles": "{{n}} projet(s) du programme ne vous sont pas ouverts.",
  "agile.addMemberHint": "Cherchez une personne de l’organisation par son nom, son identifiant ou son e-mail. Une personne hors de l’organisation s’invite par e-mail ci-dessous.",
  "agile.personneAAjouter": "Personne à ajouter",
  "agile.personneRequise": "Choisissez la personne à ajouter.",
  "nav./mon-travail": "Mon travail",
  "navdesc./mon-travail": "Mes items, anomalies, décisions et campagnes, dans tous mes projets, par statut et échéance",
  "agile.cloreEtapes": "Passer au statut final ({{n}} étapes)",
  "agile.cloreImpossible": "Le workflow ne mène pas de ce statut au statut final : modifiez l’item avec « Modifier ».",
  "continuite.statut.reussie": "réussie",
  "continuite.statut.echec": "en échec",
  "continuite.refus.motif": "Un motif de 10 caractères au moins est requis.",
  "continuite.refus.inconnue": "Cette sauvegarde n’est plus au journal.",
  "continuite.refus.echec": "Une sauvegarde en échec ne se restaure pas.",
  "continuite.refus.chemin": "Le journal ne dit pas où se trouve cette sauvegarde (ligne antérieure à cette version).",
  "continuite.refus.nomCible": "Nom de l’environnement cible : 3 à 63 caractères a-z, 0-9, - ou _.",
  "continuite.refus.doubleConfirmation": "Restauration en place : cochez la confirmation ET tapez exactement la phrase demandée.",
  "continuite.refus.essaiRequis": "Restauration en place refusée : aucun essai de restauration réussi de cette sauvegarde. Lancez d’abord une restauration sur pile jetable.",
  "continuite.refus.admin": "Réservé à l’administration de la plateforme.",
  "continuite.refus.inattendu": "La passerelle a refusé la demande.",
  "continuite.jamais": "DoIt n’a jamais été sauvegardé sur ce poste.",
  "continuite.jamaisAide": "Risque accepté en v0.5.0 (DEC-054) : la sauvegarde outillée de DoIt est désormais disponible. Demandez une première sauvegarde, puis un essai de restauration.",
  "continuite.demanderSauvegarde": "Demander une sauvegarde",
  "continuite.derniereEchec": "La dernière sauvegarde a échoué ({{quand}}). La dernière réussie date du {{reussie}}.",
  "continuite.aucune": "aucune",
  "continuite.ancienne": "Dernière sauvegarde réussie le {{quand}} : au-delà de l’objectif d’une sauvegarde toutes les {{h}} h.",
  "continuite.essaiJamais": "Aucun essai de restauration au journal : une sauvegarde jamais restaurée n’est pas une sauvegarde.",
  "continuite.essaiEchecTitre": "Essai de restauration échoué ({{quand}})",
  "continuite.essaiEchecSansMotif": "Écarts de contenu après restauration.",
  "continuite.ecarts": "{{n}} écart(s)",
  "continuite.essaiOk": "Dernier essai de restauration : {{quand}}, cible {{cible}}, en {{duree}} s — {{tables}} tables et {{lignes}} lignes contrôlées.",
  "continuite.aucuneSauvegarde": "Aucune sauvegarde au journal",
  "continuite.aucuneSauvegardeIndice": "Le journal s’écrit à chaque sauvegarde lancée sur l’hôte (make db-backup-once).",
  "continuite.legendeSauvegardes": "Sauvegardes de DoIt : date, état, taille, empreinte, rétention et dernier essai",
  "continuite.col.sauvegarde": "sauvegarde",
  "continuite.col.etat": "état",
  "continuite.col.taille": "taille",
  "continuite.col.empreinte": "empreinte (base)",
  "continuite.col.retention": "rétention",
  "continuite.col.essai": "dernier essai",
  "continuite.col.action": "action",
  "continuite.porteeBase": "base entière",
  "continuite.retentionInconnue": "non inscrite",
  "continuite.retentionRotee": "rotée le {{d}}",
  "continuite.retentionGel": "gel légal",
  "continuite.retentionJusque": "jusqu’au {{d}}",
  "continuite.retentionIllimitee": "sans échéance",
  "continuite.jamaisEssayee": "jamais essayée",
  "continuite.restaurer": "Restaurer…",
  "continuite.controles": "{{tables}} tables, {{lignes}} lignes",
  "continuite.aucuneDemande": "Aucune demande",
  "continuite.aucuneDemandeIndice": "Une demande de sauvegarde ou de restauration donne la commande exacte à lancer sur l’hôte.",
  "continuite.demandeSauvegarde": "Sauvegarde",
  "continuite.demandeEnPlace": "Restauration EN PLACE",
  "continuite.demandeCible": "Restauration sur l’environnement {{nom}}",
  "continuite.demandeJetable": "Restauration sur pile jetable",
  "continuite.executee": "exécutée",
  "continuite.enAttente": "en attente d’exécution sur l’hôte",
  "continuite.sauvegardeAide": "Base PostgreSQL de la passerelle et objets MinIO, base entière. La passerelle n’exécute rien : elle trace la demande et donne la commande à lancer sur l’hôte.",
  "continuite.demandeEnregistree": "Demande enregistrée. Lancez cette commande sur l’hôte ; la sauvegarde apparaîtra ici, reliée à la demande.",
  "continuite.motif": "Motif (obligatoire, écrit à la demande et à l’audit)",
  "continuite.fermer": "Fermer",
  "continuite.demander": "Demander",
  "continuite.cible.jetable": "Pile jetable (essai)",
  "continuite.cible.jetableAide": "Conteneur neuf, détruit à la fin ; chaque table est recomptée contre le dump. Recommandé.",
  "continuite.cible.cible": "Environnement cible",
  "continuite.cible.cibleAide": "Conteneur conservé (poste de secours), jamais l’instance courante.",
  "continuite.cible.enPlace": "En place (instance courante)",
  "continuite.cible.enPlaceAide": "Écrase la base de cette installation. Double confirmation et essai réussi exigés.",
  "continuite.restaurerTitre": "Restaurer la sauvegarde {{label}}",
  "continuite.restaurerDescription": "Empreinte {{sha}} · {{taille}} · base entière",
  "continuite.restaurationEnregistree": "Demande enregistrée. À lancer sur l’hôte ; la preuve apparaîtra ici, reliée à la demande.",
  "continuite.cibleLegende": "Où restaurer ?",
  "continuite.nomCible": "Nom de l’environnement cible",
  "continuite.enPlaceCoche": "Je comprends que la base de CETTE installation sera écrasée par la sauvegarde {{label}} ; tout ce qui a été écrit depuis sera perdu.",
  "continuite.enPlacePhrase": "Tapez exactement : {{phrase}}",
  "continuite.demanderRestauration": "Demander la restauration",
  "continuite.chargement": "Lecture du journal des sauvegardes…",
  "continuite.refusAcces": "La continuité de la plateforme est réservée à l’administration de la plateforme.",
  "continuite.erreur": "L’état des sauvegardes n’a pas pu être lu.",
  "continuite.journalAbsent": "Le journal des sauvegardes n’est pas lisible par la passerelle (DOIT_BACKUP_JOURNAL_PATH, monté en lecture seule depuis .doit/runtime).",
  "continuite.titreSauvegardes": "Sauvegardes de DoIt lui-même",
  "continuite.lignesInvalides": "{{n}} ligne(s) illisible(s) au journal, ignorée(s) et comptée(s).",
  "continuite.nePasConfondre": "À ne pas confondre avec « Continuité de l’application » d’un projet (Livrer et exploiter), qui sauvegarde l’application générée.",
  "continuite.versJournal": "Journal du super-administrateur",
  "continuite.titreEssais": "Essais de restauration",
  "continuite.titreDemandes": "Demandes",
  "accesExceptionnels.statut.active": "active",
  "accesExceptionnels.statut.revoquee": "révoquée",
  "accesExceptionnels.statut.expiree": "expirée",
  "accesExceptionnels.refus.motif": "Le motif compte au moins 20 caractères.",
  "accesExceptionnels.refus.duree": "Durée : 5 à 120 minutes.",
  "accesExceptionnels.refus.propre": "Votre propre organisation ne relève pas d’un accès exceptionnel : rejoignez le projet.",
  "accesExceptionnels.refus.sansProprietaire": "Aucun propriétaire de projet à notifier dans cette organisation : un accès exceptionnel n’est jamais silencieux.",
  "accesExceptionnels.refus.dejaActive": "Vous avez déjà une session active sur cette organisation.",
  "accesExceptionnels.refus.expiree": "La fenêtre est close : aucune prolongation tacite, une nouvelle session exige un nouveau motif.",
  "accesExceptionnels.refus.revoquee": "Cette session a été révoquée.",
  "accesExceptionnels.refus.pasLaVotre": "Seul l’administrateur qui a ouvert la session peut lire par elle.",
  "accesExceptionnels.refus.dejaRevoquee": "Session déjà révoquée.",
  "accesExceptionnels.refus.inactive": "Session déjà terminée : rien à révoquer.",
  "accesExceptionnels.refus.admin": "Réservé à l’administration de la plateforme.",
  "accesExceptionnels.refus.introuvable": "Organisation introuvable.",
  "accesExceptionnels.refus.inattendu": "La passerelle a refusé l’action.",
  "accesExceptionnels.restantH": "dans {{h}} h {{m}} min",
  "accesExceptionnels.restantMin": "dans {{m}} min",
  "accesExceptionnels.choisirOrg": "Choisissez l’organisation visée.",
  "accesExceptionnels.ouvrirTitre": "Ouvrir un accès exceptionnel",
  "accesExceptionnels.ouvrirAide": "Lecture seule d’une organisation tierce, pour un incident que son propriétaire ne peut pas traiter. Les propriétaires de projet sont notifiés à l’ouverture ; chaque consultation est écrite à l’audit des deux organisations ; la session se ferme d’elle-même à la fin prévue, sans prolongation tacite.",
  "accesExceptionnels.organisation": "Organisation visée",
  "accesExceptionnels.chargementOrgs": "Chargement…",
  "accesExceptionnels.choisir": "— choisir —",
  "accesExceptionnels.duree": "Durée (fin prévue posée par la base)",
  "accesExceptionnels.minutes": "{{n}} minutes",
  "accesExceptionnels.motif": "Motif (au moins {{n}} caractères, montré aux propriétaires notifiés)",
  "accesExceptionnels.ouverte": "Session ouverte jusqu’à {{fin}} ; {{n}} propriétaire(s) notifié(s).",
  "accesExceptionnels.ouvrir": "Ouvrir l’accès exceptionnel",
  "accesExceptionnels.lectureTitre": "Lecture de {{org}} (accès exceptionnel)",
  "accesExceptionnels.fermerLecture": "Fermer la lecture",
  "accesExceptionnels.lectureBandeau": "Lecture seule jusqu’à {{fin}}. Cette consultation est écrite à l’audit de l’organisation visée.",
  "accesExceptionnels.lectureChargement": "Lecture de l’organisation…",
  "accesExceptionnels.palier": "palier {{p}}",
  "accesExceptionnels.projets": "Projets ({{n}})",
  "accesExceptionnels.aucunProjet": "Aucun projet.",
  "accesExceptionnels.programmes": "Programmes ({{n}})",
  "accesExceptionnels.aucunProgramme": "Aucun programme.",
  "accesExceptionnels.missions": "Missions en cours ({{n}})",
  "accesExceptionnels.aucuneMission": "Aucune mission en cours.",
  "accesExceptionnels.vous": "vous",
  "accesExceptionnels.revoqueeA": "révoquée {{quand}} par {{qui}}",
  "accesExceptionnels.notifies": "{{n}} notifié(s)",
  "accesExceptionnels.consulter": "Consulter l’organisation",
  "accesExceptionnels.revoquerMienne": "Révoquer ma session",
  "accesExceptionnels.revoquer": "Révoquer maintenant",
  "accesExceptionnels.sansProlongation": "aucune prolongation tacite",
  "accesExceptionnels.chargement": "Lecture des accès exceptionnels…",
  "accesExceptionnels.refusAcces": "Les accès exceptionnels sont réservés à l’administration de la plateforme.",
  "accesExceptionnels.erreur": "Les accès exceptionnels n’ont pas pu être lus.",
  "accesExceptionnels.sessionsTitre": "Sessions ({{n}} active(s))",
  "accesExceptionnels.sessionsAide": "La fin prévue est posée et jugée par la base. Une session révoquée ou expirée ne lit plus rien.",
  "accesExceptionnels.vide": "Aucun accès exceptionnel",
  "accesExceptionnels.videIndice": "Avant d’ouvrir un accès, contactez le propriétaire de l’organisation : il agit lui-même (retour arrière, arrêt de mission). À défaut, suspendez l’organisation ou arrêtez l’IA à sa portée.",
  "accesExceptionnels.legende": "Sessions d’accès exceptionnel : qui, organisation, motif, début, fin prévue, statut",
  "accesExceptionnels.col.qui": "qui",
  "accesExceptionnels.col.organisation": "organisation",
  "accesExceptionnels.col.motif": "motif",
  "accesExceptionnels.col.debut": "début",
  "accesExceptionnels.col.fin": "fin prévue",
  "accesExceptionnels.col.statut": "statut",
  "accesExceptionnels.col.action": "action",
  "palier.ressource.documents": "Documents",
  "palier.ressource.taille": "Taille d’un document (Mo)",
  "palier.ressource.jetons": "Jetons par jour",
  "palier.ressource.requetes": "Requêtes par minute",
  "palier.ressource.appelsIa": "Appels IA par jour",
  "palier.chargement": "Lecture du palier…",
  "palier.refus": "Réservé au super-administrateur (administration de la plateforme).",
  "palier.erreur": "Le palier n’a pas pu être lu.",
  "palier.choisirNouveau": "Choisissez un palier différent du palier actuel.",
  "palier.motifObligatoire": "Le motif est obligatoire.",
  "palier.titre": "Palier de {{org}}",
  "palier.depuis": "depuis le {{quand}} · par {{qui}}",
  "palier.parDefaut": "palier par défaut (jamais changé)",
  "palier.legendeLimites": "Limites de chaque palier",
  "palier.col.ressource": "ressource",
  "palier.nouveau": "Nouveau palier",
  "palier.choisir": "— choisir —",
  "palier.actuel": "{{libelle}} (actuel)",
  "palier.motif": "Motif (obligatoire, écrit à l’historique du palier)",
  "palier.nonChange": "Palier non changé : la passerelle a refusé.",
  "palier.change": "Palier changé : {{palier}} · écrit à l’historique et à l’audit de {{org}}.",
  "palier.changer": "Changer de palier",
  "palier.releveTitre": "Relevé mensuel",
  "palier.mois": "Mois",
  "palier.releveChargement": "Lecture du relevé…",
  "palier.releveErreur": "Le relevé n’a pas pu être lu.",
  "palier.releveVide": "Aucune consommation relevée ce mois",
  "palier.releveVideIndice": "Le relevé se remplit des compteurs journaliers de l’organisation (usage_ledger).",
  "palier.legendeReleve": "Consommation du mois par compteur",
  "palier.col.compteur": "compteur",
  "palier.col.total": "total du mois",
  "palier.col.max": "pic journalier",
  "palier.col.jours": "jours",
  "palier.historique": "Historique du palier",
  "palier.historiqueVide": "Aucun changement : palier par défaut depuis la création.",
  "palier.legendeHistorique": "Changements de palier : quand, de, à, par, motif",
  "palier.col.quand": "quand",
  "palier.col.deA": "de → à",
  "palier.col.par": "par",
  "palier.col.motif": "motif",
  "palier.carteTitre": "Palier et relevé d’une organisation",
  "palier.organisation": "Organisation",
  "palier.chargementOrgs": "Chargement…",
  "palier.erreurOrgs": "La liste des organisations n’a pas pu être lue.",
  "palier.choisirOrg": "Choisissez une organisation pour lire et changer son palier.",
  "accesBandeau.region": "Accès exceptionnel de la plateforme",
  "accesBandeau.titre": "Accès exceptionnel de la plateforme en cours jusqu’à {{fin}}",
  "accesBandeau.detail": "en lecture seule, par {{qui}} : « {{motif}} ». Chaque consultation est écrite à votre audit.",
  "organisationsPlateforme.refus.motif": "Un motif de 10 caractères au moins est requis.",
  "organisationsPlateforme.refus.missions": "Choisissez le sort des missions en cours.",
  "organisationsPlateforme.refus.dejaSuspendue": "Organisation déjà suspendue.",
  "organisationsPlateforme.refus.pasSuspendue": "Organisation déjà active.",
  "organisationsPlateforme.refus.admin": "Réservé à l’administration de la plateforme.",
  "organisationsPlateforme.refus.introuvable": "Organisation introuvable.",
  "organisationsPlateforme.refus.inattendu": "La passerelle a refusé l’action.",
  "organisationsPlateforme.statut.active": "active",
  "organisationsPlateforme.statut.suspendue": "suspendue",
  "organisationsPlateforme.statut.provisionnement": "en provisionnement",
  "organisationsPlateforme.sante.ok": "saine",
  "organisationsPlateforme.sante.degradee": "dégradée",
  "organisationsPlateforme.sante.indisponible": "indisponible",
  "organisationsPlateforme.suspendreTitre": "Suspendre {{nom}}",
  "organisationsPlateforme.reactiverTitre": "Réactiver {{nom}}",
  "organisationsPlateforme.suspendreAide": "Réversible. Les membres passent en lecture seule aussitôt : toute écriture, nouvelle mission comprise, est refusée. {{n}} mission(s) en cours.",
  "organisationsPlateforme.reactiverAide": "Les membres retrouvent l’écriture. Les missions arrêtées ne reprennent pas d’elles-mêmes.",
  "organisationsPlateforme.suspendue": "Organisation suspendue ; {{n}} mission(s) arrêtée(s). Écrit à son audit.",
  "organisationsPlateforme.reactivee": "Organisation réactivée. Écrit à son audit.",
  "organisationsPlateforme.fermer": "Fermer",
  "organisationsPlateforme.missionsLegende": "Missions en cours",
  "organisationsPlateforme.laisserFinir": "Laisser finir ({{n}} min au plus, puis arrêt)",
  "organisationsPlateforme.arreterMaintenant": "Arrêter maintenant (l’étape en cours finit, rien d’autre ne démarre)",
  "organisationsPlateforme.motif": "Motif (obligatoire, écrit à l’historique et à l’audit de l’organisation)",
  "organisationsPlateforme.suspendre": "Suspendre",
  "organisationsPlateforme.reactiver": "Réactiver",
  "organisationsPlateforme.chargement": "Lecture des organisations…",
  "organisationsPlateforme.refusAcces": "La liste des organisations est réservée à l’administration de la plateforme.",
  "organisationsPlateforme.erreur": "Les organisations n’ont pas pu être lues.",
  "organisationsPlateforme.titre": "Organisations ({{n}})",
  "organisationsPlateforme.aide": "Attributs et agrégats seulement, jamais le contenu d’un projet. Toute action exige un motif et s’écrit à l’audit de l’organisation visée.",
  "organisationsPlateforme.vide": "Aucune organisation",
  "organisationsPlateforme.videIndice": "Provisionnez la première ci-dessous.",
  "organisationsPlateforme.legende": "Organisations : statut, palier, projets, membres, missions, consommation du mois, santé",
  "organisationsPlateforme.col.organisation": "organisation",
  "organisationsPlateforme.col.statut": "statut",
  "organisationsPlateforme.col.palier": "palier",
  "organisationsPlateforme.col.projets": "projets · membres",
  "organisationsPlateforme.col.missions": "missions en cours",
  "organisationsPlateforme.col.conso": "ce mois (jetons · appels IA)",
  "organisationsPlateforme.col.sante": "santé",
  "organisationsPlateforme.col.actions": "actions",
  "organisationsPlateforme.depuis": "depuis le {{quand}} · « {{motif}} »",
  "organisationsPlateforme.palierReleve": "Palier et relevé",
  "organisationsPlateforme.suspendreAction": "Suspendre…",
  "journalAudit.acteur": "Acteur",
  "journalAudit.typeAction": "Type d’action",
  "journalAudit.toutes": "toutes",
  "journalAudit.objet": "Objet (type:id ou id)",
  "journalAudit.du": "Du",
  "journalAudit.au": "Au (exclu)",
  "journalAudit.masquerBruit": "Masquer l’arrêt automatique d’environnement",
  "journalAudit.appliquer": "Filtrer",
  "journalAudit.legende": "Journal d’audit, du plus récent au plus ancien",
  "journalAudit.col.quand": "quand",
  "journalAudit.col.organisation": "organisation",
  "journalAudit.col.acteur": "acteur",
  "journalAudit.col.action": "action",
  "journalAudit.col.objet": "objet",
  "journalAudit.col.detail": "détail",
  "journalAudit.activite": "activité de job",
  "journalAudit.exporter": "Exporter (CSV)",
  "journalAudit.exportEchec": "Export refusé ou impossible.",
  "journalAudit.chargement": "Lecture du journal…",
  "journalAudit.refusProjet": "Le journal d’un projet est réservé à son propriétaire.",
  "journalAudit.refusOrganisation": "Le journal de toute l’organisation est réservé à son administration ; choisissez un projet dont vous êtes propriétaire.",
  "journalAudit.erreur": "Le journal d’audit n’a pas pu être lu.",
  "journalAudit.vide": "Aucune entrée pour ces filtres",
  "journalAudit.videIndice": "Le journal s’écrit à chaque action ; élargissez la période ou retirez un filtre.",
  "journalAudit.plage": "{{debut}}–{{fin}} sur {{total}}",
  "journalAudit.plusRecents": "Plus récents",
  "journalAudit.plusAnciens": "Plus anciens",
  "journalAudit.sansProjet": "Ouvrez un projet dont vous êtes propriétaire pour consulter son journal d’audit ; le journal de toute l’organisation est réservé à son administration.",
  "journalAudit.portee": "Portée",
  "journalAudit.porteeOrganisation": "toute l’organisation",
  "journalAudit.porteeProjet": "projet ouvert ({{id}})",
  "journalAudit.titre": "Journal d’audit",
  "journalAudit.organisation": "Organisation",
  "journalAudit.toutesOrganisations": "toutes",
  "journalAudit.titrePlateforme": "Actions de la plateforme sur les organisations",
  "provisionner.refus.emailExiste": "Un compte existe déjà pour cet e-mail : l’enrôlement exige une adresse NOUVELLE.",
  "provisionner.refus.emailInvalide": "E-mail invalide.",
  "provisionner.refus.identifiantPris": "Cet identifiant d’organisation est déjà pris.",
  "provisionner.refus.identifiantInvalide": "Identifiant : 3 à 50 caractères a-z, 0-9 et -, commençant par une lettre.",
  "provisionner.refus.conflit": "La base a refusé : rien n’a été créé, le compte a été supprimé.",
  "provisionner.refus.echec": "Provisionnement interrompu : rien n’a été créé.",
  "provisionner.refus.dejaActive": "L’administrateur a déjà activé son compte.",
  "provisionner.refus.nonRevocable": "Lien déjà utilisé ou déjà révoqué.",
  "provisionner.refus.admin": "Réservé à l’administration de la plateforme.",
  "provisionner.refus.inattendu": "La passerelle a refusé l’action.",
  "provisionner.statut.attente": "en attente",
  "provisionner.statut.active": "compte activé",
  "provisionner.statut.revoque": "révoqué",
  "provisionner.statut.expire": "expiré",
  "provisionner.emailEnvoye": "Keycloak envoie le lien d’activation à l’adresse de l’administrateur (valable jusqu’au {{fin}}).",
  "provisionner.lienTitre": "Lien d’activation — affiché UNE seule fois",
  "provisionner.lienAide": "Transmettez-le à l’administrateur par un canal sûr. Il choisira son mot de passe ; le lien sert une fois et expire le {{fin}}. Perdu ? Générez-en un nouveau : l’ancien sera révoqué.",
  "provisionner.copierLien": "Copier le lien",
  "provisionner.nomRequis": "Nom : 3 caractères au moins.",
  "provisionner.prenomRequis": "Prénom requis.",
  "provisionner.nomFamilleRequis": "Nom requis.",
  "provisionner.titre": "Provisionner une organisation",
  "provisionner.aide": "L’administrateur de l’organisation est créé avec un e-mail NOUVEAU (un compte existant est refusé). Il choisit lui-même son mot de passe par un lien d’activation à usage unique.",
  "provisionner.cree": "Organisation {{org}} créée ; administrateur {{email}} enrôlé (propriétaire de l’espace {{ws}}).",
  "provisionner.emailNonEnvoye": "L’e-mail d’activation n’a pas pu partir : générez un lien depuis la liste.",
  "provisionner.autre": "Provisionner une autre organisation",
  "provisionner.nom": "Nom de l’organisation",
  "provisionner.identifiant": "Identifiant (facultatif, ex. org-essai)",
  "provisionner.email": "E-mail de l’administrateur (nouveau)",
  "provisionner.prenom": "Prénom",
  "provisionner.nomFamille": "Nom",
  "provisionner.envoyer": "Provisionner et enrôler l’administrateur",
  "provisionner.liensTitre": "Activation de l’administrateur — {{nom}}",
  "provisionner.liensAide": "Un lien sert une fois et expire. Le jeton n’est jamais relisible : seul un nouveau lien peut être montré.",
  "provisionner.liensChargement": "Lecture des liens…",
  "provisionner.liensAucun": "Aucun administrateur enrôlé par la plateforme pour cette organisation.",
  "provisionner.expireLe": "expire le {{fin}}",
  "provisionner.revoquer": "Révoquer",
  "provisionner.fermer": "Fermer",
  "provisionner.nouveauLien": "Générer un nouveau lien",
  "activation.trop_court": "Au moins {{n}} caractères.",
  "activation.differents": "Les deux saisies diffèrent.",
  "activation.chargement": "Vérification du lien…",
  "activation.inconnu": "Ce lien d’activation est inconnu. Demandez un nouveau lien à l’administration de la plateforme.",
  "activation.erreur": "Le lien n’a pas pu être vérifié.",
  "activation.ok": "Compte activé. Connectez-vous avec {{identifiant}} et le mot de passe choisi.",
  "activation.seConnecter": "Se connecter",
  "activation.expire": "Ce lien a expiré.",
  "activation.revoque": "Ce lien a été révoqué.",
  "activation.utilise": "Ce lien a déjà servi : le compte est activé.",
  "activation.demander": "Demandez un nouveau lien à l’administration de la plateforme.",
  "activation.intro": "Administrateur de {{org}} ({{email}}) : choisissez votre mot de passe. Lien valable jusqu’au {{fin}}.",
  "activation.motDePasse": "Mot de passe (12 caractères au moins)",
  "activation.confirmation": "Confirmer le mot de passe",
  "activation.politique": "L’annuaire refuse ce mot de passe (politique de sécurité) : choisissez-en un plus solide.",
  "activation.refus": "Activation refusée : le lien n’est plus valide.",
  "activation.envoyer": "Activer mon compte",
  "activation.titre": "Activer votre compte DoIt",
  "organisationsPlateforme.activation": "Lien d’activation",
  "newWs.createdLaunchToast": "Projet créé — lancement inachevé : poursuivez l’assistant",
  "newWs.descriptionLancement": "Pas 1 sur 5 : identité et gabarit. Le projet existe dès ce pas, en « lancement inachevé » ; vous en devenez propriétaire et poursuivez le lancement (programme, choix technologiques, équipe).",
  "newWs.createAndLaunch": "Créer et poursuivre le lancement",
  "programs.techPlusTard": "Choix technologiques remis à plus tard : le programme hérite de tout le catalogue de l’organisation.",
  "adr.stack.fromBaseline": "Profil retenu par la baseline technologique v{{v}} du projet : il ne change que par une demande de changement.",
  "adr.stack.toBaseline": "Voir « Choix et baseline »",
  "missions.form.reprendreLancement": "Reprendre le lancement",
  "missions.form.voirBaseline": "Voir « Choix et baseline »",
  "missions.form.appBusySuspended": "Elle est suspendue en attente d’une décision humaine ({{n}} en attente) : ouvrez-la pour trancher ses arrêts — « Prendre acte de tous les arrêts et clore la mission » la termine — ou arrêtez-la.",
  "orgProjets.lancementsErreur": "Les lancements inachevés n’ont pas pu être lus.",
  "orgProjets.lancementsTitre": "Lancements inachevés",
  "orgProjets.enPreparation": "projet en préparation",
  "orgProjets.pasAtteint": "pas {{n}} sur 5",
  "orgProjets.reprendre": "Reprendre le lancement",
  "orgProjets.nouveau": "Nouveau projet",
  "lancement.sansProjet": "Aucun projet à lancer",
  "lancement.sansProjetIndice": "Créez un projet (« Nouveau projet ») ou reprenez un lancement inachevé depuis la liste des projets.",
  "lancement.chargement": "Lecture du lancement…",
  "lancement.refus": "Ce projet ne vous est pas ouvert.",
  "lancement.erreur": "Le lancement n’a pas pu être lu ; rien n’a changé.",
  "lancement.termine": "Lancement terminé",
  "lancement.termineIndice": "La baseline technologique v1 de ce projet existe ; elle ne change que par une demande de changement.",
  "lancement.voirBaseline": "Voir « Choix et baseline »",
  "lancement.titre": "Nouveau projet — lancement",
  "lancement.description": "Le projet existe dès le premier pas, en « lancement inachevé » ; la génération et la livraison restent refusées jusqu’à la fin du lancement.",
  "lancement.pas1": "Identité",
  "lancement.pas2": "Programme et gabarit",
  "lancement.pas3": "Choix technologiques",
  "lancement.pas4": "Équipe",
  "lancement.pas5": "Récapitulatif",
  "lancement.succes": "Lancement terminé — baseline v1 créée",
  "lancement.annoncePas": "Pas {{n}} sur {{total}} : {{nom}}",
  "lancement.parentProgramme": "la baseline du programme {{nom}}",
  "lancement.parentOrganisation": "catalogue de l’organisation",
  "lancement.enPreparation": "projet en préparation — lancement inachevé",
  "lancement.herite": "hérite de ◆ {{programme}}",
  "lancement.progression": "Progression du lancement",
  "lancement.titrePas": "Pas {{n}} sur {{total}} : {{nom}}",
  "lancement.echecBrouillon": "Le brouillon n’a pas pu être enregistré : {{message}}",
  "lancement.precedent": "Précédent",
  "lancement.enregistrerQuitter": "Enregistrer et quitter",
  "lancement.suivant": "Suivant : {{nom}}",
  "lancement.terminer": "Terminer le lancement",
  "lancement.inacheveAide": "Tant que le lancement n’est pas terminé, le projet reste « en préparation » : Concevoir et Planifier sont ouverts (sprint 0 possible), génération et livraison refusées.",
  "lancement.retourListe": "Retour aux projets",
  "lancement.nom": "Nom du projet",
  "lancement.identifiant": "Identifiant",
  "lancement.etat": "État",
  "lancement.etatInacheve": "lancement inachevé : le projet existe, ses membres peuvent cadrer et planifier ; générer et livrer attendent la fin du lancement.",
  "lancement.rattacheA": "Rattaché au programme",
  "lancement.heriteProgramme": "le pas « Choix technologiques » hérite de sa baseline (ou du catalogue de l’organisation si le programme n’en a pas).",
  "lancement.detacher": "Détacher",
  "lancement.programme": "Programme (facultatif)",
  "lancement.horsProgramme": "Hors programme : hériter du catalogue de l’organisation",
  "lancement.rattacher": "Rattacher",
  "lancement.rattacherRefus": "Rattacher un projet à ce programme revient à son propriétaire : demandez-le-lui, ou lancez le projet hors programme.",
  "lancement.gabarit": "Gabarit de configuration",
  "lancement.gabaritDefaut": "Par défaut (intégré)",
  "lancement.gabaritAide": "Choisi à la création ; il se change ensuite dans les réglages du projet (migration prévisualisée).",
  "lancement.quiObligatoire": "Indiquez l’identifiant ou le nom d’utilisateur du membre.",
  "lancement.membre": "Membre (identifiant ou nom d’utilisateur)",
  "lancement.role": "Rôle",
  "lancement.ajouter": "Ajouter",
  "lancement.equipeAide": "Facultatif : l’équipe se complète aussi plus tard (Réglages du projet).",
  "lancement.heritageChoisi": "Héritage choisi",
  "lancement.recapCaption": "Baseline v1 qui sera créée",
  "baseline.colCategorie": "Catégorie",
  "baseline.colValeur": "Valeur",
  "baseline.colSource": "Source",
  "baseline.colGenerabilite": "Générabilité",
  "baseline.aDefinir": "Catégorie obligatoire : à définir.",
  "lancement.profilRetenu": "Profil de génération retenu",
  "lancement.aucunProfil": "aucun (combinaison non couverte)",
  "lancement.catalogueIncompletAdmin": "Le jeu de départ propose encore {{n}} entrée(s) que votre catalogue n’a pas.",
  "lancement.catalogueVide": "Votre organisation n’a encore aucune technologie au catalogue.",
  "lancement.catalogueVideAdmin": "Utilisez le jeu de départ : les langages, frameworks, bases de données et plateformes cibles (web, mobile, bureau) que la plateforme sait générer, avec leur générabilité mesurée. Vous restez dans l’assistant.",
  "lancement.catalogueVideMembre": "Demandez à votre administratrice ou administrateur d’organisation d’utiliser le jeu de départ du catalogue technologique. En attendant, « Définir » permet de saisir une valeur hors catalogue pour ce projet.",
  "lancement.voirCatalogue": "Voir le catalogue technologique de l’organisation",
  "pgmTech.cree": "Choix technologiques du programme « {{nom}} » fixés — baseline v1",
  "pgmTech.pasTitre": "Choix technologiques du programme « {{nom}} »",
  "pgmTech.parentOrganisation": "catalogue de l’organisation",
  "pgmTech.plusTard": "Plus tard (tout hériter de l’organisation)",
  "pgmTech.valider": "Fixer les choix (baseline v1)",
  "pgmTech.chargement": "Lecture des choix technologiques du programme…",
  "pgmTech.refus": "Ce programme ne vous est pas ouvert : ses membres lisent ses choix technologiques.",
  "pgmTech.erreur": "Choix technologiques illisibles : la passerelle n’a pas répondu.",
  "pgmTech.titre": "Choix technologiques du programme",
  "pgmTech.description": "Le standard du programme par catégorie, hérité du catalogue de l’organisation ; les projets rattachés en héritent, ou définissent la catégorie eux-mêmes.",
  "pgmTech.baselineTitre": "Baseline — {{nom}} · v{{v}}",
  "pgmTech.versionDe": "v{{v}} du {{date}} · auteur {{auteur}}",
  "pgmTech.tableCaption": "Standard du programme par catégorie",
  "pgmTech.ouverte": "non fixée au programme : chaque projet la définit",
  "pgmTech.standard": "standard du programme",
  "pgmTech.modifierAVenir": "Modifier le standard (demande de changement ou propagation aux projets héritiers) : lot suivant de la 0.5.x.",
  "pgmTech.vide": "Aucun choix propre au programme",
  "pgmTech.videIndice": "Tout est hérité du catalogue de l’organisation ; chaque projet rattaché choisit au lancement.",
  "pgmTech.definir": "Fixer les choix du programme (v1)",
  "pgmTech.ecartsTitre": "Écarts des projets",
  "pgmTech.ecartsSansStandard": "Sans standard de programme, aucun écart à mesurer.",
  "pgmTech.aucunEcart": "Aucun projet rattaché ne s’écarte du standard.",
  "pgmTech.ecartsCaption": "Projets qui s’écartent du standard du programme",
  "pgmTech.colProjet": "projet",
  "pgmTech.colEcart": "écart",
  "pgmTech.colEtat": "état",
  "pgmTech.ecartLigne": "{{categorie}} : {{projet}} au lieu de {{programme}}",
  "pgmTech.ecartsMasques": "{{n}} projet(s) qui ne vous sont pas ouverts s’écartent aussi du standard — comptés, jamais nommés.",
  "baseline.combinaisonTitre": "Générabilité de la combinaison",
  "baseline.generableColonie": "générable par la colonie",
  "baseline.profilCouvrant": "profil de génération {{profil}}",
  "baseline.profilNonQualifie": "profil non qualifié",
  "baseline.nonGenerable": "non générable",
  "baseline.nonQualifieDetail": "le profil {{profil}} couvre la combinaison mais n’est pas qualifié : {{motif}}",
  "baseline.nonCouvertDetail": "aucun profil de génération ne couvre : {{produits}}",
  "baseline.nonCombineDetail": "aucun profil ne couvre ces produits ensemble : {{produits}}",
  "baseline.consequences": "Conséquences, dites avant le lancement :",
  "baseline.consequence1": "aucune mission « Générer l’application » (refus « combinaison non couverte par un profil de génération qualifié ») ;",
  "baseline.consequence2": "restent possibles cadrage, spécification, backlog, tests et livraison manuelle (publication, pipelines, déploiement) ;",
  "baseline.consequence3": "mode A (adaptateur d’agent, expérimental) seulement si le gabarit et la gouvernance le permettent.",
  "baseline.proche": "Plus proche combinaison générable : {{profil}} sans {{sans}} (proposée, jamais imposée).",
  "baseline.procheProfil": "Plus proche combinaison générable : {{profil}} (proposée, jamais imposée).",
  "baseline.livraisonManuelle": "Livraison manuelle assumée (règle le signal de santé « Générabilité »)",
  "baseline.sansProjet": "Aucun projet choisi",
  "baseline.sansProjetIndice": "Choisissez un projet dans le sélecteur de contexte.",
  "baseline.chargement": "Lecture de la baseline technologique…",
  "baseline.refus": "La baseline de ce projet ne vous est pas ouverte.",
  "baseline.erreur": "Baseline illisible : la passerelle n’a pas répondu ; rien n’a changé.",
  "baseline.titre": "Choix et baseline",
  "baseline.description": "La baseline technologique du projet : par catégorie, la valeur retenue, sa source, sa générabilité ; elle ne change que par une demande de changement.",
  "baseline.inachevee": "Lancement inachevé : pas encore de baseline",
  "baseline.inacheveeIndice": "La baseline v1 naît à la fin du lancement. D’ici là, génération et livraison sont refusées ; Concevoir et Planifier restent ouverts.",
  "baseline.reprendre": "Reprendre le lancement",
  "baseline.reprendreProprietaire": "Le propriétaire ou un contributeur reprend le lancement.",
  "baseline.absente": "Aucune baseline technologique",
  "baseline.absenteIndice": "Projet créé hors de l’assistant de lancement : sa génération suit encore son profil de pile (ADR). Définir sa baseline v1 passe par le pas « Choix technologiques ».",
  "baseline.definirV1": "Définir la baseline v1",
  "baseline.region1": "① Baseline v{{v}} courante",
  "baseline.versionDu": "baseline v{{v}} · {{date}}",
  "baseline.produitePar": "produite par : {{origine}}, auteur {{auteur}}",
  "baseline.heritageChoisi": "Héritage choisi au lancement : {{h}}",
  "baseline.profilRetenu": "Profil de génération retenu (lu par le générateur)",
  "baseline.aucunProfil": "aucun — combinaison non couverte",
  "baseline.livraisonAssumee": "livraison manuelle assumée",
  "baseline.repriseManques": "Reprise d’un projet existant : la pile vient de son profil ({{base}}) ; les catégories obligatoires qu’il n’apportait pas restent à compléter par une demande de changement — aucune valeur n’a été inventée.",
  "baseline.baseDefaut": "profil par défaut du générateur",
  "baseline.baseAdr": "ADR de pile décidée",
  "baseline.modifier": "Modifier…",
  "baseline.changementsAVenir": "Demandes de changement, verrou de catégorie et propagation : lot suivant de la 0.5.x. Aucune demande en cours sur ce projet.",
  "baseline.tableCaption": "Baseline technologique par catégorie",
  "baseline.colRetenue": "Valeur retenue",
  "baseline.colCatalogue": "Catalogue",
  "baseline.colEcart": "Écart",
  "baseline.obligatoire": "obligatoire",
  "baseline.horsCatalogueCourt": "hors catalogue",
  "baseline.aCompleter": "obligatoire, à compléter",
  "baseline.ecartImposee": "écart à l’entrée imposée {{p}} : dérogation attendue",
  "baseline.region2": "② Héritage par catégorie — organisation → programme → projet",
  "baseline.sansProgramme": "Projet hors programme : organisation → projet, sans standard de programme.",
  "baseline.chaineCaption": "Chaîne d’héritage par catégorie",
  "baseline.colOrganisation": "Organisation (imposée)",
  "baseline.colProgramme": "Programme {{nom}}",
  "baseline.colProjet": "Projet",
  "baseline.auChoix": "au choix",
  "baseline.region3": "③ Historique et différence",
  "baseline.historiqueCaption": "Versions de la baseline",
  "baseline.colVersion": "version",
  "baseline.colDate": "date",
  "baseline.colProduitePar": "produite par",
  "baseline.colAuteur": "auteur",
  "baseline.v1Seule": "Une seule version : la v1 du lancement, rien à comparer.",
  "baseline.versionDepart": "Version de départ",
  "baseline.versionArrivee": "Version d’arrivée",
  "baseline.comparer": "Comparer",
  "baseline.aucuneDifference": "Aucune différence entre ces versions.",
  "baseline.differenceCaption": "Différence entre deux versions",
  "baseline.heriterDe": "Hériter de {{parent}}",
  "baseline.aideProjet": "« Ne pas hériter » ne soustrait pas le projet à une entrée imposée : la remplacer demande une dérogation. Une catégorie définie peut citer l’ADR du projet qui la fonde.",
  "baseline.aideProgramme": "Le standard du programme est une entrée autorisée ou imposée du catalogue ; une catégorie héritée sans valeur imposée reste au choix de chaque projet.",
  "baseline.choixCaption": "Choix technologiques par catégorie",
  "baseline.valeursPour": "Valeurs pour {{categorie}}",
  "baseline.aucuneEntree": "Aucune entrée au catalogue pour cette catégorie.",
  "baseline.valeurPour": "Valeur pour {{categorie}}",
  "baseline.laisserAuxProjets": "Non fixée au programme : chaque projet la définit",
  "baseline.choisir": "Choisir une entrée…",
  "baseline.integre": "Intégré à la pile générée (aucun produit tiers)",
  "baseline.horsCatalogue": "Hors catalogue…",
  "baseline.produitPour": "Produit pour {{categorie}}",
  "baseline.produitExemple": "ex. Authentik",
  "baseline.versionPour": "Version pour {{categorie}}",
  "baseline.versionExemple": "ex. 2024.8",
  "baseline.facultative": "facultative",
  "baseline.sensible": "sensible",
  "baseline.plancher": "plancher de plateforme",
  "baseline.horsGeneration": "hors génération",
  "baseline.imposeePar": "imposée par l’organisation : {{produits}}",
  "baseline.sourcePour": "Source pour {{categorie}}",
  "baseline.heriter": "Hériter",
  "baseline.definir": "Définir",
  "baseline.aDefinirCourt": "à définir",
  "baseline.heritage.all": "Tout hériter",
  "baseline.heritage.partial": "Hériter en partie (par catégorie)",
  "baseline.heritage.none": "Ne pas hériter",
  "baseline.source.organisation": "héritée de l’organisation",
  "baseline.source.programme": "héritée du programme",
  "baseline.source.projet": "choix du projet",
  "baseline.source.reprise": "reprise d’ADR-0109",
  "baseline.gen.generable": "générable",
  "baseline.gen.nonQualifiee": "profil non qualifié",
  "baseline.gen.nonCouverte": "non générable",
  "baseline.gen.integre": "intégré à la pile",
  "baseline.gen.execution": "fourni à l’exécution",
  "baseline.origine.lancement": "lancement du projet",
  "baseline.origine.reprise": "reprise d’ADR-0109 (projet antérieur à la 0.5.x)",
  "baseline.origine.chg": "demande de changement {{ref}}",
  "baseline.origine.prop": "propagation reçue {{ref}}",
  "baseline.r.manquante": "Catégorie obligatoire sans valeur : {{categories}}. Définissez-la avant de terminer.",
  "baseline.r.unique": "Catégorie à choix unique : une seule valeur.",
  "baseline.r.imposee": "« {{produit}} » est imposé par l’organisation : le remplacer demande une dérogation (motif, échéance, approbation).",
  "baseline.r.retiree": "Entrée retirée du catalogue : la retenir demande une dérogation.",
  "baseline.r.nonAutorisee": "Entrée non autorisée par l’organisation pour cette catégorie (à l’étude) ou valeur hors catalogue là où seul le catalogue est permis.",
  "baseline.r.nonAssumee": "Combinaison non couverte par un profil de génération qualifié : cochez « Livraison manuelle assumée » pour terminer.",
  "baseline.r.immuable": "La baseline existe : elle ne change que par une demande de changement approuvée ou une propagation.",
  "baseline.r.changement": "La baseline ne s’écrit jamais directement : « Modifier… » ouvre une demande de changement.",
  "baseline.r.inacheve": "Lancement inachevé : terminez le lancement avant de générer ; cadrage, spécification et backlog restent ouverts.",
  "baseline.r.nonGenerable": "Combinaison non couverte par un profil de génération qualifié : la génération par la colonie est refusée ; cadrage, spécification, backlog, tests et livraison manuelle restent possibles.",
  "baseline.r.horsBaseline": "Génération hors baseline : la pile demandée n’est pas le profil retenu par la baseline.",
  "baseline.r.ecriture": "Lecture seule : le propriétaire ou un contributeur du projet mène le lancement.",
  "baseline.r.programme": "Lecture seule : le propriétaire du programme fixe ses choix technologiques.",
  "pgmTech.adrs": "ADR de programme",
  "pgmTech.adrsChargement": "Lecture des ADR du programme…",
  "pgmTech.adrsErreur": "Les ADR du programme n’ont pas pu être lues.",
  "pgmTech.adrsVide": "Aucune ADR de programme",
  "pgmTech.adrsVideAide": "Une ADR de programme fonde un standard du programme (ex. SQLite pour les caisses).",
  "pgmTech.adrsCaption": "ADR de portée programme",
  "pgmTech.adrTitre": "Titre",
  "pgmTech.adrStatut": "Statut",
  "pgmTech.nouvelleAdr": "Nouvelle ADR de programme",
  "cout.aide": "Minutes de GPU mesurées sur les événements « coût » du tableau noir. « Estimé au plan » (la reine) et « consommé » sont deux colonnes, jamais additionnées.",
  "cout.casteCaption": "Minutes de GPU par caste : estimé, consommé et écart",
  "cout.casteVide": "Aucune caste n’a encore travaillé sur cette mission.",
  "cout.chargement": "Agrégation des événements « coût »…",
  "cout.colCaste": "Caste",
  "cout.colEcart": "Écart (consommé − estimé)",
  "cout.colEtat": "État",
  "cout.colModele": "Modèle",
  "cout.colModeles": "Modèles",
  "cout.colRang": "Rang",
  "cout.colTache": "Tâche",
  "cout.colTaches": "Tâches",
  "cout.colTour": "Tour",
  "cout.colTours": "Tours",
  "cout.colTrace": "Trace",
  "cout.consomme": "Consommé",
  "cout.consommeNote": "mesuré sur les événements « coût » du tableau noir · budget {{b}} min",
  "cout.erreur": "Coût du projet illisible : {{m}}",
  "cout.estime": "Estimé au plan",
  "cout.estimeIncomplet": "somme des estimations de la reine pour {{n}} tâche(s) ; {{s}} sans estimation",
  "cout.estimeNote": "somme des estimations de la reine pour les {{n}} tâche(s)",
  "cout.minutes": "{{n}} min",
  "cout.mission": "Mission",
  "cout.missionsCaption": "Minutes de GPU par mission : estimé au plan et consommé",
  "cout.onglet.caste": "Par caste",
  "cout.onglet.mission": "Par mission",
  "cout.onglet.tache": "Par tâche",
  "cout.onglet.tour": "Par tour",
  "cout.onglets": "Ventilation du coût",
  "cout.outilTraces": "Ouvrir l’outil de traces",
  "cout.tacheCaption": "Minutes de GPU par tâche ; choisir une tâche ouvre sa vue par tour",
  "cout.tacheVide": "La reine n’a pas encore planifié de tâche pour cette mission.",
  "cout.titre": "Coût et traces",
  "cout.totaux": "Totaux dans leur colonne : {{e}} min estimées, {{c}} min consommées — jamais une somme des deux.",
  "cout.tourCaption": "Minutes de GPU par tour et lien vers la trace",
  "cout.tourSansTache": "Aucune tâche n’a encore consommé de minutes : choisissez une tâche dans « Par tâche ».",
  "cout.tourVide": "Aucun tour mesuré pour cette tâche.",
  "cout.toursTitre": "Tâche {{k}} « {{titre}} » — par tour",
  "cout.trace": "Trace",
  "cout.traceDuTour": "Trace du tour {{n}}",
  "cout.tracesNonConfigurees": "Le service de traces n’est pas configuré sur cette installation : les liens « Trace » sont désactivés ; les minutes restent lues sur le tableau noir.",
  "cout.tracesNonInstrumentees": "Le service de traces est configuré, mais aucun tour n’y est encore relié : les liens « Trace » sont désactivés ; les minutes restent lues sur le tableau noir.",
  "cout.tracesTitre": "Traces indisponibles",
  "cout.vide": "Aucune minute de GPU consommée",
  "cout.videAide": "Aucune mission n’a encore tourné dans ce projet : le coût se lira ici dès la première.",
  "design.background.blanc": "Blanc",
  "design.background.chaud": "Beige chaud",
  "design.background.froid": "Gris bleuté",
  "design.background.neutre": "Gris neutre",
  "design.background.personnalisee": "Autre fond",
  "design.backToDesign": "← Retour au design",
  "design.charter.background": "Fond de page",
  "design.charter.canvasLabel": "Couleur du fond (#rrggbb)",
  "design.charter.canvasRequired": "Saisissez la couleur du fond de page au format #rrggbb (par exemple #f3f1ec).",
  "design.charter.corners": "Angles",
  "design.charter.inheritanceUnknown": "L’héritage de la charte de l’organisation n’a pas pu être lu : la validation attend qu’il le soit (voir « Charte de l’organisation » ci-dessus).",
  "design.charter.originOverride": "propre au projet (surcharge)",
  "design.charter.saveRefused2": "Enregistrement impossible : contraste insuffisant sur {{count}} paire(s) ci-dessus. Choisissez une couleur principale plus foncée ou un fond de page plus clair.",
  "design.charter.validateNeedsOverride": "La charte de l’organisation (v{{version}}, {{mode}}) s’applique à ce projet : demandez d’abord une surcharge, avec son motif, dans « Charte de l’organisation » ci-dessus.",
  "design.charter.warningsCount": "{{count}} paire(s) tout juste lisible(s)",
  "design.comparison.application": "Application en marche",
  "design.comparison.captureAlt": "Capture de l’écran « {{name}} » de l’application",
  "design.comparison.counts": "{{major}} majeur(s), {{minor}} mineur(s), {{info}} info · {{compared}}/{{expected}} écran(s) comparé(s) · {{who}}, {{date}}",
  "design.comparison.detailDescription": "Chaque écran du parcours validé, côte à côte, et ses écarts. Un avis versé au dossier : il ne bloque rien.",
  "design.comparison.detailTitle": "Maquette ↔ application",
  "design.comparison.elements": "Éléments lus de part et d’autre",
  "design.comparison.empty": "Aucune comparaison versée au dossier.",
  "design.comparison.emptyHint": "Choisissez une révision en marche, puis « Comparer à la maquette ».",
  "design.comparison.emptyHintReader": "Un contributeur du projet verse les comparaisons.",
  "design.comparison.filed": "Versée au dossier par {{who}} le {{date}} — avis, jamais une porte.",
  "design.comparison.gaps": "Écarts",
  "design.comparison.intro": "Chaque écran du parcours validé, maquette et application côte à côte : boutons, liens et champs absents ou en plus, titre, couleurs calculées hors charte. L’avis est versé au dossier ; il ne bloque rien.",
  "design.comparison.invalidId": "Adresse invalide : aucune comparaison ne porte cet identifiant.",
  "design.comparison.line": "{{app}} · révision {{rev}} · parcours v{{flow}}",
  "design.comparison.loading": "Chargement des comparaisons…",
  "design.comparison.loadingOne": "Chargement de la comparaison…",
  "design.comparison.needFlow": "Aucun parcours d’écrans validé : il n’y a pas de maquette de référence. Validez d’abord le parcours et ses maquettes.",
  "design.comparison.needSurvey": "Aucune révision relevée : démarrez l’aperçu d’une révision, le relevé mesure l’application en marche.",
  "design.comparison.noGap": "aucun écart",
  "design.comparison.noGapLong": "Aucun écart relevé sur cet écran.",
  "design.comparison.noScreen": "L’écran ne répond pas dans l’application.",
  "design.comparison.noWireframe": "Aucune maquette validée pour cet écran.",
  "design.comparison.noWorkspaceHint": "Une comparaison appartient à un projet.",
  "design.comparison.opinion.aligned": "conforme à la maquette",
  "design.comparison.opinion.major": "écarts majeurs",
  "design.comparison.opinion.minor": "écarts mineurs",
  "design.comparison.opinion.nothing": "rien à comparer",
  "design.comparison.pageTitle": "Titre : {{title}}",
  "design.comparison.revision": "Révision en marche",
  "design.comparison.run": "Comparer à la maquette",
  "design.comparison.severity.info": "info",
  "design.comparison.severity.major": "majeur",
  "design.comparison.severity.minor": "mineur",
  "design.comparison.sideMissing": "Rien de lu de ce côté.",
  "design.comparison.summaryTitle": "{{app}} · révision {{rev}} · parcours v{{flow}}",
  "design.comparison.title": "Maquette ↔ application",
  "design.comparison.width": "Largeur des captures",
  "design.comparison.wireframe": "Maquette validée",
  "design.contrast.marginalPair": "Tout juste lisible — {{label}} : {{ratio}} (minimum {{minimum}}). Conforme, mais difficile à lire en plein soleil ou sur un écran mal réglé.",
  "design.corners.auto": "Selon la typographie",
  "design.corners.doux": "Arrondis",
  "design.corners.droits": "Angles droits",
  "design.corners.legers": "Légèrement arrondis",
  "design.corners.ronds": "Très arrondis",
  "design.enforcement.allowed": "recommandée",
  "design.enforcement.allowedShort": "recommandée",
  "design.enforcement.inForce": "imposée",
  "design.enforcement.inForceShort": "imposée",
  "design.inheritance.askOverride": "Surcharger la charte de l’organisation",
  "design.inheritance.askWaiver": "Demander une dérogation à la charte imposée",
  "design.inheritance.effective": "La génération applique {{source}}.",
  "design.inheritance.expiryOptionalLabel": "Échéance (facultative, 180 jours au plus)",
  "design.inheritance.expiryRequiredLabel": "Échéance (obligatoire, 180 jours au plus)",
  "design.inheritance.history": "Historique des surcharges du projet",
  "design.inheritance.historyEmpty": "Aucune surcharge : le projet n’a jamais dérogé à la charte de l’organisation.",
  "design.inheritance.lapsed": "La dérogation du projet est échue : la charte de l’organisation s’applique de nouveau. Demandez-en une nouvelle si le motif tient toujours.",
  "design.inheritance.loading": "Chargement de l’héritage de la charte…",
  "design.inheritance.none": "L’organisation n’a pas de charte validée : la charte du projet s’applique telle quelle.",
  "design.inheritance.open": "Surcharge en cours",
  "design.inheritance.openOrg": "Voir la charte de l’organisation",
  "design.inheritance.openVersion": "Voir cette version",
  "design.inheritance.orgAllowed": "L’organisation recommande sa charte v{{version}} ({{semver}}) : le projet l’hérite ; la surcharger est possible, avec un motif tracé.",
  "design.inheritance.orgInForce": "L’organisation impose sa charte v{{version}} ({{semver}}) : la surcharger est une dérogation, avec échéance, décidée par l’administration de l’organisation.",
  "design.inheritance.readOnly": "Demander ou terminer une surcharge est réservé aux contributeurs et propriétaires du projet.",
  "design.inheritance.reasonLabel": "Motif (pourquoi ce projet a sa propre charte)",
  "design.inheritance.return": "Revenir à la charte de l’organisation",
  "design.inheritance.sourceDefault": "la charte par défaut de la plateforme (aucune charte validée)",
  "design.inheritance.sourceOrganisation": "la charte de l’organisation (v{{version}}, {{semver}}), héritée",
  "design.inheritance.sourceOverride": "la charte du projet (v{{version}}, {{semver}}), sous surcharge",
  "design.inheritance.sourceProject": "la charte du projet (v{{version}}, {{semver}})",
  "design.inheritance.submitOverride": "Surcharger",
  "design.inheritance.submitWaiver": "Demander la dérogation",
  "design.inheritance.title": "Charte de l’organisation",
  "design.inheritance.waiting": "En attente de la décision de l’administration de l’organisation ; d’ici là, la charte de l’organisation s’applique.",
  "design.inheritance.withdraw": "Retirer la demande",
  "design.override.decided": "Décidée par {{who}} le {{date}}",
  "design.override.decisionComment": "Commentaire de décision (obligatoire pour refuser)",
  "design.override.end.expired": "échéance passée",
  "design.override.end.returned": "retour à la charte de l’organisation",
  "design.override.end.superseded": "caduque : la charte de l’organisation a changé",
  "design.override.end.withdrawn": "demande retirée",
  "design.override.ended": "Close le {{date}} par {{who}} : {{reason}}",
  "design.override.expires": "échéance {{date}}",
  "design.override.expiryPast": "L’échéance est dans le futur (demain au plus tôt).",
  "design.override.expiryRequired": "La charte de l’organisation est imposée : une dérogation a une échéance obligatoire.",
  "design.override.expiryTooFar": "Une surcharge dure 180 jours au plus : la question se repose à l’échéance.",
  "design.override.grant": "Accorder la dérogation",
  "design.override.kindOverride": "Surcharge",
  "design.override.kindWaiver": "Dérogation",
  "design.override.meta": "Vise la charte de l’organisation v{{version}} ({{mode}}) · demandée par {{who}} le {{date}}",
  "design.override.reason": "Motif : {{reason}}",
  "design.override.reasonTooShort": "Écrivez le motif (10 caractères au moins) : pourquoi la charte de l’organisation ne convient pas à ce projet.",
  "design.override.refuse": "Refuser",
  "design.override.refuseNeedsComment": "Un refus se motive : écrivez le commentaire avant de refuser.",
  "design.override.selfDecision": "Vous avez demandé cette dérogation : une autre personne de l’administration de l’organisation doit la décider.",
  "design.override.status.active": "surcharge active",
  "design.override.status.activeWaiver": "dérogation accordée",
  "design.override.status.ended": "close",
  "design.override.status.lapsed": "échue",
  "design.override.status.refused": "refusée",
  "design.override.status.requested": "dérogation demandée",
  "design.usability.addObservation": "Ajouter une observation",
  "design.usability.anyTask": "toutes",
  "design.usability.cancel": "Annuler",
  "design.usability.chooseRequirement": "— choisir une exigence du parcours validé —",
  "design.usability.chooseVerdict": "— choisir —",
  "design.usability.conclusion": "Conclusion (facultative)",
  "design.usability.counts": "{{planned}} prévu(s) · {{completed}} réalisé(s) · {{waived}} dérogé(s)",
  "design.usability.createdLine": "Prévu par {{who}} le {{date}}",
  "design.usability.criterion": "Critère de réussite (facultatif)",
  "design.usability.criterionLine": "Critère de réussite : {{c}}",
  "design.usability.date": "Date de la séance",
  "design.usability.dateFuture": "Une séance ne se déclare pas avant d’avoir eu lieu.",
  "design.usability.detailDescription": "Protocole court, résultat de la séance ou dérogation motivée (ART-0172 DES-09).",
  "design.usability.detailTitle": "Test d’usage",
  "design.usability.empty": "Aucun test d’usage pour ce projet.",
  "design.usability.emptyHint": "Prévoyez-en un pour chaque exigence d’usage.",
  "design.usability.intro": "Un protocole court : 3 à 5 personnes du métier accomplissent les tâches d’une exigence d’usage, et vous notez ce qui se passe. S’il n’a pas lieu, la dérogation se motive.",
  "design.usability.invalidId": "Adresse invalide : aucun test d’usage ne porte cet identifiant.",
  "design.usability.line": "Exigence {{ref}}{{label}} · {{count}} participant(s) prévu(s) · créé le {{date}}",
  "design.usability.loading": "Chargement des tests d’usage…",
  "design.usability.loadingOne": "Chargement du test d’usage…",
  "design.usability.needDate": "Indiquez la date de la séance.",
  "design.usability.needObservation": "Notez au moins une observation : ce que les participants ont fait, dit ou cherché.",
  "design.usability.needProfile": "Dites qui sont les participants (par exemple « vendeurs saisonniers »).",
  "design.usability.needRequirement": "Choisissez l’exigence d’usage que ce test vérifie (par exemple REQ-12).",
  "design.usability.needResults": "Pour chaque tâche, indiquez combien de participants l’ont réussie (0 à {{max}}).",
  "design.usability.needScenario": "Décrivez le scénario (10 caractères au moins) : la situation que vivent les participants.",
  "design.usability.needTasks": "Écrivez 1 à 10 tâches, une par ligne.",
  "design.usability.needTitle": "Donnez un titre au test.",
  "design.usability.needVerdict": "Choisissez le verdict.",
  "design.usability.notesCol": "Notes",
  "design.usability.noWorkspaceHint": "Un test d’usage appartient à un projet.",
  "design.usability.observation": "Observation {{n}}",
  "design.usability.observations": "Observations",
  "design.usability.observationTask": "Tâche",
  "design.usability.outcome": "Résultat",
  "design.usability.outcomeLine": "Séance du {{date}}, {{count}} participant(s) ; saisi par {{who}} le {{at}}.",
  "design.usability.participants": "Participants prévus",
  "design.usability.participantsActual": "Participants réels",
  "design.usability.participantsLine": "{{count}} participant(s) prévu(s) : {{profile}}",
  "design.usability.perTask": "Réussites par tâche",
  "design.usability.plan": "Prévoir un test d’usage",
  "design.usability.profile": "Profil des participants",
  "design.usability.protocol": "Protocole",
  "design.usability.recordResult": "Enregistrer le résultat ou déroger",
  "design.usability.requirement": "Exigence d’usage vérifiée",
  "design.usability.requirementLine": "Exigence d’usage : {{ref}}{{label}}",
  "design.usability.requirementPlaceholder": "REQ-12",
  "design.usability.resultTitle": "Résultat de la séance",
  "design.usability.save": "Enregistrer le test prévu",
  "design.usability.saveResult": "Enregistrer le résultat (définitif)",
  "design.usability.scenario": "Scénario (la situation des participants)",
  "design.usability.severity.blocking": "bloquant",
  "design.usability.severity.info": "information",
  "design.usability.severity.major": "gêne majeure",
  "design.usability.severity.minor": "gêne mineure",
  "design.usability.severityLabel": "Gravité",
  "design.usability.status.completed": "réalisé",
  "design.usability.status.planned": "prévu",
  "design.usability.status.waived": "dérogé",
  "design.usability.succeeded": "Réussie par (sur {{max}})",
  "design.usability.successCol": "Réussites",
  "design.usability.taskCol": "Tâche",
  "design.usability.taskNotes": "Notes (facultatives)",
  "design.usability.tasks": "Tâches, une par ligne (10 au plus)",
  "design.usability.title": "Tests d’usage",
  "design.usability.titleLabel": "Titre",
  "design.usability.verdict.failed": "échoué",
  "design.usability.verdict.partial": "partiel",
  "design.usability.verdict.passed": "réussi",
  "design.usability.verdictLabel": "Verdict",
  "design.usability.waive": "Déroger (définitif)",
  "design.usability.waived": "Dérogation",
  "design.usability.waivedLine": "Dérogé par {{who}} le {{date}}",
  "design.usability.waiverIntro": "Si la séance n’aura pas lieu, dites-le avec son motif : l’exigence n’est pas réputée vérifiée en silence.",
  "design.usability.waiverReason": "Motif de la dérogation",
  "design.usability.waiverTitle": "Déroger au test",
  "design.usability.waiverTooShort": "Le motif d’une dérogation compte 20 caractères au moins : pourquoi le test n’a pas lieu, et ce qui en tient lieu.",
  "indicateurs.delai.chargement": "Calcul du délai idée → livré…",
  "indicateurs.delai.delai": "Délai",
  "indicateurs.delai.demande": "Demande",
  "indicateurs.delai.deployee": "Déployée au palier le plus haut",
  "indicateurs.delai.deposee": "Idée déposée",
  "indicateurs.delai.enCours": "en cours",
  "indicateurs.delai.enCoursAge": "en cours ({{age}})",
  "indicateurs.delai.erreur": "Le délai idée → livré n’a pas pu être calculé.",
  "indicateurs.delai.livrees": "Demandes livrées sur {{jours}} j : {{nombre}}",
  "indicateurs.delai.mediane": "Médiane idée → livré",
  "indicateurs.delai.p85": "85e centile",
  "indicateurs.delai.tableau": "Demandes livrées et en cours",
  "indicateurs.delai.titre": "Délai idée → livré",
  "indicateurs.delai.vide": "Aucune demande livrée",
  "indicateurs.delai.videIndice": "La filiation demande → déploiement n’a encore rien relié.",
  "indicateurs.detailTechnique": "Détail technique",
  "indicateurs.efficacite.caste": "Caste",
  "indicateurs.efficacite.chargement": "Calcul de l’efficacité par caste et modèle…",
  "indicateurs.efficacite.erreur": "L’efficacité par caste et modèle n’a pas pu être calculée.",
  "indicateurs.efficacite.mention": "Minutes GPU consommées (jamais additionnées aux estimées) · {{jours}} derniers jours · missions : {{missions}}.",
  "indicateurs.efficacite.minutes": "Minutes GPU consommées",
  "indicateurs.efficacite.modele": "Modèle",
  "indicateurs.efficacite.premierTour": "Réussies au 1er tour",
  "indicateurs.efficacite.tableau": "Efficacité par caste et modèle",
  "indicateurs.efficacite.taches": "Tâches",
  "indicateurs.efficacite.tauxDetail": "{{num}} sur {{den}}",
  "indicateurs.efficacite.titre": "Efficacité par caste et modèle",
  "indicateurs.efficacite.toursMoyens": "Tours moyens",
  "indicateurs.efficacite.vide": "Aucune mission terminée",
  "indicateurs.efficacite.videIndice": "Les tâches se comptent à la fin de chaque mission.",
  "indicateurs.jours": "{{valeur}} j",
  "indicateurs.mesuresPasObjectifs": "Ce sont des mesures, pas des objectifs de service : ni vert, ni ambre, ni rouge.",
  "indicateurs.minutes": "{{valeur}} min",
  "indicateurs.na": "n/a",
  "indicateurs.periode": "Période",
  "indicateurs.periodeJours": "{{jours}} derniers jours",
  "indicateurs.pourcent": "{{valeur}} %",
  "nav./org/charte": "Charte de l’organisation",
  "navdesc./org/charte": "La charte graphique que les projets héritent : recommandée ou imposée, et ses dérogations",
  "org.charter.back": "← Toutes les versions",
  "org.charter.changeWarning": "Les surcharges en cours de l’autre régime deviennent caduques : leurs projets reviennent à la charte de l’organisation.",
  "org.charter.choicesLine": "Couleur principale : {{primary}} · fond de page : {{canvas}} · typographie : {{typo}} · densité : {{density}} · angles : {{corners}} · voix : {{voice}}",
  "org.charter.contrast": "Contraste vérifié (WCAG 2.2 AA)",
  "org.charter.current": "Version appliquée aux projets",
  "org.charter.description": "La charte graphique que les projets héritent par défaut : choisie en mots, contraste vérifié à la saisie, recommandée ou imposée.",
  "org.charter.designMdLabel": "DESIGN.md",
  "org.charter.editor": "Nouvelle version, sans jargon",
  "org.charter.empty": "Aucune version de la charte de l’organisation.",
  "org.charter.emptyHint": "Composez-la à gauche, puis faites-la valider par une autre personne.",
  "org.charter.invalidId": "Adresse invalide : aucune version de charte ne porte cet identifiant.",
  "org.charter.loading": "Chargement de la charte de l’organisation…",
  "org.charter.loadingOne": "Chargement de la version…",
  "org.charter.makeAllowed": "Rendre recommandée",
  "org.charter.makeInForce": "Rendre imposée",
  "org.charter.minimum": "Minimum",
  "org.charter.none": "Aucune version validée : chaque projet applique sa propre charte (ou la charte par défaut).",
  "org.charter.overrides": "Surcharges et dérogations des projets",
  "org.charter.overridesEmpty": "Aucun projet n’a surchargé la charte de l’organisation.",
  "org.charter.pair": "Paire",
  "org.charter.pending": "{{count}} dérogation(s) à décider",
  "org.charter.ratio": "Rapport",
  "org.charter.requiredRole": "Administration de l’organisation",
  "org.charter.ruleAllowed": "s’en écarter est possible, avec un motif tracé.",
  "org.charter.ruleInForce": "s’en écarter est une dérogation à échéance, décidée par l’administration.",
  "org.charter.saved": "Version v{{version}} enregistrée en brouillon : une autre personne de l’administration doit la valider.",
  "org.charter.selfRefused": "Vous en êtes l’auteur : l’auteur d’une version ne la valide jamais lui-même. Une autre personne de l’administration de l’organisation doit la valider.",
  "org.charter.title": "Charte de l’organisation",
  "org.charter.trace": "Écrite par {{author}} le {{date}} ; validée par {{validator}} ; empreinte des jetons {{sha}}",
  "org.charter.validateAllowed": "Valider — recommandée",
  "org.charter.validatedInfo": "v{{version}} ({{semver}}), validée par {{who}} le {{date}}. Les projets l’héritent ; {{rule}}",
  "org.charter.validateInForce": "Valider — imposée",
  "org.charter.validationEffect": "Valider une version l’applique à tous les projets qui n’ont pas de surcharge active, y compris ceux qui avaient validé leur propre charte : leur prochaine génération prendra celle de l’organisation.",
  "org.charter.versionDescription": "Les choix en mots, le contraste vérifié paire par paire, et ce que la plateforme en a généré.",
  "org.charter.versions": "Versions",
  "org.charter.versionTitle": "Charte de l’organisation v{{version}}",
  "org.charter.writeActions": "Modifier la charte de l’organisation",
  "pgmCapacite.agregat": "agrégat — ni nom ni mission : vous n’êtes pas membre de ces projets",
  "pgmCapacite.agregatRepli": "{{n}} projet(s) non ouvert(s)",
  "pgmCapacite.carteConsomme": "consommé {{v}}",
  "pgmCapacite.carteEstime": "estimé {{v}}",
  "pgmCapacite.carteMissions": "{{n}} mission(s) en cours",
  "pgmCapacite.chargement": "Lecture du coût et de la capacité…",
  "pgmCapacite.colConsomme": "consommé",
  "pgmCapacite.colEstime": "estimé",
  "pgmCapacite.colMissions": "missions en cours",
  "pgmCapacite.colProjet": "projet",
  "pgmCapacite.colRemarque": "remarque",
  "pgmCapacite.consommees": "Consommées (mesurées)",
  "pgmCapacite.de": "Minutes GPU consommées et estimées des projets de {{nom}}",
  "pgmCapacite.enPause": "en pause",
  "pgmCapacite.erreur": "Le coût et la capacité du programme n’ont pas pu être lus.",
  "pgmCapacite.estimees": "Estimées (missions actives)",
  "pgmCapacite.jamaisAdditionnees": "jamais additionnées",
  "pgmCapacite.legende": "Par projet rattaché : missions en cours, minutes estimées et consommées, remarque",
  "pgmCapacite.mois": "Mois",
  "pgmCapacite.periode": "Minutes GPU — {{mois}}",
  "pgmCapacite.projetsRattaches": "{{n}} projet(s) rattaché(s)",
  "pgmCapacite.refus": "Vous n’êtes pas membre de ce programme : son coût et sa capacité ne vous sont pas ouverts.",
  "pgmCapacite.regle": "Estimé ≠ consommé : deux colonnes, jamais un total commun. L’estimé est le reste à faire des missions actives ; le consommé, les minutes mesurées du mois.",
  "pgmCapacite.sansProjetIndice": "Le relevé se calcule sur les projets rattachés au programme.",
  "pgmCapacite.vide": "Aucune minute consommée",
  "pgmCapacite.videIndice": "Les missions des projets rattachés alimenteront ce relevé.",
  "pgmObjectif.ajoutEnCours": "Ajout…",
  "pgmObjectif.ajouter": "Ajouter un risque",
  "pgmObjectif.ajouterBouton": "Ajouter le risque",
  "pgmObjectif.aucunOuvert": "Aucun risque ouvert.",
  "pgmObjectif.aucunRisque": "Aucun risque inscrit au registre.",
  "pgmObjectif.chargement": "Lecture de l’objectif du programme…",
  "pgmObjectif.clore": "Clore",
  "pgmObjectif.cloreDe": "Clore « {{titre}} »",
  "pgmObjectif.clos": "clos le {{d}}",
  "pgmObjectif.colActions": "actions",
  "pgmObjectif.colImpact": "impact",
  "pgmObjectif.colPorteur": "porteur",
  "pgmObjectif.colRisque": "risque",
  "pgmObjectif.colStatut": "statut",
  "pgmObjectif.conflit": "L’objectif a été modifié entre-temps : rechargez avant d’enregistrer.",
  "pgmObjectif.date": "Date cible",
  "pgmObjectif.dateSansJalon": "Une date cible appartient à un jalon : nommez le jalon.",
  "pgmObjectif.enregistrer": "Enregistrer l’objectif",
  "pgmObjectif.erreur": "L’objectif et le registre des risques n’ont pas pu être lus.",
  "pgmObjectif.impact": "Impact",
  "pgmObjectif.impactDe": "Impact de « {{titre}} »",
  "pgmObjectif.impactHigh": "élevé",
  "pgmObjectif.impactLow": "faible",
  "pgmObjectif.impactMedium": "moyen",
  "pgmObjectif.intitule": "Intitulé",
  "pgmObjectif.jalon": "Jalon cible",
  "pgmObjectif.jalonLongueur": "Le jalon compte au plus {{max}} caractères.",
  "pgmObjectif.legende": "Registre des risques du programme : ouverts d’abord, du plus fort impact au plus faible",
  "pgmObjectif.legendeOuverts": "Risques ouverts du programme, du plus fort impact au plus faible",
  "pgmObjectif.membresErreur": "Les membres du programme n’ont pas pu être lus : le porteur ne peut pas être choisi.",
  "pgmObjectif.nonFixe": "non fixé",
  "pgmObjectif.objectifLongueur": "L’objectif compte au plus {{max}} caractères.",
  "pgmObjectif.ouvert": "ouvert",
  "pgmObjectif.ouverts": "{{n}} ouvert(s)",
  "pgmObjectif.parade": "Parade",
  "pgmObjectif.paradeChamp": "Parade (facultatif)",
  "pgmObjectif.paradeLongueur": "La parade compte au plus {{max}} caractères.",
  "pgmObjectif.porteur": "Porteur",
  "pgmObjectif.porteurDe": "Porteur de « {{titre}} »",
  "pgmObjectif.porteurNonMembre": "Le porteur d’un risque doit être membre du programme.",
  "pgmObjectif.registre": "Registre des risques",
  "pgmObjectif.registreCompte": "Registre des risques : {{n}} risque(s), {{o}} ouvert(s)",
  "pgmObjectif.risqueAjoute": "Risque « {{titre}} » ajouté au registre.",
  "pgmObjectif.risqueClos": "Risque « {{titre}} » clos.",
  "pgmObjectif.risqueModifie": "Risque « {{titre}} » enregistré.",
  "pgmObjectif.risqueRouvert": "Risque « {{titre}} » rouvert.",
  "pgmObjectif.rouvrir": "Rouvrir",
  "pgmObjectif.rouvrirDe": "Rouvrir « {{titre}} »",
  "pgmObjectif.sansDroit": "Lecteur du programme : objectif et risques en lecture — un propriétaire ou un contributeur du programme les modifie.",
  "pgmObjectif.sansPorteur": "sans porteur",
  "pgmObjectif.section": "Objectif, jalon cible, risques",
  "pgmObjectif.succes": "Objectif et jalon cible enregistrés.",
  "pgmObjectif.titre": "Objectif",
  "pgmObjectif.titreRisqueLongueur": "L’intitulé du risque compte de {{min}} à {{max}} caractères.",
  "pgmObjectif.vide": "Aucun objectif",
  "pgmObjectif.videAction": "Définir l’objectif dans les réglages",
  "pgmObjectif.videIndice": "Donnez un objectif et un jalon cible au programme.",
  "pgmObjectif.videLecteur": "Un pilote du programme (propriétaire ou contributeur) le fixe.",
  "reglagesNotif.annuler": "Annuler",
  "reglagesNotif.ceQuiNotifie": "Ce qui vous notifie",
  "reglagesNotif.chargement": "Lecture de vos réglages de notification…",
  "reglagesNotif.detailTechnique": "Détail technique",
  "reglagesNotif.enregistrement": "Enregistrement…",
  "reglagesNotif.enregistrer": "Enregistrer",
  "reglagesNotif.erreur": "Vos réglages de notification n’ont pas pu être lus.",
  "reglagesNotif.et": "et",
  "reglagesNotif.fuseau": "Heures du fuseau {{fuseau}}.",
  "reglagesNotif.heriter": "Hériter du défaut ({{niveau}})",
  "reglagesNotif.intro": "Par défaut pour tous vos projets, puis par projet. « Muet » ne coupe jamais la Boîte d’attention : une décision qui vous attend y reste.",
  "reglagesNotif.niveau.all": "Tout",
  "reglagesNotif.niveau.mentions": "Mentions seulement",
  "reglagesNotif.niveau.mute": "Muet",
  "reglagesNotif.parDefaut": "Par défaut",
  "reglagesNotif.resumeCreneaux": "Recevoir un résumé à chaque créneau : {{creneaux}}",
  "reglagesNotif.resumeNote": "Le résumé regroupe les notifications non lues depuis le précédent ; il est livré dans l’application (l’envoi d’e-mail est hors périmètre).",
  "reglagesNotif.resumeTitre": "Résumé (digest)",
  "reglagesNotif.resumeTroisFois": "Recevoir un résumé trois fois par jour : {{creneaux}}",
  "reglagesNotif.sansProjet": "Vous n’êtes membre d’aucun projet : seul le niveau par défaut s’applique.",
  "reglagesNotif.succes": "Réglages de notification enregistrés",
  "reglagesNotif.titre": "Réglages de notification",
  "sprint.aAmeliorer": "À améliorer",
  "sprint.aGarder": "À garder",
  "sprint.actionChamp": "Nouvelle action",
  "sprint.actionCreee": "Action créée dans le backlog.",
  "sprint.actionCreeeBadge": "item créé",
  "sprint.actionCreer": "Créer l’action",
  "sprint.actionFaite": "faite",
  "sprint.actionInvalide": "Le titre d’une action fait 3 caractères au moins.",
  "sprint.actionsAucune": "Aucune action créée.",
  "sprint.actionsTitre": "Actions de la rétrospective (items du backlog)",
  "sprint.ajoutAuDela": "L’engagé dépasse déjà la capacité : un avertissement — ajouter une US reste possible.",
  "sprint.ajouter": "Ajouter au sprint",
  "sprint.assigne": "assigné : {{qui}}",
  "sprint.aucunCritere": "Aucun critère d’acceptation saisi.",
  "sprint.aucuneTache": "Aucune tâche sous cet item.",
  "sprint.burn.burndownAria": "Burndown du {{debut}} au {{fin}} : {{reste}} points restants au {{jour}}",
  "sprint.burn.burndownTitre": "Burndown — points restants (réel jusqu’à aujourd’hui, idéale en tirets)",
  "sprint.burn.burnupAria": "Burn-up : {{fait}} points terminés sur un périmètre de {{perimetre}} au {{jour}}",
  "sprint.burn.burnupTitre": "Burn-up — périmètre et terminé",
  "sprint.burn.noteInstantanes": "{{n}} instantané(s) quotidien(s) depuis le {{premier}} ; aujourd’hui : {{jour}}. Le futur n’est jamais tracé.",
  "sprint.burn.noteSansInstantane": "Aucun instantané quotidien encore : les jours passés sont reconstitués depuis le journal des transitions. Le futur n’est jamais tracé.",
  "sprint.burn.pasCommence": "Le sprint n’a pas encore commencé (début le {{debut}}) : seule l’idéale est tracée ; le restant réel s’affichera dès le premier jour.",
  "sprint.burn.pasDeValeur": "pas de valeur",
  "sprint.burn.perimetre": "Périmètre",
  "sprint.burn.reconstitue": "reconstitué depuis le journal (avant le premier instantané)",
  "sprint.burn.tachesAria": "{{n}} tâche(s) restante(s) sur {{total}} au {{jour}}",
  "sprint.burn.tachesRestantes": "Tâches restantes",
  "sprint.burn.tachesTitre": "Tâches restantes (comptées)",
  "sprint.burn.termine": "Terminé",
  "sprint.burn.titre": "Burndown, burn-up et tâches de ce sprint",
  "sprint.burn.unitesTaches": "tâches",
  "sprint.burndownSansDates": "Le burndown demande des dates de début et de fin : ce sprint n’en a pas.",
  "sprint.burndownTitre": "Burndown de ce sprint — points restants",
  "sprint.capaciteAide": "Facultatif : sans valeur, seule la vélocité s’affiche. De 0,1 à 999 jours-personnes.",
  "sprint.capaciteChamp": "Capacité déclarée (jours-personnes)",
  "sprint.capaciteChargement": "Lecture de la capacité…",
  "sprint.capaciteDans": "{{j}} j-p · engagé {{e}} pts : dans la capacité.",
  "sprint.capaciteDeclaree": "Capacité déclarée",
  "sprint.capaciteDepassee": "Engagé {{e}} pts pour ≈ {{c}} pts de capacité : avertissement ; ajouter une US reste possible.",
  "sprint.capaciteEnregistree": "Capacité enregistrée.",
  "sprint.capaciteEnregistrer": "Enregistrer la capacité",
  "sprint.capaciteErreur": "Capacité illisible : {{m}}",
  "sprint.capaciteInsuffisante": "Données insuffisantes",
  "sprint.capaciteInvalide": "Un nombre de jours-personnes entre 0,1 et 999, ou vide pour effacer.",
  "sprint.capacitePoints": "capacité ≈ {{n}} pts",
  "sprint.capaciteTiret": "Capacité —",
  "sprint.capaciteTitre": "Capacité déclarée — à côté de la vélocité, jamais bloquante",
  "sprint.capaciteVide": "Capacité non déclarée : seule la vélocité s’affiche.",
  "sprint.chargement": "Chargement du sprint…",
  "sprint.choisirUneUs": "Choisissez l’US à ajouter au sprint.",
  "sprint.closLe": "clos le {{date}}",
  "sprint.closNote": "Sprint clos : son contenu ne change plus. La revue et la rétrospective se saisissent plus bas.",
  "sprint.cloture.aucunSprint": "Aucun autre sprint planifié ou actif",
  "sprint.cloture.choisirSprint": "Choisir un sprint…",
  "sprint.cloture.choixManque": "Choisissez où vont les {{n}} item(s) non terminé(s) : vers un autre sprint, ou au backlog.",
  "sprint.cloture.cibleManque": "Choisissez le sprint qui reçoit les items reportés.",
  "sprint.cloture.cloturerEtReporter": "Clôturer et reporter",
  "sprint.cloture.confirmer": "Confirmer la clôture",
  "sprint.cloture.direct": "Tous les items du sprint sont terminés : rien à reporter. Confirmez la clôture.",
  "sprint.cloture.ouVont": "Où vont-ils ? (choix obligatoire)",
  "sprint.cloture.restants": "{{n}} item(s) non terminé(s) :",
  "sprint.cloture.sprintCible": "Sprint qui reçoit les items",
  "sprint.cloture.succesBacklog": "Sprint clos : {{n}} item(s) remis au backlog. La revue est ouverte.",
  "sprint.cloture.succesDirect": "Sprint clos. La revue et la rétrospective sont ouvertes.",
  "sprint.cloture.succesSprint": "Sprint clos : {{n}} item(s) reporté(s) vers {{cible}}. La revue est ouverte.",
  "sprint.cloture.titre": "Clôturer le sprint",
  "sprint.cloture.versBacklog": "Remettre au backlog (sans sprint)",
  "sprint.cloture.versSprint": "Reporter vers le sprint :",
  "sprint.contenuChargement": "Lecture du contenu du sprint…",
  "sprint.contenuTitre": "Contenu du sprint — US, tâches, statut, points, assigné",
  "sprint.contenuVideHint": "Ajoutez une US disponible ci-dessous, ou rangez-en une depuis le board.",
  "sprint.contenuVideLecture": "Les US se rangent dans un sprint depuis le board ou depuis cette page, par un contributeur.",
  "sprint.contenuVideTitre": "Aucune US dans ce sprint",
  "sprint.criteres": "Critères d’acceptation ({{n}})",
  "sprint.criteresEtDod": "Critères d’acceptation ({{n}}) et Definition of Done",
  "sprint.engage": "Engagé",
  "sprint.erreurInconnue": "Erreur inattendue",
  "sprint.fluxTitre": "Flux cumulé de ce sprint — items par statut",
  "sprint.fluxVideHint": "Rangez des items dans ce sprint et changez leur statut : le flux se construit du journal des transitions.",
  "sprint.introuvable": "Sprint introuvable",
  "sprint.introuvableHint": "Ce sprint n’existe pas, ou il appartient à un projet auquel vous n’avez pas accès. Revenez à la liste des sprints du projet.",
  "sprint.joursRestants": "{{n}} jour(s) restant(s)",
  "sprint.joursRestantsInconnu": "jours restants : — (pas de date de fin)",
  "sprint.jp": "{{n}} j-p",
  "sprint.lancerClos": "Sprint clos : aucune mission ne s’y lance plus.",
  "sprint.lectureSeule": "Lecture seule — changer le statut, ranger ou retirer une US et déclarer la capacité sont réservés aux contributeurs.",
  "sprint.nonAssigne": "non assigné",
  "sprint.nonEstime": "non estimé",
  "sprint.objectif": "Objectif :",
  "sprint.objectifAtteint": "atteint",
  "sprint.objectifAucun": "aucun objectif saisi",
  "sprint.objectifNonAtteint": "non atteint",
  "sprint.objectifPartiel": "partiellement atteint",
  "sprint.pasDeCourbe": "Pas encore de courbe",
  "sprint.pasDeCourbeHint": "Rangez des items dans le sprint et changez leur statut : la courbe se construit du journal des transitions.",
  "sprint.points": "{{n}} pts",
  "sprint.projet": "Projet : {{nom}}",
  "sprint.ratio": "≈ {{r}} pt par j-p ({{n}} sprint(s) avec capacité)",
  "sprint.resumePoints": "{{fait}} / {{engage}} pts terminés · {{faits}} / {{total}} items · {{pct}} %",
  "sprint.retirer": "Retirer du sprint",
  "sprint.retirerAria": "Retirer « {{titre}} » du sprint",
  "sprint.revueChargement": "Lecture de la revue…",
  "sprint.revueDemo": "Démonstration",
  "sprint.revueDemoA": "Démontré à",
  "sprint.revueDemoLe": "Démontré le",
  "sprint.revueDemoValeur": "le {{date}} à {{qui}}",
  "sprint.revueEcart": "Écart : {{n}} item(s) terminé(s) sans preuve (cas de test manquant).",
  "sprint.revueEnregistree": "Revue et rétrospective enregistrées.",
  "sprint.revueEnregistrer": "Enregistrer la revue",
  "sprint.revueErreur": "Revue illisible : {{m}}",
  "sprint.revueFaits": "{{fait}} / {{total}} items terminés, {{preuve}} vraiment finis (avec preuve).",
  "sprint.revueLectureSeule": "Lecture seule — saisir la revue et la rétrospective est réservé aux contributeurs du projet.",
  "sprint.revueNonClos": "Le sprint n’est pas clos : revue et rétrospective s’ouvrent à la clôture.",
  "sprint.revueNotes": "Notes de revue",
  "sprint.revueObjectif": "Objectif du sprint",
  "sprint.revueReportes": "Reportés à la clôture ({{n}}) :",
  "sprint.revueTitre": "Revue et rétrospective",
  "sprint.revueVersBacklog": "backlog",
  "sprint.revueVide": "Aucune revue saisie",
  "sprint.sansDates": "sans dates",
  "sprint.statut": "Statut",
  "sprint.tacheAutreSprint": "rangée dans un autre sprint",
  "sprint.taches": "Tâches ({{n}})",
  "sprint.tousLesSprints": "Tous les sprints",
  "sprint.usAjoutee": "« {{titre}} » ajoutée au sprint.",
  "sprint.usRetiree": "« {{titre}} » retirée du sprint.",
  "sprint.velocite": "Vélocité ({{n}} sprints clos)",
  "sprint.velociteAucune": "aucun sprint clos",
  "sprint.wipAbsente": "Cette passerelle ne sert pas les limites : seuls les comptes s’affichent.",
  "sprint.wipActif": "Comptée sur les items de ce sprint, le sprint actif.",
  "sprint.wipErreur": "Limites illisibles (la passerelle n’a pas répondu) : seuls les comptes s’affichent.",
  "sprint.wipNonActif": "La limite s’applique au sprint actif ; ce sprint ne l’est pas : ses comptes sont donnés pour information.",
  "sprint.wipRegler": "Régler les limites",
  "sprint.wipTitre": "Limite de travail en cours, par colonne — en lecture",
  "velocite.aria": "Vélocité de {{n}} sprint(s) : {{detail}}. Moyenne des sprints clos : {{m}} points.",
  "velocite.ariaSprint": "{{nom}} {{fait}} terminés sur {{engage}} engagés",
  "velocite.ceSprint": "ce sprint",
  "velocite.chargement": "Lecture des sprints…",
  "velocite.colCapacite": "Capacité déclarée",
  "velocite.colEngage": "Engagé (pts)",
  "velocite.colSprint": "Sprint",
  "velocite.colTermine": "Terminé (pts)",
  "velocite.engage": "Engagé",
  "velocite.erreur": "Vélocité illisible : {{m}}",
  "velocite.legendeCapacite": "Sous chaque sprint : capacité déclarée (j-p), « — » si non déclarée.",
  "velocite.legendeMoyenne": "Moyenne des sprints clos",
  "velocite.moyenne": "Vélocité moyenne ({{n}} sprint(s) clos) : {{v}} pts",
  "velocite.tableCaption": "Vélocité par sprint : engagé, terminé, capacité déclarée",
  "velocite.termine": "Terminé",
  "velocite.titre": "Vélocité — points engagés et terminés par sprint",
  "velocite.vide": "Aucun sprint clos : la vélocité s’affichera à la première clôture",
  "velocite.videIndice": "La vélocité est la moyenne des points terminés des sprints clos.",
  "publication.application": "Application",
  "publication.chargement": "Chargement des révisions et des publications…",
  "publication.code.APP_REPOSITORY_MISSING": "Aucun dépôt pour cette application : publiez d’abord une révision.",
  "publication.code.ENVIRONMENT_CONFLICT": "Un environnement de ce nom existe et n’est pas celui de cette application.",
  "publication.code.GITLAB_EGRESS_REFUSED": "L’hôte GitLab n’est pas dans la liste des sorties autorisées.",
  "publication.code.GITLAB_GROUP_CONFLICT": "Le sous-groupe GitLab de l’organisation existe sans son marqueur : refus.",
  "publication.code.GITLAB_NOT_CONFIGURED": "Aucun GitLab connu pour ce projet : configurez la connexion GitLab du projet, ou publiez une première révision.",
  "publication.code.GITLAB_PROJECT_CONFLICT": "Un projet GitLab de ce nom existe et n’appartient pas à cette application.",
  "publication.code.GITLAB_PROVISION_TOKEN_MISSING": "Le worker n’a pas de jeton de provisionnement GitLab : l’exploitation doit le lui donner.",
  "publication.code.GITLAB_RUNNER_MISSING": "Aucun runner en ligne pour le dépôt : enregistrez l’exécuteur durci (make v050-gitlab-runner-register).",
  "publication.code.GITLAB_RUNNER_UNVERIFIABLE": "Les runners ne peuvent pas être listés avec ce jeton : précondition invérifiable.",
  "publication.code.GITLAB_TOKEN_REFUSED": "GitLab a refusé le jeton.",
  "publication.code.GITLAB_UNREACHABLE": "GitLab local injoignable : démarrez-le (make v050-gitlab-up).",
  "publication.code.HOST_PORT_TAKEN": "Ce port est déjà attribué à un autre environnement.",
  "publication.code.REVISION_NOT_DONE": "Seule une génération réussie se publie.",
  "publication.code.REVISION_NOT_FOUND": "Révision introuvable pour cette application.",
  "publication.code.REVISION_REQUIREMENTS_UNSAFE": "requirements.txt contient une option, une URL ou un chemin : refusé.",
  "publication.code.REVISION_UNATTESTED": "L’arbre de la révision ne correspond plus à celui attesté par sa génération.",
  "publication.code.SCM_KEY_UNAVAILABLE": "Jeton chiffré illisible : la clé SCM de la passerelle est absente ou différente de celle du worker.",
  "publication.code.STACK_DELIVERY_RUNNER_NOT_HARDENED": "Cette pile exécute le code généré en CI : un exécuteur durci attesté est exigé.",
  "publication.code.STACK_PROFILE_UNKNOWN": "Profil de pile non reconnu : les fichiers d’infrastructure de la révision ne sont pas ceux du gabarit.",
  "publication.code.STACK_PROFILE_UNSUPPORTED": "Le profil de pile publié n’est pas déployable.",
  "publication.code.VALIDATION_ERROR": "Valeur refusée par le serveur.",
  "publication.col.action": "Action",
  "publication.col.commit": "Commit",
  "publication.col.etat": "État",
  "publication.col.pipeline": "Pipeline ou motif",
  "publication.col.revision": "Révision",
  "publication.commit.aide": "Auteur : DoIt runtime. La poussée déclenche le pipeline : gabarit (Dockerfile = gabarit), construire, tester.",
  "publication.commit.rafraichi": "Pipeline non relu : {{e}}",
  "publication.commit.titre": "Révision {{rev}} — commit {{sha}}",
  "publication.dejaDemandee": "La révision {{rev}} est déjà demandée ou publiée : rien de plus.",
  "publication.demandee": "Publication de la révision {{rev}} mise en file.",
  "publication.deploiement.failed": "échoué",
  "publication.deploiement.pending": "en cours",
  "publication.deploiement.rolled_back": "revenu en arrière",
  "publication.deploiement.stopped": "arrêté",
  "publication.deploiement.succeeded": "réussi",
  "publication.depot.branche": "Branche",
  "publication.depot.brancheValeur": "main, protégée · un commit par révision",
  "publication.depot.dec039": "Un sous-groupe GitLab par organisation (DEC-039).",
  "publication.depot.jeton": "Jeton",
  "publication.depot.jetonValeur": "doit-publication · {{portees}} · échéance {{date}} · chiffré, jamais affiché",
  "publication.depot.ouvrir": "Ouvrir dans GitLab",
  "publication.depot.prive": "privé",
  "publication.depot.projet": "Projet",
  "publication.depot.titre": "Dépôt de l’application",
  "publication.depot.vide": "Pas encore de dépôt",
  "publication.depot.videAide": "Le dépôt GitLab privé de l’application naît à sa première publication.",
  "publication.description": "Chaque révision verte de l’application devient un commit de son dépôt GitLab privé ; la poussée déclenche son pipeline. Les environnements reliés se déploient depuis Versions.",
  "publication.enCoursAide": "poussée en cours ; le pipeline sera cherché par son SHA",
  "publication.env.adresse": "Adresse",
  "publication.env.chargement": "Chargement des environnements…",
  "publication.env.cree": "Environnement « {{nom}} » relié : {{url}} (pipeline exigé, branche main).",
  "publication.env.deployable": "Déployable : un commit publié par DoIt (APP_COMMIT_NOT_PUBLISHED), avec le Dockerfile du gabarit (APP_DOCKERFILE_NOT_TEMPLATE).",
  "publication.env.deploye": "Déployé",
  "publication.env.environnement": "Environnement",
  "publication.env.etat": "État",
  "publication.env.jamais": "jamais déployé",
  "publication.env.misAJour": "Environnement « {{nom}} » mis à jour : {{url}}.",
  "publication.env.nom": "Nom",
  "publication.env.nomInvalide": "Nom requis : lettres, chiffres, espace, point, tiret ; 50 caractères au plus.",
  "publication.env.port": "Port publié ({{min}}–{{max}})",
  "publication.env.portHorsPlage": "Port publié hors de la plage réservée {{min}}–{{max}}.",
  "publication.env.production": "production",
  "publication.env.rang": "rang {{r}}",
  "publication.env.regle": "Branche main · pipeline exigé · port publié sur 127.0.0.1",
  "publication.env.relier": "Relier un environnement",
  "publication.env.relierAction": "Relier",
  "publication.env.titre": "Environnements reliés au dépôt",
  "publication.env.versions": "Déployer depuis Versions",
  "publication.env.vide": "Aucun environnement relié",
  "publication.env.videAide": "Reliez un environnement ci-dessous une fois le dépôt créé ; il sera déployable depuis Versions.",
  "publication.etat.failed": "échec",
  "publication.etat.nonPubliee": "non publiée",
  "publication.etat.published": "publiée",
  "publication.etat.publishing": "publication en cours",
  "publication.etat.requested": "demandée",
  "publication.pipeline.canceled": "annulé",
  "publication.pipeline.failed": "échoué",
  "publication.pipeline.manual": "manuel",
  "publication.pipeline.pending": "en attente",
  "publication.pipeline.running": "en cours",
  "publication.pipeline.searching": "cherché par son SHA",
  "publication.pipeline.skipped": "sauté",
  "publication.pipeline.success": "réussi",
  "publication.pipelineRouge": "non déployable",
  "publication.pre.aide": "Sinon, refus nommé, jamais simulé : le worker revérifie au moment de publier.",
  "publication.pre.chargement": "Vérification de GitLab…",
  "publication.pre.dernierRefus": "Dernier refus du worker ({{date}}, révision {{rev}}) :",
  "publication.pre.inconnu": "non vérifié",
  "publication.pre.jeton": "Jeton accepté",
  "publication.pre.joignable": "GitLab joignable",
  "publication.pre.ko": "non rempli",
  "publication.pre.nonRemplie": "non remplie",
  "publication.pre.ok": "rempli",
  "publication.pre.remplie": "remplie",
  "publication.pre.runner": "Runner en ligne pour le dépôt",
  "publication.pre.runnerCompte": "{{n}} runner(s) en ligne",
  "publication.pre.runnerInconnu": "vérifié par le worker à la première publication (runner du groupe doit-apps)",
  "publication.pre.sourceDepot": "jeton du dépôt de l’application",
  "publication.pre.sourceScm": "connexion GitLab du projet",
  "publication.pre.titre": "Précondition : GitLab local actif et runner",
  "publication.pre.version": "version {{v}}",
  "publication.publier": "Publier",
  "publication.publierUne": "Publier une révision",
  "publication.refus": "Ce projet n’est pas accessible avec votre compte : demandez l’accès à son propriétaire.",
  "publication.refus.controles": "{{ok}} contrôles sur {{total}} : seule une révision verte se publie.",
  "publication.refus.nonTerminee": "Génération non réussie (état : {{etat}}) : rien à publier.",
  "publication.relancer": "Relancer",
  "publication.revisions": "Publications par révision",
  "publication.revisionsRegle": "Seule une révision verte se publie : 10 contrôles sur 10, arbre attesté.",
  "publication.roleContributeur": "contributeur",
  "publication.sansProjet": "Le dépôt GitLab appartient à une application d’un projet.",
  "publication.titre": "Publication du code",
  "publication.vide": "Aucune application générée",
  "publication.videAide": "Une révision naît d’une génération d’application depuis une spécification approuvée (écran Approbations) ; elle se publie ici une fois verte.",
  "frise.etat.livre": "livré",
  "frise.etat.termine": "terminé, non livré",
  "frise.etat.en_cours": "en cours",
  "frise.etat.a_venir": "à venir",
  "frise.etat.en_retard": "en retard",
  "frise.etat.non_date": "non daté (à planifier)",
  "frise.jalon.livre": "livrée",
  "frise.jalon.prevu": "prévue",
  "frise.jalon.en_retard": "date cible dépassée",
  "frise.jalon.non_date": "non datée",
  "frise.barreLibelle": "{{titre}} : {{etat}}, du {{debut}} au {{fin}}{{avancement}}",
  "frise.avancementSuffixe": ", {{pct}} % terminé",
  "frise.livreDans": "en {{v}}",
  "frise.aujourdhui": "aujourd’hui : {{d}}",
  "frise.versions": "Versions",
  "frise.jalonLibelle": "Version {{v}} : {{etat}}, {{d}}",
  "frise.aucuneVersion": "Aucune version préparée : les jalons apparaissent dès qu’une version a une date cible ou est livrée.",
  "frise.epics": "Epics et features",
  "frise.enRetardCompte": "{{n}} en retard",
  "frise.aucunEpic": "Aucun epic : ils naissent du backlog généré depuis une spécification approuvée.",
  "frise.aPlanifier": "À planifier : aucun sprint daté ({{n}})",
  "frise.sprints": "Sprints",
  "frise.sprintLibelle": "{{n}} : du {{a}} au {{b}}, {{f}} / {{e}} points",
  "frise.legende": "Légende",
  "frise.legendeJalon": "version (jalon)",
  "accueil.titre.scrum_master": "Le sprint actif, ses obstacles et le travail en cours",
  "accueil.titre.architecte": "Les décisions et les dérogations qui attendent votre avis",
  "accueil.titre.sponsor": "Ce qui attend votre approbation, et où en est le programme",
  "rapport.csv.programme": "Programme",
  "rapport.csv.genere": "Généré le",
  "rapport.csv.objectif": "Objectif",
  "rapport.csv.jalon": "Jalon cible",
  "rapport.csv.synthese": "Synthèse",
  "rapport.csv.projet": "Projet",
  "rapport.csv.sprintActif": "Sprint actif",
  "rapport.csv.engageTermine": "Engagé / terminé (sprint actif)",
  "rapport.csv.velocite": "Vélocité moyenne",
  "rapport.csv.tendance": "Tendance",
  "rapport.csv.reste": "Reste (points)",
  "rapport.csv.nonEstimes": "Items non estimés",
  "rapport.csv.prevision": "Prévision",
  "rapport.csv.dateProbable": "Date probable",
  "rapport.csv.fourchette": "Fourchette",
  "rapport.csv.ecart": "Écart à la cible (jours)",
  "rapport.csv.epics": "Epics terminés / total",
  "rapport.csv.derniereLivree": "Dernière version livrée",
  "rapport.csv.enPreparation": "Version en préparation",
  "rapport.csv.risque": "Risque ouvert",
  "rapport.csv.impact": "Impact",
  "rapport.csv.porteur": "Porteur",
  "rapport.csv.parade": "Parade",
  "rapport.csv.nonAccessibles": "Projets non détaillés (non membre)",
  "roadmap.descriptionProduit": "Epics et features datés par leurs sprints, versions en jalons, sprints en bandeau.",
  "roadmap.refus": "Vous n’êtes pas membre de ce projet : sa roadmap ne vous est pas ouverte.",
  "roadmap.erreur": "La roadmap n’a pas pu être lue.",
  "roadmap.filtreDemande": "Demande",
  "roadmap.toutesDemandes": "Toutes les demandes",
  "roadmap.voirDemande": "Ouvrir {{ref}}",
  "roadmap.videProduit": "Rien à placer sur la roadmap",
  "roadmap.videProduitIndice": "Les epics naissent d’une spécification approuvée ; donnez des dates à vos sprints et une date cible à vos versions.",
  "roadmap.videDemande": "Aucun epic rattaché à cette demande",
  "accueil.archi.decisions": "Décisions à rendre",
  "accueil.archi.ouvrirDecisions": "Ouvrir les décisions",
  "accueil.archi.aucuneDecision": "Aucune décision d’architecture en attente.",
  "accueil.archi.proposeePar": "proposée par {{qui}} le {{quand}} · {{n}} option(s)",
  "accueil.archi.irreversible": "irréversible",
  "accueil.archi.derogations": "Dérogations à rendre",
  "accueil.archi.ouvrirExigences": "Ouvrir les exigences et dérogations",
  "accueil.archi.aucuneDerogation": "Aucune dérogation demandée en attente.",
  "accueil.archi.derogationDetail": "demandée par {{qui}} · risque {{r}} · échéance {{e}}",
  "accueil.archi.technologies": "Technologie du projet",
  "accueil.archi.baseline": "Choix et baseline technologique",
  "accueil.archi.pile": "Profil de pile et générabilité",
  "accueil.archi.dependances": "Dépendances inter-projets",
  "accueil.sm.sprint": "Sprint actif",
  "accueil.sm.ouvrirSprint": "Ouvrir la page du sprint",
  "accueil.sm.dates": "du {{a}} au {{b}}",
  "accueil.sm.joursRestants": "jour(s) restant(s)",
  "accueil.sm.points": "points terminés / engagés",
  "accueil.sm.items": "items terminés",
  "accueil.sm.aucunSprint": "Aucun sprint actif : démarrez le prochain depuis Sprints.",
  "accueil.sm.obstacles": "Obstacles",
  "accueil.sm.obstaclesAide": "Items du sprint bloqués par un lien « bloque », ou sans mouvement depuis {{n}} jours.",
  "accueil.sm.obstaclesSansSprint": "Pas de sprint actif : rien à lever.",
  "accueil.sm.aucunObstacle": "Aucun obstacle signalé dans le sprint.",
  "accueil.sm.bloque": "bloqué",
  "accueil.sm.bloquePar": "par {{liste}}",
  "accueil.sm.stagnant": "sans mouvement",
  "accueil.sm.depuis": "statut inchangé depuis {{n}} jour(s)",
  "accueil.sm.wip": "Travail en cours",
  "accueil.sm.ouvrirTableau": "Ouvrir le tableau",
  "accueil.sm.wipAbsent": "Limites de travail en cours non servies par la passerelle.",
  "accueil.sm.wipSansLimite": "Aucune limite de travail en cours n’est réglée.",
  "accueil.sm.wipOk": "Toutes les colonnes sont sous leur limite.",
  "accueil.sm.depassee": "limite dépassée",
  "accueil.sm.atteinte": "limite atteinte",
  "accueil.sm.colonne": "{{c}} : {{n}} / {{l}}",
  "accueil.sponsor.miseEnLigne": "Mise en ligne à approuver",
  "accueil.sponsor.ouvrirVersion": "Ouvrir la version",
  "accueil.sponsor.aucuneVersion": "Aucune version en préparation.",
  "accueil.sponsor.rienAApprouver": "Rien n’attend votre approbation pour la version {{v}}.",
  "accueil.sponsor.demande": "{{v}} sur {{e}}",
  "accueil.sponsor.demandeePar": "demandée par {{qui}} le {{quand}}",
  "accueil.sponsor.production": "mise en ligne (production)",
  "accueil.sponsor.aDecider": "à décider",
  "accueil.sponsor.programme": "Programme",
  "accueil.sponsor.rapport": "Rapport d’avancement",
  "accueil.sponsor.sansProgramme": "Ce projet n’est rattaché à aucun programme : suivez-le par sa roadmap.",
  "accueil.sponsor.objectif": "Objectif",
  "accueil.sponsor.jalon": "Jalon cible",
  "accueil.sponsor.risques": "Risques ouverts",
  "accueil.sponsor.liens": "Aller plus loin",
  "accueil.sponsor.prochaines": "Prochaines mises en production",
  "accueil.sponsor.calendrier": "Ouvrir le calendrier",
  "calendrier.aucuneAVenir": "Aucune mise en production planifiée à venir.",
  "calendrier.planVers": "{{v}} → {{e}}",
  "calendrier.plan.prevu_en_gel": "prévue pendant un gel",
  "calendrier.plan.prevu": "prévue",
  "calendrier.plan.realise": "réalisée",
  "calendrier.plan.en_retard": "en retard",
  "calendrier.plan.annule": "annulée",
  "calendrier.deploiement.succeeded": "réussi",
  "calendrier.deploiement.failed": "en échec",
  "calendrier.deploiement.pending": "en cours",
  "calendrier.deploiement.rolled_back": "retour arrière",
  "calendrier.evtDeploiement": "{{v}} déployée sur {{e}} ({{s}})",
  "calendrier.evtPlan": "{{v}} → {{e}} : {{s}}",
  "calendrier.evtCible": "date cible de {{v}}",
  "calendrier.lun": "lun.",
  "calendrier.mar": "mar.",
  "calendrier.mer": "mer.",
  "calendrier.jeu": "jeu.",
  "calendrier.ven": "ven.",
  "calendrier.sam": "sam.",
  "calendrier.dim": "dim.",
  "calendrier.grilleLegende": "Mises en production du mois, jour par jour",
  "calendrier.gelCourt": "gel",
  "calendrier.production": "production",
  "calendrier.codeRefus": "Motif : {{c}}",
  "calendrier.planEnGel": "Mise en production planifiée — attention : elle tombe pendant une période de gel.",
  "calendrier.planOk": "Mise en production planifiée.",
  "calendrier.gelOk": "Période de gel déclarée ; {{n}} mise(s) en production planifiée(s) concernée(s).",
  "calendrier.cibleOk": "Date cible enregistrée.",
  "calendrier.actionsTitre": "Planifier",
  "calendrier.formPlan": "Planifier une mise en production",
  "calendrier.version": "Version",
  "calendrier.choisir": "— choisir —",
  "calendrier.environnement": "Environnement",
  "calendrier.datePrevue": "Date prévue",
  "calendrier.note": "Note (facultative)",
  "calendrier.manquePlan": "Choisissez la version, l’environnement et la date.",
  "calendrier.planifier": "Planifier",
  "calendrier.formGel": "Déclarer une période de gel",
  "calendrier.du": "Du",
  "calendrier.au": "Au",
  "calendrier.tousEnvironnements": "Tous les environnements",
  "calendrier.motif": "Motif",
  "calendrier.manqueGel": "Indiquez les deux dates et un motif d’au moins 5 caractères.",
  "calendrier.geler": "Déclarer le gel",
  "calendrier.formCible": "Date cible d’une version",
  "calendrier.cibleAide": "Elle place la version en jalon sur la roadmap produit.",
  "calendrier.dateCible": "Date cible",
  "calendrier.manqueCible": "Choisissez la version et sa date.",
  "calendrier.enregistrerCible": "Enregistrer",
  "calendrier.effacerCible": "Effacer la date",
  "nav./calendrier": "Calendrier des mises en production",
  "calendrier.description": "Déploiements réalisés et prévus, dates cibles des versions et périodes de gel, mois par mois.",
  "calendrier.chargement": "Lecture du calendrier…",
  "calendrier.refus": "Vous n’êtes pas membre de ce projet : son calendrier ne vous est pas ouvert.",
  "calendrier.erreur": "Le calendrier n’a pas pu être lu.",
  "calendrier.precedent": "Mois précédent",
  "calendrier.suivant": "Mois suivant",
  "calendrier.ceMois": "Ce mois-ci",
  "calendrier.gelDuAu": "Gel du {{a}} au {{b}}",
  "calendrier.vide": "Rien de prévu ni de réalisé ce mois-ci",
  "calendrier.videIndice": "Planifiez une mise en production ou déclarez une période de gel ci-dessous.",
  "calendrier.agenda": "Agenda du mois",
  "calendrier.aVenir": "Prochaines mises en production",
  "calendrier.annules": "Annulés ce mois-ci ({{n}})",
  "calendrier.lectureSeule": "Lecture seule : planifier, geler ou dater une version demande un rôle propriétaire ou contributeur du projet.",
  "calendrier.introuvableIndice": "Il n’existe pas dans ce projet, ou il appartient à un autre projet.",
  "calendrier.retour": "Revenir au calendrier",
  "calendrier.detailErreur": "Ce détail n’a pas pu être lu.",
  "calendrier.motifAnnulation": "Motif de l’annulation",
  "calendrier.motifCourt": "Un motif d’au moins 5 caractères est exigé.",
  "calendrier.planTitre": "Mise en production planifiée",
  "calendrier.planIntrouvable": "Mise en production planifiée introuvable",
  "calendrier.planifiePar": "Planifiée par",
  "calendrier.parLe": "{{qui}}, le {{quand}}",
  "calendrier.realiseeLe": "Réalisée le",
  "calendrier.annuleePar": "Annulée par",
  "calendrier.parLeMotif": "{{qui}}, le {{quand}} : {{motif}}",
  "calendrier.planPendantGel": "Cette date tombe pendant une période de gel : la mise en production reste possible, elle est signalée.",
  "calendrier.deploiementsReels": "Déploiements réels de cette version sur cet environnement",
  "calendrier.aucunDeploiement": "Aucun pour l’instant : le déploiement se lance depuis la fiche de la version.",
  "calendrier.annulerPlan": "Annuler cette mise en production",
  "calendrier.gelTitre": "Période de gel",
  "calendrier.gelIntrouvable": "Période de gel introuvable",
  "calendrier.gelActif": "active",
  "calendrier.gelAnnule": "annulée",
  "calendrier.periode": "Période",
  "calendrier.gelDuAuJours": "du {{a}} au {{b}} ({{n}} jour(s))",
  "calendrier.declarePar": "Déclarée par",
  "calendrier.gelAvertit": "Un gel avertit : il ne bloque pas un déploiement (politique de l’organisation).",
  "calendrier.gelPlans": "Mises en production planifiées pendant ce gel ({{n}})",
  "calendrier.gelAucunPlan": "Aucune.",
  "calendrier.gelDeploiements": "Déploiements réalisés pendant ce gel ({{n}})",
  "calendrier.gelAucunDeploiement": "Aucun.",
  "calendrier.annulerGel": "Annuler ce gel",
  "rapport.tendance.hausse": "en hausse",
  "rapport.tendance.baisse": "en baisse",
  "rapport.tendance.stable": "stable",
  "rapport.tendance.donnees_insuffisantes": "données insuffisantes (moins de 2 sprints clos)",
  "rapport.motif.AUCUN_SPRINT_CLOS": "aucun sprint clos : la vélocité n’est pas encore mesurée",
  "rapport.motif.VELOCITE_NULLE": "les derniers sprints clos n’ont rien terminé : aucune vélocité",
  "rapport.motif.RESTE_NON_ESTIME": "le reste à faire n’est pas estimé en points",
  "rapport.impact.high": "élevé",
  "rapport.impact.medium": "moyen",
  "rapport.impact.low": "faible",
  "rapport.synthese.aucun_projet": "Aucun projet ouvert : rien à prévoir.",
  "rapport.synthese.donnees_insuffisantes": "Prévision du programme impossible : {{n}} projet(s) sans données suffisantes (voir ci-dessous).",
  "rapport.synthese.termine": "Tout le reste à faire estimé est terminé.",
  "rapport.synthese.sans_cible": "Fin probable le {{d}} ; le programme n’a pas de date cible.",
  "rapport.synthese.en_retard": "Fin probable le {{d}} : {{n}} jour(s) après la date cible.",
  "rapport.synthese.dans_les_temps": "Fin probable le {{d}} : dans les temps ({{n}} jour(s) d’avance).",
  "rapport.sprintActif": "Sprint actif",
  "rapport.sprintActifDetail": "{{n}} — {{f}} / {{e}} pts terminés, {{j}} jour(s) restant(s)",
  "rapport.aucunSprintActif": "aucun",
  "rapport.velocite": "Vélocité moyenne (3 derniers sprints clos)",
  "rapport.velociteValeur": "{{v}} pts par sprint, {{tendance}}",
  "rapport.reste": "Reste à faire",
  "rapport.resteValeur": "{{p}} pts sur {{n}} item(s), dont {{e}} non estimé(s)",
  "rapport.prevision": "Prévision",
  "rapport.previsionValeur": "fin probable le {{d}} ({{n}} sprint(s) de {{c}} jours)",
  "rapport.fourchette": "fourchette : {{a}} → {{b}}",
  "rapport.cadenceDefaut": "cadence par défaut (sprints non datés)",
  "rapport.ecartRetard": "{{n}} jour(s) après la cible",
  "rapport.ecartAvance": "{{n}} jour(s) avant la cible",
  "rapport.previsionTermine": "reste à faire terminé",
  "rapport.previsionInsuffisante": "données insuffisantes : {{m}}",
  "rapport.epics": "Epics",
  "rapport.epicsValeur": "{{f}} terminé(s) sur {{n}}{{m}}",
  "rapport.avancementMoyen": ", avancement moyen {{p}} %",
  "rapport.versions": "Versions",
  "rapport.derniereLivree": "dernière livrée : {{v}}",
  "rapport.enPreparation": "en préparation : {{v}}",
  "rapport.cible": "cible {{d}}",
  "rapport.velociteTitre": "Sprints clos, du plus récent au plus ancien",
  "rapport.colSprint": "sprint",
  "rapport.colFin": "fin",
  "rapport.colEngage": "engagé",
  "rapport.colTermine": "terminé",
  "rapport.sourceInstantane": "dernier instantané du sprint actif",
  "rapport.sourceItems": "items rattachés au sprint et reportés à la clôture",
  "nav./programme/rapport": "Rapport d’avancement",
  "rapport.description": "Objectif, risques, vélocité réelle et prévision de fin, projet par projet — exportable.",
  "rapport.exporterCsv": "Exporter en CSV",
  "rapport.imprimer": "Imprimer ou enregistrer en PDF",
  "rapport.chargement": "Calcul du rapport d’avancement…",
  "rapport.erreur": "Le rapport d’avancement n’a pas pu être calculé.",
  "rapport.genereLe": "Rapport du {{d}}",
  "rapport.objectif": "Objectif : {{o}}",
  "rapport.sansObjectif": "Objectif : non défini",
  "rapport.jalon": "Jalon cible : {{j}}{{d}}",
  "rapport.sansJalon": "Jalon cible : non défini",
  "rapport.risquesTitre": "Risques ouverts ({{n}}, dont {{h}} à impact élevé)",
  "rapport.aucunRisque": "Aucun risque ouvert.",
  "rapport.impact": "impact {{i}}",
  "rapport.porteur": "porteur : {{p}}",
  "rapport.parade": "parade : {{p}}",
  "rapport.projetsTitre": "Avancement par projet",
  "rapport.regle": "Vélocité : moyenne des points terminés des 3 derniers sprints clos ; date probable = aujourd’hui + ⌈reste ÷ vélocité⌉ sprints ; fourchette avec la plus forte et la plus faible vélocité.",
  "pgmRoadmap.tableauTitre": "Sprints des projets rattachés",
  "pgmRoadmap.friseChargement": "Lecture de la frise produit…",
  "pgmRoadmap.friseErreur": "La frise produit du programme n’a pas pu être lue.",
  "pgmRoadmap.friseTitre": "Roadmap produit des projets",
  "pgmRoadmap.jalonCible": "Jalon cible du programme : {{j}}{{d}}",
  "pgmRoadmap.sansJalon": "Aucun jalon cible : fixez-le dans les réglages du programme.",
  "navdesc./calendrier": "Déploiements réalisés et prévus, dates cibles des versions et périodes de gel",
  "navdesc./programme/rapport": "Objectif, risques, vélocité réelle et prévision de fin ; export CSV et impression",
  "pgmTech.changementsTitre": "Demandes de changement du programme",
  "pgmTech.changementsDescription": "Les demandes de changement et les propagations du programme et de ses projets, avec les indicateurs du flux.",
  "pgmTech.modifier": "Modifier le standard : demande de changement ou propagation aux projets héritiers",
  "baseline.modifierAide": "« Modifier… » ouvre une demande de changement : analyse d’impact, revue, puis baseline vN+1 à l’approbation.",
  "baseline.demandesOuvertes": "Demandes de changement ouvertes",
  "chg.liste.chargement": "Lecture des demandes de changement…",
  "baseline.demandesIllisibles": "Demandes de changement illisibles pour l’instant.",
  "baseline.aucuneDemande": "Aucune demande en cours sur ce projet.",
  "baseline.toutesDemandes": "Toutes les demandes de changement",
  "baseline.colActions": "Actions",
  "baseline.completer": "Compléter par une demande",
  "baseline.demanderDerogation": "Demander une dérogation",
  "baseline.filtreesPlateforme": "{{n}} entrée(s) masquée(s) : aucune pile de la plateforme choisie ne les génère.",
  "baseline.pileNonQualifiee": "non qualifiée : générabilité à mesurer",
  "baseline.pileQualifiee": "qualifiée",
  "baseline.pileTitre": "Pile de génération",
  "baseline.pileAide": "L’IA crée l’application avec une pile validée par la plateforme : seules les piles validées sont sélectionnables ; les autres arrivent dans une version ultérieure.",
  "baseline.pileAucune": "Aucune pile de génération pour cette plateforme : choisissez sur mesure, catégorie par catégorie.",
  "baseline.pileAucuneValidee": "Aucune pile n’est encore validée pour cette plateforme : la génération par l’IA viendra avec elles ; le lancement reste possible sur mesure.",
  "baseline.pileValidee": "validée",
  "baseline.pileAVenir": "À venir",
  "baseline.pileNonSelectionnable": "Pas encore sélectionnable : {{motif}}",
  "baseline.pileSurMesure": "Sur mesure (choix par catégorie ci-dessous)",
  "baseline.pileErreur": "Le catalogue des piles n’a pas pu être lu : {{message}}",
  "baseline.pileChargement": "Lecture des piles de génération…",
  "baseline.plateforme.desktop": "Bureau (desktop)",
  "baseline.plateforme.mobile": "Mobile",
  "baseline.plateforme.web": "Web",
  "baseline.plateformeAide": "Web, mobile ou bureau : elle désigne les piles de génération possibles et filtre les langages, frameworks et bases proposés ci-dessous.",
  "baseline.plateformeAucune": "Non précisée",
  "baseline.plateformePiles": "Piles de génération pour cette plateforme :",
  "baseline.plateformeTitre": "Plateforme cible",
  "baseline.plateformeVide": "Aucune plateforme au catalogue de l’organisation : le jeu de départ en propose trois (web, mobile, bureau).",
  "chg.liste.refus": "Les demandes de changement de ce projet ne vous sont pas ouvertes : ses membres les lisent.",
  "chg.liste.erreur": "Demandes illisibles : la passerelle n’a pas répondu ; rien n’a changé.",
  "chg.liste.titre": "Demandes de changement",
  "chg.liste.description": "Changer une valeur technologique du projet : brouillon, analyse d’impact, revue par une autre personne, baseline vN+1 à l’approbation, reprise suivie jusqu’à la clôture.",
  "chg.liste.baseline": "Baseline courante : v{{v}}.",
  "chg.liste.voirBaseline": "Voir la baseline",
  "chg.liste.nouvelle": "Nouvelle demande",
  "chg.liste.verrous": "Catégories verrouillées",
  "chg.liste.verrou": "{{c}} : {{ref}} est en cours — une autre demande sur cette catégorie reste un brouillon.",
  "chg.liste.vide": "Aucune demande de changement",
  "chg.liste.videLecture": "Le propriétaire ou un contributeur du projet ouvre une demande depuis la baseline (« Modifier… »).",
  "chg.liste.videAide": "La baseline n’a jamais changé. « Nouvelle demande » ou « Modifier… » sur une catégorie de la baseline en ouvre une.",
  "chg.det.chargementBaseline": "Lecture de la baseline…",
  "chg.liste.erreurBaseline": "Baseline illisible : impossible de proposer une valeur.",
  "chg.det.refus": "Cette demande ne vous est pas ouverte, ou elle n’existe pas dans cette portée.",
  "chg.det.chargement": "Lecture de la demande…",
  "chg.det.erreur": "Demande illisible : la passerelle n’a pas répondu ; rien n’a changé.",
  "chg.det.retour": "← Toutes les demandes",
  "chg.det.niveauPropose": "niveau proposé par l’outil : {{n}}",
  "chg.sensible": "sensible",
  "chg.det.valeurs": "Valeur actuelle : {{avant}} → proposée : {{apres}}",
  "chg.det.aucune": "aucune",
  "chg.det.motif": "Motif : {{m}}",
  "chg.det.meta": "Ouverte par {{auteur}} le {{date}} · urgence {{u}}",
  "chg.det.echeance": "échéance {{date}}",
  "chg.det.baseline": "baseline v{{v}} écrite le {{date}}",
  "chg.det.echue": "Échéance dépassée : la propagation n’est pas vérifiée — conformité rouge jusqu’à la non-régression verte.",
  "chg.det.parent": "Héritée de",
  "chg.det.rapprocher": "À rapprocher de la demande ouverte",
  "chg.det.refusee": "Refusée : {{m}}",
  "chg.det.close": "Close par {{qui}} : {{note}}",
  "chg.det.cycle": "Cycle de la demande",
  "chg.act.modifier": "Modifier le brouillon",
  "chg.act.analyser": "Analyser l’impact",
  "chg.ann.analyse": "Analyse terminée : le rapport d’impact est à jour et la catégorie est verrouillée.",
  "chg.act.reprendre": "Reprendre la propagation",
  "chg.ann.reprise": "Propagation reprise : les héritiers non appliqués ont été traités.",
  "chg.act.abandonner": "Abandonner",
  "chg.act.motifAbandon": "Motif de l’abandon",
  "chg.ann.abandon": "Demande abandonnée.",
  "chg.det.decision": "Revue et décision",
  "chg.det.sansApprobation": "Aucune approbation requise : la propagation est un acte du détenteur de la source.",
  "chg.det.approbations": "Approbations : {{k}} sur {{n}} requise(s) — jamais l’auteur",
  "chg.det.approuve": "approuvé",
  "chg.det.refuse": "refusé",
  "chg.det.par": "par {{qui}} le {{date}}",
  "chg.act.approuver": "Approuver",
  "chg.act.motifApprobation": "Commentaire de décision",
  "chg.ann.approuve": "Approbation enregistrée.",
  "chg.act.refuser": "Refuser",
  "chg.act.motifRefus": "Motif du refus",
  "chg.ann.refuse": "Demande refusée, motif tracé.",
  "chg.ann.modifie": "Brouillon enregistré.",
  "chg.act.adr": "ADR de changement (majeur)",
  "chg.act.sansAdr": "— aucune —",
  "chg.act.soumettre": "Envoyer en revue",
  "chg.ann.soumis": "Demande en revue : un approbateur distinct décide.",
  "chg.ann.confirme": "Confirmation « {{d}} » enregistrée à votre nom.",
  "chg.conf.titre": "Confirmations humaines nommées",
  "chg.conf.faite": "« {{texte}} » — {{qui}}, {{date}}",
  "chg.conf.attendue": "non analysée, confirmation attendue",
  "chg.conf.dimension": "Dimension",
  "chg.conf.texte": "Ce que vous avez vérifié",
  "chg.champRequis": "Ce champ est obligatoire.",
  "chg.conf.exemple": "Par exemple : « J’ai vérifié les environnements : recette, production ». Pour une catégorie sensible, nommez la catégorie.",
  "chg.conf.envoyer": "Confirmer à mon nom",
  "chg.rep.titre": "Reprise",
  "chg.rep.aucun": "Aucun item de reprise : ajoutez-en pour suivre les éléments touchés.",
  "chg.rep.avancement": "Reprise · {{ref}} · {{k}}/{{m}} items faits",
  "chg.rep.fait": "fait",
  "chg.rep.aFaire": "à faire",
  "chg.act.ajouterItem": "Ajouter un item de reprise",
  "chg.act.titreItem": "Titre de l’item",
  "chg.ann.item": "Item de reprise ajouté au backlog.",
  "chg.act.clore": "Clore la demande",
  "chg.act.nonRegression": "Non-régression (périmètre du rapport, environnement attesté)",
  "chg.ann.close": "Demande close.",
  "chg.act.garderEcart": "Garder l’écart",
  "chg.act.motifEcart": "Motif de l’écart gardé",
  "chg.ann.ecart": "Écart gardé, motif tracé.",
  "chg.act.valider": "Valider la reprise",
  "chg.ann.verifiee": "Reprise validée : la propagation est vérifiée.",
  "chg.ann.propage": "Propagation lancée : chaque héritier touché reçoit sa baseline « propagée » et un élément d’attention.",
  "chg.prop.titre": "Propagation aux héritiers",
  "chg.prop.lu": "J’ai lu l’impact : la valeur sera écrite tout de suite dans la baseline de chaque héritier touché.",
  "chg.prop.nom": "Saisissez le nom de la catégorie sensible : « {{c}} »",
  "chg.act.propager": "Propager aux héritiers",
  "chg.dlg.modifierTitre": "Brouillon {{ref}}",
  "chg.dlg.nouvelleTitre": "Nouvelle demande de changement",
  "chg.dlg.aide": "La baseline ne change jamais directement : la demande est analysée (impact), revue, puis approuvée par une autre personne ; la baseline vN+1 s’écrit à l’approbation.",
  "chg.dlg.categorie": "Catégorie",
  "chg.dlg.actuelle": "Valeur actuelle : {{v}}",
  "chg.dlg.aucune": "aucune (catégorie à compléter)",
  "chg.dlg.sensible": "catégorie sensible : changement majeur, deux approbations",
  "chg.dlg.verrou": "{{ref}} est déjà en cours sur cette catégorie : votre demande restera un brouillon, son analyse sera refusée jusqu’à la clôture de {{ref}}.",
  "chg.dlg.voir": "Voir {{ref}}",
  "chg.dlg.valeurProposee": "Valeur proposée",
  "chg.dlg.natCatalogue": "Entrée du catalogue",
  "chg.dlg.natHors": "Hors catalogue (tracée par une ADR)",
  "chg.dlg.natIntegre": "Intégré à la pile générée",
  "chg.dlg.entree": "Entrée",
  "chg.dlg.choisir": "— choisir —",
  "chg.dlg.aucuneEntree": "Aucune entrée du catalogue dans cette catégorie : proposez une valeur hors catalogue.",
  "chg.dlg.entreeRequise": "Choisissez une entrée.",
  "chg.dlg.produit": "Produit",
  "chg.dlg.produitRequis": "Nommez le produit.",
  "chg.dlg.version": "Version ou plage",
  "chg.dlg.motif": "Motif",
  "chg.dlg.motifRequis": "Le motif est obligatoire.",
  "chg.dlg.urgence": "Urgence",
  "chg.dlg.niveau": "Niveau",
  "chg.dlg.niveauOutil": "proposé par l’outil",
  "chg.dlg.niveauMajeur": "majeur (ADR de changement, séparation des tâches)",
  "chg.dlg.enregistrer": "Enregistrer le brouillon",
  "chg.dlg.creer": "Créer le brouillon",
  "chg.dlg.titreOrg": "Changer une valeur du catalogue de l’organisation",
  "chg.dlg.titrePgm": "Changer le standard du programme",
  "chg.dlg.aideMode": "Choisissez d’abord le mode. Les héritiers qui ont défini la catégorie eux-mêmes ou obtenu une dérogation ne sont jamais écrasés : ils sont seulement informés.",
  "chg.dlg.mode": "1. Mode",
  "chg.dlg.modeA": "Analyse d’impact, revue et approbation par une autre personne ; chaque héritier reçoit une demande « à examiner » qu’il accepte ou dont il garde l’écart.",
  "chg.dlg.modeB": "La valeur est écrite tout de suite dans la baseline de chaque héritier qui l’hérite (« reprise à valider », ambre puis rouge à l’échéance).",
  "chg.dlg.sensibleDeux": "Catégorie sensible : majeur, confirmation renforcée et deux personnes.",
  "chg.dlg.entreeProposee": "Entrée proposée",
  "chg.dlg.remplacee": "Entrée remplacée (facultatif)",
  "chg.dlg.aucuneRemplacee": "— aucune —",
  "chg.dlg.apres": "Statut de l’entrée remplacée après application",
  "chg.dlg.echeance": "Échéance de la reprise (jours)",
  "chg.dlg.delaiInvalide": "De 1 à 365 jours (30 par défaut).",
  "chg.der.faite": "Dérogation demandée (n° {{id}}) : elle suit le circuit des dérogations — revue, puis décision par une autre personne.",
  "chg.der.titre": "Demander une dérogation — {{p}}",
  "chg.der.aide": "« {{p}} » est imposé par l’organisation pour « {{c}} ». S’en écarter exige une dérogation motivée, datée et approuvée (ORG-05).",
  "chg.der.justification": "Justification",
  "chg.der.controles": "Contrôles compensatoires (un par ligne)",
  "chg.der.responsable": "Responsable",
  "chg.der.echeance": "Échéance",
  "chg.der.envoyer": "Demander la dérogation",
  "chg.pf.chargement": "Lecture du portefeuille des changements…",
  "chg.pf.refusProgramme": "Ce programme ne vous est pas ouvert : ses membres lisent ses demandes de changement.",
  "chg.pf.refusOrganisation": "Le portefeuille des changements de l’organisation ne vous est pas ouvert.",
  "chg.pf.erreur": "Portefeuille illisible : la passerelle n’a pas répondu ; rien n’a changé.",
  "chg.pf.aidePgm": "Les demandes du programme et celles de ses projets. Changer le standard : une demande de changement (mode A) ou, pour le propriétaire du programme, une propagation aux projets héritiers (mode B).",
  "chg.pf.aideOrg": "Les demandes de l’organisation, de ses programmes et de ses projets. Une demande d’organisation calcule l’impact projet par projet et n’écrase jamais un projet qui a défini la catégorie ou obtenu une dérogation.",
  "chg.pf.videLecture": "Aucune demande ni propagation dans cette portée pour l’instant.",
  "chg.pf.videAide": "Aucune demande ni propagation pour l’instant : « Nouvelle demande » en ouvre une, en choisissant d’abord le mode.",
  "chg.pf.filtreEtat": "État",
  "chg.pf.tous": "Tous",
  "chg.pf.filtreCategorie": "Catégorie",
  "chg.pf.toutes": "Toutes",
  "chg.pf.filtreProjet": "Projet",
  "chg.pf.filtreVide": "Aucune demande ne correspond à ces filtres.",
  "chg.pf.chargementCatalogue": "Lecture du catalogue…",
  "chg.pf.erreurCatalogue": "Catalogue illisible : impossible de proposer une entrée.",
  "chg.echue": "échue",
  "chg.fermer": "Fermer",
  "chg.tableCaption": "Demandes de changement technologique",
  "chg.col.ref": "Demande",
  "chg.col.portee": "Portée",
  "chg.col.categorie": "Catégorie",
  "chg.col.valeurs": "Actuelle → proposée",
  "chg.col.niveauMode": "Niveau · mode",
  "chg.col.etat": "État",
  "chg.col.reprise": "Reprise",
  "chg.col.echeance": "Échéance",
  "chg.heriteeDe": "héritée de {{ref}}",
  "chg.repriseKm": "{{k}}/{{m}}",
  "chg.ind.titre": "Indicateurs du flux des changements",
  "chg.ind.vide": "Sans donnée : aucune demande de changement pour l’instant. Les indicateurs se calculent dès la première.",
  "chg.ind.caption": "Indicateurs par niveau et par mode",
  "chg.ind.niveauMode": "Niveau · mode",
  "chg.ind.ouvertes": "Ouvertes",
  "chg.ind.refus": "Taux de refus",
  "chg.ind.delai": "Délai jusqu’à la baseline (médiane · 85e c.)",
  "chg.ind.reprise": "Délai de reprise (médiane · 85e c.)",
  "chg.ind.partPropagation": "Part des propagations automatiques (mode B) : {{p}}",
  "chg.imp.aucun": "Aucun élément touché.",
  "chg.imp.titre": "Rapport d’impact",
  "chg.imp.absent": "Pas encore analysé : « Analyser l’impact » produit le rapport et verrouille la catégorie.",
  "chg.imp.du": "Analysé le {{date}}",
  "chg.imp.exigences": "Exigences",
  "chg.imp.adrs": "ADR",
  "chg.imp.items": "Items de backlog",
  "chg.imp.tests": "Tests",
  "chg.imp.projets": "Projets",
  "chg.imp.programmes": "Programmes",
  "chg.imp.vide": "Aucun élément touché parmi ce qui est analysé.",
  "chg.imp.risque": "Risque de régression",
  "chg.imp.analyse": "Analysé : {{liste}}",
  "chg.imp.nonAnalyse": "non analysé : {{liste}} — confirmation humaine nommée exigée",
  "chg.imp.generabilite": "Générabilité après changement",
  "chg.imp.generable": "générable ({{profil}})",
  "chg.imp.nonQualifie": "profil non qualifié — sa requalification relève de la plateforme",
  "chg.imp.nonCouvert": "non générable : aucune mission « Générer l’application » ne sera possible",
  "chg.imp.nonCouverts": "non couverts : {{p}}",
  "chg.imp.proche": "plus proche générable : {{p}} (sans {{sans}})",
  "chg.imp.heritiersTitre": "Impact héritier par héritier",
  "chg.imp.devientNonGenerable": "ne sera plus générable",
  "chg.imp.masques": "{{n}} héritier(s) qui ne vous sont pas ouverts : comptés, jamais nommés.",
  "chg.her.total": "{{n}} héritier(s)",
  "chg.her.pending": "{{n}} non appliquée(s)",
  "chg.her.to_validate": "{{n}} reprise(s) à valider",
  "chg.her.verified": "{{n}} vérifiée(s)",
  "chg.her.to_examine": "{{n}} à examiner",
  "chg.her.deviation_kept": "{{n}} écart(s) gardé(s)",
  "chg.her.excluded": "{{n}} non touché(s)",
  "chg.her.to_reconcile": "{{n}} à rapprocher",
  "chg.her.titre": "Héritiers",
  "chg.her.aucun": "Aucun héritier touché.",
  "chg.her.version": "baseline v{{v}}",
  "chg.her.rapprocher": "à rapprocher de {{ref}}",
  "chg.etat.draft": "brouillon",
  "chg.etat.analysis": "analysée — confirmations attendues",
  "chg.etat.in_review": "en revue",
  "chg.etat.refused": "refusée",
  "chg.etat.rework": "approuvée — reprise en cours",
  "chg.etat.closed": "close",
  "chg.etat.cancelled": "abandonnée",
  "chg.etat.propagating": "propagation en cours",
  "chg.etat.propagated": "propagée",
  "chg.etat.to_examine": "à examiner",
  "chg.etat.deviation_kept": "écart gardé",
  "chg.etat.pending": "propagation non appliquée",
  "chg.etat.to_validate": "reprise à valider",
  "chg.etat.verified": "vérifiée",
  "chg.etat.excluded": "non touché (défini ou dérogé)",
  "chg.etat.to_reconcile": "à rapprocher",
  "chg.niveau.major": "majeur",
  "chg.niveau.minor": "mineur",
  "chg.mode.propagation": "propagation aux héritiers (mode B)",
  "chg.mode.change": "demande de changement (mode A)",
  "chg.modeCourt.propagation": "B · propagation",
  "chg.modeCourt.change": "A · demande",
  "chg.urgence.low": "faible",
  "chg.urgence.normal": "normale",
  "chg.urgence.high": "haute",
  "chg.portee.project": "projet",
  "chg.portee.program": "programme",
  "chg.portee.organisation": "organisation",
  "chg.dim.code": "code et révisions",
  "chg.dim.environments": "environnements",
  "chg.dim.versions": "versions et livraisons",
  "chg.dim.design": "Design (charte, maquettes, parcours)",
  "chg.couv.requirements": "exigences",
  "chg.couv.adrs": "ADR",
  "chg.couv.backlog": "items de backlog",
  "chg.couv.tests": "tests",
  "chg.couv.generability": "générabilité",
  "chg.couv.heirs": "héritiers",
  "chg.issue.touched": "touché",
  "chg.issue.excluded_defined": "non touché : catégorie définie par l’héritier",
  "chg.issue.excluded_waiver": "non touché : dérogation",
  "chg.issue.to_reconcile": "à rapprocher : une demande y est ouverte",
  "chg.issue.no_baseline": "sans baseline",
  "chg.risque.low": "faible",
  "chg.risque.medium": "moyen",
  "chg.risque.high": "élevé",
  "chg.r.verrou": "Une demande est déjà en cours sur cette catégorie : la catégorie est verrouillée jusqu’à sa clôture.",
  "chg.r.confirmation": "Confirmez d’abord, en vous nommant, chaque dimension que l’outil n’analyse pas (code, environnements, versions, Design).",
  "chg.r.adr": "Changement majeur : liez une ADR de changement avant la revue.",
  "chg.r.autoApprobation": "L’auteur d’une demande ne la décide pas : un approbateur distinct est requis.",
  "chg.r.dejaDecide": "Vous avez déjà donné votre décision sur cette demande.",
  "chg.r.decideur": "Seul le propriétaire de la portée décide cette demande.",
  "chg.r.repriseOuverte": "Tous les items de reprise doivent être faits avant la clôture.",
  "chg.r.etat": "Cette action n’est pas possible dans l’état actuel de la demande.",
  "chg.r.motif": "Un motif est obligatoire.",
  "chg.r.source": "La propagation est réservée à qui détient la source (administration de l’organisation, propriétaire du programme).",
  "chg.r.sensible": "Catégorie sensible : saisissez le nom exact de la catégorie et obtenez l’accord d’une seconde personne.",
  "chg.r.impact": "Confirmez avoir lu l’impact avant de propager.",
  "chg.r.baseline": "Une nouvelle version de baseline exige une demande décidée qui la référence.",
  "chg.r.sansBaseline": "Ce projet n’a pas encore de baseline : terminez d’abord son lancement.",
  "chg.r.inacheve": "Lancement inachevé : terminez le lancement avant de demander un changement.",
  "chg.r.ecriture": "Lecture seule : le propriétaire ou un contributeur du projet ouvre une demande.",
  "chg.r.admin": "Lecture seule : l’administration de l’organisation (administrateur de la plateforme) ouvre et décide les demandes d’organisation.",
  "chg.r.programme": "Lecture seule : le propriétaire ou un contributeur du programme ouvre une demande ; son propriétaire la décide.",
  "chg.r.imposee": "Entrée imposée par l’organisation : la remplacer demande une dérogation accordée.",
  "chg.r.unique": "Catégorie à choix unique : une seule valeur.",
  "chg.r.manquante": "Catégorie obligatoire : elle ne peut pas rester vide.",
  "chg.jours": "{{n}} j",
  "chg.clo.titre": "Clôture",
  "chg.act.cloturer": "Clôturer",
  "chg.r.heritiersOuverts": "Des héritiers n’ont pas fini (non appliqués, à examiner, reprise à valider ou à rapprocher) : clôturez quand chacun est terminé.",
  "architecture.api.confirmee": "Servie",
  "architecture.api.nonRelevee": "Non relevée",
  "architecture.api.pasDeReleve": "pas de relevé",
  "architecture.api.releve": "{{c}} sur {{n}} route(s) confirmée(s) par le relevé d’aperçu (routes réellement servies par l’application démarrée).",
  "architecture.api.sansReleve": "Aucun relevé d’aperçu pour cette révision : les routes sont lues dans le code, non confirmées par une exécution.",
  "architecture.api.titre": "Routes exposées",
  "architecture.api.vide": "Aucune route à afficher",
  "architecture.arbre.aucune": "Aucune révision retenue",
  "architecture.arbre.missing": "Révision introuvable sur disque",
  "architecture.arbre.unavailable": "Applications non montées",
  "architecture.arbre.unverified": "Arbre non conforme au manifeste",
  "architecture.arbre.verified": "Arbre vérifié",
  "architecture.baseline.absente": "Non retrouvée dans la révision",
  "architecture.baseline.aide": "Baseline v{{v}} : chaque valeur est cherchée PAR NOM (mot entier) dans les technologies et dépendances de la révision — un indice, pas une preuve.",
  "architecture.baseline.nonDerivee": "Révision non analysée",
  "architecture.baseline.ouvrir": "Ouvrir Choix et baseline",
  "architecture.baseline.retrouvee": "Retrouvée dans la révision",
  "architecture.baseline.titre": "Baseline technologique et révision livrée",
  "architecture.baseline.vide": "Le projet n’a pas de baseline technologique",
  "architecture.chargement": "Lecture des versions et de leurs révisions…",
  "architecture.chargementVersion": "Lecture de la révision et de son SBOM…",
  "architecture.col.analyseLe": "Analysé le",
  "architecture.col.chemin": "Chemin",
  "architecture.col.composant": "Composant",
  "architecture.col.composants": "Composants",
  "architecture.col.constats": "Constats",
  "architecture.col.dependDe": "Dépend de",
  "architecture.col.dependance": "Dépendance",
  "architecture.col.dependances": "Dépendances",
  "architecture.col.ecosysteme": "Écosystème",
  "architecture.col.empreinte": "Empreinte",
  "architecture.col.etat": "État",
  "architecture.col.fichiers": "Fichiers",
  "architecture.col.gestionnaire": "Gestionnaire",
  "architecture.col.licences": "Licences",
  "architecture.col.lignes": "Lignes",
  "architecture.col.methode": "Méthode",
  "architecture.col.outil": "Outil et base",
  "architecture.col.pile": "Pile",
  "architecture.col.provenance": "Écrit par",
  "architecture.col.relation": "Relation",
  "architecture.col.releve": "Relevé",
  "architecture.col.revision": "Révision",
  "architecture.col.routes": "Routes",
  "architecture.col.sbom": "SBOM",
  "architecture.col.source": "Source",
  "architecture.col.technologie": "Technologie",
  "architecture.col.type": "Type",
  "architecture.col.version": "Version",
  "architecture.col.versionLivree": "Version",
  "architecture.col.vulnerabilites": "Vulnérabilités",
  "architecture.composant.aucun": "Aucun",
  "architecture.composant.aucune": "Aucune",
  "architecture.composant.baseSansFichier": "Base de la pile : aucun fichier de schéma livré, les tables sont créées par le code.",
  "architecture.composant.dependDe": "Dépend de",
  "architecture.composant.dependances": "Dépendances importées",
  "architecture.composant.description": "Composant de l’application livrée par une version",
  "architecture.composant.entree": "Point d’entrée {{e}} · port {{p}}",
  "architecture.composant.fichiers": "Fichiers ({{n}})",
  "architecture.composant.fichiersListe": "Fichiers du composant",
  "architecture.composant.liens": "Liens",
  "architecture.composant.routes": "Routes déclarées ({{n}})",
  "architecture.composant.sansRoute": "Ce composant ne déclare aucune route.",
  "architecture.composant.serviceSansFichier": "Service de la pile : son image est construite par le gabarit à partir des modules.",
  "architecture.composant.tables": "Tables : {{l}}",
  "architecture.composant.titre": "Composant",
  "architecture.composant.utilisePar": "Utilisé par",
  "architecture.composant.version": "version {{v}}, révision {{r}}",
  "architecture.composants.aide": "Services, base, modules de code et regroupements, dérivés des fichiers vérifiés de la révision ; « dépend de » vient des imports lus dans le code.",
  "architecture.composants.baseInutilisee": "(prévue par la pile, non utilisée par le code)",
  "architecture.composants.titre": "Composants de l’application livrée",
  "architecture.composants.vide": "Aucun composant dérivé",
  "architecture.composants.videAide": "Il faut une révision retenue par la version, dont l’arbre concorde avec son manifeste.",
  "architecture.dependance.absente": "absente",
  "architecture.dependance.courante": "(cette version)",
  "architecture.dependance.declaree": "Déclarée dans {{f}}{{s}}",
  "architecture.dependance.description": "Dépendance de l’application livrée par une version",
  "architecture.dependance.emplacements": "Emplacements dans l’image ({{n}})",
  "architecture.dependance.fixee": "Fixée par le gabarit de la pile : livrée, non choisie.",
  "architecture.dependance.gabarit": "le gabarit de la pile",
  "architecture.dependance.identite": "Identité et licence",
  "architecture.dependance.indirecte": "Dépendance indirecte : le code ne l’importe pas lui-même.",
  "architecture.dependance.licence": "Licence : {{l}} ({{s}})",
  "architecture.dependance.licenceCatalogue": "Le catalogue des piles la déclare sous {{l}}.",
  "architecture.dependance.licenceInconnue": "Licence inconnue : ni le SBOM ni le catalogue des piles ne la donnent.",
  "architecture.dependance.nonDeclaree": "Non déclarée par la révision : tirée à la construction de l’image.",
  "architecture.dependance.nonImportee": "Aucun module ne l’importe dans le code livré.",
  "architecture.dependance.nonResolue": "Version non résolue : l’image n’a pas été construite et signée.",
  "architecture.dependance.resolue": "Version dans l’image : {{v}}",
  "architecture.dependance.titre": "Dépendance",
  "architecture.dependance.utilisee": "Importée par",
  "architecture.dependance.version": "version {{v}}",
  "architecture.dependance.versions": "Dans les versions du projet",
  "architecture.deps.chercher": "Nom contient",
  "architecture.deps.declaree": "déclarée {{s}}",
  "architecture.deps.filtres": "Filtres des dépendances",
  "architecture.deps.nonResolue": "non résolue",
  "architecture.deps.relation": "Relation",
  "architecture.deps.sourceAucune": "Aucune dépendance inventoriée pour cette version.",
  "architecture.deps.sourceDeclarees": "{{d}} dépendance(s) directe(s) déclarée(s) par la révision. L’image n’a pas été construite et signée : versions résolues et dépendances transitives inconnues.",
  "architecture.deps.sourceImage": "{{total}} dépendance(s) : {{d}} directe(s), {{tr}} transitive(s), {{sy}} paquet(s) système — versions résolues et licences relevées dans le SBOM de l’image construite.",
  "architecture.deps.titre": "Inventaire des dépendances (SBOM)",
  "architecture.deps.toutes": "Toutes",
  "architecture.deps.vide": "Aucune dépendance",
  "architecture.deps.videAide": "La version ne retient aucune révision analysable.",
  "architecture.deps.videFiltre": "Aucune dépendance ne correspond aux filtres.",
  "architecture.description": "Composants, API, dépendances (SBOM) et vulnérabilités de l’application livrée, par version — dérivés de la révision retenue.",
  "architecture.fiche.chargement": "Lecture de la révision…",
  "architecture.fiche.introuvable": "Introuvable dans cette version",
  "architecture.fiche.introuvableAide": "L’objet n’existe pas dans la révision retenue par cette version (ou la version n’est pas de ce projet).",
  "architecture.fiche.nonDesigne": "Aucun objet désigné",
  "architecture.fiche.nonDesigneAide": "Ouvrez un composant ou une dépendance depuis la vue Architecture d’une version.",
  "architecture.fiche.ouvrirArchitecture": "Ouvrir Architecture",
  "architecture.fiche.retour": "Retour à l’architecture de la version",
  "architecture.fiche.retourDeps": "Retour aux dépendances de la version",
  "architecture.groupe.assets": "Ressources (styles, images, gabarits)",
  "architecture.groupe.configuration": "Configuration et manifestes",
  "architecture.groupe.infrastructure": "Infrastructure (gabarit)",
  "architecture.groupe.tests": "Tests livrés",
  "architecture.licence.catalogue": "catalogue des piles",
  "architecture.licence.inconnue": "inconnue",
  "architecture.licence.sbom": "relevée dans l’image (SBOM)",
  "architecture.licences.controleKo": "Contrôle des licences à la génération (mode {{m}}) : {{n}} dépendance(s) hors liste admise — {{l}}.",
  "architecture.licences.controleOk": "Contrôle des licences à la génération (mode {{m}}) : aucune dépendance directe hors liste admise de l’organisation.",
  "architecture.licences.inconnues": "{{n}} dépendance(s) sans licence connue : ni le SBOM ni le catalogue des piles ne la donnent.",
  "architecture.licences.titre": "Licences",
  "architecture.licences.vide": "Aucune licence connue",
  "architecture.licences.videAide": "Les licences viennent du SBOM de l’image ou du catalogue fermé des piles.",
  "architecture.ouvrirVersions": "Ouvrir Versions",
  "architecture.provenance.charte": "charte",
  "architecture.provenance.gabarit": "gabarit",
  "architecture.provenance.inconnue": "inconnue",
  "architecture.provenance.mixte": "modèle + gabarit",
  "architecture.provenance.modele": "modèle",
  "architecture.refus": "Ce projet n’est pas accessible avec votre compte : demandez l’accès à son propriétaire.",
  "architecture.relation.direct": "Directe",
  "architecture.relation.system": "Système",
  "architecture.relation.transitive": "Transitive",
  "architecture.revision.detail": "{{f}} fichier(s) · pile {{p}} · générée par {{c}} ({{m}})",
  "architecture.revision.inconnue": "origine introuvable",
  "architecture.revision.mission": "livrable de mission",
  "architecture.revision.sansSbom": "Image non construite ni signée : pas de SBOM d’image (dépendances déclarées seulement).",
  "architecture.revision.sbom": "SBOM du service {{s}} : {{n}} paquet(s), {{o}}",
  "architecture.revision.scaffold": "génération de l’application",
  "architecture.revision.titre": "Révision {{r}}",
  "architecture.routes.derived": "Routes dérivées du code de la révision.",
  "architecture.routes.no_revision": "La version ne retient aucune révision : rien à dériver.",
  "architecture.routes.none_found": "Aucune route reconnue par lecture du code : la pile n’en déclare pas sous une forme lue (décorateurs FastAPI, Express, JAX-RS, Odoo).",
  "architecture.routes.not_supported": "Les routes ne sont pas dérivables : aucun fichier d’un langage lu (Python, JavaScript, Java).",
  "architecture.routes.note.include": "Un routeur est inclus avec un préfixe (include_router) : ce préfixe n’est pas ajouté aux chemins lus.",
  "architecture.routes.note.use": "Un routeur Express est monté sous un préfixe (app.use) : ce préfixe n’est pas ajouté aux chemins lus.",
  "architecture.routes.tree_unverified": "Routes non dérivées : l’arbre de la révision n’est pas vérifié.",
  "architecture.sansProjet": "L’architecture porte sur l’application livrée d’un projet.",
  "architecture.sbom.absent": "Déclarées seulement",
  "architecture.sbom.atteste": "Attesté au registre",
  "architecture.sbom.image": "Image signée",
  "architecture.sbom.nonAtteste": "Non attesté au registre",
  "architecture.sbom.nonVerifie": "Non vérifié",
  "architecture.sbom.telecharger": "Télécharger le SBOM",
  "architecture.severite.critical": "Critique",
  "architecture.severite.high": "Haute",
  "architecture.severite.low": "Basse",
  "architecture.severite.medium": "Moyenne",
  "architecture.severite.negligible": "Négligeable",
  "architecture.severite.unknown": "Inconnue",
  "architecture.titre": "Architecture",
  "architecture.type.assets": "Ressources",
  "architecture.type.configuration": "Configuration",
  "architecture.type.database": "Base de données",
  "architecture.type.infrastructure": "Infrastructure",
  "architecture.type.module": "Module",
  "architecture.type.service": "Service",
  "architecture.type.test": "Tests",
  "architecture.version.ouvrirFiche": "Ouvrir la fiche de version",
  "architecture.version.racine": "Le répertoire des applications n’est pas monté sur la passerelle : aucune révision ne peut être lue.",
  "architecture.version.sansRevision": "Cette version ne retient aucune révision",
  "architecture.version.sansRevisionAide": "L’architecture se dérive de la révision livrée : retenez une révision dans la fiche de version.",
  "architecture.version.titre": "Version {{v}}",
  "architecture.versionIntrouvable": "Version introuvable dans ce projet",
  "architecture.versionIntrouvableAide": "Choisissez une version dans la liste ci-dessus.",
  "architecture.versions.deps": "{{d}} dir. / {{n}}",
  "architecture.versions.titre": "Versions et architecture livrée",
  "architecture.versions.vulnNombre": "{{e}} · {{n}}",
  "architecture.vide": "Aucune version dans ce projet",
  "architecture.videAide": "L’architecture se lit par version : préparez une version qui retient une révision de l’application.",
  "architecture.vue.api": "API",
  "architecture.vue.composants": "Composants",
  "architecture.vue.dependances": "Dépendances et SBOM",
  "architecture.vue.vulnerabilites": "Vulnérabilités",
  "architecture.vues": "Vues de l’architecture",
  "architecture.vuln.analysed": "Analysé",
  "architecture.vuln.analysedAide": "Dernière analyse hors réseau enregistrée pour chaque SBOM de la version.",
  "architecture.vuln.analyses": "Analyses par SBOM",
  "architecture.vuln.aucune": "Aucune connue",
  "architecture.vuln.aucuneAide": "Résultat de l’analyse enregistrée, valable pour la date de sa base de vulnérabilités.",
  "architecture.vuln.aucuneDep": "Aucune vulnérabilité connue de la base utilisée pour cette version du paquet.",
  "architecture.vuln.aucuneTitre": "Aucune vulnérabilité connue de la base utilisée",
  "architecture.vuln.corrigeeEn": "corrigée en {{v}}",
  "architecture.vuln.no_sbom": "Sans SBOM d’image",
  "architecture.vuln.no_sbomAide": "L’image de cette version n’a pas été construite et signée : sans SBOM d’image, aucune analyse n’est possible. « Construire et signer » se demande depuis la fiche de version.",
  "architecture.vuln.nombre": "{{n}} · max {{s}}",
  "architecture.vuln.nonAtteste": "(non attesté au registre : non analysable)",
  "architecture.vuln.not_analysed": "Non analysé",
  "architecture.vuln.not_analysedAide": "Aucune analyse hors réseau n’est enregistrée pour ce SBOM : aucune vulnérabilité n’est affirmée, aucune absence non plus. Une analyse s’enregistre par le pipeline (Grype et sa base importée, sans réseau).",
  "architecture.vuln.partial": "Analyse partielle",
  "architecture.vuln.partialAide": "Une partie seulement des SBOM de la version a été analysée.",
  "architecture.vuln.titre": "Vulnérabilités connues des dépendances",
  "architecture.vuln.titreCourt": "Vulnérabilités",
  "axesSante.aucunProjet": "Aucun projet rattaché",
  "axesSante.aucunProjetAide": "Aucun item d’un projet ne se rattache à cet axe ni à ses descendants.",
  "axesSante.col.axe": "axe",
  "axesSante.col.nature": "nature",
  "axesSante.col.projets": "projets rattachés",
  "axesSante.col.sante": "santé répartie",
  "axesSante.declarer": "Déclarer un axe",
  "axesSante.description": "Santé répartie des projets rattachés à chaque axe partagé : le reporting transverse entre programmes.",
  "axesSante.introuvable": "Cet axe n’existe pas dans votre organisation.",
  "axesSante.items": "{{n}} item(s) rattaché(s)",
  "axesSante.ongletAxes": "Axes et travail rattaché",
  "axesSante.onglets": "Vues des axes",
  "axesSante.ongletSante": "Vue « Axe » — santé",
  "axesSante.plusMasques": "+ {{n}} non accessible(s)",
  "axesSante.retour": "← Tous les axes",
  "axesSante.sansDroit": "Les axes de l’organisation ne vous sont pas accessibles.",
  "axesSante.titre": "Axes de portefeuille — vue « Axe »",
  "axesSante.vide": "Aucun axe partagé",
  "axesSante.videAide": "Déclarez un axe partagé (portefeuille, domaine, capacité) et rattachez-y du travail pour voir la santé répartie.",
  "chemin.absente": "absente",
  "chemin.aJour": "identique à la v{{v}}",
  "chemin.apercu": "Aperçu de migration (depuis la dernière version)",
  "chemin.aucunChangement": "Aucun changement.",
  "chemin.aucunEcart": "Aucun projet visible en écart",
  "chemin.aucunEcartAide": "Tous les projets que vous pouvez voir suivent la référence.",
  "chemin.aucuneRecommandation": "aucune recommandation (ni imposée, ni « adopter »)",
  "chemin.aucuneVersion": "Aucune version publiée",
  "chemin.aucuneVersionAide": "Tant qu’aucune version n’est publiée, les projets se mesurent au brouillon.",
  "chemin.brouillon": "Brouillon (catalogue et référentiel en direct)",
  "chemin.col.categorie": "catégorie",
  "chemin.col.recommande": "recommandé",
  "chemin.depuisPrecedente": "Changements depuis la version précédente",
  "chemin.description": "La configuration recommandée de l’organisation, versionnée, et les projets hérités qui s’en écartent.",
  "chemin.differe": "diffère de la v{{v}}",
  "chemin.empreinteBrouillon": "empreinte du brouillon",
  "chemin.impose": "imposé",
  "chemin.jamaisPublie": "jamais publié",
  "chemin.mesureBrouillon": "Référence : le brouillon (aucune version publiée). {{a}} projet(s) aligné(s).",
  "chemin.mesureVersion": "Référence : version {{v}} publiée. {{a}} projet(s) aligné(s).",
  "chemin.motif": "Motif de la publication",
  "chemin.obligatoire": "(obligatoire)",
  "chemin.ongletEcarts": "Projets en écart",
  "chemin.ongletReference": "Référence et publication",
  "chemin.onglets": "Vues du chemin doré",
  "chemin.ongletVersions": "Versions",
  "chemin.proposer": "Proposer l’alignement (demande de changement)",
  "chemin.proposerAVenir": "Proposer l’alignement — demande de changement (lot T3, à venir)",
  "chemin.publie": "Nouvelle version du chemin doré publiée.",
  "chemin.publieePar": "{{qui}}, {{quand}} — {{c}} catégorie(s), {{r}} règle(s)",
  "chemin.publierAide": "La version fige le brouillon (empreinte SHA-256) ; les projets se mesurent ensuite à elle. Le contenu est calculé, jamais saisi.",
  "chemin.publierBouton": "Publier",
  "chemin.publierTitre": "Publier une version",
  "chemin.regles": "Règles d’organisation actives",
  "chemin.reserve": "Réservé à l’administration de l’organisation (administrateur de la plateforme).",
  "chemin.retiree": "retirée",
  "chemin.retourVersions": "← Toutes les versions",
  "chemin.rien": "rien",
  "chemin.rienAPublier": "Le brouillon est identique à la dernière version : rien à publier.",
  "chemin.sansCategorie": "Le catalogue technologique n’a encore aucune catégorie.",
  "chemin.sansDroit": "Le chemin doré de l’organisation ne vous est pas accessible.",
  "chemin.sansRegle": "Aucune règle active.",
  "chemin.titre": "Chemin doré",
  "chemin.valeurs": "projet : {{p}} — recommandé : {{r}}",
  "chemin.versCatalogue": "Ouvrir le catalogue technologique",
  "chemin.versionIntrouvable": "Cette version n’existe pas dans votre organisation.",
  "chemin.versionMeta": "{{qui}}, {{quand}} — empreinte",
  "chemin.versionTitre": "Version {{v}}",
  "chemin.vide": "Rien à recommander encore",
  "chemin.videAide": "Le chemin doré se calcule depuis le catalogue technologique et les règles actives : renseignez-les d’abord.",
  "gouv.ecart.imposed": "entrée imposée non suivie",
  "gouv.ecart.mandatoryMissing": "catégorie obligatoire non choisie",
  "gouv.ecart.noBaseline": "aucune baseline technologique",
  "gouv.ecart.notRecommended": "hors recommandation",
  "gouv.ecart.retired": "entrée retirée encore utilisée",
  "gouv.ecart.ruleNotInherited": "règle d’organisation non héritée",
  "gouv.effet.none": "sans effet",
  "gouv.effet.observed": "observée",
  "gouv.effet.refused": "refusée",
  "gouv.effet.warned": "avertie",
  "gouv.nonAccessibles": "{{n}} projet(s) non accessible(s) : comptés, jamais nommés — vous n’en êtes pas membre.",
  "gouv.refus.admin": "Décision réservée à l’administration de l’organisation (administrateur de la plateforme).",
  "gouv.refus.controle": "Une règle sans contrôle nommé ne change pas de temps.",
  "gouv.refus.inactive": "Règle non active : activez-la d’abord en « observer » dans le référentiel.",
  "gouv.refus.inattendu": "La passerelle a refusé la demande.",
  "gouv.refus.inchange": "La règle est déjà à ce temps.",
  "gouv.refus.inchangeChemin": "Le chemin doré n’a pas changé depuis la dernière version : rien à publier.",
  "gouv.refus.motif": "Le motif est obligatoire : 20 caractères au moins, au vu de la mesure.",
  "gouv.refus.motifChemin": "Le motif de la publication est obligatoire (10 caractères au moins).",
  "gouv.refus.saut": "On monte d’un temps à la fois : passez d’abord par « avertir ».",
  "gouv.sante.amber": "à surveiller",
  "gouv.sante.green": "bonne",
  "gouv.sante.na": "sans objet",
  "gouv.sante.red": "dégradée",
  "gouv.sante.unknown": "inconnue",
  "gouv.temps.added": "critère du projet",
  "gouv.temps.inForce": "bloquer",
  "gouv.temps.observe": "observer",
  "gouv.temps.proposed": "proposée",
  "gouv.temps.retired": "retirée",
  "gouv.temps.warn": "avertir",
  "org.presence.warned": "avertissement — une règle « avertir » manque (l’approbation passe)",
  "org.ref.troisTemps": "Passer une règle à « avertir » puis « bloquer » : Règles en trois temps.",
  "org.status.warn": "avertir",
  "regles.aucuneDecision": "Aucune décision : la règle est à son temps initial.",
  "regles.col.absences": "absences",
  "regles.col.decision": "dernière décision",
  "regles.col.effets": "averties / refusées",
  "regles.col.evaluations": "évaluations",
  "regles.col.projets": "projets qui l’héritent",
  "regles.col.regle": "règle",
  "regles.col.temps": "temps",
  "regles.controle": "contrôle",
  "regles.decide": "Décision tracée : la règle a changé de temps.",
  "regles.decidePar": "par {{qui}} le {{quand}}",
  "regles.deciderBouton": "Décider",
  "regles.deciderTitre": "Changer de temps",
  "regles.decisions": "Décisions tracées",
  "regles.description": "Observer, avertir, bloquer : chaque règle de l’organisation change de temps par une décision tracée, au vu de sa mesure.",
  "regles.detailDescription": "Temps, décisions tracées et mesure par projet",
  "regles.detailTitre": "Règle",
  "regles.etat": "Temps et mesure ({{j}} jours)",
  "regles.inactive": "Activez d’abord la règle en « observer » dans le Référentiel d’exigences.",
  "regles.instantane": "Mesure au moment de la décision : {{m}} absence(s) sur {{e}} évaluation(s), {{p}} projet(s), {{j}} jours.",
  "regles.introuvable": "Cette règle n’existe pas dans votre organisation, ou ne vous est pas accessible.",
  "regles.lectureSeule": "Lecture seule : décider du temps d’une règle est réservé à l’administration de l’organisation (administrateur de la plateforme).",
  "regles.ligneProjet": "{{e}} éval. · {{m}} abs. · {{w}} avert. · {{f}} refus",
  "regles.liste": "Règles et mesure sur {{j}} jours",
  "regles.mesure": "{{e}} évaluation(s), {{m}} absence(s) dans {{p}} projet(s) ; {{w}} avertie(s), {{f}} refusée(s).",
  "regles.motif": "Motif (au vu de la mesure)",
  "regles.parProjet": "Mesure par projet",
  "regles.parProjetVide": "Aucune évaluation sur la fenêtre",
  "regles.parProjetVideAide": "La règle est mesurée à chaque approbation de spécification d’un projet qui l’hérite.",
  "regles.parTemps": "observer {{o}} · avertir {{a}} · bloquer {{b}} · proposées {{p}}",
  "regles.reserve": "Réservé à l’administration de l’organisation (administrateur de la plateforme) : la décision engage tous les projets qui appliquent l’héritage.",
  "regles.retour": "← Toutes les règles",
  "regles.sansDroit": "Les règles de l’organisation ne vous sont pas accessibles.",
  "regles.temps.avertir": "2. Avertir",
  "regles.temps.avertirAide": "l’absence est signalée (INHERITED_REQUIREMENT_WARNING) ; l’approbation passe.",
  "regles.temps.bloquer": "3. Bloquer",
  "regles.temps.bloquerAide": "l’approbation est refusée (INHERITED_REQUIREMENT_MISSING) dans un projet qui applique l’héritage.",
  "regles.temps.legende": "Les trois temps d’une règle",
  "regles.temps.observer": "1. Observer",
  "regles.temps.observerAide": "chaque absence est mesurée à l’approbation, sans rien gêner.",
  "regles.titre": "Règles en trois temps",
  "regles.unTemps": "On monte d’un temps à la fois ; on peut redescendre.",
  "regles.vers": "Nouveau temps",
  "regles.versReferentiel": "Ouvrir le Référentiel d’exigences",
  "regles.vide": "Aucune règle active dans le référentiel",
  "regles.videAide": "Une règle naît dans le Référentiel d’exigences, en « observer » ; elle apparaît ici dès qu’elle est proposée ou active.",
  "santeOrg.accordee": "accordée",
  "santeOrg.adoption": "en adoption (observer)",
  "santeOrg.aligne": "Aligné sur la référence.",
  "santeOrg.applique": "applique l’héritage",
  "santeOrg.aucuneAnomalie": "Aucune anomalie ouverte.",
  "santeOrg.aucuneDerogation": "Aucune dérogation en cours.",
  "santeOrg.aucuneEvaluation": "Aucune approbation de spécification sur la fenêtre.",
  "santeOrg.aucuneFrequente": "aucune",
  "santeOrg.aucuneLivraison": "Aucune version livrée.",
  "santeOrg.aucuneRegle": "aucune règle active",
  "santeOrg.col.anomalies": "anomalies ouvertes (bloquantes)",
  "santeOrg.col.contournements": "contournements",
  "santeOrg.col.derogations": "dérogations (plus ancienne)",
  "santeOrg.col.ecarts": "écarts au chemin doré",
  "santeOrg.col.livraisons": "livraisons 90 j",
  "santeOrg.col.projet": "projet",
  "santeOrg.col.regles": "règles averties / refusées",
  "santeOrg.col.sante": "santé",
  "santeOrg.contournement": "contournement",
  "santeOrg.dansNProjets": "dans {{n}} projets — la règle ou le chemin doré doit changer",
  "santeOrg.demandee": "demandée",
  "santeOrg.derogationLigne": "{{s}}, {{a}} j, échéance {{e}}",
  "santeOrg.derogationsTitre": "Dérogations demandées ou accordées",
  "santeOrg.description": "Par projet : écart au chemin doré, règles qui avertissent ou bloquent, dérogations et contournements, livraisons, anomalies.",
  "santeOrg.detailDescription": "Conformité du projet à l’organisation : écarts, règles, dérogations, livraisons, anomalies.",
  "santeOrg.detailTitre": "Santé d’un projet",
  "santeOrg.dontBloquants": "({{n}} bloquant)",
  "santeOrg.ecartsTitre": "Écarts au chemin doré",
  "santeOrg.frequentes": "Dérogations fréquentes (≥ 2 projets)",
  "santeOrg.introuvable": "Ce projet n’existe pas dans votre organisation, ou vous n’en êtes pas membre.",
  "santeOrg.jours": "({{n}} j)",
  "santeOrg.livraisonsTitre": "Livraisons et anomalies",
  "santeOrg.ouvrirProjet": "Ouvrir le projet",
  "santeOrg.parProjet": "Par projet (fenêtre de {{j}} jours pour les règles)",
  "santeOrg.partiel": "{{n}} projet(s) illisible(s) : vue partielle.",
  "santeOrg.reglesParTemps": "Règles par temps",
  "santeOrg.reglesTitre": "Règles évaluées ({{j}} jours)",
  "santeOrg.repartition": "Santé répartie",
  "santeOrg.retour": "← Tous les projets",
  "santeOrg.sansDroit": "Le tableau de santé de l’organisation ne vous est pas accessible.",
  "santeOrg.titre": "Santé de la conformité",
  "santeOrg.versRegles": "Règles en trois temps",
  "santeOrg.vide": "Aucun projet visible",
  "santeOrg.videAide": "Vous n’êtes membre d’aucun projet de l’organisation ; les autres sont comptés ci-dessous.",
  "supervisionOrg.avancement": "{{f}}/{{n}} tâches · GPU {{g}} / {{b}} min",
  "supervisionOrg.colonie": "colonie :",
  "supervisionOrg.enCours": "en cours",
  "supervisionOrg.enPause": "en pause",
  "supervisionOrg.nonAccessibles": "{{m}} mission(s) vivante(s) dans {{p}} projet(s) dont vous n’êtes pas membre : comptées, jamais nommées.",
  "supervisionOrg.planApprouve": "plan approuvé",
  "supervisionOrg.planPropose": "plan à approuver",
  "supervisionOrg.rienVisible": "Aucune mission vivante dans les projets dont vous êtes membre.",
  "supervisionOrg.sansDroit": "La supervision des agents de l’organisation ne vous est pas accessible.",
  "supervisionOrg.suspendueCapacite": "suspendue (capacité)",
  "supervisionOrg.totaux": "{{v}} mission(s) vivante(s) dans l’organisation : {{r}} en cours, {{s}} suspendue(s) dont {{c}} pour capacité, {{a}} plan(s) à approuver. File GPU : {{p}} en attente, {{e}} en exécution.",
  "supervisionOrg.vide": "Rien ne tourne",
  "supervisionOrg.videAide": "Aucune mission vivante dans l’organisation : les missions se lancent depuis un projet (Construire).",
  "taxonomy.vueSante": "Vue « Axe » — santé",
  "doublons.titre": "Doublons probables sous cet axe",
  "doublons.chargement": "Recherche des doublons…",
  "doublons.aucun": "Aucun doublon probable",
  "doublons.aucunAide": "Aucune paire d’items de cet axe n’a des titres assez proches (similarité ≥ 0,45).",
  "doublons.similarite": "similarité {{s}}",
  "doublons.fusionner": "Fusionner #{{b}} dans #{{a}}…",
  "nav./org/regles": "Règles en trois temps",
  "navdesc./org/regles": "Observer, avertir, bloquer : le temps de chaque règle, sa mesure et ses décisions tracées",
  "nav./org/chemin-dore": "Chemin doré",
  "navdesc./org/chemin-dore": "Configuration recommandée versionnée et projets hérités en écart (alignement proposé)",
  "nav./org/sante": "Santé de la conformité",
  "navdesc./org/sante": "Par projet : écarts, règles qui avertissent ou bloquent, dérogations, livraisons, anomalies",
  "incidents.sev.sev1": "SEV1 · critique",
  "incidents.sev.sev2": "SEV2 · majeure",
  "incidents.sev.sev3": "SEV3 · mineure",
  "incidents.sev.sev4": "SEV4 · faible",
  "incidents.sevAide.sev1": "service arrêté pour tous",
  "incidents.sevAide.sev2": "fonction majeure touchée",
  "incidents.sevAide.sev3": "gêne partielle, contournement possible",
  "incidents.sevAide.sev4": "gêne mineure",
  "incidents.statut.open": "ouvert",
  "incidents.statut.mitigated": "atténué",
  "incidents.statut.resolved": "résolu",
  "incidents.statut.closed": "clos",
  "incidents.nature.outage": "indisponibilité",
  "incidents.nature.degraded": "dégradation",
  "incidents.nature.limited": "impact limité",
  "incidents.geste.rouvrir": "Rouvrir",
  "incidents.geste.attenuer": "Marquer atténué",
  "incidents.geste.resoudre": "Résoudre",
  "incidents.geste.clore": "Clore",
  "supervisionApp.etat.intact": "intacte",
  "supervisionApp.etat.dans": "dans la marge",
  "supervisionApp.etat.presque": "presque épuisée",
  "supervisionApp.etat.epuise": "épuisée",
  "supervisionApp.etat.nonMesure": "non mesurée",
  "supervisionApp.sante.outage": "indisponible (incident ouvert)",
  "supervisionApp.sante.incident": "incident en cours",
  "supervisionApp.sante.healthy": "sonde saine",
  "supervisionApp.sante.unhealthy": "sonde en échec",
  "supervisionApp.sante.notMeasured": "non mesurée",
  "objectif.modifie": "Objectif modifié",
  "objectif.declare": "Objectif déclaré",
  "objectif.nomCourt": "Nommez l’objectif comme le métier le dit (3 caractères au moins).",
  "objectif.cibleInvalide": "La cible est un pourcentage strictement entre 0 et 100 (ex. 99,5).",
  "objectif.fenetreInvalide": "La fenêtre compte de 1 à 90 jours.",
  "objectif.seuilInvalide": "Le seuil de latence est un nombre de millisecondes (1 à 600 000).",
  "incidents.envRequis": "Choisissez l’environnement touché.",
  "objectif.formModifier": "Modifier l’objectif",
  "objectif.formDeclarer": "Déclarer un objectif de service métier",
  "objectif.nom": "Nom métier",
  "objectif.nomExemple": "Encaissement disponible",
  "objectif.indicateur": "Indicateur",
  "objectif.dispo": "disponibilité",
  "objectif.latence": "latence",
  "objectif.dispoAide": "Part du temps sans indisponibilité ; consommée par les incidents « indisponibilité » de l’environnement.",
  "objectif.latenceAide": "Part des sondes saines sous le seuil ; consommée par les sondes lentes ou en échec des déploiements.",
  "objectif.environnement": "Environnement",
  "incidents.production": "production",
  "objectif.cible": "Cible (%)",
  "objectif.fenetre": "Fenêtre (jours)",
  "objectif.seuil": "Seuil de latence (ms)",
  "objectif.descriptionChamp": "Ce que l’objectif promet (facultatif)",
  "objectif.actif": "Objectif actif",
  "objectif.enregistrer": "Enregistrer",
  "objectif.declarer": "Déclarer l’objectif",
  "incidentFiche.description": "Chronologie, résolution et post-mortem sans blâme d’un incident de production.",
  "incidentFiche.retour": "← Tous les incidents",
  "incidents.titre": "Incidents",
  "incidents.sansProjet": "Les incidents appartiennent à l’application d’un projet.",
  "incidentFiche.chargement": "Lecture de l’incident…",
  "incidentFiche.introuvable": "Incident introuvable",
  "incidentFiche.introuvableAide": "Cet incident n’existe pas dans ce projet, ou le projet ne vous est pas ouvert.",
  "incidentFiche.env": "Environnement",
  "incidentFiche.version": "Version",
  "incidents.nonPrecise": "non précisée",
  "incidentFiche.deploiement": "Déploiement en cause",
  "incidentFiche.retourArriere": "Retour arrière déclenché",
  "incidentFiche.aucunRetour": "aucun",
  "incidentFiche.responsable": "Responsable",
  "incidentFiche.declarePar": "Déclaré par",
  "incidentFiche.debut": "Début de l’impact",
  "incidentFiche.attenue": "Atténué",
  "incidentFiche.resolu": "Résolu",
  "incidentFiche.clos": "Clos",
  "incidentFiche.duree": "Durée d’impact",
  "incidents.enCours": "en cours",
  "incidentFiche.impact": "Impact",
  "incidentFiche.resolution": "Résolution",
  "incidentFiche.statutChange": "Statut de l’incident mis à jour",
  "incidentFiche.closLecture": "Incident clos : sa fiche est en lecture seule.",
  "incidentFiche.resolutionRequise": "Écrivez ce qui a rétabli le service.",
  "incidentFiche.motifRequis": "Écrivez pourquoi l’incident se rouvre.",
  "incidentFiche.faireAvancer": "Faire avancer l’incident",
  "incidents.reserve": "Déclarer ou faire avancer un incident exige d’être propriétaire ou contributeur du projet ; vous gardez la lecture.",
  "incidentFiche.refusPostMortem": "Clore exige le post-mortem publié (section Post-mortem ci-dessous).",
  "incidentFiche.refusAutre": "Ce geste n’est pas permis dans l’état actuel de l’incident.",
  "incidentFiche.champResolution": "Ce qui a rétabli le service",
  "incidentFiche.champMotif": "Motif de la réouverture",
  "incidents.annuler": "Annuler",
  "incidentFiche.marge": "Marge d’incidents consommée",
  "incidentFiche.margeSansObjectif": "Aucun objectif de disponibilité actif sur cet environnement : rien n’est décompté.",
  "incidentFiche.margeNonIndispo": "Ce n’est pas une indisponibilité : il ne consomme pas la marge des objectifs de disponibilité.",
  "incidentFiche.margePart": "{{d}} sur une marge de {{m}}",
  "incidentFiche.fait.declared": "Incident déclaré",
  "incidentFiche.fait.status": "{{de}} → {{vers}}",
  "incidentFiche.fait.note": "Note",
  "incidentFiche.fait.updated": "Fiche modifiée",
  "incidentFiche.fait.defect": "Anomalie reliée",
  "incidentFiche.fait.pmSaved": "Post-mortem enregistré",
  "incidentFiche.fait.pmPublished": "Post-mortem publié",
  "incidentFiche.fait.action": "Action corrective créée",
  "incidentFiche.noteVide": "Écrivez le fait à consigner.",
  "incidentFiche.chronologie": "Chronologie",
  "incidentFiche.ajouterFait": "Ajouter un fait",
  "incidentFiche.noteExemple": "Alerte reçue du support du magasin",
  "incidentFiche.quand": "Quand (facultatif)",
  "incidentFiche.consigner": "Consigner",
  "incidentFiche.anomalieInvalide": "Donnez le numéro d’une anomalie du projet (ex. ANO-17).",
  "incidentFiche.anomalies": "Anomalies reliées",
  "incidentFiche.aucuneAnomalie": "Aucune anomalie reliée. Une anomalie dit l’écart du produit qui a causé ou aggravé la panne.",
  "incidentFiche.relierAnomalie": "Relier une anomalie",
  "incidentFiche.relier": "Relier",
  "incidentFiche.modifie": "Incident modifié",
  "incidentFiche.qualifier": "Qualifier l’incident",
  "incidentFiche.modifier": "Modifier",
  "incidents.champSeverite": "Sévérité",
  "incidents.champNature": "Nature de l’impact",
  "incidents.champResponsable": "Responsable",
  "incidentFiche.retourAide": "Le retour arrière se lance depuis Environnements et déploiements, derrière sa porte ; il se relie ici.",
  "incidentFiche.enregistrer": "Enregistrer",
  "incidents.declare": "Incident déclaré",
  "incidents.description": "Les pannes vécues par les utilisateurs de l’application livrée : déclaration, chronologie, résolution et post-mortem sans blâme.",
  "incidents.chargement": "Lecture des incidents…",
  "incidents.titreCourt": "Donnez un titre d’au moins 3 caractères : ce que vivent les utilisateurs.",
  "incidents.impactRequis": "Décrivez l’impact : qui est touché, et comment.",
  "incidents.regle": "Un incident se déclare dès que des utilisateurs sont gênés. Il passe par « atténué » (le service est rétabli, la cause peut rester), puis « résolu », et se clôt une fois son post-mortem publié.",
  "incidents.filtreStatut": "Statut",
  "incidents.actifs": "en cours (ouverts et atténués)",
  "incidents.tous": "tous",
  "incidents.filtreSeverite": "Sévérité",
  "incidents.toutes": "toutes",
  "incidents.declarer": "Déclarer un incident",
  "incidents.formTitre": "Déclarer un incident de production",
  "incidents.optionsChargement": "Lecture des environnements et des membres…",
  "incidents.champTitre": "Ce que vivent les utilisateurs",
  "incidents.champTitreExemple": "Paiement carte refusé en caisse",
  "incidents.champImpact": "Impact",
  "incidents.champImpactExemple": "Toutes les caisses du magasin, depuis 9 h 40 ; les paiements en espèces passent.",
  "incidents.natureAide": "Une indisponibilité consomme la marge des objectifs de disponibilité de l’environnement.",
  "incidents.champEnv": "Environnement touché",
  "incidents.champVersion": "Version en cause (facultatif)",
  "incidents.champDebut": "Début de l’impact (facultatif)",
  "incidents.enregistrer": "Déclarer",
  "incidents.videActifs": "Aucun incident en cours",
  "incidents.vide": "Aucun incident",
  "incidents.videIndice": "Aucune panne déclarée pour ce filtre. Les incidents résolus et clos restent consultables avec le filtre « tous ».",
  "incidents.legende": "Incidents de production du projet",
  "incidents.colIncident": "incident",
  "incidents.colSeverite": "sévérité",
  "incidents.colStatut": "statut",
  "incidents.colEnv": "environnement · version",
  "incidents.colResponsable": "responsable",
  "incidents.colDebut": "début",
  "incidents.colDuree": "impact",
  "incidents.colPostMortem": "post-mortem",
  "incidents.pmPublie": "publié",
  "incidents.pmBrouillon": "brouillon",
  "incidents.pmAucun": "à rédiger",
  "incidents.voirSupervision": "Voir la supervision et la marge d’incidents des objectifs de service",
  "objectif.retour": "← Supervision de l’application",
  "supervisionApp.sansProjet": "La supervision porte sur l’application d’un projet.",
  "objectif.chargement": "Lecture de l’objectif…",
  "objectif.introuvable": "Objectif introuvable",
  "objectif.introuvableAide": "Cet objectif n’existe pas dans ce projet, ou le projet ne vous est pas ouvert.",
  "objectif.descriptionDefaut": "Objectif de service métier de l’application livrée.",
  "objectif.versionMaj": "version {{v}} · modifiée le {{quand}} par {{qui}}",
  "objectif.avertEpuise": "Marge épuisée sur la fenêtre. C’est un avertissement : aucune promotion ni mise en ligne n’est bloquée.",
  "objectif.avertPresque": "Marge presque épuisée (80 % ou plus). Rien n’est bloqué.",
  "objectif.cibleFenetre": "Cible sur la fenêtre",
  "supervisionApp.colAtteint": "atteint",
  "objectif.marge": "Marge d’incidents",
  "objectif.margeMinutes": "Marge = (100 % − cible) × fenêtre = {{m}} d’indisponibilité tolérée ; reste {{r}}.",
  "objectif.margeSondes": "Marge = (100 % − cible) × {{n}} sondes observées = {{m}} sondes lentes ou en échec tolérées ; reste {{r}}.",
  "objectif.incidents": "Incidents de la fenêtre sur cet environnement",
  "objectif.aucunIncident": "Aucun incident sur la fenêtre : la marge est intacte.",
  "objectif.consomme": "consomme {{d}}",
  "objectif.neConsommePas": "ne consomme pas (pas une indisponibilité)",
  "objectif.sondes": "Sondes de la fenêtre",
  "objectif.aucuneSonde": "Aucune sonde relevée sur la fenêtre : un déploiement avec une URL de santé en relève une.",
  "objectif.sondesLegende": "Sondes HTTP relevées par les déploiements",
  "objectif.colQuand": "relevée le",
  "objectif.colStatut": "statut",
  "objectif.colHttp": "HTTP",
  "objectif.colLatence": "latence",
  "objectif.modifier": "Modifier l’objectif",
  "supervisionApp.reserve": "Déclarer ou modifier un objectif exige d’être propriétaire ou contributeur du projet ; vous gardez la lecture.",
  "postMortem.resume": "Résumé",
  "postMortem.resumeAide": "Ce qui s’est passé, pour qui, combien de temps.",
  "postMortem.cause": "Cause",
  "postMortem.causeAide": "Le mécanisme technique ou organisationnel, pas une personne.",
  "postMortem.facteurs": "Facteurs contributifs",
  "postMortem.facteursAide": "Ce qui a laissé la cause produire la panne, ou l’a prolongée.",
  "postMortem.bien": "Ce qui a bien fonctionné",
  "postMortem.bienAide": "Détection, contournement, communication.",
  "postMortem.lecons": "Enseignements",
  "postMortem.leconsAide": "Ce que l’équipe change dans sa façon de faire.",
  "postMortem.enregistre": "Post-mortem enregistré",
  "postMortem.publieToast": "Post-mortem publié : l’incident peut être clos",
  "postMortem.actionCourte": "Décrivez l’action en 3 caractères au moins.",
  "postMortem.titre": "Post-mortem",
  "postMortem.publie": "publié",
  "postMortem.brouillon": "brouillon",
  "postMortem.aRediger": "à rédiger",
  "postMortem.sansBlame": "Sans blâme : on décrit des faits et des mécanismes, jamais une faute de personne. Chacun a agi au mieux avec ce qu’il savait ; la question est ce qui a rendu l’erreur possible.",
  "postMortem.mentions": "Ce texte cite {{noms}}. Reformulez autour du mécanisme plutôt que de la personne — c’est un avertissement, la publication reste possible.",
  "postMortem.publiePar": "Publié par {{qui}} le {{quand}}",
  "postMortem.enregistrer": "Enregistrer le brouillon",
  "postMortem.publier": "Publier",
  "postMortem.refusResolu": "Le post-mortem se publie une fois l’incident résolu ; enregistrez le brouillon d’ici là.",
  "postMortem.refusAutre": "La publication n’est pas permise dans l’état actuel.",
  "postMortem.actions": "Actions correctives",
  "postMortem.aucuneAction": "Aucune action. Chaque action devient une tâche du backlog, suivie comme les autres.",
  "postMortem.itemSupprime": "item supprimé",
  "postMortem.nouvelleAction": "Nouvelle action corrective",
  "postMortem.actionExemple": "Alerter 30 jours avant l’expiration d’un certificat",
  "postMortem.creerAction": "Créer la tâche",
  "supervisionApp.sansSonde": "aucune sonde dans la fenêtre",
  "supervisionApp.sondes": "{{n}} sondes",
  "supervisionApp.titre": "Supervision de l’application",
  "supervisionApp.description": "La santé de chaque environnement de l’application livrée, ses incidents en cours, et les objectifs de service métier avec leur marge d’incidents.",
  "supervisionApp.chargement": "Lecture des environnements, sondes et objectifs…",
  "supervisionApp.avertEpuise": "La marge d’incidents de « {{nom}} » est épuisée. C’est un avertissement : rien n’est bloqué, la mise en ligne reste possible.",
  "supervisionApp.avertPresque": "La marge d’incidents de « {{nom}} » est presque épuisée (80 % ou plus). Rien n’est bloqué.",
  "supervisionApp.voirObjectif": "Voir l’objectif",
  "supervisionApp.environnements": "Environnements de l’application",
  "supervisionApp.aucunEnv": "Aucun environnement",
  "supervisionApp.aucunEnvAide": "Les environnements se déclarent dans Environnements et déploiements ; la supervision suit ensuite leurs déploiements et leurs incidents.",
  "supervisionApp.ouvrirRunops": "Ouvrir Environnements et déploiements",
  "supervisionApp.version": "En service",
  "supervisionApp.aucuneVersion": "aucune version déployée",
  "supervisionApp.dernierDeploiement": "Dernier déploiement",
  "supervisionApp.derniereSonde": "Dernière sonde",
  "supervisionApp.jamaisSondee": "jamais sondée",
  "supervisionApp.sondes7j": "Sondes ({{j}} j)",
  "supervisionApp.aucuneSondeFenetre": "aucune",
  "supervisionApp.sondesSaines": "{{s}} saines sur {{n}}{{p}}",
  "supervisionApp.mediane": "médiane {{ms}} ms",
  "supervisionApp.incidentsEnCours": "Incidents en cours",
  "supervisionApp.aucun": "aucun",
  "supervisionApp.source": "Mesures : la sonde HTTP relevée à chaque déploiement (comme dans Environnements et déploiements) et les incidents déclarés. Aucune sonde périodique ni journal du conteneur n’est encore relevé : un environnement sans sonde est « non mesuré », jamais « sain ».",
  "supervisionApp.objectifs": "Objectifs de service métier",
  "supervisionApp.declarerObjectif": "Déclarer un objectif",
  "supervisionApp.aucunObjectif": "Aucun objectif de service métier",
  "supervisionApp.aucunObjectifAide": "Un objectif dit ce que l’application promet à ses utilisateurs (ex. « Encaissement disponible 99,5 % sur 30 jours ») ; sa marge se consomme par les incidents et les sondes.",
  "supervisionApp.legende": "Objectifs de service métier et marge d’incidents",
  "supervisionApp.colObjectif": "objectif",
  "supervisionApp.colCible": "cible · fenêtre",
  "supervisionApp.colMarge": "marge consommée",
  "supervisionApp.colEtat": "état",
  "supervisionApp.voirIncidents": "Voir les incidents",
  "supervisionApp.voirEnService": "Application en service",
  "supervisionApp.voirSloRuntime": "Objectifs de service du runtime (génération)",
  "nav./incidents": "Incidents",
  "navdesc./incidents": "Incidents de production : déclaration, chronologie, résolution et post-mortem sans blâme",
  "nav./exploitation/supervision": "Supervision de l’application",
  "navdesc./exploitation/supervision": "Santé des environnements livrés, objectifs de service métier et marge d’incidents",
  "cmdk.descriptionObjets": "Rechercher un écran, une action ou un objet (identifiant ou texte)",
  "rech.aide": "Objets : tapez au moins 2 caractères, ou un identifiant (#12, ANO-3, ADR-1).",
  "rech.aucunObjet": "Aucun objet ne correspond à « {{q}} ».",
  "rech.chargement": "Recherche des objets…",
  "rech.contexteOrganisation": "Organisation",
  "rech.contexteProgramme": "Programme {{nom}}",
  "rech.erreur": "La recherche des objets a échoué : {{message}}",
  "rech.groupeTronque": "{{type}} — premiers résultats, précisez la recherche",
  "rech.nObjets": "{{n}} objets trouvés.",
  "rech.partiel": "Résultats partiels : {{types}} illisible(s) pour le moment.",
  "rech.reessayer": "Réessayer",
  "rech.tropLong": "Recherche limitée à 100 caractères.",
  "rech.type.adr": "Décisions (ADR)",
  "rech.type.defect": "Anomalies",
  "rech.type.deployment": "Déploiements",
  "rech.type.item": "Items du backlog",
  "rech.type.mission": "Missions",
  "rech.type.program": "Programmes",
  "rech.type.project": "Projets",
  "rech.type.release": "Versions",
  "rech.type.requirement": "Exigences",
  "rech.type.sprint": "Sprints",
  "rech.type.test_campaign": "Campagnes de test",
  "rech.type.test_case": "Cas de test",
  "rech.unObjet": "1 objet trouvé.",
  "activation.classes": "Au moins {{n}} sortes de caractères parmi minuscules, majuscules, chiffres et symboles.",
  "activation.inconnuLien": "Ce lien d’activation est inconnu. Demandez un nouveau lien à l’administration qui vous l’a envoyé.",
  "activation.okReinit": "Mot de passe changé. Connectez-vous avec {{identifiant}} et le nouveau mot de passe.",
  "activation.demanderOrganisation": "Demandez un nouveau lien à l’administration de votre organisation.",
  "activation.introMembre": "Vous êtes invité dans {{org}} ({{email}}) comme {{role}} : choisissez votre mot de passe. Lien valable jusqu’au {{fin}}.",
  "activation.introReinit": "Réinitialisation de votre accès à {{org}} ({{email}}) : choisissez un nouveau mot de passe ; vos sessions ouvertes seront fermées. Lien valable jusqu’au {{fin}}.",
  "activation.mfa": "Votre organisation exige un second facteur : à votre première connexion, l’écran de connexion vous demandera de configurer une application d’authentification (OTP).",
  "activation.motDePasseMin": "Mot de passe ({{n}} caractères au moins)",
  "activation.desactive": "Ce compte a été désactivé par votre organisation : le lien n’est plus utilisable.",
  "login.motifSessionMax": "Votre session a atteint la durée maximale fixée par votre organisation : reconnectez-vous.",
  "agile.addMemberHintAnnuaire": "Cherchez une personne de l’organisation par son nom, son identifiant ou son e-mail. Une personne qui n’a pas encore de compte s’invite dans l’organisation (Organisation › Invitations).",
  "admin.gererAnnuaire": "Gérer dans l’annuaire",
  "usr.role.org_admin": "Administrateur d’organisation",
  "usr.role.auditor": "Auditeur (lecture seule)",
  "usr.matrice.admin": "Administrateur de la plateforme",
  "usr.acces.lienRevue": "Revue des refus d’habilitation",
  "usr.annuaire.chargement": "Lecture de l’annuaire…",
  "usr.annuaire.erreur": "L’annuaire n’a pas pu être lu.",
  "usr.annuaire.aucunResultat": "Aucune personne ne correspond à ces filtres",
  "usr.annuaire.effacer": "Effacer les filtres",
  "usr.annuaire.vide": "Aucune personne dans l’organisation",
  "usr.annuaire.videIndice": "Invitez la première personne par e-mail.",
  "usr.annuaire.inviter": "Inviter une personne",
  "usr.annuaire.legende": "Personnes de l’organisation : nom, e-mail, rôle d’organisation, statut, projets, programmes, dernier accès",
  "usr.col.personne": "Personne",
  "usr.col.role": "Rôle d’organisation",
  "usr.col.statut": "Statut",
  "usr.col.projets": "Projets · programmes",
  "usr.col.dernierAcces": "Dernier accès",
  "nav./org/utilisateurs": "Utilisateurs",
  "usr.annuaire.descriptionTierce": "Personnes de l’organisation {{o}} (administration de la plateforme : chaque acte s’écrit à son journal).",
  "usr.annuaire.description": "Les personnes de l’organisation, leur rôle, leur statut et leurs appartenances.",
  "usr.annuaire.compteurs": "{{a}} actif(s) · {{i}} invité(s) · {{d}} désactivé(s) · {{adm}} administrateur(s) d’organisation",
  "usr.annuaire.voirInvitations": "Voir les invitations",
  "usr.annuaire.rechercheAria": "Rechercher dans l’annuaire",
  "usr.annuaire.recherche": "Nom ou e-mail",
  "usr.annuaire.chercher": "Chercher",
  "usr.annuaire.tous": "Tous",
  "usr.role.aucun": "Non observé",
  "usr.annuaire.projet": "Projet",
  "usr.lectureSeule": "Consultation seulement : l’annuaire se gère par l’administration de l’organisation.",
  "usr.mode.bloquantTitre": "Mode bloquant : les refus de la matrice sont appliqués",
  "usr.mode.observationTitre": "Mode observation : les refus de la matrice ne sont PAS appliqués",
  "usr.mode.bloquant": "Une permission retirée ici refuse aussitôt l’action correspondante, et chaque refus est journalisé.",
  "usr.mode.observation": "Un refus calculé est seulement journalisé : retirer une permission ici ne protège encore rien. La revue des refus dit quand la matrice peut bloquer.",
  "usr.fiche.retour": "← Annuaire des utilisateurs",
  "usr.fiche.chargement": "Lecture de la fiche…",
  "usr.fiche.erreur": "La fiche n’a pas pu être lue.",
  "usr.fiche.reactive": "Compte réactivé",
  "usr.fiche.deconnecte": "Sessions fermées",
  "usr.fiche.superAdmin": "Administrateur de la plateforme",
  "usr.fiche.vous": "Vous",
  "usr.fiche.identite": "Identité",
  "usr.fiche.identifiant": "Identifiant de connexion",
  "usr.fiche.email": "E-mail",
  "usr.fiche.reference": "Référence technique",
  "usr.fiche.creation": "Entrée dans l’organisation",
  "usr.fiche.desactive": "Désactivé le",
  "usr.fiche.connexion": "Compte de connexion (Keycloak)",
  "usr.fiche.kcActif": "Connexion",
  "usr.fiche.autorisee": "autorisée",
  "usr.fiche.bloquee": "bloquée",
  "usr.fiche.mdp": "Mot de passe",
  "usr.fiche.defini": "défini",
  "usr.fiche.nonDefini": "pas encore choisi",
  "usr.fiche.mfa": "Second facteur (OTP)",
  "usr.fiche.configure": "configuré",
  "usr.fiche.nonConfigure": "non configuré",
  "usr.fiche.actions": "Actions requises",
  "usr.fiche.roleEffectif": "Rôle effectif",
  "usr.fiche.kcInconnu": "L’annuaire ne répond pas ou ne connaît pas ce compte : l’état de connexion n’est pas lisible.",
  "usr.fiche.equipes": "Équipes",
  "usr.fiche.actionsTitre": "Accès et départ",
  "usr.fiche.resetOtp": "Réinitialiser aussi le second facteur (OTP)",
  "usr.fiche.reinitialiser": "Réinitialiser l’accès",
  "usr.fiche.deconnecterTitre": "Fermer toutes les sessions de {{n}} ?",
  "usr.fiche.deconnecterC1": "La personne est déconnectée partout ; ses jetons déjà émis sont refusés.",
  "usr.fiche.deconnecterRev": "Elle peut se reconnecter aussitôt avec ses identifiants.",
  "usr.fiche.deconnecterVerbe": "Déconnecter",
  "usr.fiche.deconnecter": "Forcer la déconnexion",
  "usr.fiche.desactiver": "Désactiver…",
  "usr.fiche.emailEnvoye": "L’annuaire a envoyé un e-mail de réinitialisation à {{e}}.",
  "usr.fiche.reactiverTitre": "Réactiver {{n}} ?",
  "usr.fiche.reactiverC1": "La connexion est de nouveau autorisée. Les appartenances retirées au départ ne reviennent pas : ajoutez-les ci-dessus.",
  "usr.fiche.motif": "Motif (écrit au journal)",
  "usr.fiche.reactiverVerbe": "Réactiver",
  "usr.fiche.reactiver": "Réactiver le compte",
  "usr.fiche.invitations": "Invitations et liens",
  "usr.fiche.aucuneInvitation": "Aucune invitation ni lien pour cette personne",
  "usr.fiche.lienReinit": "Réinitialisation d’accès",
  "usr.fiche.lienInvit": "Invitation ({{r}})",
  "usr.fiche.historique": "Historique",
  "usr.fiche.aucunHistorique": "Aucun événement au journal pour cette personne",
  "usr.fiche.par": "par {{a}}",
  "usr.fiche.roleChange": "Rôle d’organisation changé",
  "usr.fiche.nouveauRole": "Rôle",
  "usr.fiche.motifFacultatif": "Motif (facultatif, écrit au journal)",
  "usr.fiche.immediat": "Appliquer immédiatement (déconnecte la personne)",
  "usr.fiche.immediatAide": "Sans cette case, les jetons émis avant le changement sont refusés par la passerelle : la personne est invitée à se reconnecter à sa prochaine action.",
  "usr.fiche.changerRole": "Changer le rôle",
  "usr.fiche.appartenanceAjoutee": "Appartenance ajoutée",
  "usr.fiche.appartenanceRetiree": "Appartenance retirée",
  "usr.fiche.choisirCible": "Choisissez un projet ou un programme.",
  "usr.fiche.aucune": "Aucune.",
  "usr.fiche.membresProjet": "membres du projet",
  "usr.fiche.roleDans": "Rôle dans {{n}}",
  "usr.fiche.dernierProprio": "dernier propriétaire actif",
  "usr.fiche.depuis": "depuis {{d}}",
  "usr.fiche.retirerDe": "Retirer de {{n}}",
  "usr.fiche.retirerTitre": "Retirer {{p}} de {{n}} ?",
  "usr.fiche.retirerC1": "L’accès à ce projet ou programme est révoqué immédiatement ; le compte reste actif.",
  "usr.fiche.retirerRev": "Vous pourrez l’ajouter de nouveau depuis cette fiche.",
  "usr.fiche.retirerVerbe": "Retirer",
  "usr.fiche.retirer": "Retirer",
  "usr.fiche.appartenances": "Appartenances",
  "usr.fiche.projets": "Projets",
  "usr.fiche.programmes": "Programmes",
  "usr.fiche.portee": "Type",
  "usr.fiche.projet": "Projet",
  "usr.fiche.programme": "Programme",
  "usr.fiche.cible": "Projet ou programme",
  "usr.fiche.choisir": "Choisir…",
  "usr.fiche.role": "Rôle",
  "usr.fiche.ajouter": "Ajouter",
  "usr.depart.fait": "Compte désactivé",
  "usr.refus.DEACTIVATION_REASON_REQUIRED": "Motif du départ : 5 caractères au moins.",
  "usr.depart.transfertManquant": "Choisissez un nouveau propriétaire pour chaque projet et programme listé.",
  "usr.depart.attester": "Cochez la confirmation pour continuer.",
  "usr.depart.titre": "Désactiver {{n}}",
  "usr.depart.aide": "La personne perd tout accès à l’organisation : connexion bloquée dans l’annuaire, sessions fermées, toutes ses appartenances retirées, ses invitations en attente révoquées. Réactivable plus tard (les appartenances ne reviennent pas).",
  "usr.depart.transferts": "Transfert de propriété (obligatoire)",
  "usr.depart.aucunCandidat": "Aucune autre personne active ne peut reprendre ces propriétés : invitez ou réactivez quelqu’un d’abord.",
  "usr.depart.projet": "Projet « {{n}} »",
  "usr.depart.programme": "Programme « {{n}} »",
  "usr.depart.nouveauProprio": "Nouveau propriétaire…",
  "usr.depart.aucuneExclusive": "Aucun projet ni programme dont la personne serait le dernier propriétaire : aucun transfert requis.",
  "usr.depart.motif": "Motif du départ (obligatoire, écrit au journal)",
  "usr.depart.attestation": "Je confirme la désactivation de ce compte dans toute l’organisation",
  "usr.depart.annuler": "Annuler",
  "usr.depart.confirmer": "Désactiver le compte",
  "usr.inv.revoquee": "Invitation révoquée, compte supprimé",
  "usr.inv.chargement": "Lecture des invitations…",
  "usr.inv.erreur": "Les invitations n’ont pas pu être lues.",
  "usr.inv.aucunResultat": "Aucune invitation dans cet état",
  "usr.inv.vide": "Aucune invitation envoyée",
  "usr.inv.videIndice": "Invitez une personne avec le formulaire ci-dessus.",
  "usr.inv.legende": "Invitations : personne, rôle, projets, statut, échéance, actions",
  "usr.inv.colAttributions": "Projets et programmes",
  "usr.inv.colEcheance": "Envoyée · échéance",
  "usr.inv.colActions": "Actions",
  "usr.inv.renouveler": "Nouveau lien",
  "usr.inv.revoquerTitre": "Révoquer l’invitation de {{e}} ?",
  "usr.inv.revoquerC1": "Le lien cesse de fonctionner ; le compte jamais activé et ses appartenances sont supprimés.",
  "usr.inv.revoquerRev": "L’adresse redevient invitable.",
  "usr.inv.motif": "Motif (facultatif)",
  "usr.inv.revoquer": "Révoquer",
  "nav./org/invitations": "Invitations",
  "usr.inv.description": "Faire entrer une personne nouvelle dans l’organisation : son compte est créé, elle choisit son mot de passe par un lien à usage unique.",
  "usr.inv.emailNonEnvoye": "Invitation créée, mais l’annuaire n’a pas pu envoyer l’e-mail : utilisez « Nouveau lien ».",
  "usr.inv.emailEnvoye": "L’annuaire a envoyé l’e-mail d’invitation à {{e}}.",
  "usr.inv.liste": "Invitations de l’organisation",
  "usr.inv.creee": "Invitation créée",
  "usr.refus.INVITATION_EMAIL_INVALID": "Adresse e-mail invalide.",
  "usr.inv.nouvelle": "Inviter une personne",
  "usr.inv.email": "E-mail (adresse nouvelle)",
  "usr.inv.prenom": "Prénom",
  "usr.inv.nom": "Nom",
  "usr.inv.validite": "Validité du lien (heures, 1 à 168)",
  "usr.inv.attributions": "Projets et programmes (facultatif)",
  "usr.inv.lectureSeuleAide": "Un lecteur ou un auditeur d’organisation n’est que lecteur des projets et programmes.",
  "usr.inv.ajouterAttribution": "Ajouter",
  "usr.inv.retirerAttribution": "Retirer {{n}}",
  "usr.inv.envoyer": "Inviter",
  "usr.revue.legitime": "légitime : à corriger",
  "usr.revue.corrige": "corrigé depuis",
  "usr.revue.attendu": "attendu (refus voulu)",
  "usr.revue.chargement": "Lecture de la revue…",
  "usr.revue.erreur": "La revue n’a pas pu être lue.",
  "usr.revue.pret": "Prêt pour le mode bloquant : aucun rôle légitime ne manque à la matrice et aucun refus légitime n’a été observé sur {{j}} jours.",
  "usr.revue.pasPret": "Pas encore prêt : {{m}} rôle(s) légitime(s) manquant(s), {{l}} refus légitime(s) observé(s) sur {{j}} jours. Corrigez la matrice avant de bloquer.",
  "usr.revue.chemins": "Chemins gardés par la matrice",
  "usr.revue.horsCatalogue": "absente du catalogue",
  "usr.revue.manquent": "manque à : {{r}}",
  "usr.revue.complet": "rôles légitimes couverts",
  "usr.revue.porteurs": "Portée par : {{r}}",
  "usr.revue.observes": "Refus observés",
  "usr.revue.periode": "Période",
  "usr.revue.jours": "{{j}} jours",
  "usr.revue.aucunRefus": "Aucun refus observé sur la période",
  "usr.revue.legende": "Refus observés : permission, rôles, route, nombre, verdict",
  "usr.revue.colPermission": "Permission",
  "usr.revue.colRoles": "Rôles de l’appelant",
  "usr.revue.colRoute": "Route",
  "usr.revue.colNombre": "Fois · personnes",
  "usr.revue.colDernier": "Dernier",
  "usr.revue.colVerdict": "Verdict",
  "usr.revue.retour": "← Accès : rôles et politiques",
  "nav./org/acces/revue": "Revue des refus d’habilitation",
  "usr.revue.description": "Ce que la matrice des droits refuse ou refuserait, et si elle peut bloquer sans gêner un usage légitime.",
  "usr.secu.chargement": "Lecture de la politique…",
  "usr.secu.erreur": "La politique n’a pas pu être lue.",
  "usr.secu.effectif": "Réglage effectif, compte par compte",
  "usr.secu.effectifChargement": "Lecture des comptes dans l’annuaire…",
  "usr.secu.effectifErreur": "L’état des comptes n’a pas pu être lu.",
  "usr.secu.aucunCompte": "Aucun compte dans l’organisation",
  "usr.secu.resume": "{{o}} compte(s) avec OTP configuré · {{p}} en attente de configuration · {{u}} inconnu(s) de l’annuaire",
  "usr.secu.legende": "Comptes : connexion, mot de passe, second facteur",
  "usr.secu.inconnu": "inconnu de l’annuaire",
  "usr.secu.enAttente": "à configurer à la prochaine connexion",
  "usr.secu.tronque": "Liste limitée aux 200 premiers comptes.",
  "nav./org/securite": "Sécurité de connexion",
  "usr.secu.description": "Politique d’authentification de l’organisation : second facteur, durée de session, domaines autorisés, mot de passe.",
  "usr.secu.enregistree": "Politique enregistrée et appliquée",
  "usr.secu.sessionInvalide": "Durée de session : 15 à 43 200 minutes (30 jours), ou vide.",
  "usr.secu.longueurInvalide": "Longueur du mot de passe : 12 à 128.",
  "usr.secu.politique": "Politique de l’organisation",
  "usr.secu.version": "Version {{v}}, modifiée le {{q}} par {{a}}",
  "usr.secu.defaut": "Aucune politique enregistrée : valeurs par défaut (seul le realm s’applique).",
  "usr.secu.lectureSeule": "Consultation seulement : la politique se règle par l’administration de l’organisation.",
  "usr.secu.mfa": "Second facteur (OTP) obligatoire pour tous les membres",
  "usr.secu.mfaAide": "Appliqué par l’annuaire : chaque compte sans OTP reçoit l’action « configurer l’OTP » à sa prochaine connexion, puis le code est demandé à chaque connexion.",
  "usr.secu.session": "Durée maximale d’une session (minutes, vide = celle du realm)",
  "usr.secu.sessionAide": "Appliquée par la passerelle sur l’instant de la connexion : au-delà, la personne doit se reconnecter.",
  "usr.secu.domaines": "Domaines e-mail autorisés aux invitations (un par ligne, vide = tous)",
  "usr.secu.domainesAide": "Appliqués à chaque invitation (sous-domaines compris).",
  "usr.secu.longueur": "Longueur minimale du mot de passe",
  "usr.secu.classes": "Classes de caractères exigées (1 à 4)",
  "usr.secu.mdpAide": "Appliqué à tout mot de passe choisi par un lien DoIt (activation, réinitialisation) ; la politique de l’annuaire reste le plancher.",
  "usr.secu.application": "MFA appliquée : {{u}} compte(s) mis à jour, {{d}} déjà configuré(s), {{e}} échec(s).",
  "usr.secu.enregistrer": "Enregistrer et appliquer",
  "usr.role.owner": "Responsable de projets",
  "usr.role.contributor": "Contributeur",
  "usr.role.viewer": "Lecteur",
  "usr.roleDesc.org_admin": "Gère les utilisateurs, rôles, catalogue, règles, chartes, connecteurs, modèles et le journal de l’organisation.",
  "usr.roleDesc.owner": "Crée et possède des projets ; n’administre pas l’organisation.",
  "usr.roleDesc.contributor": "Écrit dans les projets et programmes dont il est membre.",
  "usr.roleDesc.viewer": "Lit les projets et programmes dont il est membre.",
  "usr.roleDesc.auditor": "Lit le journal, la matrice et l’annuaire de l’organisation ; n’écrit jamais.",
  "usr.rolePortee.owner": "Propriétaire",
  "usr.rolePortee.contributor": "Contributeur",
  "usr.rolePortee.viewer": "Lecteur",
  "usr.statut.active": "Actif",
  "usr.statut.invited": "Invité",
  "usr.statut.deactivated": "Désactivé",
  "usr.inv.statut.pending": "En attente",
  "usr.inv.statut.expired": "Expirée",
  "usr.inv.statut.accepted": "Acceptée",
  "usr.inv.statut.revoked": "Révoquée",
  "usr.refus.ORG_ADMIN_REQUIRED": "Réservé à l’administration de l’organisation.",
  "usr.refus.RESOURCE_UNAVAILABLE": "Organisation ou ressource introuvable.",
  "usr.refus.USER_NOT_FOUND": "Cette personne n’appartient pas à l’organisation.",
  "usr.refus.LAST_ORG_ADMIN": "C’est le dernier administrateur actif de l’organisation : nommez-en d’abord un autre.",
  "usr.refus.LAST_OWNER": "C’est le dernier propriétaire actif du projet : nommez d’abord un autre propriétaire.",
  "usr.refus.PROGRAM_LAST_OWNER": "C’est le dernier propriétaire actif du programme : nommez d’abord un autre propriétaire.",
  "usr.refus.OWNERSHIP_TRANSFER_REQUIRED": "Transfert de propriété obligatoire : choisissez un nouveau propriétaire pour chaque projet ou programme dont la personne est le dernier propriétaire.",
  "usr.refus.SELF_DEACTIVATION_FORBIDDEN": "Vous ne pouvez pas désactiver votre propre compte.",
  "usr.refus.SELF_ROLE_CHANGE_FORBIDDEN": "Vous ne pouvez pas changer votre propre rôle d’organisation : une autre administration le fait.",
  "usr.refus.USER_ALREADY_DEACTIVATED": "Ce compte est déjà désactivé.",
  "usr.refus.USER_NOT_DEACTIVATED": "Ce compte est déjà actif.",
  "usr.refus.USER_DEACTIVATED": "Ce compte est désactivé : réactivez-le d’abord.",
  "usr.refus.MEMBERSHIP_ROLE_EXCEEDS_ORG_ROLE": "Un lecteur ou un auditeur d’organisation n’est que lecteur d’un projet ou d’un programme : changez d’abord son rôle d’organisation.",
  "usr.refus.ALREADY_MEMBER": "Cette personne en est déjà membre.",
  "usr.refus.MEMBERSHIP_NOT_FOUND": "Cette personne n’en est pas membre.",
  "usr.refus.TRANSFER_TARGET_INVALID": "Nouveau propriétaire invalide : une autre personne active, ni lectrice ni auditrice.",
  "usr.refus.REACTIVATION_REASON_REQUIRED": "Motif de la réactivation : 5 caractères au moins.",
  "usr.refus.ORG_ROLE_INVALID": "Rôle d’organisation inconnu.",
  "usr.refus.INVITATION_EMAIL_ALREADY_EXISTS": "Un compte existe déjà pour cette adresse : invitez une adresse nouvelle, ou ajoutez la personne depuis sa fiche.",
  "usr.refus.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "Ce domaine d’e-mail n’est pas autorisé par la politique de l’organisation.",
  "usr.refus.INVITATION_SCOPE_NOT_FOUND": "Un projet ou un programme choisi n’existe pas dans l’organisation.",
  "usr.refus.INVITATION_NOT_REVOCABLE": "Invitation déjà acceptée ou révoquée.",
  "usr.refus.INVITATION_NOT_RENEWABLE": "Invitation déjà acceptée ou révoquée : rien à renouveler.",
  "usr.refus.WORKSPACE_ARCHIVED": "Ce projet est archivé.",
  "usr.refus.KEYCLOAK_UNAVAILABLE": "L’annuaire (Keycloak) ne répond pas : rien n’a été modifié, réessayez.",
  "usr.refus.AUTH_POLICY_INVALID": "Politique invalide : vérifiez les valeurs saisies.",
  "usr.refus.AUTH_POLICY_STALE": "La politique a été modifiée entre-temps : rechargez-la avant d’enregistrer.",
  "usr.refus.PASSWORD_POLICY": "Mot de passe refusé par la politique de sécurité.",
  "usr.refus.INVITATION_FAILED": "Invitation interrompue : rien n’a été créé.",
  "usr.refus.inconnu": "Opération refusée.",
  "usr.lien.pour": "Lien à usage unique pour {{email}} : transmettez-le à cette personne. Il ne sera plus affiché.",
  "usr.lien.aria": "Lien à usage unique",
  "usr.lien.copie": "Copié",
  "usr.lien.copier": "Copier le lien",
  "usr.lien.masquer": "Masquer",
  "erreurs.code.TOKEN_ROLE_STALE": "Vos droits ont changé : votre session est renouvelée, réessayez.",
  "erreurs.code.SESSION_MAX_DURATION_EXCEEDED": "Durée maximale de session de votre organisation atteinte : reconnectez-vous.",
  "erreurs.code.SPEC_GATE_HUMAN_VERIFIED_PROVENANCE_REQUIRED": "Story refusée : l’epic parent est rattaché à une spécification approuvée dont la preuve Spec Gate n’est plus valide (le reçu attesté expire 24 h après son évaluation). Réévaluez la spécification puis rattachez la preuve renouvelée, ou créez la story sans epic parent.",
  "erreurs.code.MISSION_TASKS_STILL_ACTIVE": "Des tâches de cette mission peuvent encore réussir : tranchez les arrêts un par un, ou arrêtez la mission.",
  "erreurs.code.MISSION_NO_STOP_TO_ACKNOWLEDGE": "Aucune tâche arrêtée n’attend de décision dans cette mission.",
  "erreurs.code.MISSION_STEP_IN_PROGRESS": "Une étape de la mission est en cours : attendez qu’elle finisse, ou arrêtez la mission.",
  "navdesc./org/utilisateurs": "Annuaire de l’organisation : rôles, statuts, appartenances, départs et réactivations",
  "navdesc./org/invitations": "Faire entrer une personne nouvelle : invitation par e-mail et lien d’activation",
  "navdesc./org/securite": "Second facteur obligatoire, durée de session, domaines autorisés, mot de passe",
  "navdesc./org/acces/revue": "Ce que la matrice refuse ou refuserait, avant et après le mode bloquant",
  "grp.Utilisateurs et accès": "Utilisateurs et accès",
  "cycle.refus.adminOrg": "Réservé à l’administration de l’organisation.",
  "cycle.refus.adminPlateforme": "Réservé à l’administration de la plateforme.",
  "cycle.refus.proprietaire": "Réservé au propriétaire du projet ou à l’administration de l’organisation.",
  "cycle.refus.confirmation": "La confirmation ne correspond pas : tapez le nom exact.",
  "cycle.refus.motif": "Un motif de 10 à 1000 caractères est requis.",
  "cycle.refus.delai": "Délai hors des bornes permises.",
  "cycle.refus.dejaProgrammee": "Une suppression est déjà programmée.",
  "cycle.refus.close": "Cette demande est close : plus rien à annuler.",
  "cycle.refus.suppressionEnCours": "Suppression programmée : annulez-la d’abord.",
  "cycle.refus.pasArchive": "Ce projet n’est pas archivé.",
  "cycle.refus.archive": "Projet archivé : désarchivez-le d’abord.",
  "cycle.refus.soiMeme": "La plateforme ne supprime jamais sa propre organisation.",
  "cycle.refus.supprimee": "Organisation déjà supprimée.",
  "cycle.refus.suspendue": "Organisation suspendue : lecture seule.",
  "cycle.refus.exportPasPret": "L’archive n’est pas encore prête.",
  "cycle.refus.introuvable": "Introuvable.",
  "cycle.refus.validation": "Valeur refusée par la passerelle.",
  "cycle.refus.inattendu": "La passerelle a refusé l’action.",
  "cycle.motif": "Motif (obligatoire, écrit sur la demande, à l’audit et dans la notification)",
  "cycle.delai": "Délai avant la purge définitive, en jours ({{min}} à {{max}})",
  "cycle.fermer": "Fermer",
  "cycle.programmerSuppression": "Programmer la suppression",
  "cycle.consequence.export": "Un export complet est produit d’abord : données, artefacts, preuves et journal, en une archive téléchargeable avec son empreinte SHA-256.",
  "cycle.consequence.lectureSeuleProjet": "Le projet passe aussitôt en lecture seule ; ses missions en cours sont arrêtées.",
  "cycle.consequence.lectureSeuleOrganisation": "L’organisation est aussitôt suspendue : ses membres passent en lecture seule ; ses missions sont arrêtées.",
  "cycle.consequence.delai": "La purge définitive a lieu après {{n}} jour(s), seulement si l’export est prêt. D’ici là, la suppression s’annule.",
  "cycle.consequence.notificationProjet": "Les propriétaires du projet sont notifiés ; tout est écrit à l’audit de l’organisation.",
  "cycle.consequence.notificationOrganisation": "Les propriétaires de projets de l’organisation sont notifiés ; tout est écrit au journal de la plateforme. Les comptes de ses utilisateurs seront supprimés à la purge.",
  "cycle.archiverTitre": "Archiver « {{nom}} » ?",
  "cycle.archiverEffet1": "Le projet passe en lecture seule : aucune écriture, aucune nouvelle mission.",
  "cycle.archiverEffet2": "Ses données, son journal et ses membres sont conservés.",
  "cycle.archiverReversible": "Désarchivable à tout moment par son propriétaire ou l’administration de l’organisation.",
  "cycle.archiver": "Archiver",
  "cycle.desarchiverTitre": "Désarchiver « {{nom}} » ?",
  "cycle.desarchiverEffet": "Le projet redevient modifiable par ses membres.",
  "cycle.desarchiverReversible": "Il peut être de nouveau archivé à tout moment.",
  "cycle.desarchiver": "Désarchiver",
  "cycle.voirDemande": "Suppression programmée — voir la demande",
  "cycle.renommer": "Renommer…",
  "cycle.desarchiverAction": "Désarchiver…",
  "cycle.archiverAction": "Archiver…",
  "cycle.supprimerAction": "Supprimer…",
  "cycle.renommerTitre": "Renommer « {{nom}} »",
  "cycle.renommerAide": "Le nouveau nom s’affiche partout ; l’identifiant du projet ne change pas. Écrit à l’audit.",
  "cycle.nom": "Nom (3 à 255 caractères)",
  "cycle.description": "Description",
  "cycle.nomCourt": "Le nom doit comporter au moins 3 caractères.",
  "cycle.renommerValider": "Renommer",
  "cycle.supprimerTitre": "Supprimer le projet « {{nom}} »",
  "cycle.supprimerAide": "Suppression différée et annulable : rien n’est effacé avant la fin du délai.",
  "cycle.supprimerOk": "Suppression programmée : purge après le {{quand}}. L’export complet se prépare.",
  "cycle.ouvrirDemande": "Ouvrir la demande n° {{id}}",
  "cycle.confirmationProjet": "Pour confirmer, tapez le nom exact du projet : {{nom}}",
  "cycleBandeau.region": "Suppression programmée",
  "cycleBandeau.organisation": "Suppression de l’organisation programmée : purge définitive après le {{quand}}.",
  "cycleBandeau.organisationDetail": "L’organisation est suspendue, en lecture seule. Seule la plateforme peut annuler.",
  "cycleBandeau.voirExport": "Voir la demande et l’export",
  "cycleBandeau.projet": "Suppression du projet « {{nom}} » programmée : purge définitive après le {{quand}}.",
  "cycleBandeau.projetDetail": "Le projet est en lecture seule.",
  "cycleBandeau.voirDemande": "Voir la demande (annuler, export)",
  "cycle.orgSuppressionLe": "Suppression le {{quand}}",
  "cycle.supprimerOrgTitre": "Supprimer l’organisation « {{nom}} »",
  "cycle.supprimerOrgOk": "Suppression programmée, organisation suspendue : purge après le {{quand}}.",
  "cycle.confirmationOrganisation": "Pour confirmer, tapez l’identifiant exact de l’organisation : {{id}}",
  "cycle.annulerTitre": "Annuler la suppression de « {{nom}} »",
  "cycle.annulerAideProjet": "Rien ne sera purgé ; le projet retrouve son statut d’avant la demande ({{statut}}). Écrit à l’audit, propriétaires notifiés.",
  "cycle.annulerAideOrganisation": "Rien ne sera purgé ; l’organisation est réactivée si elle était active avant la demande. Écrit au journal de la plateforme.",
  "cycle.annulerMotif": "Motif de l’annulation (10 caractères au moins)",
  "cycle.annulerValider": "Annuler la suppression",
  "cycle.retourListe": "Toutes les demandes",
  "cycle.chargementFiche": "Lecture de la demande…",
  "cycle.introuvable": "Demande introuvable dans votre organisation.",
  "cycle.refusFiche": "Réservé à l’administration de l’organisation ou de la plateforme.",
  "cycle.erreurFiche": "La demande n’a pas pu être lue.",
  "cycle.ficheTitre": "Suppression de « {{nom}} »",
  "cycle.ficheAideProjet": "Projet {{ws}} — demande n° {{id}}",
  "cycle.ficheAideOrganisation": "Organisation {{org}} — demande n° {{id}}",
  "cycle.purgePrevue": "Purge définitive après le {{quand}}, seulement si l’archive est prête.",
  "cycle.annuler": "Annuler la suppression…",
  "cycle.demandeePar": "Demandée par",
  "cycle.motifLu": "Motif",
  "cycle.delaiLu": "Délai",
  "cycle.jours": "{{n}} jour(s)",
  "cycle.statutAvant": "Statut avant la demande",
  "cycle.annuleePar": "Annulée par",
  "cycle.absorbeePar": "Absorbée par",
  "cycle.numero": "n° {{id}}",
  "cycle.exportTitre": "Export complet (archive)",
  "cycle.exportPreteLe": "prête le {{quand}}",
  "cycle.empreinte": "Empreinte SHA-256 :",
  "cycle.exportEchec": "Export en échec ({{n}} tentative(s)), rejoué automatiquement ; la purge attend une archive prête.",
  "cycle.exportEnCours": "L’archive se prépare (quelques minutes). La purge ne peut pas avoir lieu sans elle.",
  "cycle.exportConservation": "Archive conservée jusqu’au {{quand}}.",
  "cycle.telecharger": "Télécharger l’archive",
  "cycle.telechargeOk": "Téléchargée ; empreinte annoncée identique à celle de la demande.",
  "cycle.telechargeEcart": "Téléchargée ; empreinte annoncée DIFFÉRENTE : vérifiez l’archive avant tout usage.",
  "cycle.perimetrePurge": "Purgé",
  "cycle.perimetreAPurger": "Sera purgé : {{n}} ligne(s) dans {{tables}} table(s)",
  "cycle.perimetreVide": "Aucune ligne restante.",
  "cycle.perimetreConserve": "Conservé (preuve et audit)",
  "cycle.rapportTitre": "Rapport de purge",
  "cycle.rapport": "{{n}} ligne(s) purgée(s) dans {{tables}} table(s), le {{quand}} ; reçu conservé au journal du cycle de vie.",
  "cycle.purgeEchec": "Dernière tentative de purge en échec ({{n}}), rejouée automatiquement :",
  "cycle.etat.programmee": "programmée",
  "cycle.etat.annulee": "annulée",
  "cycle.etat.purgee": "purgée",
  "cycle.etat.absorbee": "absorbée par la suppression de l’organisation",
  "cycle.export.enPreparation": "en préparation",
  "cycle.export.pret": "prête",
  "cycle.export.echec": "en échec (rejouée)",
  "cycle.export.expiree": "expirée",
  "cycle.listeTitre": "Demandes de suppression",
  "cycle.listeAidePlateforme": "Projets et organisations : export complet, purge différée, annulable pendant le délai. Toutes les organisations.",
  "cycle.listeAideOrganisation": "Projets de l’organisation (et l’organisation elle-même) : export complet, purge différée, annulable pendant le délai.",
  "cycle.retourProjets": "Projets de l’organisation",
  "cycle.retourOrganisations": "Organisations",
  "cycle.chargement": "Lecture des demandes…",
  "cycle.refusListePlateforme": "Réservé à l’administration de la plateforme.",
  "cycle.refusListe": "Réservé à l’administration de l’organisation.",
  "cycle.erreurListe": "Les demandes n’ont pas pu être lues.",
  "cycle.vide": "Aucune demande de suppression",
  "cycle.videIndice": "Une suppression se programme depuis la liste des projets (ou des organisations).",
  "cycle.listeLegende": "Demandes : cible, portée, état, archive, purge prévue, demandeur",
  "cycle.col.cible": "cible",
  "cycle.col.portee": "portée",
  "cycle.col.etat": "état",
  "cycle.col.export": "archive",
  "cycle.col.purge": "purge prévue",
  "cycle.col.demande": "demandée par",
  "cycle.porteeProjet": "projet",
  "cycle.porteeOrganisation": "organisation",
  "orgProjetsAdmin.refus": "La liste complète des projets est réservée à l’administration de l’organisation.",
  "orgProjetsAdmin.videFiltre": "Aucun projet de l’organisation ne correspond à ce programme.",
  "orgProjetsAdmin.videIndice": "L’organisation n’a encore aucun projet : créez le premier.",
  "orgProjetsAdmin.suppressionLe": "suppression le {{quand}}",
  "orgProjetsAdmin.legende": "Tous les projets de l’organisation",
  "orgProjetsAdmin.proprietaires": "propriétaires · membres",
  "orgProjetsAdmin.gestes": "cycle de vie",
  "orgProjetsAdmin.nonMembre": "non membre",
  "orgProjets.descriptionAdmin": "Tous les projets de l’organisation : renommer, archiver, désarchiver, supprimer (export complet puis purge différée, annulable).",
  "orgProjets.suppressions": "Demandes de suppression",
  "organisationsPlateforme.statut.supprimee": "supprimée",
  "organisationsPlateforme.suppressions": "Demandes de suppression",
  "organisationsPlateforme.sante.battementPerime": "Dernier battement de l’exécutant (worker) il y a {{n}} s : il ne traite plus la file. Voir la santé de la plateforme.",
  "organisationsPlateforme.sante.nonMesuree": "non mesurée",
  "organisationsPlateforme.sante.pasDeBattement": "Aucun battement de l’exécutant (worker) reçu à ce jour : la santé se mesure dès qu’il tourne. Les missions IA attendent l’exécutant.",
  "organisationsPlateforme.sante.pasDeDonnee": "pas encore de donnée",
  "fonA.mcp.sansProjet": "Choisissez un projet actif pour exécuter.",
  "fonA.mcp.inactif": "Serveur non activé.",
  "fonA.mcp.nonLie": "Associez d’abord un agent à ce serveur.",
  "fonA.mcp.executer": "Exécuter maintenant",
  "fonA.mcp.supprimerTitre": "Supprimer le serveur MCP « {{nom}} » ?",
  "fonA.mcp.supprimerConsequence": "Le paquet et ses liaisons aux agents sont retirés ; les gabarits qui l’utilisent ne pourront plus le lancer.",
  "fonA.mcp.supprimerReversible": "Vous pourrez le réimporter, puis le faire approuver de nouveau.",
  "fonA.mcp.supprimer": "Supprimer",
  "fonA.mcp.enFile": "Exécution mise en file : job {{id}} (suivi dans Exécutions et file).",
  "fonA.webhooks.titre": "Webhooks publics",
  "fonA.webhooks.aide": "Un outil tiers (GitLab, CI) notifie DoIt par une requête signée (HMAC) ; chaque événement n’est accepté qu’une fois.",
  "fonA.webhooks.chargement": "Lecture des webhooks…",
  "fonA.webhooks.refus": "Les webhooks du projet relèvent de son propriétaire.",
  "fonA.webhooks.erreur": "Les webhooks n’ont pas pu être lus.",
  "fonA.webhooks.vide": "Aucun webhook public",
  "fonA.webhooks.videAide": "Créez-en un ci-dessous pour recevoir les événements d’un outil tiers.",
  "fonA.webhooks.creer": "Créer un webhook",
  "fonA.webhooks.recus": "{{n}} événement(s) reçu(s)",
  "fonA.webhooks.dernier": "dernier le {{date}}",
  "fonA.connexions.active": "active",
  "fonA.connexions.inactive": "désactivée",
  "fonA.connexions.desactiver": "Désactiver",
  "fonA.connexions.activer": "Activer",
  "fonA.webhooks.secretUneFois": "Secret de signature — copiez-le maintenant, il ne sera plus jamais affiché :",
  "fonA.webhooks.adresse": "Adresse de réception :",
  "fonA.webhooks.masquer": "J’ai copié le secret",
  "fonA.connexions.nom": "Nom",
  "fonA.webhooks.type": "Type d’événement",
  "fonA.webhooks.workflow": "Workflow déclenché (obligatoire pour gitlab_push)",
  "fonA.finalite.proposee": "proposée, à décider",
  "fonA.finalite.approuvee": "approuvée",
  "fonA.finalite.refusee": "refusée",
  "fonA.finalite.retiree": "retirée",
  "fonA.finalite.remplacee": "remplacée par une version plus récente",
  "fonA.prep.sansFinalite": "Aucune finalité de traitement IA approuvée ne couvre cet agent dans ce projet.",
  "fonA.prep.enAttente": "Une finalité est déclarée et attend la décision de l’administration de l’organisation.",
  "fonA.prep.sansConsentement": "La finalité est approuvée, mais vous n’y avez pas consenti.",
  "fonA.prep.ok": "Prêt : finalité approuvée et consentement donné.",
  "fonA.refus.proprietaire": "Seul le propriétaire du projet déclare ou retire une finalité.",
  "fonA.refus.admin": "Cette décision revient à l’administration de l’organisation.",
  "fonA.refus.auto": "Vous avez déclaré cette finalité : une autre personne la décide.",
  "fonA.refus.dejaProposee": "Une déclaration de cette finalité attend déjà sa décision.",
  "fonA.refus.etat": "Cet acte ne s’applique pas à l’état actuel de la finalité.",
  "fonA.refus.inconnue": "Aucune finalité de ce code n’est déclarée dans l’organisation.",
  "fonA.prep.chargement": "Vérification de la finalité et du consentement…",
  "fonA.prep.erreur": "La préparation de l’exécution n’a pas pu être lue.",
  "fonA.prep.pret": "prêt",
  "fonA.prep.bloque": "bloqué",
  "fonA.prep.consentir": "Donner mon consentement à « {{code}} » (180 jours)",
  "fonA.prep.demanderProprietaire": "Le propriétaire du projet déclare la finalité ; l’administration de l’organisation l’approuve.",
  "fonA.finalites.chargement": "Lecture des finalités du projet…",
  "fonA.finalites.refus": "Les finalités de ce projet ne vous sont pas ouvertes.",
  "fonA.finalites.erreur": "Les finalités n’ont pas pu être lues.",
  "fonA.finalites.vide": "Aucune finalité déclarée dans ce projet",
  "fonA.finalites.videAide": "Déclarez la finalité d’un agent ci-dessous : l’administration de l’organisation l’approuvera.",
  "fonA.finalites.declarerLien": "Déclarer une finalité",
  "fonA.finalites.videLecture": "Le propriétaire du projet déclare les finalités.",
  "fonA.finalite.echue": "échue",
  "fonA.finalites.ligne": "{{agent}} · échéance {{date}}",
  "fonA.finalites.declarerTitre": "Déclarer une finalité de traitement IA",
  "fonA.finalites.choisir": "— choisir —",
  "fonA.finalites.code": "Code de la finalité",
  "fonA.finalites.codeExemple": "resume.comptes-rendus",
  "fonA.finalites.codeAide": "Minuscules, chiffres, « . », « _ » ou « - » ; 3 à 96 caractères. Chaque personne consent à ce code.",
  "fonA.finalites.justification": "Justification (pourquoi ce traitement)",
  "fonA.finalites.duree": "Durée de validité (jours, 365 au plus)",
  "fonA.finalites.declarer": "Déclarer",
  "fonA.finalites.codeInvalide": "Code invalide.",
  "fonA.finalites.declaree": "Finalité déclarée : elle attend la décision de l’administration de l’organisation.",
  "fonA.finalites.ligneOrg": "{{projet}} · {{agent}} · déclarée par {{qui}}",
  "fonA.attention.recetteSousTitre": "campagne ouverte par {{w}} · version {{v}}",
  "fonA.attention.descriptionProgramme": "Ce qui attend une décision dans les projets de ce programme, avec son âge.",
  "fonA.attention.descriptionOrganisation": "Ce qui attend une décision dans tous vos projets de l’organisation, avec son âge.",
  "fonA.attention.portee": "Portée de la boîte d’attention",
  "fonA.attention.projet": "Ce projet",
  "fonA.attention.sansProgramme": "Le projet actif n’appartient à aucun programme.",
  "fonA.attention.programme": "Son programme",
  "fonA.attention.organisation": "Toute l’organisation",
  "fonA.attention.resume": "{{n}} élément(s) dans {{p}} projet(s)",
  "fonA.attention.partiel": "{{n}} projet(s) illisible(s) pour l’instant",
  "fonA.attention.dansProjet": "Projet : {{p}}",
  "fonA.attention.autreProjet": "Cet élément appartient au projet {{p}} : il se décide dans ce projet.",
  "fonA.attention.ouvrirProjet": "Ouvrir dans le projet {{p}}",
  "fonA.attention.recette": "Une version attend sa recette métier : exécutez les scénarios et rendez le verdict (accordée ou refusée).",
  "fonA.attention.ouvrirRecette": "Ouvrir la recette",
  "fonA.decisionsOutil.titre": "Décisions de l’outil",
  "fonA.decisionsOutil.description": "Les décisions d’architecture de DoIt lui-même (moteur, pile, sécurité), séparées des ADR des projets.",
  "attention.kind.recette_to_run": "Version à recetter",
  "fonA.finalites.titre": "Finalités de traitement IA du projet",
  "fonA.finalites.aide": "Un agent ne s’exécute que pour une finalité déclarée par le propriétaire du projet, approuvée par l’administration de l’organisation, et à laquelle la personne qui l’exécute a consenti.",
  "fonA.gouvernance.autres": "Le reste du gabarit (types d’items, cycle de vie, agents, modèles et routage) se règle dans les",
  "fonA.deleg.roleOwner": "propriétaire",
  "fonA.deleg.roleContrib": "contributeur",
  "fonA.deleg.roleViewer": "lecteur",
  "fonA.deleg.active": "active",
  "fonA.deleg.programmee": "programmée",
  "fonA.deleg.expiree": "expirée",
  "fonA.deleg.revoquee": "révoquée",
  "fonA.raci.decideur": "décide",
  "fonA.raci.consulte": "consulté",
  "fonA.raci.informe": "informé",
  "fonA.deleg.r.role": "Le délégant ne détient pas ce rôle dans ce projet.",
  "fonA.deleg.r.autrui": "Déléguer le rôle d’une autre personne relève de l’administration de l’organisation.",
  "fonA.deleg.r.fenetre": "La fin doit être future et la délégation durer 90 jours au plus.",
  "fonA.deleg.r.soi": "On ne se délègue pas un rôle à soi-même.",
  "fonA.deleg.r.delegue": "Le délégué n’est pas une personne active de l’organisation.",
  "fonA.deleg.r.revocation": "Seuls le délégant, le délégué ou l’administration révoquent cette délégation.",
  "fonA.deleg.r.ecriture": "Votre rôle ne permet pas de déléguer.",
  "fonA.raci.r.decideur": "Une décision garde au moins un rôle décideur.",
  "fonA.deleg.titre": "Délégations et RACI",
  "fonA.deleg.description": "Qui peut agir à la place d’un décideur, et qui décide, est consulté ou informé de chaque décision.",
  "fonA.deleg.onglets": "Vues des délégations",
  "fonA.deleg.ongletDelegations": "Délégations",
  "fonA.deleg.ongletRaci": "Matrice RACI",
  "fonA.deleg.chargement": "Lecture des délégations…",
  "fonA.deleg.erreur": "Les délégations n’ont pas pu être lues.",
  "fonA.deleg.portee": "Toutes les délégations de l’organisation.",
  "fonA.deleg.porteeMoi": "Les délégations où vous êtes délégant ou délégué.",
  "fonA.deleg.vide": "Aucune délégation",
  "fonA.deleg.videAide": "Déclarez une délégation ci-dessous avant une absence.",
  "fonA.deleg.declarer": "Déclarer une délégation",
  "fonA.deleg.ligne": "{{role}} de {{de}} → {{a}}",
  "fonA.deleg.ligneProjet": "{{projet}} · jusqu’au {{date}}",
  "fonA.derog.col.projet": "Projet",
  "fonA.deleg.role": "Rôle délégué",
  "fonA.deleg.delegant": "Délégant (vide : vous)",
  "fonA.deleg.moi": "moi ({{id}})",
  "fonA.deleg.delegue": "Délégué",
  "fonA.deleg.fin": "Jusqu’au (90 jours au plus)",
  "fonA.deleg.motif": "Motif (5 caractères au moins)",
  "fonA.deleg.enregistrer": "Déclarer",
  "fonA.deleg.declaree": "Délégation déclarée et consignée.",
  "fonA.deleg.ficheChargement": "Lecture de la délégation…",
  "fonA.deleg.introuvable": "Cette délégation n’existe pas ou ne vous est pas ouverte.",
  "fonA.deleg.ficheTitre": "Délégation du rôle {{role}}",
  "fonA.fiche.fil": "Fil d’Ariane",
  "fonA.deleg.retour": "Toutes les délégations",
  "fonA.fiche.etat": "État",
  "fonA.deleg.delegantSeul": "Délégant",
  "fonA.deleg.fenetre": "Fenêtre",
  "fonA.deleg.motifSeul": "Motif",
  "fonA.deleg.declareePar": "Déclarée par",
  "fonA.deleg.revoqueePar": "Révoquée par",
  "fonA.deleg.revoquerTitre": "Révoquer cette délégation ?",
  "fonA.deleg.revoquerConsequence": "Le délégué ne peut plus agir à la place du délégant dans ce projet, dès maintenant.",
  "fonA.deleg.revoquerReversible": "Une nouvelle délégation peut être déclarée ensuite.",
  "fonA.deleg.revoquer": "Révoquer",
  "fonA.raci.chargement": "Lecture de la matrice RACI…",
  "fonA.raci.erreur": "La matrice RACI n’a pas pu être lue.",
  "fonA.raci.aideAdmin": "Chaque décision garde au moins un rôle qui décide. Une modification est consignée au journal d’audit.",
  "fonA.raci.lecture": "Lecture seule : la matrice se règle par l’administration de l’organisation.",
  "fonA.raci.vide": "Aucune décision au catalogue",
  "fonA.raci.videAide": "Le catalogue des permissions est vide.",
  "fonA.raci.region": "Matrice RACI, défilement horizontal",
  "fonA.raci.legende": "Décisions et rôles : décide, consulté, informé",
  "fonA.raci.decision": "Décision",
  "fonA.raci.actions": "Actions",
  "fonA.raci.modifiee": "modifiée par {{qui}}",
  "fonA.raci.choix": "{{decision}} — {{role}}",
  "fonA.raci.enregistrer": "Enregistrer",
  "fonA.fiche.parLe": "par {{qui}} le {{date}}",
  "fonA.fiche.decision": "Décision",
  "fonA.mcp.aide": "Un serveur MCP importé reste en quarantaine jusqu’à son approbation par une autre personne que son auteur ; il s’active, se lie à un agent, se teste, s’exécute dans le projet actif ou se supprime ici.",
  "fonA.mcp.refus": "Les serveurs MCP de l’organisation relèvent de son administration.",
  "harnais.ongletFinalites": "Finalités IA",
  "fonA.gabarits.chargement": "Lecture des gabarits de l’organisation…",
  "fonA.gabarits.erreur": "Les gabarits n’ont pas pu être lus.",
  "fonA.gabarits.titre": "Mode du harnais et mode deux personnes, par gabarit",
  "fonA.gabarits.aide": "Le gabarit fixe le mode d’exécution des missions et les modes qu’un lancement peut choisir ; le mode deux personnes permet au demandeur d’approuver un objet à risque faible après la revue d’un relecteur distinct.",
  "fonA.gabarits.lecture": "Lecture seule : régler les gabarits relève de l’administration de l’organisation.",
  "fonA.gabarits.vide": "Aucun gabarit propre à l’organisation",
  "fonA.gabarits.videAide": "Le gabarit intégré s’applique (mode C, mode deux personnes désactivé). Créez un gabarit pour régler ces modes.",
  "fonA.gabarits.sansPlateforme": "Ce gabarit n’a pas de section plateforme : ouvrez-le une fois dans Gabarits.",
  "fonA.gabarits.publie": "publié",
  "fonA.gabarits.brouillon": "brouillon",
  "fonA.gabarits.modeDefaut": "Mode par défaut",
  "fonA.gabarits.permis": "Modes permis au lancement",
  "fonA.gabarits.agent": "Agent enveloppé (mode A)",
  "fonA.gabarits.nonLivre": "non livré",
  "fonA.gabarits.externe": "IA externe",
  "fonA.gabarits.agentRequis": "Le mode A exige un agent.",
  "fonA.gabarits.deuxPersonnes": "Mode deux personnes",
  "fonA.gabarits.deuxPersonnesAide": "Permis : objet à risque faible, après la revue d’un relecteur distinct (le risque se relève, jamais ne s’abaisse). Jamais : promotion en production, sécurité, dérogations, décisions à sens unique, missions.",
  "fonA.gabarits.enregistrer": "Enregistrer (brouillon)",
  "fonA.gabarits.publier": "Publier",
  "fonA.gabarits.enregistre": "Enregistré en brouillon : les projets gardent la version publiée jusqu’à la publication.",
  "fonA.castes.chargement": "Lecture des castes du harnais…",
  "fonA.castes.refus": "Les castes du harnais ne vous sont pas ouvertes.",
  "fonA.castes.erreur": "Les castes n’ont pas pu être lues ; rien n’a changé.",
  "fonA.castes.activeDeterministe": "active (sans modèle)",
  "fonA.castes.active": "active",
  "fonA.castes.beta": "en bêta",
  "fonA.castes.prevue": "prévue",
  "fonA.castes.sansRegistre": "Aucun instantané du registre n’a été publié par le worker : les cartes en service sont inconnues. Les castes sans modèle restent actives.",
  "fonA.castes.publie": "Cartes en service selon l’instantané publié le {{date}}.",
  "fonA.castes.region": "Castes du harnais, défilement horizontal",
  "fonA.castes.legende": "Castes : rôle, droit, dépôt, état et carte en service",
  "fonA.castes.col.caste": "Caste",
  "fonA.castes.col.droit": "Droit",
  "fonA.castes.col.depose": "Dépose",
  "fonA.castes.col.etat": "État",
  "fonA.castes.col.carte": "Carte en service et modèle",
  "fonA.castes.modesTitre": "Modes du harnais par gabarit",
  "fonA.castes.experimental": "expérimental",
  "fonA.castes.defaut": "par défaut",
  "fonA.castes.gabaritModes": "mode {{mode}} ({{source}}), permis : {{permis}}",
  "fonA.castes.fixe": "fixé par le gabarit",
  "fonA.castes.parDefaut": "défaut",
  "fonA.castes.gabaritInvalide": "section harnais invalide",
  "fonA.castes.reglerModes": "Le mode et les modes permis se règlent par gabarit dans",
  "fonA.connexions.refus": "Les connexions d’IA de l’organisation relèvent de son administration.",
  "fonA.connexions.sondee": "sondée le {{date}}",
  "fonA.connexions.joignable": "joignable",
  "fonA.connexions.injoignable": "injoignable",
  "fonA.connexions.inconnu": "non testée",
  "fonA.connexions.tester": "Tester la connexion",
  "fonA.fiche.chargement": "Lecture de la finalité…",
  "fonA.fiche.introuvable": "Cette finalité n’existe pas ou ne vous est pas ouverte.",
  "fonA.fiche.erreur": "La finalité n’a pas pu être lue.",
  "fonA.fiche.titre": "Finalité « {{code}} » v{{v}}",
  "fonA.fiche.description": "Projet {{projet}} · agent {{agent}}",
  "fonA.fiche.retourOrg": "Finalités de l’organisation",
  "fonA.fiche.retourAgents": "Agents personnalisés",
  "fonA.fiche.justification": "Justification",
  "fonA.fiche.declaree": "Déclarée",
  "fonA.fiche.echeance": "Échéance",
  "fonA.fiche.retrait": "Motif du retrait",
  "fonA.fiche.consentement": "Mon consentement",
  "fonA.fiche.consentiJusqua": "donné jusqu’au {{date}}",
  "fonA.fiche.nonConsenti": "non donné",
  "fonA.fiche.motif": "Motif (refus ou retrait, 5 caractères au moins)",
  "fonA.fiche.approuver": "Approuver",
  "fonA.fiche.refuser": "Refuser",
  "fonA.fiche.retirer": "Retirer la finalité",
  "fonA.fiche.retirerConsentement": "Retirer mon consentement",
  "fonA.fiche.donnerConsentement": "Donner mon consentement (180 jours)",
  "fonA.fiche.consentementPersonnel": "Personne ne consent à votre place.",
  "fonA.fiche.enregistre": "Enregistré et consigné au journal d’audit.",
  "fonA.finalitesOrg.aDecider": "À décider",
  "fonA.finalitesOrg.approuvees": "Approuvées",
  "fonA.finalitesOrg.toutes": "Toutes",
  "fonA.finalitesOrg.aide": "Le propriétaire d’un projet déclare la finalité d’un agent ; l’administration de l’organisation l’approuve ou la refuse — jamais la personne qui l’a déclarée. Chaque personne consent ensuite elle-même avant d’exécuter l’agent.",
  "fonA.finalitesOrg.filtres": "Filtrer les finalités",
  "fonA.finalitesOrg.chargement": "Lecture des finalités de l’organisation…",
  "fonA.finalitesOrg.refus": "La décision des finalités IA revient à l’administration de l’organisation.",
  "fonA.finalitesOrg.erreur": "Les finalités n’ont pas pu être lues.",
  "fonA.finalitesOrg.vide": "Aucune finalité dans ce filtre",
  "fonA.finalitesOrg.videAide": "Les propriétaires de projet déclarent les finalités depuis Agents personnalisés.",
  "fonA.sante.chargement": "Lecture de la santé de la plateforme…",
  "fonA.sante.refus": "La santé de la plateforme est réservée à son administration.",
  "fonA.sante.erreur": "La santé de la plateforme n’a pas pu être lue.",
  "fonA.sante.sain": "sain",
  "fonA.sante.attention": "à surveiller",
  "fonA.sante.degrade": "dégradé",
  "fonA.sante.inconnu": "inconnu",
  "fonA.sante.gpuDetecte": "détecté",
  "fonA.sante.gpuNonDetecte": "non détecté",
  "fonA.sante.verifie": "vérifié le {{date}}",
  "fonA.sante.etatsDegrades": "États dégradés et procédure de réparation",
  "fonA.sante.procedure": "Procédure hors outil :",
  "fonA.sante.composants": "Versions des composants",
  "fonA.sante.interface": "Interface",
  "fonA.sante.migrations": "{{n}} migrations",
  "fonA.sante.poste": "Profil du poste",
  "fonA.sante.gpu": "GPU : {{etat}}",
  "fonA.sante.budget": "Carte déclarée : {{carte}} · budget {{budget}} Mio sur {{total}} Mio",
  "fonA.sante.residentsInconnus": "Modèles résidents : inconnus ({{code}})",
  "fonA.sante.aucunResident": "Aucun modèle résident en VRAM.",
  "fonA.sante.residents": "Résidents : {{liste}}",
  "fonA.sante.modeleOk": "installé, empreinte conforme",
  "fonA.sante.modeleManquant": "manquant",
  "fonA.sante.modeleCorrompu": "empreinte différente",
  "fonA.sante.moteurs": "Moteurs d’IA et workers",
  "fonA.sante.aucunWorker": "Aucun worker n’a donné signe de vie depuis un jour.",
  "fonA.sante.vivant": "vivant",
  "fonA.sante.perime": "muet",
  "fonA.sante.sansMoteur": "sans moteur",
  "fonA.sante.travaux": "{{n}} travaux",
  "fonA.sante.connexions": "Connexions d’IA de la plateforme",
  "fonA.exigence.chargement": "Lecture de l’exigence…",
  "fonA.exigence.introuvable": "Cette exigence n’existe pas dans votre organisation.",
  "fonA.exigence.erreur": "L’exigence n’a pas pu être lue.",
  "fonA.exigence.titre": "Exigence {{code}}",
  "fonA.exigence.description": "{{categorie}} · version {{v}} · héritée par {{p}} projet(s) et {{g}} programme(s)",
  "fonA.exigence.retour": "Référentiel d’exigences",
  "fonA.exigence.creee": "créée par {{qui}} le {{date}}",
  "fonA.exigence.modifiee": "modifiée par {{qui}} le {{date}}",
  "fonA.exigence.retiree": "Une exigence retirée ne se modifie plus.",
  "fonA.exigence.enonce": "Énoncé",
  "fonA.exigence.seuil": "Seuil",
  "fonA.exigence.mesure": "Méthode de mesure",
  "fonA.exigence.controle": "Contrôle qui la vérifie",
  "fonA.exigence.proprietaire": "Propriétaire",
  "fonA.exigence.enregistrer": "Enregistrer (nouvelle version)",
  "fonA.exigence.enregistree": "Exigence modifiée : version {{v}}, consignée au journal.",
  "fonA.sante.vram": "{{u}} / {{n}} Mio",
  "fonA.webhooks.nomRequis": "Donnez un nom au webhook.",
  "fonA.webhooks.workflowRequis": "Un webhook gitlab_push déclenche un workflow : indiquez-le.",
  "fonA.finalites.agentRequis": "Choisissez l’agent concerné.",
  "fonA.finalites.justificationCourte": "La justification compte 10 caractères au moins.",
  "fonA.finalites.dureeInvalide": "La durée va de 1 à 365 jours.",
  "fonA.deleg.projetRequis": "Choisissez le projet.",
  "fonA.deleg.delegueRequis": "Choisissez le délégué.",
  "fonA.deleg.finRequise": "Indiquez la date de fin.",
  "fonA.deleg.motifRequis": "Le motif compte 5 caractères au moins.",
  "fonA.fiche.motifRequis": "Un refus ou un retrait porte un motif de 5 caractères au moins.",
  "fonA.exigence.requis": "L’énoncé et le propriétaire sont obligatoires.",
  "fonA.gouvernance.onglets": "Vues de la gouvernance",
  "fonA.gouvernance.ongletReglages": "Réglages et arrêt d’urgence",
  "accueil.titre.administration": "Ce qui attend une décision d’administration, et les raccourcis",
  "accueilAdmin.degradee": "dégradée",
  "accueilAdmin.demandeLigne": "{{qui}} demande l’accès à « {{projet}} »",
  "accueilAdmin.demandes": "Demandes d’accès à décider",
  "accueilAdmin.demandesChargement": "Lecture des demandes d’accès…",
  "accueilAdmin.demandesErreur": "Les demandes d’accès n’ont pas pu être lues.",
  "accueilAdmin.demandesVide": "Aucune demande d’accès en attente",
  "accueilAdmin.demandesVideIndice": "Une personne qui ouvre un projet sans en être membre peut demander l’accès ; elle apparaît ici.",
  "accueilAdmin.description": "Ce qui attend une décision d’administration, puis les raccourcis de l’organisation{{plateforme}}.",
  "accueilAdmin.emetteurCoherent": "Émetteur des jetons cohérent avec Keycloak.",
  "accueilAdmin.emetteurIncoherent": "Émetteur des jetons incohérent : la passerelle attend « {{attendu}} », Keycloak émet « {{servi}} » — aucune connexion ne passe.",
  "accueilAdmin.emetteurNonVerifie": "Émetteur des jetons non vérifié ({{statut}}).",
  "accueilAdmin.etPlateforme": " et de la plateforme",
  "accueilAdmin.gererInvitations": "Gérer les invitations",
  "accueilAdmin.indisponible": "indisponible",
  "accueilAdmin.invitations": "Invitations en attente — projet courant",
  "accueilAdmin.invitationsChargement": "Lecture des invitations…",
  "accueilAdmin.invitationsErreur": "Les invitations n’ont pas pu être lues.",
  "accueilAdmin.invitationsSansProjet": "Aucun projet ouvert",
  "accueilAdmin.invitationsSansProjetIndice": "Les invitations se lisent par projet : ouvrez-en un dans le sélecteur de contexte.",
  "accueilAdmin.invitationsVide": "Aucune invitation en attente",
  "accueilAdmin.invitationsVideIndice": "Les invitations se créent dans les Réglages du projet, section Membres.",
  "accueilAdmin.inviter": "Inviter dans « {{projet}} »",
  "accueilAdmin.membresProjet": "Membres du projet courant",
  "accueilAdmin.ouvrirOrganisations": "Ouvrir les organisations",
  "accueilAdmin.ouvrirSante": "Ouvrir la santé de la plateforme",
  "accueilAdmin.raccourcis": "Raccourcis",
  "accueilAdmin.refus": "Cette vue est celle de l’administration",
  "accueilAdmin.refusIndice": "Votre rôle ne comporte aucune tâche d’administration : choisissez une autre vue dans « Vue », en bas de la navigation.",
  "accueilAdmin.saine": "saine",
  "accueilAdmin.sante": "Santé de la plateforme",
  "accueilAdmin.santeChargement": "Lecture de la santé…",
  "accueilAdmin.santeErreur": "La santé de la plateforme n’a pas pu être lue.",
  "accueilAdmin.santeEtat": "Plateforme : {{etat}}",
  "accueilAdmin.suspensions": "Organisations suspendues",
  "accueilAdmin.suspensionsChargement": "Lecture des organisations…",
  "accueilAdmin.suspensionsErreur": "Les organisations n’ont pas pu être lues.",
  "accueilAdmin.suspensionsVide": "Aucune organisation suspendue",
  "accueilAdmin.suspensionsVideIndice": "{{n}} organisation(s) active(s) sur la plateforme.",
  "accueilAdmin.titre": "Accueil administration",
  "admin.demanderProprietaire": "Demander à un propriétaire du projet",
  "admin.emetteurCoherent": "cohérent",
  "admin.emetteurIncoherent": "incohérent : aucune connexion ne passe",
  "admin.emetteurNonVerifie": "non vérifié",
  "admin.emetteurRemede": "Alignez KEYCLOAK_ISSUER_URI de la passerelle sur KC_HOSTNAME de Keycloak (mêmes fichiers Compose pour les deux), puis recréez la passerelle.",
  "admin.emetteurTitre": "Émetteur des jetons (Keycloak)",
  "admin.emetteurValeurs": "attendu : {{attendu}} · servi : {{servi}}",
  "adr.baselineLivree": "La baseline technologique du projet (héritage par catégorie, demandes de changement, propagation) vit dans « Choix et baseline » ; l’ADR et la matrice restent le chemin d’une catégorie définie pour ce projet.",
  "adr.ouvrirBaseline": "Ouvrir Choix et baseline",
  "adr.vuePile": "Profil de pile du projet",
  "adr.vueToutes": "Toutes les décisions",
  "attention.voisins": "Écrans voisins",
  "deliveryOverview.gitlabNonConnecte": "GitLab n’est pas connecté à ce projet.",
  "membres.accorder": "Accorder",
  "membres.chargement": "Lecture des membres…",
  "membres.colIdentifiant": "identifiant",
  "membres.colNom": "nom",
  "membres.colRole": "rôle",
  "membres.decisionEnregistree": "Décision enregistrée ; la personne en est notifiée.",
  "membres.dejaDecidee": "Cette demande a déjà été décidée.",
  "membres.demandes": "Demandes d’accès en attente",
  "membres.demandesChargement": "Lecture des demandes d’accès…",
  "membres.demandesErreur": "Les demandes d’accès n’ont pas pu être lues.",
  "membres.demandesVide": "Aucune demande d’accès en attente",
  "membres.demandesVideIndice": "Une personne de l’organisation qui ouvre ce projet sans en être membre peut demander l’accès ; vous en êtes notifié.",
  "membres.description": "Qui travaille sur « {{projet}} », avec quel rôle. Pour un rôle plus élevé, adressez-vous à un propriétaire.",
  "membres.equipeMembres": "{{n}} membre(s)",
  "membres.equipes": "Équipes",
  "membres.equipesChargement": "Lecture des équipes…",
  "membres.equipesErreur": "Les équipes n’ont pas pu être lues.",
  "membres.equipesVide": "Aucune équipe dans ce projet",
  "membres.equipesVideIndice": "Un propriétaire du projet ou l’administration de l’organisation crée les équipes depuis cet écran.",
  "membres.erreur": "Les membres n’ont pas pu être lus.",
  "membres.gerer": "Gérer les membres et les invitations",
  "membres.annuaire": "Annuaire de l’organisation",
  "membres.liste": "Membres",
  "membres.motifRefus": "Motif du refus (facultatif)",
  "membres.proprietaires": "Propriétaires : {{noms}}.",
  "membres.refuser": "Refuser",
  "membres.role.contributor": "contributeur",
  "membres.role.owner": "propriétaire",
  "membres.role.viewer": "lecteur",
  "membres.roleAccorde": "Rôle accordé",
  "membres.sansProjet": "Aucun projet ouvert",
  "membres.sansProjetIndice": "Choisissez un projet dans le sélecteur de contexte pour voir ses membres.",
  "membres.sansProprietaire": "Ce projet n’a aucun propriétaire actif.",
  "membres.titre": "Membres du projet",
  "membres.vide": "Aucun membre",
  "membres.videIndice": "Un propriétaire du projet ou l’administration de l’organisation ajoute les membres depuis cet écran.",
  "menu.accueilAdministration": "Accueil administration",
  "menu.invitations": "Mes invitations",
  "nonMembre.accordee": "Votre demande est accordée : le projet s’ouvre dès que la liste de vos projets est relue.",
  "nonMembre.adminIndisponible": "Ce projet n’est pas proposé au rattachement : il est archivé ou n’appartient pas à votre organisation.",
  "nonMembre.adminRejoindre": "Administrateur de la plateforme, vous pouvez rejoindre « {{nom}} » comme propriétaire : le geste est tracé au journal.",
  "nonMembre.annuler": "Annuler ma demande",
  "nonMembre.archive": "Ce projet est archivé : il n’accueille plus de nouveaux membres.",
  "nonMembre.chargement": "Lecture de vos demandes d’accès…",
  "nonMembre.compteInconnu": "Votre compte n’est pas un utilisateur actif de cette organisation.",
  "nonMembre.dejaEnAttente": "Une demande attend déjà la décision d’un propriétaire.",
  "nonMembre.dejaMembre": "Vous êtes déjà membre de ce projet : rechargez la page.",
  "nonMembre.demander": "Demander l’accès",
  "nonMembre.description": "Le projet {{id}} appartient à votre organisation, mais vous n’y avez aucun rôle : son contenu ne vous est pas montré.",
  "nonMembre.enAttente": "Demande envoyée le {{date}} : elle attend la décision d’un propriétaire du projet, qui en a été notifié.",
  "nonMembre.erreurLecture": "Vos demandes d’accès n’ont pas pu être lues.",
  "nonMembre.introuvable": "Ce projet est introuvable dans votre organisation.",
  "nonMembre.mesProjets": "Revenir à mes projets",
  "nonMembre.messageExemple": "Pourquoi avez-vous besoin de ce projet ?",
  "nonMembre.messageLabel": "Message au propriétaire (facultatif)",
  "nonMembre.ouvrir": "Ouvrir le projet",
  "nonMembre.redemander": "Vous pouvez en déposer une nouvelle.",
  "nonMembre.refusee": "Votre demande du {{date}} a été refusée",
  "nonMembre.rejoindre": "Rejoindre ce projet",
  "nonMembre.titre": "Vous n’êtes pas membre de ce projet",
  "orgProjets.lancement": "Lancement",
  "programs.ouvrirVue": "Ouvrir la vue du programme",
  "programs.ouvrirVueAria": "Ouvrir la vue du programme {{nom}}",
  "projet.ouvrirPleinePage": "Ouvrir en pleine page",
  "projetArchive.choisir": "Choisissez un autre projet dans le sélecteur de contexte, ou depuis la liste des projets de l’organisation.",
  "projetArchive.description": "« {{nom}} » n’est plus un lieu de travail : la passerelle ne sert plus son contenu, et ses écrans ne sont pas affichés.",
  "projetArchive.titre": "Ce projet est archivé",
  "roleRestreint.lien": "Voir les propriétaires du projet pour demander ce rôle",
  "roleRestreint.motif": "Action interdite pour votre rôle actuel. Le rôle {{role}} est requis pour {{action}}.",
  "runops.gitlabNonConnecte": "GitLab n’est pas connecté à ce projet : aucun pipeline à proposer.",
  "vueProjet.voirBaseline": "Voir la baseline technologique du projet",
  "nav./projet/membres": "Membres du projet",
  "navdesc./projet/membres": "Qui travaille sur ce projet, avec quel rôle ; équipes ; demandes d’accès à décider",
  "nav./administration": "Accueil administration",
  "navdesc./administration": "Demandes d’accès, invitations, organisations suspendues, santé et raccourcis d’administration",
  "menu.monOrganisation": "Mon organisation",
  "org.settings.demenage": "Mode des nouveaux projets et architectes désignés : ils engagent toute l’organisation et se règlent dans sa fiche. Les dérogations de tous les projets ont leur propre liste.",
  "org.settings.versFiche": "Mon organisation › Gouvernance",
  "org.settings.versDerogations": "Dérogations de toute l’organisation",
  "admin.organisationAiLecture": "En lecture ici : les connexions aux fournisseurs d’IA et les modèles de l’organisation se gèrent dans Mon organisation › Intégrations. Ce projet choisit ci-dessous, parmi eux, ceux qu’il autorise.",
  "admin.organisationAiAucunActif": "Aucun modèle n’est activé pour l’organisation.",
  "admin.versIntegrationsOrganisation": "Gérer dans Mon organisation › Intégrations",
  "derogationsOrg.titre": "Dérogations de l’organisation",
  "derogationsOrg.description": "Toutes les dérogations, par projet, risque, échéance et état — jamais prolongées en silence.",
  "derogationsOrg.chargement": "Lecture des dérogations…",
  "derogationsOrg.erreur": "Les dérogations n’ont pas pu être lues.",
  "derogationsOrg.aDecider": "à décider",
  "derogationsOrg.accordees": "accordées",
  "derogationsOrg.echues": "échues — non conformes",
  "derogationsOrg.levees": "levées ou refusées",
  "derogationsOrg.masquees": "Vous voyez les dérogations des projets dont vous êtes membre ; {{n}} autre(s) existe(nt) dans des projets où vous ne l’êtes pas.",
  "derogationsOrg.porteeMembre": "Vous voyez les dérogations des projets dont vous êtes membre.",
  "derogationsOrg.liste": "Dérogations ({{n}})",
  "derogationsOrg.filtre": "Afficher",
  "derogationsOrg.filtreActives": "en cours (à décider, accordées, échues)",
  "derogationsOrg.filtreADecider": "à décider",
  "derogationsOrg.filtreEchues": "échues",
  "derogationsOrg.filtreToutes": "toutes",
  "derogationsOrg.vide": "Aucune dérogation",
  "derogationsOrg.videIndice": "Une dérogation se demande depuis l’écran Exigences et dérogations d’un projet.",
  "derogationsOrg.filtreVide": "Aucune dérogation pour ce filtre",
  "derogationsOrg.filtreVideIndice": "Choisissez « toutes » pour revoir les dérogations levées ou refusées.",
  "derogationsOrg.legende": "Dérogations : exigence, projet, risque, échéance, état, responsable",
  "derogationsOrg.col.exigence": "exigence",
  "derogationsOrg.col.projet": "projet",
  "derogationsOrg.col.risque": "risque",
  "derogationsOrg.col.echeance": "échéance",
  "derogationsOrg.col.etat": "état",
  "derogationsOrg.col.responsable": "responsable",
  "derogationsOrg.retour": "← Dérogations de l’organisation",
  "derogationsOrg.introuvable": "Dérogation introuvable",
  "derogationsOrg.introuvableIndice": "Elle n’existe pas, ou appartient à un projet dont vous n’êtes pas membre.",
  "derogationsOrg.ficheChargement": "Lecture de la dérogation…",
  "derogationsOrg.ficheErreur": "La dérogation n’a pas pu être lue.",
  "derogationsOrg.ficheTitre": "Dérogation à {{code}}",
  "derogationsOrg.ficheEtat": "État et échéance",
  "derogationsOrg.parcours": "approbation",
  "derogationsOrg.demandee": "demandée",
  "derogationsOrg.ficheJustification": "Justification et contrôles",
  "derogationsOrg.relue": "Relue par {{qui}} : {{verdict}} — « {{commentaire}} »",
  "derogationsOrg.decidee": "Décidée par {{qui}} le {{quand}}",
  "derogationsOrg.agir": "Relire, décider ou lever cette dérogation se fait dans son projet :",
  "derogationsOrg.agirNonMembre": "Vous n’êtes pas membre de ce projet : la dérogation s’y relit et s’y décide par ses membres.",
  "derogationsOrg.ouvrirProjet": "Exigences et dérogations du projet",
  "ficheMonOrg.section.apercu": "Aperçu",
  "ficheMonOrg.section.gouvernance": "Gouvernance",
  "ficheMonOrg.section.derogations": "Dérogations",
  "ficheMonOrg.section.integrations": "Intégrations",
  "ficheMonOrg.refus.nom": "Le nom doit compter de 2 à 120 caractères.",
  "ficheMonOrg.refus.description": "La description tient en 2 000 caractères au plus.",
  "ficheMonOrg.refus.inchange": "Rien à enregistrer : nom et description sont inchangés.",
  "ficheMonOrg.refus.identifiant": "L’identifiant d’une organisation ne se modifie pas.",
  "ficheMonOrg.refus.admin": "Réservé à l’administration de l’organisation.",
  "ficheMonOrg.refus.suspendue": "Organisation suspendue par la plateforme : lecture seule.",
  "ficheMonOrg.refus.inattendu": "La passerelle a refusé la modification.",
  "ficheOrg.identite": "Identité et statut",
  "ficheMonOrg.modifier": "Modifier le nom et la description",
  "ficheOrg.nom": "Nom",
  "ficheOrg.description": "Description",
  "ficheMonOrg.identifiantFige": "L’identifiant {{id}} reste figé : il est porté par les jetons, les liens et l’audit.",
  "ficheMonOrg.annuler": "Annuler",
  "ficheMonOrg.enregistrer": "Enregistrer",
  "ficheOrg.identifiant": "Identifiant",
  "ficheOrg.sansDescription": "Aucune description.",
  "ficheOrg.statut": "Statut",
  "ficheOrg.palier": "Palier",
  "ficheMonOrg.quotas": "quotas et consommation",
  "ficheOrg.creee": "Créée le",
  "ficheMonOrg.modifiee": "Modifiée le",
  "ficheMonOrg.modifieePar": "{{quand}} par {{qui}}",
  "ficheMonOrg.enregistre": "Identité enregistrée et écrite à l’audit de l’organisation.",
  "ficheMonOrg.lectureSeule": "Lecture seule : l’identité et les intégrations se modifient par l’administration de l’organisation.",
  "ficheOrg.administrateurs": "Administrateurs",
  "ficheMonOrg.adminsVide": "Aucun administrateur enrôlé par la plateforme",
  "ficheMonOrg.adminsVideIndice": "L’organisation a été créée en libre-service : son administration est portée par le rôle d’administrateur de ses membres.",
  "ficheOrg.compteurs": "Compteurs",
  "ficheMonOrg.versProjets": "Projets",
  "ficheMonOrg.versProjetsAide": "{{n}} projet(s) : créer, ouvrir, rattacher",
  "ficheMonOrg.versProgrammes": "Programmes",
  "ficheMonOrg.versProgrammesAide": "{{n}} programme(s)",
  "ficheMonOrg.versUtilisateurs": "Utilisateurs",
  "ficheMonOrg.versUtilisateursAide": "{{n}} personne(s) : annuaire, rôles, appartenances",
  "ficheMonOrg.versQuotas": "Quotas et palier",
  "ficheMonOrg.versQuotasAide": "Palier {{p}} : limites et consommation",
  "ficheMonOrg.reglagesTitre": "Où se règle la gouvernance de l’organisation",
  "ficheMonOrg.reglagesAide": "Chaque réglage a son écran ; tous engagent l’ensemble des projets de l’organisation.",
  "ficheMonOrg.referentielAide": "Définition de fini, exigences et contrôles hérités par les projets",
  "ficheMonOrg.reglesAide": "Observer, avertir, bloquer : le temps de chaque règle",
  "ficheMonOrg.gouvernanceAide": "Modes d’approbation et arrêt d’urgence de l’IA",
  "ficheMonOrg.derogationsAide": "Toutes les dérogations de l’organisation, par projet et échéance",
  "ficheMonOrg.cheminAide": "Configuration recommandée et projets en écart",
  "ficheMonOrg.charteAide": "Charte graphique héritée par les projets",
  "ficheMonOrg.catalogueAide": "Choix technologiques proposés aux projets",
  "ficheMonOrg.accesAide": "Matrice des rôles et politiques d’accès",
  "ficheMonOrg.voirDerogations": "Ouvrir la liste des dérogations",
  "ficheMonOrg.chargement": "Lecture de la fiche de votre organisation…",
  "ficheMonOrg.titre": "Mon organisation",
  "ficheMonOrg.sansOrganisation": "Votre compte n’est rattaché à aucune organisation.",
  "ficheMonOrg.erreur": "La fiche de l’organisation n’a pas pu être lue.",
  "ficheMonOrg.description": "Mon organisation : identité, gouvernance, dérogations et intégrations communes à tous ses projets.",
  "ficheMonOrg.sections": "Sections de la fiche de l’organisation",
  "ficheOrg.onglet.apercu": "Aperçu",
  "ficheOrg.onglet.projets": "Projets et programmes",
  "ficheOrg.onglet.utilisateurs": "Utilisateurs",
  "ficheOrg.onglet.consommation": "Consommation",
  "ficheOrg.onglet.palier": "Palier",
  "ficheOrg.onglet.acces": "Accès exceptionnels",
  "ficheOrg.onglet.activation": "Liens d’activation",
  "ficheOrg.onglet.journal": "Journal",
  "ficheOrg.sante": "Santé",
  "ficheOrg.santeInconnue": "non mesurée",
  "ficheOrg.voirSante": "santé de la plateforme",
  "ficheOrg.adminsVide": "Aucun administrateur enrôlé par la plateforme",
  "ficheOrg.adminsVideIndice": "Organisation créée en libre-service ou avant l’enrôlement : générez un lien d’activation pour un administrateur.",
  "ficheOrg.versActivation": "Liens d’activation",
  "ficheOrg.projetsTitre": "Projets et programmes",
  "ficheOrg.besoinDeConnaitre": "Organisation tierce : la fiche en donne le nombre, jamais les noms ni le contenu. Pour un incident que son administrateur ne peut pas traiter, ouvrez un accès exceptionnel : motivé, limité dans le temps, notifié à ses propriétaires et écrit à son audit.",
  "ficheOrg.compteur.projets": "Projets",
  "ficheOrg.compteur.archives": "dont {{n}} archivé(s)",
  "ficheOrg.compteur.programmes": "Programmes",
  "ficheOrg.compteur.missions": "Missions en cours",
  "ficheOrg.versAcces": "Accès exceptionnels",
  "ficheOrg.projetsN": "Projets ({{n}})",
  "ficheOrg.aucunProjet": "Aucun projet",
  "ficheOrg.aucunProjetIndice": "Les projets se créent depuis Organisation › Projets.",
  "ficheOrg.archive": "archivé",
  "ficheOrg.programmesN": "Programmes ({{n}})",
  "ficheOrg.aucunProgramme": "Aucun programme",
  "ficheOrg.aucunProgrammeIndice": "Les programmes se créent depuis Organisation › Programmes.",
  "ficheOrg.utilisateursTitre": "Utilisateurs de l’organisation",
  "ficheOrg.utilisateursAide": "L’annuaire (personnes, rôles, appartenances, invitations) est tenu sur son propre écran.",
  "ficheOrg.compteur.membres": "Utilisateurs",
  "ficheOrg.compteur.actifsSeul": "Actifs",
  "ficheOrg.compteur.proprietaires": "Propriétaires de projet",
  "ficheOrg.versAnnuaire": "Ouvrir l’annuaire des utilisateurs",
  "ficheOrg.retour": "← Toutes les organisations",
  "ficheOrg.chargement": "Lecture de la fiche de l’organisation…",
  "ficheOrg.refus": "La fiche d’une organisation est réservée à l’administration de la plateforme.",
  "ficheOrg.introuvable": "Organisation introuvable",
  "ficheOrg.introuvableIndice": "Cet identifiant ne désigne aucune organisation. Revenez à la liste.",
  "ficheOrg.erreur": "La fiche n’a pas pu être lue.",
  "ficheOrg.sousTitre": "Fiche de l’organisation {{id}} — attributs et agrégats, jamais le contenu d’un projet.",
  "ficheOrg.palierCourt": "palier {{p}}",
  "ficheOrg.sienne": "votre organisation",
  "ficheOrg.onglets": "Sections de la fiche",
  "ficheOrg.accesSienne": "C’est votre organisation : vous la voyez déjà, sans accès exceptionnel.",
  "ficheOrg.activationTitre": "Liens d’activation de l’administrateur",
  "ficheMonOrg.connexionsVide": "Aucune connexion propre à l’organisation : seules celles que la plateforme partage avec elle s’appliquent.",
  "ficheMonOrg.exempleConnexion": "Ollama local GPU",
  "ficheMonOrg.type.ia": "Fournisseur IA",
  "ficheMonOrg.type.gitlab": "GitLab",
  "ficheMonOrg.type.odoo": "Odoo",
  "ficheMonOrg.inventaireTitre": "Inventaire des connecteurs",
  "ficheMonOrg.inventaireAide": "Connexions IA de l’organisation, GitLab et Odoo de chaque projet. Aucun secret n’est jamais montré : seulement s’il est configuré. Un connecteur de projet se règle dans les réglages de son projet.",
  "ficheMonOrg.inventaireChargement": "Lecture de l’inventaire…",
  "ficheMonOrg.inventaireRefus": "L’inventaire des connecteurs est réservé à l’administration de l’organisation.",
  "ficheMonOrg.inventaireErreur": "L’inventaire n’a pas pu être lu.",
  "ficheMonOrg.inventaireVide": "Aucun connecteur",
  "ficheMonOrg.inventaireVideIndice": "Enregistrez une connexion IA ci-dessus, ou reliez GitLab ou Odoo depuis les réglages d’un projet.",
  "ficheMonOrg.inventaireLegende": "Connecteurs : type, nom, portée, point d’accès, secret, dernière modification",
  "ficheMonOrg.col.type": "type",
  "ficheMonOrg.col.nom": "nom",
  "ficheMonOrg.col.portee": "portée",
  "ficheMonOrg.col.acces": "point d’accès",
  "ficheMonOrg.col.secret": "secret",
  "ficheMonOrg.col.modifie": "modifié",
  "ficheMonOrg.desactive": "désactivé",
  "ficheMonOrg.porteeOrganisation": "organisation",
  "ficheMonOrg.secretRef": "référencé : {{r}}",
  "ficheMonOrg.secretPose": "configuré",
  "ficheMonOrg.secretAbsent": "aucun",
  "ficheMonOrg.integrationsSansDroit": "Les intégrations de l’organisation (connexions IA, modèles, connecteurs) sont réservées à son administration.",
  "ficheMonOrg.canauxTitre": "Canaux de notification",
  "ficheMonOrg.canauxAide": "Les canaux (webhook, messagerie) sont aujourd’hui réglés par la plateforme et relayés pour toutes les organisations ; chaque personne choisit ce qui la notifie dans ses préférences.",
  "ficheMonOrg.versNotifications": "Mes notifications",
  "ficheOrg.admin.active": "compte activé",
  "ficheOrg.admin.attente": "activation en attente",
  "ficheOrg.admin.expire": "lien expiré",
  "ficheOrg.admin.revoque": "lien révoqué",
  "ficheOrg.compteur.actifs": "{{n}} actif(s) · {{p}} propriétaire(s) de projet",
  "ficheOrg.compteur.conso": "Ce mois : jetons · appels IA",
  "ficheOrg.compteur.acces": "Accès exceptionnels actifs",
  "ficheOrg.compteur.liens": "{{n}} lien(s) d’activation en attente",
  "ficheOrg.admin.activeLe": "activé le {{quand}}",
  "nav./org/fiche": "Mon organisation",
  "navdesc./org/fiche": "Identité de l’organisation, réglages de gouvernance, dérogations et intégrations (IA, connecteurs)",
  "ficheMonOrg.exempleSecret": "secret/llm/openai",
  "admin.accessDeniedProjetActif": "Ces réglages appartiennent au propriétaire du projet ouvert et à l'administration de l'organisation. Être propriétaire d'un autre projet ne suffit pas : ouvrez l'un de vos projets dans le sélecteur.",
  "admin.purgeReservee": "La purge détruit des preuves d’audit : elle relève de l’administration de l’organisation.",
  "arret.basculeReserveeOrganisation": "Arrêter ou relancer l’IA de l’organisation relève de son administration.",
  "config.mcpGestionReservee": "Importer, approuver, activer ou supprimer un serveur MCP relève de l’administration de l’organisation.",
  "conformite.exportReserve": "L’export d’audit de ce projet est réservé à son propriétaire, aux auditeurs et à l’administration de l’organisation.",
  "premiersPas.aFaire": "à faire",
  "premiersPas.acces": "Régler les politiques d’accès",
  "premiersPas.accesAction": "Régler la sécurité de connexion",
  "premiersPas.accesAide": "Second facteur obligatoire, durée de session, domaines e-mail autorisés ; puis la matrice des rôles.",
  "premiersPas.catalogue": "Constituer le catalogue technologique",
  "premiersPas.catalogueAction": "Ouvrir le catalogue",
  "premiersPas.catalogueAide": "Le jeu de départ pose en un geste les langages, frameworks, bases et plateformes (web, mobile, bureau) que la plateforme sait générer ; il reste à inscrire votre coffre de secrets.",
  "premiersPas.equipe": "Inviter l’équipe",
  "premiersPas.equipeAction": "Inviter une personne",
  "premiersPas.equipeAide": "Chaque personne reçoit un lien d’activation à usage unique, avec son rôle d’organisation et ses projets.",
  "premiersPas.fait": "fait",
  "premiersPas.masquer": "Masquer",
  "premiersPas.progression": "{{faits}} sur {{total}} faits — chaque pas se coche d’après l’état réel de l’organisation.",
  "premiersPas.projet": "Créer le premier projet",
  "premiersPas.projetAction": "Ouvrir les projets",
  "premiersPas.projetAide": "L’assistant de lancement : identité, programme, choix technologiques (dont la plateforme cible), équipe.",
  "premiersPas.titre": "Premiers pas de votre organisation",
  "risquePlan.enregistre": "Plan de mitigation enregistré",
  "risquePlan.titre": "Plan de mitigation du risque",
  "risquePlan.proprietaireLu": "Propriétaire : {{p}}",
  "risquePlan.mesureLue": "Mesure : {{m}}",
  "risquePlan.echeanceLue": "Échéance : {{e}}",
  "risquePlan.incomplet": "Choisissez le propriétaire, décrivez la mesure et fixez l’échéance.",
  "risquePlan.echeancePassee": "L’échéance doit être dans le futur.",
  "risquePlan.aide": "Le relecteur a signalé un risque. Pour approuver malgré ce risque, enregistrez d’abord qui le porte, ce qui sera fait et pour quand ; puis motivez votre décision dans le commentaire.",
  "risquePlan.proprietaire": "Propriétaire",
  "risquePlan.choisir": "Choisir un membre du projet…",
  "risquePlan.mesure": "Mesure",
  "risquePlan.echeance": "Échéance",
  "risquePlan.enregistrer": "Enregistrer le plan",
  "job.remedeModele.titre": "Le modèle {{modele}} n’est pas accordé à votre organisation.",
  "job.remedeModele.org": "Une administratrice ou un administrateur de l’organisation l’active dans",
  "job.remedeModele.orgLien": "Mon organisation › Intégrations",
  "job.remedeModele.orgFin": ", puis relance la demande.",
  "job.remedeModele.plateforme": "Si le bouton « Activer » y est grisé (« connecteur introuvable »), la connexion qui sert ce modèle n’est pas accordée à l’organisation : seul un super-administrateur l’accorde, dans",
  "job.remedeModele.plateformeLien": "Plateforme › IA",
  "premiersPas.modelesIa": "Activer les modèles IA de la plateforme",
  "premiersPas.modelesIaAction": "Ouvrir les intégrations",
  "premiersPas.modelesIaAide": "Modèles exécutés par la plateforme (cadrage, spécification, revue) non activés : {{modeles}}. Sans eux, le premier dépôt d’idée échoue.",
  "premiersPas.modelesIaConnecteur": "Modèles exécutés par la plateforme sans connecteur accordé : {{modeles}}. Seul un super-administrateur accorde la connexion (Plateforme › IA) ; activez ensuite les modèles ici.",
  "premiersPas.modelesIaIllisible": "L’état des modèles IA n’a pas pu être lu : vérifiez Mon organisation › Intégrations.",
  "versions.docsPerimee": "Documentation périmée : les objets qu’elle décrit (items livrés, déploiements, preuves de recette, notes) ont changé depuis sa génération. Régénérez-la avant de la diffuser.",
  "versions.docsRegenerate": "Régénérer la documentation",
  "versions.docsGenerePar": "générée par {{qui}}",
  "versions.docPerimee": "périmée",
  "catalogueTech.plancherIdentiteAideV2": "aucune entrée : le jeu de départ propose Keycloak, le fournisseur d’identité de la plateforme. Aucun profil de génération ne l’intègre : un projet qui le retient n’est pas générable. Pour une application générée, retenez « Intégré à la pile générée » — l’authentification est alors celle que le code généré écrit ; exigez-la dans la spécification si elle compte.",
  "baseline.optionNonGenerable": "non générable",
  "baseline.nonGenerableAide": "Non générable : {{produits}} — aucun profil de génération ne l’intègre, le projet ne serait pas générable. Pour une application générée, choisissez « Intégré à la pile générée ».",
  "approvals.appSlugExemple": "caisse-web",
  "chat.conversationLibre": "Conversation libre : rien de ce qui se dit ici n’est enregistré comme décision. Les relectures et les décisions se prennent dans",
  "decisions.afficherConsignes": "Afficher les consignes",
  "decisions.age.heures": "{{n}} h",
  "decisions.age.jours": "{{n}} j",
  "decisions.age.minutes": "{{n}} min",
  "decisions.agir": "Agir",
  "decisions.aide": "Comment se prend une décision ?",
  "decisions.apresDecision": "Après votre décision",
  "decisions.aVous": "À vous d’agir",
  "decisions.col.action": "Action",
  "decisions.col.depuis": "Depuis",
  "decisions.col.document": "Document",
  "decisions.col.etape": "Étape requise",
  "decisions.col.qui": "Qui doit agir",
  "decisions.consigne": "Ce qui doit changer",
  "decisions.consignesIA": "Consignes de l’IA (prompt d’origine)",
  "decisions.controleALancer": "La spécification doit réussir son contrôle qualité sur cette version avant toute approbation.",
  "decisions.demanderChangement": "Demander un changement de cette spécification",
  "decisions.demanderVersion": "Demander la nouvelle version",
  "decisions.description": "Ce qui attend une relecture, un contrôle ou une décision dans ce projet — et qui doit agir. Une ligne par document ; ses versions sont dans le détail.",
  "decisions.erreurLecture": "Le document n’a pas pu être lu.",
  "decisions.etape.approved": "Approuvé",
  "decisions.etape.attendPrecedente": "Possible après l’étape précédente — {{qui}}.",
  "decisions.etape.decision": "Décision",
  "decisions.etape.enCours": "En cours…",
  "decisions.etape.expired": "Expirée",
  "decisions.etape.planRequis": "· plan de mitigation requis",
  "decisions.etape.qualityCheck": "Contrôle qualité à lancer",
  "decisions.etape.qualityCheckRunning": "Contrôle qualité en cours",
  "decisions.etape.rejected": "Rejeté",
  "decisions.etape.reussi": "Réussi sur cette version.",
  "decisions.etape.review": "Relecture par un tiers",
  "decisions.etape.revision": "Nouvelle version demandée",
  "decisions.etape.revueFaite": "{{qui}} — {{verdict}}",
  "decisions.etape.superseded": "Remplacée",
  "decisions.etapesRequises": "Étapes requises",
  "decisions.etat.aVenir": "à venir",
  "decisions.etat.bloque": "en attente de l’étape précédente",
  "decisions.etat.courant": "en cours",
  "decisions.etat.fait": "faite",
  "decisions.filAriane": "Fil d’Ariane",
  "decisions.filtre.demande": "Demande",
  "decisions.filtre.etape": "Étape",
  "decisions.filtre.recherche": "Rechercher",
  "decisions.filtre.rechercherDocument": "Titre, demande ou personne…",
  "decisions.filtre.tousTypes": "Tous les documents",
  "decisions.filtre.toutes": "Toutes",
  "decisions.filtre.type": "Type",
  "decisions.filtres": "Filtrer les décisions",
  "decisions.introuvable": "Ce document n’existe pas ou vous n’êtes pas membre du projet.",
  "decisions.lancerControle": "Lancer le contrôle qualité",
  "decisions.meta.demandePar": "demandé par {{qui}}",
  "decisions.meta.editee": "édité par {{qui}}",
  "decisions.meta.le": "le {{date}}",
  "decisions.meta.redigeeIA": "rédigé par l’IA",
  "decisions.meta.remplace": "remplace la v{{n}}",
  "decisions.meta.version": "version {{n}}",
  "decisions.methodeIA": "Méthode IA",
  "decisions.motif.accessDenied": "Votre rôle dans ce projet permet de lire, pas d’agir ({{qui}} peut agir).",
  "decisions.motif.autre": "Une autre personne doit agir : {{qui}}.",
  "decisions.motif.expired": "Cette demande a expiré : une nouvelle demande est nécessaire.",
  "decisions.motif.qualityRunning": "Le contrôle qualité est en cours ; la décision sera possible ensuite.",
  "decisions.motif.reviewer": "Vous avez relu ce document : une autre personne décidera ({{qui}}).",
  "decisions.motif.reviewRequired": "Une relecture par un tiers est nécessaire avant toute décision ({{qui}}).",
  "decisions.motif.selfApproval": "Vous avez demandé ce document : une autre personne décidera ({{qui}}).",
  "decisions.motif.selfReview": "Vous avez demandé ce document : une relecture par un tiers est nécessaire ({{qui}}).",
  "decisions.motif.specGate": "La spécification doit d’abord réussir son contrôle qualité sur cette version.",
  "decisions.motif.twoPersonExcluded": "Mode deux personnes : ce type de décision garde trois personnes distinctes ({{qui}} décidera).",
  "decisions.motif.twoPersonReviewer": "Mode deux personnes : une relecture par une autre personne est d’abord nécessaire.",
  "decisions.motif.twoPersonRisk": "Mode deux personnes : réservé aux objets à risque faible ; une autre personne décidera ({{qui}}).",
  "decisions.nouvelleVersion": "Demander une nouvelle version…",
  "decisions.othersAide": "Vous pouvez les lire ; la personne nommée doit agir.",
  "decisions.ou": " ou ",
  "decisions.pour": "Pour {{qui}}",
  "decisions.precision.controle": "Contrôle automatique en cours",
  "decisions.precision.lecture": "Lecture seule pour votre rôle",
  "decisions.precision.plan": "Réserve du relecteur : plan de mitigation requis",
  "decisions.precision.relu": "Relu par {{qui}} — {{verdict}}",
  "decisions.precision.reviewer": "Vous l’avez relu : une autre personne décide",
  "decisions.precision.selfApproval": "Vous ne pouvez pas décider votre propre demande",
  "decisions.precision.selfReview": "Vous ne pouvez pas relire votre propre demande",
  "decisions.qui.etAutres": "{{debut}} et {{n}} autres",
  "decisions.qui.ou": "{{debut}} ou {{dernier}}",
  "decisions.qui.personne": "Personne d’autre dans ce projet ne peut le faire",
  "decisions.qui.systeme": "Contrôle automatique en cours",
  "decisions.qui.vous": "Vous",
  "decisions.rail.titre": "Votre décision",
  "decisions.rail.titreTermine": "Décision prise",
  "decisions.remplaceesExclues": "{{n}} version(s) remplacée(s) ne sont jamais « à traiter » : elles se consultent dans le détail du document.",
  "decisions.retourListe": "Retour aux décisions à prendre",
  "decisions.rienAFaire": "Rien à faire pour vous dans ce projet.",
  "decisions.rienPourVous": "Rien à faire pour vous ; {{n}} document(s) attendent {{qui}}.",
  "decisions.role.approbateur": "décision",
  "decisions.role.membre": "membre du projet",
  "decisions.role.relecteur": "relecture",
  "decisions.section.controle": "Contrôle qualité",
  "decisions.section.document": "Document",
  "decisions.section.done": "Terminées",
  "decisions.section.mine": "À vous d’agir",
  "decisions.section.others": "En attente d’une autre personne",
  "decisions.section.technique": "Technique",
  "decisions.section.versions": "Versions",
  "decisions.sections": "Sections du document",
  "decisions.suiteProposee": "Prochaine étape proposée",
  "decisions.titreListe": "Décisions à prendre",
  "decisions.uneAutrePersonne": "une autre personne",
  "decisions.verbe.decider": "Décider",
  "decisions.verbe.evaluer": "Évaluer",
  "decisions.verbe.lire": "Lire",
  "decisions.verbe.ouvrir": "Ouvrir",
  "decisions.verbe.relire": "Relire",
  "decisions.verbe.reviser": "Demander une version",
  "decisions.verbe.suivre": "Suivre",
  "decisions.verdict.approve": "favorable",
  "decisions.verdict.reject": "révision demandée",
  "decisions.verdict.risk": "réserve",
  "decisions.videTitre": "Rien n’attend de décision dans ce projet",
  "decisions.voirControle": "Voir le contrôle qualité",
  "decisions.voirEtapes": "Voir les étapes",
  "decisions.vousPouvezLire": "Vous pouvez lire le document.",
  "demandes.documents": "Documents de cette demande",
  "demandes.documentsAucun": "Aucun document n’attend de décision pour cette demande.",
  "demandes.prochaine.ensuite": "Les autres documents de la demande sont listés ci-dessous.",
  "demandes.prochaine.pourAutre": "Prochaine action — pour {{qui}}",
  "demandes.prochaine.pourVous": "Prochaine action — pour vous",
  "demandes.prochaine.titre": "Prochaine action",
  "lecture.alors": "Alors",
  "lecture.applicationTechnique": "Empreintes et arborescence : dans la fiche technique.",
  "lecture.aucunChangement": "Aucun changement de contenu (seul l’en-tête technique diffère).",
  "lecture.aucuneQuestion": "Aucune question : l’IA n’a relevé aucune zone floue.",
  "lecture.backlogResume": "{{e}} epics, {{s}} stories",
  "lecture.changements": "Ce qui change depuis la version précédente",
  "lecture.changementsDepuis": "Ce qui change depuis la version {{n}}",
  "lecture.chiffre.couverture": "Exigences couvertes par un critère",
  "lecture.chiffre.criteres": "Critères d’acceptation",
  "lecture.chiffre.exigences": "Exigences",
  "lecture.col.couverture": "Couverture",
  "lecture.col.criteres": "Critères",
  "lecture.col.exigence": "Exigence",
  "lecture.comparerTexte": "Comparer le texte complet, ligne à ligne",
  "lecture.criteres": "Critères d’acceptation",
  "lecture.criteresAjoutes": "critères ajoutés",
  "lecture.criteresModifies": "critères modifiés",
  "lecture.criteresN": "Critères ({{n}})",
  "lecture.criteresRetires": "critères retirés",
  "lecture.criteresSansExigence": "Critères sans exigence : {{n}}",
  "lecture.enTete": "En-tête du document",
  "lecture.epic": "Epic",
  "lecture.etantDonne": "Étant donné",
  "lecture.exigences": "Exigences",
  "lecture.exigencesAjoutees": "exigences ajoutées",
  "lecture.exigencesModifiees": "exigences modifiées",
  "lecture.exigencesN": "Exigences ({{n}})",
  "lecture.exigencesRetirees": "exigences retirées",
  "lecture.ficheTechnique": "Fiche technique (provenance, références machine, consignes de l’IA)",
  "lecture.introuvable": "{{c}} introuvable",
  "lecture.langueDifferente": "{{n}} titre(s) sur {{total}} semblent rédigés dans une autre langue que celle du projet (indication automatique).",
  "lecture.lignesMachine": "Exemples de vérification (lignes machine)",
  "lecture.modifiee": "Modifiée",
  "lecture.modifieeEn": "Modifiée en v{{n}}",
  "lecture.nCriteres": "{{n}} critère(s)",
  "lecture.nouvelle": "Nouvelle",
  "lecture.nouvelleEn": "Nouvelle en v{{n}}",
  "lecture.origine.ia": "déduit par l’IA",
  "lecture.origine.idee": "écrit dans l’idée",
  "lecture.quand": "Quand",
  "lecture.questionN": "Question {{n}}",
  "lecture.questionsN": "Questions ouvertes ({{n}})",
  "lecture.questionsOuvertes": "Questions ouvertes",
  "lecture.referencesIntrouvables": "références introuvables : {{l}}",
  "lecture.registre.metier": "Lecture",
  "lecture.registre.technique": "Texte brut",
  "lecture.reglesBesoin": "Règles du besoin",
  "lecture.reglesBesoinN": "Règles du besoin ({{n}})",
  "lecture.sansCritere": "Aucun critère ne vérifie cette exigence.",
  "lecture.sectionsAjoutees": "sections ajoutées",
  "lecture.sectionsModifiees": "sections modifiées",
  "lecture.sectionsRetirees": "sections retirées",
  "lecture.sommaire": "Sommaire du document",
  "lecture.titreGenere": "Titre généré :",
  "lecture.tracabilite": "Traçabilité",
  "lecture.tracabiliteResume": "Chaque exigence et les critères qui la vérifient — {{c}} exigences sur {{n}} couvertes.",
  "lecture.type.application": "Application",
  "lecture.type.autre": "Document",
  "lecture.type.backlog": "Backlog",
  "lecture.type.cadrage": "Cadrage",
  "lecture.type.idee": "Idée",
  "lecture.type.options": "Options",
  "lecture.type.personas": "Personas",
  "lecture.type.processus": "Processus",
  "lecture.type.specification": "Spécification",
  "lecture.verifie": "Vérifie",
  "lecture.verifieePar": "Vérifiée par",
  "nav.decisionsPourMoi": "{{n}} décision(s) à prendre par vous",
  "review.openDecisionPage": "Ouvrir la page de décision",
  "decisions.etape.qualityCheckDone": "Contrôle qualité",
  "points.etat.ouverteBloquante": "Ouverte · bloquante",
  "points.etat.ouverte": "Ouverte",
  "points.etat.reporteeSpec": "Reportée à la spécification",
  "points.etat.reportee": "Reportée ({{etape}})",
  "points.etat.repondueTransmise": "Répondue — transmise à l’IA",
  "points.etat.repondue": "Répondue — sera transmise à la prochaine version",
  "points.etat.aVerifier": "À vérifier dans la nouvelle version",
  "points.etat.integree": "Intégrée",
  "points.etat.sansObjet": "Sans objet",
  "points.etape.backlog": "backlog",
  "points.etape.application": "application",
  "points.etape.specification": "spécification",
  "points.doc.cadrage": "le cadrage",
  "points.doc.specification": "la spécification",
  "points.doc.document": "le document",
  "points.origine.cadrage": "Posée par l’IA dans {{doc}}{{v}} — « Questions ouvertes ».",
  "points.origine.spec": "Point bloquant relevé par l’IA dans {{doc}}{{v}}.",
  "points.origine.humain": "Ajoutée par {{qui}} le {{date}}.",
  "points.origine.ia": "Posée par l’IA.",
  "points.evt.created": "posée",
  "points.evt.raisedAgain": "reposée par une nouvelle version",
  "points.evt.blocking": "devenue bloquante",
  "points.evt.answered": "répondue",
  "points.evt.answerChanged": "réponse modifiée",
  "points.evt.deferred": "reportée",
  "points.evt.reposed": "reposée à l’étape prévue",
  "points.evt.notApplicable": "déclarée sans objet",
  "points.evt.reopened": "rouverte",
  "points.evt.sent": "transmise à l’IA",
  "points.evt.versionProduced": "nouvelle version produite",
  "points.evt.integrated": "intégrée (vérifiée)",
  "points.evt.notFound": "non retrouvée — rouverte",
  "points.evt.linked": "rattachée",
  "points.erreur.conflit": "Ce point a été modifié par une autre personne pendant votre saisie : il vient d’être rechargé. Votre texte est conservé.",
  "points.erreur.generique": "L’enregistrement a échoué. Votre saisie est conservée ; réessayez.",
  "points.statut.enregistre": "{{code}} : {{etat}}.",
  "points.relanceDe": "Relance de {{code}}.",
  "points.avis": "avis — ne décide pas",
  "points.suggestion": "Ressemble à {{code}} : même question ?",
  "points.confirmerRattachement": "Confirmer le rattachement à {{code}}",
  "points.propositionRetenue": "proposition de l’IA retenue",
  "points.reporteeTexte": "Elle sera reposée à l’étape « {{etape}} ».",
  "points.motifSansObjet": "Motif :",
  "points.verifiePar": "Vérifiée par {{qui}} le {{date}}",
  "points.aVerifierTexte": "Une nouvelle version a été produite avec cette réponse. Une personne doit confirmer qu’elle s’y retrouve — l’IA ne coche jamais.",
  "points.refs": "Où la retrouve-t-on ? (ex. REQ-11, C-12 — facultatif)",
  "points.retrouvee": "Retrouvée dans la version",
  "points.nonRetrouvee": "Non retrouvée — rouvrir",
  "points.verifAutre": "Vous avez écrit cette réponse : une autre personne du projet vérifiera son intégration.",
  "points.verifLecture": "Un membre qui peut agir vérifiera son intégration.",
  "points.votreReponse": "Votre réponse",
  "points.aideReponse": "Votre réponse est enregistrée à votre nom et transmise à l’IA comme une donnée, avec la prochaine version. {{n}} / 2 000 caractères.",
  "points.motifObligatoire": "Motif (obligatoire)",
  "points.motifRouvrir": "Motif de la réouverture",
  "points.reponseVide": "Écrivez une réponse avant de l’enregistrer.",
  "points.enregistrer": "Enregistrer la réponse",
  "points.annuler": "Annuler",
  "points.motifRequis": "Un motif est obligatoire pour déclarer un point sans objet.",
  "points.motifRequisRouvrir": "Un motif est obligatoire pour rouvrir un point sans objet.",
  "points.confirmerSansObjet": "Déclarer sans objet",
  "points.confirmerRouvrir": "Rouvrir",
  "points.modifier": "Modifier la réponse",
  "points.repondre": "Répondre",
  "points.reporter": "Reporter à la spécification",
  "points.sansObjet": "Sans objet…",
  "points.rouvrir": "Rouvrir…",
  "points.historique": "Historique ({{n}})",
  "points.acteur.ia": "IA",
  "points.acteur.systeme": "Plateforme",
  "points.erreurLecture": "Les points à trancher n’ont pas pu être lus.",
  "points.sansDemande": "Ce document n’est rattaché à aucune demande : il n’a pas de points à trancher.",
  "points.intro": "Les zones floues deviennent des questions — jamais des suppositions. Chaque réponse est enregistrée à votre nom et transmise à la version suivante comme une donnée.",
  "points.nouvelleQuestion": "Nouvelle question",
  "points.questionVide": "Écrivez la question.",
  "points.ajouter": "Ajouter la question",
  "points.ajouterQuestion": "Ajouter une question",
  "points.lectureSeule": "Votre rôle permet de lire les points, pas d’y répondre.",
  "points.vide": "Aucune question : l’IA n’a relevé aucune zone floue.",
  "points.compte.ouvertes": "Ouvertes",
  "points.compte.reportees": "Reportées",
  "points.compte.repondues": "Répondues",
  "points.compte.aVerifier": "À vérifier",
  "points.compte.integrees": "Intégrées",
  "points.compte.sansObjet": "Sans objet",
  "points.compte.titre": "Points à trancher par état",
  "points.compte.etat": "État",
  "points.compte.nombre": "Nombre",
  "echanges.doc.cadrage": "le cadrage",
  "echanges.doc.specification": "la spécification",
  "echanges.doc.document": "le document",
  "echanges.idee": "Idée déposée",
  "echanges.versionIA": "A rédigé",
  "echanges.versionHumaine": "A édité",
  "echanges.remplacee": "remplacée depuis",
  "echanges.consigne": "Consigne complémentaire",
  "echanges.bloquant": "bloquant",
  "echanges.relecture": "Relecture",
  "echanges.approuve": "A approuvé",
  "echanges.rejete": "A rejeté",
  "echanges.controle": "Contrôle qualité",
  "echanges.reussi": "réussi",
  "echanges.corrections": "corrections requises",
  "echanges.score": "score {{s}} (avis — ne décide pas)",
  "echanges.reponseModifiee": "réponse modifiée",
  "echanges.reponse": "réponse",
  "echanges.repondue": "répondue",
  "echanges.reporte": "A reporté {{code}} à la spécification",
  "echanges.sansObjet": "sans objet",
  "echanges.rouvert": "A rouvert {{code}}",
  "echanges.repose": "{{code}} est reposée : l’étape de la spécification a commencé.",
  "echanges.devenuBloquant": "{{code}} est reprise comme point bloquant de la spécification.",
  "echanges.transmis": "A demandé une nouvelle version avec les réponses à {{codes}} ({{n}} caractères transmis comme données).",
  "echanges.produite": "Nouvelle version produite avec la réponse à {{code}} : à vérifier par une personne.",
  "echanges.voirVersion": "Voir la version",
  "echanges.integre": "A vérifié {{code}} : retrouvée dans la version",
  "echanges.integree": "intégrée",
  "echanges.nonRetrouve": "La réponse à {{code}} n’a pas été retrouvée dans la version : rouverte.",
  "echanges.rattache": "A rattaché {{code}} à {{cible}}.",
  "echanges.ajoute": "A ajouté la question {{code}} : « {{q}} »",
  "echanges.filtre.tout": "Tout",
  "echanges.filtre.questions": "Questions",
  "echanges.filtre.reponses": "Réponses et décisions",
  "echanges.filtre.versions": "Versions",
  "echanges.filtres": "Filtrer le fil",
  "echanges.vide": "Rien dans ce filtre pour le moment.",
  "echanges.liste": "Échanges, du plus ancien au plus récent",
  "echanges.acteur.ia": "IA",
  "echanges.acteur.systeme": "Contrôle automatique",
  "echanges.acteur.personne": "Une personne",
  "echanges.introuvable": "Cette demande n’existe pas ou vous n’êtes pas membre du projet.",
  "echanges.erreur": "Le fil n’a pas pu être lu.",
  "echanges.demandes": "Demandes",
  "echanges.titreCourt": "Échanges",
  "echanges.demande": "Demande {{ref}}",
  "echanges.titre": "Échanges sur « {{titre}} »",
  "echanges.intro": "Tout ce que l’IA a demandé, ce que vous avez répondu et ce qui en est sorti, du dépôt de l’idée à la dernière version. Les réponses sont des décisions signées ; l’IA ne les modifie pas.",
  "echanges.tronque": "{{n}} éléments au total ; les plus récents ne sont pas affichés.",
  "echanges.repondreA": "Répondre à {{code}}",
  "decisions.section.pointsTitre": "Points à trancher",
  "echanges.integreeDef": "Une réponse est « intégrée » quand une personne a vérifié qu’elle se retrouve dans une version. L’IA ne coche pas.",
  "echanges.tousLesPoints": "Voir et traiter tous les points ({{n}})",
  "decisions.section.points": "Points à trancher ({{n}})",
  "decisions.section.echanges": "Échanges",
  "decisions.reponsesTransmises": "Réponses transmises : {{codes}} ({{n}} caractères).",
  "decisions.consignesTransmises": "Consignes précédentes transmises avec la vôtre : {{versions}}.",
  "decisions.consignesPrecedentesTitre": "Consignes déjà données sur ce document ({{n}}) — transmises avec la vôtre",
  "decisions.consignesPrecedentesAide": "L’IA les conserve, sauf si votre consigne les contredit explicitement : inutile de les recopier.",
  "decisions.consignesPrecedentesEcartees": "Au-delà de {{max}} caractères, les plus anciennes ne partent pas : {{versions}}. Reprenez dans votre consigne celles qui comptent encore.",
  "decisions.capaciteConsignesAbsente": "Aucun worker actif ne sait transmettre les consignes précédentes à l’IA : la nouvelle version serait refusée plutôt que de les perdre. Faites mettre à jour et redémarrer le worker.",
  "approvals.consignesPrecedentesJointes": "avec les consignes précédentes de {{versions}}",
  "decisions.nouvelleVersionReponses": "Demander une nouvelle version avec mes réponses ({{n}})…",
  "decisions.reponsesJointes": "Réponses jointes (données, jamais des consignes)",
  "decisions.caracteresTransmis": "{{n}} caractères transmis (au plus {{max}}) — l’IA les lit comme des décisions de l’équipe, pas comme des ordres.",
  "decisions.reponsesTropLongues": "Les réponses cochées dépassent {{max}} caractères : décochez-en une partie.",
  "decisions.demanderVersionReponses": "Demander une nouvelle version avec mes réponses ({{n}})",
  "decisions.pointsDeLaDemande": "{{n}} point(s) sur la demande",
  "decisions.section.echangesTitre": "Échanges avec l’IA sur cette demande ({{n}})",
  "decisions.voirEchanges": "Ouvrir le fil complet de {{ref}}",
  "decisions.etape.pointsDetail": "{{n}} à répondre, reporter ou déclarer sans objet — tout membre peut répondre.",
  "decisions.rail.pointsCadrage": "Pour approuver, il reste {{n}} question(s) à répondre ou à reporter.",
  "decisions.rail.pointsSpec": "Pour approuver, il reste {{n}} point(s) bloquant(s) à trancher.",
  "decisions.rail.allerPoints": "Répondre aux points",
  "decisions.rail.toutReporter": "Tout reporter à la spécification",
  "decisions.rail.reportees": "{{n}} question(s) reportée(s) à la spécification : elles y seront reposées.",
  "decisions.abandonner": "Abandonner cette version…",
  "decisions.rejeter": "Rejeter…",
  "decisions.abandonnerAide": "Cette version remplacée attend encore une décision : l’abandonner la retire de la file avec votre motif. La dernière version n’est pas touchée.",
  "decisions.rejeterAide": "Vous pouvez rejeter dès maintenant avec un motif, sans attendre l’étape de décision ; le demandeur le lira.",
  "decisions.motifRejet": "Motif du rejet (obligatoire)",
  "decisions.abandonnerBouton": "Abandonner la version",
  "demandes.points.titre": "Points à trancher",
  "demandes.points.ouverts": "{{n}} ouvert(s)",
  "demandes.points.aucun": "Aucune question pour le moment.",
  "demandes.points.repondre": "Répondre aux points et voir les échanges avec l’IA",
  "demandes.points.voirEchanges": "Voir les échanges avec l’IA",
  "decisions.precision.pointsCadrage": "{{n}} question(s) à répondre ou reporter",
  "decisions.precision.pointsSpec": "{{n}} point(s) bloquant(s) ouvert(s)",
  "decisions.etape.points": "Points à trancher",
  "decisions.verbe.repondre": "Répondre aux points",
  "decisions.motif.cadragePoints": "Des questions du cadrage n’ont ni réponse ni report : répondez-y ou reportez-les à la spécification avant toute approbation.",
  "decisions.motif.specPoints": "Des points bloquants sont encore ouverts : répondez-y ou déclarez-les sans objet avant toute approbation.",
  "echanges.questionsPosees2": "A posé {{n}} question(s) :",
  "demandes.livraisons.aucune": "Aucune version contenant un item de cette demande n’a encore été déployée avec succès.",
  "demandes.livraisons.horsProd": "palier hors production",
  "demandes.livraisons.manque": "Pas encore livrée : aucun de ces déploiements n’est sur un palier de production ni couvert par une recette métier accordée.",
  "demandes.livraisons.prod": "palier de production",
  "demandes.livraisons.prodDeduite": "palier de production (déduit, non déclaré)",
  "demandes.livraisons.recetteNon": "recette métier non accordée",
  "demandes.livraisons.recetteOk": "recette métier accordée",
  "demandes.livraisons.sur": "déployée sur {{p}}",
  "demandes.livraisons.titre": "Livraison",
  "palier.type.deduitHorsProduction": "hors production (déduit, à déclarer)",
  "palier.type.deduitProduction": "production (déduit, à déclarer)",
  "palier.type.horsProduction": "hors production",
  "palier.type.production": "production",
  "runops.productionAide": "Production : utilisé par les clients réels (approbation à deux personnes, mise en ligne par le sponsor). Hors production : dev, recette, préproduction. Modifiable ensuite, le changement est tracé.",
  "runops.productionChoisir": "— Choisir le type —",
  "runops.productionCorrection": "Corriger le type change le mode d’approbation et l’état « Livrée » des demandes ; le changement est tracé à l’audit.",
  "backlog.testsCriteresParent": "Une tâche ne porte pas de critères : les tests couvriront les critères de sa story « {{s}} ».",
  "backlog.testsSansCriteresStory": "Cette story n’a encore aucun critère d’acceptation : ajoutez-en, sinon la conception sera refusée.",
  "backlog.testsSansCriteresItem": "Cet item n’a aucun critère d’acceptation ni story parente : la conception sera refusée.",
  "backlog.provenance.expired": "La preuve Spec Gate de la spécification n° {{id}} a expiré le {{date}} : un reçu vaut 24 h. Pour rattacher la story à cet epic, réévaluez la spécification puis rattachez la preuve renouvelée (un propriétaire ou contributeur autre que son demandeur). Sinon, choisissez « Aucun » comme epic parent.",
  "backlog.provenance.superseded": "La spécification n° {{id}} de cet epic a été remplacée par une version plus récente : choisissez un epic de la version courante, ou « Aucun » comme epic parent.",
  "backlog.provenance.other": "La spécification de cet epic n’a pas (ou plus) de preuve Spec Gate courante : faites aboutir son approbation et sa preuve, ou choisissez « Aucun » comme epic parent.",
  "backlog.provenance.link": "Ouvrir la spécification n° {{id}}",
  "planFiche.aucunCasAideGeste": "Cochez un ou plusieurs cas du projet, puis rattachez-les en une fois.",
  "planFiche.aucunCasAideLecture": "Les cas se rattachent par un membre qui peut écrire dans le projet.",
  "planFiche.rattacherAucun": "Tous les cas actifs du projet sont déjà dans ce plan.",
  "planFiche.rattacherBilan": "{{n}} cas rattaché(s) au plan.",
  "planFiche.rattacherChargement": "Chargement des cas du projet…",
  "planFiche.rattacherEnCours": "Rattachement…",
  "planFiche.rattacherFermer": "Fermer",
  "planFiche.rattacherLegende": "Cas du projet hors de ce plan ({{n}})",
  "planFiche.rattacherN": "Rattacher {{n}} cas",
  "planFiche.rattacherOuvrir": "Rattacher des cas",
  "planFiche.rattacherTous": "Tout sélectionner",
  "planFiche.rattacherAucunChoisi": "Cochez au moins un cas à rattacher.",
  "points.attenteVersion": "Transmise à l’IA : la vérification s’ouvrira quand la nouvelle version sera produite.",
  "points.dejaIntegree": "Déjà dans cette version",
  "points.refsObligatoires": "Où la retrouve-t-on dans cette version ? (obligatoire, ex. REQ-04, § Contrats)",
  "points.refsRequises": "Dites où la réponse se retrouve déjà dans cette version : sans nouvelle version, c’est la seule preuve de son intégration.",
  "points.verifCouranteAuteur": "Vous avez écrit cette réponse : une autre personne du projet pourra confirmer qu’elle figure déjà dans cette version.",
  "points.verifCouranteDecision": "Pour confirmer qu’elle figure déjà dans une version, ouvrez la décision de cette version.",
  "points.versionCouranteTexte": "Elle partira avec la prochaine version demandée. Si cette version la contient déjà, une autre personne du projet peut le confirmer, sans nouvelle version.",
  "reglages.versMembres": "Membres, invitations, équipes et permission « exécuter une recette » :",
  "reglages.versMembresLien": "Membres du projet",
  "verifier.recetteDemanderPermission": "Seul un propriétaire du projet ou l’administration de l’organisation peut la donner.",
  "verifier.recetteDetenteurs": "Ont cette permission : {{noms}}.",
  "verifier.recetteDonnerPermission": "Donner la permission « exécuter une recette » (Membres du projet)",
  "verifier.recettePersonne": "Personne n’a encore cette permission dans ce projet.",
  "membres.colRecette": "exécuter une recette",
  "membres.gestionChargement": "Lecture de la gestion des membres…",
  "membres.gestionErreur": "La gestion des membres n’a pas pu être lue.",
  "membres.gestionTitre": "Gérer les membres, les invitations et les permissions des membres",
  "membres.recetteNon": "non",
  "membres.recetteOui": "oui",
  "membres.recettePersonne": "Personne n’a encore la permission « exécuter une recette » : seul un propriétaire du projet ou l’administration de l’organisation peut la donner, ici même.",
  "decisions.versionRemplaceeAbandon": "Elle attend encore une décision : vous pouvez seulement l’abandonner.",
  "decisions.versionRemplaceeEnCours": "Version remplacée — la nouvelle version est en cours de production",
  "decisions.versionRemplaceeTexte": "Cette page est en lecture seule : on ne décide, ne régénère ni n’édite plus une version remplacée.",
  "decisions.versionRemplaceeTitre": "Version remplacée — voir la version {{n}}",
  "decisions.voirVersionCourante": "Ouvrir la version {{n}} (courante)",
  "baseline.sansObjet": "Sans objet pour la pile retenue ({{pile}})",
  "baseline.sansObjetCourt": "sans objet",
  "decisions.capaciteReponsesAbsente": "Aucun worker actif ne sait transmettre vos réponses à l’IA : la nouvelle version n’en contiendrait aucune. Faites mettre à jour et redémarrer le worker, ou décochez les réponses pour relancer avec la seule consigne.",
  "decisions.section.pointsCompte": "Points à trancher ({{n}} à traiter / {{total}})",
  "decisions.section.pointsCompteAria": "Points à trancher : {{n}} à traiter sur {{total}} point(s) de la demande",
  "job.artifactWritten.analysis": "Analyse du dépôt écrite",
  "job.artifactWritten.app": "Compte rendu de l’application écrit",
  "job.artifactWritten.backlog": "Backlog écrit",
  "job.artifactWritten.change": "Changement écrit",
  "job.artifactWritten.framing": "Cadrage écrit",
  "job.artifactWritten.options": "Options écrites",
  "job.artifactWritten.other": "Artefact écrit",
  "job.artifactWritten.personas": "Personas écrits",
  "job.artifactWritten.processes": "Processus écrits",
  "job.artifactWritten.review": "Revue de code écrite",
  "job.artifactWritten.tests": "Conception des tests écrite",
  "points.editionManuelleTexte": "Une édition manuelle (version {{n}}) a suivi cette réponse : c’est la version suivante, la réponse ne sera pas transmise à l’IA. Une autre personne du projet confirme qu’elle s’y retrouve, en citant où.",
  "points.etat.repondueEditee": "Répondue — à vérifier dans la v{{n}} (édition manuelle)",
  "points.retrouveeDansVersion": "Retrouvée dans la version {{n}}",
  "revision.origin.mission": "mission « {{title}} »",
  "revision.origin.missionUntitled": "mission",
  "revision.origin.fixes": "corrige {{refs}}",
  "revision.origin.generation": "génération",
  "apercu.identity.base": "base {{base}}",
  "versions.replacesBase": "Cette révision corrige la révision {{base}} déjà retenue : retirez-la, une version ne déploie qu’une seule révision.",
  "cas.attendu": "Résultat attendu",
  "cas.criteres": "Critères couverts",
  "cas.criteresAide": "Séparés par des virgules, par exemple : C-04, C-12.",
  "cas.identiteAide": "Nom, résultat attendu et critères couverts : le nom qui cite une exigence (REQ-nn) la prouve dans le guide utilisateur.",
  "cas.identiteEnregistree": "Cas mis à jour",
  "cas.identiteModifier": "Modifier le nom, l’attendu et les critères",
  "cas.identiteTitre": "Identité du cas",
  "cas.nom": "Nom du cas",
  "cas.nomObligatoire": "Le nom du cas est obligatoire.",
  "cas.statut.active": "actif",
  "cas.statut.deprecated": "obsolète",
  "cas.statut.draft": "brouillon",
  "cas.type.e2e": "bout en bout",
  "cas.type.functional": "fonctionnel",
  "cas.type.integration": "intégration",
  "cas.type.manual": "manuel",
  "cas.type.unit": "unitaire",
  "job.generatedTestsFailedN": "{{n}} en échec",
  "job.generatedTestsNotCovered": "non exécutés pour cette pile (non couverts)",
  "job.generatedTestsPassedN": "{{n}} réussis",
  "versions.key.requirements_proven": "Exigences de la spécification prouvées",
  "versions.key.pipeline": "Pipeline de la révision",
  "livrer.objet.publication": "révision {{quoi}} · {{etat}}",
  "livrer.publication.nonPubliee": "non publiée",
  "livrer.publication.echouee": "publication échouée",
  "livrer.publication.demandee": "publication demandée",
  "livrer.publication.enCours": "publication en cours",
  "livrer.publication.sansPipeline": "aucun pipeline",
  "livrer.publication.nonRelu": "non relu auprès de GitLab",
  "livrer.objet.exigenceDeclaree": "{{quoi}} (déclarée)",
  "livrer.objet.exigenceProuvee": "{{quoi}} (prouvée)",
  "livrer.objet.exigenceEnEchec_one": "{{quoi}} (déclarée, {{n}} cas en échec)",
  "livrer.objet.exigenceEnEchec_other": "{{quoi}} (déclarée, {{n}} cas en échec)",
  "versions.code.REQUIREMENTS_NO_REVISION": "Aucune révision : aucune exigence de la spécification à prouver",
  "versions.code.REQUIREMENTS_NOT_PROVEN": "Des exigences de la spécification ne sont pas prouvées par un cas réussi",
  "versions.code.REQUIREMENTS_SOURCE_MISSING": "Spécification source introuvable pour une révision : ses exigences ne sont pas vérifiées",
  "versions.code.REQUIREMENTS_NOT_FOUND": "Aucune exigence REQ-xx lisible dans la spécification source : rien n’est prouvé",
  "versions.code.REQUIREMENTS_PROVEN": "Exigences de la spécification prouvées",
  "versions.code.PIPELINE_NO_REVISION": "Aucune révision : aucun pipeline attendu",
  "versions.code.PIPELINE_RED": "Un pipeline est rouge : bloquant sauf dérogation signée (14 jours au plus à compter de la signature) sur une exigence du projet au contrôle ci_pipeline_green",
  "versions.code.PIPELINE_MISSING": "Une révision n’a pas de pipeline (non publiée, publication échouée ou pipeline absent) : bloquant sauf dérogation signée (14 jours au plus à compter de la signature) sur une exigence du projet au contrôle ci_pipeline_green",
  "versions.code.PIPELINE_RUNNING": "Une publication ou un pipeline est en cours : son résultat est attendu",
  "versions.code.PIPELINE_WAIVED": "Pipeline rouge ou absent, sous une dérogation signée en vigueur",
  "versions.code.PIPELINE_GREEN": "Pipeline vert",
  "livrer.objet.derogationEcartee": "{{code}} · écartée : {{jours}} jours de validité, {{max}} au plus",
  "livrer.objet.derogationEcheance": "{{code}} · échéance {{date}}",
  "membres.demandesRefusAdministration": "Seul un propriétaire du projet ou l’administration de l’organisation décide des demandes d’accès.",
  "decisions.rail.nonVerifiesTitre": "Points bloquants non vérifiés",
  "decisions.rail.nonVerifiesTexte": "{{codes}} : les réponses à ces points n’ont pas encore été vérifiées dans une version du document. Ces points ne bloquent pas l’approbation : si vous approuvez, la décision sera enregistrée avec cet avertissement.",
  "decisions.rail.nonVerifiesTexte_one": "{{codes}} : la réponse à ce point n’a pas encore été vérifiée dans une version du document. Ce point ne bloque pas l’approbation : si vous approuvez, la décision sera enregistrée avec cet avertissement.",
  "decisions.rail.nonVerifiesTexte_other": "{{codes}} : les réponses à ces points n’ont pas encore été vérifiées dans une version du document. Ces points ne bloquent pas l’approbation : si vous approuvez, la décision sera enregistrée avec cet avertissement.",
  "decisions.rail.nonVerifiesLien": "Vérifier ces points",
  "membres.demandesVideIndiceAdministration": "Une personne de l’organisation qui ouvre ce projet sans en être membre peut demander l’accès ; sa demande apparaît ici et sur l’accueil d’administration.",
  "accueil.dev.type.generateFeatures": "Génération des features",
  "accueil.dev.type.generateStories": "Génération des user stories",
  "accueil.dev.type.generateTasks": "Génération des tâches",
  "accueil.dev.type.generateChildren": "Génération des éléments enfants",
  "accueil.dev.type.runWorkflow": "Déroulé d’un workflow",
  "accueil.dev.type.analyzeRepository": "Analyse du dépôt",
  "accueil.dev.type.implementChange": "Implémentation d’un changement",
  "accueil.dev.type.designTests": "Conception des tests",
  "accueil.dev.type.codeReview": "Revue de code",
  "accueil.dev.type.compareModels": "Comparaison de modèles",
  "accueil.dev.type.runPipeline": "Exécution du pipeline",
  "accueil.dev.type.runTestCampaign": "Exécution d’une campagne de tests",
  "accueil.dev.type.deployDocker": "Déploiement",
  "accueil.dev.type.rollbackDocker": "Retour à la version précédente",
  "accueil.dev.type.runMcp": "Exécution d’un serveur MCP",
  "accueil.dev.type.publishAppRevision": "Publication de la révision dans GitLab",
  "accueil.dev.type.planSprints": "Planification des sprints",
  "accueil.dev.type.planMission": "Planification de mission",
  "accueil.dev.type.runMission": "Étape de mission",
  "accueil.dev.type.buildSignRevision": "Construction et signature de la révision",
  "accueil.dev.type.startPreview": "Démarrage de l’aperçu",
  "accueil.dev.type.stopPreview": "Arrêt de l’aperçu",
  "accueil.dev.type.restartPreview": "Redémarrage de l’aperçu",
  "accueil.dev.echec.workerPerdu": "Le worker chargé de ce traitement ne répond plus : relancez-le depuis l’historique.",
  "accueil.dev.echec.sansCause": "Échec sans cause transmise par le worker.",
  "accueil.dev.echec.sujetVide": "Le sujet de la mission ne contient aucun élément à exécuter : tous sont terminés, ou ce ne sont que des conteneurs.",
  "accueil.dev.echec.provenance": "Refusé ({{gate}}) : la spécification d’origine n’a pas (ou plus) de preuve courante vérifiée par une personne ; renouvelez-la, puis relancez le traitement.",
  "accueil.dev.echec.registreRefuse": "Le registre des révisions a refusé d’enregistrer cette révision.",
  "accueil.dev.echec.testsLivres": "Application refusée : des tests livrés avec elle échouent.",
  "accueil.dev.echec.voirDetail": "Le traitement a échoué : la cause est dans le détail technique.",
  "accueil.dev.echec.code": "Échec (code {{code}})",
  "accueil.dev.echec.traitement": "Traitement",
  "activation.lienIncomplet": "Ce lien d’activation est incomplet : il ne contient pas de jeton. Ouvrez le lien complet reçu par courriel, ou demandez-en un nouveau à l’administration qui vous l’a envoyé.",
  "nonMembre.introuvableDescription": "Aucun projet de votre organisation ne porte l’identifiant {{id}} : le lien est erroné ou périmé, ou il désigne un projet d’une autre organisation.",
  "nonMembre.introuvableTitre": "Ce projet est introuvable dans votre organisation",
  "nonMembre.descriptionNeutre": "Vous n’avez aucun rôle dans le projet {{id}} : son contenu ne vous est pas montré. S’il fait partie de votre organisation, vous pouvez en demander l’accès à ses propriétaires.",
  "nonMembre.adminArchive": "Ce projet est archivé : il n’est pas proposé au rattachement.",
  "shell.basculerPanneau": "Replier ou déplier le panneau",
  "shell.panneauDescription": "Panneau de navigation ouvert depuis le rail. Échap le ferme.",
  "shell.tiroirDescription": "Tiroir plein écran de navigation. Échap le ferme et rend le focus au bouton Menu.",
  "tree.collapse": "Replier",
  "tree.expand": "Déplier",
  "app.versionDeployee": "Version déployée {{version}}",
  "app.versionDeployeeLe": "Version déployée {{version}} — déployée le {{date}}",
  "lifecycleRail.aria": "Étapes du cycle de vie",
  "pipelines.stageNameAria": "Nom de l'étape {{numero}}",
  "pipelines.stageCommandAria": "Commande de l'étape {{numero}}",
  "user.navModeAfficherTout": "Afficher toutes les entrées",
  "user.navModeEssentiel": "Revenir à l’essentiel",
  "user.navModeMasquees": "{{n}} entrées masquées",
  "user.navModeConflitEssentiel": "Un autre appareil a choisi « essentiel » entre-temps.",
  "user.navModeConflitToutAfficher": "Un autre appareil a choisi « tout afficher » entre-temps.",
  "user.navModeConflitUtiliser": "Utiliser cette valeur",
  "ecriture.refus.administrateurPlateforme": "Administrateur de plateforme : ce compte administre la plateforme mais n’écrit pas dans les projets (créer un projet, valider, approuver). Connectez-vous avec un compte propriétaire ou contributeur.",
  "ecriture.refus.lectureSeule": "Lecture seule : votre rôle ne permet pas cette action. Un propriétaire ou un contributeur peut la faire.",
  "savedFilters.selectAria": "Filtre sauvegardé",
  "feedback.pageTitle": "Retours",
  "feedback.noteSur5": "Note {{note}} sur 5",
  "history.pageDescriptionDetail": "Tout le travail passé de l'espace — chaque job, son statut et le détail rejouable de son traitement. Rien de ce qui a été produit n'est perdu de vue.",
  "history.detailTraitement": "Détail du traitement",
  "history.detailTraitementDuJob": "Détail du traitement du job {{job}}",
  "chat.sansProjet": "Aucun projet sélectionné",
  "chat.sansProjetAide": "L’assistant répond dans le contexte d’un projet.",
  "compare.sansProjet": "Aucun projet sélectionné",
  "compare.sansProjetAide": "Une comparaison se lance sur les modèles autorisés d’un projet, et s’y conserve.",
  "ingestion.deleteConsequence": "Le document et ses extraits indexés sont retirés de la base documentaire : les prochaines réponses ne pourront plus le citer.",
  "ingestion.deleteReversibilite": "Pour le retrouver, il faudra le téléverser de nouveau.",
  "ingestion.deleteVerb": "Supprimer le document",
  "ingestion.sansProjet": "Aucun projet sélectionné",
  "ingestion.sansProjetAide": "Les documents ingérés et la base documentaire appartiennent à un projet.",
  "notif.sansProjet": "Aucun projet sélectionné",
  "notif.sansProjetAide": "Les notifications appartiennent à un projet.",
  "processView.chargement": "Chargement du processus…",
  "processView.etapesCycle": "Étapes du cycle",
  "workflow.sansProjetAide": "Un agent personnalisé s’exécute sur un projet : ses agents autorisés, ses finalités et ses modèles.",
  "decisions.adresseInvalide": "Adresse invalide : numéro de décision attendu.",
  "echanges.adresseInvalide": "Adresse invalide : numéro de demande attendu.",
  "echanges.retourDemandes": "Retour aux demandes",
  "cycle.entite.organisations": "Organisation",
  "cycle.entite.programs": "Programmes",
  "cycle.entite.program_members": "Membres de programme",
  "cycle.entite.program_risks": "Risques de programme",
  "cycle.entite.users": "Utilisateurs",
  "cycle.entite.workspaces": "Projets",
  "cycle.entite.workspace_members": "Membres de projet",
  "cycle.entite.workspace_teams": "Équipes de projet",
  "cycle.entite.workspace_team_members": "Membres d’équipe",
  "cycle.entite.workspace_invitations": "Invitations au projet",
  "cycle.entite.workspace_access_requests": "Demandes d’accès au projet",
  "cycle.entite.workspace_dependencies": "Dépendances entre projets",
  "cycle.entite.workspace_allowed_agents": "Agents autorisés du projet",
  "cycle.entite.workspace_allowed_models": "Modèles autorisés du projet",
  "cycle.entite.organisation_invitations": "Invitations à l’organisation",
  "cycle.entite.role_delegations": "Délégations de rôle",
  "cycle.entite.backlog_items": "Éléments du backlog",
  "cycle.entite.backlog_item_merges": "Fusions d’éléments",
  "cycle.entite.item_comments": "Commentaires d’éléments",
  "cycle.entite.item_labels": "Étiquettes posées sur les éléments",
  "cycle.entite.item_links": "Liens entre éléments",
  "cycle.entite.item_attachments": "Pièces jointes d’éléments",
  "cycle.entite.item_status_history": "Historique des statuts d’éléments",
  "cycle.entite.labels": "Étiquettes",
  "cycle.entite.components": "Composants",
  "cycle.entite.saved_filters": "Filtres enregistrés",
  "cycle.entite.sprints": "Sprints",
  "cycle.entite.sprint_reviews": "Revues de sprint",
  "cycle.entite.sprint_carryovers": "Reports de sprint",
  "cycle.entite.sprint_daily_snapshots": "Instantanés quotidiens de sprint",
  "cycle.entite.demands": "Demandes",
  "cycle.entite.demand_points": "Points des demandes",
  "cycle.entite.approvals": "Approbations",
  "cycle.entite.approval_artifacts": "Artefacts annexes des approbations",
  "cycle.entite.artifact_versions": "Versions d’artefacts",
  "cycle.entite.artifact_receipts": "Reçus d’artefacts",
  "cycle.entite.waivers": "Dérogations",
  "cycle.entite.adrs": "Décisions d’architecture",
  "cycle.entite.missions": "Missions",
  "cycle.entite.mission_tasks": "Tâches de mission",
  "cycle.entite.mission_events": "Événements de mission",
  "cycle.entite.notifications": "Notifications",
  "cycle.entite.feedback": "Retours sur les générations",
  "cycle.entite.documents": "Documents ingérés",
  "cycle.entite.agents": "Agents",
  "cycle.entite.test_cases": "Cas de test",
  "cycle.entite.test_plans": "Plans de test",
  "cycle.entite.test_campaigns": "Campagnes de test",
  "cycle.entite.test_executions": "Exécutions de test",
  "cycle.entite.test_results": "Résultats de test",
  "cycle.entite.test_evidence": "Preuves de test",
  "cycle.entite.releases": "Versions",
  "cycle.entite.release_contents": "Contenu des versions",
  "cycle.entite.release_deployment_plans": "Mises en production planifiées",
  "cycle.entite.deployment_freeze_windows": "Périodes de gel",
  "cycle.entite.deployments": "Déploiements",
  "cycle.entite.environments": "Environnements",
  "cycle.entite.pipelines": "Pipelines",
  "cycle.entite.pipeline_runs": "Exécutions de pipeline",
  "cycle.entite.production_incidents": "Incidents de production",
  "cycle.entite.defects": "Anomalies",
  "cycle.entite.audit_log": "Journal d’audit",
  "cycle.entite.audit_pseudonyms": "Pseudonymes du journal d’audit",
  "cycle.entite.data_lifecycle_operations": "Reçus des opérations de cycle de vie",
  "cycle.entite.lifecycle_deletion_requests": "Demandes de suppression",
  "cycle.entite.organisation_status_history": "Historique des statuts d’organisation",
  "cycle.entite.platform_exceptional_access": "Accès exceptionnels de la plateforme",
  "cycle.entite.user_lifecycle_audit": "Audit du cycle de vie des comptes",
  "cycle.entite.unknown_quarantine_evidence": "Preuves de la quarantaine des inconnus",
  "cycle.entite.unknown_quarantine_audit_sink": "Audit de la quarantaine des inconnus",
  "cycle.entite.object_purge_queue": "File d’effacement des objets",
  "cycle.entite.flyway_schema_history": "Historique des migrations",
  "cycle.adresseInvalide": "Adresse invalide : numéro de demande de suppression attendu.",
  "design.comparison.introuvable": "Comparaison introuvable",
  "design.comparison.introuvableAide": "Cette comparaison n’existe pas dans ce projet, ou le projet ne vous est pas ouvert.",
  "design.usability.introuvable": "Test d’usage introuvable",
  "design.usability.introuvableAide": "Ce test d’usage n’existe pas dans ce projet, ou le projet ne vous est pas ouvert.",
  "calendrier.sansProjet": "Le calendrier des mises en production appartient à un projet.",
  "calendrier.planAdresseInvalide": "Adresse invalide : numéro de mise en production attendu.",
  "calendrier.gelAdresseInvalide": "Adresse invalide : numéro de période de gel attendu.",
  "fonA.deleg.moiSeul": "moi",
  "fonA.deleg.adresseInvalide": "Adresse invalide : numéro de délégation attendu.",
  "fonA.fiche.adresseInvalide": "Adresse invalide : numéro de finalité attendu.",
  "fonA.exigence.adresseInvalide": "Adresse invalide : numéro d’exigence attendu.",
  "cycle.entite.access_policies": "Politiques d’accès",
  "cycle.entite.access_decision_observations": "Refus d’habilitation observés",
  "cycle.entite.role_permissions": "Permissions des rôles",
  "cycle.entite.decision_raci": "Désignations RACI des décisions",
  "cycle.entite.workspace_permission_grants": "Permissions accordées nominativement",
  "cycle.entite.organisation_auth_policies": "Politique d’authentification",
  "cycle.entite.organisation_session_starts": "Débuts de session observés",
  "cycle.entite.organisation_enrolments": "Liens d’activation de l’administrateur",
  "cycle.entite.user_offboardings": "Départs d’utilisateurs",
  "cycle.entite.workspace_creation_requests": "Demandes de création de projet",
  "cycle.entite.user_navigation_preferences": "Modes de navigation des utilisateurs",
  "cycle.entite.navigation_preferences": "Modes de navigation par projet",
  "cycle.entite.navigation_preference_commands": "Changements de mode de navigation",
  "cycle.entite.profile_preferences": "Vues d’accueil par profil",
  "cycle.entite.notification_preferences": "Préférences de notification",
  "cycle.entite.notification_digests": "Résumés de notifications",
  "cycle.entite.notification_channels": "Canaux de notification",
  "cycle.entite.notification_delivery_outbox": "File d’envoi des notifications externes",
  "cycle.entite.ai_kill_switches": "Arrêts d’urgence de l’IA",
  "cycle.entite.ai_kill_switch_history": "Historique des arrêts d’urgence de l’IA",
  "cycle.entite.ai_model_grants": "Modèles autorisés de l’organisation",
  "cycle.entite.ai_processing_purposes": "Finalités de traitement IA",
  "cycle.entite.ai_subject_consents": "Consentements aux finalités IA",
  "cycle.entite.ai_provider_connections": "Connexions aux fournisseurs d’IA",
  "cycle.entite.ai_provider_connection_grants": "Activations des connexions fournisseurs",
  "cycle.entite.ai_tool_execution_requests": "Demandes d’exécution d’outil",
  "cycle.entite.ai_tool_execution_receipts": "Reçus d’exécution d’outil",
  "cycle.entite.mcp_server_packages": "Paquets de serveurs MCP",
  "cycle.entite.mcp_server_agent_bindings": "Liaisons entre serveurs MCP et agents",
  "cycle.entite.models": "Modèles d’IA enregistrés",
  "cycle.entite.model_comparisons": "Comparaisons de modèles",
  "cycle.entite.agent_execution_status": "États d’exécution des agents",
  "cycle.entite.feedback_evaluations": "Évaluations des retours sur les générations",
  "cycle.entite.api_requests": "Requêtes d’API journalisées",
  "cycle.entite.quotas": "Quotas",
  "cycle.entite.quota_reservations": "Réservations de quota",
  "cycle.entite.usage_ledger": "Relevés d’usage journaliers",
  "cycle.entite.organisation_plans": "Palier de l’organisation",
  "cycle.entite.organisation_plan_history": "Historique des paliers",
  "cycle.entite.tenant_retention_policy": "Politique de rétention",
  "cycle.entite.vector_store_retention": "Rétention des vecteurs documentaires",
  "cycle.entite.file_artifact_retention": "Rétention des artefacts fichiers",
  "cycle.entite.export_requests": "Demandes d’export gouverné",
  "cycle.entite.config_templates": "Gabarits de configuration",
  "cycle.entite.config_template_versions": "Versions publiées des gabarits",
  "cycle.entite.template_migrations": "Migrations vers un gabarit plus récent",
  "cycle.entite.process_runs": "Exécutions de processus",
  "cycle.entite.process_action_runs": "Actions de processus exécutées",
  "cycle.entite.project_governance": "Mode d’héritage du projet",
  "cycle.entite.project_launch_drafts": "Brouillon de lancement du projet",
  "cycle.entite.workspace_wip_limits": "Limites de travail en cours",
  "cycle.entite.taxonomy_axes": "Axes de rattachement",
  "cycle.entite.item_axes": "Rattachements d’éléments aux axes",
  "cycle.entite.versions": "Versions de classement",
  "cycle.entite.org_requirements": "Exigences de l’organisation",
  "cycle.entite.scope_requirements": "Exigences des programmes et projets",
  "cycle.entite.org_governance_settings": "Réglages de gouvernance de l’organisation",
  "cycle.entite.org_rule_observations": "Mesures des règles d’organisation",
  "cycle.entite.org_rule_stage_decisions": "Changements de temps des règles",
  "cycle.entite.org_golden_path_versions": "Versions du chemin doré",
  "cycle.entite.program_initiative_objectives": "Objectifs des initiatives de programme",
  "cycle.entite.spec_change_requests": "Demandes de modification de spécification",
  "cycle.entite.spec_gate_receipts": "Reçus Spec Gate",
  "cycle.entite.spec_gate_receipt_renewals": "Renouvellements de reçus Spec Gate",
  "cycle.entite.approval_publication_effects": "Effets de publication des approbations",
  "cycle.entite.demand_links": "Rattachements des demandes",
  "cycle.entite.demand_point_events": "Événements des points de demande",
  "cycle.entite.demand_point_extractions": "Extractions de points depuis les approbations",
  "cycle.entite.technology_categories": "Catégories technologiques",
  "cycle.entite.technology_baseline_versions": "Versions de la baseline technologique",
  "cycle.entite.technology_baseline_entries": "Valeurs de la baseline technologique",
  "cycle.entite.technology_change_requests": "Demandes de changement technologique",
  "cycle.entite.technology_change_decisions": "Décisions sur les changements technologiques",
  "cycle.entite.technology_change_rework_items": "Éléments de reprise des changements technologiques",
  "cycle.entite.project_stack_profiles": "Profil de pile du projet",
  "cycle.entite.adr_criteria": "Critères des décisions d’architecture",
  "cycle.entite.adr_options": "Options des décisions d’architecture",
  "cycle.entite.adr_scores": "Notes des options d’architecture",
  "cycle.entite.design_charters": "Chartes de design des projets",
  "cycle.entite.design_charter_overrides": "Surcharges de la charte d’organisation",
  "cycle.entite.org_design_charters": "Chartes de design de l’organisation",
  "cycle.entite.design_screen_flows": "Parcours d’écrans",
  "cycle.entite.design_wireframes": "Maquettes",
  "cycle.entite.design_comparisons": "Comparaisons maquette ↔ application",
  "cycle.entite.design_usability_checks": "Tests d’usage",
  "cycle.entite.preview_environments": "Environnements d’aperçu",
  "cycle.entite.preview_annotations": "Annotations d’aperçu",
  "cycle.entite.preview_share_links": "Liens de partage d’aperçu",
  "cycle.entite.test_plan_cases": "Cas de test des plans",
  "cycle.entite.test_plan_versions": "Versions de plans de test",
  "cycle.entite.test_plan_version_cases": "Cas de test des versions de plan",
  "cycle.entite.test_execution_assignments": "Assignations de cas de test",
  "cycle.entite.test_execution_steps": "Pas d’exécution de test",
  "cycle.entite.test_runs": "Lancements de tests",
  "cycle.entite.regression_acceptances": "Acceptations de régression",
  "cycle.entite.defect_execution_links": "Exécutions reliées aux anomalies",
  "cycle.entite.defect_lessons": "Leçons tirées des anomalies",
  "cycle.entite.defect_transitions": "Transitions d’anomalies",
  "cycle.entite.app_instances": "Instances d’application",
  "cycle.entite.app_publications": "Publications d’application",
  "cycle.entite.app_repositories": "Dépôts d’application",
  "cycle.entite.release_documents": "Documents de livraison",
  "cycle.entite.release_environment_approvals": "Approbations de version par environnement",
  "cycle.entite.release_note_versions": "Notes de version",
  "cycle.entite.revision_artefacts": "Artefacts signés des révisions",
  "cycle.entite.revision_lineage": "Lignée des révisions",
  "cycle.entite.revision_migrations": "Migrations de schéma des révisions",
  "cycle.entite.revision_vulnerability_scans": "Analyses de vulnérabilités des révisions",
  "cycle.entite.scm_connections": "Connexions au gestionnaire de sources",
  "cycle.entite.scm_delivery_events": "Événements de livraison du gestionnaire de sources",
  "cycle.entite.scm_item_commits": "Preuves de publication des éléments",
  "cycle.entite.odoo_connections": "Connexions Odoo",
  "cycle.entite.public_webhooks": "Webhooks publics",
  "cycle.entite.public_webhook_events": "Événements reçus par les webhooks",
  "cycle.entite.public_webhook_rejection_audit": "Audit des rejets de webhooks",
  "cycle.entite.production_incident_actions": "Actions correctives d’incident",
  "cycle.entite.production_incident_defects": "Anomalies reliées aux incidents",
  "cycle.entite.production_incident_events": "Chronologie des incidents",
  "cycle.entite.production_incident_postmortems": "Post-mortems d’incident",
  "cycle.entite.service_objectives": "Objectifs de service métier",
  "cycle.entite.slo_catalog": "Objectifs de niveau de service",
  "cycle.entite.slo_error_budgets": "Budgets d’erreur",
  "cycle.entite.deployment_slo_incidents": "Violations d’objectif ayant déclenché un retour arrière",
  "cycle.entite.jobs_outbox": "File des travaux",
  "cycle.entite.job_events": "Événements des travaux",
  "cycle.entite.background_active_scopes": "Portées actives des traitements d’arrière-plan",
  "cycle.entite.background_scope_transitions": "Transitions des portées d’arrière-plan",
  "decisions.adresseInvalideTitre": "Décision",
  "echanges.adresseInvalideTitre": "Échanges de la demande",
  "fonA.exigence.adresseInvalideTitre": "Exigence",
  "fonA.fiche.adresseInvalideTitre": "Finalité",
  "fonA.deleg.adresseInvalideTitre": "Délégation",
  "cycle.adresseInvalideTitre": "Demande de suppression",
  "cycle.entite.ai_promotion_decisions": "Décisions de promotion de modèles et de prompts",
  "cycle.entite.profils_organisation": "Profils de l’organisation",
  "cycle.entite.profils_organisation_versions": "Versions des profils de l’organisation",
  "cycle.entite.profils_organisation_version_droits": "Droits de chaque version de profil",
  "cycle.entite.profils_organisation_version_contributeurs": "Contributeurs de chaque version de profil",
  "cycle.entite.attributions_profils": "Profils attribués aux personnes",
  "cycle.entite.attributions_plateforme": "Profils de plateforme attribués",
  "cycle.entite.droits_isoles": "Droits accordés isolément",
  "cycle.entite.proprietes": "Propriétaires des organisations, programmes et projets",
  "cycle.entite.repair_experiences": "Banque de réparations de la colonie",
  "cycle.entite.trace_links": "Liens de traçabilité entre objets",
  "cycle.entite.trace_link_retirements": "Retraits de liens de traçabilité",
  "cycle.entite.appartenances_retirees": "Appartenances retirées au départ",
  "cycle.entite.demandes_invitation": "Demandes d’invitation",
  "cycle.entite.designations_projet": "Désignations du projet",
  "cycle.entite.exports_organisation": "Exports de l’organisation",
  "missions.jobStatus.done": "terminé",
  "missions.jobStatus.failed": "en échec",
  "missions.jobStatus.pending": "en attente",
  "missions.jobStatus.processing": "en cours",
  "missions.jobStatus.unknown": "introuvable",
  "valeurs.execution.passed": "réussi",
  "valeurs.execution.failed": "échoué",
  "valeurs.execution.blocked": "bloqué",
  "valeurs.execution.skipped": "ignoré",
  "valeurs.execution.running": "en cours",
  "valeurs.plan.draft": "brouillon",
  "valeurs.plan.active": "actif",
  "valeurs.plan.archived": "archivé",
  "valeurs.versionPlan.draft": "brouillon",
  "valeurs.versionPlan.published": "publiée",
  "valeurs.versionPlan.archived": "archivée",
  "valeurs.campagne.open": "ouverte",
  "valeurs.campagne.closed": "fermée",
  "valeurs.campagne.cancelled": "annulée",
  "valeurs.deploiement.pending": "en attente",
  "valeurs.deploiement.running": "en cours",
  "valeurs.deploiement.succeeded": "réussi",
  "valeurs.deploiement.failed": "échoué",
  "valeurs.deploiement.rolled_back": "restauré",
  "valeurs.deploiement.stopped": "arrêté",
  "valeurs.deploiement.cancelled": "annulé",
  "valeurs.livraison.none": "aucune",
  "valeurs.livraison.in_progress": "en cours",
  "valeurs.livraison.succeeded": "réussie",
  "valeurs.livraison.failed": "échouée",
  "valeurs.livraison.opened": "ouverte",
  "valeurs.livraison.merged": "fusionnée",
  "valeurs.livraison.closed": "fermée",
  "valeurs.livraison.unknown": "inconnue",
  "valeurs.sante.healthy": "sain",
  "valeurs.sante.unhealthy": "en échec",
  "valeurs.sante.degraded": "dégradé",
  "valeurs.sante.not_configured": "non configuré",
  "valeurs.sante.unknown": "inconnu",
  "valeurs.sonde.healthy": "saine",
  "valeurs.sonde.unhealthy": "en échec",
  "valeurs.sonde.degraded": "dégradée",
  "valeurs.sonde.not_configured": "non configurée",
  "valeurs.sonde.unknown": "inconnue",
  "valeurs.signature.signed": "signée",
  "valeurs.signature.verified": "vérifiée",
  "valeurs.signature.unsigned": "non signée",
  "valeurs.signature.unavailable": "indisponible",
  "valeurs.niveau.low": "faible",
  "valeurs.niveau.medium": "moyen",
  "valeurs.niveau.high": "élevé",
  "valeurs.niveau.critical": "critique",
  "valeurs.priorite.low": "basse",
  "valeurs.priorite.medium": "moyenne",
  "valeurs.priorite.high": "haute",
  "valeurs.priorite.critical": "critique",
  "valeurs.cible.docker": "Docker",
  "valeurs.politiqueImage.digest-pinned": "épinglée par empreinte",
  "valeurs.politiqueImage.tag-allowed": "étiquette admise",
  "valeurs.dureeVie.persistent": "persistant",
  "valeurs.dureeVie.ephemeral": "éphémère",
  "valeurs.item.todo": "à faire",
  "valeurs.item.in_progress": "en cours",
  "valeurs.item.in_review": "en revue",
  "valeurs.item.done": "terminé",
  "valeurs.oui": "Oui",
  "valeurs.non": "Non",
  "lecture.prioriteStory": "priorité {{p}}",
  "admin.polConditionVide": "aucune condition : la règle s’applique toujours",
  "admin.polConditionEt": "et",
  "admin.operationsHealthEtat.healthy": "sain",
  "admin.operationsHealthEtat.degraded": "dégradé",
  "admin.operationsHealthEtat.unavailable": "indisponible",
  "journalAudit.actionRefusee": "Refus consigné",
  "journalAudit.parPlateforme": "{{action}} (par la plateforme)",
  "journalAudit.detail": "Détail",
  "journalAudit.paire": "{{cle}} : {{valeur}}",
  "journalAudit.vrai": "vrai",
  "journalAudit.faux": "faux",
  "journalAudit.action.org.user.deactivated": "Utilisateur désactivé",
  "journalAudit.action.org.user.reactivated": "Utilisateur réactivé",
  "journalAudit.action.org.user.role_changed": "Rôle d’organisation modifié",
  "journalAudit.action.org.user.access_reset": "Accès réinitialisé",
  "journalAudit.action.org.user.access_reset_completed": "Réinitialisation d’accès terminée",
  "journalAudit.action.org.user.sessions_closed": "Sessions fermées",
  "journalAudit.action.org.user.read": "Fiche utilisateur consultée",
  "journalAudit.action.org.users.read": "Annuaire consulté",
  "journalAudit.action.org.invitation.created": "Invitation envoyée",
  "journalAudit.action.org.invitation.accepted": "Invitation acceptée",
  "journalAudit.action.org.invitation.revoked": "Invitation révoquée",
  "journalAudit.action.org.invitation.renewed": "Invitation renouvelée",
  "journalAudit.action.org.invitations.read": "Invitations consultées",
  "journalAudit.action.org.auth_policy.changed": "Politique de connexion modifiée",
  "journalAudit.action.org.auth_policy.mfa_applied": "Second facteur imposé",
  "journalAudit.action.org.auth_policy.read": "Politique de connexion consultée",
  "journalAudit.action.org.profile.created": "Profil de l’organisation créé",
  "journalAudit.action.org.profile.duplicated": "Profil de l’organisation dupliqué",
  "journalAudit.action.org.profile.draft_saved": "Brouillon de profil enregistré",
  "journalAudit.action.org.profile.draft_deleted": "Brouillon de profil supprimé",
  "journalAudit.action.org.profile.submitted": "Profil soumis à validation",
  "journalAudit.action.org.profile.withdrawn": "Profil retiré de la validation",
  "journalAudit.action.org.profile.refused": "Profil refusé",
  "journalAudit.action.org.profile.validated": "Profil validé",
  "journalAudit.action.org.profile.published": "Profil publié",
  "journalAudit.action.org.profile.retired": "Profil de l’organisation retiré",
  "journalAudit.action.organisation.provisioned": "Organisation créée",
  "journalAudit.action.organisation.provisioning_denied": "Création d’organisation refusée",
  "journalAudit.action.organisation.profile_updated": "Identité de l’organisation modifiée",
  "journalAudit.action.organisation.enrolment_link_issued": "Lien d’activation émis",
  "journalAudit.action.organisation.enrolment_link_revoked": "Lien d’activation révoqué",
  "journalAudit.action.organisation.admin_enrolled": "Administrateur de l’organisation activé",
  "journalAudit.action.organisation.write_refused_suspended": "Écriture refusée : organisation suspendue",
  "journalAudit.action.organisation.write_refused_deleted": "Écriture refusée : organisation en suppression",
  "journalAudit.action.platform.organisation_plan_changed": "Palier de l’organisation changé",
  "journalAudit.action.platform.organisation_suspended": "Organisation suspendue",
  "journalAudit.action.platform.organisation_reactivated": "Organisation réactivée",
  "journalAudit.action.platform.organisation_deletion_requested": "Suppression de l’organisation demandée",
  "journalAudit.action.platform.organisation_deletion_cancelled": "Suppression de l’organisation annulée",
  "journalAudit.action.platform.organisation_export_ready": "Export de l’organisation prêt",
  "journalAudit.action.platform.organisation_export_expired": "Export de l’organisation expiré",
  "journalAudit.action.platform.organisation_purged": "Organisation purgée",
  "journalAudit.action.platform.exceptional_access_opened": "Accès exceptionnel ouvert",
  "journalAudit.action.platform.exceptional_access_read": "Lecture sous accès exceptionnel",
  "journalAudit.action.platform.exceptional_access_revoked": "Accès exceptionnel révoqué",
  "journalAudit.action.platform.continuity_backup_requested": "Sauvegarde demandée",
  "journalAudit.action.platform.continuity_restore_requested": "Restauration demandée",
  "journalAudit.action.platform.journal_exported": "Journal de la plateforme exporté",
  "journalAudit.action.platform.lifecycle_export_downloaded": "Archive de suppression téléchargée",
  "journalAudit.action.workspace.member_added": "Membre ajouté au projet",
  "journalAudit.action.workspace.member_joined": "Membre entré dans le projet",
  "journalAudit.action.workspace.member_removed": "Membre retiré du projet",
  "journalAudit.action.workspace.member_role_changed": "Rôle dans le projet modifié",
  "journalAudit.action.workspace.permission_granted": "Permission accordée dans le projet",
  "journalAudit.action.workspace.permission_revoked": "Permission retirée dans le projet",
  "journalAudit.action.droit_isole.accorde": "Droit accordé isolément",
  "journalAudit.action.droit_isole.revoque": "Droit accordé isolément révoqué",
  "journalAudit.action.workspace.ownership_transferred": "Propriété du projet transférée",
  "journalAudit.action.workspace.access_requested": "Accès au projet demandé",
  "journalAudit.action.workspace.access_request_approved": "Demande d’accès acceptée",
  "journalAudit.action.workspace.access_request_rejected": "Demande d’accès refusée",
  "journalAudit.action.workspace.access_request_cancelled": "Demande d’accès annulée",
  "journalAudit.action.workspace.access_denied": "Accès à un projet refusé",
  "journalAudit.action.workspace.renamed": "Projet renommé",
  "journalAudit.action.workspace.archived": "Projet archivé",
  "journalAudit.action.workspace.unarchived": "Projet désarchivé",
  "journalAudit.action.workspace.deletion_requested": "Suppression du projet demandée",
  "journalAudit.action.workspace.deletion_cancelled": "Suppression du projet annulée",
  "journalAudit.action.workspace.purged": "Projet purgé",
  "journalAudit.action.workspace.export": "Projet exporté",
  "journalAudit.action.program.member_added": "Membre ajouté au programme",
  "journalAudit.action.program.workspace_attached": "Projet rattaché au programme",
  "journalAudit.action.audit.export": "Audit exporté",
  "journalAudit.action.audit.journal_exported": "Journal d’audit exporté",
  "journalAudit.action.lifecycle.request_read_denied": "Lecture d’une demande de suppression refusée",
  "journalAudit.action.lifecycle.requests_list_denied": "Liste des demandes de suppression refusée",
  "journalAudit.action.lifecycle.export_ready": "Archive de suppression prête",
  "journalAudit.action.lifecycle.export_expired": "Archive de suppression expirée",
  "journalAudit.action.ai.purpose.read_denied": "Lecture des finalités IA refusée",
  "journalAudit.action.ai_model_not_granted": "Modèle d’IA non autorisé",
  "journalAudit.action.mission.launched": "Mission lancée",
  "journalAudit.action.mission.decision": "Décision de mission",
  "journalAudit.action.mission.plan_approved": "Plan de mission approuvé",
  "journalAudit.action.mission.dossier_approved": "Dossier de mission approuvé",
  "journalAudit.action.mission.dossier_rejected": "Dossier de mission rejeté",
  "journalAudit.action.mission.stopped": "Mission arrêtée",
  "journalAudit.action.mission.stopped_budget": "Mission arrêtée : budget atteint",
  "journalAudit.action.mission.stops_acknowledged": "Arrêts de mission pris en compte",
  "journalAudit.action.mission.failed": "Mission en échec",
  "journalAudit.action.defect.created": "Anomalie déclarée",
  "journalAudit.action.defect.transition": "Anomalie : changement d’état",
  "journalAudit.action.defect.test_case_linked": "Cas de test rattaché à l’anomalie",
  "journalAudit.action.test_case.test_code_set": "Code de test enregistré",
  "journalAudit.action.test_case.test_code_validated": "Code de test validé",
  "journalAudit.action.recette.execute_denied": "Exécution de recette refusée",
  "journalAudit.action.release.created": "Version créée",
  "journalAudit.action.release.transition": "Version : changement d’état",
  "journalAudit.action.release.content_added": "Contenu ajouté à la version",
  "journalAudit.action.release.content_removed": "Contenu retiré de la version",
  "journalAudit.action.release.notes_generated": "Notes de version générées",
  "journalAudit.action.release.notes_published": "Notes de version publiées",
  "journalAudit.action.release.documents_generated": "Documents de la version générés",
  "journalAudit.action.release.approval_requested": "Approbation de la version demandée",
  "journalAudit.action.release.approval_decided": "Approbation de la version décidée",
  "journalAudit.action.release.revision_signing_requested": "Signature de la révision demandée",
  "journalAudit.action.release.deploy_requested": "Déploiement demandé",
  "journalAudit.action.runops.environment_production_declared": "Environnement déclaré en production",
  "journalAudit.action.preview.start_requested": "Démarrage de l’aperçu demandé",
  "journalAudit.action.preview.stop_requested": "Arrêt de l’aperçu demandé",
  "journalAudit.action.preview.expired": "Aperçu expiré",
  "journalAudit.action.technology_entry.created": "Entrée du catalogue technologique créée",
  "journalAudit.action.technology_baseline.created": "Socle technologique créé",
  "journalAudit.action.technology_category.starter_set_applied": "Jeu de départ des catégories appliqué",
  "journalAudit.action.technology_catalog.starter_set_applied": "Jeu de départ du catalogue appliqué",
  "journalAudit.action.design.wireframe.validated": "Maquette validée",
  "journalAudit.action.design.flow.validated": "Parcours validé",
  "journalAudit.action.design.org_charter.created": "Charte de l’organisation créée",
  "journalAudit.action.design.org_charter.validated": "Charte de l’organisation validée",
  "journalAudit.action.approval.governance_refused": "Approbation refusée par la gouvernance",
  "journalAudit.action.approval.spec_gate_evidence_renewed": "Preuves du Spec Gate renouvelées",
  "journalAudit.action.job_enqueued": "Job mis en file",
  "journalAudit.action.job_claimed": "Job pris en charge",
  "journalAudit.action.job_terminal": "Job terminé",
  "journalAudit.action.job_done": "Job réussi",
  "journalAudit.action.job_failed": "Job en échec",
  "journalAudit.action.mission_step_done": "Étape de mission terminée",
  "journalAudit.action.mission_plan_proposed": "Plan de mission proposé",
  "journalAudit.action.generation_started": "Génération démarrée",
  "journalAudit.action.generation_finished": "Génération terminée",
  "journalAudit.action.generated_tests_executed": "Tests générés exécutés",
  "journalAudit.action.generated_tests_failed": "Tests générés en échec",
  "journalAudit.action.generated_tests_repair_attempted": "Réparation des tests tentée",
  "journalAudit.action.generated_tests_repair_finished": "Réparation des tests terminée",
  "journalAudit.action.approval_requested": "Approbation demandée",
  "journalAudit.action.approval_granted": "Approbation accordée",
  "journalAudit.action.approval_rejected": "Approbation rejetée",
  "journalAudit.action.artifact_written": "Artefact écrit",
  "journalAudit.action.app_tree_written": "Arborescence de l’application écrite",
  "journalAudit.action.committed": "Modifications enregistrées dans le dépôt",
  "journalAudit.action.stack_profile_resolved": "Profil de pile résolu",
  "journalAudit.action.preview_starting": "Aperçu en démarrage",
  "journalAudit.action.preview_running": "Aperçu démarré",
  "journalAudit.action.preview_stopped": "Aperçu arrêté",
  "journalAudit.action.preview_failed": "Aperçu en échec",
  "journalAudit.action.independent_review_submitted": "Revue indépendante rendue",
  "journalAudit.action.spec_gate_started": "Spec Gate démarré",
  "journalAudit.action.spec_gate_done": "Spec Gate terminé",
  "journalAudit.action.deployment_started": "Déploiement démarré",
  "journalAudit.action.deployment_succeeded": "Déploiement réussi",
  "journalAudit.action.deployment_failed": "Déploiement en échec",
  "journalAudit.action.revision_signing_started": "Signature de la révision démarrée",
  "journalAudit.action.revision_signed": "Révision signée",
  "journalAudit.action.revision_signing_failed": "Signature de la révision en échec",
  "journalAudit.action.environment_auto_stop_failed": "Arrêt automatique d’environnement en échec",
  "journalAudit.action.publication_blocked": "Publication bloquée",
  "journalAudit.action.regeneration_previous_tree": "Arborescence précédente montrée pour la régénération",
  "journalAudit.action.regeneration_previous_version": "Version précédente reprise pour la régénération",
  "journalAudit.action.demand_decisions_resolved": "Réponses de l’équipe jointes à la génération",
  "journalAudit.action.backlog_items_inserted": "Éléments de backlog créés",
  "journalAudit.action.black_box_inputs_ignored": "Saisies de code ignorées (test en boîte noire)",
  "journalAudit.action.design_flow_proposed": "Parcours proposé",
  "journalAudit.action.children_reviewed": "Éléments générés relus par un second modèle",
  "journalAudit.action.publication_terminal_blocked": "Publication bloquée définitivement",
  "journalAudit.action.risk_mitigation_plan_recorded": "Plan de mitigation du risque enregistré",
  "journalAudit.action.template_leakage_refused": "Sortie refusée : lignes de gabarit conservées",
  "journalAudit.action.spec_gate_evidence_renewed": "Preuves du Spec Gate renouvelées",
  "journalAudit.acteurAide": "Identifiant exact, affiché sous le nom",
  "journalAudit.action.access.matrix.permission_granted": "Permission accordée à un rôle",
  "journalAudit.action.access.matrix.permission_revoked": "Permission retirée à un rôle",
  "journalAudit.action.access.policy.created": "Règle d’accès créée",
  "journalAudit.action.access.policy.deleted": "Règle d’accès supprimée",
  "journalAudit.action.access.review.read": "Revue des accès consultée",
  "journalAudit.action.adr.created": "ADR créée",
  "journalAudit.action.adr.criterion_updated": "Critère d’une ADR modifié",
  "journalAudit.action.adr.decided": "ADR décidée",
  "journalAudit.action.adr.decided.two_person_mode": "ADR décidée (mode deux personnes)",
  "journalAudit.action.adr.reviewed": "ADR relue",
  "journalAudit.action.agent.promotion_requested": "Promotion d’un agent demandée",
  "journalAudit.action.agent.promoted": "Agent promu",
  "journalAudit.action.agent.promotion_refused": "Promotion d’un agent refusée",
  "journalAudit.action.agent.promotion_withdrawn": "Promotion d’un agent retirée",
  "journalAudit.action.ai.consent.granted": "Consentement IA accordé",
  "journalAudit.action.ai.consent.withdrawn": "Consentement IA retiré",
  "journalAudit.action.ai.purpose.declared": "Finalité IA déclarée",
  "journalAudit.action.ai.purpose.approved": "Finalité IA approuvée",
  "journalAudit.action.ai.purpose.refused": "Finalité IA refusée",
  "journalAudit.action.ai.purpose.withdrawn": "Finalité IA retirée",
  "journalAudit.action.harness.card_promotion_requested": "Promotion d’une carte demandée",
  "journalAudit.action.harness.card_promotion_approved": "Promotion d’une carte approuvée",
  "journalAudit.action.harness.card_promotion_refused": "Promotion d’une carte refusée",
  "journalAudit.action.harness.card_promotion_withdrawn": "Promotion d’une carte retirée",
  "journalAudit.action.approval.risk_category_raised": "Catégorie de risque de l’approbation relevée",
  "journalAudit.action.approval.two_person_mode": "Approbation décidée en mode deux personnes",
  "journalAudit.action.backlog.item_assigned": "Élément du backlog assigné",
  "journalAudit.action.backlog.items_assigned": "Éléments du backlog assignés en lot",
  "journalAudit.action.backlog.item_ranked": "Élément du backlog reclassé",
  "journalAudit.action.backlog.wip_limits.set": "Limites de travail en cours réglées",
  "journalAudit.action.backlog.wip_limits.refused": "Réglage des limites de travail en cours refusé",
  "journalAudit.action.backlog_item.deleted": "Élément du backlog supprimé",
  "journalAudit.action.backlog_item.merged": "Éléments du backlog fusionnés",
  "journalAudit.action.classification.deleted": "Élément de classement supprimé",
  "journalAudit.action.classification.version_updated": "Version de classement modifiée",
  "journalAudit.action.item_axis.attached": "Axe rattaché à un élément",
  "journalAudit.action.item_axis.detached": "Axe détaché d’un élément",
  "journalAudit.action.workspace_team.deleted": "Équipe du projet supprimée",
  "journalAudit.action.workspace_team.member_removed": "Membre retiré de l’équipe",
  "journalAudit.action.defect.assigned": "Anomalie assignée",
  "journalAudit.action.defect_lesson.proposed": "Leçon d’anomalie proposée",
  "journalAudit.action.defect_lesson.validated": "Leçon d’anomalie validée",
  "journalAudit.action.defect_lesson.dismissed": "Leçon d’anomalie écartée",
  "journalAudit.action.test_case.test_code_removed": "Code de test retiré",
  "journalAudit.action.test_execution.assigned": "Cas de test assigné dans la campagne",
  "journalAudit.action.test_execution.unassigned": "Assignation d’un cas de test retirée",
  "journalAudit.action.test_execution.step_run_started": "Exécution pas à pas démarrée",
  "journalAudit.action.test_execution.step_run_finished": "Exécution pas à pas terminée",
  "journalAudit.action.regression.accept": "Régression acceptée",
  "journalAudit.action.regression.accept.refused": "Acceptation d’une régression refusée",
  "journalAudit.action.regression_suite.case_added": "Cas ajouté à la suite de non-régression",
  "journalAudit.action.regression_suite.case_removed": "Cas retiré de la suite de non-régression",
  "journalAudit.action.regression_suite.designated": "Suite de non-régression désignée",
  "journalAudit.action.regression_suite.undesignated": "Désignation de la suite de non-régression retirée",
  "journalAudit.action.design.charter.created": "Charte du projet créée",
  "journalAudit.action.design.charter.validated": "Charte du projet validée",
  "journalAudit.action.design.charter_override.created": "Surcharge de la charte créée",
  "journalAudit.action.design.charter_override.ended": "Surcharge de la charte terminée",
  "journalAudit.action.design.charter_override.expired": "Surcharge de la charte échue",
  "journalAudit.action.design.charter_waiver.requested": "Dérogation à la charte demandée",
  "journalAudit.action.design.charter_waiver.granted": "Dérogation à la charte accordée",
  "journalAudit.action.design.charter_waiver.refused": "Dérogation à la charte refusée",
  "journalAudit.action.design.comparison.filed": "Comparaison maquette–application consignée",
  "journalAudit.action.design.flow.created": "Parcours créé",
  "journalAudit.action.design.org_charter.enforcement_changed": "Application de la charte de l’organisation modifiée",
  "journalAudit.action.design.usability_check.planned": "Test d’usage prévu",
  "journalAudit.action.design.usability_check.completed": "Test d’usage réalisé",
  "journalAudit.action.design.usability_check.waived": "Test d’usage dérogé",
  "journalAudit.action.golden_path.published": "Version du chemin doré publiée",
  "journalAudit.action.incident.declared": "Incident déclaré",
  "journalAudit.action.incident.updated": "Incident modifié",
  "journalAudit.action.incident.status_changed": "Incident : changement d’état",
  "journalAudit.action.incident.note_added": "Note ajoutée à l’incident",
  "journalAudit.action.incident.defect_linked": "Anomalie rattachée à l’incident",
  "journalAudit.action.incident.action_created": "Action de suivi créée depuis l’incident",
  "journalAudit.action.incident.postmortem_saved": "Post-mortem enregistré",
  "journalAudit.action.incident.postmortem_published": "Post-mortem publié",
  "journalAudit.action.invitation.created": "Invitation au projet envoyée",
  "journalAudit.action.invitation.accepted": "Invitation au projet acceptée",
  "journalAudit.action.invitation.revoked": "Invitation au projet révoquée",
  "journalAudit.action.user.offboarded": "Départ d’un utilisateur acté",
  "journalAudit.action.notification.preferences_updated": "Préférences de notification modifiées",
  "journalAudit.action.lifecycle.export_downloaded": "Archive de suppression téléchargée",
  "journalAudit.action.mcp.link_tested": "Liaison MCP testée",
  "journalAudit.action.quarantine.replayed": "Événement en quarantaine rejoué",
  "journalAudit.action.quarantine.replay_refused": "Rejeu d’un événement en quarantaine refusé",
  "journalAudit.action.referential.imported": "Référentiel importé",
  "journalAudit.action.scm.gitlab_disconnected": "GitLab déconnecté du projet",
  "journalAudit.action.workspace.export.requested": "Export du projet demandé",
  "journalAudit.action.mission.paused": "Mission mise en pause",
  "journalAudit.action.mission.resumed": "Mission reprise",
  "journalAudit.action.mission.plan_rejected": "Plan de mission rejeté",
  "journalAudit.action.mission.replan_approved": "Replanification de mission approuvée",
  "journalAudit.action.mission.replan_rejected": "Replanification de mission rejetée",
  "journalAudit.action.org_governance.settings_changed": "Réglages de gouvernance de l’organisation modifiés",
  "journalAudit.action.org_governance.external_ai_agents_changed": "Agents IA externes autorisés modifiés",
  "journalAudit.action.org_requirement.created": "Exigence de l’organisation créée",
  "journalAudit.action.org_requirement.updated": "Exigence de l’organisation modifiée",
  "journalAudit.action.org_requirement.status_changed": "Exigence de l’organisation : changement d’état",
  "journalAudit.action.org_rule.stage_decided": "Règle de l’organisation : changement de temps décidé",
  "journalAudit.action.project_governance.mode_changed": "Mode de gouvernance du projet modifié",
  "journalAudit.action.scope_requirement.added": "Exigence ajoutée au périmètre",
  "journalAudit.action.scope_requirement.removed": "Exigence retirée du périmètre",
  "journalAudit.action.scope_requirement.waived": "Exigence mise en dérogation",
  "journalAudit.action.waiver.requested": "Dérogation demandée",
  "journalAudit.action.waiver.reviewed": "Dérogation relue",
  "journalAudit.action.waiver.granted": "Dérogation accordée",
  "journalAudit.action.waiver.refused": "Dérogation refusée",
  "journalAudit.action.waiver.lifted": "Dérogation levée",
  "journalAudit.action.waiver.expired": "Dérogation échue",
  "journalAudit.action.role_delegation.created": "Délégation de rôle créée",
  "journalAudit.action.role_delegation.revoked": "Délégation de rôle révoquée",
  "journalAudit.action.raci.updated": "Matrice RACI modifiée",
  "journalAudit.action.service_objective.created": "Objectif de service créé",
  "journalAudit.action.service_objective.updated": "Objectif de service modifié",
  "journalAudit.action.spec_change.requested": "Modification de spécification demandée",
  "journalAudit.action.spec_change.withdrawn": "Demande de modification de spécification retirée",
  "journalAudit.action.spec_change.accepted": "Modification de spécification acceptée",
  "journalAudit.action.spec_change.refused": "Modification de spécification refusée",
  "journalAudit.action.preview.restart_requested": "Redémarrage de l’aperçu demandé",
  "journalAudit.action.preview.share_created": "Lien de partage de l’aperçu créé",
  "journalAudit.action.preview.share_opened": "Lien de partage de l’aperçu ouvert",
  "journalAudit.action.preview.share_revoked": "Lien de partage de l’aperçu révoqué",
  "journalAudit.action.program.initiative_objective_set": "Objectif d’une initiative fixé",
  "journalAudit.action.program.member_removed": "Membre retiré du programme",
  "journalAudit.action.program.member_role_changed": "Rôle dans le programme modifié",
  "journalAudit.action.program.objective_updated": "Objectif du programme modifié",
  "journalAudit.action.program.ownership_transferred": "Propriété du programme transférée",
  "journalAudit.action.program.risk_added": "Risque du programme ajouté",
  "journalAudit.action.program.risk_updated": "Risque du programme modifié",
  "journalAudit.action.program.settings_updated": "Réglages du programme modifiés",
  "journalAudit.action.program.workspace_detached": "Projet détaché du programme",
  "journalAudit.action.release.adopted": "Version existante adoptée dans le cycle",
  "journalAudit.action.release.approval_reviewed": "Approbation de la version relue",
  "journalAudit.action.release.approval_withdrawn": "Approbation de la version retirée",
  "journalAudit.action.release.campaign_linked": "Campagne de test rattachée à la version",
  "journalAudit.action.release.deployment_planned": "Mise en production planifiée",
  "journalAudit.action.release.deployment_plan_cancelled": "Plan de mise en production annulé",
  "journalAudit.action.release.freeze_declared": "Période de gel déclarée",
  "journalAudit.action.release.freeze_cancelled": "Période de gel annulée",
  "journalAudit.action.release.notes_edited": "Notes de version modifiées",
  "journalAudit.action.release.target_date_set": "Date cible de la version fixée",
  "journalAudit.action.revision_registry.vulnerability_scan_recorded": "Analyse de vulnérabilités de la révision enregistrée",
  "journalAudit.action.runops.deployment_outcome_declared": "Issue du déploiement déclarée",
  "journalAudit.action.sprint.capacity_declared": "Capacité du sprint déclarée",
  "journalAudit.action.sprint.closed": "Sprint clos",
  "journalAudit.action.sprint.retro_action_created": "Action de rétrospective créée",
  "journalAudit.action.sprint.review_saved": "Revue de sprint enregistrée",
  "journalAudit.action.technology_category.created": "Catégorie technologique créée",
  "journalAudit.action.technology_category.updated": "Catégorie technologique modifiée",
  "journalAudit.action.technology_category.deleted": "Catégorie technologique supprimée",
  "journalAudit.action.technology_change.created": "Changement technologique créé",
  "journalAudit.action.technology_change.analysed": "Changement technologique analysé",
  "journalAudit.action.technology_change.confirmed": "Dimension du changement technologique confirmée",
  "journalAudit.action.technology_change.submitted": "Changement technologique soumis à revue",
  "journalAudit.action.technology_change.approved": "Changement technologique approuvé",
  "journalAudit.action.technology_change.refused": "Changement technologique refusé",
  "journalAudit.action.technology_change.propagation_started": "Propagation du changement technologique démarrée",
  "journalAudit.action.technology_change.propagation_resumed": "Propagation du changement technologique reprise",
  "journalAudit.action.technology_change.deviation_kept": "Écart conservé par un projet héritier",
  "journalAudit.action.technology_change.rework_item_added": "Reprise ajoutée au changement technologique",
  "journalAudit.action.technology_change.verified": "Changement technologique vérifié",
  "journalAudit.action.technology_change.closed": "Changement technologique clos",
  "journalAudit.action.technology_change.cancelled": "Changement technologique annulé",
  "journalAudit.action.technology_entry.status_changed": "Entrée du catalogue technologique : changement d’état",
  "journalAudit.action.technology_entry.updated": "Entrée du catalogue technologique modifiée",
  "journalAudit.action.ai_model_quota_exceeded": "Quota d’appels du modèle d’IA dépassé",
  "journalAudit.action.ai_reviewer_blocked": "Relecteur d’IA bloqué",
  "journalAudit.action.ai_model_attestation_gap": "Attestation du modèle d’IA manquante",
  "journalAudit.action.ai_provider_policy_blocked": "Fournisseur d’IA bloqué par la politique",
  "journalAudit.action.ai_provider_qualification_blocked": "Qualification du fournisseur d’IA bloquée",
  "journalAudit.action.ai_provider_qualification_succeeded": "Fournisseur d’IA qualifié",
  "design.comparison.authRequired": "Connexion requise : le relevé ne se connecte pas, cet écran n’a pas été mesuré.",
  "design.comparison.authCount": "{{count}} à connexion requise (non mesuré(s)) ; ",
  "design.comparison.summaryWithAuth": "{{compared}} écran(s) comparé(s) sur {{expected}} ; {{missing}} absent(s) de l’application ; {{auth}}{{without}} sans maquette validée. Écarts : {{major}} majeur(s), {{minor}} mineur(s), {{info}} info.",
  "design.comparison.opinion.partial": "comparaison partielle : écrans non mesurés",
  "design.conformance.flowAuth": "dont {{n}} avec connexion requise (non mesurés)",
  "design.conformance.flowAuth_one": "dont {{n}} avec connexion requise (non mesuré)",
  "design.conformance.flowAuth_other": "dont {{n}} avec connexion requise (non mesurés)",
  "apercu.compare.authRequired": "connexion requise",
  "apercu.count.authRequired": "{{n}} écrans à connexion requise (non mesurés)",
  "apercu.count.authRequired_one": "{{n}} écran à connexion requise (non mesuré)",
  "apercu.count.authRequired_other": "{{n}} écrans à connexion requise (non mesurés)",
  "journalAudit.action.ai.grant_revoked": "Accord d’un modèle d’IA retiré à l’organisation",
  "journalAudit.action.ai.grant_set": "Accord d’un modèle d’IA enregistré pour l’organisation",
  "slo.reserveEcriture": "Seuls le propriétaire du projet, l’administration de l’organisation et l’administration de la plateforme déclarent ou modifient un objectif de service ; vous gardez la lecture du budget.",
  "journalAudit.action.lifecycle.request.read": "Demande de suppression consultée",
  "journalAudit.action.lifecycle.requests.read": "Demandes de suppression consultées",
  "app.listeProjetsIllisible": "La liste de vos projets n’a pas pu être lue",
  "app.listeProjetsIllisibleAide": "L’accès aux réglages du projet ne peut pas être vérifié tant que cette liste est illisible.",
  "app.coquilleIndisponible": "L’interface n’a pas pu démarrer",
  "app.coquilleIndisponibleAide": "La configuration de l’interface est incohérente. Signalez-le à l’administration de la plateforme.",
  "runopsFiche.retourEnvironnements": "Retour aux environnements et déploiements",
  "runops.actualiserEnvironnements": "Actualiser les environnements",
  "preteEnv.aucunEnvAideEcran": "Les environnements se déclarent dans « Environnements et déploiements ».",
  "processView.configurerProcessus": "Configurer le processus",
  "processView.ouvrirPipelines": "Ouvrir les pipelines",
  "processView.chargerPlan": "Charger le plan effectif",
  "processView.examinerBlocage": "Examiner le blocage",
  "processView.attendreApprobation": "Attendre une approbation humaine",
  "processView.suivreExecution": "Suivre l’exécution",
  "processView.lancer": "Lancer le processus",
  "processView.projetActif": "Projet actif",
  "processView.defautIntegre": "Default intégré",
  "processView.cyclePersonnalise": "cycle personnalisé",
  "processView.cycleIntegre": "cycle intégré",
  "processView.provenance": "Provenance :",
  "processView.version": "Version :",
  "processView.empreinte": "Empreinte :",
  "processView.resolution.instantane": "Instantané épinglé",
  "processView.resolution.courante": "Configuration courante",
  "processView.resolution.integre": "Template intégré",
  "processView.processusPret": "Processus prêt",
  "processView.prerequisACompleter": "Prérequis à compléter",
  "processView.actualiser": "Actualiser",
  "processView.erreurPlan": "Impossible de charger le plan : {{message}}",
  "processView.blocagesTitre": "Ce qui bloque la prochaine étape",
  "processView.blocagesAide": "Le serveur a évalué ces prérequis avant toute exécution.",
  "processView.politiqueUnique": "Une seule politique effective est évaluée pour ce projet.",
  "processView.run": "Run : {{statut}}",
  "processView.aucuneEtape": "Aucune étape n’est déclarée dans le template effectif.",
  "processView.roles": "Rôles :",
  "processView.tous": "Tous",
  "processView.approbation": "Approbation :",
  "processView.approbation.aucune": "Aucune",
  "processView.approbation.unePersonne": "Une personne",
  "processView.approbation.sod": "Séparation des tâches",
  "processView.approbation.quorum": "Quorum",
  "processView.approbation.nonDeclaree": "Non déclarée",
  "processView.prerequis": "Prérequis :",
  "processView.aucun": "Aucun",
  "processView.disponible": "Disponible",
  "processView.bloque": "Bloqué",
  "processView.prochaineAction": "Prochaine action",
  "processView.sodAutreApprobateur": "La séparation des tâches exige un autre approbateur.",
  "processView.ouvrir": "Ouvrir",
  "processView.termine": "Processus terminé",
  "processView.demarre": "Le processus de livraison a été démarré.",
  "processView.workflowTitre": "Workflow des workitems",
  "processView.workflowAide": "Transitions et compteurs fournis par le serveur pour ce projet.",
  "processView.workflowLegende": "Statuts, transitions autorisées et prérequis",
  "processView.colStatut": "Statut",
  "processView.colObjets": "Objets",
  "processView.colTransitions": "Transitions",
  "processView.colPrerequis": "Prérequis",
  "tree.priorityLabel": "Priorité",
  "livrer.publication.numeroPipeline": "pipeline n° {{numero}}",
  "livrer.publication.pipelineEtat": "{{pipeline}} : {{etat}}",
  "processView.templateEffectifEtiquette": "Template effectif :",
  "filters.deleteConsequencePersonnel": "Ce filtre est personnel : il disparaît seulement de votre liste. Les items, eux, ne sont pas touchés.",
  "n28.pastilleAriaSansDuree": "Prochaine action pour votre rôle ({{role}}) : {{action}}",
  "agile.annuaireRefusProgramme": "Réservé à un propriétaire du programme : vous ne pouvez pas ajouter de membres ici.",
  "admin.colRegression": "Accepter une régression",
  "admin.colLimites": "Régler les limites d’en-cours",
  "admin.regressionCaseAria": "Accepter une régression : {{u}}",
  "admin.limitesCaseAria": "Régler les limites d’en-cours : {{u}}",
  "admin.permissionsAide": "« Accepter une régression » : accepter, avec un motif et une échéance, une régression constatée à la non-régression. « Régler les limites d’en-cours » : fixer les limites de travail en cours du tableau. Le propriétaire du projet les a déjà ; cochez-les pour les donner à un autre membre. Pour s’en servir, il faut porter un rôle d’organisation qui écrit (administrateur d’organisation, responsable de projets ou contributeur), quel que soit son rôle dans ce projet, propriétaire compris : un lecteur ou un auditeur d’organisation ne se sert que d’« Exécuter une recette ». Chaque attribution est tracée.",
  "workflow.agentAExecuter": "Agent à exécuter",
  "fonA.finalites.agentConcerne": "Agent concerné par la finalité",
  "versions.code.CI_PIPELINE_UNREADABLE": "Le statut d’un pipeline en cours n’a pas pu être relu auprès de GitLab : bloquant pour une cible de production sauf dérogation signée (14 jours au plus à compter de la signature) sur une exigence du projet au contrôle ci_pipeline_green, simple avertissement pour une autre cible",
  "versions.code.CI_PIPELINE_NOT_APPLICABLE": "Aucune révision n’est publiée et aucun dépôt n’est relié : aucun pipeline à attendre (sans objet)",
  "org.request.pipelineLimit": "Exigence au contrôle {{controle}} : 14 jours au plus à compter de la signature (14 × 24 h). Dernière date acceptable : {{date}}.",
  "org.request.pipelineLimitExceeded": "Cette échéance dépasse la validité d'une dérogation de pipeline (14 × 24 h à compter de la signature) : la dernière date acceptable est le {{date}}.",
  "erreurs.code.WAIVER_PIPELINE_VALIDITY_EXCEEDED": "L’échéance demandée dépasse la validité d’une dérogation de pipeline : 14 jours au plus à compter de la signature (14 × 24 h). Choisissez une date plus proche.",
  "org.waiver.expiredRequirement": "échue — exigence {{etat}}",
  "org.motifReinitialisationAnnuaire": "Réinitialisation demandée depuis l’annuaire",
  "org.membreAjoutPartiel": "Ajouté en lecteur ; les profils demandés n’ont pas été posés",
  "erreurs.code.BACKUP_RETENTION_NO_POLICY": "Cette sauvegarde n’a aucune politique de rétention enregistrée : sa rotation ne peut pas être enregistrée.",
  "erreurs.code.BACKUP_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "Cette sauvegarde est sous gel légal : sa rotation ne peut pas être enregistrée tant que le gel dure.",
  "erreurs.code.CONTINUITY_ACTOR_MISMATCH": "La demande de sauvegarde ou de restauration doit être faite en votre propre nom.",
  "erreurs.code.CONTINUITY_PLATFORM_ADMIN_REQUIRED": "Les demandes de sauvegarde et de restauration de la plateforme sont réservées à son administration.",
  "erreurs.code.CONTINUITY_REQUEST_APPEND_ONLY": "Une demande de sauvegarde ou de restauration ne se modifie ni ne s’efface : elle reste au journal.",
  "erreurs.code.DEPLOYMENT_PLAN_SCOPE_MISMATCH": "La version ou l’environnement choisi n’appartient pas au projet de cette mise en production planifiée.",
  "erreurs.code.ENROLMENT_ALREADY_CLOSED": "Ce lien d’activation a déjà servi ou a été révoqué.",
  "erreurs.code.ENROLMENT_APPEND_ONLY": "Un lien d’activation ne s’efface pas : il se révoque.",
  "erreurs.code.ENROLMENT_IMMUTABLE": "Un lien d’activation ne se modifie pas : seules sa consommation et sa révocation sont possibles.",
  "erreurs.code.ENROLMENT_NOT_VALID": "Ce lien d’activation n’est plus valable : il a expiré, il a déjà servi ou il a été révoqué.",
  "erreurs.code.ENROLMENT_UNKNOWN": "Ce lien d’activation est inconnu : demandez-en un nouveau à l’administration de la plateforme.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ACTOR_MISMATCH": "Un accès exceptionnel doit être ouvert ou révoqué en votre propre nom.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ALREADY_ACTIVE": "Vous avez déjà une session d’accès exceptionnel active sur cette organisation.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ALREADY_REVOKED": "Cette session d’accès exceptionnel est déjà révoquée.",
  "erreurs.code.EXCEPTIONAL_ACCESS_APPEND_ONLY": "Une session d’accès exceptionnel ne s’efface jamais : elle se révoque.",
  "erreurs.code.EXCEPTIONAL_ACCESS_EXPIRED": "La fenêtre de cette session d’accès exceptionnel est close : ouvrez une nouvelle session, avec un nouveau motif.",
  "erreurs.code.EXCEPTIONAL_ACCESS_IMMUTABLE": "Une session d’accès exceptionnel ne se modifie pas : seule sa révocation est possible.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_ACTIVE": "Cette session d’accès exceptionnel est déjà terminée : il n’y a rien à révoquer.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_FOUND": "Cette session d’accès exceptionnel est introuvable.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_OWNER": "Seul l’administrateur qui a ouvert cette session d’accès exceptionnel peut lire par elle.",
  "erreurs.code.EXCEPTIONAL_ACCESS_PLATFORM_ADMIN_REQUIRED": "Les accès exceptionnels sont réservés à l’administration de la plateforme.",
  "erreurs.code.EXCEPTIONAL_ACCESS_READ_ONLY_REQUIRED": "Un accès exceptionnel ne donne qu’une lecture seule : cette opération n’a pas été ouverte comme telle.",
  "erreurs.code.EXCEPTIONAL_ACCESS_REVOKED": "Cette session d’accès exceptionnel a été révoquée : ouvrez une nouvelle session, avec un nouveau motif.",
  "erreurs.code.FILE_RETENTION_NOTHING_TO_RESTORE": "Ce fichier n’a pas été retiré : il n’y a rien à restaurer.",
  "erreurs.code.FILE_RETENTION_NO_POLICY": "Ce fichier n’a aucune politique de rétention enregistrée : son retrait ne peut pas être enregistré.",
  "erreurs.code.FILE_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "Ce fichier est sous gel légal : son retrait ne peut pas être enregistré tant que le gel dure.",
  "erreurs.code.HARNESS_CASTES_SESSION_REQUIRED": "Pour lire les castes en service, travaillez depuis une organisation ou connectez-vous comme administrateur de la plateforme.",
  "erreurs.code.LIFECYCLE_ACTOR_MISMATCH": "Une demande de suppression doit être faite ou annulée en votre propre nom.",
  "erreurs.code.LIFECYCLE_EXPORT_IMMUTABLE": "L’archive de cette suppression est prête : elle ne change plus.",
  "erreurs.code.LIFECYCLE_EXPORT_REQUIRED": "L’archive d’export n’est pas prête : la purge attend qu’elle soit produite.",
  "erreurs.code.LIFECYCLE_FORBIDDEN": "Vous n’avez pas l’autorité nécessaire pour agir sur cette demande de suppression.",
  "erreurs.code.LIFECYCLE_PERIMETER_NO_FIXPOINT": "Le périmètre à supprimer ne se stabilise pas : la purge est suspendue.",
  "erreurs.code.LIFECYCLE_PURGE_BLOCKED": "Des données liées empêchent la purge : elle est suspendue.",
  "erreurs.code.LIFECYCLE_PURGE_INCOMPLETE": "Des données du périmètre subsistent après la purge : elle est annulée.",
  "erreurs.code.LIFECYCLE_PURGE_TOO_EARLY": "Le délai avant la purge n’est pas écoulé : la suppression ne peut pas encore être exécutée.",
  "erreurs.code.LIFECYCLE_REQUEST_CLOSED": "Cette demande de suppression est close : elle ne change plus.",
  "erreurs.code.LIFECYCLE_REQUEST_IDENTITY_IMMUTABLE": "Une demande de suppression ne change ni de cible, ni de motif, ni de délai.",
  "erreurs.code.LIFECYCLE_REQUEST_IMMUTABLE": "Une demande de suppression ne s’efface pas : elle se clôt ou s’annule.",
  "erreurs.code.LIFECYCLE_REQUEST_NOT_FOUND": "Cette demande de suppression est introuvable.",
  "erreurs.code.LIFECYCLE_TABLE_OUT_OF_SCOPE": "Cette table de données ne fait pas partie du périmètre de la suppression.",
  "erreurs.code.LIFECYCLE_TARGET_NOT_FOUND": "Le projet ou l’organisation à supprimer est introuvable.",
  "erreurs.code.ORGANISATION_ALREADY_SUSPENDED": "Cette organisation est déjà suspendue.",
  "erreurs.code.ORGANISATION_DELETED": "Cette organisation est déjà supprimée : elle ne peut plus être modifiée.",
  "erreurs.code.ORGANISATION_DELETION_PENDING": "Une suppression est programmée pour cette organisation : annulez-la avant de la réactiver.",
  "erreurs.code.ORGANISATION_NOT_FOUND": "Organisation introuvable.",
  "erreurs.code.ORGANISATION_NOT_SUSPENDED": "Cette organisation n’est pas suspendue : il n’y a rien à réactiver.",
  "erreurs.code.ORGANISATION_SELF_DELETION_FORBIDDEN": "Vous ne pouvez pas demander la suppression de l’organisation à laquelle vous êtes connecté.",
  "erreurs.code.ORGANISATION_STATUS_HISTORY_APPEND_ONLY": "L’historique des statuts d’une organisation ne se modifie ni ne s’efface.",
  "erreurs.code.ORGANISATION_STATUS_INVALID": "Ce statut n’existe pas : une organisation est active ou suspendue.",
  "erreurs.code.ORGANISATION_STATUS_PLATFORM_ADMIN_REQUIRED": "Changer le statut d’une organisation est réservé à l’administration de la plateforme.",
  "erreurs.code.ORGANISATION_STATUS_PLATFORM_ONLY": "Le statut d’une organisation ne change que par un acte de l’administration de la plateforme.",
  "erreurs.code.ORG_INVITATION_ALREADY_CLOSED": "Cette invitation a déjà été acceptée ou révoquée.",
  "erreurs.code.ORG_INVITATION_APPEND_ONLY": "Une invitation ne s’efface pas : elle se révoque.",
  "erreurs.code.ORG_INVITATION_IMMUTABLE": "Une invitation ne se modifie pas : seules son acceptation et sa révocation sont possibles.",
  "erreurs.code.ORG_INVITATION_NOT_VALID": "Cette invitation n’est plus valable : elle a expiré, elle a déjà été acceptée ou elle a été révoquée.",
  "erreurs.code.ORG_INVITATION_UNKNOWN": "Ce lien d’invitation est inconnu : demandez-en un nouveau à l’administration de votre organisation.",
  "erreurs.code.PLATFORM_JOURNAL_PLATFORM_ADMIN_REQUIRED": "Le journal de la plateforme est réservé à l’administration de la plateforme.",
  "erreurs.code.PURGED": "La purge définitive est refusée : le départ de l’organisation doit être prêt à être purgé, sans gel légal en cours et une fois la durée de rétention écoulée.",
  "erreurs.code.QUARANTINE_PLATFORM_ADMIN_REQUIRED": "La lecture de la quarantaine sur toute l’installation est réservée à l’administration de la plateforme.",
  "erreurs.code.RELEASE_APPROVAL_APPEND_ONLY": "Une approbation de version ne s’efface pas : elle se retire.",
  "erreurs.code.RELEASE_APPROVAL_FROZEN": "La demande, la relecture et la décision d’une approbation ne se réécrivent pas.",
  "erreurs.code.RELEASE_APPROVAL_INVALID": "Cette approbation doit appartenir au projet de la version.",
  "erreurs.code.RELEASE_APPROVAL_REQUIRED": "Cette version n’a aucune approbation d’environnement accordée : obtenez-en une avant de l’approuver.",
  "erreurs.code.RELEASE_APPROVAL_STATE_INVALID": "Cette approbation n’est pas dans un état qui permet ce geste.",
  "erreurs.code.RELEASE_CONTENT_FROZEN": "Le contenu de cette version est figé hors brouillon ; en brouillon, une ligne se retire puis s’ajoute, elle ne se modifie pas.",
  "erreurs.code.RELEASE_CONTENT_INVALID": "Ce contenu n’appartient pas au projet de la version.",
  "erreurs.code.RELEASE_ENVIRONMENT_NOT_FOUND": "Cet environnement est introuvable depuis le projet de la version.",
  "erreurs.code.RELEASE_IDENTITY_FROZEN": "Le numéro, le commit, la source et le créateur d’une version sont figés.",
  "erreurs.code.RELEASE_NOTES_PUBLICATION_INVALID": "Une publication de notes de version exige son auteur et sa date.",
  "erreurs.code.RELEASE_NOTES_UNPUBLISH_FORBIDDEN": "Une publication de notes ne s’annule pas : elle se remplace par une nouvelle version des notes.",
  "erreurs.code.RELEASE_NOTES_VERSION_NOT_FOUND": "Cette version des notes de version est introuvable.",
  "erreurs.code.RELEASE_NOT_DEPLOYED": "Cette version n’a réussi aucun déploiement sur un environnement approuvé.",
  "erreurs.code.RELEASE_NOT_FOUND": "Version introuvable dans ce projet.",
  "erreurs.code.RELEASE_NOT_MANAGED": "Cette version est hors cycle : préparez-la d’abord.",
  "erreurs.code.RELEASE_STATUS_INVALID": "Le statut de la version ne permet pas ce geste.",
  "erreurs.code.RELEASE_TEXT_APPEND_ONLY": "Les notes de version gardent leur historique : aucune version de texte ne se modifie ni ne s’efface.",
  "erreurs.code.RELEASE_TRANSITION_FORBIDDEN": "Ce changement de statut est refusé : la version ne peut pas y passer depuis son statut actuel, ou une approbation accordée doit d’abord être retirée.",
  "erreurs.code.RETENTION_TENANT_SESSION_MISMATCH": "Cette opération de rétention vise une autre organisation que celle de votre session.",
  "erreurs.code.RETENTION_WORKSPACE_SESSION_MISMATCH": "Ce projet appartient à une autre organisation que celle de votre session.",
  "erreurs.code.VECTOR_RETENTION_NO_POLICY": "Les vecteurs de documents de ce projet n’ont aucune politique de rétention enregistrée : leur purge ne peut pas être enregistrée.",
  "erreurs.code.VECTOR_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "Les vecteurs de documents de ce projet sont sous gel légal : leur purge ne peut pas être enregistrée tant que le gel dure.",
  "erreurs.code.WORKSPACE_DELETION_PENDING": "Une suppression est programmée pour ce projet : annulez-la avant de le désarchiver.",
  "navMode.sansOrganisation": "Le mode de navigation se règle par organisation : ce compte n’en a pas.",
  "porteProjet.verification": "Vérification du projet dans votre organisation…",
  "journalAudit.action.mission.partial_delivery_requested": "Livraison des tâches abouties demandée",
  "journalAudit.action.org.directory.exported": "Annuaire de l’organisation exporté",
  "journalAudit.action.org.invitation.resent": "Invitation renvoyée",
  "journalAudit.action.org.invitation_request.approved": "Demande d’invitation approuvée",
  "journalAudit.action.org.invitation_request.created": "Demande d’invitation déposée",
  "journalAudit.action.org.invitation_request.refused": "Demande d’invitation refusée",
  "journalAudit.action.org.user.profiles_changed": "Profils d’organisation modifiés",
  "journalAudit.action.program.member_profiles_changed": "Profils d’un membre du programme modifiés",
  "journalAudit.action.workspace.member_profiles_changed": "Profils d’un membre du projet modifiés",
  "missions.reason.browser_proof_required": "preuve par navigateur exigée",
  "missions.reason.capability_missing": "capacité du worker manquante",
  "missions.reason.budget_escalations_reached": "budget d’escalades épuisé",
  "missions.status.succeededPartial": "réussie — livraison partielle",
  "missions.decision.deliverConverged": "Livrer les tâches abouties",
  "missions.decision.deliver.confirm": "{{n}} tâche(s) aboutie(s) seront proposées à l’approbation du dossier ; {{m}} tâche(s) arrêtée(s) seront annulées et resteront à reprendre.",
  "missions.decision.deliver.lastStop": "{{n}} tâche(s) aboutie(s) ne seront pas livrées ; pour les livrer : « Livrer les tâches abouties »",
  "missions.decision.deliver.refused.WORKER_CAPABILITY_MISSING": "Livraison impossible : le worker en service ne sait pas encore livrer une partie d’une mission. Mettez le worker à jour et redémarrez-le.",
  "missions.decision.deliver.refused.MISSION_NOTHING_TO_DELIVER": "Livraison impossible : aucune tâche n’a abouti.",
  "missions.decision.deliver.refused.MISSION_TASKS_STILL_ACTIVE": "Livraison impossible pour l’instant : une tâche est encore en cours.",
  "missions.decision.deliver.refused.MISSION_STEP_IN_PROGRESS": "Livraison impossible pour l’instant : une étape de la mission est en cours.",
  "missions.decision.effect.acknowledgeBudget": "L’escalade est close : la mission est arrêtée pour budget épuisé, sans fusion.",
  "construire.carteEnService": "en service",
  "missions.decision.deliver.refused.default": "Livraison impossible : la passerelle la refuse.",
  "missions.decision.deliver.confirmNotStarted": "{{k}} tâche(s) non commencée(s) seront annulées.",
  "catalogueTech.gen.versionEnDesaccord": "qualifiée pour {{qualifiee}}, entrée en {{declaree}} : la colonie ne génère pas cette version",
  "erreurs.code.HARNESS_GENERATION_SESSION_REQUIRED": "Pour lire ce que le moteur de génération exécute, travaillez depuis une organisation ou connectez-vous comme administrateur de la plateforme.",
  "adr.stack.reason.REGISTRY_SNAPSHOT_MISSING": "Registre des cartes indisponible : le moteur de génération en service n’a encore rien publié",
  "adr.stack.reason.GENERATION_TRUST_UNAVAILABLE": "Le code exécuté par le moteur de génération n’a pas pu être empreint : la mesure ne peut pas être comparée",
  "adr.stack.reason.GENERATION_CARD_NOT_ACTIVE": "La carte de génération n’est pas active",
  "adr.stack.reason.GENERATION_CARD_RECEIPT_STALE": "Le reçu de la carte de génération est périmé",
  "adr.stack.reason.QUALIFICATION_WITHOUT_FINGERPRINTS": "Mesure ancienne, sans empreintes : à refaire",
  "adr.stack.reason.QUALIFICATION_DRAWS_NOT_STANDARD": "Nombre de tirages non standard (3 par cas, ou 6 pour une confirmation)",
  "adr.stack.reason.QUALIFICATION_DRAWS_NOT_STANDARD_NO_CASES": "Cas distincts non renseignés : les {{draws}} tirages par cas de la mesure ne sont pas prouvés (à réenregistrer avec distinct_cases)",
  "adr.stack.reason.QUALIFICATION_STALE_CARD_VERSION": "Mesurée sur la carte {{mesuree}}, en service {{service}}",
  "adr.stack.reason.QUALIFICATION_STALE_COMMON_BASE": "Code commun de génération modifié depuis la mesure",
  "adr.stack.reason.QUALIFICATION_STALE_GENERATION_SUBJECT": "Modèle ou texte de la carte changés depuis la mesure",
  "adr.stack.reason.QUALIFICATION_STALE_STACK_DEFINITION": "Définition de la pile modifiée depuis la mesure",
  "adr.stack.confirmed": "qualifiée après confirmation ({{passed}} sur {{total}} ; mesure initiale {{initialPassed}} sur {{initialTotal}})",
  "adr.stack.confirmationMissed": "confirmation manquée ({{passed}} sur {{total}} ; mesure initiale {{initialPassed}} sur {{initialTotal}})",
  "erreurs.code.PROMPT_CATALOG_APPEND_ONLY": "Le catalogue des consignes est en ajout seul : un contenu publié ou un refus journalisé ne se modifie ni ne se supprime.",
  "erreurs.code.POLITIQUE_APPROBATION_AJOUT_SEUL": "Une politique d’approbation en vigueur ne se modifie ni ne se supprime : enregistrez une nouvelle version."
}
